import { defineComponent as W, createBlock as L, openBlock as w, unref as P, withCtx as M, renderSlot as R, computed as ae, watch as Et, h as Rr, inject as pe, resolveDynamicComponent as Fe, createVNode as H, normalizeClass as Z, createElementVNode as A, provide as Be, createElementBlock as j, createCommentVNode as Q, mergeProps as He, createTextVNode as se, Fragment as ye, resolveComponent as jm, version as c1, renderList as je, toDisplayString as _, createStaticVNode as rr, withModifiers as Ml, normalizeProps as Mm, guardReactiveProps as zm, createSlots as Nm, mergeModels as lr, useModel as cr, ref as ie, withDirectives as yo, vModelDynamic as Im, useId as Qo, normalizeStyle as zo, reactive as Rm, onMounted as ur, Transition as Ro, vModelSelect as Lm, vModelText as Dc, useTemplateRef as u1, readonly as Cr, onUnmounted as p1, shallowRef as d1, vModelRadio as g1, useSlots as zu, useAttrs as m1 } from "vue";
import { Disclosure as Hm, DisclosureButton as Wm, DisclosurePanel as Vm, DialogTitle as js, TransitionRoot as sa, Dialog as ia, TransitionChild as qo, DialogPanel as la, DialogDescription as Sc, Popover as ca, PopoverButton as tr, PopoverPanel as ua, Combobox as y1, ComboboxInput as f1, ComboboxButton as h1, ComboboxLabel as F1, ComboboxOption as b1, ComboboxOptions as v1, Menu as Gm, MenuButton as zl, MenuItems as Zm, MenuItem as Xm, RadioGroup as Ms, RadioGroupDescription as Ec, RadioGroupLabel as pa, RadioGroupOption as zs, Listbox as P1, ListboxButton as B1, ListboxLabel as k1, ListboxOption as w1, ListboxOptions as D1, PopoverGroup as qm, Switch as S1, SwitchGroup as E1, SwitchLabel as x1, Tab as Um, TabGroup as A1, TabList as Nu, TabPanel as C1, TabPanels as O1 } from "@headlessui/vue";
import { instantMeiliSearch as xc } from "@meilisearch/instant-meilisearch";
import { useToggle as Uo, whenever as Ac, useDebounceFn as nn, promiseTimeout as Cc, useResizeObserver as T1, useEventListener as j1, useClipboard as Ym, onClickOutside as Oc, useFileDialog as Jm, useDropZone as M1, useObjectUrl as z1, useTimeoutFn as Iu, watchDebounced as N1 } from "@vueuse/core";
import { Link as Co } from "@inertiajs/vue3";
import Or from "dayjs";
import { Float as Qm } from "@headlessui-float/vue";
import { OnClickOutside as I1, vInfiniteScroll as Ns } from "@vueuse/components";
import { useTippy as R1 } from "vue-tippy";
import { groupBy as L1, isString as Ru } from "lodash-es";
import { z as ci } from "zod";
import { useEditor as H1, EditorContent as W1 } from "@tiptap/vue-3";
import V1 from "@tiptap/extension-underline";
import G1 from "@tiptap/extension-placeholder";
import Tc from "axios";
import Z1 from "@tailwindcss/forms";
const yM = /* @__PURE__ */ W({
  __name: "Accordion",
  props: {
    defaultOpen: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (w(), L(P(Hm), {
      as: "div",
      "default-open": e.defaultOpen
    }, {
      default: M(({ open: t, close: n }) => [
        R(e.$slots, "default", {
          open: t,
          close: n
        })
      ]),
      _: 3
    }, 8, ["default-open"]));
  }
});
function Lu(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function re(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Lu(Object(r), !0).forEach(function(t) {
      Ve(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Lu(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function ds(o) {
  "@babel/helpers - typeof";
  return ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ds(o);
}
function X1(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function q1(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, t.key, t);
  }
}
function U1(o, e, r) {
  return e && q1(o.prototype, e), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function Ve(o, e, r) {
  return e in o ? Object.defineProperty(o, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = r, o;
}
function jc(o, e) {
  return J1(o) || K1(o, e) || Km(o, e) || $1();
}
function da(o) {
  return Y1(o) || Q1(o) || Km(o) || _1();
}
function Y1(o) {
  if (Array.isArray(o)) return Nl(o);
}
function J1(o) {
  if (Array.isArray(o)) return o;
}
function Q1(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function K1(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t = [], n = !0, a = !1, s, i;
    try {
      for (r = r.call(o); !(n = (s = r.next()).done) && (t.push(s.value), !(e && t.length === e)); n = !0)
        ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && r.return != null && r.return();
      } finally {
        if (a) throw i;
      }
    }
    return t;
  }
}
function Km(o, e) {
  if (o) {
    if (typeof o == "string") return Nl(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Nl(o, e);
  }
}
function Nl(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function _1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Hu = function() {
}, Mc = {}, _m = {}, $m = null, ey = {
  mark: Hu,
  measure: Hu
};
try {
  typeof window < "u" && (Mc = window), typeof document < "u" && (_m = document), typeof MutationObserver < "u" && ($m = MutationObserver), typeof performance < "u" && (ey = performance);
} catch {
}
var eF = Mc.navigator || {}, Wu = eF.userAgent, Vu = Wu === void 0 ? "" : Wu, Br = Mc, Te = _m, Gu = $m, wa = ey;
Br.document;
var pr = !!Te.documentElement && !!Te.head && typeof Te.addEventListener == "function" && typeof Te.createElement == "function", oy = ~Vu.indexOf("MSIE") || ~Vu.indexOf("Trident/"), Da, Sa, Ea, xa, Aa, nr = "___FONT_AWESOME___", Il = 16, ry = "fa", ty = "svg-inline--fa", Gr = "data-fa-i2svg", Rl = "data-fa-pseudo-element", oF = "data-fa-pseudo-element-pending", zc = "data-prefix", Nc = "data-icon", Zu = "fontawesome-i2svg", rF = "async", tF = ["HTML", "HEAD", "STYLE", "SCRIPT"], ny = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Oe = "classic", Re = "sharp", Ic = [Oe, Re];
function ga(o) {
  return new Proxy(o, {
    get: function(r, t) {
      return t in r ? r[t] : r[Oe];
    }
  });
}
var an = ga((Da = {}, Ve(Da, Oe, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), Ve(Da, Re, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), Da)), sn = ga((Sa = {}, Ve(Sa, Oe, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Ve(Sa, Re, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), Sa)), ln = ga((Ea = {}, Ve(Ea, Oe, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Ve(Ea, Re, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), Ea)), nF = ga((xa = {}, Ve(xa, Oe, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Ve(xa, Re, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), xa)), aF = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, ay = "fa-layers-text", sF = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, iF = ga((Aa = {}, Ve(Aa, Oe, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Ve(Aa, Re, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), Aa)), sy = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], lF = sy.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), cF = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Tr = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, cn = /* @__PURE__ */ new Set();
Object.keys(sn[Oe]).map(cn.add.bind(cn));
Object.keys(sn[Re]).map(cn.add.bind(cn));
var uF = [].concat(Ic, da(cn), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Tr.GROUP, Tr.SWAP_OPACITY, Tr.PRIMARY, Tr.SECONDARY]).concat(sy.map(function(o) {
  return "".concat(o, "x");
})).concat(lF.map(function(o) {
  return "w-".concat(o);
})), Qt = Br.FontAwesomeConfig || {};
function pF(o) {
  var e = Te.querySelector("script[" + o + "]");
  if (e)
    return e.getAttribute(o);
}
function dF(o) {
  return o === "" ? !0 : o === "false" ? !1 : o === "true" ? !0 : o;
}
if (Te && typeof Te.querySelector == "function") {
  var gF = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  gF.forEach(function(o) {
    var e = jc(o, 2), r = e[0], t = e[1], n = dF(pF(r));
    n != null && (Qt[t] = n);
  });
}
var iy = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: ry,
  replacementClass: ty,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Qt.familyPrefix && (Qt.cssPrefix = Qt.familyPrefix);
var Ft = re(re({}, iy), Qt);
Ft.autoReplaceSvg || (Ft.observeMutations = !1);
var ne = {};
Object.keys(iy).forEach(function(o) {
  Object.defineProperty(ne, o, {
    enumerable: !0,
    set: function(r) {
      Ft[o] = r, Kt.forEach(function(t) {
        return t(ne);
      });
    },
    get: function() {
      return Ft[o];
    }
  });
});
Object.defineProperty(ne, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Ft.cssPrefix = e, Kt.forEach(function(r) {
      return r(ne);
    });
  },
  get: function() {
    return Ft.cssPrefix;
  }
});
Br.FontAwesomeConfig = ne;
var Kt = [];
function mF(o) {
  return Kt.push(o), function() {
    Kt.splice(Kt.indexOf(o), 1);
  };
}
var tt = Il, Xo = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function yF(o) {
  if (!(!o || !pr)) {
    var e = Te.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = o;
    for (var r = Te.head.childNodes, t = null, n = r.length - 1; n > -1; n--) {
      var a = r[n], s = (a.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(s) > -1 && (t = a);
    }
    return Te.head.insertBefore(e, t), o;
  }
}
var fF = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function un() {
  for (var o = 12, e = ""; o-- > 0; )
    e += fF[Math.random() * 62 | 0];
  return e;
}
function xt(o) {
  for (var e = [], r = (o || []).length >>> 0; r--; )
    e[r] = o[r];
  return e;
}
function Rc(o) {
  return o.classList ? xt(o.classList) : (o.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function ly(o) {
  return "".concat(o).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function hF(o) {
  return Object.keys(o || {}).reduce(function(e, r) {
    return e + "".concat(r, '="').concat(ly(o[r]), '" ');
  }, "").trim();
}
function Is(o) {
  return Object.keys(o || {}).reduce(function(e, r) {
    return e + "".concat(r, ": ").concat(o[r].trim(), ";");
  }, "");
}
function Lc(o) {
  return o.size !== Xo.size || o.x !== Xo.x || o.y !== Xo.y || o.rotate !== Xo.rotate || o.flipX || o.flipY;
}
function FF(o) {
  var e = o.transform, r = o.containerWidth, t = o.iconWidth, n = {
    transform: "translate(".concat(r / 2, " 256)")
  }, a = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), s = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), i = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(a, " ").concat(s, " ").concat(i)
  }, c = {
    transform: "translate(".concat(t / 2 * -1, " -256)")
  };
  return {
    outer: n,
    inner: l,
    path: c
  };
}
function bF(o) {
  var e = o.transform, r = o.width, t = r === void 0 ? Il : r, n = o.height, a = n === void 0 ? Il : n, s = "";
  return oy ? s += "translate(".concat(e.x / tt - t / 2, "em, ").concat(e.y / tt - a / 2, "em) ") : s += "translate(calc(-50% + ".concat(e.x / tt, "em), calc(-50% + ").concat(e.y / tt, "em)) "), s += "scale(".concat(e.size / tt * (e.flipX ? -1 : 1), ", ").concat(e.size / tt * (e.flipY ? -1 : 1), ") "), s += "rotate(".concat(e.rotate, "deg) "), s;
}
var vF = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function cy() {
  var o = ry, e = ty, r = ne.cssPrefix, t = ne.replacementClass, n = vF;
  if (r !== o || t !== e) {
    var a = new RegExp("\\.".concat(o, "\\-"), "g"), s = new RegExp("\\--".concat(o, "\\-"), "g"), i = new RegExp("\\.".concat(e), "g");
    n = n.replace(a, ".".concat(r, "-")).replace(s, "--".concat(r, "-")).replace(i, ".".concat(t));
  }
  return n;
}
var Xu = !1;
function ui() {
  ne.autoAddCss && !Xu && (yF(cy()), Xu = !0);
}
var PF = {
  mixout: function() {
    return {
      dom: {
        css: cy,
        insertCss: ui
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        ui();
      },
      beforeI2svg: function() {
        ui();
      }
    };
  }
}, ar = Br || {};
ar[nr] || (ar[nr] = {});
ar[nr].styles || (ar[nr].styles = {});
ar[nr].hooks || (ar[nr].hooks = {});
ar[nr].shims || (ar[nr].shims = []);
var Mo = ar[nr], uy = [], BF = function o() {
  Te.removeEventListener("DOMContentLoaded", o), gs = 1, uy.map(function(e) {
    return e();
  });
}, gs = !1;
pr && (gs = (Te.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Te.readyState), gs || Te.addEventListener("DOMContentLoaded", BF));
function kF(o) {
  pr && (gs ? setTimeout(o, 0) : uy.push(o));
}
function ma(o) {
  var e = o.tag, r = o.attributes, t = r === void 0 ? {} : r, n = o.children, a = n === void 0 ? [] : n;
  return typeof o == "string" ? ly(o) : "<".concat(e, " ").concat(hF(t), ">").concat(a.map(ma).join(""), "</").concat(e, ">");
}
function qu(o, e, r) {
  if (o && o[e] && o[e][r])
    return {
      prefix: e,
      iconName: r,
      icon: o[e][r]
    };
}
var pi = function(e, r, t, n) {
  var a = Object.keys(e), s = a.length, i = r, l, c, u;
  for (t === void 0 ? (l = 1, u = e[a[0]]) : (l = 0, u = t); l < s; l++)
    c = a[l], u = i(u, e[c], c, e);
  return u;
};
function wF(o) {
  for (var e = [], r = 0, t = o.length; r < t; ) {
    var n = o.charCodeAt(r++);
    if (n >= 55296 && n <= 56319 && r < t) {
      var a = o.charCodeAt(r++);
      (a & 64512) == 56320 ? e.push(((n & 1023) << 10) + (a & 1023) + 65536) : (e.push(n), r--);
    } else
      e.push(n);
  }
  return e;
}
function Ll(o) {
  var e = wF(o);
  return e.length === 1 ? e[0].toString(16) : null;
}
function DF(o, e) {
  var r = o.length, t = o.charCodeAt(e), n;
  return t >= 55296 && t <= 56319 && r > e + 1 && (n = o.charCodeAt(e + 1), n >= 56320 && n <= 57343) ? (t - 55296) * 1024 + n - 56320 + 65536 : t;
}
function Uu(o) {
  return Object.keys(o).reduce(function(e, r) {
    var t = o[r], n = !!t.icon;
    return n ? e[t.iconName] = t.icon : e[r] = t, e;
  }, {});
}
function Hl(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = r.skipHooks, n = t === void 0 ? !1 : t, a = Uu(e);
  typeof Mo.hooks.addPack == "function" && !n ? Mo.hooks.addPack(o, Uu(e)) : Mo.styles[o] = re(re({}, Mo.styles[o] || {}), a), o === "fas" && Hl("fa", e);
}
var Ca, Oa, Ta, pt = Mo.styles, SF = Mo.shims, EF = (Ca = {}, Ve(Ca, Oe, Object.values(ln[Oe])), Ve(Ca, Re, Object.values(ln[Re])), Ca), Hc = null, py = {}, dy = {}, gy = {}, my = {}, yy = {}, xF = (Oa = {}, Ve(Oa, Oe, Object.keys(an[Oe])), Ve(Oa, Re, Object.keys(an[Re])), Oa);
function AF(o) {
  return ~uF.indexOf(o);
}
function CF(o, e) {
  var r = e.split("-"), t = r[0], n = r.slice(1).join("-");
  return t === o && n !== "" && !AF(n) ? n : null;
}
var fy = function() {
  var e = function(a) {
    return pi(pt, function(s, i, l) {
      return s[l] = pi(i, a, {}), s;
    }, {});
  };
  py = e(function(n, a, s) {
    if (a[3] && (n[a[3]] = s), a[2]) {
      var i = a[2].filter(function(l) {
        return typeof l == "number";
      });
      i.forEach(function(l) {
        n[l.toString(16)] = s;
      });
    }
    return n;
  }), dy = e(function(n, a, s) {
    if (n[s] = s, a[2]) {
      var i = a[2].filter(function(l) {
        return typeof l == "string";
      });
      i.forEach(function(l) {
        n[l] = s;
      });
    }
    return n;
  }), yy = e(function(n, a, s) {
    var i = a[2];
    return n[s] = s, i.forEach(function(l) {
      n[l] = s;
    }), n;
  });
  var r = "far" in pt || ne.autoFetchSvg, t = pi(SF, function(n, a) {
    var s = a[0], i = a[1], l = a[2];
    return i === "far" && !r && (i = "fas"), typeof s == "string" && (n.names[s] = {
      prefix: i,
      iconName: l
    }), typeof s == "number" && (n.unicodes[s.toString(16)] = {
      prefix: i,
      iconName: l
    }), n;
  }, {
    names: {},
    unicodes: {}
  });
  gy = t.names, my = t.unicodes, Hc = Rs(ne.styleDefault, {
    family: ne.familyDefault
  });
};
mF(function(o) {
  Hc = Rs(o.styleDefault, {
    family: ne.familyDefault
  });
});
fy();
function Wc(o, e) {
  return (py[o] || {})[e];
}
function OF(o, e) {
  return (dy[o] || {})[e];
}
function jr(o, e) {
  return (yy[o] || {})[e];
}
function hy(o) {
  return gy[o] || {
    prefix: null,
    iconName: null
  };
}
function TF(o) {
  var e = my[o], r = Wc("fas", o);
  return e || (r ? {
    prefix: "fas",
    iconName: r
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function kr() {
  return Hc;
}
var Vc = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function Rs(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.family, t = r === void 0 ? Oe : r, n = an[t][o], a = sn[t][o] || sn[t][n], s = o in Mo.styles ? o : null;
  return a || s || null;
}
var Yu = (Ta = {}, Ve(Ta, Oe, Object.keys(ln[Oe])), Ve(Ta, Re, Object.keys(ln[Re])), Ta);
function Ls(o) {
  var e, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.skipLookups, n = t === void 0 ? !1 : t, a = (e = {}, Ve(e, Oe, "".concat(ne.cssPrefix, "-").concat(Oe)), Ve(e, Re, "".concat(ne.cssPrefix, "-").concat(Re)), e), s = null, i = Oe;
  (o.includes(a[Oe]) || o.some(function(c) {
    return Yu[Oe].includes(c);
  })) && (i = Oe), (o.includes(a[Re]) || o.some(function(c) {
    return Yu[Re].includes(c);
  })) && (i = Re);
  var l = o.reduce(function(c, u) {
    var m = CF(ne.cssPrefix, u);
    if (pt[u] ? (u = EF[i].includes(u) ? nF[i][u] : u, s = u, c.prefix = u) : xF[i].indexOf(u) > -1 ? (s = u, c.prefix = Rs(u, {
      family: i
    })) : m ? c.iconName = m : u !== ne.replacementClass && u !== a[Oe] && u !== a[Re] && c.rest.push(u), !n && c.prefix && c.iconName) {
      var y = s === "fa" ? hy(c.iconName) : {}, g = jr(c.prefix, c.iconName);
      y.prefix && (s = null), c.iconName = y.iconName || g || c.iconName, c.prefix = y.prefix || c.prefix, c.prefix === "far" && !pt.far && pt.fas && !ne.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, Vc());
  return (o.includes("fa-brands") || o.includes("fab")) && (l.prefix = "fab"), (o.includes("fa-duotone") || o.includes("fad")) && (l.prefix = "fad"), !l.prefix && i === Re && (pt.fass || ne.autoFetchSvg) && (l.prefix = "fass", l.iconName = jr(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || s === "fa") && (l.prefix = kr() || "fas"), l;
}
var jF = /* @__PURE__ */ function() {
  function o() {
    X1(this, o), this.definitions = {};
  }
  return U1(o, [{
    key: "add",
    value: function() {
      for (var r = this, t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      var s = n.reduce(this._pullDefinitions, {});
      Object.keys(s).forEach(function(i) {
        r.definitions[i] = re(re({}, r.definitions[i] || {}), s[i]), Hl(i, s[i]);
        var l = ln[Oe][i];
        l && Hl(l, s[i]), fy();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(r, t) {
      var n = t.prefix && t.iconName && t.icon ? {
        0: t
      } : t;
      return Object.keys(n).map(function(a) {
        var s = n[a], i = s.prefix, l = s.iconName, c = s.icon, u = c[2];
        r[i] || (r[i] = {}), u.length > 0 && u.forEach(function(m) {
          typeof m == "string" && (r[i][m] = c);
        }), r[i][l] = c;
      }), r;
    }
  }]), o;
}(), Ju = [], dt = {}, yt = {}, MF = Object.keys(yt);
function zF(o, e) {
  var r = e.mixoutsTo;
  return Ju = o, dt = {}, Object.keys(yt).forEach(function(t) {
    MF.indexOf(t) === -1 && delete yt[t];
  }), Ju.forEach(function(t) {
    var n = t.mixout ? t.mixout() : {};
    if (Object.keys(n).forEach(function(s) {
      typeof n[s] == "function" && (r[s] = n[s]), ds(n[s]) === "object" && Object.keys(n[s]).forEach(function(i) {
        r[s] || (r[s] = {}), r[s][i] = n[s][i];
      });
    }), t.hooks) {
      var a = t.hooks();
      Object.keys(a).forEach(function(s) {
        dt[s] || (dt[s] = []), dt[s].push(a[s]);
      });
    }
    t.provides && t.provides(yt);
  }), r;
}
function Wl(o, e) {
  for (var r = arguments.length, t = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)
    t[n - 2] = arguments[n];
  var a = dt[o] || [];
  return a.forEach(function(s) {
    e = s.apply(null, [e].concat(t));
  }), e;
}
function Zr(o) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
    r[t - 1] = arguments[t];
  var n = dt[o] || [];
  n.forEach(function(a) {
    a.apply(null, r);
  });
}
function sr() {
  var o = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return yt[o] ? yt[o].apply(null, e) : void 0;
}
function Vl(o) {
  o.prefix === "fa" && (o.prefix = "fas");
  var e = o.iconName, r = o.prefix || kr();
  if (e)
    return e = jr(r, e) || e, qu(Fy.definitions, r, e) || qu(Mo.styles, r, e);
}
var Fy = new jF(), NF = function() {
  ne.autoReplaceSvg = !1, ne.observeMutations = !1, Zr("noAuto");
}, IF = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return pr ? (Zr("beforeI2svg", e), sr("pseudoElements2svg", e), sr("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot;
    ne.autoReplaceSvg === !1 && (ne.autoReplaceSvg = !0), ne.observeMutations = !0, kF(function() {
      LF({
        autoReplaceSvgRoot: r
      }), Zr("watch", e);
    });
  }
}, RF = {
  icon: function(e) {
    if (e === null)
      return null;
    if (ds(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: jr(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var r = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], t = Rs(e[0]);
      return {
        prefix: t,
        iconName: jr(t, r) || r
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(ne.cssPrefix, "-")) > -1 || e.match(aF))) {
      var n = Ls(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: n.prefix || kr(),
        iconName: jr(n.prefix, n.iconName) || n.iconName
      };
    }
    if (typeof e == "string") {
      var a = kr();
      return {
        prefix: a,
        iconName: jr(a, e) || e
      };
    }
  }
}, ko = {
  noAuto: NF,
  config: ne,
  dom: IF,
  parse: RF,
  library: Fy,
  findIconDefinition: Vl,
  toHtml: ma
}, LF = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot, t = r === void 0 ? Te : r;
  (Object.keys(Mo.styles).length > 0 || ne.autoFetchSvg) && pr && ne.autoReplaceSvg && ko.dom.i2svg({
    node: t
  });
};
function Hs(o, e) {
  return Object.defineProperty(o, "abstract", {
    get: e
  }), Object.defineProperty(o, "html", {
    get: function() {
      return o.abstract.map(function(t) {
        return ma(t);
      });
    }
  }), Object.defineProperty(o, "node", {
    get: function() {
      if (pr) {
        var t = Te.createElement("div");
        return t.innerHTML = o.html, t.children;
      }
    }
  }), o;
}
function HF(o) {
  var e = o.children, r = o.main, t = o.mask, n = o.attributes, a = o.styles, s = o.transform;
  if (Lc(s) && r.found && !t.found) {
    var i = r.width, l = r.height, c = {
      x: i / l / 2,
      y: 0.5
    };
    n.style = Is(re(re({}, a), {}, {
      "transform-origin": "".concat(c.x + s.x / 16, "em ").concat(c.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: n,
    children: e
  }];
}
function WF(o) {
  var e = o.prefix, r = o.iconName, t = o.children, n = o.attributes, a = o.symbol, s = a === !0 ? "".concat(e, "-").concat(ne.cssPrefix, "-").concat(r) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: re(re({}, n), {}, {
        id: s
      }),
      children: t
    }]
  }];
}
function Gc(o) {
  var e = o.icons, r = e.main, t = e.mask, n = o.prefix, a = o.iconName, s = o.transform, i = o.symbol, l = o.title, c = o.maskId, u = o.titleId, m = o.extra, y = o.watchable, g = y === void 0 ? !1 : y, p = t.found ? t : r, d = p.width, h = p.height, f = n === "fak", F = [ne.replacementClass, a ? "".concat(ne.cssPrefix, "-").concat(a) : ""].filter(function(D) {
    return m.classes.indexOf(D) === -1;
  }).filter(function(D) {
    return D !== "" || !!D;
  }).concat(m.classes).join(" "), b = {
    children: [],
    attributes: re(re({}, m.attributes), {}, {
      "data-prefix": n,
      "data-icon": a,
      class: F,
      role: m.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(h)
    })
  }, v = f && !~m.classes.indexOf("fa-fw") ? {
    width: "".concat(d / h * 16 * 0.0625, "em")
  } : {};
  g && (b.attributes[Gr] = ""), l && (b.children.push({
    tag: "title",
    attributes: {
      id: b.attributes["aria-labelledby"] || "title-".concat(u || un())
    },
    children: [l]
  }), delete b.attributes.title);
  var k = re(re({}, b), {}, {
    prefix: n,
    iconName: a,
    main: r,
    mask: t,
    maskId: c,
    transform: s,
    symbol: i,
    styles: re(re({}, v), m.styles)
  }), E = t.found && r.found ? sr("generateAbstractMask", k) || {
    children: [],
    attributes: {}
  } : sr("generateAbstractIcon", k) || {
    children: [],
    attributes: {}
  }, S = E.children, B = E.attributes;
  return k.children = S, k.attributes = B, i ? WF(k) : HF(k);
}
function Qu(o) {
  var e = o.content, r = o.width, t = o.height, n = o.transform, a = o.title, s = o.extra, i = o.watchable, l = i === void 0 ? !1 : i, c = re(re(re({}, s.attributes), a ? {
    title: a
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  l && (c[Gr] = "");
  var u = re({}, s.styles);
  Lc(n) && (u.transform = bF({
    transform: n,
    width: r,
    height: t
  }), u["-webkit-transform"] = u.transform);
  var m = Is(u);
  m.length > 0 && (c.style = m);
  var y = [];
  return y.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), a && y.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [a]
  }), y;
}
function VF(o) {
  var e = o.content, r = o.title, t = o.extra, n = re(re(re({}, t.attributes), r ? {
    title: r
  } : {}), {}, {
    class: t.classes.join(" ")
  }), a = Is(t.styles);
  a.length > 0 && (n.style = a);
  var s = [];
  return s.push({
    tag: "span",
    attributes: n,
    children: [e]
  }), r && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), s;
}
var di = Mo.styles;
function Gl(o) {
  var e = o[0], r = o[1], t = o.slice(4), n = jc(t, 1), a = n[0], s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(ne.cssPrefix, "-").concat(Tr.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(ne.cssPrefix, "-").concat(Tr.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(ne.cssPrefix, "-").concat(Tr.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: e,
    height: r,
    icon: s
  };
}
var GF = {
  found: !1,
  width: 512,
  height: 512
};
function ZF(o, e) {
  !ny && !ne.showMissingIcons && o && console.error('Icon with name "'.concat(o, '" and prefix "').concat(e, '" is missing.'));
}
function Zl(o, e) {
  var r = e;
  return e === "fa" && ne.styleDefault !== null && (e = kr()), new Promise(function(t, n) {
    if (sr("missingIconAbstract"), r === "fa") {
      var a = hy(o) || {};
      o = a.iconName || o, e = a.prefix || e;
    }
    if (o && e && di[e] && di[e][o]) {
      var s = di[e][o];
      return t(Gl(s));
    }
    ZF(o, e), t(re(re({}, GF), {}, {
      icon: ne.showMissingIcons && o ? sr("missingIconAbstract") || {} : {}
    }));
  });
}
var Ku = function() {
}, Xl = ne.measurePerformance && wa && wa.mark && wa.measure ? wa : {
  mark: Ku,
  measure: Ku
}, Wt = 'FA "6.5.1"', XF = function(e) {
  return Xl.mark("".concat(Wt, " ").concat(e, " begins")), function() {
    return by(e);
  };
}, by = function(e) {
  Xl.mark("".concat(Wt, " ").concat(e, " ends")), Xl.measure("".concat(Wt, " ").concat(e), "".concat(Wt, " ").concat(e, " begins"), "".concat(Wt, " ").concat(e, " ends"));
}, Zc = {
  begin: XF,
  end: by
}, Qa = function() {
};
function _u(o) {
  var e = o.getAttribute ? o.getAttribute(Gr) : null;
  return typeof e == "string";
}
function qF(o) {
  var e = o.getAttribute ? o.getAttribute(zc) : null, r = o.getAttribute ? o.getAttribute(Nc) : null;
  return e && r;
}
function UF(o) {
  return o && o.classList && o.classList.contains && o.classList.contains(ne.replacementClass);
}
function YF() {
  if (ne.autoReplaceSvg === !0)
    return Ka.replace;
  var o = Ka[ne.autoReplaceSvg];
  return o || Ka.replace;
}
function JF(o) {
  return Te.createElementNS("http://www.w3.org/2000/svg", o);
}
function QF(o) {
  return Te.createElement(o);
}
function vy(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.ceFn, t = r === void 0 ? o.tag === "svg" ? JF : QF : r;
  if (typeof o == "string")
    return Te.createTextNode(o);
  var n = t(o.tag);
  Object.keys(o.attributes || []).forEach(function(s) {
    n.setAttribute(s, o.attributes[s]);
  });
  var a = o.children || [];
  return a.forEach(function(s) {
    n.appendChild(vy(s, {
      ceFn: t
    }));
  }), n;
}
function KF(o) {
  var e = " ".concat(o.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var Ka = {
  replace: function(e) {
    var r = e[0];
    if (r.parentNode)
      if (e[1].forEach(function(n) {
        r.parentNode.insertBefore(vy(n), r);
      }), r.getAttribute(Gr) === null && ne.keepOriginalSource) {
        var t = Te.createComment(KF(r));
        r.parentNode.replaceChild(t, r);
      } else
        r.remove();
  },
  nest: function(e) {
    var r = e[0], t = e[1];
    if (~Rc(r).indexOf(ne.replacementClass))
      return Ka.replace(e);
    var n = new RegExp("".concat(ne.cssPrefix, "-.*"));
    if (delete t[0].attributes.id, t[0].attributes.class) {
      var a = t[0].attributes.class.split(" ").reduce(function(i, l) {
        return l === ne.replacementClass || l.match(n) ? i.toSvg.push(l) : i.toNode.push(l), i;
      }, {
        toNode: [],
        toSvg: []
      });
      t[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? r.removeAttribute("class") : r.setAttribute("class", a.toNode.join(" "));
    }
    var s = t.map(function(i) {
      return ma(i);
    }).join(`
`);
    r.setAttribute(Gr, ""), r.innerHTML = s;
  }
};
function $u(o) {
  o();
}
function Py(o, e) {
  var r = typeof e == "function" ? e : Qa;
  if (o.length === 0)
    r();
  else {
    var t = $u;
    ne.mutateApproach === rF && (t = Br.requestAnimationFrame || $u), t(function() {
      var n = YF(), a = Zc.begin("mutate");
      o.map(n), a(), r();
    });
  }
}
var Xc = !1;
function By() {
  Xc = !0;
}
function ql() {
  Xc = !1;
}
var ms = null;
function ep(o) {
  if (Gu && ne.observeMutations) {
    var e = o.treeCallback, r = e === void 0 ? Qa : e, t = o.nodeCallback, n = t === void 0 ? Qa : t, a = o.pseudoElementsCallback, s = a === void 0 ? Qa : a, i = o.observeMutationsRoot, l = i === void 0 ? Te : i;
    ms = new Gu(function(c) {
      if (!Xc) {
        var u = kr();
        xt(c).forEach(function(m) {
          if (m.type === "childList" && m.addedNodes.length > 0 && !_u(m.addedNodes[0]) && (ne.searchPseudoElements && s(m.target), r(m.target)), m.type === "attributes" && m.target.parentNode && ne.searchPseudoElements && s(m.target.parentNode), m.type === "attributes" && _u(m.target) && ~cF.indexOf(m.attributeName))
            if (m.attributeName === "class" && qF(m.target)) {
              var y = Ls(Rc(m.target)), g = y.prefix, p = y.iconName;
              m.target.setAttribute(zc, g || u), p && m.target.setAttribute(Nc, p);
            } else UF(m.target) && n(m.target);
        });
      }
    }), pr && ms.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function _F() {
  ms && ms.disconnect();
}
function $F(o) {
  var e = o.getAttribute("style"), r = [];
  return e && (r = e.split(";").reduce(function(t, n) {
    var a = n.split(":"), s = a[0], i = a.slice(1);
    return s && i.length > 0 && (t[s] = i.join(":").trim()), t;
  }, {})), r;
}
function e0(o) {
  var e = o.getAttribute("data-prefix"), r = o.getAttribute("data-icon"), t = o.innerText !== void 0 ? o.innerText.trim() : "", n = Ls(Rc(o));
  return n.prefix || (n.prefix = kr()), e && r && (n.prefix = e, n.iconName = r), n.iconName && n.prefix || (n.prefix && t.length > 0 && (n.iconName = OF(n.prefix, o.innerText) || Wc(n.prefix, Ll(o.innerText))), !n.iconName && ne.autoFetchSvg && o.firstChild && o.firstChild.nodeType === Node.TEXT_NODE && (n.iconName = o.firstChild.data)), n;
}
function o0(o) {
  var e = xt(o.attributes).reduce(function(n, a) {
    return n.name !== "class" && n.name !== "style" && (n[a.name] = a.value), n;
  }, {}), r = o.getAttribute("title"), t = o.getAttribute("data-fa-title-id");
  return ne.autoA11y && (r ? e["aria-labelledby"] = "".concat(ne.replacementClass, "-title-").concat(t || un()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function r0() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Xo,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function op(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, r = e0(o), t = r.iconName, n = r.prefix, a = r.rest, s = o0(o), i = Wl("parseNodeAttributes", {}, o), l = e.styleParser ? $F(o) : [];
  return re({
    iconName: t,
    title: o.getAttribute("title"),
    titleId: o.getAttribute("data-fa-title-id"),
    prefix: n,
    transform: Xo,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: s
    }
  }, i);
}
var t0 = Mo.styles;
function ky(o) {
  var e = ne.autoReplaceSvg === "nest" ? op(o, {
    styleParser: !1
  }) : op(o);
  return ~e.extra.classes.indexOf(ay) ? sr("generateLayersText", o, e) : sr("generateSvgReplacementMutation", o, e);
}
var wr = /* @__PURE__ */ new Set();
Ic.map(function(o) {
  wr.add("fa-".concat(o));
});
Object.keys(an[Oe]).map(wr.add.bind(wr));
Object.keys(an[Re]).map(wr.add.bind(wr));
wr = da(wr);
function rp(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!pr) return Promise.resolve();
  var r = Te.documentElement.classList, t = function(m) {
    return r.add("".concat(Zu, "-").concat(m));
  }, n = function(m) {
    return r.remove("".concat(Zu, "-").concat(m));
  }, a = ne.autoFetchSvg ? wr : Ic.map(function(u) {
    return "fa-".concat(u);
  }).concat(Object.keys(t0));
  a.includes("fa") || a.push("fa");
  var s = [".".concat(ay, ":not([").concat(Gr, "])")].concat(a.map(function(u) {
    return ".".concat(u, ":not([").concat(Gr, "])");
  })).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  var i = [];
  try {
    i = xt(o.querySelectorAll(s));
  } catch {
  }
  if (i.length > 0)
    t("pending"), n("complete");
  else
    return Promise.resolve();
  var l = Zc.begin("onTree"), c = i.reduce(function(u, m) {
    try {
      var y = ky(m);
      y && u.push(y);
    } catch (g) {
      ny || g.name === "MissingIcon" && console.error(g);
    }
    return u;
  }, []);
  return new Promise(function(u, m) {
    Promise.all(c).then(function(y) {
      Py(y, function() {
        t("active"), t("complete"), n("pending"), typeof e == "function" && e(), l(), u();
      });
    }).catch(function(y) {
      l(), m(y);
    });
  });
}
function n0(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  ky(o).then(function(r) {
    r && Py([r], e);
  });
}
function a0(o) {
  return function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = (e || {}).icon ? e : Vl(e || {}), n = r.mask;
    return n && (n = (n || {}).icon ? n : Vl(n || {})), o(t, re(re({}, r), {}, {
      mask: n
    }));
  };
}
var s0 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.transform, n = t === void 0 ? Xo : t, a = r.symbol, s = a === void 0 ? !1 : a, i = r.mask, l = i === void 0 ? null : i, c = r.maskId, u = c === void 0 ? null : c, m = r.title, y = m === void 0 ? null : m, g = r.titleId, p = g === void 0 ? null : g, d = r.classes, h = d === void 0 ? [] : d, f = r.attributes, F = f === void 0 ? {} : f, b = r.styles, v = b === void 0 ? {} : b;
  if (e) {
    var k = e.prefix, E = e.iconName, S = e.icon;
    return Hs(re({
      type: "icon"
    }, e), function() {
      return Zr("beforeDOMElementCreation", {
        iconDefinition: e,
        params: r
      }), ne.autoA11y && (y ? F["aria-labelledby"] = "".concat(ne.replacementClass, "-title-").concat(p || un()) : (F["aria-hidden"] = "true", F.focusable = "false")), Gc({
        icons: {
          main: Gl(S),
          mask: l ? Gl(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: k,
        iconName: E,
        transform: re(re({}, Xo), n),
        symbol: s,
        title: y,
        maskId: u,
        titleId: p,
        extra: {
          attributes: F,
          styles: v,
          classes: h
        }
      });
    });
  }
}, i0 = {
  mixout: function() {
    return {
      icon: a0(s0)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.treeCallback = rp, r.nodeCallback = n0, r;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(r) {
      var t = r.node, n = t === void 0 ? Te : t, a = r.callback, s = a === void 0 ? function() {
      } : a;
      return rp(n, s);
    }, e.generateSvgReplacementMutation = function(r, t) {
      var n = t.iconName, a = t.title, s = t.titleId, i = t.prefix, l = t.transform, c = t.symbol, u = t.mask, m = t.maskId, y = t.extra;
      return new Promise(function(g, p) {
        Promise.all([Zl(n, i), u.iconName ? Zl(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(d) {
          var h = jc(d, 2), f = h[0], F = h[1];
          g([r, Gc({
            icons: {
              main: f,
              mask: F
            },
            prefix: i,
            iconName: n,
            transform: l,
            symbol: c,
            maskId: m,
            title: a,
            titleId: s,
            extra: y,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(r) {
      var t = r.children, n = r.attributes, a = r.main, s = r.transform, i = r.styles, l = Is(i);
      l.length > 0 && (n.style = l);
      var c;
      return Lc(s) && (c = sr("generateAbstractTransformGrouping", {
        main: a,
        transform: s,
        containerWidth: a.width,
        iconWidth: a.width
      })), t.push(c || a.icon), {
        children: t,
        attributes: n
      };
    };
  }
}, l0 = {
  mixout: function() {
    return {
      layer: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.classes, a = n === void 0 ? [] : n;
        return Hs({
          type: "layer"
        }, function() {
          Zr("beforeDOMElementCreation", {
            assembler: r,
            params: t
          });
          var s = [];
          return r(function(i) {
            Array.isArray(i) ? i.map(function(l) {
              s = s.concat(l.abstract);
            }) : s = s.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(ne.cssPrefix, "-layers")].concat(da(a)).join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, c0 = {
  mixout: function() {
    return {
      counter: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.title, a = n === void 0 ? null : n, s = t.classes, i = s === void 0 ? [] : s, l = t.attributes, c = l === void 0 ? {} : l, u = t.styles, m = u === void 0 ? {} : u;
        return Hs({
          type: "counter",
          content: r
        }, function() {
          return Zr("beforeDOMElementCreation", {
            content: r,
            params: t
          }), VF({
            content: r.toString(),
            title: a,
            extra: {
              attributes: c,
              styles: m,
              classes: ["".concat(ne.cssPrefix, "-layers-counter")].concat(da(i))
            }
          });
        });
      }
    };
  }
}, u0 = {
  mixout: function() {
    return {
      text: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transform, a = n === void 0 ? Xo : n, s = t.title, i = s === void 0 ? null : s, l = t.classes, c = l === void 0 ? [] : l, u = t.attributes, m = u === void 0 ? {} : u, y = t.styles, g = y === void 0 ? {} : y;
        return Hs({
          type: "text",
          content: r
        }, function() {
          return Zr("beforeDOMElementCreation", {
            content: r,
            params: t
          }), Qu({
            content: r,
            transform: re(re({}, Xo), a),
            title: i,
            extra: {
              attributes: m,
              styles: g,
              classes: ["".concat(ne.cssPrefix, "-layers-text")].concat(da(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(r, t) {
      var n = t.title, a = t.transform, s = t.extra, i = null, l = null;
      if (oy) {
        var c = parseInt(getComputedStyle(r).fontSize, 10), u = r.getBoundingClientRect();
        i = u.width / c, l = u.height / c;
      }
      return ne.autoA11y && !n && (s.attributes["aria-hidden"] = "true"), Promise.resolve([r, Qu({
        content: r.innerHTML,
        width: i,
        height: l,
        transform: a,
        title: n,
        extra: s,
        watchable: !0
      })]);
    };
  }
}, p0 = new RegExp('"', "ug"), tp = [1105920, 1112319];
function d0(o) {
  var e = o.replace(p0, ""), r = DF(e, 0), t = r >= tp[0] && r <= tp[1], n = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: Ll(n ? e[0] : e),
    isSecondary: t || n
  };
}
function np(o, e) {
  var r = "".concat(oF).concat(e.replace(":", "-"));
  return new Promise(function(t, n) {
    if (o.getAttribute(r) !== null)
      return t();
    var a = xt(o.children), s = a.filter(function(S) {
      return S.getAttribute(Rl) === e;
    })[0], i = Br.getComputedStyle(o, e), l = i.getPropertyValue("font-family").match(sF), c = i.getPropertyValue("font-weight"), u = i.getPropertyValue("content");
    if (s && !l)
      return o.removeChild(s), t();
    if (l && u !== "none" && u !== "") {
      var m = i.getPropertyValue("content"), y = ~["Sharp"].indexOf(l[2]) ? Re : Oe, g = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? sn[y][l[2].toLowerCase()] : iF[y][c], p = d0(m), d = p.value, h = p.isSecondary, f = l[0].startsWith("FontAwesome"), F = Wc(g, d), b = F;
      if (f) {
        var v = TF(d);
        v.iconName && v.prefix && (F = v.iconName, g = v.prefix);
      }
      if (F && !h && (!s || s.getAttribute(zc) !== g || s.getAttribute(Nc) !== b)) {
        o.setAttribute(r, b), s && o.removeChild(s);
        var k = r0(), E = k.extra;
        E.attributes[Rl] = e, Zl(F, g).then(function(S) {
          var B = Gc(re(re({}, k), {}, {
            icons: {
              main: S,
              mask: Vc()
            },
            prefix: g,
            iconName: b,
            extra: E,
            watchable: !0
          })), D = Te.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? o.insertBefore(D, o.firstChild) : o.appendChild(D), D.outerHTML = B.map(function(x) {
            return ma(x);
          }).join(`
`), o.removeAttribute(r), t();
        }).catch(n);
      } else
        t();
    } else
      t();
  });
}
function g0(o) {
  return Promise.all([np(o, "::before"), np(o, "::after")]);
}
function m0(o) {
  return o.parentNode !== document.head && !~tF.indexOf(o.tagName.toUpperCase()) && !o.getAttribute(Rl) && (!o.parentNode || o.parentNode.tagName !== "svg");
}
function ap(o) {
  if (pr)
    return new Promise(function(e, r) {
      var t = xt(o.querySelectorAll("*")).filter(m0).map(g0), n = Zc.begin("searchPseudoElements");
      By(), Promise.all(t).then(function() {
        n(), ql(), e();
      }).catch(function() {
        n(), ql(), r();
      });
    });
}
var y0 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.pseudoElementsCallback = ap, r;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(r) {
      var t = r.node, n = t === void 0 ? Te : t;
      ne.searchPseudoElements && ap(n);
    };
  }
}, sp = !1, f0 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          By(), sp = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        ep(Wl("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        _F();
      },
      watch: function(r) {
        var t = r.observeMutationsRoot;
        sp ? ql() : ep(Wl("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
}, ip = function(e) {
  var r = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(t, n) {
    var a = n.toLowerCase().split("-"), s = a[0], i = a.slice(1).join("-");
    if (s && i === "h")
      return t.flipX = !0, t;
    if (s && i === "v")
      return t.flipY = !0, t;
    if (i = parseFloat(i), isNaN(i))
      return t;
    switch (s) {
      case "grow":
        t.size = t.size + i;
        break;
      case "shrink":
        t.size = t.size - i;
        break;
      case "left":
        t.x = t.x - i;
        break;
      case "right":
        t.x = t.x + i;
        break;
      case "up":
        t.y = t.y - i;
        break;
      case "down":
        t.y = t.y + i;
        break;
      case "rotate":
        t.rotate = t.rotate + i;
        break;
    }
    return t;
  }, r);
}, h0 = {
  mixout: function() {
    return {
      parse: {
        transform: function(r) {
          return ip(r);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-transform");
        return n && (r.transform = ip(n)), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(r) {
      var t = r.main, n = r.transform, a = r.containerWidth, s = r.iconWidth, i = {
        transform: "translate(".concat(a / 2, " 256)")
      }, l = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), u = "rotate(".concat(n.rotate, " 0 0)"), m = {
        transform: "".concat(l, " ").concat(c, " ").concat(u)
      }, y = {
        transform: "translate(".concat(s / 2 * -1, " -256)")
      }, g = {
        outer: i,
        inner: m,
        path: y
      };
      return {
        tag: "g",
        attributes: re({}, g.outer),
        children: [{
          tag: "g",
          attributes: re({}, g.inner),
          children: [{
            tag: t.icon.tag,
            children: t.icon.children,
            attributes: re(re({}, t.icon.attributes), g.path)
          }]
        }]
      };
    };
  }
}, gi = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function lp(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return o.attributes && (o.attributes.fill || e) && (o.attributes.fill = "black"), o;
}
function F0(o) {
  return o.tag === "g" ? o.children : [o];
}
var b0 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-mask"), a = n ? Ls(n.split(" ").map(function(s) {
          return s.trim();
        })) : Vc();
        return a.prefix || (a.prefix = kr()), r.mask = a, r.maskId = t.getAttribute("data-fa-mask-id"), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(r) {
      var t = r.children, n = r.attributes, a = r.main, s = r.mask, i = r.maskId, l = r.transform, c = a.width, u = a.icon, m = s.width, y = s.icon, g = FF({
        transform: l,
        containerWidth: m,
        iconWidth: c
      }), p = {
        tag: "rect",
        attributes: re(re({}, gi), {}, {
          fill: "white"
        })
      }, d = u.children ? {
        children: u.children.map(lp)
      } : {}, h = {
        tag: "g",
        attributes: re({}, g.inner),
        children: [lp(re({
          tag: u.tag,
          attributes: re(re({}, u.attributes), g.path)
        }, d))]
      }, f = {
        tag: "g",
        attributes: re({}, g.outer),
        children: [h]
      }, F = "mask-".concat(i || un()), b = "clip-".concat(i || un()), v = {
        tag: "mask",
        attributes: re(re({}, gi), {}, {
          id: F,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, f]
      }, k = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: b
          },
          children: F0(y)
        }, v]
      };
      return t.push(k, {
        tag: "rect",
        attributes: re({
          fill: "currentColor",
          "clip-path": "url(#".concat(b, ")"),
          mask: "url(#".concat(F, ")")
        }, gi)
      }), {
        children: t,
        attributes: n
      };
    };
  }
}, v0 = {
  provides: function(e) {
    var r = !1;
    Br.matchMedia && (r = Br.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var t = [], n = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      t.push({
        tag: "path",
        attributes: re(re({}, n), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var s = re(re({}, a), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: re(re({}, n), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return r || i.children.push({
        tag: "animate",
        attributes: re(re({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: re(re({}, s), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), t.push(i), t.push({
        tag: "path",
        attributes: re(re({}, n), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: r ? [] : [{
          tag: "animate",
          attributes: re(re({}, s), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), r || t.push({
        tag: "path",
        attributes: re(re({}, n), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: re(re({}, s), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: t
      };
    };
  }
}, P0 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-symbol"), a = n === null ? !1 : n === "" ? !0 : n;
        return r.symbol = a, r;
      }
    };
  }
}, B0 = [PF, i0, l0, c0, u0, y0, f0, h0, b0, v0, P0];
zF(B0, {
  mixoutsTo: ko
});
ko.noAuto;
var wy = ko.config;
ko.library;
ko.dom;
var ys = ko.parse;
ko.findIconDefinition;
ko.toHtml;
var k0 = ko.icon;
ko.layer;
var w0 = ko.text;
ko.counter;
function cp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function jo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cp(Object(r), !0).forEach(function(t) {
      po(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : cp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function fs(o) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fs(o);
}
function po(o, e, r) {
  return e = T0(e), e in o ? Object.defineProperty(o, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = r, o;
}
function D0(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function S0(o, e) {
  if (o == null) return {};
  var r = D0(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function Ul(o) {
  return E0(o) || x0(o) || A0(o) || C0();
}
function E0(o) {
  if (Array.isArray(o)) return Yl(o);
}
function x0(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function A0(o, e) {
  if (o) {
    if (typeof o == "string") return Yl(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yl(o, e);
  }
}
function Yl(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function C0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O0(o, e) {
  if (typeof o != "object" || o === null) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (typeof t != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function T0(o) {
  var e = O0(o, "string");
  return typeof e == "symbol" ? e : String(e);
}
var j0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Dy = { exports: {} };
(function(o) {
  (function(e) {
    var r = function(f, F, b) {
      if (!c(F) || m(F) || y(F) || g(F) || l(F))
        return F;
      var v, k = 0, E = 0;
      if (u(F))
        for (v = [], E = F.length; k < E; k++)
          v.push(r(f, F[k], b));
      else {
        v = {};
        for (var S in F)
          Object.prototype.hasOwnProperty.call(F, S) && (v[f(S, b)] = r(f, F[S], b));
      }
      return v;
    }, t = function(f, F) {
      F = F || {};
      var b = F.separator || "_", v = F.split || /(?=[A-Z])/;
      return f.split(v).join(b);
    }, n = function(f) {
      return p(f) ? f : (f = f.replace(/[\-_\s]+(.)?/g, function(F, b) {
        return b ? b.toUpperCase() : "";
      }), f.substr(0, 1).toLowerCase() + f.substr(1));
    }, a = function(f) {
      var F = n(f);
      return F.substr(0, 1).toUpperCase() + F.substr(1);
    }, s = function(f, F) {
      return t(f, F).toLowerCase();
    }, i = Object.prototype.toString, l = function(f) {
      return typeof f == "function";
    }, c = function(f) {
      return f === Object(f);
    }, u = function(f) {
      return i.call(f) == "[object Array]";
    }, m = function(f) {
      return i.call(f) == "[object Date]";
    }, y = function(f) {
      return i.call(f) == "[object RegExp]";
    }, g = function(f) {
      return i.call(f) == "[object Boolean]";
    }, p = function(f) {
      return f = f - 0, f === f;
    }, d = function(f, F) {
      var b = F && "process" in F ? F.process : F;
      return typeof b != "function" ? f : function(v, k) {
        return b(v, f, k);
      };
    }, h = {
      camelize: n,
      decamelize: s,
      pascalize: a,
      depascalize: s,
      camelizeKeys: function(f, F) {
        return r(d(n, F), f);
      },
      decamelizeKeys: function(f, F) {
        return r(d(s, F), f, F);
      },
      pascalizeKeys: function(f, F) {
        return r(d(a, F), f);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    o.exports ? o.exports = h : e.humps = h;
  })(j0);
})(Dy);
var M0 = Dy.exports, z0 = ["class", "style"];
function N0(o) {
  return o.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, r) {
    var t = r.indexOf(":"), n = M0.camelize(r.slice(0, t)), a = r.slice(t + 1).trim();
    return e[n] = a, e;
  }, {});
}
function I0(o) {
  return o.split(/\s+/).reduce(function(e, r) {
    return e[r] = !0, e;
  }, {});
}
function qc(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof o == "string")
    return o;
  var t = (o.children || []).map(function(l) {
    return qc(l);
  }), n = Object.keys(o.attributes || {}).reduce(function(l, c) {
    var u = o.attributes[c];
    switch (c) {
      case "class":
        l.class = I0(u);
        break;
      case "style":
        l.style = N0(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  r.class;
  var a = r.style, s = a === void 0 ? {} : a, i = S0(r, z0);
  return Rr(o.tag, jo(jo(jo({}, e), {}, {
    class: n.class,
    style: jo(jo({}, n.style), s)
  }, n.attrs), i), t);
}
var Sy = !1;
try {
  Sy = process.env.NODE_ENV === "production";
} catch {
}
function R0() {
  if (!Sy && console && typeof console.error == "function") {
    var o;
    (o = console).error.apply(o, arguments);
  }
}
function _t(o, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? po({}, o, e) : {};
}
function L0(o) {
  var e, r = (e = {
    "fa-spin": o.spin,
    "fa-pulse": o.pulse,
    "fa-fw": o.fixedWidth,
    "fa-border": o.border,
    "fa-li": o.listItem,
    "fa-inverse": o.inverse,
    "fa-flip": o.flip === !0,
    "fa-flip-horizontal": o.flip === "horizontal" || o.flip === "both",
    "fa-flip-vertical": o.flip === "vertical" || o.flip === "both"
  }, po(e, "fa-".concat(o.size), o.size !== null), po(e, "fa-rotate-".concat(o.rotation), o.rotation !== null), po(e, "fa-pull-".concat(o.pull), o.pull !== null), po(e, "fa-swap-opacity", o.swapOpacity), po(e, "fa-bounce", o.bounce), po(e, "fa-shake", o.shake), po(e, "fa-beat", o.beat), po(e, "fa-fade", o.fade), po(e, "fa-beat-fade", o.beatFade), po(e, "fa-flash", o.flash), po(e, "fa-spin-pulse", o.spinPulse), po(e, "fa-spin-reverse", o.spinReverse), e);
  return Object.keys(r).map(function(t) {
    return r[t] ? t : null;
  }).filter(function(t) {
    return t;
  });
}
function up(o) {
  if (o && fs(o) === "object" && o.prefix && o.iconName && o.icon)
    return o;
  if (ys.icon)
    return ys.icon(o);
  if (o === null)
    return null;
  if (fs(o) === "object" && o.prefix && o.iconName)
    return o;
  if (Array.isArray(o) && o.length === 2)
    return {
      prefix: o[0],
      iconName: o[1]
    };
  if (typeof o == "string")
    return {
      prefix: "fas",
      iconName: o
    };
}
var ce = W({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var t = r.attrs, n = ae(function() {
      return up(e.icon);
    }), a = ae(function() {
      return _t("classes", L0(e));
    }), s = ae(function() {
      return _t("transform", typeof e.transform == "string" ? ys.transform(e.transform) : e.transform);
    }), i = ae(function() {
      return _t("mask", up(e.mask));
    }), l = ae(function() {
      return k0(n.value, jo(jo(jo(jo({}, a.value), s.value), i.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    Et(l, function(u) {
      if (!u)
        return R0("Could not find one or more icon(s)", n.value, i.value);
    }, {
      immediate: !0
    });
    var c = ae(function() {
      return l.value ? qc(l.value.abstract[0], {}, t) : null;
    });
    return function() {
      return c.value;
    };
  }
});
W({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var t = r.slots, n = wy.familyPrefix, a = ae(function() {
      return ["".concat(n, "-layers")].concat(Ul(e.fixedWidth ? ["".concat(n, "-fw")] : []));
    });
    return function() {
      return Rr("div", {
        class: a.value
      }, t.default ? t.default() : []);
    };
  }
});
W({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(e) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(e) > -1;
      }
    }
  },
  setup: function(e, r) {
    var t = r.attrs, n = wy.familyPrefix, a = ae(function() {
      return _t("classes", [].concat(Ul(e.counter ? ["".concat(n, "-layers-counter")] : []), Ul(e.position ? ["".concat(n, "-layers-").concat(e.position)] : [])));
    }), s = ae(function() {
      return _t("transform", typeof e.transform == "string" ? ys.transform(e.transform) : e.transform);
    }), i = ae(function() {
      var c = w0(e.value.toString(), jo(jo({}, s.value), a.value)), u = c.abstract;
      return e.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = ae(function() {
      return qc(i.value, {}, t);
    });
    return function() {
      return l.value;
    };
  }
});
var ya = {
  prefix: "far",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
  ]
}, H0 = {
  prefix: "far",
  iconName: "face-smile",
  icon: [
    512,
    512,
    [128578, "smile"],
    "f118",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, W0 = H0, Ws = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
  ]
}, Uc = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
  ]
}, fa = {
  prefix: "far",
  iconName: "xmark",
  icon: [
    384,
    512,
    [215, 10005, 10006, 10060, 128473, "close", "multiply", "remove", "times"],
    "f00d",
    "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
  ]
}, V0 = {
  prefix: "far",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"
  ]
}, Yc = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"
  ]
}, G0 = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"
  ]
}, Z0 = G0, X0 = {
  prefix: "far",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"
  ]
}, q0 = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [
    448,
    512,
    [8592],
    "f060",
    "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"
  ]
}, pp = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [
    448,
    512,
    [8594],
    "f061",
    "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"
  ]
}, U0 = {
  prefix: "far",
  iconName: "italic",
  icon: [
    384,
    512,
    [],
    "f033",
    "M128 56c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H291.3L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H92.7L239.3 80H152c-13.3 0-24-10.7-24-24z"
  ]
}, Y0 = {
  prefix: "far",
  iconName: "bold",
  icon: [
    384,
    512,
    [],
    "f032",
    "M0 56C0 42.7 10.7 32 24 32H72 88 212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H88 72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V256 80H24C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76H96V232H212zM96 280V432H244c42 0 76-34 76-76s-34-76-76-76H212 96z"
  ]
}, J0 = {
  prefix: "far",
  iconName: "underline",
  icon: [
    448,
    512,
    [],
    "f0cd",
    "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
  ]
}, Q0 = {
  prefix: "far",
  iconName: "sparkles",
  icon: [
    512,
    512,
    [10024],
    "f890",
    "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
  ]
}, K0 = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"
  ]
}, _0 = {
  prefix: "far",
  iconName: "bars",
  icon: [
    448,
    512,
    ["navicon"],
    "f0c9",
    "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"
  ]
}, $0 = {
  prefix: "far",
  iconName: "strikethrough",
  icon: [
    512,
    512,
    [],
    "f0cc",
    "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z"
  ]
};
const eb = { class: "flex-1 text-left" }, fM = /* @__PURE__ */ W({
  __name: "AccordionButton",
  setup(o) {
    const e = pe("multiple", !1);
    return (r, t) => (w(), L(Fe(P(e) ? "dt" : "div"), null, {
      default: M(() => [
        H(P(Wm), {
          class: Z([
            "w-full text-sm flex justify-between items-center gap-2 text-default-600",
            "hover:text-default-700"
          ])
        }, {
          default: M(({ open: n }) => [
            A("span", eb, [
              R(r.$slots, "default", { open: n })
            ]),
            H(P(ce), {
              icon: n ? P(X0) : P(V0),
              class: "size-5 flex-none",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), ob = {
  class: /* @__PURE__ */ Z([
    "divide-y divide-gray-900/10",
    "[&>div]:py-6 [&>div:first-child]:pt-0 [&>div:last-child]:pb-0"
  ])
}, hM = /* @__PURE__ */ W({
  __name: "AccordionGroup",
  setup(o) {
    return Be("multiple", !0), (e, r) => (w(), j("dl", ob, [
      R(e.$slots, "default")
    ]));
  }
}), FM = /* @__PURE__ */ W({
  __name: "AccordionPanel",
  setup(o) {
    const e = pe("multiple", !1);
    return (r, t) => (w(), L(P(Vm), {
      class: "pt-6 text-sm",
      as: P(e) ? "dd" : void 0
    }, {
      default: M(({ open: n, close: a }) => [
        R(r.$slots, "default", {
          open: n,
          close: a
        })
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), rb = {
  class: /* @__PURE__ */ Z([
    "shadow rounded-2xl bg-primary-100 p-6 flex items-center",
    "md:space-x-base"
  ])
}, tb = {
  key: 0,
  class: /* @__PURE__ */ Z([
    "hidden size-10 rounded-full bg-primary-600 items-center justify-center",
    "md:inline-flex"
  ])
}, nb = {
  class: /* @__PURE__ */ Z([
    "flex-1 grid-cols-12 grid-rows-[repeat(2,minmax(0,auto))]",
    "md:grid"
  ])
}, bM = /* @__PURE__ */ W({
  __name: "ActionBanner",
  props: {
    icon: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", rb, [
      e.icon ? (w(), j("span", tb, [
        H(P(ce), {
          icon: e.icon,
          class: "size-4 text-white",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : Q("", !0),
      A("div", nb, [
        R(e.$slots, "default")
      ])
    ]));
  }
}), le = (o, e) => {
  const r = o.__vccOpts || o;
  for (const [t, n] of e)
    r[t] = n;
  return r;
}, ab = {}, sb = {
  class: /* @__PURE__ */ Z([
    "col-start-9 col-end-13 row-start-1 row-end-3 pt-4",
    "md:pt-0 md:self-center md:justify-self-end"
  ])
};
function ib(o, e) {
  return w(), j("div", sb, [
    R(o.$slots, "default")
  ]);
}
const vM = /* @__PURE__ */ le(ab, [["render", ib]]), lb = {}, cb = { class: "mt-1 text-sm font-medium text-default-700 col-start-1 col-end-9 row-start-2 row-end-3" };
function ub(o, e) {
  return w(), j("div", cb, [
    A("p", null, [
      R(o.$slots, "default")
    ])
  ]);
}
const PM = /* @__PURE__ */ le(lb, [["render", ub]]), Dr = /* @__PURE__ */ W({
  __name: "Heading",
  props: {
    as: {},
    size: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["sm", "text-sm font-bold"],
      ["base", "text-base font-semibold"],
      ["lg", "text-lg font-semibold"],
      ["xl", "text-xl font-bold"],
      ["2xl", "text-2xl font-bold"]
    ]);
    return (r, t) => (w(), L(Fe(r.as), {
      class: Z([
        "text-default-900 font-gilmer",
        P(e).get(r.size)
      ])
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), pb = { class: "col-start-1 col-end-9 row-start-1 row-end-2" }, BM = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "ActionBannerTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (w(), j("div", pb, [
      H(Dr, He({
        as: e.as,
        size: "2xl"
      }, e.$attrs), {
        default: M(() => [
          R(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["as"])
    ]));
  }
}), db = {
  class: /* @__PURE__ */ Z([
    "px-4 py-5",
    "sm:p-6"
  ])
}, kM = /* @__PURE__ */ W({
  __name: "ActionPanel",
  props: {
    color: { default: "default" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["default", "bg-white"],
      ["ai", "bg-[linear-gradient(55deg,_rgba(255,255,255,0.6)_80%,_rgba(119,165,234,0.1)_90%,_rgba(214,150,229,0.3)_100%)] border border-primary-500"]
    ]);
    return (r, t) => (w(), j("div", {
      class: Z([
        "mx-auto shadow relative",
        "sm:rounded-lg",
        P(e).get(r.color)
      ])
    }, [
      A("div", db, [
        R(r.$slots, "default")
      ])
    ], 2));
  }
}), gb = {}, mb = { class: "pt-5" };
function yb(o, e) {
  return w(), j("div", mb, [
    R(o.$slots, "default")
  ]);
}
const wM = /* @__PURE__ */ le(gb, [["render", yb]]), fb = {}, hb = { class: "mt-2 max-w-xl text-sm text-default-500" };
function Fb(o, e) {
  return w(), j("div", hb, [
    A("p", null, [
      R(o.$slots, "default")
    ])
  ]);
}
const DM = /* @__PURE__ */ le(fb, [["render", Fb]]), SM = /* @__PURE__ */ W({
  __name: "ActionPanelTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "text-base font-semibold text-default-900" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
function bb(o, e, r) {
  if (!o) throw new Error("You need to provide `widgetName` in your data");
  var t = ["ais-" + o];
  return e && t.push("-" + e), r && t.push("--" + r), t.join("");
}
var be = function(o) {
  var e = o.name;
  return { props: { classNames: { type: Object, default: void 0 } }, methods: { suit: function(r, t) {
    var n = bb(e, r, t), a = this.classNames && this.classNames[n];
    return a ? [n, a].join(" ") : n;
  } } };
};
function pn(o) {
  for (var e = arguments, r = 1; r < arguments.length; r++) {
    var t = e[r] != null ? e[r] : {}, n = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    }))), n.forEach(function(a) {
      vb(o, a, t[a]);
    });
  }
  return o;
}
function vb(o, e, r) {
  return e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
var Pb = !1, Bb = !0;
function ha(o) {
  function e(r, t) {
    for (var n = [], a = arguments.length - 2; a-- > 0; ) n[a] = arguments[a + 2];
    var s = n.length > 0 ? n : void 0;
    if (typeof t == "object" && (t.attrs || t.props || t.scopedSlots || t.on)) {
      var i = Object.keys(t.on || {}), l = Object.assign({}, t, t.attrs, t.props, i.reduce(function(c, u) {
        return c["on" + u[0].toUpperCase() + u.slice(1)] = t.on[u], c;
      }, {}));
      return delete l.attrs, delete l.props, delete l.scopedSlots, i.forEach(function(c) {
        return delete l.on[c];
      }), l.on && Object.keys(l.on).length === 0 && delete l.on, Rr(r, l, t.scopedSlots ? Object.assign({ default: function() {
        return s;
      } }, t.scopedSlots) : s);
    }
    return Rr(r, t, s);
  }
  return function() {
    return o.call(this, e);
  };
}
function Jc(o) {
  var e = o.$slots || o.slots;
  return typeof e.default == "function" ? e.default() : e.default;
}
function mi(o, e) {
  return (o.$slots || o.slots || {})[e];
}
var dp = /* @__PURE__ */ new Set();
function ft(o) {
  dp.has(o) || (dp.add(o), console.warn(o));
}
var De = function(o, e) {
  var r;
  o === void 0 && (o = {});
  var t = o.connector;
  return e === void 0 && (e = {}), (r = { inject: { instantSearchInstance: { from: "$_ais_instantSearchInstance", default: function() {
    var n = this.$options._componentTag;
    throw new TypeError('It looks like you forgot to wrap your Algolia search component "<' + n + '>" inside of an "<ais-instant-search>" component.');
  } }, getParentIndex: { from: "$_ais_getParentIndex", default: function() {
    var n = this;
    return function() {
      return n.instantSearchInstance.mainIndex;
    };
  } } }, data: function() {
    return { state: null };
  }, created: function() {
    if (typeof t == "function") {
      if (this.factory = t(this.updateState, function() {
      }), this.widget = pn(this.factory(this.widgetParams), e), this.getParentIndex().addWidgets([this.widget]), this.instantSearchInstance._initialResults && !this.instantSearchInstance.started) {
        if (typeof this.instantSearchInstance.__forceRender != "function") throw new Error("You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.");
        this.instantSearchInstance.__forceRender(this.widget, this.getParentIndex());
      }
    } else t !== !0 && ft(`You are using the InstantSearch widget mixin, but didn't provide a connector.
While this is technically possible, and will give you access to the Helper,
it's not the recommended way of making custom components.

If you want to disable this message, pass { connector: true } to the mixin.

Read more on using connectors: https://alg.li/vue-custom`);
  } }).beforeUnmount = function() {
    this.widget && this.getParentIndex().removeWidgets([this.widget]);
  }, r.watch = { widgetParams: { handler: function(n) {
    this.state = null, this.getParentIndex().removeWidgets([this.widget]), this.widget = pn(this.factory(n), e), this.getParentIndex().addWidgets([this.widget]);
  }, deep: !0 } }, r.methods = { updateState: function(n, a) {
    n === void 0 && (n = {}), a || (this.state = n);
  } }, r;
}, kb = 0;
function wb(o) {
  o.dependsOn === "recommend" && (o.$$id = kb++);
}
function gp(o) {
  return o.toString().charAt(0).toUpperCase() + o.toString().slice(1);
}
function fe() {
}
var dr = function(e, r) {
  return e;
}, yi = fe, ue = fe;
process.env.NODE_ENV === "development" && (yi = function(e) {
  console.warn("[InstantSearch.js]: ".concat(e.trim()));
}, dr = function(e, r) {
  var t = !1;
  return function() {
    return t || (t = !0, process.env.NODE_ENV === "development" && yi(r)), e.apply(void 0, arguments);
  };
}, ue = function(e, r) {
  if (!e) {
    var t = ue.cache[r];
    t || (ue.cache[r] = !0, process.env.NODE_ENV === "development" && yi(r));
  }
}, ue.cache = {});
var Db = Object.keys;
function Sb(o) {
  return Ab(o) || xb(o) || Ey(o) || Eb();
}
function Eb() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xb(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function Ab(o) {
  if (Array.isArray(o)) return Jl(o);
}
function zt(o, e) {
  return Tb(o) || Ob(o, e) || Ey(o, e) || Cb();
}
function Cb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ey(o, e) {
  if (o) {
    if (typeof o == "string") return Jl(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Jl(o, e);
  }
}
function Jl(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Ob(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function Tb(o) {
  if (Array.isArray(o)) return o;
}
function jb(o) {
  switch (o) {
    case "range":
      return [];
    case "menu":
      return ["menu", "menuSelect"];
    default:
      return [o];
  }
}
var Mb = {
  query: {
    connectors: ["connectSearchBox"],
    widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"]
  },
  refinementList: {
    connectors: ["connectRefinementList"],
    widgets: ["ais.refinementList"]
  },
  menu: {
    connectors: ["connectMenu"],
    widgets: ["ais.menu"]
  },
  hierarchicalMenu: {
    connectors: ["connectHierarchicalMenu"],
    widgets: ["ais.hierarchicalMenu"]
  },
  numericMenu: {
    connectors: ["connectNumericMenu"],
    widgets: ["ais.numericMenu"]
  },
  ratingMenu: {
    connectors: ["connectRatingMenu"],
    widgets: ["ais.ratingMenu"]
  },
  range: {
    connectors: ["connectRange"],
    widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"]
  },
  toggle: {
    connectors: ["connectToggleRefinement"],
    widgets: ["ais.toggleRefinement"]
  },
  geoSearch: {
    connectors: ["connectGeoSearch"],
    widgets: ["ais.geoSearch"]
  },
  sortBy: {
    connectors: ["connectSortBy"],
    widgets: ["ais.sortBy"]
  },
  page: {
    connectors: ["connectPagination"],
    widgets: ["ais.pagination", "ais.infiniteHits"]
  },
  hitsPerPage: {
    connectors: ["connectHitsPerPage"],
    widgets: ["ais.hitsPerPage"]
  },
  configure: {
    connectors: ["connectConfigure"],
    widgets: ["ais.configure"]
  },
  places: {
    connectors: [],
    widgets: ["ais.places"]
  }
};
function xy(o) {
  var e = o.index, r = o.indexUiState, t = e.getWidgets().map(function(a) {
    return a.$$type;
  }).filter(Boolean), n = Db(r).reduce(function(a, s) {
    var i = Mb[s];
    if (!i)
      return a;
    var l = i.widgets;
    return l && !l.some(function(c) {
      return t.includes(c);
    }) && a.push([s, {
      connectors: i.connectors,
      widgets: i.widgets.map(function(c) {
        return c.split("ais.")[1];
      })
    }]), a;
  }, []);
  process.env.NODE_ENV === "development" && ue(n.length === 0, 'The UI state for the index "'.concat(e.getIndexId(), '" is not consistent with the widgets mounted.\n\nThis can happen when the UI state is specified via `initialUiState`, `routing` or `setUiState` but that the widgets responsible for this state were not added. This results in those query parameters not being sent to the API.\n\nTo fully reflect the state, some widgets need to be added to the index "').concat(e.getIndexId(), `":

`).concat(n.map(function(a) {
    var s, i = zt(a, 2), l = i[0], c = i[1].widgets;
    return "- `".concat(l, "` needs one of these widgets: ").concat((s = []).concat.apply(s, Sb(c.map(function(u) {
      return jb(u);
    }))).map(function(u) {
      return '"'.concat(u, '"');
    }).join(", "));
  }).join(`
`), `

If you do not wish to display widgets but still want to support their search parameters, you can mount "virtual widgets" that don't render anything:

\`\`\`
`).concat(n.filter(function(a) {
    var s = zt(a, 2);
    s[0];
    var i = s[1].connectors;
    return i.length > 0;
  }).map(function(a) {
    var s = zt(a, 2);
    s[0];
    var i = s[1], l = i.connectors, c = i.widgets, u = gp(c[0]), m = l[0];
    return "const virtual".concat(u, " = ").concat(m, "(() => null);");
  }).join(`
`), `

search.addWidgets([
  `).concat(n.filter(function(a) {
    var s = zt(a, 2);
    s[0];
    var i = s[1].connectors;
    return i.length > 0;
  }).map(function(a) {
    var s = zt(a, 2);
    s[0];
    var i = s[1].widgets, l = gp(i[0]);
    return "virtual".concat(l, "({ /* ... */ })");
  }).join(`,
  `), `
]);
\`\`\`

If you're using custom widgets that do set these query parameters, we recommend using connectors instead.

See https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/js/#customize-the-complete-ui-of-the-widgets`));
}
function Ay(o) {
  return Object.prototype.toString.call(o).slice(8, -1);
}
function Le(o, e) {
  if (o === void 0 || typeof o != "function")
    throw new Error("The render function is not valid (received type ".concat(Ay(o), `).

`).concat(e));
}
function mp(o) {
  var e = o.helper, r = o.attributesToClear, t = r === void 0 ? [] : r, n = e.state.setPage(0);
  return n = t.reduce(function(a, s) {
    return n.isNumericRefined(s) ? a.removeNumericRefinement(s) : n.isHierarchicalFacet(s) ? a.removeHierarchicalFacetRefinement(s) : n.isDisjunctiveFacet(s) ? a.removeDisjunctiveFacetRefinement(s) : n.isConjunctiveFacet(s) ? a.removeFacetRefinement(s) : a;
  }, n), t.indexOf("query") !== -1 && (n = n.setQuery("")), n;
}
var zb = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, Cy = /[&<>"']/g, Nb = RegExp(Cy.source);
function Ib(o) {
  return o && Nb.test(o) ? o.replace(Cy, function(e) {
    return zb[e];
  }) : o;
}
var Rb = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, Oy = /&(amp|quot|lt|gt|#39);/g, Lb = RegExp(Oy.source);
function Ty(o) {
  return o && Lb.test(o) ? o.replace(Oy, function(e) {
    return Rb[e];
  }) : o;
}
function Ql(o) {
  "@babel/helpers - typeof";
  return Ql = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ql(o);
}
function Hb(o) {
  return o === null ? o === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(o);
}
function Wb(o) {
  return Ql(o) === "object" && o !== null;
}
function jy(o) {
  if (!Wb(o) || Hb(o) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(o) === null)
    return !0;
  for (var e = o; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(o) === e;
}
function dn(o) {
  "@babel/helpers - typeof";
  return dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, dn(o);
}
function Vb(o) {
  if (o == null) throw new TypeError("Cannot destructure " + o);
}
function Kl() {
  return Kl = Object.assign ? Object.assign.bind() : function(o) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (o[t] = r[t]);
    }
    return o;
  }, Kl.apply(this, arguments);
}
function yp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function gt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yp(Object(r), !0).forEach(function(t) {
      My(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : yp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function My(o, e, r) {
  return e = Gb(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Gb(o) {
  var e = Zb(o, "string");
  return dn(e) == "symbol" ? e : String(e);
}
function Zb(o, e) {
  if (dn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (dn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Yo = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
}, oo = {
  highlightPreTag: "<mark>",
  highlightPostTag: "</mark>"
};
function zy(o) {
  return Ib(o).replace(new RegExp(Yo.highlightPreTag, "g"), oo.highlightPreTag).replace(new RegExp(Yo.highlightPostTag, "g"), oo.highlightPostTag);
}
function hs(o) {
  return jy(o) && typeof o.value != "string" ? Object.keys(o).reduce(function(e, r) {
    return gt(gt({}, e), {}, My({}, r, hs(o[r])));
  }, {}) : Array.isArray(o) ? o.map(hs) : gt(gt({}, o), {}, {
    value: zy(o.value)
  });
}
function Vs(o) {
  return o.__escaped === void 0 && (o = o.map(function(e) {
    var r = Kl({}, (Vb(e), e));
    return r._highlightResult && (r._highlightResult = hs(r._highlightResult)), r._snippetResult && (r._snippetResult = hs(r._snippetResult)), r;
  }), o.__escaped = !0), o;
}
function Xb(o) {
  return o.map(function(e) {
    return gt(gt({}, e), {}, {
      highlighted: zy(e.highlighted)
    });
  });
}
function Ny(o) {
  var e = oo.highlightPreTag, r = oo.highlightPostTag;
  return o.map(function(t) {
    return t.isHighlighted ? e + t.value + r : t.value;
  }).join("");
}
function qb() {
  var o = -1, e = -1, r = void 0;
  return function(n) {
    var a = ++o;
    return Promise.resolve(n).then(function(s) {
      return r && a < e ? r : (e = a, r = s, s);
    });
  };
}
function Ub(o, e, r) {
  return o.state.isHierarchicalFacet(e) ? o.state.isHierarchicalFacetRefined(e, r) : o.state.isConjunctiveFacet(e) ? o.state.isFacetRefined(e, r) : o.state.isDisjunctiveFacetRefined(e, r);
}
function fp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Yb(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fp(Object(r), !0).forEach(function(t) {
      Jb(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : fp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Jb(o, e, r) {
  return e = Qb(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Qb(o) {
  var e = Kb(o, "string");
  return bt(e) == "symbol" ? e : String(e);
}
function Kb(o, e) {
  if (bt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (bt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function bt(o) {
  "@babel/helpers - typeof";
  return bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bt(o);
}
function _b(o, e) {
  return r2(o) || o2(o, e) || e2(o, e) || $b();
}
function $b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e2(o, e) {
  if (o) {
    if (typeof o == "string") return hp(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return hp(o, e);
  }
}
function hp(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function o2(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function r2(o) {
  if (Array.isArray(o)) return o;
}
function Qc(o) {
  var e = o.instantSearchInstance, r = o.helper, t = o.attribute, n = o.widgetType, a = function() {
    for (var i = arguments.length, l = new Array(i), c = 0; c < i; c++)
      l[c] = arguments[c];
    var u = l[1], m = l[2], y = m === void 0 ? "Filter Applied" : m, g = l[3], p = g === void 0 ? {} : g, d = l[0].split(":"), h = _b(d, 2), f = h[0], F = h[1], b = typeof t == "string" ? t : t(u);
    if (l.length === 1 && bt(l[0]) === "object")
      e.sendEventToInsights(l[0]);
    else if (f === "click" && l.length >= 2 && l.length <= 4)
      Ub(r, b, u) || e.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: n,
        eventType: f,
        eventModifier: F,
        payload: Yb({
          eventName: y,
          index: r.getIndex(),
          filters: ["".concat(b, ":").concat(u)]
        }, p),
        attribute: b
      });
    else if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass between two and four arguments like:
  sendEvent('click', facetValue, eventName?, additionalData?);

If you want to send a custom payload, you can pass one object: sendEvent(customPayload);
`);
  };
  return a;
}
function Iy(o) {
  return btoa(encodeURIComponent(JSON.stringify(o)));
}
function Fp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function fi(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fp(Object(r), !0).forEach(function(t) {
      t2(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Fp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function t2(o, e, r) {
  return e = n2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function n2(o) {
  var e = a2(o, "string");
  return vt(e) == "symbol" ? e : String(e);
}
function a2(o, e) {
  if (vt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (vt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function s2(o, e) {
  return u2(o) || c2(o, e) || l2(o, e) || i2();
}
function i2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function l2(o, e) {
  if (o) {
    if (typeof o == "string") return bp(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bp(o, e);
  }
}
function bp(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function c2(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function u2(o) {
  if (Array.isArray(o)) return o;
}
function vt(o) {
  "@babel/helpers - typeof";
  return vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vt(o);
}
function p2(o) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, r = [], t = 0; t < Math.ceil(o.length / e); t++)
    r.push(o.slice(t * e, (t + 1) * e));
  return r;
}
function Ry(o) {
  var e = o.getIndex, r = o.widgetType, t = o.methodName, n = o.args, a = o.instantSearchInstance;
  if (n.length === 1 && vt(n[0]) === "object")
    return [n[0]];
  var s = n[0].split(":"), i = s2(s, 2), l = i[0], c = i[1], u = n[1], m = n[2], y = n[3] || {};
  if (!u) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass hit or hits as the second argument like:
  `.concat(t, `(eventType, hit);
  `));
    return [];
  }
  if ((l === "click" || l === "conversion") && !m) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass eventName as the third argument for 'click' or 'conversion' events like:
  `.concat(t, `('click', hit, 'Product Purchased');

  To learn more about event naming: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/
  `));
    return [];
  }
  var g = Array.isArray(u) ? u : [u];
  if (g.length === 0)
    return [];
  var p = g[0].__queryID, d = p2(g), h = d.map(function(F) {
    return F.map(function(b) {
      return b.objectID;
    });
  }), f = d.map(function(F) {
    return F.map(function(b) {
      return b.__position;
    });
  });
  if (l === "view")
    return a.status !== "idle" ? [] : d.map(function(F, b) {
      return {
        insightsMethod: "viewedObjectIDs",
        widgetType: r,
        eventType: l,
        payload: fi({
          eventName: m || "Hits Viewed",
          index: e(),
          objectIDs: h[b]
        }, y),
        hits: F,
        eventModifier: c
      };
    });
  if (l === "click")
    return d.map(function(F, b) {
      return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: fi({
          eventName: m || "Hit Clicked",
          index: e(),
          queryID: p,
          objectIDs: h[b],
          positions: f[b]
        }, y),
        hits: F,
        eventModifier: c
      };
    });
  if (l === "conversion")
    return d.map(function(F, b) {
      return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: fi({
          eventName: m || "Hit Converted",
          index: e(),
          queryID: p,
          objectIDs: h[b]
        }, y),
        hits: F,
        eventModifier: c
      };
    });
  if (process.env.NODE_ENV === "development")
    throw new Error('eventType("'.concat(l, `") is not supported.
    If you want to send a custom payload, you can pass one object: `).concat(t, `(customPayload);
    `));
  return [];
}
function Kc(o) {
  var e = o.instantSearchInstance, r = o.getIndex, t = o.widgetType, n = {}, a = void 0, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    var m = Ry({
      widgetType: t,
      getIndex: r,
      methodName: "sendEvent",
      args: c,
      instantSearchInstance: e
    });
    m.forEach(function(y) {
      y.eventType === "click" && y.eventModifier === "internal" && n[y.eventType] || (n[y.eventType] = !0, e.sendEventToInsights(y));
    }), clearTimeout(a), a = setTimeout(function() {
      n = {};
    }, 0);
  };
  return s;
}
function Ly(o) {
  var e = o.getIndex, r = o.widgetType, t = o.instantSearchInstance, n = function() {
    for (var s = arguments.length, i = new Array(s), l = 0; l < s; l++)
      i[l] = arguments[l];
    var c = Ry({
      widgetType: r,
      getIndex: e,
      methodName: "bindEvent",
      args: i,
      instantSearchInstance: t
    });
    return c.length ? "data-insights-event=".concat(Iy(c)) : "";
  };
  return n;
}
function go(o) {
  return o.$$type === "ais.index";
}
function _l(o, e) {
  var r = o[e.getIndexId()] || {};
  process.env.NODE_ENV === "development" && xy({
    index: e,
    indexUiState: r
  }), e.getHelper().setState(e.getWidgetSearchParameters(e.getHelper().state, {
    uiState: r
  })), e.getWidgets().filter(go).forEach(function(t) {
    return _l(o, t);
  });
}
function vp(o, e) {
  var r = null;
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return new Promise(function(s, i) {
      r && clearTimeout(r), r = setTimeout(function() {
        r = null, Promise.resolve(o.apply(void 0, n)).then(s).catch(i);
      }, e);
    });
  };
}
var d2 = Promise.resolve();
function Nt(o) {
  var e = null, r = !1, t = function() {
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    e === null && (e = d2.then(function() {
      if (e = null, r) {
        r = !1;
        return;
      }
      o.apply(void 0, s);
    }));
  };
  return t.wait = function() {
    if (e === null)
      throw new Error("The deferred function should be called before calling `wait()`");
    return e;
  }, t.cancel = function() {
    e !== null && (r = !0);
  }, t;
}
function gn(o) {
  var e = o.name, r = o.connector, t = r === void 0 ? !1 : r;
  return ["https://www.algolia.com/doc/api-reference/widgets/", e, "/js/", t ? "#connector" : ""].join("");
}
function xe() {
  for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
    e[r] = arguments[r];
  var t = e.map(function(n) {
    return gn(n);
  }).join(", ");
  return function(n) {
    return [n, "See documentation: ".concat(t)].filter(Boolean).join(`

`);
  };
}
function g2(o) {
  return typeof o == "string" ? o.replace(/^\\-/, "-") : o;
}
function Vt(o) {
  return typeof o == "number" && o < 0 || typeof o == "string" ? String(o).replace(/^-/, "\\-") : o;
}
function ir(o, e) {
  for (var r, t = 0; t < o.length; t++)
    if (r = o[t], e(r, t, o))
      return r;
}
function m2(o, e) {
  if (!Array.isArray(o))
    return -1;
  for (var r = 0; r < o.length; r++)
    if (e(o[r]))
      return r;
  return -1;
}
function y2(o) {
  if (o.appId && o.apiKey)
    return [o.appId, o.apiKey];
  if (o.transporter) {
    var e = o.transporter, r = e.headers || e.baseHeaders, t = e.queryParameters || e.baseQueryParameters, n = "x-algolia-application-id", a = "x-algolia-api-key", s = r[n] || t[n], i = r[a] || t[a];
    return [s, i];
  } else
    return [o.applicationID, o.apiKey];
}
function _c(o) {
  var e = oo.highlightPostTag, r = oo.highlightPreTag, t = o.split(r), n = t.shift(), a = n ? [{
    value: n,
    isHighlighted: !1
  }] : [];
  return t.forEach(function(s) {
    var i = s.split(e);
    a.push({
      value: i[0],
      isHighlighted: !0
    }), i[1] !== "" && a.push({
      value: i[1],
      isHighlighted: !1
    });
  }), a;
}
var f2 = new RegExp(/\w/i);
function h2(o, e) {
  var r, t, n = o[e], a = ((r = o[e + 1]) === null || r === void 0 ? void 0 : r.isHighlighted) || !0, s = ((t = o[e - 1]) === null || t === void 0 ? void 0 : t.isHighlighted) || !0;
  return !f2.test(Ty(n.value)) && s === a ? s : n.isHighlighted;
}
function At(o, e) {
  var r = Array.isArray(e) ? e : e.split(".");
  return r.reduce(function(t, n) {
    return t && t[n];
  }, o);
}
function hi(o, e, r, t) {
  var n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
    type: e,
    attribute: r,
    name: t,
    escapedValue: Vt(t)
  }, s = ir(n, function(g) {
    return g.name === r;
  }), i;
  if (e === "hierarchical") {
    for (var l = o.getHierarchicalFacetByName(r), c = t.split(l.separator), u = function(p) {
      return function(d) {
        return p[d];
      };
    }, m = function(p) {
      s = s && s.data && ir(Object.keys(s.data).map(u(s.data)), function(d) {
        return d.name === c[p];
      });
    }, y = 0; s !== void 0 && y < c.length; ++y)
      m(y);
    i = s && s.count;
  } else
    i = s && s.data && s.data[a.name];
  return i !== void 0 && (a.count = i), s && s.exhaustive !== void 0 && (a.exhaustive = s.exhaustive), a;
}
function $c(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, t = o || {}, n = [], a = e.facetsRefinements, s = a === void 0 ? {} : a, i = e.facetsExcludes, l = i === void 0 ? {} : i, c = e.disjunctiveFacetsRefinements, u = c === void 0 ? {} : c, m = e.hierarchicalFacetsRefinements, y = m === void 0 ? {} : m, g = e.numericRefinements, p = g === void 0 ? {} : g, d = e.tagRefinements, h = d === void 0 ? [] : d;
  return Object.keys(s).forEach(function(f) {
    var F = s[f];
    F.forEach(function(b) {
      n.push(hi(e, "facet", f, b, t.facets));
    });
  }), Object.keys(l).forEach(function(f) {
    var F = l[f];
    F.forEach(function(b) {
      n.push({
        type: "exclude",
        attribute: f,
        name: b,
        exclude: !0
      });
    });
  }), Object.keys(u).forEach(function(f) {
    var F = u[f];
    F.forEach(function(b) {
      n.push(hi(
        e,
        "disjunctive",
        f,
        // We unescape any disjunctive refined values with `unescapeFacetValue` because
        // they can be escaped on negative numeric values with `escapeFacetValue`.
        g2(b),
        t.disjunctiveFacets
      ));
    });
  }), Object.keys(y).forEach(function(f) {
    var F = y[f];
    F.forEach(function(b) {
      n.push(hi(e, "hierarchical", f, b, t.hierarchicalFacets));
    });
  }), Object.keys(p).forEach(function(f) {
    var F = p[f];
    Object.keys(F).forEach(function(b) {
      var v = b, k = F[v], E = Array.isArray(k) ? k : [k];
      E.forEach(function(S) {
        n.push({
          type: "numeric",
          attribute: f,
          name: "".concat(S),
          numericValue: S,
          operator: v
        });
      });
    });
  }), h.forEach(function(f) {
    n.push({
      type: "tag",
      attribute: "_tags",
      name: f
    });
  }), r && e.query && e.query.trim() && n.push({
    attribute: "query",
    type: "query",
    name: e.query,
    query: e.query
  }), n;
}
function F2(o, e) {
  var r, t = (r = o.getWidgetRenderState) === null || r === void 0 ? void 0 : r.call(o, e), n = null;
  if (t && t.widgetParams) {
    var a = t.widgetParams;
    a.attribute ? n = a.attribute : Array.isArray(a.attributes) && (n = a.attributes[0]);
  }
  if (typeof n != "string")
    throw new Error(`Could not find the attribute of the widget:

`.concat(JSON.stringify(o), `

Please check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly.`));
  return n;
}
function mn(o) {
  "@babel/helpers - typeof";
  return mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mn(o);
}
function Pp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Bp(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pp(Object(r), !0).forEach(function(t) {
      b2(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Pp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function b2(o, e, r) {
  return e = v2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function v2(o) {
  var e = P2(o, "string");
  return mn(e) == "symbol" ? e : String(e);
}
function P2(o, e) {
  if (mn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (mn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function eu(o, e, r) {
  return o.map(function(t, n) {
    return Bp(Bp({}, t), {}, {
      __position: r * e + n + 1
    });
  });
}
function yn(o) {
  "@babel/helpers - typeof";
  return yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, yn(o);
}
function kp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function wp(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kp(Object(r), !0).forEach(function(t) {
      B2(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : kp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function B2(o, e, r) {
  return e = k2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function k2(o) {
  var e = w2(o, "string");
  return yn(e) == "symbol" ? e : String(e);
}
function w2(o, e) {
  if (yn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (yn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function ou(o, e) {
  return e ? o.map(function(r) {
    return wp(wp({}, r), {}, {
      __queryID: e
    });
  }) : o;
}
function fn(o) {
  "@babel/helpers - typeof";
  return fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fn(o);
}
function Dp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Sp(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Dp(Object(r), !0).forEach(function(t) {
      D2(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Dp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function D2(o, e, r) {
  return e = S2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function S2(o) {
  var e = E2(o, "string");
  return fn(e) == "symbol" ? e : String(e);
}
function E2(o, e) {
  if (fn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (fn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function x2(o, e) {
  var r = Object.keys(e).reduce(function(t, n) {
    var a = e[n];
    return a.recommendResults ? Sp(Sp({}, t), a.recommendResults.results) : t;
  }, {});
  o._recommendCache = r;
}
function hn(o) {
  "@babel/helpers - typeof";
  return hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hn(o);
}
function A2(o, e) {
  return j2(o) || T2(o, e) || O2(o, e) || C2();
}
function C2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O2(o, e) {
  if (o) {
    if (typeof o == "string") return Ep(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ep(o, e);
  }
}
function Ep(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function T2(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function j2(o) {
  if (Array.isArray(o)) return o;
}
function xp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function It(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xp(Object(r), !0).forEach(function(t) {
      Hy(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : xp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Hy(o, e, r) {
  return e = M2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function M2(o) {
  var e = z2(o, "string");
  return hn(e) == "symbol" ? e : String(e);
}
function z2(o, e) {
  if (hn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (hn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function N2(o, e) {
  if (e && !((!("transporter" in o) || o._cacheHydrated) && (!o._useCache || typeof o.addAlgoliaAgent != "function"))) {
    var r = [Object.keys(e).reduce(function(s, i) {
      var l = e[i], c = l.state, u = l.requestParams, m = l.results, y = m && c ? m.map(function(g, p) {
        return It({
          indexName: c.index || g.index
        }, u != null && u[p] || g.params ? {
          params: Fi((u == null ? void 0 : u[p]) || I2(g.params))
        } : {});
      }) : [];
      return s.concat(y);
    }, [])], t = Object.keys(e).reduce(function(s, i) {
      var l = e[i].results;
      return l ? s.concat(l) : s;
    }, []);
    if ("transporter" in o && !o._cacheHydrated) {
      o._cacheHydrated = !0;
      var n = o.search.bind(o);
      o.search = function(s) {
        for (var i = arguments.length, l = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
          l[c - 1] = arguments[c];
        var u = Array.isArray(s) ? (
          // search client
          s.map(function(m) {
            return It(It({}, m), {}, {
              params: Fi(m.params)
            });
          })
        ) : (
          // composition client
          Fi(s.requestBody.params)
        );
        return o.transporter.responsesCache.get({
          method: "search",
          args: [u].concat(l)
        }, function() {
          return n.apply(void 0, [s].concat(l));
        });
      }, o.transporter.responsesCache.set({
        method: "search",
        args: r
      }, {
        results: t
      });
    }
    if (!("transporter" in o)) {
      var a = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: r
      }));
      o.cache = It(It({}, o.cache), {}, Hy({}, a, JSON.stringify({
        results: Object.keys(e).map(function(s) {
          return e[s].results;
        })
      })));
    }
  }
}
function I2(o) {
  return o.split("&").reduce(function(e, r) {
    var t = r.split("="), n = A2(t, 2), a = n[0], s = n[1];
    return e[a] = s ? decodeURIComponent(s) : "", e;
  }, {});
}
function Fi(o) {
  var e = function(n) {
    return Object.prototype.toString.call(n) === "[object Object]" || Object.prototype.toString.call(n) === "[object Array]";
  }, r = function(n) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      s[i - 1] = arguments[i];
    var l = 0;
    return n.replace(/%s/g, function() {
      return encodeURIComponent(s[l++]);
    });
  };
  return Object.keys(o).map(function(t) {
    return r("%s=%s", t, e(o[t]) ? JSON.stringify(o[t]) : o[t]);
  }).join("&");
}
function Ap(o) {
  return o !== Object(o);
}
function Ur(o, e) {
  if (o === e)
    return !0;
  if (Ap(o) || Ap(e) || typeof o == "function" || typeof e == "function")
    return o === e;
  if (Object.keys(o).length !== Object.keys(e).length)
    return !1;
  for (var r = 0, t = Object.keys(o); r < t.length; r++) {
    var n = t[r];
    if (!(n in e) || !Ur(o[n], e[n]))
      return !1;
  }
  return !0;
}
function ke(o) {
  return typeof o == "number" && isFinite(o);
}
function Wy(o, e) {
  e(o), o.getWidgets().forEach(function(r) {
    go(r) && Wy(r, e);
  });
}
function ru(o) {
  return o.filter(function(e, r, t) {
    return t.indexOf(e) === r;
  });
}
function Fn(o) {
  "@babel/helpers - typeof";
  return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Fn(o);
}
var R2 = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"];
function Cp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Jo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cp(Object(r), !0).forEach(function(t) {
      L2(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Cp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function L2(o, e, r) {
  return e = H2(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function H2(o) {
  var e = W2(o, "string");
  return Fn(e) == "symbol" ? e : String(e);
}
function W2(o, e) {
  if (Fn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Fn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function V2(o, e) {
  if (o == null) return {};
  var r = G2(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function G2(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var Z2 = function(e, r) {
  r.facets, r.disjunctiveFacets, r.facetsRefinements, r.facetsExcludes, r.disjunctiveFacetsRefinements, r.numericRefinements, r.tagRefinements, r.hierarchicalFacets, r.hierarchicalFacetsRefinements, r.ruleContexts;
  var t = V2(r, R2);
  return e.setQueryParameters(t);
}, X2 = function(e, r) {
  return r.facets.reduce(function(t, n) {
    return t.addFacet(n);
  }, e);
}, q2 = function(e, r) {
  return r.disjunctiveFacets.reduce(function(t, n) {
    return t.addDisjunctiveFacet(n);
  }, e);
}, U2 = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacets: r.hierarchicalFacets.reduce(function(t, n) {
      var a = m2(t, function(i) {
        return i.name === n.name;
      });
      if (a === -1)
        return t.concat(n);
      var s = t.slice();
      return s.splice(a, 1, n), s;
    }, e.hierarchicalFacets)
  });
}, Y2 = function(e, r) {
  return r.tagRefinements.reduce(function(t, n) {
    return t.addTagRefinement(n);
  }, e);
}, J2 = function(e, r) {
  return e.setQueryParameters({
    facetsRefinements: Jo(Jo({}, e.facetsRefinements), r.facetsRefinements)
  });
}, Q2 = function(e, r) {
  return e.setQueryParameters({
    facetsExcludes: Jo(Jo({}, e.facetsExcludes), r.facetsExcludes)
  });
}, K2 = function(e, r) {
  return e.setQueryParameters({
    disjunctiveFacetsRefinements: Jo(Jo({}, e.disjunctiveFacetsRefinements), r.disjunctiveFacetsRefinements)
  });
}, _2 = function(e, r) {
  return e.setQueryParameters({
    numericRefinements: Jo(Jo({}, e.numericRefinements), r.numericRefinements)
  });
}, $2 = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacetsRefinements: Jo(Jo({}, e.hierarchicalFacetsRefinements), r.hierarchicalFacetsRefinements)
  });
}, ev = function(e, r) {
  var t = ru([].concat(e.ruleContexts).concat(r.ruleContexts).filter(Boolean));
  return t.length > 0 ? e.setQueryParameters({
    ruleContexts: t
  }) : e;
}, $t = function() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return r.reduce(function(n, a) {
    var s = $2(n, a), i = U2(s, a), l = Y2(i, a), c = _2(l, a), u = K2(c, a), m = Q2(u, a), y = J2(m, a), g = q2(y, a), p = ev(g, a), d = X2(p, a);
    return Z2(d, a);
  });
};
function ov(o) {
  return av(o) || nv(o) || tv(o) || rv();
}
function rv() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tv(o, e) {
  if (o) {
    if (typeof o == "string") return $l(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $l(o, e);
  }
}
function nv(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function av(o) {
  if (Array.isArray(o)) return $l(o);
}
function $l(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Op(o) {
  var e = o.start, r = e === void 0 ? 0 : e, t = o.end, n = o.step, a = n === void 0 ? 1 : n, s = a === 0 ? 1 : a, i = Math.round((t - r) / s);
  return ov(Array(i)).map(function(l, c) {
    return r + c * s;
  });
}
function Gt(o, e, r) {
  var t = e.getHelper();
  return {
    uiState: r,
    helper: t,
    parent: e,
    instantSearchInstance: o,
    state: t.state,
    renderState: o.renderState,
    templatesConfig: o.templatesConfig,
    createURL: e.createURL,
    scopedResults: [],
    searchMetadata: {
      isSearchStalled: o.status === "stalled"
    },
    status: o.status,
    error: o.error
  };
}
function Tp(o, e, r) {
  var t = e.getResultsForWidget(r), n = e.getHelper();
  return {
    helper: n,
    parent: e,
    instantSearchInstance: o,
    results: t,
    scopedResults: e.getScopedResults(),
    state: t && "_state" in t ? t._state : n.state,
    renderState: o.renderState,
    templatesConfig: o.templatesConfig,
    createURL: e.createURL,
    searchMetadata: {
      isSearchStalled: o.status === "stalled"
    },
    status: o.status,
    error: o.error
  };
}
function sv(o) {
  for (var e = o.getParent(), r = [o.getHelper().state]; e !== null; )
    r = [e.getHelper().state].concat(r), e = e.getParent();
  return r;
}
function bn(o) {
  "@babel/helpers - typeof";
  return bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bn(o);
}
function jp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ja(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jp(Object(r), !0).forEach(function(t) {
      iv(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : jp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function iv(o, e, r) {
  return e = lv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function lv(o) {
  var e = cv(o, "string");
  return bn(e) == "symbol" ? e : String(e);
}
function cv(o, e) {
  if (bn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (bn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Vy(o) {
  return o.some(function(e) {
    return e.isHighlighted;
  }) ? o.map(function(e, r) {
    return ja(ja({}, e), {}, {
      isHighlighted: !h2(o, r)
    });
  }) : o.map(function(e) {
    return ja(ja({}, e), {}, {
      isHighlighted: !1
    });
  });
}
function Go(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    fallback: function() {
    }
  }, r = e.fallback;
  return typeof window > "u" ? r() : o({
    window
  });
}
function bi(o) {
  return Array.isArray(o) ? o : [o];
}
function vn(o) {
  "@babel/helpers - typeof";
  return vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vn(o);
}
function Mp(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function wo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mp(Object(r), !0).forEach(function(t) {
      uv(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Mp(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function uv(o, e, r) {
  return e = pv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function pv(o) {
  var e = dv(o, "string");
  return vn(e) == "symbol" ? e : String(e);
}
function dv(o, e) {
  if (vn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (vn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function gv(o) {
  return typeof o.findAnswers == "function";
}
var Ma = xe({
  name: "answers",
  connector: !0
}), mv = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Ma()), function(t) {
    var n = t || {}, a = n.queryLanguages, s = n.attributesForPrediction, i = n.nbHits, l = i === void 0 ? 1 : i, c = n.renderDebounceTime, u = c === void 0 ? 100 : c, m = n.searchDebounceTime, y = m === void 0 ? 100 : m, g = n.escapeHTML, p = g === void 0 ? !0 : g, d = n.extraParameters, h = d === void 0 ? {} : d;
    if (!a || a.length === 0)
      throw new Error(Ma("The `queryLanguages` expects an array of strings."));
    var f = qb(), F = [], b = !1, v = vp(e, u), k;
    return {
      $$type: "ais.answers",
      init: function(S) {
        var B = S.state, D = S.instantSearchInstance;
        if (typeof D.client.initIndex != "function")
          throw new Error(Ma("`algoliasearch` <5 required."));
        var x = D.client.initIndex(B.index);
        if (!gv(x))
          throw new Error(Ma("`algoliasearch` >= 4.8.0 required."));
        k = vp(x.findAnswers, y), e(wo(wo({}, this.getWidgetRenderState(S)), {}, {
          instantSearchInstance: S.instantSearchInstance
        }), !0);
      },
      render: function(S) {
        var B = this, D = S.state.query;
        if (!D) {
          F = [], b = !1, e(wo(wo({}, this.getWidgetRenderState(S)), {}, {
            instantSearchInstance: S.instantSearchInstance
          }), !1);
          return;
        }
        F = [], b = !0, e(wo(wo({}, this.getWidgetRenderState(S)), {}, {
          instantSearchInstance: S.instantSearchInstance
        }), !1), f(k(D, a, wo(wo({}, h), {}, {
          nbHits: l,
          attributesForPrediction: s
        }))).then(function(x) {
          if (x) {
            p && x.hits.length > 0 && (x.hits = Vs(x.hits));
            var C = eu(x.hits, 0, l), O = ou(C, x.queryID);
            F = O, b = !1, v(wo(wo({}, B.getWidgetRenderState(S)), {}, {
              instantSearchInstance: S.instantSearchInstance
            }), !1);
          }
        });
      },
      getRenderState: function(S, B) {
        return wo(wo({}, S), {}, {
          answers: this.getWidgetRenderState(B)
        });
      },
      getWidgetRenderState: function() {
        return {
          hits: F,
          isLoading: b,
          widgetParams: t
        };
      },
      dispose: function(S) {
        var B = S.state;
        return r(), B;
      },
      getWidgetSearchParameters: function(S) {
        return S;
      }
    };
  };
};
function Ct(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var vi, zp;
function tu() {
  if (zp) return vi;
  zp = 1;
  function o() {
    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
  }
  vi = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0, o.defaultMaxListeners = 10, o.prototype.setMaxListeners = function(a) {
    if (!r(a) || a < 0 || isNaN(a))
      throw TypeError("n must be a positive number");
    return this._maxListeners = a, this;
  }, o.prototype.emit = function(a) {
    var s, i, l, c, u, m;
    if (this._events || (this._events = {}), a === "error" && (!this._events.error || t(this._events.error) && !this._events.error.length)) {
      if (s = arguments[1], s instanceof Error)
        throw s;
      var y = new Error('Uncaught, unspecified "error" event. (' + s + ")");
      throw y.context = s, y;
    }
    if (i = this._events[a], n(i))
      return !1;
    if (e(i))
      switch (arguments.length) {
        // fast cases
        case 1:
          i.call(this);
          break;
        case 2:
          i.call(this, arguments[1]);
          break;
        case 3:
          i.call(this, arguments[1], arguments[2]);
          break;
        // slower
        default:
          c = Array.prototype.slice.call(arguments, 1), i.apply(this, c);
      }
    else if (t(i))
      for (c = Array.prototype.slice.call(arguments, 1), m = i.slice(), l = m.length, u = 0; u < l; u++)
        m[u].apply(this, c);
    return !0;
  }, o.prototype.addListener = function(a, s) {
    var i;
    if (!e(s))
      throw TypeError("listener must be a function");
    return this._events || (this._events = {}), this._events.newListener && this.emit(
      "newListener",
      a,
      e(s.listener) ? s.listener : s
    ), this._events[a] ? t(this._events[a]) ? this._events[a].push(s) : this._events[a] = [this._events[a], s] : this._events[a] = s, t(this._events[a]) && !this._events[a].warned && (n(this._maxListeners) ? i = o.defaultMaxListeners : i = this._maxListeners, i && i > 0 && this._events[a].length > i && (this._events[a].warned = !0, console.error(
      "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
      this._events[a].length
    ), typeof console.trace == "function" && console.trace())), this;
  }, o.prototype.on = o.prototype.addListener, o.prototype.once = function(a, s) {
    if (!e(s))
      throw TypeError("listener must be a function");
    var i = !1;
    function l() {
      this.removeListener(a, l), i || (i = !0, s.apply(this, arguments));
    }
    return l.listener = s, this.on(a, l), this;
  }, o.prototype.removeListener = function(a, s) {
    var i, l, c, u;
    if (!e(s))
      throw TypeError("listener must be a function");
    if (!this._events || !this._events[a])
      return this;
    if (i = this._events[a], c = i.length, l = -1, i === s || e(i.listener) && i.listener === s)
      delete this._events[a], this._events.removeListener && this.emit("removeListener", a, s);
    else if (t(i)) {
      for (u = c; u-- > 0; )
        if (i[u] === s || i[u].listener && i[u].listener === s) {
          l = u;
          break;
        }
      if (l < 0)
        return this;
      i.length === 1 ? (i.length = 0, delete this._events[a]) : i.splice(l, 1), this._events.removeListener && this.emit("removeListener", a, s);
    }
    return this;
  }, o.prototype.removeAllListeners = function(a) {
    var s, i;
    if (!this._events)
      return this;
    if (!this._events.removeListener)
      return arguments.length === 0 ? this._events = {} : this._events[a] && delete this._events[a], this;
    if (arguments.length === 0) {
      for (s in this._events)
        s !== "removeListener" && this.removeAllListeners(s);
      return this.removeAllListeners("removeListener"), this._events = {}, this;
    }
    if (i = this._events[a], e(i))
      this.removeListener(a, i);
    else if (i)
      for (; i.length; )
        this.removeListener(a, i[i.length - 1]);
    return delete this._events[a], this;
  }, o.prototype.listeners = function(a) {
    var s;
    return !this._events || !this._events[a] ? s = [] : e(this._events[a]) ? s = [this._events[a]] : s = this._events[a].slice(), s;
  }, o.prototype.listenerCount = function(a) {
    if (this._events) {
      var s = this._events[a];
      if (e(s))
        return 1;
      if (s)
        return s.length;
    }
    return 0;
  }, o.listenerCount = function(a, s) {
    return a.listenerCount(s);
  };
  function e(a) {
    return typeof a == "function";
  }
  function r(a) {
    return typeof a == "number";
  }
  function t(a) {
    return typeof a == "object" && a !== null;
  }
  function n(a) {
    return a === void 0;
  }
  return vi;
}
var Pi, Np;
function Gy() {
  if (Np) return Pi;
  Np = 1;
  function o(e, r) {
    e.prototype = Object.create(r.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  }
  return Pi = o, Pi;
}
var Bi, Ip;
function yv() {
  if (Ip) return Bi;
  Ip = 1;
  var o = tu(), e = Gy();
  function r(t, n, a) {
    this.main = t, this.fn = n, this.recommendFn = a, this.lastResults = null, this.lastRecommendResults = null;
  }
  return e(r, o), r.prototype.detach = function() {
    this.removeAllListeners(), this.main.detachDerivedHelper(this);
  }, r.prototype.getModifiedState = function(t) {
    return this.fn(t);
  }, r.prototype.getModifiedRecommendState = function(t) {
    return this.recommendFn(t);
  }, Bi = r, Bi;
}
var ki, Rp;
function nu() {
  if (Rp) return ki;
  Rp = 1;
  function o(r) {
    return typeof r != "string" ? r : String(r).replace(/^-/, "\\-");
  }
  function e(r) {
    return typeof r != "string" ? r : r.replace(/^\\-/, "-");
  }
  return ki = {
    escapeFacetValue: o,
    unescapeFacetValue: e
  }, ki;
}
var wi, Lp;
function au() {
  if (Lp) return wi;
  Lp = 1;
  function o(n) {
    return typeof n == "object" && n !== null ? r(Array.isArray(n) ? [] : {}, n) : n;
  }
  function e(n) {
    return typeof n == "function" || Array.isArray(n) || Object.prototype.toString.call(n) === "[object Object]";
  }
  function r(n, a) {
    if (n === a)
      return n;
    for (var s in a)
      if (!(!Object.prototype.hasOwnProperty.call(a, s) || s === "__proto__" || s === "constructor")) {
        var i = a[s], l = n[s];
        typeof l < "u" && typeof i > "u" || (e(l) && e(i) ? n[s] = r(l, i) : n[s] = o(i));
      }
    return n;
  }
  function t(n) {
    e(n) || (n = {});
    for (var a = 1, s = arguments.length; a < s; a++) {
      var i = arguments[a];
      e(i) && r(n, i);
    }
    return n;
  }
  return wi = t, wi;
}
var Di, Hp;
function su() {
  if (Hp) return Di;
  Hp = 1;
  function o(e) {
    return e && Object.keys(e).length > 0;
  }
  return Di = o, Di;
}
var Si, Wp;
function iu() {
  if (Wp) return Si;
  Wp = 1;
  function o(e, r) {
    if (e === null) return {};
    var t = {}, n = Object.keys(e), a, s;
    for (s = 0; s < n.length; s++)
      a = n[s], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
    return t;
  }
  return Si = o, Si;
}
var Ei, Vp;
function Zy() {
  if (Vp) return Ei;
  Vp = 1;
  function o(e) {
    e = e || {}, this.params = e.params || [];
  }
  return o.prototype = {
    constructor: o,
    addParams: function(e) {
      var r = this.params.slice();
      return r.push(e), new o({ params: r });
    },
    removeParams: function(e) {
      return new o({
        params: this.params.filter(function(r) {
          return r.$$id !== e;
        })
      });
    },
    addFrequentlyBoughtTogether: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "bought-together" })
      );
    },
    addRelatedProducts: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "related-products" })
      );
    },
    addTrendingItems: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "trending-items" })
      );
    },
    addTrendingFacets: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "trending-facets" })
      );
    },
    addLookingSimilar: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "looking-similar" })
      );
    },
    _buildQueries: function(e, r) {
      return this.params.filter(function(t) {
        return r[t.$$id] === void 0;
      }).map(function(t) {
        var n = Object.assign({}, t, {
          indexName: e,
          // @TODO: remove this if it ever gets handled by the API
          threshold: t.threshold || 0
        });
        return delete n.$$id, n;
      });
    }
  }, Ei = o, Ei;
}
var xi, Gp;
function Xy() {
  if (Gp) return xi;
  Gp = 1;
  function o(e, r) {
    this._state = e, this._rawResults = {};
    var t = this;
    e.params.forEach(function(n) {
      var a = n.$$id;
      t[a] = r[a], t._rawResults[a] = r[a];
    });
  }
  return o.prototype = {
    constructor: o
  }, xi = o, xi;
}
var Ai, Zp;
function fv() {
  if (Zp) return Ai;
  Zp = 1;
  var o = au();
  function e(t) {
    return Object.keys(t).sort().reduce(function(n, a) {
      return n[a] = t[a], n;
    }, {});
  }
  var r = {
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {string} index The name of the index
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getQueries: function(n, a) {
      var s = [];
      return s.push({
        indexName: n,
        params: r._getHitsSearchParams(a)
      }), a.getRefinedDisjunctiveFacets().forEach(function(i) {
        s.push({
          indexName: n,
          params: r._getDisjunctiveFacetSearchParams(
            a,
            i
          )
        });
      }), a.getRefinedHierarchicalFacets().forEach(function(i) {
        var l = a.getHierarchicalFacetByName(i), c = a.getHierarchicalRefinement(i), u = a._getHierarchicalFacetSeparator(l);
        if (c.length > 0 && c[0].split(u).length > 1) {
          var m = c[0].split(u).slice(0, -1).reduce(function(g, p, d) {
            return g.concat({
              attribute: l.attributes[d],
              value: d === 0 ? p : [g[g.length - 1].value, p].join(u)
            });
          }, []);
          m.forEach(function(y, g) {
            var p = r._getDisjunctiveFacetSearchParams(
              a,
              y.attribute,
              g === 0
            );
            function d(F) {
              return l.attributes.some(function(b) {
                return b === F.split(":")[0];
              });
            }
            var h = (p.facetFilters || []).reduce(
              function(F, b) {
                if (Array.isArray(b)) {
                  var v = b.filter(function(k) {
                    return !d(k);
                  });
                  v.length > 0 && F.push(v);
                }
                return typeof b == "string" && !d(b) && F.push(b), F;
              },
              []
            ), f = m[g - 1];
            g > 0 ? p.facetFilters = h.concat(
              f.attribute + ":" + f.value
            ) : h.length > 0 ? p.facetFilters = h : delete p.facetFilters, s.push({ indexName: n, params: p });
          });
        }
      }), s;
    },
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getCompositionQueries: function(n) {
      return [
        {
          compositionID: n.index,
          requestBody: {
            params: r._getCompositionHitsSearchParams(n)
          }
        }
      ];
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getHitsSearchParams: function(t) {
      var n = t.facets.concat(t.disjunctiveFacets).concat(r._getHitsHierarchicalFacetsAttributes(t)).sort(), a = r._getFacetFilters(t), s = r._getNumericFilters(t), i = r._getTagFilters(t), l = {};
      return n.length > 0 && (l.facets = n.indexOf("*") > -1 ? ["*"] : n), i.length > 0 && (l.tagFilters = i), a.length > 0 && (l.facetFilters = a), s.length > 0 && (l.numericFilters = s), e(o({}, t.getQueryParams(), l));
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getCompositionHitsSearchParams: function(t) {
      var n = t.facets.concat(
        t.disjunctiveFacets.map(function(u) {
          return "disjunctive(" + u + ")";
        })
      ).concat(r._getHitsHierarchicalFacetsAttributes(t)).sort(), a = r._getFacetFilters(t), s = r._getNumericFilters(t), i = r._getTagFilters(t), l = {};
      n.length > 0 && (l.facets = n.indexOf("*") > -1 ? ["*"] : n), i.length > 0 && (l.tagFilters = i), a.length > 0 && (l.facetFilters = a), s.length > 0 && (l.numericFilters = s);
      var c = t.getQueryParams();
      return delete c.highlightPreTag, delete c.highlightPostTag, delete c.index, e(o({}, c, l));
    },
    /**
     * Build search parameters used to fetch a disjunctive facet
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} facet the associated facet name
     * @param  {boolean} hierarchicalRootLevel ?? FIXME
     * @return {object} The search parameters for a disjunctive facet
     */
    _getDisjunctiveFacetSearchParams: function(t, n, a) {
      var s = r._getFacetFilters(
        t,
        n,
        a
      ), i = r._getNumericFilters(t, n), l = r._getTagFilters(t), c = {
        hitsPerPage: 0,
        page: 0,
        analytics: !1,
        clickAnalytics: !1
      };
      l.length > 0 && (c.tagFilters = l);
      var u = t.getHierarchicalFacetByName(n);
      return u ? c.facets = r._getDisjunctiveHierarchicalFacetAttribute(
        t,
        u,
        a
      ) : c.facets = n, i.length > 0 && (c.numericFilters = i), s.length > 0 && (c.facetFilters = s), e(o({}, t.getQueryParams(), c));
    },
    /**
     * Return the numeric filters in an algolia request fashion
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @param {string} [facetName] the name of the attribute for which the filters should be excluded
     * @return {string[]} the numeric filters in the algolia format
     */
    _getNumericFilters: function(t, n) {
      if (t.numericFilters)
        return t.numericFilters;
      var a = [];
      return Object.keys(t.numericRefinements).forEach(function(s) {
        var i = t.numericRefinements[s] || {};
        Object.keys(i).forEach(function(l) {
          var c = i[l] || [];
          n !== s && c.forEach(function(u) {
            if (Array.isArray(u)) {
              var m = u.map(function(y) {
                return s + l + y;
              });
              a.push(m);
            } else
              a.push(s + l + u);
          });
        });
      }), a;
    },
    /**
     * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @return {string} Tag filters in a single string
     */
    _getTagFilters: function(t) {
      return t.tagFilters ? t.tagFilters : t.tagRefinements.join(",");
    },
    /**
     * Build facetFilters parameter based on current refinements. The array returned
     * contains strings representing the facet filters in the algolia format.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} [facet] if set, the current disjunctive facet
     * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
     * @return {array.<string>} The facet filters in the algolia format
     */
    _getFacetFilters: function(t, n, a) {
      var s = [], i = t.facetsRefinements || {};
      Object.keys(i).sort().forEach(function(m) {
        var y = i[m] || [];
        y.slice().sort().forEach(function(g) {
          s.push(m + ":" + g);
        });
      });
      var l = t.facetsExcludes || {};
      Object.keys(l).sort().forEach(function(m) {
        var y = l[m] || [];
        y.sort().forEach(function(g) {
          s.push(m + ":-" + g);
        });
      });
      var c = t.disjunctiveFacetsRefinements || {};
      Object.keys(c).sort().forEach(function(m) {
        var y = c[m] || [];
        if (!(m === n || !y || y.length === 0)) {
          var g = [];
          y.slice().sort().forEach(function(p) {
            g.push(m + ":" + p);
          }), s.push(g);
        }
      });
      var u = t.hierarchicalFacetsRefinements || {};
      return Object.keys(u).sort().forEach(function(m) {
        var y = u[m] || [], g = y[0];
        if (g !== void 0) {
          var p = t.getHierarchicalFacetByName(m), d = t._getHierarchicalFacetSeparator(p), h = t._getHierarchicalRootPath(p), f, F;
          if (n === m) {
            if (g.indexOf(d) === -1 || !h && a === !0 || h && h.split(d).length === g.split(d).length)
              return;
            h ? (F = h.split(d).length - 1, g = h) : (F = g.split(d).length - 2, g = g.slice(0, g.lastIndexOf(d))), f = p.attributes[F];
          } else
            F = g.split(d).length - 1, f = p.attributes[F];
          f && s.push([f + ":" + g]);
        }
      }), s;
    },
    _getHitsHierarchicalFacetsAttributes: function(t) {
      var n = [];
      return t.hierarchicalFacets.reduce(
        // ask for as much levels as there's hierarchical refinements
        function(s, i) {
          var l = t.getHierarchicalRefinement(
            i.name
          )[0];
          if (!l)
            return s.push(i.attributes[0]), s;
          var c = t._getHierarchicalFacetSeparator(i), u = l.split(c).length, m = i.attributes.slice(0, u + 1);
          return s.concat(m);
        },
        n
      );
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(t, n, a) {
      var s = t._getHierarchicalFacetSeparator(n);
      if (a === !0) {
        var i = t._getHierarchicalRootPath(n), l = 0;
        return i && (l = i.split(s).length), [n.attributes[l]];
      }
      var c = t.getHierarchicalRefinement(n.name)[0] || "", u = c.split(s).length - 1;
      return n.attributes.slice(0, u + 1);
    },
    getSearchForFacetQuery: function(t, n, a, s) {
      var i = s.isDisjunctiveFacet(t) ? s.clearRefinements(t) : s, l = {
        facetQuery: n,
        facetName: t
      };
      return typeof a == "number" && (l.maxFacetHits = a), e(
        o(
          {},
          r._getHitsSearchParams(i),
          l
        )
      );
    }
  };
  return Ai = r, Ai;
}
var Ci, Xp;
function lu() {
  return Xp || (Xp = 1, Ci = function() {
    var e = Array.prototype.slice.call(arguments);
    return e.reduceRight(function(r, t) {
      return Object.keys(Object(t)).forEach(function(n) {
        t[n] !== void 0 && (r[n] !== void 0 && delete r[n], r[n] = t[n]);
      }), r;
    }, {});
  }), Ci;
}
var Oi, qp;
function Fa() {
  return qp || (qp = 1, Oi = function(e, r) {
    if (Array.isArray(e)) {
      for (var t = 0; t < e.length; t++)
        if (r(e[t]))
          return e[t];
    }
  }), Oi;
}
var Ti, Up;
function hv() {
  if (Up) return Ti;
  Up = 1;
  function o(e, r) {
    return e.filter(function(t, n) {
      return r.indexOf(t) > -1 && e.indexOf(t) === n;
    });
  }
  return Ti = o, Ti;
}
var ji, Yp;
function Fv() {
  if (Yp) return ji;
  Yp = 1;
  function o(e) {
    if (typeof e == "number")
      return e;
    if (typeof e == "string")
      return parseFloat(e);
    if (Array.isArray(e))
      return e.map(o);
    throw new Error(
      "The value should be a number, a parsable string or an array of those."
    );
  }
  return ji = o, ji;
}
var Mi, Jp;
function bv() {
  return Jp || (Jp = 1, Mi = function(e) {
    return e === null ? !1 : /^[a-zA-Z0-9_-]{1,64}$/.test(e);
  }), Mi;
}
var zi, Qp;
function vv() {
  if (Qp) return zi;
  Qp = 1;
  var o = lu(), e = su(), r = iu(), t = {
    /**
     * Adds a refinement to a RefinementList
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement, if the value is not a string it will be converted
     * @return {RefinementList} a new and updated refinement list
     */
    addRefinement: function(a, s, i) {
      if (t.isRefined(a, s, i))
        return a;
      var l = "" + i, c = a[s] ? a[s].concat(l) : [l], u = {};
      return u[s] = c, o(u, a);
    },
    /**
     * Removes refinement(s) for an attribute:
     *  - if the value is specified removes the refinement for the value on the attribute
     *  - if no value is specified removes all the refinements for this attribute
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} [value] the value of the refinement
     * @return {RefinementList} a new and updated refinement lst
     */
    removeRefinement: function(a, s, i) {
      if (i === void 0)
        return t.clearRefinement(a, function(c, u) {
          return s === u;
        });
      var l = "" + i;
      return t.clearRefinement(a, function(c, u) {
        return s === u && l === c;
      });
    },
    /**
     * Toggles the refinement value for an attribute.
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement
     * @return {RefinementList} a new and updated list
     */
    toggleRefinement: function(a, s, i) {
      if (i === void 0)
        throw new Error("toggleRefinement should be used with a value");
      return t.isRefined(a, s, i) ? t.removeRefinement(a, s, i) : t.addRefinement(a, s, i);
    },
    /**
     * Clear all or parts of a RefinementList. Depending on the arguments, three
     * kinds of behavior can happen:
     *  - if no attribute is provided: clears the whole list
     *  - if an attribute is provided as a string: clears the list for the specific attribute
     *  - if an attribute is provided as a function: discards the elements for which the function returns true
     * @param {RefinementList} refinementList the initial list
     * @param {string} [attribute] the attribute or function to discard
     * @param {string} [refinementType] optional parameter to give more context to the attribute function
     * @return {RefinementList} a new and updated refinement list
     */
    clearRefinement: function(a, s, i) {
      if (s === void 0)
        return e(a) ? {} : a;
      if (typeof s == "string")
        return r(a, [s]);
      if (typeof s == "function") {
        var l = !1, c = Object.keys(a).reduce(
          function(u, m) {
            var y = a[m] || [], g = y.filter(function(p) {
              return !s(p, m, i);
            });
            return g.length !== y.length && (l = !0), u[m] = g, u;
          },
          {}
        );
        return l ? c : a;
      }
    },
    /**
     * Test if the refinement value is used for the attribute. If no refinement value
     * is provided, test if the refinementList contains any refinement for the
     * given attribute.
     * @param {RefinementList} refinementList the list of refinement
     * @param {string} attribute name of the attribute
     * @param {string} [refinementValue] value of the filter/refinement
     * @return {boolean} true if the attribute is refined, false otherwise
     */
    isRefined: function(a, s, i) {
      var l = !!a[s] && a[s].length > 0;
      if (i === void 0 || !l)
        return l;
      var c = "" + i;
      return a[s].indexOf(c) !== -1;
    }
  };
  return zi = t, zi;
}
var Ni, Kp;
function qy() {
  if (Kp) return Ni;
  Kp = 1;
  var o = lu(), e = Fa(), r = hv(), t = au(), n = su(), a = iu(), s = Fv(), i = bv(), l = vv();
  function c(y, g) {
    return Array.isArray(y) && Array.isArray(g) ? y.length === g.length && y.every(function(p, d) {
      return c(g[d], p);
    }) : y === g;
  }
  function u(y, g) {
    return e(y, function(p) {
      return c(p, g);
    });
  }
  function m(y) {
    var g = y ? m._parseNumbers(y) : {};
    g.userToken !== void 0 && !i(g.userToken) && console.warn(
      "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"
    ), this.facets = g.facets || [], this.disjunctiveFacets = g.disjunctiveFacets || [], this.hierarchicalFacets = g.hierarchicalFacets || [], this.facetsRefinements = g.facetsRefinements || {}, this.facetsExcludes = g.facetsExcludes || {}, this.disjunctiveFacetsRefinements = g.disjunctiveFacetsRefinements || {}, this.numericRefinements = g.numericRefinements || {}, this.tagRefinements = g.tagRefinements || [], this.hierarchicalFacetsRefinements = g.hierarchicalFacetsRefinements || {};
    var p = this;
    Object.keys(g).forEach(function(d) {
      var h = m.PARAMETERS.indexOf(d) !== -1, f = g[d] !== void 0;
      !h && f && (p[d] = g[d]);
    });
  }
  return m.PARAMETERS = Object.keys(new m()), m._parseNumbers = function(y) {
    if (y instanceof m) return y;
    var g = {}, p = [
      "aroundPrecision",
      "aroundRadius",
      "getRankingInfo",
      "minWordSizefor2Typos",
      "minWordSizefor1Typo",
      "page",
      "maxValuesPerFacet",
      "distinct",
      "minimumAroundRadius",
      "hitsPerPage",
      "minProximity"
    ];
    if (p.forEach(function(h) {
      var f = y[h];
      if (typeof f == "string") {
        var F = parseFloat(f);
        g[h] = isNaN(F) ? f : F;
      }
    }), Array.isArray(y.insideBoundingBox) && (g.insideBoundingBox = y.insideBoundingBox.map(function(h) {
      return Array.isArray(h) ? h.map(function(f) {
        return parseFloat(f);
      }) : h;
    })), y.numericRefinements) {
      var d = {};
      Object.keys(y.numericRefinements).forEach(function(h) {
        var f = y.numericRefinements[h] || {};
        d[h] = {}, Object.keys(f).forEach(function(F) {
          var b = f[F], v = b.map(function(k) {
            return Array.isArray(k) ? k.map(function(E) {
              return typeof E == "string" ? parseFloat(E) : E;
            }) : typeof k == "string" ? parseFloat(k) : k;
          });
          d[h][F] = v;
        });
      }), g.numericRefinements = d;
    }
    return t(y, g);
  }, m.make = function(g) {
    var p = new m(g), d = g.hierarchicalFacets || [];
    return d.forEach(function(h) {
      if (h.rootPath) {
        var f = p.getHierarchicalRefinement(h.name);
        f.length > 0 && f[0].indexOf(h.rootPath) !== 0 && (p = p.clearRefinements(h.name)), f = p.getHierarchicalRefinement(h.name), f.length === 0 && (p = p.toggleHierarchicalFacetRefinement(
          h.name,
          h.rootPath
        ));
      }
    }), p;
  }, m.validate = function(y, g) {
    var p = g || {};
    return y.tagFilters && p.tagRefinements && p.tagRefinements.length > 0 ? new Error(
      "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method."
    ) : y.tagRefinements.length > 0 && p.tagFilters ? new Error(
      "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method."
    ) : y.numericFilters && p.numericRefinements && n(p.numericRefinements) ? new Error(
      "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : n(y.numericRefinements) && p.numericFilters ? new Error(
      "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : null;
  }, m.prototype = {
    constructor: m,
    /**
     * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
     * @method
     * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {SearchParameters} new instance with filters cleared
     */
    clearRefinements: function(g) {
      var p = {
        numericRefinements: this._clearNumericRefinements(g),
        facetsRefinements: l.clearRefinement(
          this.facetsRefinements,
          g,
          "conjunctiveFacet"
        ),
        facetsExcludes: l.clearRefinement(
          this.facetsExcludes,
          g,
          "exclude"
        ),
        disjunctiveFacetsRefinements: l.clearRefinement(
          this.disjunctiveFacetsRefinements,
          g,
          "disjunctiveFacet"
        ),
        hierarchicalFacetsRefinements: l.clearRefinement(
          this.hierarchicalFacetsRefinements,
          g,
          "hierarchicalFacet"
        )
      };
      return p.numericRefinements === this.numericRefinements && p.facetsRefinements === this.facetsRefinements && p.facetsExcludes === this.facetsExcludes && p.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && p.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(p);
    },
    /**
     * Remove all the refined tags from the SearchParameters
     * @method
     * @return {SearchParameters} new instance with tags cleared
     */
    clearTags: function() {
      return this.tagFilters === void 0 && this.tagRefinements.length === 0 ? this : this.setQueryParameters({
        tagFilters: void 0,
        tagRefinements: []
      });
    },
    /**
     * Set the index.
     * @method
     * @param {string} index the index name
     * @return {SearchParameters} new instance
     */
    setIndex: function(g) {
      return g === this.index ? this : this.setQueryParameters({
        index: g
      });
    },
    /**
     * Query setter
     * @method
     * @param {string} newQuery value for the new query
     * @return {SearchParameters} new instance
     */
    setQuery: function(g) {
      return g === this.query ? this : this.setQueryParameters({
        query: g
      });
    },
    /**
     * Page setter
     * @method
     * @param {number} newPage new page number
     * @return {SearchParameters} new instance
     */
    setPage: function(g) {
      return g === this.page ? this : this.setQueryParameters({
        page: g
      });
    },
    /**
     * Facets setter
     * The facets are the simple facets, used for conjunctive (and) faceting.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
     * @return {SearchParameters} new instance
     */
    setFacets: function(g) {
      return this.setQueryParameters({
        facets: g
      });
    },
    /**
     * Disjunctive facets setter
     * Change the list of disjunctive (or) facets the helper chan handle.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
     * @return {SearchParameters} new instance
     */
    setDisjunctiveFacets: function(g) {
      return this.setQueryParameters({
        disjunctiveFacets: g
      });
    },
    /**
     * HitsPerPage setter
     * Hits per page represents the number of hits retrieved for this query
     * @method
     * @param {number} n number of hits retrieved per page of results
     * @return {SearchParameters} new instance
     */
    setHitsPerPage: function(g) {
      return this.hitsPerPage === g ? this : this.setQueryParameters({
        hitsPerPage: g
      });
    },
    /**
     * typoTolerance setter
     * Set the value of typoTolerance
     * @method
     * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
     * @return {SearchParameters} new instance
     */
    setTypoTolerance: function(g) {
      return this.typoTolerance === g ? this : this.setQueryParameters({
        typoTolerance: g
      });
    },
    /**
     * Add a numeric filter for a given attribute
     * When value is an array, they are combined with OR
     * When value is a single value, it will combined with AND
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number | number[]} value value of the filter
     * @return {SearchParameters} new instance
     * @example
     * // for price = 50 or 40
     * state.addNumericRefinement('price', '=', [50, 40]);
     * @example
     * // for size = 38 and 40
     * state.addNumericRefinement('size', '=', 38);
     * state.addNumericRefinement('size', '=', 40);
     */
    addNumericRefinement: function(y, g, p) {
      var d = s(p);
      if (this.isNumericRefined(y, g, d)) return this;
      var h = t({}, this.numericRefinements);
      return h[y] = t({}, h[y]), h[y][g] ? (h[y][g] = h[y][g].slice(), h[y][g].push(d)) : h[y][g] = [d], this.setQueryParameters({
        numericRefinements: h
      });
    },
    /**
     * Get the list of conjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getConjunctiveRefinements: function(y) {
      return this.isConjunctiveFacet(y) ? this.facetsRefinements[y] || [] : [];
    },
    /**
     * Get the list of disjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getDisjunctiveRefinements: function(y) {
      return this.isDisjunctiveFacet(y) ? this.disjunctiveFacetsRefinements[y] || [] : [];
    },
    /**
     * Get the list of hierarchical refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getHierarchicalRefinement: function(y) {
      return this.hierarchicalFacetsRefinements[y] || [];
    },
    /**
     * Get the list of exclude refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getExcludeRefinements: function(y) {
      return this.isConjunctiveFacet(y) ? this.facetsExcludes[y] || [] : [];
    },
    /**
     * Remove all the numeric filter for a given (attribute, operator)
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number} [number] the value to be removed
     * @return {SearchParameters} new instance
     */
    removeNumericRefinement: function(y, g, p) {
      var d = p;
      return d !== void 0 ? this.isNumericRefined(y, g, d) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(h, f) {
          return f === y && h.op === g && c(h.val, s(d));
        })
      }) : this : g !== void 0 ? this.isNumericRefined(y, g) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(h, f) {
          return f === y && h.op === g;
        })
      }) : this : this.isNumericRefined(y) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(h, f) {
          return f === y;
        })
      }) : this;
    },
    /**
     * Get the list of numeric refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {SearchParameters.OperatorList} list of refinements
     */
    getNumericRefinements: function(y) {
      return this.numericRefinements[y] || {};
    },
    /**
     * Return the current refinement for the (attribute, operator)
     * @param {string} attribute attribute in the record
     * @param {string} operator operator applied on the refined values
     * @return {Array.<number|number[]>} refined values
     */
    getNumericRefinement: function(y, g) {
      return this.numericRefinements[y] && this.numericRefinements[y][g];
    },
    /**
     * Clear numeric filters.
     * @method
     * @private
     * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {Object.<string, OperatorList>} new numeric refinements
     */
    _clearNumericRefinements: function(g) {
      if (g === void 0)
        return n(this.numericRefinements) ? {} : this.numericRefinements;
      if (typeof g == "string")
        return a(this.numericRefinements, [g]);
      if (typeof g == "function") {
        var p = !1, d = this.numericRefinements, h = Object.keys(d).reduce(
          function(f, F) {
            var b = d[F], v = {};
            return b = b || {}, Object.keys(b).forEach(function(k) {
              var E = b[k] || [], S = [];
              E.forEach(function(B) {
                var D = g(
                  { val: B, op: k },
                  F,
                  "numeric"
                );
                D || S.push(B);
              }), S.length !== E.length && (p = !0), v[k] = S;
            }), f[F] = v, f;
          },
          {}
        );
        return p ? h : this.numericRefinements;
      }
    },
    /**
     * Add a facet to the facets attribute of the helper configuration, if it
     * isn't already present.
     * @method
     * @param {string} facet facet name to add
     * @return {SearchParameters} new instance
     */
    addFacet: function(g) {
      return this.isConjunctiveFacet(g) ? this : this.setQueryParameters({
        facets: this.facets.concat([g])
      });
    },
    /**
     * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
     * configuration, if it isn't already present.
     * @method
     * @param {string} facet disjunctive facet name to add
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacet: function(g) {
      return this.isDisjunctiveFacet(g) ? this : this.setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.concat([g])
      });
    },
    /**
     * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
     * configuration.
     * @method
     * @param {object} hierarchicalFacet hierarchical facet to add
     * @return {SearchParameters} new instance
     * @throws will throw an error if a hierarchical facet with the same name was already declared
     */
    addHierarchicalFacet: function(g) {
      if (this.isHierarchicalFacet(g.name))
        throw new Error(
          "Cannot declare two hierarchical facets with the same name: `" + g.name + "`"
        );
      return this.setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.concat([g])
      });
    },
    /**
     * Add a refinement on a "normal" facet
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addFacetRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsRefinements, g, p) ? this : this.setQueryParameters({
        facetsRefinements: l.addRefinement(
          this.facetsRefinements,
          g,
          p
        )
      });
    },
    /**
     * Exclude a value from a "normal" facet
     * @method
     * @param {string} facet attribute to apply the exclusion on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addExcludeRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsExcludes, g, p) ? this : this.setQueryParameters({
        facetsExcludes: l.addRefinement(
          this.facetsExcludes,
          g,
          p
        )
      });
    },
    /**
     * Adds a refinement on a disjunctive facet.
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacetRefinement: function(g, p) {
      if (!this.isDisjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return l.isRefined(this.disjunctiveFacetsRefinements, g, p) ? this : this.setQueryParameters({
        disjunctiveFacetsRefinements: l.addRefinement(
          this.disjunctiveFacetsRefinements,
          g,
          p
        )
      });
    },
    /**
     * addTagRefinement adds a tag to the list used to filter the results
     * @param {string} tag tag to be added
     * @return {SearchParameters} new instance
     */
    addTagRefinement: function(g) {
      if (this.isTagRefined(g)) return this;
      var p = {
        tagRefinements: this.tagRefinements.concat(g)
      };
      return this.setQueryParameters(p);
    },
    /**
     * Remove a facet from the facets attribute of the helper configuration, if it
     * is present.
     * @method
     * @param {string} facet facet name to remove
     * @return {SearchParameters} new instance
     */
    removeFacet: function(g) {
      return this.isConjunctiveFacet(g) ? this.clearRefinements(g).setQueryParameters({
        facets: this.facets.filter(function(p) {
          return p !== g;
        })
      }) : this;
    },
    /**
     * Remove a disjunctive facet from the disjunctiveFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet disjunctive facet name to remove
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacet: function(g) {
      return this.isDisjunctiveFacet(g) ? this.clearRefinements(g).setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.filter(function(p) {
          return p !== g;
        })
      }) : this;
    },
    /**
     * Remove a hierarchical facet from the hierarchicalFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet hierarchical facet name to remove
     * @return {SearchParameters} new instance
     */
    removeHierarchicalFacet: function(g) {
      return this.isHierarchicalFacet(g) ? this.clearRefinements(g).setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.filter(function(p) {
          return p.name !== g;
        })
      }) : this;
    },
    /**
     * Remove a refinement set on facet. If a value is provided, it will clear the
     * refinement for the given value, otherwise it will clear all the refinement
     * values for the faceted attribute.
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} [value] value used to filter
     * @return {SearchParameters} new instance
     */
    removeFacetRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsRefinements, g, p) ? this.setQueryParameters({
        facetsRefinements: l.removeRefinement(
          this.facetsRefinements,
          g,
          p
        )
      }) : this;
    },
    /**
     * Remove a negative refinement on a facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeExcludeRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsExcludes, g, p) ? this.setQueryParameters({
        facetsExcludes: l.removeRefinement(
          this.facetsExcludes,
          g,
          p
        )
      }) : this;
    },
    /**
     * Remove a refinement on a disjunctive facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacetRefinement: function(g, p) {
      if (!this.isDisjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return l.isRefined(this.disjunctiveFacetsRefinements, g, p) ? this.setQueryParameters({
        disjunctiveFacetsRefinements: l.removeRefinement(
          this.disjunctiveFacetsRefinements,
          g,
          p
        )
      }) : this;
    },
    /**
     * Remove a tag from the list of tag refinements
     * @method
     * @param {string} tag the tag to remove
     * @return {SearchParameters} new instance
     */
    removeTagRefinement: function(g) {
      if (!this.isTagRefined(g)) return this;
      var p = {
        tagRefinements: this.tagRefinements.filter(function(d) {
          return d !== g;
        })
      };
      return this.setQueryParameters(p);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
     */
    toggleRefinement: function(g, p) {
      return this.toggleFacetRefinement(g, p);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     */
    toggleFacetRefinement: function(g, p) {
      if (this.isHierarchicalFacet(g))
        return this.toggleHierarchicalFacetRefinement(g, p);
      if (this.isConjunctiveFacet(g))
        return this.toggleConjunctiveFacetRefinement(g, p);
      if (this.isDisjunctiveFacet(g))
        return this.toggleDisjunctiveFacetRefinement(g, p);
      throw new Error(
        "Cannot refine the undeclared facet " + g + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
      );
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleConjunctiveFacetRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsRefinements: l.toggleRefinement(
          this.facetsRefinements,
          g,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleExcludeFacetRefinement: function(g, p) {
      if (!this.isConjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsExcludes: l.toggleRefinement(
          this.facetsExcludes,
          g,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleDisjunctiveFacetRefinement: function(g, p) {
      if (!this.isDisjunctiveFacet(g))
        throw new Error(
          g + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        disjunctiveFacetsRefinements: l.toggleRefinement(
          this.disjunctiveFacetsRefinements,
          g,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleHierarchicalFacetRefinement: function(g, p) {
      if (!this.isHierarchicalFacet(g))
        throw new Error(
          g + " is not defined in the hierarchicalFacets attribute of the helper configuration"
        );
      var d = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(g)
      ), h = {}, f = this.hierarchicalFacetsRefinements[g] !== void 0 && this.hierarchicalFacetsRefinements[g].length > 0 && // remove current refinement:
      // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
      (this.hierarchicalFacetsRefinements[g][0] === p || // remove a parent refinement of the current refinement:
      //  - refinement was 'beer > IPA > Flying dog'
      //  - call is toggleRefine('beer > IPA')
      //  - refinement should be `beer`
      this.hierarchicalFacetsRefinements[g][0].indexOf(
        p + d
      ) === 0);
      return f ? p.indexOf(d) === -1 ? h[g] = [] : h[g] = [p.slice(0, p.lastIndexOf(d))] : h[g] = [p], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          h,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Adds a refinement on a hierarchical facet.
     * @param {string} facet the facet name
     * @param {string} path the hierarchical facet path
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is refined
     */
    addHierarchicalFacetRefinement: function(y, g) {
      if (this.isHierarchicalFacetRefined(y))
        throw new Error(y + " is already refined.");
      if (!this.isHierarchicalFacet(y))
        throw new Error(
          y + " is not defined in the hierarchicalFacets attribute of the helper configuration."
        );
      var p = {};
      return p[y] = [g], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          p,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Removes the refinement set on a hierarchical facet.
     * @param {string} facet the facet name
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is not refined
     */
    removeHierarchicalFacetRefinement: function(y) {
      if (!this.isHierarchicalFacetRefined(y))
        return this;
      var g = {};
      return g[y] = [], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          g,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Switch the tag refinement
     * @method
     * @param {string} tag the tag to remove or add
     * @return {SearchParameters} new instance
     */
    toggleTagRefinement: function(g) {
      return this.isTagRefined(g) ? this.removeTagRefinement(g) : this.addTagRefinement(g);
    },
    /**
     * Test if the facet name is from one of the disjunctive facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a disjunctive facet
     */
    isDisjunctiveFacet: function(y) {
      return this.disjunctiveFacets.indexOf(y) > -1;
    },
    /**
     * Test if the facet name is from one of the hierarchical facets
     * @method
     * @param {string} facetName facet name to test
     * @return {boolean} true if facetName is a hierarchical facet
     */
    isHierarchicalFacet: function(y) {
      return this.getHierarchicalFacetByName(y) !== void 0;
    },
    /**
     * Test if the facet name is from one of the conjunctive/normal facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a conjunctive facet
     */
    isConjunctiveFacet: function(y) {
      return this.facets.indexOf(y) > -1;
    },
    /**
     * Returns true if the facet is refined, either for a specific value or in
     * general.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value, optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isFacetRefined: function(g, p) {
      return this.isConjunctiveFacet(g) ? l.isRefined(this.facetsRefinements, g, p) : !1;
    },
    /**
     * Returns true if the facet contains exclusions or if a specific value is
     * excluded.
     *
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} [value] optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isExcludeRefined: function(g, p) {
      return this.isConjunctiveFacet(g) ? l.isRefined(this.facetsExcludes, g, p) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isDisjunctiveFacetRefined: function(g, p) {
      return this.isDisjunctiveFacet(g) ? l.isRefined(
        this.disjunctiveFacetsRefinements,
        g,
        p
      ) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isHierarchicalFacetRefined: function(g, p) {
      if (!this.isHierarchicalFacet(g))
        return !1;
      var d = this.getHierarchicalRefinement(g);
      return p ? d.indexOf(p) !== -1 : d.length > 0;
    },
    /**
     * Test if the triple (attribute, operator, value) is already refined.
     * If only the attribute and the operator are provided, it tests if the
     * contains any refinement value.
     * @method
     * @param {string} attribute attribute for which the refinement is applied
     * @param {string} [operator] operator of the refinement
     * @param {string} [value] value of the refinement
     * @return {boolean} true if it is refined
     */
    isNumericRefined: function(g, p, d) {
      if (d === void 0 && p === void 0)
        return !!this.numericRefinements[g];
      var h = this.numericRefinements[g] && this.numericRefinements[g][p] !== void 0;
      if (d === void 0 || !h)
        return h;
      var f = s(d), F = u(this.numericRefinements[g][p], f) !== void 0;
      return h && F;
    },
    /**
     * Returns true if the tag refined, false otherwise
     * @method
     * @param {string} tag the tag to check
     * @return {boolean} true if tag is refined
     */
    isTagRefined: function(g) {
      return this.tagRefinements.indexOf(g) !== -1;
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedDisjunctiveFacets: function() {
      var g = this, p = r(
        Object.keys(this.numericRefinements).filter(function(d) {
          return Object.keys(g.numericRefinements[d]).length > 0;
        }),
        this.disjunctiveFacets
      );
      return Object.keys(this.disjunctiveFacetsRefinements).filter(function(d) {
        return g.disjunctiveFacetsRefinements[d].length > 0;
      }).concat(p).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedHierarchicalFacets: function() {
      var g = this;
      return r(
        // enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(p) {
          return p.name;
        }),
        Object.keys(this.hierarchicalFacetsRefinements).filter(function(p) {
          return g.hierarchicalFacetsRefinements[p].length > 0;
        })
      ).sort();
    },
    /**
     * Returned the list of all disjunctive facets not refined
     * @method
     * @return {string[]} returns the list of facets that are not refined
     */
    getUnrefinedDisjunctiveFacets: function() {
      var y = this.getRefinedDisjunctiveFacets();
      return this.disjunctiveFacets.filter(function(g) {
        return y.indexOf(g) === -1;
      });
    },
    managedParameters: [
      "index",
      "facets",
      "disjunctiveFacets",
      "facetsRefinements",
      "hierarchicalFacets",
      "facetsExcludes",
      "disjunctiveFacetsRefinements",
      "numericRefinements",
      "tagRefinements",
      "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function() {
      var g = this.managedParameters, p = {}, d = this;
      return Object.keys(this).forEach(function(h) {
        var f = d[h];
        g.indexOf(h) === -1 && f !== void 0 && (p[h] = f);
      }), p;
    },
    /**
     * Let the user set a specific value for a given parameter. Will return the
     * same instance if the parameter is invalid or if the value is the same as the
     * previous one.
     * @method
     * @param {string} parameter the parameter name
     * @param {any} value the value to be set, must be compliant with the definition
     * of the attribute on the object
     * @return {SearchParameters} the updated state
     */
    setQueryParameter: function(g, p) {
      if (this[g] === p) return this;
      var d = {};
      return d[g] = p, this.setQueryParameters(d);
    },
    /**
     * Let the user set any of the parameters with a plain object.
     * @method
     * @param {object} params all the keys and the values to be updated
     * @return {SearchParameters} a new updated instance
     */
    setQueryParameters: function(g) {
      if (!g) return this;
      var p = m.validate(this, g);
      if (p)
        throw p;
      var d = this, h = m._parseNumbers(g), f = Object.keys(this).reduce(function(b, v) {
        return b[v] = d[v], b;
      }, {}), F = Object.keys(h).reduce(
        function(b, v) {
          var k = b[v] !== void 0, E = h[v] !== void 0;
          return k && !E ? a(b, [v]) : (E && (b[v] = h[v]), b);
        },
        f
      );
      return new this.constructor(F);
    },
    /**
     * Returns a new instance with the page reset. Two scenarios possible:
     * the page is omitted -> return the given instance
     * the page is set -> return a new instance with a page of 0
     * @return {SearchParameters} a new updated instance
     */
    resetPage: function() {
      return this.page === void 0 ? this : this.setPage(0);
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSortBy: function(y) {
      return y.sortBy || ["isRefined:desc", "name:asc"];
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSeparator: function(y) {
      return y.separator || " > ";
    },
    /**
     * Helper function to get the hierarchicalFacet prefix path or null
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.rootPath or null as default
     */
    _getHierarchicalRootPath: function(y) {
      return y.rootPath || null;
    },
    /**
     * Helper function to check if we show the parent level of the hierarchicalFacet
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
     */
    _getHierarchicalShowParentLevel: function(y) {
      return typeof y.showParentLevel == "boolean" ? y.showParentLevel : !0;
    },
    /**
     * Helper function to get the hierarchicalFacet by it's name
     * @param  {string} hierarchicalFacetName the hierarchicalFacet name
     * @return {object} a hierarchicalFacet
     */
    getHierarchicalFacetByName: function(y) {
      return e(this.hierarchicalFacets, function(g) {
        return g.name === y;
      });
    },
    /**
     * Get the current breadcrumb for a hierarchical facet, as an array
     * @param  {string} facetName Hierarchical facet name
     * @return {array.<string>} the path as an array of string
     */
    getHierarchicalFacetBreadcrumb: function(y) {
      if (!this.isHierarchicalFacet(y))
        return [];
      var g = this.getHierarchicalRefinement(y)[0];
      if (!g) return [];
      var p = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(y)
      ), d = g.split(p);
      return d.map(function(h) {
        return h.trim();
      });
    },
    toString: function() {
      return JSON.stringify(this, null, 2);
    }
  }, Ni = m, Ni;
}
var Ii, _p;
function Pv() {
  return _p || (_p = 1, Ii = function(e) {
    return Array.isArray(e) ? e.filter(Boolean) : [];
  }), Ii;
}
var Ri, $p;
function Bv() {
  return $p || ($p = 1, Ri = function(e, r) {
    if (!Array.isArray(e))
      return -1;
    for (var t = 0; t < e.length; t++)
      if (r(e[t]))
        return t;
    return -1;
  }), Ri;
}
var Li, ed;
function Uy() {
  if (ed) return Li;
  ed = 1;
  var o = Fa();
  return Li = function(r, t) {
    var n = (t || []).map(function(a) {
      return a.split(":");
    });
    return r.reduce(
      function(s, i) {
        var l = i.split(":"), c = o(
          n,
          function(u) {
            return u[0] === l[0];
          }
        );
        return l.length > 1 || !c ? (s[0].push(l[0]), s[1].push(l[1]), s) : (s[0].push(c[0]), s[1].push(c[1]), s);
      },
      [[], []]
    );
  }, Li;
}
var Hi, od;
function kv() {
  if (od) return Hi;
  od = 1;
  function o() {
    var e = Array.prototype.slice.call(arguments);
    return e.reduceRight(function(r, t) {
      return Object.keys(Object(t)).forEach(function(n) {
        var a = typeof r[n] == "number" ? r[n] : 0, s = t[n];
        s !== void 0 && s >= a && (r[n] !== void 0 && delete r[n], r[n] = s);
      }), r;
    }, {});
  }
  return Hi = o, Hi;
}
var Wi, rd;
function Yy() {
  if (rd) return Wi;
  rd = 1;
  function o(r, t) {
    if (r !== t) {
      var n = r !== void 0, a = r === null, s = t !== void 0, i = t === null;
      if (!i && r > t || a && s || !n)
        return 1;
      if (!a && r < t || i && n || !s)
        return -1;
    }
    return 0;
  }
  function e(r, t, n) {
    if (!Array.isArray(r))
      return [];
    Array.isArray(n) || (n = []);
    var a = r.map(function(s, i) {
      return {
        criteria: t.map(function(l) {
          return s[l];
        }),
        index: i,
        value: s
      };
    });
    return a.sort(function(i, l) {
      for (var c = -1; ++c < i.criteria.length; ) {
        var u = o(i.criteria[c], l.criteria[c]);
        if (u)
          return c >= n.length ? u : n[c] === "desc" ? -u : u;
      }
      return i.index - l.index;
    }), a.map(function(s) {
      return s.value;
    });
  }
  return Wi = e, Wi;
}
var Vi, td;
function wv() {
  if (td) return Vi;
  td = 1, Vi = s;
  var o = nu(), e = Fa(), r = Uy(), t = Yy(), n = o.escapeFacetValue, a = o.unescapeFacetValue;
  function s(u) {
    return function(y, g) {
      var p = u.hierarchicalFacets[g], d = u.hierarchicalFacetsRefinements[p.name] && u.hierarchicalFacetsRefinements[p.name][0] || "", h = u._getHierarchicalFacetSeparator(p), f = u._getHierarchicalRootPath(p), F = u._getHierarchicalShowParentLevel(p), b = r(
        u._getHierarchicalFacetSortBy(p)
      ), v = y.every(function(S) {
        return S.exhaustive;
      }), k = i(
        b,
        h,
        f,
        F,
        d
      ), E = y;
      return f && (E = y.slice(
        f.split(h).length
      )), E.reduce(k, {
        name: u.hierarchicalFacets[g].name,
        count: null,
        // root level, no count
        isRefined: !0,
        // root level, always refined
        path: null,
        // root level, no path
        escapedValue: null,
        exhaustive: v,
        data: null
      });
    };
  }
  function i(u, m, y, g, p) {
    return function(h, f, F) {
      var b = h;
      if (F > 0) {
        var v = 0;
        for (b = h; v < F; ) {
          var k = b && Array.isArray(b.data) ? b.data : [];
          b = e(k, function(S) {
            return S.isRefined;
          }), v++;
        }
      }
      if (b) {
        var E = Object.keys(f.data).map(function(S) {
          return [S, f.data[S]];
        }).filter(function(S) {
          var B = S[0];
          return l(
            B,
            b.path || y,
            p,
            m,
            y,
            g
          );
        });
        b.data = t(
          E.map(function(S) {
            var B = S[0], D = S[1];
            return c(
              D,
              B,
              m,
              a(p),
              f.exhaustive
            );
          }),
          u[0],
          u[1]
        );
      }
      return h;
    };
  }
  function l(u, m, y, g, p, d) {
    return p && (u.indexOf(p) !== 0 || p === u) ? !1 : !p && u.indexOf(g) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    p && u.split(g).length - p.split(g).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    u.indexOf(g) === -1 && y.indexOf(g) === -1 || // currentRefinement is a child of the facet value
    y.indexOf(u) === 0 || // facetValue is a child of the current parent, add it
    u.indexOf(m + g) === 0 && (d || u.indexOf(y) === 0);
  }
  function c(u, m, y, g, p) {
    var d = m.split(y);
    return {
      name: d[d.length - 1].trim(),
      path: m,
      escapedValue: n(m),
      count: u,
      isRefined: g === m || g.indexOf(m + y) === 0,
      exhaustive: p,
      data: null
    };
  }
  return Vi;
}
var Gi, nd;
function Jy() {
  if (nd) return Gi;
  nd = 1;
  var o = Pv(), e = lu(), r = nu(), t = Fa(), n = Bv(), a = Uy(), s = kv(), i = Yy(), l = r.escapeFacetValue, c = r.unescapeFacetValue, u = wv();
  function m(B) {
    var D = {};
    return B.forEach(function(x, C) {
      D[x] = C;
    }), D;
  }
  function y(B, D, x) {
    D && D[x] && (B.stats = D[x]);
  }
  function g(B, D) {
    return t(
      B,
      function(C) {
        var O = C.attributes || [];
        return O.indexOf(D) > -1;
      }
    );
  }
  function p(B, D, x) {
    var C = D[0] || {};
    this._rawResults = D;
    var O = this;
    Object.keys(C).forEach(function(V) {
      O[V] = C[V];
    });
    var T = e(x, {
      persistHierarchicalRootCount: !1
    });
    Object.keys(T).forEach(function(V) {
      O[V] = T[V];
    }), this.processingTimeMS = D.reduce(function(V, Y) {
      return Y.processingTimeMS === void 0 ? V : V + Y.processingTimeMS;
    }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = B.hierarchicalFacets.map(
      function() {
        return [];
      }
    ), this.facets = [];
    var I = B.getRefinedDisjunctiveFacets(), G = m(B.facets), U = m(B.disjunctiveFacets), N = 1, z = C.facets || {};
    Object.keys(z).forEach(function(V) {
      var Y = z[V], K = g(
        B.hierarchicalFacets,
        V
      );
      if (K) {
        var $ = K.attributes.indexOf(V), te = n(B.hierarchicalFacets, function(J) {
          return J.name === K.name;
        });
        O.hierarchicalFacets[te][$] = {
          attribute: V,
          data: Y,
          exhaustive: C.exhaustiveFacetsCount
        };
      } else {
        var ge = B.disjunctiveFacets.indexOf(V) !== -1, X = B.facets.indexOf(V) !== -1, q;
        ge && (q = U[V], O.disjunctiveFacets[q] = {
          name: V,
          data: Y,
          exhaustive: C.exhaustiveFacetsCount
        }, y(
          O.disjunctiveFacets[q],
          C.facets_stats,
          V
        )), X && (q = G[V], O.facets[q] = {
          name: V,
          data: Y,
          exhaustive: C.exhaustiveFacetsCount
        }, y(
          O.facets[q],
          C.facets_stats,
          V
        ));
      }
    }), this.hierarchicalFacets = o(this.hierarchicalFacets), I.forEach(function(V) {
      var Y = D[N], K = Y && Y.facets ? Y.facets : {}, $ = B.getHierarchicalFacetByName(V);
      Object.keys(K).forEach(function(te) {
        var ge = K[te], X;
        if ($) {
          X = n(B.hierarchicalFacets, function(ee) {
            return ee.name === $.name;
          });
          var q = n(
            O.hierarchicalFacets[X],
            function(ee) {
              return ee.attribute === te;
            }
          );
          if (q === -1)
            return;
          O.hierarchicalFacets[X][q].data = O.persistHierarchicalRootCount ? s(
            O.hierarchicalFacets[X][q].data,
            ge
          ) : e(
            ge,
            O.hierarchicalFacets[X][q].data
          );
        } else {
          X = U[te];
          var J = C.facets && C.facets[te] || {};
          O.disjunctiveFacets[X] = {
            name: te,
            data: s(J, ge),
            exhaustive: Y.exhaustiveFacetsCount
          }, y(
            O.disjunctiveFacets[X],
            Y.facets_stats,
            te
          ), B.disjunctiveFacetsRefinements[te] && B.disjunctiveFacetsRefinements[te].forEach(function(ee) {
            !O.disjunctiveFacets[X].data[ee] && B.disjunctiveFacetsRefinements[te].indexOf(
              c(ee)
            ) > -1 && (O.disjunctiveFacets[X].data[ee] = 0);
          });
        }
      }), N++;
    }), B.getRefinedHierarchicalFacets().forEach(function(V) {
      var Y = B.getHierarchicalFacetByName(V), K = B._getHierarchicalFacetSeparator(Y), $ = B.getHierarchicalRefinement(V);
      $.length === 0 || $[0].split(K).length < 2 || D.slice(N).forEach(function(te) {
        var ge = te && te.facets ? te.facets : {};
        Object.keys(ge).forEach(function(X) {
          var q = ge[X], J = n(B.hierarchicalFacets, function(Ee) {
            return Ee.name === Y.name;
          }), ee = n(
            O.hierarchicalFacets[J],
            function(Ee) {
              return Ee.attribute === X;
            }
          );
          if (ee !== -1) {
            var me = {};
            if ($.length > 0 && !O.persistHierarchicalRootCount) {
              var Se = $[0].split(K)[0];
              me[Se] = O.hierarchicalFacets[J][ee].data[Se];
            }
            O.hierarchicalFacets[J][ee].data = e(
              me,
              q,
              O.hierarchicalFacets[J][ee].data
            );
          }
        }), N++;
      });
    }), Object.keys(B.facetsExcludes).forEach(function(V) {
      var Y = B.facetsExcludes[V], K = G[V];
      O.facets[K] = {
        name: V,
        data: z[V],
        exhaustive: C.exhaustiveFacetsCount
      }, Y.forEach(function($) {
        O.facets[K] = O.facets[K] || { name: V }, O.facets[K].data = O.facets[K].data || {}, O.facets[K].data[$] = 0;
      });
    }), this.hierarchicalFacets = this.hierarchicalFacets.map(
      u(B)
    ), this.facets = o(this.facets), this.disjunctiveFacets = o(this.disjunctiveFacets), this._state = B;
  }
  p.prototype.getFacetByName = function(B) {
    function D(x) {
      return x.name === B;
    }
    return t(this.facets, D) || t(this.disjunctiveFacets, D) || t(this.hierarchicalFacets, D);
  };
  function d(B, D) {
    function x(z) {
      return z.name === D;
    }
    if (B._state.isConjunctiveFacet(D)) {
      var C = t(B.facets, x);
      return C ? Object.keys(C.data).map(function(z) {
        var V = l(z);
        return {
          name: z,
          escapedValue: V,
          count: C.data[z],
          isRefined: B._state.isFacetRefined(D, V),
          isExcluded: B._state.isExcludeRefined(D, z)
        };
      }) : [];
    } else if (B._state.isDisjunctiveFacet(D)) {
      var O = t(B.disjunctiveFacets, x);
      return O ? Object.keys(O.data).map(function(z) {
        var V = l(z);
        return {
          name: z,
          escapedValue: V,
          count: O.data[z],
          isRefined: B._state.isDisjunctiveFacetRefined(D, V)
        };
      }) : [];
    } else if (B._state.isHierarchicalFacet(D)) {
      var T = t(B.hierarchicalFacets, x);
      if (!T) return T;
      var I = B._state.getHierarchicalFacetByName(D), G = B._state._getHierarchicalFacetSeparator(I), U = c(
        B._state.getHierarchicalRefinement(D)[0] || ""
      );
      U.indexOf(I.rootPath) === 0 && (U = U.replace(
        I.rootPath + G,
        ""
      ));
      var N = U.split(G);
      return N.unshift(D), h(T, N, 0), T;
    }
  }
  function h(B, D, x) {
    B.isRefined = B.name === (D[x] && D[x].trim()), B.data && B.data.forEach(function(C) {
      h(C, D, x + 1);
    });
  }
  function f(B, D, x, C) {
    if (C = C || 0, Array.isArray(D))
      return B(D, x[C]);
    if (!D.data || D.data.length === 0)
      return D;
    var O = D.data.map(function(G) {
      return f(B, G, x, C + 1);
    }), T = B(O, x[C]), I = e({ data: T }, D);
    return I;
  }
  p.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"];
  function F(B, D) {
    return D.sort(B);
  }
  function b(B, D) {
    var x = [], C = [], O = D.hide || [], T = D.order || [], I = T.reduce(function(N, z, V) {
      return N[z] = V, N;
    }, {});
    B.forEach(function(N) {
      var z = N.path || N.name, V = O.indexOf(z) > -1;
      !V && I[z] !== void 0 ? x[I[z]] = N : V || C.push(N);
    }), x = x.filter(function(N) {
      return N;
    });
    var G = D.sortRemainingBy, U;
    return G === "hidden" ? x : (G === "alpha" ? U = [
      ["path", "name"],
      ["asc", "asc"]
    ] : U = [["count"], ["desc"]], x.concat(
      i(C, U[0], U[1])
    ));
  }
  function v(B, D) {
    return B.renderingContent && B.renderingContent.facetOrdering && B.renderingContent.facetOrdering.values && B.renderingContent.facetOrdering.values[D];
  }
  p.prototype.getFacetValues = function(B, D) {
    var x = d(this, B);
    if (x) {
      var C = e(D, {
        sortBy: p.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(D && D.sortBy)
      }), O = this, T;
      if (Array.isArray(x))
        T = [B];
      else {
        var I = O._state.getHierarchicalFacetByName(x.name);
        T = I.attributes;
      }
      return f(
        function(G, U) {
          if (C.facetOrdering) {
            var N = v(O, U);
            if (N)
              return b(G, N);
          }
          if (Array.isArray(C.sortBy)) {
            var z = a(C.sortBy, p.DEFAULT_SORT);
            return i(G, z[0], z[1]);
          } else if (typeof C.sortBy == "function")
            return F(C.sortBy, G);
          throw new Error(
            "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function"
          );
        },
        x,
        T
      );
    }
  }, p.prototype.getFacetStats = function(B) {
    if (this._state.isConjunctiveFacet(B))
      return k(this.facets, B);
    if (this._state.isDisjunctiveFacet(B))
      return k(this.disjunctiveFacets, B);
  };
  function k(B, D) {
    var x = t(B, function(C) {
      return C.name === D;
    });
    return x && x.stats;
  }
  p.prototype.getRefinements = function() {
    var B = this._state, D = this, x = [];
    return Object.keys(B.facetsRefinements).forEach(function(C) {
      B.facetsRefinements[C].forEach(function(O) {
        x.push(
          E(B, "facet", C, O, D.facets)
        );
      });
    }), Object.keys(B.facetsExcludes).forEach(function(C) {
      B.facetsExcludes[C].forEach(function(O) {
        x.push(
          E(B, "exclude", C, O, D.facets)
        );
      });
    }), Object.keys(B.disjunctiveFacetsRefinements).forEach(function(C) {
      B.disjunctiveFacetsRefinements[C].forEach(function(O) {
        x.push(
          E(
            B,
            "disjunctive",
            C,
            O,
            D.disjunctiveFacets
          )
        );
      });
    }), Object.keys(B.hierarchicalFacetsRefinements).forEach(function(C) {
      B.hierarchicalFacetsRefinements[C].forEach(function(O) {
        x.push(
          S(
            B,
            C,
            O,
            D.hierarchicalFacets
          )
        );
      });
    }), Object.keys(B.numericRefinements).forEach(function(C) {
      var O = B.numericRefinements[C];
      Object.keys(O).forEach(function(T) {
        O[T].forEach(function(I) {
          x.push({
            type: "numeric",
            attributeName: C,
            name: I,
            numericValue: I,
            operator: T
          });
        });
      });
    }), B.tagRefinements.forEach(function(C) {
      x.push({ type: "tag", attributeName: "_tags", name: C });
    }), x;
  };
  function E(B, D, x, C, O) {
    var T = t(O, function(U) {
      return U.name === x;
    }), I = T && T.data && T.data[C] ? T.data[C] : 0, G = T && T.exhaustive || !1;
    return {
      type: D,
      attributeName: x,
      name: C,
      count: I,
      exhaustive: G
    };
  }
  function S(B, D, x, C) {
    var O = B.getHierarchicalFacetByName(D), T = B._getHierarchicalFacetSeparator(O), I = x.split(T), G = t(C, function(Y) {
      return Y.name === D;
    }), U = I.reduce(function(Y, K) {
      var $ = Y && t(Y.data, function(te) {
        return te.name === K;
      });
      return $ !== void 0 ? $ : Y;
    }, G), N = U && U.count || 0, z = U && U.exhaustive || !1, V = U && U.path || "";
    return {
      type: "hierarchical",
      attributeName: D,
      name: V,
      count: N,
      exhaustive: z
    };
  }
  return Gi = p, Gi;
}
var Zi, ad;
function Dv() {
  return ad || (ad = 1, Zi = function(e) {
    return e.reduce(function(r, t) {
      return r.concat(t);
    }, []);
  }), Zi;
}
var Xi, sd;
function Sv() {
  if (sd) return Xi;
  sd = 1;
  var o = Fa(), e = Dv();
  function r(n, a) {
    var s = [];
    return Object.keys(n).forEach(function(i) {
      n[i].count < 2 && (n[i].indexSum += 100), s.push({
        objectID: i,
        avgOfIndices: n[i].indexSum / a
      });
    }), s.sort(function(i, l) {
      return i.avgOfIndices > l.avgOfIndices ? 1 : -1;
    });
  }
  function t(n) {
    var a = {};
    n.forEach(function(l) {
      l.forEach(function(c, u) {
        a[c.objectID] ? a[c.objectID] = {
          indexSum: a[c.objectID].indexSum + u,
          count: a[c.objectID].count + 1
        } : a[c.objectID] = { indexSum: u, count: 1 };
      });
    });
    var s = r(a, n.length), i = s.reduce(
      function(l, c) {
        var u = o(e(n), function(m) {
          return m.objectID === c.objectID;
        });
        return u ? l.concat(u) : l;
      },
      []
    );
    return i;
  }
  return Xi = t, Xi;
}
var qi, id;
function Qy() {
  return id || (id = 1, qi = "3.24.1"), qi;
}
var Ui, ld;
function Ev() {
  if (ld) return Ui;
  ld = 1;
  var o = tu(), e = yv(), r = nu().escapeFacetValue, t = Gy(), n = au(), a = su(), s = iu(), i = Zy(), l = Xy(), c = fv(), u = qy(), m = Jy(), y = Sv(), g = Qy();
  function p(f, F, b, v) {
    typeof f.addAlgoliaAgent == "function" && f.addAlgoliaAgent("JS Helper (" + g + ")"), this.setClient(f);
    var k = b || {};
    k.index = F, this.state = u.make(k), this.recommendState = new i({
      params: k.recommendState
    }), this.lastResults = null, this.lastRecommendResults = null, this._queryId = 0, this._recommendQueryId = 0, this._lastQueryIdReceived = -1, this._lastRecommendQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0, this._currentNbRecommendQueries = 0, this._searchResultsOptions = v, this._recommendCache = {};
  }
  t(p, o), p.prototype.search = function() {
    return this._search({ onlyWithDerivedHelpers: !1 }), this;
  }, p.prototype.searchOnlyWithDerivedHelpers = function() {
    return this._search({ onlyWithDerivedHelpers: !0 }), this;
  }, p.prototype.searchWithComposition = function() {
    return this._runComposition({ onlyWithDerivedHelpers: !0 }), this;
  }, p.prototype.recommend = function() {
    return this._recommend(), this;
  }, p.prototype.getQuery = function() {
    var f = this.state;
    return c._getHitsSearchParams(f);
  }, p.prototype.searchOnce = function(f, F) {
    var b = f ? this.state.setQueryParameters(f) : this.state, v = c._getQueries(b.index, b), k = this;
    if (this._currentNbQueries++, this.emit("searchOnce", {
      state: b
    }), F) {
      this.client.search(v).then(function(E) {
        k._currentNbQueries--, k._currentNbQueries === 0 && k.emit("searchQueueEmpty"), F(null, new m(b, E.results), b);
      }).catch(function(E) {
        k._currentNbQueries--, k._currentNbQueries === 0 && k.emit("searchQueueEmpty"), F(E, null, b);
      });
      return;
    }
    return this.client.search(v).then(
      function(E) {
        return k._currentNbQueries--, k._currentNbQueries === 0 && k.emit("searchQueueEmpty"), {
          content: new m(b, E.results),
          state: b,
          _originalResponse: E
        };
      },
      function(E) {
        throw k._currentNbQueries--, k._currentNbQueries === 0 && k.emit("searchQueueEmpty"), E;
      }
    );
  }, p.prototype.findAnswers = function(f) {
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var F = this.state, b = this.derivedHelpers[0];
    if (!b)
      return Promise.resolve([]);
    var v = b.getModifiedState(F), k = n(
      {
        attributesForPrediction: f.attributesForPrediction,
        nbHits: f.nbHits
      },
      {
        params: s(c._getHitsSearchParams(v), [
          "attributesToSnippet",
          "hitsPerPage",
          "restrictSearchableAttributes",
          "snippetEllipsisText"
        ])
      }
    ), E = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex != "function")
      throw new Error(E);
    var S = this.client.initIndex(v.index);
    if (typeof S.findAnswers != "function")
      throw new Error(E);
    return S.findAnswers(v.query, f.queryLanguages, k);
  }, p.prototype.searchForFacetValues = function(f, F, b, v) {
    var k = typeof this.client.searchForFacetValues == "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets != "function", E = typeof this.client.initIndex == "function";
    if (!k && !E && typeof this.client.search != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues"
      );
    var S = this.state.setQueryParameters(v || {}), B = S.isDisjunctiveFacet(f), D = c.getSearchForFacetQuery(
      f,
      F,
      b,
      S
    );
    this._currentNbQueries++;
    var x = this, C;
    return k ? C = this.client.searchForFacetValues([
      { indexName: S.index, params: D }
    ]) : E ? C = this.client.initIndex(S.index).searchForFacetValues(D) : (delete D.facetName, C = this.client.search([
      {
        type: "facet",
        facet: f,
        indexName: S.index,
        params: D
      }
    ]).then(function(T) {
      return T.results[0];
    })), this.emit("searchForFacetValues", {
      state: S,
      facet: f,
      query: F
    }), C.then(
      function(T) {
        return x._currentNbQueries--, x._currentNbQueries === 0 && x.emit("searchQueueEmpty"), T = Array.isArray(T) ? T[0] : T, T.facetHits.forEach(function(I) {
          I.escapedValue = r(I.value), I.isRefined = B ? S.isDisjunctiveFacetRefined(f, I.escapedValue) : S.isFacetRefined(f, I.escapedValue);
        }), T;
      },
      function(O) {
        throw x._currentNbQueries--, x._currentNbQueries === 0 && x.emit("searchQueueEmpty"), O;
      }
    );
  }, p.prototype.searchForCompositionFacetValues = function(f, F, b, v) {
    if (typeof this.client.searchForFacetValues != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues"
      );
    var k = this.state.setQueryParameters(v || {}), E = k.isDisjunctiveFacet(f);
    this._currentNbQueries++;
    var S = this, B;
    return B = this.client.searchForFacetValues({
      compositionID: k.index,
      facetName: f,
      searchForFacetValuesRequest: {
        params: {
          query: F,
          maxFacetHits: b,
          searchQuery: c._getCompositionHitsSearchParams(k)
        }
      }
    }), this.emit("searchForFacetValues", {
      state: k,
      facet: f,
      query: F
    }), B.then(
      function(x) {
        return S._currentNbQueries--, S._currentNbQueries === 0 && S.emit("searchQueueEmpty"), x = x.results[0], x.facetHits.forEach(function(C) {
          C.escapedValue = r(C.value), C.isRefined = E ? k.isDisjunctiveFacetRefined(f, C.escapedValue) : k.isFacetRefined(f, C.escapedValue);
        }), x;
      },
      function(D) {
        throw S._currentNbQueries--, S._currentNbQueries === 0 && S.emit("searchQueueEmpty"), D;
      }
    );
  }, p.prototype.setQuery = function(f) {
    return this._change({
      state: this.state.resetPage().setQuery(f),
      isPageReset: !0
    }), this;
  }, p.prototype.clearRefinements = function(f) {
    return this._change({
      state: this.state.resetPage().clearRefinements(f),
      isPageReset: !0
    }), this;
  }, p.prototype.clearTags = function() {
    return this._change({
      state: this.state.resetPage().clearTags(),
      isPageReset: !0
    }), this;
  }, p.prototype.addDisjunctiveFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().addDisjunctiveFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
  }, p.prototype.addHierarchicalFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().addHierarchicalFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addNumericRefinement = function(f, F, b) {
    return this._change({
      state: this.state.resetPage().addNumericRefinement(f, F, b),
      isPageReset: !0
    }), this;
  }, p.prototype.addFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().addFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
  }, p.prototype.addFacetExclusion = function(f, F) {
    return this._change({
      state: this.state.resetPage().addExcludeRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
  }, p.prototype.addTag = function(f) {
    return this._change({
      state: this.state.resetPage().addTagRefinement(f),
      isPageReset: !0
    }), this;
  }, p.prototype.addFrequentlyBoughtTogether = function(f) {
    return this._recommendChange({
      state: this.recommendState.addFrequentlyBoughtTogether(f)
    }), this;
  }, p.prototype.addRelatedProducts = function(f) {
    return this._recommendChange({
      state: this.recommendState.addRelatedProducts(f)
    }), this;
  }, p.prototype.addTrendingItems = function(f) {
    return this._recommendChange({
      state: this.recommendState.addTrendingItems(f)
    }), this;
  }, p.prototype.addTrendingFacets = function(f) {
    return this._recommendChange({
      state: this.recommendState.addTrendingFacets(f)
    }), this;
  }, p.prototype.addLookingSimilar = function(f) {
    return this._recommendChange({
      state: this.recommendState.addLookingSimilar(f)
    }), this;
  }, p.prototype.removeNumericRefinement = function(f, F, b) {
    return this._change({
      state: this.state.resetPage().removeNumericRefinement(f, F, b),
      isPageReset: !0
    }), this;
  }, p.prototype.removeDisjunctiveFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().removeDisjunctiveFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
  }, p.prototype.removeHierarchicalFacetRefinement = function(f) {
    return this._change({
      state: this.state.resetPage().removeHierarchicalFacetRefinement(f),
      isPageReset: !0
    }), this;
  }, p.prototype.removeFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().removeFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
  }, p.prototype.removeFacetExclusion = function(f, F) {
    return this._change({
      state: this.state.resetPage().removeExcludeRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
  }, p.prototype.removeTag = function(f) {
    return this._change({
      state: this.state.resetPage().removeTagRefinement(f),
      isPageReset: !0
    }), this;
  }, p.prototype.removeFrequentlyBoughtTogether = function(f) {
    return this._recommendChange({
      state: this.recommendState.removeParams(f)
    }), this;
  }, p.prototype.removeRelatedProducts = function(f) {
    return this._recommendChange({
      state: this.recommendState.removeParams(f)
    }), this;
  }, p.prototype.removeTrendingItems = function(f) {
    return this._recommendChange({
      state: this.recommendState.removeParams(f)
    }), this;
  }, p.prototype.removeTrendingFacets = function(f) {
    return this._recommendChange({
      state: this.recommendState.removeParams(f)
    }), this;
  }, p.prototype.removeLookingSimilar = function(f) {
    return this._recommendChange({
      state: this.recommendState.removeParams(f)
    }), this;
  }, p.prototype.toggleFacetExclusion = function(f, F) {
    return this._change({
      state: this.state.resetPage().toggleExcludeFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
  }, p.prototype.toggleRefinement = function(f, F) {
    return this.toggleFacetRefinement(f, F);
  }, p.prototype.toggleFacetRefinement = function(f, F) {
    return this._change({
      state: this.state.resetPage().toggleFacetRefinement(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
  }, p.prototype.toggleTag = function(f) {
    return this._change({
      state: this.state.resetPage().toggleTagRefinement(f),
      isPageReset: !0
    }), this;
  }, p.prototype.nextPage = function() {
    var f = this.state.page || 0;
    return this.setPage(f + 1);
  }, p.prototype.previousPage = function() {
    var f = this.state.page || 0;
    return this.setPage(f - 1);
  };
  function d(f) {
    if (f < 0) throw new Error("Page requested below 0.");
    return this._change({
      state: this.state.setPage(f),
      isPageReset: !1
    }), this;
  }
  p.prototype.setCurrentPage = d, p.prototype.setPage = d, p.prototype.setIndex = function(f) {
    return this._change({
      state: this.state.resetPage().setIndex(f),
      isPageReset: !0
    }), this;
  }, p.prototype.setQueryParameter = function(f, F) {
    return this._change({
      state: this.state.resetPage().setQueryParameter(f, F),
      isPageReset: !0
    }), this;
  }, p.prototype.setState = function(f) {
    return this._change({
      state: u.make(f),
      isPageReset: !1
    }), this;
  }, p.prototype.overrideStateWithoutTriggeringChangeEvent = function(f) {
    return this.state = new u(f), this;
  }, p.prototype.hasRefinements = function(f) {
    return a(this.state.getNumericRefinements(f)) ? !0 : this.state.isConjunctiveFacet(f) ? this.state.isFacetRefined(f) : this.state.isDisjunctiveFacet(f) ? this.state.isDisjunctiveFacetRefined(f) : this.state.isHierarchicalFacet(f) ? this.state.isHierarchicalFacetRefined(f) : !1;
  }, p.prototype.isExcluded = function(f, F) {
    return this.state.isExcludeRefined(f, F);
  }, p.prototype.isDisjunctiveRefined = function(f, F) {
    return this.state.isDisjunctiveFacetRefined(f, F);
  }, p.prototype.hasTag = function(f) {
    return this.state.isTagRefined(f);
  }, p.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
  }, p.prototype.getIndex = function() {
    return this.state.index;
  };
  function h() {
    return this.state.page;
  }
  return p.prototype.getCurrentPage = h, p.prototype.getPage = h, p.prototype.getTags = function() {
    return this.state.tagRefinements;
  }, p.prototype.getRefinements = function(f) {
    var F = [];
    if (this.state.isConjunctiveFacet(f)) {
      var b = this.state.getConjunctiveRefinements(f);
      b.forEach(function(S) {
        F.push({
          value: S,
          type: "conjunctive"
        });
      });
      var v = this.state.getExcludeRefinements(f);
      v.forEach(function(S) {
        F.push({
          value: S,
          type: "exclude"
        });
      });
    } else if (this.state.isDisjunctiveFacet(f)) {
      var k = this.state.getDisjunctiveRefinements(f);
      k.forEach(function(S) {
        F.push({
          value: S,
          type: "disjunctive"
        });
      });
    }
    var E = this.state.getNumericRefinements(f);
    return Object.keys(E).forEach(function(S) {
      var B = E[S];
      F.push({
        value: B,
        operator: S,
        type: "numeric"
      });
    }), F;
  }, p.prototype.getNumericRefinement = function(f, F) {
    return this.state.getNumericRefinement(f, F);
  }, p.prototype.getHierarchicalFacetBreadcrumb = function(f) {
    return this.state.getHierarchicalFacetBreadcrumb(f);
  }, p.prototype._search = function(f) {
    var F = this.state, b = [], v = [];
    f.onlyWithDerivedHelpers || (v = c._getQueries(F.index, F), b.push({
      state: F,
      queriesCount: v.length,
      helper: this
    }), this.emit("search", {
      state: F,
      results: this.lastResults
    }));
    var k = this.derivedHelpers.map(function(B) {
      var D = B.getModifiedState(F), x = D.index ? c._getQueries(D.index, D) : [];
      return b.push({
        state: D,
        queriesCount: x.length,
        helper: B
      }), B.emit("search", {
        state: D,
        results: B.lastResults
      }), x;
    }), E = Array.prototype.concat.apply(v, k), S = this._queryId++;
    if (this._currentNbQueries++, !E.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, b, S)
      );
    try {
      this.client.search(E).then(this._dispatchAlgoliaResponse.bind(this, b, S)).catch(this._dispatchAlgoliaError.bind(this, S));
    } catch (B) {
      this.emit("error", {
        error: B
      });
    }
  }, p.prototype._runComposition = function() {
    var f = this.state, F = [], b = [], v = this.derivedHelpers.map(function(B) {
      var D = B.getModifiedState(f), x = c._getCompositionQueries(D);
      return F.push({
        state: D,
        queriesCount: x.length,
        helper: B
      }), B.emit("search", {
        state: D,
        results: B.lastResults
      }), x;
    }), k = Array.prototype.concat.apply(b, v), E = this._queryId++;
    if (this._currentNbQueries++, !k.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, F, E)
      );
    if (k.length > 1)
      throw new Error("Only one query is allowed when using a composition.");
    var S = k[0];
    try {
      this.client.search(S).then(this._dispatchAlgoliaResponse.bind(this, F, E)).catch(this._dispatchAlgoliaError.bind(this, E));
    } catch (B) {
      this.emit("error", {
        error: B
      });
    }
  }, p.prototype._recommend = function() {
    var f = this.state, F = this.recommendState, b = this.getIndex(), v = [{ state: F, index: b, helper: this }], k = F.params.map(function(x) {
      return x.$$id;
    });
    this.emit("fetch", {
      recommend: {
        state: F,
        results: this.lastRecommendResults
      }
    });
    var E = this._recommendCache, S = this.derivedHelpers.map(function(x) {
      var C = x.getModifiedState(f).index;
      if (!C)
        return [];
      var O = x.getModifiedRecommendState(
        new i()
      );
      return v.push({
        state: O,
        index: C,
        helper: x
      }), k = Array.prototype.concat.apply(
        k,
        O.params.map(function(T) {
          return T.$$id;
        })
      ), x.emit("fetch", {
        recommend: {
          state: O,
          results: x.lastRecommendResults
        }
      }), O._buildQueries(C, E);
    }), B = Array.prototype.concat.apply(
      this.recommendState._buildQueries(b, E),
      S
    );
    if (B.length !== 0) {
      if (B.length > 0 && typeof this.client.getRecommendations > "u") {
        console.warn(
          "Please update algoliasearch/lite to the latest version in order to use recommend widgets."
        );
        return;
      }
      var D = this._recommendQueryId++;
      this._currentNbRecommendQueries++;
      try {
        this.client.getRecommendations(B).then(this._dispatchRecommendResponse.bind(this, D, v, k)).catch(this._dispatchRecommendError.bind(this, D));
      } catch (x) {
        this.emit("error", {
          error: x
        });
      }
    }
  }, p.prototype._dispatchAlgoliaResponse = function(f, F, b) {
    var v = this;
    if (!(F < this._lastQueryIdReceived)) {
      this._currentNbQueries -= F - this._lastQueryIdReceived, this._lastQueryIdReceived = F, this._currentNbQueries === 0 && this.emit("searchQueueEmpty");
      var k = b.results.slice(), E = Object.keys(b).reduce(function(S, B) {
        return B !== "results" && (S[B] = b[B]), S;
      }, {});
      Object.keys(E).length <= 0 && (E = void 0), f.forEach(function(S) {
        var B = S.state, D = S.queriesCount, x = S.helper, C = k.splice(0, D);
        if (!B.index) {
          x.emit("result", {
            results: null,
            state: B
          });
          return;
        }
        x.lastResults = new m(
          B,
          C,
          v._searchResultsOptions
        ), E !== void 0 && (x.lastResults._rawContent = E), x.emit("result", {
          results: x.lastResults,
          state: B
        });
      });
    }
  }, p.prototype._dispatchRecommendResponse = function(f, F, b, v) {
    if (!(f < this._lastRecommendQueryIdReceived)) {
      this._currentNbRecommendQueries -= f - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = f, this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty");
      var k = this._recommendCache, E = {};
      b.filter(function(B) {
        return k[B] === void 0;
      }).forEach(function(B, D) {
        E[B] || (E[B] = []), E[B].push(D);
      }), Object.keys(E).forEach(function(B) {
        var D = E[B], x = v.results[D[0]];
        if (D.length === 1) {
          k[B] = x;
          return;
        }
        k[B] = Object.assign({}, x, {
          hits: y(
            D.map(function(C) {
              return v.results[C].hits;
            })
          )
        });
      });
      var S = {};
      b.forEach(function(B) {
        S[B] = k[B];
      }), F.forEach(function(B) {
        var D = B.state, x = B.helper;
        if (!B.index) {
          x.emit("recommend:result", {
            results: null,
            state: D
          });
          return;
        }
        x.lastRecommendResults = new l(D, S), x.emit("recommend:result", {
          recommend: {
            results: x.lastRecommendResults,
            state: D
          }
        });
      });
    }
  }, p.prototype._dispatchAlgoliaError = function(f, F) {
    f < this._lastQueryIdReceived || (this._currentNbQueries -= f - this._lastQueryIdReceived, this._lastQueryIdReceived = f, this.emit("error", {
      error: F
    }), this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
  }, p.prototype._dispatchRecommendError = function(f, F) {
    f < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= f - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = f, this.emit("error", {
      error: F
    }), this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty"));
  }, p.prototype.containsRefinement = function(f, F, b, v) {
    return f || F.length !== 0 || b.length !== 0 || v.length !== 0;
  }, p.prototype._hasDisjunctiveRefinements = function(f) {
    return this.state.disjunctiveRefinements[f] && this.state.disjunctiveRefinements[f].length > 0;
  }, p.prototype._change = function(f) {
    var F = f.state, b = f.isPageReset;
    F !== this.state && (this.state = F, this.emit("change", {
      state: this.state,
      results: this.lastResults,
      isPageReset: b
    }));
  }, p.prototype._recommendChange = function(f) {
    var F = f.state;
    F !== this.recommendState && (this.recommendState = F, this.emit("recommend:change", {
      search: {
        results: this.lastResults,
        state: this.state
      },
      recommend: {
        results: this.lastRecommendResults,
        state: this.recommendState
      }
    }));
  }, p.prototype.clearCache = function() {
    return this.client.clearCache && this.client.clearCache(), this;
  }, p.prototype.setClient = function(f) {
    return this.client === f ? this : (typeof f.addAlgoliaAgent == "function" && f.addAlgoliaAgent("JS Helper (" + g + ")"), this.client = f, this);
  }, p.prototype.getClient = function() {
    return this.client;
  }, p.prototype.derive = function(f, F) {
    var b = new e(this, f, F);
    return this.derivedHelpers.push(b), b;
  }, p.prototype.detachDerivedHelper = function(f) {
    var F = this.derivedHelpers.indexOf(f);
    if (F === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(F, 1);
  }, p.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
  }, Ui = p, Ui;
}
var Yi, cd;
function xv() {
  if (cd) return Yi;
  cd = 1;
  var o = Ev(), e = Zy(), r = Xy(), t = qy(), n = Jy();
  function a(s, i, l, c) {
    return new o(s, i, l, c);
  }
  return a.version = Qy(), a.AlgoliaSearchHelper = o, a.SearchParameters = t, a.RecommendParameters = e, a.SearchResults = n, a.RecommendResults = r, Yi = a, Yi;
}
var Av = xv();
const $e = /* @__PURE__ */ Ct(Av);
function Pn(o) {
  "@babel/helpers - typeof";
  return Pn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pn(o);
}
function ud(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Xe(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ud(Object(r), !0).forEach(function(t) {
      Ky(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : ud(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ky(o, e, r) {
  return e = Cv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Cv(o) {
  var e = Ov(o, "string");
  return Pn(e) == "symbol" ? e : String(e);
}
function Ov(o, e) {
  if (Pn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Pn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Tv = xe({
  name: "configure",
  connector: !0
});
function pd(o, e) {
  return o.setQueryParameters(Object.keys(e.searchParameters).reduce(function(r, t) {
    return Xe(Xe({}, r), {}, Ky({}, t, void 0));
  }, {}));
}
var _y = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return function(t) {
    if (!t || !jy(t.searchParameters))
      throw new Error(Tv("The `searchParameters` option expects an object."));
    var n = {};
    function a(s) {
      return function(i) {
        var l = pd(s.state, t), c = $t(l, new $e.SearchParameters(i));
        t.searchParameters = i, s.setState(c).search();
      };
    }
    return {
      $$type: "ais.configure",
      init: function(i) {
        var l = i.instantSearchInstance;
        e(Xe(Xe({}, this.getWidgetRenderState(i)), {}, {
          instantSearchInstance: l
        }), !0);
      },
      render: function(i) {
        var l = i.instantSearchInstance;
        e(Xe(Xe({}, this.getWidgetRenderState(i)), {}, {
          instantSearchInstance: l
        }), !1);
      },
      dispose: function(i) {
        var l = i.state;
        return r(), pd(l, t);
      },
      getRenderState: function(i, l) {
        var c, u = this.getWidgetRenderState(l);
        return Xe(Xe({}, i), {}, {
          configure: Xe(Xe({}, u), {}, {
            widgetParams: Xe(Xe({}, u.widgetParams), {}, {
              searchParameters: $t(new $e.SearchParameters((c = i.configure) === null || c === void 0 ? void 0 : c.widgetParams.searchParameters), new $e.SearchParameters(u.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function(i) {
        var l = i.helper;
        return n.refine || (n.refine = a(l)), {
          refine: n.refine,
          widgetParams: t
        };
      },
      getWidgetSearchParameters: function(i, l) {
        var c = l.uiState;
        return $t(i, new $e.SearchParameters(Xe(Xe({}, c.configure), t.searchParameters)));
      },
      getWidgetUiState: function(i) {
        return Xe(Xe({}, i), {}, {
          configure: Xe(Xe({}, i.configure), t.searchParameters)
        });
      }
    };
  };
};
function Bn(o) {
  "@babel/helpers - typeof";
  return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bn(o);
}
function dd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ji(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? dd(Object(r), !0).forEach(function(t) {
      jv(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : dd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function jv(o, e, r) {
  return e = Mv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Mv(o) {
  var e = zv(o, "string");
  return Bn(e) == "symbol" ? e : String(e);
}
function zv(o, e) {
  if (Bn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Bn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function gd(o) {
  return Lv(o) || Rv(o) || Iv(o) || Nv();
}
function Nv() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Iv(o, e) {
  if (o) {
    if (typeof o == "string") return ec(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ec(o, e);
  }
}
function Rv(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function Lv(o) {
  if (Array.isArray(o)) return ec(o);
}
function ec(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var md = xe({
  name: "configure-related-items",
  connector: !0
});
function yd(o) {
  var e = o.attributeName, r = o.attributeValue, t = o.attributeScore;
  return "".concat(e, ":").concat(r, "<score=").concat(t || 1, ">");
}
var Hv = function(e, r) {
  return function(t) {
    var n = t || {}, a = n.hit, s = n.matchingPatterns, i = n.transformSearchParameters, l = i === void 0 ? function(y) {
      return y;
    } : i;
    if (!a)
      throw new Error(md("The `hit` option is required."));
    if (!s)
      throw new Error(md("The `matchingPatterns` option is required."));
    var c = Object.keys(s).reduce(function(y, g) {
      var p = s[g], d = At(a, g), h = p.score;
      return Array.isArray(d) ? [].concat(gd(y), [d.map(function(f) {
        return yd({
          attributeName: g,
          attributeValue: f,
          attributeScore: h
        });
      })]) : typeof d == "string" ? [].concat(gd(y), [yd({
        attributeName: g,
        attributeValue: d,
        attributeScore: h
      })]) : (process.env.NODE_ENV === "development" && ue(!1, "\nThe `matchingPatterns` option returned a value of type ".concat(Ay(d), ' for the "').concat(g, '" key. This value was not sent to Algolia because `optionalFilters` only supports strings and array of strings.\n\nYou can remove the "').concat(g, `" key from the \`matchingPatterns\` option.

See https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/
            `)), y);
    }, []), u = Ji({}, l(new $e.SearchParameters({
      sumOrFiltersScores: !0,
      facetFilters: ["objectID:-".concat(a.objectID)],
      optionalFilters: c
    }))), m = _y(e, r);
    return Ji(Ji({}, m({
      searchParameters: u
    })), {}, {
      $$type: "ais.configureRelatedItems"
    });
  };
};
function fd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function nt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fd(Object(r), !0).forEach(function(t) {
      Wv(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : fd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Wv(o, e, r) {
  return e = Vv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Vv(o) {
  var e = Gv(o, "string");
  return Pt(e) == "symbol" ? e : String(e);
}
function Gv(o, e) {
  if (Pt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Pt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Pt(o) {
  "@babel/helpers - typeof";
  return Pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pt(o);
}
var za = xe({
  name: "dynamic-widgets",
  connector: !0
}), hd = 20, $y = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, za()), function(t) {
    var n = t.widgets, a = t.maxValuesPerFacet, s = a === void 0 ? 20 : a, i = t.facets, l = i === void 0 ? ["*"] : i, c = t.transformItems, u = c === void 0 ? function(g) {
      return g;
    } : c, m = t.fallbackWidget;
    if (!(n && Array.isArray(n) && n.every(function(g) {
      return Pt(g) === "object";
    })))
      throw new Error(za("The `widgets` option expects an array of widgets."));
    if (!Array.isArray(l))
      throw new Error(za("The `facets` option only accepts an array of facets, you passed ".concat(JSON.stringify(l))));
    var y = /* @__PURE__ */ new Map();
    return {
      $$type: "ais.dynamicWidgets",
      init: function(p) {
        n.forEach(function(d) {
          var h = F2(d, p);
          y.set(h, {
            widget: d,
            isMounted: !1
          });
        }), e(nt(nt({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !0);
      },
      render: function(p) {
        var d = p.parent, h = this.getWidgetRenderState(p), f = [], F = [];
        m && h.attributesToRender.forEach(function(b) {
          if (!y.has(b)) {
            var v = m({
              attribute: b
            });
            y.set(b, {
              widget: v,
              isMounted: !1
            });
          }
        }), y.forEach(function(b, v) {
          var k = b.widget, E = b.isMounted, S = h.attributesToRender.indexOf(v) > -1;
          !E && S ? (F.push(k), y.set(v, {
            widget: k,
            isMounted: !0
          })) : E && !S && (f.push(k), y.set(v, {
            widget: k,
            isMounted: !1
          }));
        }), d.addWidgets(F), setTimeout(function() {
          return d.removeWidgets(f);
        }, 0), e(nt(nt({}, h), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !1);
      },
      dispose: function(p) {
        var d = p.parent, h = [];
        y.forEach(function(f) {
          var F = f.widget, b = f.isMounted;
          b && h.push(F);
        }), d.removeWidgets(h), r();
      },
      getWidgetSearchParameters: function(p) {
        return l.reduce(function(d, h) {
          return d.addFacet(h);
        }, p.setQueryParameters({
          maxValuesPerFacet: Math.max(s || 0, p.maxValuesPerFacet || 0)
        }));
      },
      getRenderState: function(p, d) {
        return nt(nt({}, p), {}, {
          dynamicWidgets: this.getWidgetRenderState(d)
        });
      },
      getWidgetRenderState: function(p) {
        var d, h, f, F, b = p.results, v = p.state;
        if (!b)
          return {
            attributesToRender: [],
            widgetParams: t
          };
        var k = u((d = (h = b.renderingContent) === null || h === void 0 || (f = h.facetOrdering) === null || f === void 0 || (F = f.facets) === null || F === void 0 ? void 0 : F.order) !== null && d !== void 0 ? d : [], {
          results: b
        });
        if (!Array.isArray(k))
          throw new Error(za("The `transformItems` option expects a function that returns an Array."));
        return process.env.NODE_ENV === "development" && ue(s >= (v.maxValuesPerFacet || 0), "The maxValuesPerFacet set by dynamic widgets (".concat(s, ") is smaller than one of the limits set by a widget (").concat(v.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")), process.env.NODE_ENV === "development" && ue(k.length <= hd || t.facets !== void 0, "More than ".concat(hd, ` facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set "facets" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.`)), {
          attributesToRender: k,
          widgetParams: t
        };
      }
    };
  };
};
function kn(o) {
  "@babel/helpers - typeof";
  return kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, kn(o);
}
function Zv(o) {
  return Yv(o) || Uv(o) || qv(o) || Xv();
}
function Xv() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qv(o, e) {
  if (o) {
    if (typeof o == "string") return oc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oc(o, e);
  }
}
function Uv(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function Yv(o) {
  if (Array.isArray(o)) return oc(o);
}
function oc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Fd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function at(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fd(Object(r), !0).forEach(function(t) {
      Jv(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Fd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Jv(o, e, r) {
  return e = Qv(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Qv(o) {
  var e = Kv(o, "string");
  return kn(e) == "symbol" ? e : String(e);
}
function Kv(o, e) {
  if (kn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (kn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var bd = xe({
  name: "clear-refinements",
  connector: !0
}), _v = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, bd()), function(t) {
    var n = t || {}, a = n.includedAttributes, s = a === void 0 ? [] : a, i = n.excludedAttributes, l = i === void 0 ? ["query"] : i, c = n.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    if (t && t.includedAttributes && t.excludedAttributes)
      throw new Error(bd("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var m = {
      refine: fe,
      createURL: function() {
        return "";
      },
      attributesToClear: []
    }, y = function() {
      return m.refine();
    }, g = function() {
      return m.createURL();
    };
    return {
      $$type: "ais.clearRefinements",
      init: function(d) {
        var h = d.instantSearchInstance;
        e(at(at({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: h
        }), !0);
      },
      render: function(d) {
        var h = d.instantSearchInstance;
        e(at(at({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: h
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(d, h) {
        return at(at({}, d), {}, {
          clearRefinements: this.getWidgetRenderState(h)
        });
      },
      getWidgetRenderState: function(d) {
        var h = d.createURL, f = d.scopedResults, F = d.results;
        m.attributesToClear = f.reduce(function(v, k) {
          return v.concat($v({
            scopedResult: k,
            includedAttributes: s,
            excludedAttributes: l,
            transformItems: u,
            results: F
          }));
        }, []), m.refine = function() {
          m.attributesToClear.forEach(function(v) {
            var k = v.helper, E = v.items;
            k.setState(mp({
              helper: k,
              attributesToClear: E
            })).search();
          });
        }, m.createURL = function() {
          return h($t.apply(void 0, Zv(m.attributesToClear.map(function(v) {
            var k = v.helper, E = v.items;
            return mp({
              helper: k,
              attributesToClear: E
            });
          }))));
        };
        var b = m.attributesToClear.some(function(v) {
          return v.items.length > 0;
        });
        return {
          canRefine: b,
          hasRefinements: b,
          refine: y,
          createURL: g,
          widgetParams: t
        };
      }
    };
  };
};
function $v(o) {
  var e = o.scopedResult, r = o.includedAttributes, t = o.excludedAttributes, n = o.transformItems, a = o.results, s = r.indexOf("query") !== -1 || t.indexOf("query") === -1;
  return {
    helper: e.helper,
    items: n(ru($c(e.results, e.helper.state, s).map(function(i) {
      return i.attribute;
    }).filter(function(i) {
      return (
        // If the array is empty (default case), we keep all the attributes
        r.length === 0 || // Otherwise, only add the specified attributes
        r.indexOf(i) !== -1
      );
    }).filter(function(i) {
      return (
        // If the query is included, we ignore the default `excludedAttributes = ['query']`
        i === "query" && s || // Otherwise, ignore the excluded attributes
        t.indexOf(i) === -1
      );
    })), {
      results: a
    })
  };
}
function wn(o) {
  "@babel/helpers - typeof";
  return wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wn(o);
}
function e3(o) {
  return n3(o) || t3(o) || r3(o) || o3();
}
function o3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function r3(o, e) {
  if (o) {
    if (typeof o == "string") return rc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return rc(o, e);
  }
}
function t3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function n3(o) {
  if (Array.isArray(o)) return rc(o);
}
function rc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function vd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function st(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vd(Object(r), !0).forEach(function(t) {
      a3(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : vd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function a3(o, e, r) {
  return e = s3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function s3(o) {
  var e = i3(o, "string");
  return wn(e) == "symbol" ? e : String(e);
}
function i3(o, e) {
  if (wn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (wn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Pd = xe({
  name: "current-refinements",
  connector: !0
}), l3 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Pd()), function(t) {
    if ((t || {}).includedAttributes && (t || {}).excludedAttributes)
      throw new Error(Pd("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var n = t || {}, a = n.includedAttributes, s = n.excludedAttributes, i = s === void 0 ? ["query"] : s, l = n.transformItems, c = l === void 0 ? function(u) {
      return u;
    } : l;
    return {
      $$type: "ais.currentRefinements",
      init: function(m) {
        var y = m.instantSearchInstance;
        e(st(st({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !0);
      },
      render: function(m) {
        var y = m.instantSearchInstance;
        e(st(st({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(m, y) {
        return st(st({}, m), {}, {
          currentRefinements: this.getWidgetRenderState(y)
        });
      },
      getWidgetRenderState: function(m) {
        var y = m.results, g = m.scopedResults, p = m.createURL, d = m.helper;
        function h() {
          return y ? g.reduce(function(F, b) {
            return F.concat(c(Bd({
              results: b.results,
              helper: b.helper,
              indexId: b.indexId,
              includedAttributes: a,
              excludedAttributes: i
            }), {
              results: y
            }));
          }, []) : c(Bd({
            results: null,
            helper: d,
            indexId: d.state.index,
            includedAttributes: a,
            excludedAttributes: i
          }), {
            results: y
          });
        }
        var f = h();
        return {
          items: f,
          canRefine: f.length > 0,
          refine: function(b) {
            return of(d, b);
          },
          createURL: function(b) {
            return p(ef(d.state, b));
          },
          widgetParams: t
        };
      }
    };
  };
};
function Bd(o) {
  var e = o.results, r = o.helper, t = o.indexId, n = o.includedAttributes, a = o.excludedAttributes, s = (n || []).indexOf("query") !== -1 || (a || []).indexOf("query") === -1, i = n ? function(c) {
    return n.indexOf(c.attribute) !== -1;
  } : function(c) {
    return a.indexOf(c.attribute) === -1;
  }, l = $c(e, r.state, s).map(u3).filter(i);
  return l.reduce(function(c, u) {
    return [].concat(e3(c.filter(function(m) {
      return m.attribute !== u.attribute;
    })), [{
      indexName: r.state.index,
      indexId: t,
      attribute: u.attribute,
      label: u.attribute,
      refinements: l.filter(function(m) {
        return m.attribute === u.attribute;
      }).sort(function(m, y) {
        return m.type === "numeric" ? m.value - y.value : 0;
      }),
      refine: function(y) {
        return of(r, y);
      }
    }]);
  }, []);
}
function ef(o, e) {
  switch (o = o.resetPage(), e.type) {
    case "facet":
      return o.removeFacetRefinement(e.attribute, String(e.value));
    case "disjunctive":
      return o.removeDisjunctiveFacetRefinement(e.attribute, String(e.value));
    case "hierarchical":
      return o.removeHierarchicalFacetRefinement(e.attribute);
    case "exclude":
      return o.removeExcludeRefinement(e.attribute, String(e.value));
    case "numeric":
      return o.removeNumericRefinement(e.attribute, e.operator, String(e.value));
    case "tag":
      return o.removeTagRefinement(String(e.value));
    case "query":
      return o.setQueryParameter("query", "");
    default:
      return process.env.NODE_ENV === "development" && ue(!1, 'The refinement type "'.concat(e.type, '" does not exist and cannot be cleared from the current refinements.')), o;
  }
}
function of(o, e) {
  o.setState(ef(o.state, e)).search();
}
function c3(o) {
  switch (o) {
    case ">=":
      return "≥";
    case "<=":
      return "≤";
    default:
      return o;
  }
}
function u3(o) {
  var e = p3(o), r = o.operator ? "".concat(c3(o.operator), " ").concat(o.name) : o.name, t = {
    attribute: o.attribute,
    type: o.type,
    value: e,
    label: r
  };
  return o.operator !== void 0 && (t.operator = o.operator), o.count !== void 0 && (t.count = o.count), o.exhaustive !== void 0 && (t.exhaustive = o.exhaustive), t;
}
function p3(o) {
  return o.type === "numeric" ? Number(o.name) : "escapedValue" in o ? o.escapedValue : o.name;
}
function Dn(o) {
  "@babel/helpers - typeof";
  return Dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dn(o);
}
var d3 = ["name", "escapedValue", "data", "path"];
function kd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Qe(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kd(Object(r), !0).forEach(function(t) {
      _a(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : kd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function _a(o, e, r) {
  return e = g3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function g3(o) {
  var e = m3(o, "string");
  return Dn(e) == "symbol" ? e : String(e);
}
function m3(o, e) {
  if (Dn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Dn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function y3(o, e) {
  if (o == null) return {};
  var r = f3(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function f3(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function h3(o, e) {
  return P3(o) || v3(o, e) || b3(o, e) || F3();
}
function F3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b3(o, e) {
  if (o) {
    if (typeof o == "string") return wd(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wd(o, e);
  }
}
function wd(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function v3(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function P3(o) {
  if (Array.isArray(o)) return o;
}
var Qi = xe({
  name: "hierarchical-menu",
  connector: !0
}), Dd = ["name:asc"], B3 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Qi()), function(t) {
    var n = t || {}, a = n.attributes, s = n.separator, i = s === void 0 ? " > " : s, l = n.rootPath, c = l === void 0 ? null : l, u = n.showParentLevel, m = u === void 0 ? !0 : u, y = n.limit, g = y === void 0 ? 10 : y, p = n.showMore, d = p === void 0 ? !1 : p, h = n.showMoreLimit, f = h === void 0 ? 20 : h, F = n.sortBy, b = F === void 0 ? Dd : F, v = n.transformItems, k = v === void 0 ? function(U) {
      return U;
    } : v;
    if (!a || !Array.isArray(a) || a.length === 0)
      throw new Error(Qi("The `attributes` option expects an array of strings."));
    if (d === !0 && f <= g)
      throw new Error(Qi("The `showMoreLimit` option must be greater than `limit`."));
    var E = h3(a, 1), S = E[0], B, D = function() {
    };
    function x() {
      D();
    }
    var C, O = !1;
    function T(U, N) {
      return function() {
        O = !O, N.render(U);
      };
    }
    function I() {
      return O ? f : g;
    }
    function G(U) {
      return U.slice(0, I()).map(function(N) {
        var z = N.name, V = N.escapedValue, Y = N.data;
        N.path;
        var K = y3(N, d3), $ = Qe(Qe({}, K), {}, {
          value: V,
          label: z,
          data: null
        });
        return Array.isArray(Y) && ($.data = G(Y)), $;
      });
    }
    return {
      $$type: "ais.hierarchicalMenu",
      init: function(N) {
        var z = N.instantSearchInstance;
        e(Qe(Qe({}, this.getWidgetRenderState(N)), {}, {
          instantSearchInstance: z
        }), !0);
      },
      render: function(N) {
        var z = N.instantSearchInstance;
        D = T(N, this), e(Qe(Qe({}, this.getWidgetRenderState(N)), {}, {
          instantSearchInstance: z
        }), !1);
      },
      dispose: function(N) {
        var z = N.state;
        return r(), z.removeHierarchicalFacet(S).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(N, z) {
        return Qe(Qe({}, N), {}, {
          hierarchicalMenu: Qe(Qe({}, N.hierarchicalMenu), {}, _a({}, S, this.getWidgetRenderState(z)))
        });
      },
      getWidgetRenderState: function(N) {
        var z = this, V = N.results, Y = N.state, K = N.createURL, $ = N.instantSearchInstance, te = N.helper, ge = [], X = !1, q = function(Ee) {
          return K(function(no) {
            return z.getWidgetUiState(no, {
              searchParameters: Y.resetPage().toggleFacetRefinement(S, Ee),
              helper: te
            });
          });
        };
        if (B || (B = Qc({
          instantSearchInstance: $,
          helper: te,
          attribute: function(Ee) {
            var no = Ee.split(i).length - 1;
            return a[no];
          },
          widgetType: this.$$type
        })), C || (C = function(Ee) {
          B("click:internal", Ee), te.toggleFacetRefinement(S, Ee).search();
        }), V) {
          var J = V.getFacetValues(S, {
            sortBy: b,
            facetOrdering: b === Dd
          }), ee = J && !Array.isArray(J) && J.data ? J.data : [], me = (Y.maxValuesPerFacet || 0) > I() ? ee.length <= I() : ee.length < I();
          X = d && (O || !me), ge = k(G(ee), {
            results: V
          });
        }
        return {
          items: ge,
          refine: C,
          canRefine: ge.length > 0,
          createURL: q,
          sendEvent: B,
          widgetParams: t,
          isShowingMore: O,
          toggleShowMore: x,
          canToggleShowMore: X
        };
      },
      getWidgetUiState: function(N, z) {
        var V = z.searchParameters, Y = V.getHierarchicalFacetBreadcrumb(S);
        return k3(Qe(Qe({}, N), {}, {
          hierarchicalMenu: Qe(Qe({}, N.hierarchicalMenu), {}, _a({}, S, Y))
        }), S);
      },
      getWidgetSearchParameters: function(N, z) {
        var V = z.uiState, Y = V.hierarchicalMenu && V.hierarchicalMenu[S];
        if (N.isConjunctiveFacet(S) || N.isDisjunctiveFacet(S))
          return process.env.NODE_ENV === "development" && ue(!1, 'HierarchicalMenu: Attribute "'.concat(S, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), N;
        if (N.isHierarchicalFacet(S)) {
          var K = N.getHierarchicalFacetByName(S);
          process.env.NODE_ENV === "development" && ue(Ur(K.attributes, a) && K.separator === i && K.rootPath === c, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var $ = N.removeHierarchicalFacet(S).addHierarchicalFacet({
          name: S,
          attributes: a,
          separator: i,
          rootPath: c,
          showParentLevel: m
        }), te = $.maxValuesPerFacet || 0, ge = Math.max(te, d ? f : g), X = $.setQueryParameter("maxValuesPerFacet", ge);
        return Y ? X.addHierarchicalFacetRefinement(S, Y.join(i)) : X.setQueryParameters({
          hierarchicalFacetsRefinements: Qe(Qe({}, X.hierarchicalFacetsRefinements), {}, _a({}, S, []))
        });
      }
    };
  };
};
function k3(o, e) {
  return o.hierarchicalMenu && ((!o.hierarchicalMenu[e] || o.hierarchicalMenu[e].length === 0) && delete o.hierarchicalMenu[e], Object.keys(o.hierarchicalMenu).length === 0 && delete o.hierarchicalMenu), o;
}
function Sn(o) {
  "@babel/helpers - typeof";
  return Sn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Sn(o);
}
function Sd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function gr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sd(Object(r), !0).forEach(function(t) {
      rf(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Sd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function rf(o, e, r) {
  return e = w3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function w3(o) {
  var e = D3(o, "string");
  return Sn(e) == "symbol" ? e : String(e);
}
function D3(o, e) {
  if (Sn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Sn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var S3 = xe({
  name: "hits",
  connector: !0
});
const E3 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, S3()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a, i = n.transformItems, l = i === void 0 ? function(m) {
      return m;
    } : i, c, u;
    return {
      $$type: "ais.hits",
      init: function(y) {
        e(gr(gr({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: y.instantSearchInstance
        }), !0);
      },
      render: function(y) {
        var g = this.getWidgetRenderState(y);
        e(gr(gr({}, g), {}, {
          instantSearchInstance: y.instantSearchInstance
        }), !1), g.sendEvent("view:internal", g.items);
      },
      getRenderState: function(y, g) {
        return gr(gr({}, y), {}, {
          hits: this.getWidgetRenderState(g)
        });
      },
      getWidgetRenderState: function(y) {
        var g, p, d, h = y.results, f = y.helper, F = y.instantSearchInstance;
        if (c || (c = Kc({
          instantSearchInstance: F,
          getIndex: function() {
            return f.getIndex();
          },
          widgetType: this.$$type
        })), u || (u = Ly({
          getIndex: function() {
            return f.getIndex();
          },
          widgetType: this.$$type,
          instantSearchInstance: F
        })), !h)
          return {
            hits: [],
            items: [],
            results: void 0,
            banner: void 0,
            sendEvent: c,
            bindEvent: u,
            widgetParams: t
          };
        s && h.hits.length > 0 && (h.hits = Vs(h.hits));
        var b = eu(h.hits, h.page, h.hitsPerPage), v = ou(b, h.queryID), k = l(v, {
          results: h
        }), E = (g = h.renderingContent) === null || g === void 0 || (p = g.widgets) === null || p === void 0 || (d = p.banners) === null || d === void 0 ? void 0 : d[0];
        return {
          hits: k,
          items: k,
          results: h,
          banner: E,
          sendEvent: c,
          bindEvent: u,
          widgetParams: t
        };
      },
      dispose: function(y) {
        var g = y.state;
        return r(), s ? g.setQueryParameters(Object.keys(Yo).reduce(function(p, d) {
          return gr(gr({}, p), {}, rf({}, d, void 0));
        }, {})) : g;
      },
      getWidgetSearchParameters: function(y, g) {
        return s ? y.setQueryParameters(Yo) : y;
      }
    };
  };
};
function En(o) {
  "@babel/helpers - typeof";
  return En = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, En(o);
}
function Ed(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Fs(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ed(Object(r), !0).forEach(function(t) {
      x3(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ed(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function x3(o, e, r) {
  return e = A3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function A3(o) {
  var e = C3(o, "string");
  return En(e) == "symbol" ? e : String(e);
}
function C3(o, e) {
  if (En(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (En(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var O3 = function(e, r) {
  return r.map(function(t) {
    var n = ir(e, function(a) {
      return a.objectID === t;
    });
    if (typeof n > "u")
      throw new Error('Could not find objectID "'.concat(t, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
    return n;
  });
}, T3 = function(e) {
  var r = ru(e.map(function(n) {
    return n.__queryID;
  }));
  if (r.length > 1)
    throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
  var t = r[0];
  if (typeof t != "string")
    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
  return t;
}, j3 = function(e) {
  return e.map(function(r) {
    return r.__position;
  });
}, M3 = function(e) {
  var r = e.method, t = e.results, n = e.hits, a = e.objectIDs, s = t.index, i = O3(n, a), l = T3(i);
  switch (r) {
    case "clickedObjectIDsAfterSearch": {
      var c = j3(i);
      return {
        index: s,
        queryID: l,
        objectIDs: a,
        positions: c
      };
    }
    case "convertedObjectIDsAfterSearch":
      return {
        index: s,
        queryID: l,
        objectIDs: a
      };
    default:
      throw new Error('Unsupported method passed to insights: "'.concat(r, '".'));
  }
}, z3 = function(e, r, t) {
  return function(n) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      s[i - 1] = arguments[i];
    var l = s[0];
    if (process.env.NODE_ENV === "development" && ue(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), !e) {
      var c = xe({
        name: "instantsearch"
      });
      throw new Error(c("The `insightsClient` option has not been provided to `instantsearch`."));
    }
    if (!Array.isArray(l.objectIDs))
      throw new TypeError("Expected `objectIDs` to be an array.");
    var u = M3({
      method: n,
      results: r,
      hits: t,
      objectIDs: l.objectIDs
    });
    e(n, Fs(Fs({}, u), l));
  };
};
function tf(o) {
  return function(e, r) {
    return o(function(t, n) {
      var a = t.results, s = t.hits, i = t.instantSearchInstance;
      if (a && s && i) {
        var l = z3(i.insightsClient, a, s);
        return e(Fs(Fs({}, t), {}, {
          insights: l
        }), n);
      }
      return e(t, n);
    }, r);
  };
}
function tc(o) {
  "@babel/helpers - typeof";
  return tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, tc(o);
}
function N3(o) {
  var e = o.method, r = o.payload;
  if (tc(r) !== "object")
    throw new Error("The insights helper expects the payload to be an object.");
  var t;
  try {
    t = Iy(r);
  } catch {
    throw new Error("Could not JSON serialize the payload object.");
  }
  return 'data-insights-method="'.concat(e, '" data-insights-payload="').concat(t, '"');
}
function nf(o, e) {
  return process.env.NODE_ENV === "development" && ue(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), N3({
    method: o,
    payload: e
  });
}
var I3 = tf(E3);
function xn(o) {
  "@babel/helpers - typeof";
  return xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xn(o);
}
function R3(o) {
  return V3(o) || W3(o) || H3(o) || L3();
}
function L3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H3(o, e) {
  if (o) {
    if (typeof o == "string") return nc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return nc(o, e);
  }
}
function W3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function V3(o) {
  if (Array.isArray(o)) return nc(o);
}
function nc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function xd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ho(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xd(Object(r), !0).forEach(function(t) {
      G3(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : xd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function G3(o, e, r) {
  return e = Z3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Z3(o) {
  var e = X3(o, "string");
  return xn(e) == "symbol" ? e : String(e);
}
function X3(o, e) {
  if (xn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (xn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Na = xe({
  name: "hits-per-page",
  connector: !0
}), q3 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Na()), function(t) {
    var n = t || {}, a = n.items, s = n.transformItems, i = s === void 0 ? function(g) {
      return g;
    } : s;
    if (!Array.isArray(a))
      throw new Error(Na("The `items` option expects an array of objects."));
    var l = a, c = l.filter(function(g) {
      return g.default === !0;
    });
    if (c.length === 0)
      throw new Error(Na("A default value must be specified in `items`."));
    if (c.length > 1)
      throw new Error(Na("More than one default value is specified in `items`."));
    var u = c[0], m = function(p) {
      var d = p.hitsPerPage;
      return l.map(function(h) {
        return Ho(Ho({}, h), {}, {
          isRefined: Number(h.value) === Number(d)
        });
      });
    }, y = {
      getRefine: function(p) {
        return function(d) {
          return !d && d !== 0 ? p.setQueryParameter("hitsPerPage", void 0).search() : p.setQueryParameter("hitsPerPage", d).search();
        };
      },
      createURLFactory: function(p) {
        var d = p.state, h = p.createURL, f = p.getWidgetUiState, F = p.helper;
        return function(b) {
          return h(function(v) {
            return f(v, {
              searchParameters: d.resetPage().setQueryParameter("hitsPerPage", !b && b !== 0 ? void 0 : b),
              helper: F
            });
          });
        };
      }
    };
    return {
      $$type: "ais.hitsPerPage",
      init: function(p) {
        var d = p.state, h = p.instantSearchInstance, f = l.some(function(F) {
          return Number(d.hitsPerPage) === Number(F.value);
        });
        f || (process.env.NODE_ENV === "development" && ue(d.hitsPerPage !== void 0, "\n`hitsPerPage` is not defined.\nThe option `hitsPerPage` needs to be set using the `configure` widget.\n\nLearn more: https://www.algolia.com/doc/api-reference/widgets/hits-per-page/js/\n            "), process.env.NODE_ENV === "development" && ue(!1, '\nThe `items` option of `hitsPerPage` does not contain the "hits per page" value coming from the state: '.concat(d.hitsPerPage, ".\n\nYou may want to add another entry to the `items` option with this value.")), l = [
          // The helper will convert the empty string to `undefined`.
          {
            value: "",
            label: ""
          }
        ].concat(R3(l))), e(Ho(Ho({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: h
        }), !0);
      },
      render: function(p) {
        var d = p.instantSearchInstance;
        e(Ho(Ho({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !1);
      },
      dispose: function(p) {
        var d = p.state;
        return r(), d.setQueryParameter("hitsPerPage", void 0);
      },
      getRenderState: function(p, d) {
        return Ho(Ho({}, p), {}, {
          hitsPerPage: this.getWidgetRenderState(d)
        });
      },
      getWidgetRenderState: function(p) {
        var d = p.state, h = p.results, f = p.createURL, F = p.helper, b = h ? h.nbHits > 0 : !1;
        return {
          items: i(m(d), {
            results: h
          }),
          refine: y.getRefine(F),
          createURL: y.createURLFactory({
            state: d,
            createURL: f,
            getWidgetUiState: this.getWidgetUiState,
            helper: F
          }),
          hasNoResults: !b,
          canRefine: b,
          widgetParams: t
        };
      },
      getWidgetUiState: function(p, d) {
        var h = d.searchParameters, f = h.hitsPerPage;
        return f === void 0 || f === u.value ? p : Ho(Ho({}, p), {}, {
          hitsPerPage: f
        });
      },
      getWidgetSearchParameters: function(p, d) {
        var h = d.uiState;
        return p.setQueryParameters({
          hitsPerPage: h.hitsPerPage || u.value
        });
      }
    };
  };
};
function An(o) {
  "@babel/helpers - typeof";
  return An = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, An(o);
}
var U3 = ["page"], Y3 = ["clickAnalytics", "userToken"];
function Ad(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Do(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ad(Object(r), !0).forEach(function(t) {
      af(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ad(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function af(o, e, r) {
  return e = J3(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function J3(o) {
  var e = Q3(o, "string");
  return An(e) == "symbol" ? e : String(e);
}
function Q3(o, e) {
  if (An(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (An(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Cd(o) {
  return eP(o) || $3(o) || _3(o) || K3();
}
function K3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _3(o, e) {
  if (o) {
    if (typeof o == "string") return ac(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ac(o, e);
  }
}
function $3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function eP(o) {
  if (Array.isArray(o)) return ac(o);
}
function ac(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function sf(o, e) {
  if (o == null) return {};
  var r = oP(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function oP(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var rP = xe({
  name: "infinite-hits",
  connector: !0
});
function Od(o) {
  var e = o || {};
  e.page;
  var r = sf(e, U3);
  return r;
}
function Ia(o) {
  var e = o || {};
  e.clickAnalytics, e.userToken;
  var r = sf(e, Y3);
  return r;
}
function tP() {
  var o = null, e = null;
  return {
    read: function(t) {
      var n = t.state;
      return Ur(e, Od(n)) ? o : null;
    },
    write: function(t) {
      var n = t.state, a = t.hits;
      e = Od(n), o = a;
    }
  };
}
function nP(o) {
  return Object.keys(o).map(Number).sort(function(e, r) {
    return e - r;
  }).reduce(function(e, r) {
    return e.concat(o[r]);
  }, []);
}
const aP = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, rP()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a, i = n.transformItems, l = i === void 0 ? function(b) {
      return b;
    } : i, c = n.cache, u = c === void 0 ? tP() : c, m, y, g, p, d = function(v, k) {
      var E = v.page, S = E === void 0 ? 0 : E, B = Object.keys(k).map(Number);
      return B.length === 0 ? S : Math.min.apply(Math, [S].concat(Cd(B)));
    }, h = function(v, k) {
      var E = v.page, S = E === void 0 ? 0 : E, B = Object.keys(k).map(Number);
      return B.length === 0 ? S : Math.max.apply(Math, [S].concat(Cd(B)));
    }, f = function(v) {
      return function() {
        v.overrideStateWithoutTriggeringChangeEvent(Do(Do({}, v.state), {}, {
          page: d(v.state, u.read({
            state: Ia(v.state)
          }) || {}) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    }, F = function(v) {
      return function() {
        v.setPage(h(v.state, u.read({
          state: Ia(v.state)
        }) || {}) + 1).search();
      };
    };
    return {
      $$type: "ais.infiniteHits",
      init: function(v) {
        e(Do(Do({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: v.instantSearchInstance
        }), !0);
      },
      render: function(v) {
        var k = v.instantSearchInstance, E = this.getWidgetRenderState(v);
        e(Do(Do({}, E), {}, {
          instantSearchInstance: k
        }), !1), g("view:internal", E.currentPageHits);
      },
      getRenderState: function(v, k) {
        return Do(Do({}, v), {}, {
          infiniteHits: this.getWidgetRenderState(k)
        });
      },
      getWidgetRenderState: function(v) {
        var k, E, S, B = v.results, D = v.helper, x = v.parent, C = v.state, O = v.instantSearchInstance, T, I = [], G = x.getPreviousState() || C, U = u.read({
          state: Ia(G)
        }) || {}, N = B == null || (k = B.renderingContent) === null || k === void 0 || (E = k.widgets) === null || E === void 0 || (S = E.banners) === null || S === void 0 ? void 0 : S[0];
        if (!B)
          m = f(D), y = F(D), g = Kc({
            instantSearchInstance: O,
            getIndex: function() {
              return D.getIndex();
            },
            widgetType: this.$$type
          }), p = Ly({
            getIndex: function() {
              return D.getIndex();
            },
            widgetType: this.$$type,
            instantSearchInstance: O
          }), T = G.page === void 0 || d(G, U) === 0;
        else {
          var z, V, Y = G.page, K = Y === void 0 ? 0 : Y;
          s && B.hits.length > 0 && (B.hits = Vs(B.hits));
          var $ = eu(B.hits, B.page, B.hitsPerPage), te = ou($, B.queryID), ge = l(te, {
            results: B
          }), X = !1;
          Wy(O.mainIndex, function(me) {
            !X && me.getWidgets().some(function(Se) {
              var Ee = Se.$$type;
              return Ee === "ais.dynamicWidgets";
            }) && (X = !0);
          });
          var q = !((z = G.disjunctiveFacets) !== null && z !== void 0 && z.length) && !(G.facets || []).filter(function(me) {
            return me !== "*";
          }).length && !((V = G.hierarchicalFacets) !== null && V !== void 0 && V.length);
          U[K] === void 0 && !B.__isArtificial && O.status === "idle" && !(X && q) && (U[K] = ge, u.write({
            state: Ia(G),
            hits: U
          })), I = ge, T = d(G, U) === 0;
        }
        var J = nP(U), ee = B ? B.nbPages <= h(G, U) + 1 : !0;
        return {
          hits: J,
          items: J,
          currentPageHits: I,
          sendEvent: g,
          bindEvent: p,
          banner: N,
          results: B || void 0,
          showPrevious: m,
          showMore: y,
          isFirstPage: T,
          isLastPage: ee,
          widgetParams: t
        };
      },
      dispose: function(v) {
        var k = v.state;
        r();
        var E = k.setQueryParameter("page", void 0);
        return s ? E.setQueryParameters(Object.keys(Yo).reduce(function(S, B) {
          return Do(Do({}, S), {}, af({}, B, void 0));
        }, {})) : E;
      },
      getWidgetUiState: function(v, k) {
        var E = k.searchParameters, S = E.page || 0;
        return S ? Do(Do({}, v), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: S + 1
        }) : v;
      },
      getWidgetSearchParameters: function(v, k) {
        var E = k.uiState, S = v;
        s && (S = v.setQueryParameters(Yo));
        var B = E.page ? E.page - 1 : 0;
        return S.setQueryParameter("page", B);
      }
    };
  };
};
var sP = tf(aP), iP = ["name", "escapedValue", "path"];
function Cn(o) {
  "@babel/helpers - typeof";
  return Cn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Cn(o);
}
function lP(o, e) {
  if (o == null) return {};
  var r = cP(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function cP(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function Td(o, e) {
  return gP(o) || dP(o, e) || pP(o, e) || uP();
}
function uP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pP(o, e) {
  if (o) {
    if (typeof o == "string") return jd(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return jd(o, e);
  }
}
function jd(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function dP(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function gP(o) {
  if (Array.isArray(o)) return o;
}
function Md(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ke(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Md(Object(r), !0).forEach(function(t) {
      $a(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Md(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function $a(o, e, r) {
  return e = mP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function mP(o) {
  var e = yP(o, "string");
  return Cn(e) == "symbol" ? e : String(e);
}
function yP(o, e) {
  if (Cn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Cn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Ki = xe({
  name: "menu",
  connector: !0
}), zd = ["isRefined", "name:asc"], lf = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Ki()), function(t) {
    var n = t || {}, a = n.attribute, s = n.limit, i = s === void 0 ? 10 : s, l = n.showMore, c = l === void 0 ? !1 : l, u = n.showMoreLimit, m = u === void 0 ? 20 : u, y = n.sortBy, g = y === void 0 ? zd : y, p = n.transformItems, d = p === void 0 ? function(B) {
      return B;
    } : p;
    if (!a)
      throw new Error(Ki("The `attribute` option is required."));
    if (c === !0 && m <= i)
      throw new Error(Ki("The `showMoreLimit` option must be greater than `limit`."));
    var h, f, F, b = !1, v = function() {
    };
    function k(B, D) {
      return function() {
        b = !b, D.render(B);
      };
    }
    function E() {
      v();
    }
    function S() {
      return b ? m : i;
    }
    return {
      $$type: "ais.menu",
      init: function(D) {
        var x = D.instantSearchInstance;
        e(Ke(Ke({}, this.getWidgetRenderState(D)), {}, {
          instantSearchInstance: x
        }), !0);
      },
      render: function(D) {
        var x = D.instantSearchInstance;
        e(Ke(Ke({}, this.getWidgetRenderState(D)), {}, {
          instantSearchInstance: x
        }), !1);
      },
      dispose: function(D) {
        var x = D.state;
        return r(), x.removeHierarchicalFacet(a).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(D, x) {
        return Ke(Ke({}, D), {}, {
          menu: Ke(Ke({}, D.menu), {}, $a({}, a, this.getWidgetRenderState(x)))
        });
      },
      getWidgetRenderState: function(D) {
        var x = this, C = D.results, O = D.createURL, T = D.instantSearchInstance, I = D.helper, G = [], U = !1;
        if (h || (h = Qc({
          instantSearchInstance: T,
          helper: I,
          attribute: a,
          widgetType: this.$$type
        })), f || (f = function(Y) {
          return O(function(K) {
            return x.getWidgetUiState(K, {
              searchParameters: I.state.resetPage().toggleFacetRefinement(a, Y),
              helper: I
            });
          });
        }), F || (F = function(Y) {
          var K = I.getHierarchicalFacetBreadcrumb(a), $ = Td(K, 1), te = $[0];
          h("click:internal", Y || te), I.toggleFacetRefinement(a, Y || te).search();
        }), D.results && (v = k(D, this)), C) {
          var N = C.getFacetValues(a, {
            sortBy: g,
            facetOrdering: g === zd
          }), z = N && !Array.isArray(N) && N.data ? N.data : [];
          U = c && (b || z.length > S()), G = d(z.slice(0, S()).map(function(V) {
            var Y = V.name, K = V.escapedValue;
            V.path;
            var $ = lP(V, iP);
            return Ke(Ke({}, $), {}, {
              label: Y,
              value: K
            });
          }), {
            results: C
          });
        }
        return {
          items: G,
          createURL: f,
          refine: F,
          sendEvent: h,
          canRefine: G.length > 0,
          widgetParams: t,
          isShowingMore: b,
          toggleShowMore: E,
          canToggleShowMore: U
        };
      },
      getWidgetUiState: function(D, x) {
        var C = x.searchParameters, O = C.getHierarchicalFacetBreadcrumb(a), T = Td(O, 1), I = T[0];
        return fP(Ke(Ke({}, D), {}, {
          menu: Ke(Ke({}, D.menu), {}, $a({}, a, I))
        }), a);
      },
      getWidgetSearchParameters: function(D, x) {
        var C = x.uiState, O = C.menu && C.menu[a];
        if (D.isConjunctiveFacet(a) || D.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ue(!1, 'Menu: Attribute "'.concat(a, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this Menu widget will not work at all.`)), D;
        var T = D.removeHierarchicalFacet(a).addHierarchicalFacet({
          name: a,
          attributes: [a]
        }), I = T.maxValuesPerFacet || 0, G = Math.max(I, c ? m : i), U = T.setQueryParameter("maxValuesPerFacet", G);
        return O ? U.addHierarchicalFacetRefinement(a, O) : U.setQueryParameters({
          hierarchicalFacetsRefinements: Ke(Ke({}, U.hierarchicalFacetsRefinements), {}, $a({}, a, []))
        });
      }
    };
  };
};
function fP(o, e) {
  return o.menu && (o.menu[e] === void 0 && delete o.menu[e], Object.keys(o.menu).length === 0 && delete o.menu), o;
}
function On(o) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, On(o);
}
function hP(o, e) {
  var r = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (!r) {
    if (Array.isArray(o) || (r = cf(o)) || e) {
      r && (o = r);
      var t = 0, n = function() {
      };
      return { s: n, n: function() {
        return t >= o.length ? { done: !0 } : { done: !1, value: o[t++] };
      }, e: function(c) {
        throw c;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, i;
  return { s: function() {
    r = r.call(o);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    s = !0, i = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s) throw i;
    }
  } };
}
function FP(o, e) {
  return PP(o) || vP(o, e) || cf(o, e) || bP();
}
function bP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cf(o, e) {
  if (o) {
    if (typeof o == "string") return Nd(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Nd(o, e);
  }
}
function Nd(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function vP(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function PP(o) {
  if (Array.isArray(o)) return o;
}
function Id(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ze(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Id(Object(r), !0).forEach(function(t) {
      Zt(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Id(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Zt(o, e, r) {
  return e = BP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function BP(o) {
  var e = kP(o, "string");
  return On(e) == "symbol" ? e : String(e);
}
function kP(o, e) {
  if (On(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (On(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var _i = xe({
  name: "numeric-menu",
  connector: !0
}), wP = "ais.numericMenu", DP = function(e) {
  var r = e.instantSearchInstance;
  return function() {
    if (arguments.length === 1) {
      r.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
      return;
    }
  };
}, SP = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, _i()), function(t) {
    var n = t || {}, a = n.attribute, s = a === void 0 ? "" : a, i = n.items, l = i === void 0 ? [] : i, c = n.transformItems, u = c === void 0 ? function(g) {
      return g;
    } : c;
    if (s === "")
      throw new Error(_i("The `attribute` option is required."));
    if (!l || l.length === 0)
      throw new Error(_i("The `items` option expects an array of objects."));
    var m = function(p) {
      return l.map(function(d) {
        var h = d.start, f = d.end, F = d.label;
        return {
          label: F,
          value: encodeURI(JSON.stringify({
            start: h,
            end: f
          })),
          isRefined: uf(p, s, {
            start: h,
            end: f
          })
        };
      });
    }, y = {};
    return {
      $$type: wP,
      init: function(p) {
        var d = p.instantSearchInstance;
        e(Ze(Ze({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !0);
      },
      render: function(p) {
        var d = p.instantSearchInstance;
        e(Ze(Ze({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: d
        }), !1);
      },
      dispose: function(p) {
        var d = p.state;
        return r(), d.removeNumericRefinement(s);
      },
      getWidgetUiState: function(p, d) {
        var h = d.searchParameters, f = h.getNumericRefinements(s), F = f["="] && f["="][0];
        if (F || F === 0)
          return Ze(Ze({}, p), {}, {
            numericMenu: Ze(Ze({}, p.numericMenu), {}, Zt({}, s, "".concat(f["="])))
          });
        var b = f[">="] && f[">="][0] || "", v = f["<="] && f["<="][0] || "";
        return EP(Ze(Ze({}, p), {}, {
          numericMenu: Ze(Ze({}, p.numericMenu), {}, Zt({}, s, "".concat(b, ":").concat(v)))
        }), s);
      },
      getWidgetSearchParameters: function(p, d) {
        var h = d.uiState, f = h.numericMenu && h.numericMenu[s], F = p.setQueryParameters({
          numericRefinements: Ze(Ze({}, p.numericRefinements), {}, Zt({}, s, {}))
        });
        if (!f)
          return F;
        var b = f.indexOf(":") === -1;
        if (b)
          return F.addNumericRefinement(s, "=", Number(f));
        var v = f.split(":").map(parseFloat), k = FP(v, 2), E = k[0], S = k[1], B = ke(E) ? F.addNumericRefinement(s, ">=", E) : F, D = ke(S) ? B.addNumericRefinement(s, "<=", S) : B;
        return D;
      },
      getRenderState: function(p, d) {
        return Ze(Ze({}, p), {}, {
          numericMenu: Ze(Ze({}, p.numericMenu), {}, Zt({}, s, this.getWidgetRenderState(d)))
        });
      },
      getWidgetRenderState: function(p) {
        var d = this, h = p.results, f = p.state, F = p.instantSearchInstance, b = p.helper, v = p.createURL;
        y.refine || (y.refine = function(C) {
          var O = Rd(b.state, s, C);
          y.sendEvent("click:internal", C), b.setState(O).search();
        }), y.createURL || (y.createURL = function(C) {
          return function(O) {
            return v(function(T) {
              return d.getWidgetUiState(T, {
                searchParameters: Rd(C, s, O),
                helper: b
              });
            });
          };
        }), y.sendEvent || (y.sendEvent = DP({
          instantSearchInstance: F
        }));
        var k = h ? h.nbHits === 0 : !0, E = m(f), S = !0, B = hP(E), D;
        try {
          for (B.s(); !(D = B.n()).done; ) {
            var x = D.value;
            if (x.isRefined && decodeURI(x.value) !== "{}") {
              S = !1;
              break;
            }
          }
        } catch (C) {
          B.e(C);
        } finally {
          B.f();
        }
        return {
          createURL: y.createURL(f),
          items: u(E, {
            results: h
          }),
          hasNoResults: k,
          canRefine: !(k && S),
          refine: y.refine,
          sendEvent: y.sendEvent,
          widgetParams: t
        };
      }
    };
  };
};
function uf(o, e, r) {
  var t = o.getNumericRefinements(e);
  return r.start !== void 0 && r.end !== void 0 ? r.start === r.end ? vr(t, "=", r.start) : vr(t, ">=", r.start) && vr(t, "<=", r.end) : r.start !== void 0 ? vr(t, ">=", r.start) : r.end !== void 0 ? vr(t, "<=", r.end) : r.start === void 0 && r.end === void 0 ? Object.keys(t).every(function(n) {
    return (t[n] || []).length === 0;
  }) : !1;
}
function Rd(o, e, r) {
  var t = o, n = JSON.parse(decodeURI(r)), a = t.getNumericRefinements(e);
  if (n.start === void 0 && n.end === void 0)
    return t.removeNumericRefinement(e);
  if (uf(t, e, n) || (t = t.removeNumericRefinement(e)), n.start !== void 0 && n.end !== void 0) {
    if (n.start > n.end)
      throw new Error("option.start should be > to option.end");
    if (n.start === n.end)
      return vr(a, "=", n.start) ? t = t.removeNumericRefinement(e, "=", n.start) : t = t.addNumericRefinement(e, "=", n.start), t;
  }
  return n.start !== void 0 && (vr(a, ">=", n.start) && (t = t.removeNumericRefinement(e, ">=", n.start)), t = t.addNumericRefinement(e, ">=", n.start)), n.end !== void 0 && (vr(a, "<=", n.end) && (t = t.removeNumericRefinement(e, "<=", n.end)), t = t.addNumericRefinement(e, "<=", n.end)), typeof t.page == "number" && (t.page = 0), t;
}
function vr(o, e, r) {
  return o[e] !== void 0 && o[e].includes(r);
}
function EP(o, e) {
  return o.numericMenu && (o.numericMenu[e] === ":" && delete o.numericMenu[e], Object.keys(o.numericMenu).length === 0 && delete o.numericMenu), o;
}
function Tn(o) {
  "@babel/helpers - typeof";
  return Tn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Tn(o);
}
function xP(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function AP(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, pf(t.key), t);
  }
}
function CP(o, e, r) {
  return e && AP(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function $i(o, e, r) {
  return e = pf(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function pf(o) {
  var e = OP(o, "string");
  return Tn(e) == "symbol" ? e : String(e);
}
function OP(o, e) {
  if (Tn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Tn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var TP = /* @__PURE__ */ function() {
  function o(e) {
    xP(this, o), $i(this, "currentPage", void 0), $i(this, "total", void 0), $i(this, "padding", void 0), this.currentPage = e.currentPage, this.total = e.total, this.padding = e.padding;
  }
  return CP(o, [{
    key: "pages",
    value: function() {
      var r = this.total, t = this.currentPage, n = this.padding;
      if (r === 0) return [0];
      var a = this.nbPagesDisplayed(n, r);
      if (a === r)
        return Op({
          end: r
        });
      var s = this.calculatePaddingLeft(t, n, r, a), i = a - s, l = t - s, c = t + i;
      return Op({
        start: l,
        end: c
      });
    }
  }, {
    key: "nbPagesDisplayed",
    value: function(r, t) {
      return Math.min(2 * r + 1, t);
    }
  }, {
    key: "calculatePaddingLeft",
    value: function(r, t, n, a) {
      return r <= t ? r : r >= n - t ? a - (n - r) : t;
    }
  }, {
    key: "isLastPage",
    value: function() {
      return this.currentPage >= this.total - 1;
    }
  }, {
    key: "isFirstPage",
    value: function() {
      return this.currentPage <= 0;
    }
  }]), o;
}();
function jn(o) {
  "@babel/helpers - typeof";
  return jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jn(o);
}
function Ld(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Wo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ld(Object(r), !0).forEach(function(t) {
      jP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ld(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function jP(o, e, r) {
  return e = MP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function MP(o) {
  var e = zP(o, "string");
  return jn(e) == "symbol" ? e : String(e);
}
function zP(o, e) {
  if (jn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (jn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var NP = xe({
  name: "pagination",
  connector: !0
}), IP = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, NP()), function(t) {
    var n = t || {}, a = n.totalPages, s = n.padding, i = s === void 0 ? 3 : s, l = new TP({
      currentPage: 0,
      total: 0,
      padding: i
    }), c = {};
    function u(m) {
      var y = m.nbPages;
      return a !== void 0 ? Math.min(a, y) : y;
    }
    return {
      $$type: "ais.pagination",
      init: function(y) {
        var g = y.instantSearchInstance;
        e(Wo(Wo({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(y) {
        var g = y.instantSearchInstance;
        e(Wo(Wo({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: g
        }), !1);
      },
      dispose: function(y) {
        var g = y.state;
        return r(), g.setQueryParameter("page", void 0);
      },
      getWidgetUiState: function(y, g) {
        var p = g.searchParameters, d = p.page || 0;
        return d ? Wo(Wo({}, y), {}, {
          page: d + 1
        }) : y;
      },
      getWidgetSearchParameters: function(y, g) {
        var p = g.uiState, d = p.page ? p.page - 1 : 0;
        return y.setQueryParameter("page", d);
      },
      getWidgetRenderState: function(y) {
        var g = y.results, p = y.helper, d = y.state, h = y.createURL;
        c.refine || (c.refine = function(b) {
          p.setPage(b), p.search();
        }), c.createURL || (c.createURL = function(b) {
          return h(function(v) {
            return Wo(Wo({}, v), {}, {
              page: b + 1
            });
          });
        });
        var f = d.page || 0, F = u(g || {
          nbPages: 0
        });
        return l.currentPage = f, l.total = F, {
          createURL: c.createURL,
          refine: c.refine,
          canRefine: F > 1,
          currentRefinement: f,
          nbHits: (g == null ? void 0 : g.nbHits) || 0,
          nbPages: F,
          pages: g ? l.pages() : [],
          isFirstPage: l.isFirstPage(),
          isLastPage: l.isLastPage(),
          widgetParams: t
        };
      },
      getRenderState: function(y, g) {
        return Wo(Wo({}, y), {}, {
          pagination: this.getWidgetRenderState(g)
        });
      }
    };
  };
};
function Mn(o) {
  "@babel/helpers - typeof";
  return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mn(o);
}
function Hd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function _e(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hd(Object(r), !0).forEach(function(t) {
      es(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Hd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function es(o, e, r) {
  return e = RP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function RP(o) {
  var e = LP(o, "string");
  return Mn(e) == "symbol" ? e : String(e);
}
function LP(o, e) {
  if (Mn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Mn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function it(o, e) {
  return GP(o) || VP(o, e) || WP(o, e) || HP();
}
function HP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WP(o, e) {
  if (o) {
    if (typeof o == "string") return Wd(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Wd(o, e);
  }
}
function Wd(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function VP(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function GP(o) {
  if (Array.isArray(o)) return o;
}
var el = xe({
  name: "range-input",
  connector: !0
}, {
  name: "range-slider",
  connector: !0
}), ZP = "ais.range";
function Vd(o) {
  var e = o.min, r = o.max, t = o.precision, n = Math.pow(10, t);
  return {
    min: e && Math.floor(e * n) / n,
    max: r && Math.ceil(r * n) / n
  };
}
var XP = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, el()), function(t) {
    var n = t || {}, a = n.attribute, s = a === void 0 ? "" : a, i = n.min, l = n.max, c = n.precision, u = c === void 0 ? 0 : c;
    if (!s)
      throw new Error(el("The `attribute` option is required."));
    if (ke(i) && ke(l) && i > l)
      throw new Error(el("The `max` option can't be lower than `min`."));
    var m = function(b) {
      return Number(Number(b).toFixed(u));
    }, y = {
      from: function(b) {
        return b.toLocaleString();
      },
      to: function(b) {
        return m(b).toLocaleString();
      }
    }, g = function(b, v, k, E) {
      var S = b.state, B = v.min, D = v.max, x = S.getNumericRefinement(s, ">=") || [], C = it(x, 1), O = C[0], T = S.getNumericRefinement(s, "<=") || [], I = it(T, 1), G = I[0], U = k === void 0 || k === "", N = E === void 0 || E === "", z = Vd({
        min: U ? void 0 : parseFloat(k),
        max: N ? void 0 : parseFloat(E),
        precision: u
      }), V = z.min, Y = z.max, K;
      !ke(i) && B === V ? K = void 0 : ke(i) && U ? K = i : K = V;
      var $;
      !ke(l) && D === Y ? $ = void 0 : ke(l) && N ? $ = l : $ = Y;
      var te = K === void 0, ge = ke(B) && B <= K, X = te || ke(K) && (!ke(B) || ge), q = $ === void 0, J = ke($) && D >= $, ee = q || ke($) && (!ke(D) || J), me = O !== K, Se = G !== $;
      return (me || Se) && X && ee ? (S = S.removeNumericRefinement(s), ke(K) && (S = S.addNumericRefinement(s, ">=", K)), ke($) && (S = S.addNumericRefinement(s, "<=", $)), S.resetPage()) : null;
    }, p = function(b) {
      return function() {
        if (arguments.length === 1) {
          b.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
          return;
        }
      };
    };
    function d(F) {
      var b;
      ke(i) ? b = i : ke(F.min) ? b = F.min : b = 0;
      var v;
      return ke(l) ? v = l : ke(F.max) ? v = F.max : v = 0, Vd({
        min: b,
        max: v,
        precision: u
      });
    }
    function h(F) {
      var b = F.getNumericRefinement(s, ">=") || [], v = it(b, 1), k = v[0], E = F.getNumericRefinement(s, "<=") || [], S = it(E, 1), B = S[0], D = ke(k) ? k : -1 / 0, x = ke(B) ? B : 1 / 0;
      return [D, x];
    }
    function f(F, b) {
      return function() {
        var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [void 0, void 0], k = it(v, 2), E = k[0], S = k[1], B = g(F, b, E, S);
        B && F.setState(B).search();
      };
    }
    return {
      $$type: ZP,
      init: function(b) {
        e(_e(_e({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !0);
      },
      render: function(b) {
        e(_e(_e({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !1);
      },
      getRenderState: function(b, v) {
        return _e(_e({}, b), {}, {
          range: _e(_e({}, b.range), {}, es({}, s, this.getWidgetRenderState(v)))
        });
      },
      getWidgetRenderState: function(b) {
        var v = b.results, k = b.helper, E = b.instantSearchInstance, S = v && v.disjunctiveFacets || [], B = ir(S, function(T) {
          return T.name === s;
        }), D = B && B.stats || {
          min: void 0,
          max: void 0
        }, x = d(D), C = h(k), O;
        return v ? O = f(k, x) : O = f(k, {
          min: void 0,
          max: void 0
        }), {
          refine: O,
          canRefine: x.min !== x.max,
          format: y,
          range: x,
          sendEvent: p(E),
          widgetParams: _e(_e({}, t), {}, {
            precision: u
          }),
          start: C
        };
      },
      dispose: function(b) {
        var v = b.state;
        return r(), v.removeDisjunctiveFacet(s).removeNumericRefinement(s);
      },
      getWidgetUiState: function(b, v) {
        var k = v.searchParameters, E = k.getNumericRefinements(s), S = E[">="], B = S === void 0 ? [] : S, D = E["<="], x = D === void 0 ? [] : D;
        return B.length === 0 && x.length === 0 ? b : _e(_e({}, b), {}, {
          range: _e(_e({}, b.range), {}, es({}, s, "".concat(B, ":").concat(x)))
        });
      },
      getWidgetSearchParameters: function(b, v) {
        var k = v.uiState, E = b.addDisjunctiveFacet(s).setQueryParameters({
          numericRefinements: _e(_e({}, b.numericRefinements), {}, es({}, s, {}))
        });
        ke(i) && (E = E.addNumericRefinement(s, ">=", i)), ke(l) && (E = E.addNumericRefinement(s, "<=", l));
        var S = k.range && k.range[s];
        if (!S || S.indexOf(":") === -1)
          return E;
        var B = S.split(":").map(parseFloat), D = it(B, 2), x = D[0], C = D[1];
        return ke(x) && (!ke(i) || i < x) && (E = E.removeNumericRefinement(s, ">="), E = E.addNumericRefinement(s, ">=", x)), ke(C) && (!ke(l) || C < l) && (E = E.removeNumericRefinement(s, "<="), E = E.addNumericRefinement(s, "<=", C)), E;
      }
    };
  };
};
function zn(o) {
  "@babel/helpers - typeof";
  return zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zn(o);
}
var qP = ["name", "escapedValue"], UP = ["escapedValue", "value"];
function Gd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ae(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gd(Object(r), !0).forEach(function(t) {
      Xt(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Gd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Xt(o, e, r) {
  return e = YP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function YP(o) {
  var e = JP(o, "string");
  return zn(e) == "symbol" ? e : String(e);
}
function JP(o, e) {
  if (zn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (zn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Zd(o, e) {
  if (o == null) return {};
  var r = QP(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function QP(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var Ra = xe({
  name: "refinement-list",
  connector: !0
}), Xd = ["isRefined", "count:desc", "name:asc"], KP = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Ra()), function(t) {
    var n = t || {}, a = n.attribute, s = n.operator, i = s === void 0 ? "or" : s, l = n.limit, c = l === void 0 ? 10 : l, u = n.showMore, m = u === void 0 ? !1 : u, y = n.showMoreLimit, g = y === void 0 ? 20 : y, p = n.sortBy, d = p === void 0 ? Xd : p, h = n.escapeFacetValues, f = h === void 0 ? !0 : h, F = n.transformItems, b = F === void 0 ? function(N) {
      return N;
    } : F;
    if (!a)
      throw new Error(Ra("The `attribute` option is required."));
    if (!/^(and|or)$/.test(i))
      throw new Error(Ra('The `operator` must one of: `"and"`, `"or"` (got "'.concat(i, '").')));
    if (m === !0 && g <= c)
      throw new Error(Ra("`showMoreLimit` should be greater than `limit`."));
    var v = function(z) {
      var V = z.name, Y = z.escapedValue, K = Zd(z, qP);
      return Ae(Ae({}, K), {}, {
        value: Y,
        label: V,
        highlighted: V
      });
    }, k, E = [], S = !0, B, D, x = !1, C = function() {
    };
    function O() {
      C();
    }
    function T(N, z) {
      return function() {
        x = !x, z.render(N);
      };
    }
    function I() {
      return x ? g : c;
    }
    var G = function() {
      return function() {
      };
    }, U = function(z, V) {
      return function(Y) {
        return function(K) {
          var $ = Y.instantSearchInstance, te = Y.results;
          if (K === "" && E)
            e(Ae(Ae({}, V.getWidgetRenderState(Ae(Ae({}, Y), {}, {
              results: k
            }))), {}, {
              instantSearchInstance: $
            }), !1);
          else {
            var ge = {
              highlightPreTag: f ? Yo.highlightPreTag : oo.highlightPreTag,
              highlightPostTag: f ? Yo.highlightPostTag : oo.highlightPostTag
            };
            z.searchForFacetValues(
              a,
              K,
              // We cap the `maxFacetHits` value to 100 because the Algolia API
              // doesn't support a greater number.
              // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
              Math.min(I(), 100),
              ge
            ).then(function(X) {
              var q = f ? Xb(X.facetHits) : X.facetHits, J = b(q.map(function(ee) {
                var me = ee.escapedValue, Se = ee.value, Ee = Zd(ee, UP);
                return Ae(Ae({}, Ee), {}, {
                  value: me,
                  label: Se
                });
              }), {
                results: te
              });
              e(Ae(Ae({}, V.getWidgetRenderState(Ae(Ae({}, Y), {}, {
                results: k
              }))), {}, {
                items: J,
                canToggleShowMore: !1,
                canRefine: !0,
                isFromSearch: !0,
                instantSearchInstance: $
              }), !1);
            });
          }
        };
      };
    };
    return {
      $$type: "ais.refinementList",
      init: function(z) {
        e(Ae(Ae({}, this.getWidgetRenderState(z)), {}, {
          instantSearchInstance: z.instantSearchInstance
        }), !0);
      },
      render: function(z) {
        e(Ae(Ae({}, this.getWidgetRenderState(z)), {}, {
          instantSearchInstance: z.instantSearchInstance
        }), !1);
      },
      getRenderState: function(z, V) {
        return Ae(Ae({}, z), {}, {
          refinementList: Ae(Ae({}, z.refinementList), {}, Xt({}, a, this.getWidgetRenderState(V)))
        });
      },
      getWidgetRenderState: function(z) {
        var V = this, Y = z.results, K = z.state, $ = z.createURL, te = z.instantSearchInstance, ge = z.helper, X = [], q = [];
        if ((!D || !B || !G) && (D = Qc({
          instantSearchInstance: te,
          helper: ge,
          attribute: a,
          widgetType: this.$$type
        }), B = function(Je) {
          D("click:internal", Je), ge.toggleFacetRefinement(a, Je).search();
        }, G = U(ge, this)), Y) {
          var J = Y.getFacetValues(a, {
            sortBy: d,
            facetOrdering: d === Xd
          });
          q = J && Array.isArray(J) ? J : [], X = b(q.slice(0, I()).map(v), {
            results: Y
          });
          var ee = K.maxValuesPerFacet, me = I();
          S = ee > me ? q.length <= me : q.length < me, k = Y, E = X, z.results && (C = T(z, this));
        }
        var Se = G && G(z), Ee = x && E.length > c, no = m && !S, Lo = Ee || no;
        return {
          createURL: function(Je) {
            return $(function(Er) {
              return V.getWidgetUiState(Er, {
                searchParameters: K.resetPage().toggleFacetRefinement(a, Je),
                helper: ge
              });
            });
          },
          items: X,
          refine: B,
          searchForItems: Se,
          isFromSearch: !1,
          canRefine: X.length > 0,
          widgetParams: t,
          isShowingMore: x,
          canToggleShowMore: Lo,
          toggleShowMore: O,
          sendEvent: D,
          hasExhaustiveItems: S
        };
      },
      dispose: function(z) {
        var V = z.state;
        r();
        var Y = V.setQueryParameter("maxValuesPerFacet", void 0);
        return i === "and" ? Y.removeFacet(a) : Y.removeDisjunctiveFacet(a);
      },
      getWidgetUiState: function(z, V) {
        var Y = V.searchParameters, K = i === "or" ? Y.getDisjunctiveRefinements(a) : Y.getConjunctiveRefinements(a);
        return _P(Ae(Ae({}, z), {}, {
          refinementList: Ae(Ae({}, z.refinementList), {}, Xt({}, a, K))
        }), a);
      },
      getWidgetSearchParameters: function(z, V) {
        var Y = V.uiState, K = i === "or";
        if (z.isHierarchicalFacet(a))
          return process.env.NODE_ENV === "development" && ue(!1, 'RefinementList: Attribute "'.concat(a, `" is already used by another widget applying hierarchical faceting.
As this is not supported, please make sure to remove this other widget or this RefinementList widget will not work at all.`)), z;
        if (K && z.isConjunctiveFacet(a) || !K && z.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ue(!1, 'RefinementList: Attribute "'.concat(a, `" is used by another refinement list with a different operator.
As this is not supported, please make sure to only use this attribute with one of the two operators.`)), z;
        var $ = Y.refinementList && Y.refinementList[a], te = K ? z.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a) : z.addFacet(a).removeFacetRefinement(a), ge = te.maxValuesPerFacet || 0, X = Math.max(ge, m ? g : c), q = te.setQueryParameter("maxValuesPerFacet", X);
        if (!$) {
          var J = K ? "disjunctiveFacetsRefinements" : "facetsRefinements";
          return q.setQueryParameters(Xt({}, J, Ae(Ae({}, q[J]), {}, Xt({}, a, []))));
        }
        return $.reduce(function(ee, me) {
          return K ? ee.addDisjunctiveFacetRefinement(a, me) : ee.addFacetRefinement(a, me);
        }, q);
      }
    };
  };
};
function _P(o, e) {
  return o.refinementList && ((!o.refinementList[e] || o.refinementList[e].length === 0) && delete o.refinementList[e], Object.keys(o.refinementList).length === 0 && delete o.refinementList), o;
}
function Nn(o) {
  "@babel/helpers - typeof";
  return Nn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Nn(o);
}
function qd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function mr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qd(Object(r), !0).forEach(function(t) {
      $P(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : qd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function $P(o, e, r) {
  return e = e4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function e4(o) {
  var e = o4(o, "string");
  return Nn(e) == "symbol" ? e : String(e);
}
function o4(o, e) {
  if (Nn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Nn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var r4 = xe({
  name: "search-box",
  connector: !0
}), t4 = function(e, r) {
  return r(e);
}, n4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, r4()), function(t) {
    var n = t || {}, a = n.queryHook, s = a === void 0 ? t4 : a, i, l;
    return {
      $$type: "ais.searchBox",
      init: function(u) {
        var m = u.instantSearchInstance;
        e(mr(mr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: m
        }), !0);
      },
      render: function(u) {
        var m = u.instantSearchInstance;
        e(mr(mr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      dispose: function(u) {
        var m = u.state;
        return r(), m.setQueryParameter("query", void 0);
      },
      getRenderState: function(u, m) {
        return mr(mr({}, u), {}, {
          searchBox: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(u) {
        var m = u.helper, y = u.instantSearchInstance, g = u.state;
        return i || (i = function(d) {
          s(d, function(h) {
            return m.setQuery(h).search();
          });
        }, l = function() {
          m.setQuery("").search();
        }), {
          query: g.query || "",
          refine: i,
          clear: l,
          widgetParams: t,
          isSearchStalled: y.status === "stalled"
        };
      },
      getWidgetUiState: function(u, m) {
        var y = m.searchParameters, g = y.query || "";
        return g === "" || u && u.query === g ? u : mr(mr({}, u), {}, {
          query: g
        });
      },
      getWidgetSearchParameters: function(u, m) {
        var y = m.uiState;
        return u.setQueryParameter("query", y.query || "");
      }
    };
  };
};
function In(o) {
  "@babel/helpers - typeof";
  return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, In(o);
}
function Ud(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function yr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ud(Object(r), !0).forEach(function(t) {
      a4(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ud(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function a4(o, e, r) {
  return e = s4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function s4(o) {
  var e = i4(o, "string");
  return In(e) == "symbol" ? e : String(e);
}
function i4(o, e) {
  if (In(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (In(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Yd = xe({
  name: "sort-by",
  connector: !0
}), l4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  Le(e, Yd());
  var t = {};
  return function(n) {
    var a = n || {}, s = a.items, i = a.transformItems, l = i === void 0 ? function(c) {
      return c;
    } : i;
    if (!Array.isArray(s))
      throw new Error(Yd("The `items` option expects an array of objects."));
    return {
      $$type: "ais.sortBy",
      init: function(u) {
        var m = u.instantSearchInstance, y = this.getWidgetRenderState(u), g = y.currentRefinement, p = ir(s, function(d) {
          return d.value === g;
        });
        process.env.NODE_ENV === "development" && ue(p !== void 0, 'The index named "'.concat(g, '" is not listed in the `items` of `sortBy`.')), e(yr(yr({}, y), {}, {
          instantSearchInstance: m
        }), !0);
      },
      render: function(u) {
        var m = u.instantSearchInstance;
        e(yr(yr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      dispose: function(u) {
        var m = u.state;
        return r(), t.initialIndex ? m.setIndex(t.initialIndex) : m;
      },
      getRenderState: function(u, m) {
        return yr(yr({}, u), {}, {
          sortBy: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(u) {
        var m = u.results, y = u.helper, g = u.state, p = u.parent;
        !t.initialIndex && p && (t.initialIndex = p.getIndexName()), t.setIndex || (t.setIndex = function(h) {
          y.setIndex(h).search();
        });
        var d = m ? m.nbHits === 0 : !0;
        return {
          currentRefinement: g.index,
          options: l(s, {
            results: m
          }),
          refine: t.setIndex,
          hasNoResults: d,
          canRefine: !d && s.length > 0,
          widgetParams: n
        };
      },
      getWidgetUiState: function(u, m) {
        var y = m.searchParameters, g = y.index;
        return yr(yr({}, u), {}, {
          sortBy: g !== t.initialIndex ? g : void 0
        });
      },
      getWidgetSearchParameters: function(u, m) {
        var y = m.uiState;
        return u.setQueryParameter("index", y.sortBy || t.initialIndex || u.index);
      }
    };
  };
};
function Rn(o) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rn(o);
}
function c4(o) {
  return d4(o) || p4(o) || gf(o) || u4();
}
function u4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p4(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function d4(o) {
  if (Array.isArray(o)) return sc(o);
}
function Jd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function lo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Jd(Object(r), !0).forEach(function(t) {
      rs(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Jd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function rs(o, e, r) {
  return e = g4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function g4(o) {
  var e = m4(o, "string");
  return Rn(e) == "symbol" ? e : String(e);
}
function m4(o, e) {
  if (Rn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Rn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function df(o, e) {
  return h4(o) || f4(o, e) || gf(o, e) || y4();
}
function y4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gf(o, e) {
  if (o) {
    if (typeof o == "string") return sc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return sc(o, e);
  }
}
function sc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function f4(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function h4(o) {
  if (Array.isArray(o)) return o;
}
var Qd = xe({
  name: "rating-menu",
  connector: !0
}), mf = "ais.ratingMenu", ol = 1e3, La = 1, F4 = function(e) {
  var r = e.instantSearchInstance, t = e.helper, n = e.getRefinedStar, a = e.attribute;
  return function() {
    for (var s = arguments.length, i = new Array(s), l = 0; l < s; l++)
      i[l] = arguments[l];
    if (i.length === 1) {
      r.sendEventToInsights(i[0]);
      return;
    }
    var c = i[1], u = i[2], m = u === void 0 ? "Filter Applied" : u, y = i[0].split(":"), g = df(y, 2), p = g[0], d = g[1];
    if (p === "click") {
      var h = n() === Number(c);
      h || r.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: mf,
        eventType: p,
        eventModifier: d,
        payload: {
          eventName: m,
          index: t.getIndex(),
          filters: ["".concat(a, ">=").concat(c)]
        },
        attribute: a
      });
    }
  };
}, b4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, Qd()), function(t) {
    var n = t || {}, a = n.attribute, s = n.max, i = s === void 0 ? 5 : s, l;
    if (!a)
      throw new Error(Qd("The `attribute` option is required."));
    var c = function(h) {
      var f, F = h.getNumericRefinements(a);
      if ((f = F[">="]) !== null && f !== void 0 && f.length)
        return F[">="][0];
    }, u = function(h) {
      var f = 0;
      return h.forEach(function(F) {
        var b = F.name.split("."), v = df(b, 2), k = v[1], E = k === void 0 ? "" : k;
        f = Math.max(f, E.length);
      }), f;
    }, m = function(h) {
      var f = h.maxDecimalPlaces, F = h.maxFacets, b = h.maxValuesPerFacet, v = Math.max(0, Math.floor(Math.log10(ol / i))), k = Math.min(ol, Math.pow(10, v) * i), E = [];
      return F > ol && E.push('- Update your records to lower the precision of the values in the "'.concat(a, '" attribute (for example: ').concat(5.123456789.toPrecision(f + 1), " to ").concat(5.123456789.toPrecision(v + 1), ")")), b < k && E.push("- Increase the maximum number of facet values to ".concat(k, ' using the "configure" widget ').concat(gn({
        name: "configure"
      }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/')), "The ".concat(a, " attribute can have ").concat(F, " different values (0 to ").concat(i, " with a maximum of ").concat(f, " decimals = ").concat(F, ") but you retrieved only ").concat(b, ` facet values. Therefore the number of results that match the refinements can be incorrect.
    `).concat(E.length ? `To resolve this problem you can:
`.concat(E.join(`
`)) : "");
    };
    function y(d, h) {
      var f = c(d) === Number(h), F = d.resetPage().removeNumericRefinement(a);
      return f ? F : F.addNumericRefinement(a, "<=", i).addNumericRefinement(a, ">=", Number(h));
    }
    var g = function(h, f) {
      l("click:internal", f), h.setState(y(h.state, f)).search();
    }, p = {
      toggleRefinementFactory: function(h) {
        return g.bind(null, h);
      },
      createURLFactory: function(h) {
        var f = h.state, F = h.createURL, b = h.getWidgetUiState, v = h.helper;
        return function(k) {
          return F(function(E) {
            return b(E, {
              searchParameters: y(f, k),
              helper: v
            });
          });
        };
      }
    };
    return {
      $$type: mf,
      init: function(h) {
        var f = h.instantSearchInstance;
        e(lo(lo({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(h) {
        var f = h.instantSearchInstance;
        e(lo(lo({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      getRenderState: function(h, f) {
        return lo(lo({}, h), {}, {
          ratingMenu: lo(lo({}, h.ratingMenu), {}, rs({}, a, this.getWidgetRenderState(f)))
        });
      },
      getWidgetRenderState: function(h) {
        var f = h.helper, F = h.results, b = h.state, v = h.instantSearchInstance, k = h.createURL, E = [];
        l || (l = F4({
          instantSearchInstance: v,
          helper: f,
          getRefinedStar: function() {
            return c(f.state);
          },
          attribute: a
        }));
        var S = !1, B = 0, D = F == null ? void 0 : F.getFacetValues(a, {});
        if (F && D) {
          var x = D.length, C = u(D), O = Math.pow(10, C) * i;
          process.env.NODE_ENV === "development" && ue(O <= x || !!F.__isArtificial, m({
            maxDecimalPlaces: C,
            maxFacets: O,
            maxValuesPerFacet: x
          }));
          for (var T = c(b), I = function(V) {
            var Y = T === V;
            S = S || Y;
            var K = D.filter(function(te) {
              return Number(te.name) >= V && Number(te.name) <= i;
            }).map(function(te) {
              return te.count;
            }).reduce(function(te, ge) {
              return te + ge;
            }, 0);
            if (B += K, T && !Y && K === 0)
              return "continue";
            var $ = c4(new Array(Math.floor(i / La))).map(function(te, ge) {
              return ge * La < V;
            });
            E.push({
              stars: $,
              name: String(V),
              label: String(V),
              value: String(V),
              count: K,
              isRefined: Y
            });
          }, G = La; G < i; G += La)
            var U = I(G);
        }
        E = E.reverse();
        var N = F ? F.nbHits === 0 : !0;
        return {
          items: E,
          hasNoResults: N,
          canRefine: (!N || S) && B > 0,
          refine: p.toggleRefinementFactory(f),
          sendEvent: l,
          createURL: p.createURLFactory({
            state: b,
            createURL: k,
            helper: f,
            getWidgetUiState: this.getWidgetUiState
          }),
          widgetParams: t
        };
      },
      dispose: function(h) {
        var f = h.state;
        return r(), f.removeNumericRefinement(a);
      },
      getWidgetUiState: function(h, f) {
        var F = f.searchParameters, b = c(F);
        return v4(lo(lo({}, h), {}, {
          ratingMenu: lo(lo({}, h.ratingMenu), {}, rs({}, a, typeof b == "number" ? b : void 0))
        }), a);
      },
      getWidgetSearchParameters: function(h, f) {
        var F = f.uiState, b = F.ratingMenu && F.ratingMenu[a], v = h.addDisjunctiveFacet(a).removeNumericRefinement(a).removeDisjunctiveFacetRefinement(a);
        return b ? v.addNumericRefinement(a, "<=", i).addNumericRefinement(a, ">=", b) : v.setQueryParameters({
          numericRefinements: lo(lo({}, v.numericRefinements), {}, rs({}, a, {}))
        });
      }
    };
  };
};
function v4(o, e) {
  return o.ratingMenu && (typeof o.ratingMenu[e] != "number" && delete o.ratingMenu[e], Object.keys(o.ratingMenu).length === 0 && delete o.ratingMenu), o;
}
function Ln(o) {
  "@babel/helpers - typeof";
  return Ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ln(o);
}
function Kd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function lt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Kd(Object(r), !0).forEach(function(t) {
      P4(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Kd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function P4(o, e, r) {
  return e = B4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function B4(o) {
  var e = k4(o, "string");
  return Ln(e) == "symbol" ? e : String(e);
}
function k4(o, e) {
  if (Ln(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Ln(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var w4 = xe({
  name: "stats",
  connector: !0
}), D4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, w4()), function(t) {
    return {
      $$type: "ais.stats",
      init: function(a) {
        var s = a.instantSearchInstance;
        e(lt(lt({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !0);
      },
      render: function(a) {
        var s = a.instantSearchInstance;
        e(lt(lt({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(a, s) {
        return lt(lt({}, a), {}, {
          stats: this.getWidgetRenderState(s)
        });
      },
      getWidgetRenderState: function(a) {
        var s = a.results, i = a.state;
        return s ? {
          hitsPerPage: s.hitsPerPage,
          nbHits: s.nbHits,
          nbSortedHits: s.nbSortedHits,
          areHitsSorted: typeof s.appliedRelevancyStrictness < "u" && s.appliedRelevancyStrictness > 0 && s.nbSortedHits !== s.nbHits,
          nbPages: s.nbPages,
          page: s.page,
          processingTimeMS: s.processingTimeMS,
          query: s.query,
          widgetParams: t
        } : {
          hitsPerPage: i.hitsPerPage,
          nbHits: 0,
          nbSortedHits: void 0,
          areHitsSorted: !1,
          nbPages: 0,
          page: i.page || 0,
          processingTimeMS: -1,
          query: i.query || "",
          widgetParams: t
        };
      }
    };
  };
};
function Hn(o) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hn(o);
}
function _d(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function co(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _d(Object(r), !0).forEach(function(t) {
      ts(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : _d(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function ts(o, e, r) {
  return e = S4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function S4(o) {
  var e = E4(o, "string");
  return Hn(e) == "symbol" ? e : String(e);
}
function E4(o, e) {
  if (Hn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Hn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function x4(o, e) {
  return T4(o) || O4(o, e) || C4(o, e) || A4();
}
function A4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C4(o, e) {
  if (o) {
    if (typeof o == "string") return $d(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $d(o, e);
  }
}
function $d(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function O4(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function T4(o) {
  if (Array.isArray(o)) return o;
}
var eg = xe({
  name: "toggle-refinement",
  connector: !0
}), yf = "ais.toggleRefinement", j4 = function(e) {
  var r = e.instantSearchInstance, t = e.helper, n = e.attribute, a = e.on, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    if (c.length === 1) {
      r.sendEventToInsights(c[0]);
      return;
    }
    var m = c[1], y = c[2], g = y === void 0 ? "Filter Applied" : y, p = c[0].split(":"), d = x4(p, 2), h = d[0], f = d[1];
    h !== "click" || a === void 0 || m || r.sendEventToInsights({
      insightsMethod: "clickedFilters",
      widgetType: yf,
      eventType: h,
      eventModifier: f,
      payload: {
        eventName: g,
        index: t.getIndex(),
        filters: a.map(function(F) {
          return "".concat(n, ":").concat(F);
        })
      },
      attribute: n
    });
  };
  return s;
}, M4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, eg()), function(t) {
    var n = t || {}, a = n.attribute, s = n.on, i = s === void 0 ? !0 : s, l = n.off;
    if (!a)
      throw new Error(eg("The `attribute` option is required."));
    var c = l !== void 0, u = bi(i).map(Vt), m = c ? bi(l).map(Vt) : void 0, y, g = function(h) {
      return function() {
        var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
          isRefined: !1
        }, F = f.isRefined;
        F ? (u.forEach(function(b) {
          return h.removeDisjunctiveFacetRefinement(a, b);
        }), c && m.forEach(function(b) {
          return h.addDisjunctiveFacetRefinement(a, b);
        })) : (y("click:internal", F), c && m.forEach(function(b) {
          return h.removeDisjunctiveFacetRefinement(a, b);
        }), u.forEach(function(b) {
          return h.addDisjunctiveFacetRefinement(a, b);
        })), h.search();
      };
    }, p = {
      createURLFactory: function(h, f) {
        var F = f.state, b = f.createURL, v = f.getWidgetUiState, k = f.helper;
        return function() {
          F = F.resetPage();
          var E = h ? u : m;
          E && E.forEach(function(B) {
            F = F.removeDisjunctiveFacetRefinement(a, B);
          });
          var S = h ? m : u;
          return S && S.forEach(function(B) {
            F = F.addDisjunctiveFacetRefinement(a, B);
          }), b(function(B) {
            return v(B, {
              searchParameters: F,
              helper: k
            });
          });
        };
      }
    };
    return {
      $$type: yf,
      init: function(h) {
        var f = h.instantSearchInstance;
        e(co(co({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(h) {
        var f = h.instantSearchInstance;
        e(co(co({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      dispose: function(h) {
        var f = h.state;
        return r(), f.removeDisjunctiveFacet(a);
      },
      getRenderState: function(h, f) {
        return co(co({}, h), {}, {
          toggleRefinement: co(co({}, h.toggleRefinement), {}, ts({}, a, this.getWidgetRenderState(f)))
        });
      },
      getWidgetRenderState: function(h) {
        var f = h.state, F = h.helper, b = h.results, v = h.createURL, k = h.instantSearchInstance, E = b ? u.every(function(I) {
          return f.isDisjunctiveFacetRefined(a, I);
        }) : u.every(function(I) {
          return f.isDisjunctiveFacetRefined(a, I);
        }), S = {
          isRefined: E,
          count: 0
        }, B = {
          isRefined: c && !E,
          count: 0
        };
        if (b) {
          var D = bi(m || !1), x = b.getFacetValues(a, {}) || [], C = u.map(function(I) {
            return ir(x, function(G) {
              var U = G.escapedValue;
              return U === Vt(String(I));
            });
          }).filter(function(I) {
            return I !== void 0;
          }), O = c ? D.map(function(I) {
            return ir(x, function(G) {
              var U = G.escapedValue;
              return U === Vt(String(I));
            });
          }).filter(function(I) {
            return I !== void 0;
          }) : [];
          S = {
            isRefined: C.length ? C.every(function(I) {
              return I.isRefined;
            }) : !1,
            count: C.reduce(function(I, G) {
              return I + G.count;
            }, 0) || null
          }, B = {
            isRefined: O.length ? O.every(function(I) {
              return I.isRefined;
            }) : !1,
            count: O.reduce(function(I, G) {
              return I + G.count;
            }, 0) || x.reduce(function(I, G) {
              var U = G.count;
              return I + U;
            }, 0)
          };
        }
        y || (y = j4({
          instantSearchInstance: k,
          attribute: a,
          on: u,
          helper: F
        }));
        var T = E ? B : S;
        return {
          value: {
            name: a,
            isRefined: E,
            count: b ? T.count : null,
            onFacetValue: S,
            offFacetValue: B
          },
          createURL: p.createURLFactory(E, {
            state: f,
            createURL: v,
            helper: F,
            getWidgetUiState: this.getWidgetUiState
          }),
          sendEvent: y,
          canRefine: !!(b && T.count),
          refine: g(F),
          widgetParams: t
        };
      },
      getWidgetUiState: function(h, f) {
        var F = f.searchParameters, b = u && u.every(function(k) {
          return F.isDisjunctiveFacetRefined(a, k);
        });
        if (!b) {
          var v;
          return (v = h.toggle) === null || v === void 0 || delete v[a], h;
        }
        return co(co({}, h), {}, {
          toggle: co(co({}, h.toggle), {}, ts({}, a, b))
        });
      },
      getWidgetSearchParameters: function(h, f) {
        var F = f.uiState;
        if (h.isHierarchicalFacet(a) || h.isConjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && ue(!1, 'ToggleRefinement: Attribute "'.concat(a, `" is already used by another widget of a different type.
As this is not supported, please make sure to remove this other widget or this ToggleRefinement widget will not work at all.`)), h;
        var b = h.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a), v = !!(F.toggle && F.toggle[a]);
        return v ? (u && u.forEach(function(k) {
          b = b.addDisjunctiveFacetRefinement(a, k);
        }), b) : c ? (m && m.forEach(function(k) {
          b = b.addDisjunctiveFacetRefinement(a, k);
        }), b) : b.setQueryParameters({
          disjunctiveFacetsRefinements: co(co({}, h.disjunctiveFacetsRefinements), {}, ts({}, a, []))
        });
      }
    };
  };
};
function Wn(o) {
  "@babel/helpers - typeof";
  return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wn(o);
}
function og(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function uo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? og(Object(r), !0).forEach(function(t) {
      ns(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : og(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function ns(o, e, r) {
  return e = z4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function z4(o) {
  var e = N4(o, "string");
  return Wn(e) == "symbol" ? e : String(e);
}
function N4(o, e) {
  if (Wn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Wn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function rg(o, e) {
  return H4(o) || L4(o, e) || R4(o, e) || I4();
}
function I4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function R4(o, e) {
  if (o) {
    if (typeof o == "string") return tg(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return tg(o, e);
  }
}
function tg(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function L4(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function H4(o) {
  if (Array.isArray(o)) return o;
}
var ng = xe({
  name: "breadcrumb",
  connector: !0
}), W4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  Le(e, ng());
  var t = {};
  return function(n) {
    var a = n || {}, s = a.attributes, i = a.separator, l = i === void 0 ? " > " : i, c = a.rootPath, u = c === void 0 ? null : c, m = a.transformItems, y = m === void 0 ? function(h) {
      return h;
    } : m;
    if (!s || !Array.isArray(s) || s.length === 0)
      throw new Error(ng("The `attributes` option expects an array of strings."));
    var g = rg(s, 1), p = g[0];
    function d(h, f) {
      if (!f) {
        var F = h.getHierarchicalFacetBreadcrumb(p);
        return F.length === 0 ? h : h.resetPage().toggleFacetRefinement(p, F[0]);
      }
      return h.resetPage().toggleFacetRefinement(p, f);
    }
    return {
      $$type: "ais.breadcrumb",
      init: function(f) {
        e(uo(uo({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: f.instantSearchInstance
        }), !0);
      },
      render: function(f) {
        e(uo(uo({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: f.instantSearchInstance
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(f, F) {
        return uo(uo({}, f), {}, {
          breadcrumb: uo(uo({}, f.breadcrumb), {}, ns({}, p, this.getWidgetRenderState(F)))
        });
      },
      getWidgetRenderState: function(f) {
        var F = this, b = f.helper, v = f.createURL, k = f.results, E = f.state;
        function S() {
          if (!k || E.hierarchicalFacets.length === 0)
            return [];
          var D = rg(E.hierarchicalFacets, 1), x = D[0].name, C = k.getFacetValues(x, {}), O = C && !Array.isArray(C) && C.data ? C.data : [], T = y(V4(ff(O)), {
            results: k
          });
          return T;
        }
        var B = S();
        return t.createURL || (t.createURL = function(D) {
          return v(function(x) {
            return F.getWidgetUiState(x, {
              searchParameters: d(b.state, D),
              helper: b
            });
          });
        }), t.refine || (t.refine = function(D) {
          b.setState(d(b.state, D)).search();
        }), {
          canRefine: B.length > 0,
          createURL: t.createURL,
          items: B,
          refine: t.refine,
          widgetParams: n
        };
      },
      getWidgetUiState: function(f, F) {
        var b = F.searchParameters, v = b.getHierarchicalFacetBreadcrumb(p);
        return G4(uo(uo({}, f), {}, {
          hierarchicalMenu: uo(uo({}, f.hierarchicalMenu), {}, ns({}, p, v))
        }), p);
      },
      getWidgetSearchParameters: function(f, F) {
        var b = F.uiState, v = b.hierarchicalMenu && b.hierarchicalMenu[p];
        if (f.isConjunctiveFacet(p) || f.isDisjunctiveFacet(p))
          return process.env.NODE_ENV === "development" && ue(!1, 'HierarchicalMenu: Attribute "'.concat(p, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), f;
        if (f.isHierarchicalFacet(p)) {
          var k = f.getHierarchicalFacetByName(p);
          process.env.NODE_ENV === "development" && ue(Ur(k.attributes, s) && k.separator === l && k.rootPath === u, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var E = f.removeHierarchicalFacet(p).addHierarchicalFacet({
          name: p,
          attributes: s,
          separator: l,
          rootPath: u
        });
        return v ? E.addHierarchicalFacetRefinement(p, v.join(l)) : E.setQueryParameters({
          hierarchicalFacetsRefinements: uo(uo({}, E.hierarchicalFacetsRefinements), {}, ns({}, p, []))
        });
      }
    };
  };
};
function ff(o) {
  return o.reduce(function(e, r) {
    return r.isRefined && (e.push({
      label: r.name,
      value: r.escapedValue
    }), Array.isArray(r.data) && (e = e.concat(ff(r.data)))), e;
  }, []);
}
function V4(o) {
  return o.map(function(e, r) {
    return {
      label: e.label,
      value: r + 1 === o.length ? null : o[r + 1].value
    };
  });
}
function G4(o, e) {
  return o.hierarchicalMenu && ((!o.hierarchicalMenu[e] || !o.hierarchicalMenu[e].length) && delete o.hierarchicalMenu[e], Object.keys(o.hierarchicalMenu).length === 0 && delete o.hierarchicalMenu), o;
}
function Vn(o) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vn(o);
}
function ag(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function So(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ag(Object(r), !0).forEach(function(t) {
      hf(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : ag(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function hf(o, e, r) {
  return e = Z4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Z4(o) {
  var e = X4(o, "string");
  return Vn(e) == "symbol" ? e : String(e);
}
function X4(o, e) {
  if (Vn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Vn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var q4 = xe({
  name: "autocomplete",
  connector: !0
}), U4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, q4()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a;
    process.env.NODE_ENV === "development" && ue(!t.indices, `
The option \`indices\` has been removed from the Autocomplete connector.

The indices to target are now inferred from the widgets tree.
`.concat(Array.isArray(t.indices) ? `
An alternative would be:

const autocomplete = connectAutocomplete(renderer);

search.addWidgets([
  `.concat(t.indices.map(function(l) {
      var c = l.value;
      return "index({ indexName: '".concat(c, "' }),");
    }).join(`
  `), `
  autocomplete()
]);
`) : "", `
      `));
    var i = {};
    return {
      $$type: "ais.autocomplete",
      init: function(c) {
        var u = c.instantSearchInstance;
        e(So(So({}, this.getWidgetRenderState(c)), {}, {
          instantSearchInstance: u
        }), !0);
      },
      render: function(c) {
        var u = c.instantSearchInstance, m = this.getWidgetRenderState(c);
        m.indices.forEach(function(y) {
          var g = y.sendEvent, p = y.hits;
          g("view:internal", p);
        }), e(So(So({}, m), {}, {
          instantSearchInstance: u
        }), !1);
      },
      getRenderState: function(c, u) {
        return So(So({}, c), {}, {
          autocomplete: this.getWidgetRenderState(u)
        });
      },
      getWidgetRenderState: function(c) {
        var u = this, m = c.helper, y = c.state, g = c.scopedResults, p = c.instantSearchInstance;
        i.refine || (i.refine = function(h) {
          m.setQuery(h).search();
        });
        var d = g.map(function(h) {
          var f, F;
          h.results && (h.results.hits = s ? Vs(h.results.hits) : h.results.hits);
          var b = Kc({
            instantSearchInstance: p,
            getIndex: function() {
              var k;
              return ((k = h.results) === null || k === void 0 ? void 0 : k.index) || "";
            },
            widgetType: u.$$type
          });
          return {
            indexId: h.indexId,
            indexName: ((f = h.results) === null || f === void 0 ? void 0 : f.index) || "",
            hits: ((F = h.results) === null || F === void 0 ? void 0 : F.hits) || [],
            results: h.results || {},
            sendEvent: b
          };
        });
        return {
          currentRefinement: y.query || "",
          indices: d,
          refine: i.refine,
          widgetParams: t
        };
      },
      getWidgetUiState: function(c, u) {
        var m = u.searchParameters, y = m.query || "";
        return y === "" || c && c.query === y ? c : So(So({}, c), {}, {
          query: y
        });
      },
      getWidgetSearchParameters: function(c, u) {
        var m = u.uiState, y = {
          query: m.query || ""
        };
        return s ? c.setQueryParameters(So(So({}, y), Yo)) : c.setQueryParameters(y);
      },
      dispose: function(c) {
        var u = c.state;
        r();
        var m = u.setQueryParameter("query", void 0);
        return s ? m.setQueryParameters(Object.keys(Yo).reduce(function(y, g) {
          return So(So({}, y), {}, hf({}, g, void 0));
        }, {})) : m;
      }
    };
  };
};
function Gn(o) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gn(o);
}
function sg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function br(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sg(Object(r), !0).forEach(function(t) {
      Y4(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : sg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Y4(o, e, r) {
  return e = J4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function J4(o) {
  var e = Q4(o, "string");
  return Gn(e) == "symbol" ? e : String(e);
}
function Q4(o, e) {
  if (Gn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Gn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function bs(o) {
  return e6(o) || $4(o) || _4(o) || K4();
}
function K4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _4(o, e) {
  if (o) {
    if (typeof o == "string") return ic(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ic(o, e);
  }
}
function $4(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function e6(o) {
  if (Array.isArray(o)) return ic(o);
}
function ic(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var ig = xe({
  name: "query-rules",
  connector: !0
});
function o6(o) {
  return [o.disjunctiveFacetsRefinements, o.facetsRefinements, o.hierarchicalFacetsRefinements, o.numericRefinements].some(function(e) {
    return !!(e && Object.keys(e).length > 0);
  });
}
function r6(o) {
  return o.replace(/[^a-z0-9-_]+/gi, "_");
}
function t6(o) {
  var e = o.helper, r = o.sharedHelperState, t = o.trackedFilters, n = Object.keys(t).reduce(function(a, s) {
    var i = $c(e.lastResults || {}, r, !0).filter(function(u) {
      return u.attribute === s;
    }).map(function(u) {
      return u.numericValue || u.name;
    }), l = t[s], c = l(i);
    return [].concat(bs(a), bs(i.filter(function(u) {
      return c.includes(u);
    }).map(function(u) {
      return r6("ais-".concat(s, "-").concat(u));
    })));
  }, []);
  return n;
}
function n6(o) {
  var e = this.helper, r = this.initialRuleContexts, t = this.trackedFilters, n = this.transformRuleContexts, a = o.state, s = a.ruleContexts || [], i = t6({
    helper: e,
    sharedHelperState: a,
    trackedFilters: t
  }), l = [].concat(bs(r), bs(i));
  process.env.NODE_ENV === "development" && ue(l.length <= 10, "\nThe maximum number of `ruleContexts` is 10. They have been sliced to that limit.\nConsider using `transformRuleContexts` to minimize the number of rules sent to Algolia.\n");
  var c = n(l).slice(0, 10);
  Ur(s, c) || e.overrideStateWithoutTriggeringChangeEvent(br(br({}, a), {}, {
    ruleContexts: c
  }));
}
var Ff = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, ig()), function(t) {
    var n = t || {}, a = n.trackedFilters, s = a === void 0 ? {} : a, i = n.transformRuleContexts, l = i === void 0 ? function(p) {
      return p;
    } : i, c = n.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    Object.keys(s).forEach(function(p) {
      if (typeof s[p] != "function")
        throw new Error(ig(`'The "`.concat(p, '" filter value in the `trackedFilters` option expects a function.')));
    });
    var m = Object.keys(s).length > 0, y = [], g;
    return {
      $$type: "ais.queryRules",
      init: function(d) {
        var h = d.helper, f = d.state, F = d.instantSearchInstance;
        y = f.ruleContexts || [], g = n6.bind({
          helper: h,
          initialRuleContexts: y,
          trackedFilters: s,
          transformRuleContexts: l
        }), m && ((o6(f) || t.transformRuleContexts) && g({
          state: f
        }), h.on("change", g)), e(br(br({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: F
        }), !0);
      },
      render: function(d) {
        var h = d.instantSearchInstance;
        e(br(br({}, this.getWidgetRenderState(d)), {}, {
          instantSearchInstance: h
        }), !1);
      },
      getWidgetRenderState: function(d) {
        var h = d.results, f = h || {}, F = f.userData, b = F === void 0 ? [] : F, v = u(b, {
          results: h
        });
        return {
          items: v,
          widgetParams: t
        };
      },
      getRenderState: function(d, h) {
        return br(br({}, d), {}, {
          queryRules: this.getWidgetRenderState(h)
        });
      },
      dispose: function(d) {
        var h = d.helper, f = d.state;
        return r(), m ? (h.removeListener("change", g), f.setQueryParameter("ruleContexts", y)) : f;
      }
    };
  };
};
function Zn(o) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zn(o);
}
function lg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function cg(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lg(Object(r), !0).forEach(function(t) {
      a6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : lg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function a6(o, e, r) {
  return e = s6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function s6(o) {
  var e = i6(o, "string");
  return Zn(e) == "symbol" ? e : String(e);
}
function i6(o, e) {
  if (Zn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Zn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var l6 = function(e) {
  var r = e.searchAsYouSpeak, t = e.language, n = e.onQueryChange, a = e.onStateChange, s = window.webkitSpeechRecognition || window.SpeechRecognition, i = function(S) {
    return {
      status: S,
      transcript: "",
      isSpeechFinal: !1,
      errorCode: void 0
    };
  }, l = i("initial"), c, u = function() {
    return !!s;
  }, m = function() {
    return l.status === "askingPermission" || l.status === "waiting" || l.status === "recognizing";
  }, y = function() {
    var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    l = cg(cg({}, l), S), a();
  }, g = function() {
    return l;
  }, p = function() {
    var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "initial";
    y(i(S));
  }, d = function() {
    y({
      status: "waiting"
    });
  }, h = function(S) {
    y({
      status: "error",
      errorCode: S.error
    });
  }, f = function(S) {
    y({
      status: "recognizing",
      transcript: S.results[0] && S.results[0][0] && S.results[0][0].transcript || "",
      isSpeechFinal: S.results[0] && S.results[0].isFinal
    }), r && l.transcript && n(l.transcript);
  }, F = function() {
    !l.errorCode && l.transcript && !r && n(l.transcript), l.status !== "error" && y({
      status: "finished"
    });
  }, b = function() {
    c = new s(), c && (p("askingPermission"), c.interimResults = !0, t && (c.lang = t), c.addEventListener("start", d), c.addEventListener("error", h), c.addEventListener("result", f), c.addEventListener("end", F), c.start());
  }, v = function() {
    c && (c.stop(), c.removeEventListener("start", d), c.removeEventListener("error", h), c.removeEventListener("result", f), c.removeEventListener("end", F), c = void 0);
  }, k = function() {
    v(), p("finished");
  };
  return {
    getState: g,
    isBrowserSupported: u,
    isListening: m,
    startListening: b,
    stopListening: k,
    dispose: v
  };
};
function Xn(o) {
  "@babel/helpers - typeof";
  return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xn(o);
}
function ug(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Eo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ug(Object(r), !0).forEach(function(t) {
      c6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : ug(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function c6(o, e, r) {
  return e = u6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function u6(o) {
  var e = p6(o, "string");
  return Xn(e) == "symbol" ? e : String(e);
}
function p6(o, e) {
  if (Xn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Xn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var d6 = xe({
  name: "voice-search",
  connector: !0
}), g6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return Le(e, d6()), function(t) {
    var n = t.searchAsYouSpeak, a = n === void 0 ? !1 : n, s = t.language, i = t.additionalQueryParameters, l = t.createVoiceSearchHelper, c = l === void 0 ? l6 : l;
    return {
      $$type: "ais.voiceSearch",
      init: function(m) {
        var y = m.instantSearchInstance;
        e(Eo(Eo({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !0);
      },
      render: function(m) {
        var y = m.instantSearchInstance;
        e(Eo(Eo({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !1);
      },
      getRenderState: function(m, y) {
        return Eo(Eo({}, m), {}, {
          voiceSearch: this.getWidgetRenderState(y)
        });
      },
      getWidgetRenderState: function(m) {
        var y = this, g = m.helper, p = m.instantSearchInstance;
        this._refine || (this._refine = function(k) {
          if (k !== g.state.query) {
            var E = s ? [s.split("-")[0]] : void 0;
            g.setQueryParameter("queryLanguages", E), typeof i == "function" && g.setState(g.state.setQueryParameters(Eo({
              ignorePlurals: !0,
              removeStopWords: !0,
              // @ts-ignore optionalWords is allowed to be a string too
              optionalWords: k
            }, i({
              query: k
            })))), g.setQuery(k).search();
          }
        }), this._voiceSearchHelper || (this._voiceSearchHelper = c({
          searchAsYouSpeak: a,
          language: s,
          onQueryChange: function(E) {
            return y._refine(E);
          },
          onStateChange: function() {
            e(Eo(Eo({}, y.getWidgetRenderState(m)), {}, {
              instantSearchInstance: p
            }), !1);
          }
        }));
        var d = this._voiceSearchHelper, h = d.isBrowserSupported, f = d.isListening, F = d.startListening, b = d.stopListening, v = d.getState;
        return {
          isBrowserSupported: h(),
          isListening: f(),
          toggleListening: function() {
            h() && (f() ? b() : F());
          },
          voiceListeningState: v(),
          widgetParams: t
        };
      },
      dispose: function(m) {
        var y = m.state;
        this._voiceSearchHelper.dispose(), r();
        var g = y;
        if (typeof i == "function") {
          var p = i({
            query: ""
          }), d = p ? Object.keys(p).reduce(function(h, f) {
            return h[f] = void 0, h;
          }, {}) : {};
          g = y.setQueryParameters(Eo({
            // @ts-ignore (queryLanguages is not added to algoliasearch v3)
            queryLanguages: void 0,
            ignorePlurals: void 0,
            removeStopWords: void 0,
            optionalWords: void 0
          }, d));
        }
        return g.setQueryParameter("query", void 0);
      },
      getWidgetUiState: function(m, y) {
        var g = y.searchParameters, p = g.query || "";
        return p ? Eo(Eo({}, m), {}, {
          query: p
        }) : m;
      },
      getWidgetSearchParameters: function(m, y) {
        var g = y.uiState;
        return m.setQueryParameter("query", g.query || "");
      }
    };
  };
};
function qn(o) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qn(o);
}
function pg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function fr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? pg(Object(r), !0).forEach(function(t) {
      m6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : pg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function m6(o, e, r) {
  return e = y6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function y6(o) {
  var e = f6(o, "string");
  return qn(e) == "symbol" ? e : String(e);
}
function f6(o, e) {
  if (qn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (qn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var h6 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe;
  return function(t) {
    var n = {};
    return {
      $$type: "ais.relevantSort",
      init: function(s) {
        var i = s.instantSearchInstance;
        e(fr(fr({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: i
        }), !0);
      },
      render: function(s) {
        var i = s.instantSearchInstance;
        e(fr(fr({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: i
        }), !1);
      },
      dispose: function(s) {
        var i = s.state;
        return r(), i.setQueryParameter("relevancyStrictness", void 0);
      },
      getRenderState: function(s, i) {
        return fr(fr({}, s), {}, {
          relevantSort: this.getWidgetRenderState(i)
        });
      },
      getWidgetRenderState: function(s) {
        var i = s.results, l = s.helper;
        n.refine || (n.refine = function(y) {
          l.setQueryParameter("relevancyStrictness", y).search();
        });
        var c = i || {}, u = c.appliedRelevancyStrictness, m = u !== void 0;
        return {
          isRelevantSorted: typeof u < "u" && u > 0,
          isVirtualReplica: m,
          canRefine: m,
          refine: n.refine,
          widgetParams: t
        };
      },
      getWidgetSearchParameters: function(s, i) {
        var l, c = i.uiState;
        return s.setQueryParameter("relevancyStrictness", (l = c.relevantSort) !== null && l !== void 0 ? l : s.relevancyStrictness);
      },
      getWidgetUiState: function(s, i) {
        var l = i.searchParameters;
        return fr(fr({}, s), {}, {
          relevantSort: l.relevancyStrictness || s.relevantSort
        });
      }
    };
  };
};
dr(mv, "answers is no longer supported");
var F6 = dr(Hv, "EXPERIMENTAL_connectConfigureRelatedItems is deprecated and will be removed in a next minor version of InstantSearch. Please use connectRelatedItems instead.");
dr($y, "use connectDynamicWidgets");
De({ connector: U4 }, { $$widgetType: "ais.autocomplete" }), be({ name: "Autocomplete" });
A("p", null, " This widget doesn't render anything without a filled in default slot. ", -1);
A("p", null, "query, function to refine and results are provided.", -1);
A("pre", null, "refine: Function", -1);
A("summary", null, [A("code", null, "indices"), se(":")], -1);
function b6(o) {
  return { all: o = o || /* @__PURE__ */ new Map(), on: function(e, r) {
    var t = o.get(e);
    t && t.push(r) || o.set(e, [r]);
  }, off: function(e, r) {
    var t = o.get(e);
    t && t.splice(t.indexOf(r) >>> 0, 1);
  }, emit: function(e, r) {
    (o.get(e) || []).slice().map(function(t) {
      t(r);
    }), (o.get("*") || []).slice().map(function(t) {
      t(e, r);
    });
  } };
}
var v6 = function() {
  var o;
  return (o = { props: { emitter: { type: Object, required: !1, default: function() {
    return b6();
  } } }, provide: function() {
    var e;
    return (e = {}).instantSearchPanelEmitter = this.emitter, e;
  }, data: function() {
    return { canRefine: !0 };
  }, created: function() {
    var e = this;
    this.emitter.on("PANEL_CHANGE_EVENT", function(r) {
      e.updateCanRefine(r);
    });
  } }).beforeUnmount = function() {
    this.emitter.all.clear();
  }, o.methods = { updateCanRefine: function(e) {
    this.canRefine = e;
  } }, o;
}, fo = function(o) {
  o === void 0 && (o = {});
  var e = o.mapStateToCanRefine;
  return e === void 0 && (e = function(r) {
    return !!r.canRefine;
  }), { inject: { emitter: { from: "instantSearchPanelEmitter", default: function() {
    return { emit: function() {
    } };
  } } }, data: function() {
    return { state: null, hasAlreadyEmitted: !1 };
  }, watch: { state: { immediate: !0, handler: function(r, t) {
    if (r) {
      var n = e(t || {}), a = e(r);
      this.hasAlreadyEmitted && n === a || (this.emitter.emit("PANEL_CHANGE_EVENT", a), this.hasAlreadyEmitted = !0);
    }
  } } } };
};
De({ connector: W4 }, { $$widgetType: "ais.breadcrumb" }), fo(), be({ name: "Breadcrumb" });
De({ connector: _v }, { $$widgetType: "ais.clearRefinements" }), fo(), be({ name: "ClearRefinements" });
const P6 = { inheritAttrs: !1, name: "AisConfigure", mixins: [be({ name: "Configure" }), De({ connector: _y }, { $$widgetType: "ais.configure" })], computed: { widgetParams: function() {
  return { searchParameters: Object.assign({}, this.$attrs) };
} }, render: ha(function(o) {
  var e = this.$slots.default;
  return this.state && e ? o("div", { class: this.suit() }, [e({ refine: this.state.refine, searchParameters: this.state.widgetParams.searchParameters })]) : null;
}) };
De({ connector: F6 }, { $$widgetType: "ais.configureRelatedItems" });
be({ name: "CurrentRefinements" }), De({ connector: l3 }, { $$widgetType: "ais.currentRefinements" }), fo();
be({ name: "HierarchicalMenu" }), De({ connector: B3 }, { $$widgetType: "ais.hierarchicalMenu" }), fo();
function vs() {
  return vs = Object.assign ? Object.assign.bind() : function(o) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var t in r) ({}).hasOwnProperty.call(r, t) && (o[t] = r[t]);
    }
    return o;
  }, vs.apply(null, arguments);
}
function B6(o, e) {
  if (o == null) return {};
  var r = {};
  for (var t in o) if ({}.hasOwnProperty.call(o, t)) {
    if (e.indexOf(t) !== -1) continue;
    r[t] = o[t];
  }
  return r;
}
function bf(o, e) {
  if (o == null) return {};
  var r, t, n = B6(o, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (t = 0; t < a.length; t++) r = a[t], e.indexOf(r) === -1 && {}.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
  }
  return n;
}
function Zo() {
  for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
    e[r] = arguments[r];
  return e.reduce(function(t, n) {
    return Array.isArray(n) ? t.concat(n) : t.concat([n]);
  }, []).filter(Boolean).join(" ");
}
var k6 = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function w6(o) {
  var e = o.createElement;
  return function(t) {
    var n = t.classNames, a = t.children, s = t.highlightedTagName, i = t.isHighlighted, l = t.nonHighlightedTagName, c = i ? s : l;
    return e(c, {
      className: i ? n.highlighted : n.nonHighlighted
    }, a);
  };
}
function D6(o) {
  var e = o.createElement, r = o.Fragment, t = w6({
    createElement: e
  });
  return function(a) {
    var s = a.parts, i = a.highlightedTagName, l = i === void 0 ? "mark" : i, c = a.nonHighlightedTagName, u = c === void 0 ? "span" : c, m = a.separator, y = m === void 0 ? ", " : m, g = a.className, p = a.classNames, d = p === void 0 ? {} : p, h = bf(a, k6);
    return e("span", vs({}, h, {
      className: Zo(d.root, g)
    }), s.map(function(f, F) {
      var b = F === s.length - 1;
      return e(r, {
        key: F
      }, f.map(function(v, k) {
        return e(t, {
          key: k,
          classNames: d,
          highlightedTagName: l,
          nonHighlightedTagName: u,
          isHighlighted: v.isHighlighted
        }, v.value);
      }), !b && e("span", {
        className: d.separator
      }, y));
    }));
  };
}
var S6 = ["classNames", "hits", "itemComponent", "sendEvent", "emptyComponent", "banner", "bannerComponent"];
function E6(o) {
  var e = o.createElement;
  return function(t) {
    var n = t.classNames, a = t.banner;
    return a.image.urls[0].url ? e("aside", {
      className: Zo("ais-Hits-banner", n.bannerRoot)
    }, a.link ? e("a", {
      className: Zo("ais-Hits-banner-link", n.bannerLink),
      href: a.link.url,
      target: a.link.target
    }, e("img", {
      className: Zo("ais-Hits-banner-image", n.bannerImage),
      src: a.image.urls[0].url,
      alt: a.image.title
    })) : e("img", {
      className: Zo("ais-Hits-banner-image", n.bannerImage),
      src: a.image.urls[0].url,
      alt: a.image.title
    })) : null;
  };
}
function x6(o) {
  var e = o.createElement, r = E6({
    createElement: e
  });
  return function(n) {
    var a = n.classNames, s = a === void 0 ? {} : a, i = n.hits, l = n.itemComponent, c = n.sendEvent, u = n.emptyComponent, m = n.banner, y = n.bannerComponent, g = bf(n, S6);
    return e("div", vs({}, g, {
      className: Zo("ais-Hits", s.root, i.length === 0 && Zo("ais-Hits--empty", s.emptyRoot), g.className)
    }), m && (y ? e(y, {
      className: Zo("ais-Hits-banner", s.bannerRoot),
      banner: m
    }) : e(r, {
      classNames: s,
      banner: m
    })), i.length === 0 && u ? e(u, null) : e("ol", {
      className: Zo("ais-Hits-list", s.list)
    }, i.map(function(p, d) {
      return e(l, {
        key: p.objectID,
        hit: p,
        index: d,
        className: Zo("ais-Hits-item", s.item),
        onClick: function() {
          c("click:internal", p, "Hit Clicked");
        },
        onAuxClick: function() {
          c("click:internal", p, "Hit Clicked");
        }
      });
    })));
  };
}
var vf = function(o, e, r) {
  if (!r) return Rr(o, e);
  if (o === ye) return Rr(o, Array.isArray(r) ? r : [r]);
  var t = typeof r == "string" ? { default: function() {
    return r;
  } } : r, n = typeof o == "string" ? e : Object.assign(e, { children: r });
  return Rr(o, n, t);
}, A6 = D6({ createElement: vf, Fragment: ye });
const C6 = { name: "AisHighlighter", props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" }, suit: { type: Function, required: !0 }, highlightProperty: { type: String, required: !0 }, preTag: { type: String, required: !0 }, postTag: { type: String, required: !0 } }, render: function() {
  var o = At(this.hit[this.highlightProperty], this.attribute) || [], e = (Array.isArray(o) ? o : [o]).map(function(r) {
    return _c(Ty(r.value || "")).map(function(t) {
      var n = t.value;
      return { value: n === " " ? "  " : n, isHighlighted: t.isHighlighted };
    });
  });
  return vf(A6, { classNames: { root: this.suit(), highlighted: this.suit("highlighted") }, highlightedTagName: this.highlightedTagName, nonHighlightedTagName: ye, parts: e });
} }, Gs = { name: "AisHighlight", mixins: [be({ name: "Highlight" })], components: { AisHighlighter: C6 }, props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" } } };
function O6(o, e, r, t, n, a) {
  var s = jm("ais-highlighter");
  return w(), L(s, { hit: r.hit, attribute: r.attribute, "highlighted-tag-name": r.highlightedTagName, suit: o.suit, "highlight-property": "_highlightResult", "pre-tag": "<mark>", "post-tag": "</mark>" }, null, 8, ["hit", "attribute", "highlighted-tag-name", "suit"]);
}
Gs.render = O6;
const T6 = { name: "AisHits", mixins: [De({ connector: I3 }, { $$widgetType: "ais.hits" }), be({ name: "Hits" })], props: { showBanner: { type: Boolean, default: !0 }, escapeHTML: { type: Boolean, default: !0 }, transformItems: { type: Function, default: void 0 } }, computed: { widgetParams: function() {
  return { showBanner: this.showBanner, escapeHTML: this.escapeHTML, transformItems: this.transformItems };
} }, render: ha(function(o) {
  var e = this;
  if (!this.state) return null;
  var r = mi(this, "default"), t = mi(this, "item"), n = mi(this, "banner");
  return t || n || !r ? o(x6({ createElement: o }), { hits: this.state.items, itemComponent: function(a) {
    var s = a.hit, i = a.index, l = a.onClick, c = a.onAuxClick, u = (a.key, function(m, y) {
      var g = {};
      for (var p in m) Object.prototype.hasOwnProperty.call(m, p) && y.indexOf(p) === -1 && (g[p] = m[p]);
      return g;
    }(a, ["hit", "index", "onClick", "onAuxClick", "key"]));
    return o("li", { key: s.objectID, attrs: u, on: { click: l, auxclick: c } }, [t && t({ item: s, index: i, insights: e.state.insights, sendEvent: e.state.sendEvent }) || "objectID: " + s.objectID + ", index: " + i]);
  }, banner: this.showBanner ? this.state.banner : void 0, bannerComponent: n, sendEvent: this.state.sendEvent, classNames: this.classNames && { root: this.classNames["ais-Hits"], list: this.classNames["ais-Hits-list"], item: this.classNames["ais-Hits-item"], bannerRoot: this.classNames["ais-Hits-banner"], bannerImage: this.classNames["ais-Hits-banner-image"], bannerLink: this.classNames["ais-Hits-banner-link"] } }) : o("div", { attrs: { class: this.suit() } }, [r({ banner: this.state.banner, items: this.state.items, insights: this.state.insights, sendEvent: this.state.sendEvent })]);
}) };
be({ name: "HitsPerPage" }), De({ connector: q3 }, { $$widgetType: "ais.hitsPerPage" }), fo();
function Un(o) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Un(o);
}
var j6 = ["initialSearchParameters"], M6 = ["initialRecommendParameters"];
function dg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Vo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? dg(Object(r), !0).forEach(function(t) {
      mt(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : dg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function mt(o, e, r) {
  return e = z6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function z6(o) {
  var e = N6(o, "string");
  return Un(e) == "symbol" ? e : String(e);
}
function N6(o, e) {
  if (Un(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Un(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Pf(o) {
  return H6(o) || L6(o) || R6(o) || I6();
}
function I6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function R6(o, e) {
  if (o) {
    if (typeof o == "string") return lc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lc(o, e);
  }
}
function L6(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function H6(o) {
  if (Array.isArray(o)) return lc(o);
}
function lc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Bf(o, e) {
  if (o == null) return {};
  var r = W6(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function W6(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var Rt = xe({
  name: "index-widget"
});
function kf(o, e) {
  var r = e.state, t = e.recommendState, n = e.isPageReset, a = e._uiState;
  r !== o.state && (o.state = r, o.emit("change", {
    state: o.state,
    results: o.lastResults,
    isPageReset: n,
    _uiState: a
  })), t !== o.recommendState && (o.recommendState = t);
}
function Lt(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return o.reduce(function(t, n) {
    return go(n) || !n.getWidgetUiState && !n.getWidgetState ? t : n.getWidgetUiState ? n.getWidgetUiState(t, e) : n.getWidgetState(t, e);
  }, r);
}
function Ht(o, e) {
  var r = e.initialSearchParameters, t = Bf(e, j6);
  return o.reduce(function(n, a) {
    return !a.getWidgetSearchParameters || go(a) ? n : a.dependsOn === "search" && a.getWidgetParameters ? a.getWidgetParameters(n, t) : a.getWidgetSearchParameters(n, t);
  }, r);
}
function gg(o, e) {
  var r = e.initialRecommendParameters, t = Bf(e, M6);
  return o.reduce(function(n, a) {
    return !go(a) && a.dependsOn === "recommend" && a.getWidgetParameters ? a.getWidgetParameters(n, t) : n;
  }, r);
}
function wf(o) {
  var e = o.filter(go);
  e.length !== 0 && e.forEach(function(r) {
    var t = r.getHelper();
    kf(t, {
      state: t.state.resetPage(),
      recommendState: t.recommendState,
      isPageReset: !0
    }), wf(r.getWidgets());
  });
}
function Df(o) {
  var e = o.filter(go);
  return e.reduce(function(r, t) {
    return r.concat.apply(r, [{
      indexId: t.getIndexId(),
      results: t.getResults(),
      helper: t.getHelper()
    }].concat(Pf(Df(t.getWidgets()))));
  }, []);
}
var Sf = function(e) {
  if (e === void 0 || e.indexName === void 0)
    throw new Error(Rt("The `indexName` option is required."));
  var r = e.indexName, t = e.indexId, n = t === void 0 ? r : t, a = [], s = {}, i = null, l = null, c = null, u = null, m = null, y = !1, g = !1;
  return {
    $$type: "ais.index",
    $$widgetType: "ais.index",
    getIndexName: function() {
      return r;
    },
    getIndexId: function() {
      return n;
    },
    getHelper: function() {
      return c;
    },
    getResults: function() {
      var d;
      return (d = u) !== null && d !== void 0 && d.lastResults ? (u.lastResults._state = c.state, u.lastResults) : null;
    },
    getResultsForWidget: function(d) {
      var h;
      return d.dependsOn !== "recommend" || go(d) || d.$$id === void 0 ? this.getResults() : (h = c) !== null && h !== void 0 && h.lastRecommendResults ? c.lastRecommendResults[d.$$id] : null;
    },
    getPreviousState: function() {
      return m;
    },
    getScopedResults: function() {
      var d = this.getParent(), h;
      return d ? h = d.getWidgets() : r.length === 0 ? h = this.getWidgets() : h = [this], Df(h);
    },
    getParent: function() {
      return l;
    },
    createURL: function(d) {
      return typeof d == "function" ? i._createURL(mt({}, n, d(s))) : i._createURL(mt({}, n, Lt(a, {
        searchParameters: d,
        helper: c
      })));
    },
    getWidgets: function() {
      return a;
    },
    addWidgets: function(d) {
      var h = this;
      if (!Array.isArray(d))
        throw new Error(Rt("The `addWidgets` method expects an array of widgets."));
      if (d.some(function(f) {
        return typeof f.init != "function" && typeof f.render != "function";
      }))
        throw new Error(Rt("The widget definition expects a `render` and/or an `init` method."));
      return d.forEach(function(f) {
        go(f) || (i && f.dependsOn === "recommend" ? i._hasRecommendWidget = !0 : i ? i._hasSearchWidget = !0 : f.dependsOn === "recommend" ? y = !0 : g = !0, wb(f));
      }), a = a.concat(d), i && d.length && (kf(c, {
        state: Ht(a, {
          uiState: s,
          initialSearchParameters: c.state
        }),
        recommendState: gg(a, {
          uiState: s,
          initialRecommendParameters: c.recommendState
        }),
        _uiState: s
      }), d.forEach(function(f) {
        if (f.getRenderState) {
          var F = f.getRenderState(i.renderState[h.getIndexId()] || {}, Gt(i, h, i._initialUiState));
          rl({
            renderState: F,
            instantSearchInstance: i,
            parent: h
          });
        }
      }), d.forEach(function(f) {
        f.init && f.init(Gt(i, h, i._initialUiState));
      }), i.scheduleSearch()), this;
    },
    removeWidgets: function(d) {
      var h = this;
      if (!Array.isArray(d))
        throw new Error(Rt("The `removeWidgets` method expects an array of widgets."));
      if (d.some(function(k) {
        return typeof k.dispose != "function";
      }))
        throw new Error(Rt("The widget definition expects a `dispose` method."));
      if (a = a.filter(function(k) {
        return d.indexOf(k) === -1;
      }), a.forEach(function(k) {
        go(k) || (i && k.dependsOn === "recommend" ? i._hasRecommendWidget = !0 : i ? i._hasSearchWidget = !0 : k.dependsOn === "recommend" ? y = !0 : g = !0);
      }), i && d.length) {
        var f = d.reduce(function(k, E) {
          var S = E.dispose({
            helper: c,
            state: k.cleanedSearchState,
            recommendState: k.cleanedRecommendState,
            parent: h
          });
          return S instanceof $e.RecommendParameters ? k.cleanedRecommendState = S : S && (k.cleanedSearchState = S), k;
        }, {
          cleanedSearchState: c.state,
          cleanedRecommendState: c.recommendState
        }), F = f.cleanedSearchState, b = f.cleanedRecommendState, v = i.future.preserveSharedStateOnUnmount ? Ht(a, {
          uiState: s,
          initialSearchParameters: new $e.SearchParameters({
            index: this.getIndexName()
          })
        }) : Ht(a, {
          uiState: Lt(a, {
            searchParameters: F,
            helper: c
          }),
          initialSearchParameters: F
        });
        s = Lt(a, {
          searchParameters: v,
          helper: c
        }), c.setState(v), c.recommendState = b, a.length && i.scheduleSearch();
      }
      return this;
    },
    init: function(d) {
      var h = this, f, F = d.instantSearchInstance, b = d.parent, v = d.uiState;
      if (c === null) {
        i = F, l = b, s = v[n] || {};
        var k = F.mainHelper, E = Ht(a, {
          uiState: s,
          initialSearchParameters: new $e.SearchParameters({
            index: r
          })
        }), S = gg(a, {
          uiState: s,
          initialRecommendParameters: new $e.RecommendParameters()
        });
        c = $e({}, E.index, E), c.recommendState = S, c.search = function() {
          return F.onStateChange ? (F.onStateChange({
            uiState: F.mainIndex.getWidgetUiState({}),
            setUiState: function(O) {
              return F.setUiState(O, !1);
            }
          }), k) : k.search();
        }, c.searchWithoutTriggeringOnStateChange = function() {
          return k.search();
        }, c.searchForFacetValues = function(C, O, T, I) {
          var G = c.state.setQueryParameters(I);
          return k.searchForFacetValues(C, O, T, G);
        }, u = k.derive(function() {
          return $t.apply(void 0, [k.state].concat(Pf(sv(h))));
        }, function() {
          return h.getHelper().recommendState;
        });
        var B = (f = F._initialResults) === null || f === void 0 ? void 0 : f[this.getIndexId()];
        if (B != null && B.results) {
          var D = new $e.SearchResults(new $e.SearchParameters(B.state), B.results);
          u.lastResults = D, c.lastResults = D;
        }
        if (B != null && B.recommendResults) {
          var x = new $e.RecommendResults(new $e.RecommendParameters({
            params: B.recommendResults.params
          }), B.recommendResults.results);
          u.lastRecommendResults = x, c.lastRecommendResults = x;
        }
        c.on("change", function(C) {
          var O = C.isPageReset;
          O && wf(a);
        }), u.on("search", function() {
          F.scheduleStalledRender(), process.env.NODE_ENV === "development" && xy({
            index: h,
            indexUiState: s
          });
        }), u.on("result", function(C) {
          var O = C.results;
          F.scheduleRender(), c.lastResults = O, m = O == null ? void 0 : O._state;
        }), u.on("recommend:result", function(C) {
          var O = C.recommend;
          F.scheduleRender(), c.lastRecommendResults = O.results;
        }), a.forEach(function(C) {
          if (C.getRenderState) {
            var O = C.getRenderState(F.renderState[h.getIndexId()] || {}, Gt(F, h, v));
            rl({
              renderState: O,
              instantSearchInstance: F,
              parent: h
            });
          }
        }), a.forEach(function(C) {
          process.env.NODE_ENV === "development" && ue(
            // if it has NO getWidgetState or if it has getWidgetUiState, we don't warn
            // aka we warn if there's _only_ getWidgetState
            !C.getWidgetState || !!C.getWidgetUiState,
            "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."
          ), C.init && C.init(Gt(F, h, v));
        }), c.on("change", function(C) {
          var O = C.state, T = C._uiState;
          s = Lt(a, {
            searchParameters: O,
            helper: c
          }, T || {}), F.onStateChange || F.onInternalStateChange();
        }), B && F.scheduleRender(), y && (F._hasRecommendWidget = !0), g && (F._hasSearchWidget = !0);
      }
    },
    render: function(d) {
      var h, f = this, F = d.instantSearchInstance;
      F.status === "error" && !F.mainHelper.hasPendingRequests() && m && c.setState(m);
      var b = this.getResults() || (h = u) !== null && h !== void 0 && h.lastRecommendResults ? a : a.filter(go);
      b = b.filter(function(v) {
        return v.shouldRender ? v.shouldRender({
          instantSearchInstance: F
        }) : !0;
      }), b.forEach(function(v) {
        if (v.getRenderState) {
          var k = v.getRenderState(F.renderState[f.getIndexId()] || {}, Tp(F, f, v));
          rl({
            renderState: k,
            instantSearchInstance: F,
            parent: f
          });
        }
      }), b.forEach(function(v) {
        v.render && v.render(Tp(F, f, v));
      });
    },
    dispose: function() {
      var d = this, h, f;
      a.forEach(function(F) {
        F.dispose && c && F.dispose({
          helper: c,
          state: c.state,
          recommendState: c.recommendState,
          parent: d
        });
      }), i = null, l = null, (h = c) === null || h === void 0 || h.removeAllListeners(), c = null, (f = u) === null || f === void 0 || f.detach(), u = null;
    },
    getWidgetUiState: function(d) {
      return a.filter(go).reduce(function(h, f) {
        return f.getWidgetUiState(h);
      }, Vo(Vo({}, d), {}, mt({}, n, Vo(Vo({}, d[n]), s))));
    },
    getWidgetState: function(d) {
      return process.env.NODE_ENV === "development" && ue(!1, "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."), this.getWidgetUiState(d);
    },
    getWidgetSearchParameters: function(d, h) {
      var f = h.uiState;
      return Ht(a, {
        uiState: f,
        initialSearchParameters: d
      });
    },
    refreshUiState: function() {
      s = Lt(a, {
        searchParameters: this.getHelper().state,
        helper: this.getHelper()
      }, s);
    },
    setIndexUiState: function(d) {
      var h = typeof d == "function" ? d(s) : d;
      i.setUiState(function(f) {
        return Vo(Vo({}, f), {}, mt({}, n, h));
      });
    }
  };
};
function rl(o) {
  var e = o.renderState, r = o.instantSearchInstance, t = o.parent, n = t ? t.getIndexId() : r.mainIndex.getIndexId();
  r.renderState = Vo(Vo({}, r.renderState), {}, mt({}, n, Vo(Vo({}, r.renderState[n]), e)));
}
be({ name: "Index" }), De({ connector: function() {
  return Sf;
} }, { $$widgetType: "ais.index" });
var V6 = "ais", Zs = function(e) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r.descendantName, n = r.modifierName, a = t ? "-".concat(t) : "", s = n ? "--".concat(n) : "";
    return "".concat(V6, "-").concat(e).concat(a).concat(s);
  };
}, G6 = Zs("Highlight");
function Ef(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ue(!1, "`instantsearch.highlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Highlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = At(n._highlightResult, e);
  process.env.NODE_ENV === "development" && ue(i, 'Could not enable highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, m = G6({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(oo.highlightPreTag, "g"), "<".concat(t, ' class="').concat(m, '">')).replace(new RegExp(oo.highlightPostTag, "g"), "</".concat(t, ">"));
}
var Z6 = Zs("ReverseHighlight");
function xf(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ue(!1, "`instantsearch.reverseHighlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseHighlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = At(n._highlightResult, e);
  process.env.NODE_ENV === "development" && ue(i, 'Could not enable reverse highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, m = Z6({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), y = Ny(Vy(_c(u)));
  return y.replace(new RegExp(oo.highlightPreTag, "g"), "<".concat(t, ' class="').concat(m, '">')).replace(new RegExp(oo.highlightPostTag, "g"), "</".concat(t, ">"));
}
var X6 = Zs("Snippet");
function Af(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ue(!1, "`instantsearch.snippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Snippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = At(n._snippetResult, e);
  process.env.NODE_ENV === "development" && ue(i, 'Could not enable snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, m = X6({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(oo.highlightPreTag, "g"), "<".concat(t, ' class="').concat(m, '">')).replace(new RegExp(oo.highlightPostTag, "g"), "</".concat(t, ">"));
}
var q6 = Zs("ReverseSnippet");
function Cf(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && ue(!1, "`instantsearch.reverseSnippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseSnippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = At(n._snippetResult, e);
  process.env.NODE_ENV === "development" && ue(i, 'Could not enable reverse snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, m = q6({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), y = Ny(Vy(_c(u)));
  return y.replace(new RegExp(oo.highlightPreTag, "g"), "<".concat(t, ' class="').concat(m, '">')).replace(new RegExp(oo.highlightPostTag, "g"), "</".concat(t, ">"));
}
function cc(o) {
  "@babel/helpers - typeof";
  return cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cc(o);
}
var U6 = "_ALGOLIA";
function Y6(o) {
  if (!((typeof document > "u" ? "undefined" : cc(document)) !== "object" || typeof document.cookie != "string"))
    for (var e = "".concat(o, "="), r = document.cookie.split(";"), t = 0; t < r.length; t++) {
      for (var n = r[t]; n.charAt(0) === " "; )
        n = n.substring(1);
      if (n.indexOf(e) === 0)
        return n.substring(e.length, n.length);
    }
}
function Of() {
  return Y6(U6);
}
function J6() {
  return process.env.NODE_ENV === "development" && ue(!1, "`getInsightsAnonymousUserToken` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), Of();
}
var Q6 = ["page"];
function K6(o, e) {
  if (o == null) return {};
  var r = _6(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function _6(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function mg(o) {
  var e = o || {};
  e.page;
  var r = K6(e, Q6);
  return r;
}
function $6() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.key, r = ["ais.infiniteHits", e].filter(Boolean).join(":");
  return {
    read: function(n) {
      var a = n.state, s = Go(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (!s)
        return null;
      try {
        var i = JSON.parse(
          // @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
          s.getItem(r)
        );
        return i && Ur(i.state, mg(a)) ? i.hits : null;
      } catch (l) {
        if (l instanceof SyntaxError)
          try {
            s.removeItem(r);
          } catch {
          }
        return null;
      }
    },
    write: function(n) {
      var a = n.state, s = n.hits, i = Go(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (i)
        try {
          i.setItem(r, JSON.stringify({
            state: mg(a),
            hits: s
          }));
        } catch {
        }
    }
  };
}
var eB = tu();
const oB = /* @__PURE__ */ Ct(eB);
function rB() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(o) {
    var e = Math.random() * 16 | 0, r = o === "x" ? e : e & 3 | 8;
    return r.toString(16);
  });
}
function Yn(o) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yn(o);
}
function yg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function xr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yg(Object(r), !0).forEach(function(t) {
      tB(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : yg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function tB(o, e, r) {
  return e = nB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function nB(o) {
  var e = aB(o, "string");
  return Yn(e) == "symbol" ? e : String(e);
}
function aB(o, e) {
  if (Yn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Yn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function hr(o, e) {
  return lB(o) || iB(o, e) || Tf(o, e) || sB();
}
function sB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iB(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function lB(o) {
  if (Array.isArray(o)) return o;
}
function cB(o) {
  return dB(o) || pB(o) || Tf(o) || uB();
}
function uB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tf(o, e) {
  if (o) {
    if (typeof o == "string") return uc(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uc(o, e);
  }
}
function pB(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function dB(o) {
  if (Array.isArray(o)) return uc(o);
}
function uc(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var jf = "2.17.2", gB = "https://cdn.jsdelivr.net/npm/search-insights@".concat(jf, "/dist/search-insights.min.js");
function fg() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.insightsClient, r = o.insightsInitParams, t = o.onEvent, n = o.$$internal, a = n === void 0 ? !1 : n, s = o.$$automatic, i = s === void 0 ? !1 : s, l = e;
  !e && e !== null && Go(function(u) {
    var m = u.window, y = m.AlgoliaAnalyticsObject || "aa";
    typeof y == "string" && (l = m[y]), l || (m.AlgoliaAnalyticsObject = y, m[y] || (m[y] = function() {
      m[y].queue || (m[y].queue = []);
      for (var g = arguments.length, p = new Array(g), d = 0; d < g; d++)
        p[d] = arguments[d];
      m[y].queue.push(p);
    }, m[y].version = jf, m[y].shouldAddScript = !0), l = m[y]);
  });
  var c = l || fe;
  return function(u) {
    var m = u.instantSearchInstance, y = m.middleware.filter(function(D) {
      return D.instance.$$type === "ais.insights" && D.instance.$$internal;
    }).map(function(D) {
      return D.creator;
    });
    m.unuse.apply(m, cB(y));
    var g = y2(m.client), p = hr(g, 2), d = p[0], h = p[1];
    process.env.NODE_ENV === "development" && ue(!!(d && h), "could not extract Algolia credentials from searchClient in insights middleware.");
    var f = void 0, F = void 0, b = void 0, v = c.queue;
    if (Array.isArray(v)) {
      var k = ["setUserToken", "init"].map(function(D) {
        var x = ir(v.slice().reverse(), function(T) {
          var I = hr(T, 1), G = I[0];
          return G === D;
        }) || [], C = hr(x, 2), O = C[1];
        return O;
      }), E = hr(k, 2);
      F = E[0], f = E[1];
    }
    c("getUserToken", null, function(D, x) {
      b = Fg(x);
    }), (r || !hg(c)) && c("init", xr({
      appId: d,
      apiKey: h,
      partial: !0
    }, r));
    var S, B;
    return {
      $$type: "ais.insights",
      $$internal: a,
      $$automatic: i,
      onStateChange: function() {
      },
      subscribe: function() {
        if (c.shouldAddScript) {
          var x = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
          try {
            var C = document.createElement("script");
            C.async = !0, C.src = gB, C.onerror = function() {
              m.emit("error", new Error(x));
            }, document.body.appendChild(C), c.shouldAddScript = !1;
          } catch {
            c.shouldAddScript = !1, m.emit("error", new Error(x));
          }
        }
      },
      started: function() {
        c("addAlgoliaAgent", "insights-middleware"), B = m.mainHelper;
        var x = c.queue;
        if (Array.isArray(x)) {
          var C = ["setUserToken", "init"].map(function(X) {
            var q = ir(x.slice().reverse(), function(me) {
              var Se = hr(me, 1), Ee = Se[0];
              return Ee === X;
            }) || [], J = hr(q, 2), ee = J[1];
            return ee;
          }), O = hr(C, 2);
          F = O[0], f = O[1];
        }
        S = mB(m), i || B.overrideStateWithoutTriggeringChangeEvent(xr(xr({}, B.state), {}, {
          clickAnalytics: !0
        })), a || m.scheduleSearch();
        var T = function(q) {
          var J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ee = Fg(q);
          if (!ee)
            return;
          var me = B.state.userToken;
          function Se() {
            B.overrideStateWithoutTriggeringChangeEvent(xr(xr({}, B.state), {}, {
              userToken: ee
            })), me && me !== q && m.scheduleSearch();
          }
          J ? Se() : setTimeout(Se, 0);
        };
        function I(X) {
          T(X, !0), c("setUserToken", X);
        }
        var G = void 0, U = Of();
        if (U)
          G = U;
        else {
          var N = "anonymous-".concat(rB());
          G = N;
        }
        var z, V = S.userToken;
        if (r != null && r.userToken && (z = r.userToken), z)
          I(z);
        else if (V)
          I(V);
        else if (b)
          I(b);
        else if (F)
          I(F);
        else if (G) {
          var Y;
          if (I(G), r != null && r.useCookie || (Y = f) !== null && Y !== void 0 && Y.useCookie) {
            var K;
            yB(G, (r == null ? void 0 : r.cookieDuration) || ((K = f) === null || K === void 0 ? void 0 : K.cookieDuration));
          }
        }
        c("onUserTokenChange", function(X) {
          return T(X, !0);
        }, {
          immediate: !0
        });
        var $ = c;
        hg(c) && ($ = function(q, J) {
          var ee = {
            headers: {
              "X-Algolia-Application-Id": d,
              "X-Algolia-API-Key": h
            }
          };
          return c(q, J, ee);
        });
        var te = /* @__PURE__ */ new Set(), ge;
        m.mainHelper.derivedHelpers[0].on("result", function(X) {
          var q = X.results;
          q && (!q.queryID || q.queryID !== ge) && (ge = q.queryID, te.clear());
        }), m.sendEventToInsights = function(X) {
          if (t)
            t(X, $);
          else if (X.insightsMethod) {
            if (X.insightsMethod === "viewedObjectIDs") {
              var q = X.payload, J = q.objectIDs.filter(function(ee) {
                return !te.has(ee);
              });
              if (J.length === 0)
                return;
              J.forEach(function(ee) {
                return te.add(ee);
              }), q.objectIDs = J;
            }
            X.payload.algoliaSource = ["instantsearch"], i && X.payload.algoliaSource.push("instantsearch-automatic"), X.eventModifier === "internal" && X.payload.algoliaSource.push("instantsearch-internal"), $(X.insightsMethod, X.payload), process.env.NODE_ENV === "development" && ue(!!B.state.userToken, `
Cannot send event to Algolia Insights because \`userToken\` is not set.

See documentation: https://www.algolia.com/doc/guides/building-search-ui/going-further/send-insights-events/js/#setting-the-usertoken
`);
          } else
            process.env.NODE_ENV === "development" && ue(!1, "Cannot send event to Algolia Insights because `insightsMethod` option is missing.");
        };
      },
      unsubscribe: function() {
        c("onUserTokenChange", void 0), m.sendEventToInsights = fe, B && S && (B.overrideStateWithoutTriggeringChangeEvent(xr(xr({}, B.state), S)), m.scheduleSearch());
      }
    };
  };
}
function mB(o) {
  var e, r, t = ((e = o._initialResults) === null || e === void 0 || (r = e[o.indexName]) === null || r === void 0 ? void 0 : r.state) || {}, n = o.mainHelper.state;
  return {
    userToken: t.userToken || n.userToken,
    clickAnalytics: t.clickAnalytics || n.clickAnalytics
  };
}
function yB(o, e) {
  var r = 2592e6, t = /* @__PURE__ */ new Date();
  t.setTime(t.getTime() + (e || r * 6));
  var n = "expires=".concat(t.toUTCString());
  document.cookie = "_ALGOLIA=".concat(o, ";").concat(n, ";path=/");
}
function hg(o) {
  var e = (o.version || "").split(".").map(Number), r = hr(e, 2), t = r[0], n = r[1], a = t >= 3, s = t === 2 && n >= 6, i = t === 1 && n >= 10;
  return a || s || i;
}
function Fg(o) {
  if (o)
    return typeof o == "number" ? o.toString() : o;
}
function Mf(o, e, r) {
  var t = Gt(e, e.mainIndex, e._initialUiState);
  o.forEach(function(n) {
    var a = {};
    if (n.getWidgetRenderState) {
      var s = n.getWidgetRenderState(t);
      s && s.widgetParams && (a = s.widgetParams);
    }
    var i = Object.keys(a).filter(function(l) {
      return a[l] !== void 0;
    });
    r.widgets.push({
      type: n.$$type,
      widgetType: n.$$widgetType,
      params: i
    }), n.$$type === "ais.index" && Mf(n.getWidgets(), e, r);
  });
}
function fB() {
  return Go(function(o) {
    var e, r, t = o.window;
    return ((e = t.navigator) === null || e === void 0 || (r = e.userAgent) === null || r === void 0 ? void 0 : r.indexOf("Algolia Crawler")) > -1;
  }, {
    fallback: function() {
      return !1;
    }
  });
}
function hB() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.$$internal, r = e === void 0 ? !1 : e;
  return function(t) {
    var n = t.instantSearchInstance, a = {
      widgets: []
    }, s = document.createElement("meta"), i = document.querySelector("head");
    return s.name = "instantsearch:widgets", {
      $$type: "ais.metadata",
      $$internal: r,
      onStateChange: function() {
      },
      subscribe: function() {
        setTimeout(function() {
          var c = n.client;
          a.ua = c.transporter && c.transporter.userAgent ? c.transporter.userAgent.value : c._ua, Mf(n.mainIndex.getWidgets(), n, a), n.middleware.forEach(function(u) {
            return a.widgets.push({
              middleware: !0,
              type: u.instance.$$type,
              internal: u.instance.$$internal
            });
          }), s.content = JSON.stringify(a), i.appendChild(s);
        }, 0);
      },
      started: function() {
      },
      unsubscribe: function() {
        s.remove();
      }
    };
  };
}
var tl, bg;
function cu() {
  if (bg) return tl;
  bg = 1;
  var o = String.prototype.replace, e = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return tl = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(t) {
        return o.call(t, e, "+");
      },
      RFC3986: function(t) {
        return String(t);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, tl;
}
var nl, vg;
function zf() {
  if (vg) return nl;
  vg = 1;
  var o = cu(), e = Object.prototype.hasOwnProperty, r = Array.isArray, t = function() {
    for (var d = [], h = 0; h < 256; ++h)
      d.push("%" + ((h < 16 ? "0" : "") + h.toString(16)).toUpperCase());
    return d;
  }(), n = function(h) {
    for (; h.length > 1; ) {
      var f = h.pop(), F = f.obj[f.prop];
      if (r(F)) {
        for (var b = [], v = 0; v < F.length; ++v)
          typeof F[v] < "u" && b.push(F[v]);
        f.obj[f.prop] = b;
      }
    }
  }, a = function(h, f) {
    for (var F = f && f.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, b = 0; b < h.length; ++b)
      typeof h[b] < "u" && (F[b] = h[b]);
    return F;
  }, s = function d(h, f, F) {
    if (!f)
      return h;
    if (typeof f != "object") {
      if (r(h))
        h.push(f);
      else if (h && typeof h == "object")
        (F && (F.plainObjects || F.allowPrototypes) || !e.call(Object.prototype, f)) && (h[f] = !0);
      else
        return [h, f];
      return h;
    }
    if (!h || typeof h != "object")
      return [h].concat(f);
    var b = h;
    return r(h) && !r(f) && (b = a(h, F)), r(h) && r(f) ? (f.forEach(function(v, k) {
      if (e.call(h, k)) {
        var E = h[k];
        E && typeof E == "object" && v && typeof v == "object" ? h[k] = d(E, v, F) : h.push(v);
      } else
        h[k] = v;
    }), h) : Object.keys(f).reduce(function(v, k) {
      var E = f[k];
      return e.call(v, k) ? v[k] = d(v[k], E, F) : v[k] = E, v;
    }, b);
  }, i = function(h, f) {
    return Object.keys(f).reduce(function(F, b) {
      return F[b] = f[b], F;
    }, h);
  }, l = function(d, h, f) {
    var F = d.replace(/\+/g, " ");
    if (f === "iso-8859-1")
      return F.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(F);
    } catch {
      return F;
    }
  }, c = function(h, f, F, b, v) {
    if (h.length === 0)
      return h;
    var k = h;
    if (typeof h == "symbol" ? k = Symbol.prototype.toString.call(h) : typeof h != "string" && (k = String(h)), F === "iso-8859-1")
      return escape(k).replace(/%u[0-9a-f]{4}/gi, function(D) {
        return "%26%23" + parseInt(D.slice(2), 16) + "%3B";
      });
    for (var E = "", S = 0; S < k.length; ++S) {
      var B = k.charCodeAt(S);
      if (B === 45 || B === 46 || B === 95 || B === 126 || B >= 48 && B <= 57 || B >= 65 && B <= 90 || B >= 97 && B <= 122 || v === o.RFC1738 && (B === 40 || B === 41)) {
        E += k.charAt(S);
        continue;
      }
      if (B < 128) {
        E = E + t[B];
        continue;
      }
      if (B < 2048) {
        E = E + (t[192 | B >> 6] + t[128 | B & 63]);
        continue;
      }
      if (B < 55296 || B >= 57344) {
        E = E + (t[224 | B >> 12] + t[128 | B >> 6 & 63] + t[128 | B & 63]);
        continue;
      }
      S += 1, B = 65536 + ((B & 1023) << 10 | k.charCodeAt(S) & 1023), E += t[240 | B >> 18] + t[128 | B >> 12 & 63] + t[128 | B >> 6 & 63] + t[128 | B & 63];
    }
    return E;
  }, u = function(h) {
    for (var f = [{ obj: { o: h }, prop: "o" }], F = [], b = 0; b < f.length; ++b)
      for (var v = f[b], k = v.obj[v.prop], E = Object.keys(k), S = 0; S < E.length; ++S) {
        var B = E[S], D = k[B];
        typeof D == "object" && D !== null && F.indexOf(D) === -1 && (f.push({ obj: k, prop: B }), F.push(D));
      }
    return n(f), h;
  }, m = function(h) {
    return Object.prototype.toString.call(h) === "[object RegExp]";
  }, y = function(h) {
    return !h || typeof h != "object" ? !1 : !!(h.constructor && h.constructor.isBuffer && h.constructor.isBuffer(h));
  }, g = function(h, f) {
    return [].concat(h, f);
  }, p = function(h, f) {
    if (r(h)) {
      for (var F = [], b = 0; b < h.length; b += 1)
        F.push(f(h[b]));
      return F;
    }
    return f(h);
  };
  return nl = {
    arrayToObject: a,
    assign: i,
    combine: g,
    compact: u,
    decode: l,
    encode: c,
    isBuffer: y,
    isRegExp: m,
    maybeMap: p,
    merge: s
  }, nl;
}
var al, Pg;
function FB() {
  if (Pg) return al;
  Pg = 1;
  var o = zf(), e = cu(), r = Object.prototype.hasOwnProperty, t = {
    brackets: function(d) {
      return d + "[]";
    },
    comma: "comma",
    indices: function(d, h) {
      return d + "[" + h + "]";
    },
    repeat: function(d) {
      return d;
    }
  }, n = Array.isArray, a = String.prototype.split, s = Array.prototype.push, i = function(p, d) {
    s.apply(p, n(d) ? d : [d]);
  }, l = Date.prototype.toISOString, c = e.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: o.encode,
    encodeValuesOnly: !1,
    format: c,
    formatter: e.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(d) {
      return l.call(d);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, m = function(d) {
    return typeof d == "string" || typeof d == "number" || typeof d == "boolean" || typeof d == "symbol" || typeof d == "bigint";
  }, y = function p(d, h, f, F, b, v, k, E, S, B, D, x, C, O) {
    var T = d;
    if (typeof k == "function" ? T = k(h, T) : T instanceof Date ? T = B(T) : f === "comma" && n(T) && (T = o.maybeMap(T, function(X) {
      return X instanceof Date ? B(X) : X;
    })), T === null) {
      if (F)
        return v && !C ? v(h, u.encoder, O, "key", D) : h;
      T = "";
    }
    if (m(T) || o.isBuffer(T)) {
      if (v) {
        var I = C ? h : v(h, u.encoder, O, "key", D);
        if (f === "comma" && C) {
          for (var G = a.call(String(T), ","), U = "", N = 0; N < G.length; ++N)
            U += (N === 0 ? "" : ",") + x(v(G[N], u.encoder, O, "value", D));
          return [x(I) + "=" + U];
        }
        return [x(I) + "=" + x(v(T, u.encoder, O, "value", D))];
      }
      return [x(h) + "=" + x(String(T))];
    }
    var z = [];
    if (typeof T > "u")
      return z;
    var V;
    if (f === "comma" && n(T))
      V = [{ value: T.length > 0 ? T.join(",") || null : void 0 }];
    else if (n(k))
      V = k;
    else {
      var Y = Object.keys(T);
      V = E ? Y.sort(E) : Y;
    }
    for (var K = 0; K < V.length; ++K) {
      var $ = V[K], te = typeof $ == "object" && typeof $.value < "u" ? $.value : T[$];
      if (!(b && te === null)) {
        var ge = n(T) ? typeof f == "function" ? f(h, $) : h : h + (S ? "." + $ : "[" + $ + "]");
        i(z, p(
          te,
          ge,
          f,
          F,
          b,
          v,
          k,
          E,
          S,
          B,
          D,
          x,
          C,
          O
        ));
      }
    }
    return z;
  }, g = function(d) {
    if (!d)
      return u;
    if (d.encoder !== null && typeof d.encoder < "u" && typeof d.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var h = d.charset || u.charset;
    if (typeof d.charset < "u" && d.charset !== "utf-8" && d.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var f = e.default;
    if (typeof d.format < "u") {
      if (!r.call(e.formatters, d.format))
        throw new TypeError("Unknown format option provided.");
      f = d.format;
    }
    var F = e.formatters[f], b = u.filter;
    return (typeof d.filter == "function" || n(d.filter)) && (b = d.filter), {
      addQueryPrefix: typeof d.addQueryPrefix == "boolean" ? d.addQueryPrefix : u.addQueryPrefix,
      allowDots: typeof d.allowDots > "u" ? u.allowDots : !!d.allowDots,
      charset: h,
      charsetSentinel: typeof d.charsetSentinel == "boolean" ? d.charsetSentinel : u.charsetSentinel,
      delimiter: typeof d.delimiter > "u" ? u.delimiter : d.delimiter,
      encode: typeof d.encode == "boolean" ? d.encode : u.encode,
      encoder: typeof d.encoder == "function" ? d.encoder : u.encoder,
      encodeValuesOnly: typeof d.encodeValuesOnly == "boolean" ? d.encodeValuesOnly : u.encodeValuesOnly,
      filter: b,
      format: f,
      formatter: F,
      serializeDate: typeof d.serializeDate == "function" ? d.serializeDate : u.serializeDate,
      skipNulls: typeof d.skipNulls == "boolean" ? d.skipNulls : u.skipNulls,
      sort: typeof d.sort == "function" ? d.sort : null,
      strictNullHandling: typeof d.strictNullHandling == "boolean" ? d.strictNullHandling : u.strictNullHandling
    };
  };
  return al = function(p, d) {
    var h = p, f = g(d), F, b;
    typeof f.filter == "function" ? (b = f.filter, h = b("", h)) : n(f.filter) && (b = f.filter, F = b);
    var v = [];
    if (typeof h != "object" || h === null)
      return "";
    var k;
    d && d.arrayFormat in t ? k = d.arrayFormat : d && "indices" in d ? k = d.indices ? "indices" : "repeat" : k = "indices";
    var E = t[k];
    F || (F = Object.keys(h)), f.sort && F.sort(f.sort);
    for (var S = 0; S < F.length; ++S) {
      var B = F[S];
      f.skipNulls && h[B] === null || i(v, y(
        h[B],
        B,
        E,
        f.strictNullHandling,
        f.skipNulls,
        f.encode ? f.encoder : null,
        f.filter,
        f.sort,
        f.allowDots,
        f.serializeDate,
        f.format,
        f.formatter,
        f.encodeValuesOnly,
        f.charset
      ));
    }
    var D = v.join(f.delimiter), x = f.addQueryPrefix === !0 ? "?" : "";
    return f.charsetSentinel && (f.charset === "iso-8859-1" ? x += "utf8=%26%2310003%3B&" : x += "utf8=%E2%9C%93&"), D.length > 0 ? x + D : "";
  }, al;
}
var sl, Bg;
function bB() {
  if (Bg) return sl;
  Bg = 1;
  var o = zf(), e = Object.prototype.hasOwnProperty, r = Array.isArray, t = {
    allowDots: !1,
    allowPrototypes: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: o.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, n = function(y) {
    return y.replace(/&#(\d+);/g, function(g, p) {
      return String.fromCharCode(parseInt(p, 10));
    });
  }, a = function(y, g) {
    return y && typeof y == "string" && g.comma && y.indexOf(",") > -1 ? y.split(",") : y;
  }, s = "utf8=%26%2310003%3B", i = "utf8=%E2%9C%93", l = function(g, p) {
    var d = {}, h = p.ignoreQueryPrefix ? g.replace(/^\?/, "") : g, f = p.parameterLimit === 1 / 0 ? void 0 : p.parameterLimit, F = h.split(p.delimiter, f), b = -1, v, k = p.charset;
    if (p.charsetSentinel)
      for (v = 0; v < F.length; ++v)
        F[v].indexOf("utf8=") === 0 && (F[v] === i ? k = "utf-8" : F[v] === s && (k = "iso-8859-1"), b = v, v = F.length);
    for (v = 0; v < F.length; ++v)
      if (v !== b) {
        var E = F[v], S = E.indexOf("]="), B = S === -1 ? E.indexOf("=") : S + 1, D, x;
        B === -1 ? (D = p.decoder(E, t.decoder, k, "key"), x = p.strictNullHandling ? null : "") : (D = p.decoder(E.slice(0, B), t.decoder, k, "key"), x = o.maybeMap(
          a(E.slice(B + 1), p),
          function(C) {
            return p.decoder(C, t.decoder, k, "value");
          }
        )), x && p.interpretNumericEntities && k === "iso-8859-1" && (x = n(x)), E.indexOf("[]=") > -1 && (x = r(x) ? [x] : x), e.call(d, D) ? d[D] = o.combine(d[D], x) : d[D] = x;
      }
    return d;
  }, c = function(y, g, p, d) {
    for (var h = d ? g : a(g, p), f = y.length - 1; f >= 0; --f) {
      var F, b = y[f];
      if (b === "[]" && p.parseArrays)
        F = [].concat(h);
      else {
        F = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var v = b.charAt(0) === "[" && b.charAt(b.length - 1) === "]" ? b.slice(1, -1) : b, k = parseInt(v, 10);
        !p.parseArrays && v === "" ? F = { 0: h } : !isNaN(k) && b !== v && String(k) === v && k >= 0 && p.parseArrays && k <= p.arrayLimit ? (F = [], F[k] = h) : v !== "__proto__" && (F[v] = h);
      }
      h = F;
    }
    return h;
  }, u = function(g, p, d, h) {
    if (g) {
      var f = d.allowDots ? g.replace(/\.([^.[]+)/g, "[$1]") : g, F = /(\[[^[\]]*])/, b = /(\[[^[\]]*])/g, v = d.depth > 0 && F.exec(f), k = v ? f.slice(0, v.index) : f, E = [];
      if (k) {
        if (!d.plainObjects && e.call(Object.prototype, k) && !d.allowPrototypes)
          return;
        E.push(k);
      }
      for (var S = 0; d.depth > 0 && (v = b.exec(f)) !== null && S < d.depth; ) {
        if (S += 1, !d.plainObjects && e.call(Object.prototype, v[1].slice(1, -1)) && !d.allowPrototypes)
          return;
        E.push(v[1]);
      }
      return v && E.push("[" + f.slice(v.index) + "]"), c(E, p, d, h);
    }
  }, m = function(g) {
    if (!g)
      return t;
    if (g.decoder !== null && g.decoder !== void 0 && typeof g.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof g.charset < "u" && g.charset !== "utf-8" && g.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var p = typeof g.charset > "u" ? t.charset : g.charset;
    return {
      allowDots: typeof g.allowDots > "u" ? t.allowDots : !!g.allowDots,
      allowPrototypes: typeof g.allowPrototypes == "boolean" ? g.allowPrototypes : t.allowPrototypes,
      arrayLimit: typeof g.arrayLimit == "number" ? g.arrayLimit : t.arrayLimit,
      charset: p,
      charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : t.charsetSentinel,
      comma: typeof g.comma == "boolean" ? g.comma : t.comma,
      decoder: typeof g.decoder == "function" ? g.decoder : t.decoder,
      delimiter: typeof g.delimiter == "string" || o.isRegExp(g.delimiter) ? g.delimiter : t.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof g.depth == "number" || g.depth === !1 ? +g.depth : t.depth,
      ignoreQueryPrefix: g.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof g.interpretNumericEntities == "boolean" ? g.interpretNumericEntities : t.interpretNumericEntities,
      parameterLimit: typeof g.parameterLimit == "number" ? g.parameterLimit : t.parameterLimit,
      parseArrays: g.parseArrays !== !1,
      plainObjects: typeof g.plainObjects == "boolean" ? g.plainObjects : t.plainObjects,
      strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : t.strictNullHandling
    };
  };
  return sl = function(y, g) {
    var p = m(g);
    if (y === "" || y === null || typeof y > "u")
      return p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var d = typeof y == "string" ? l(y, p) : y, h = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, f = Object.keys(d), F = 0; F < f.length; ++F) {
      var b = f[F], v = u(b, d[b], p, typeof y == "string");
      h = o.merge(h, v, p);
    }
    return o.compact(h);
  }, sl;
}
var il, kg;
function vB() {
  if (kg) return il;
  kg = 1;
  var o = FB(), e = bB(), r = cu();
  return il = {
    formats: r,
    parse: e,
    stringify: o
  }, il;
}
var PB = vB();
const wg = /* @__PURE__ */ Ct(PB);
function Jn(o) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jn(o);
}
function BB(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function kB(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, Nf(t.key), t);
  }
}
function wB(o, e, r) {
  return e && kB(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function ao(o, e, r) {
  return e = Nf(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Nf(o) {
  var e = DB(o, "string");
  return Jn(e) == "symbol" ? e : String(e);
}
function DB(o, e) {
  if (Jn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Jn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Dg = function(e) {
  e && (window.document.title = e);
}, SB = /* @__PURE__ */ function() {
  function o(e) {
    var r = this, t = e.windowTitle, n = e.writeDelay, a = n === void 0 ? 400 : n, s = e.createURL, i = e.parseURL, l = e.getLocation, c = e.start, u = e.dispose, m = e.push, y = e.cleanUrlOnDispose;
    BB(this, o), ao(this, "$$type", "ais.browser"), ao(this, "windowTitle", void 0), ao(this, "writeDelay", void 0), ao(this, "_createURL", void 0), ao(this, "parseURL", void 0), ao(this, "getLocation", void 0), ao(this, "writeTimer", void 0), ao(this, "_onPopState", void 0), ao(this, "inPopState", !1), ao(this, "isDisposed", !1), ao(this, "latestAcknowledgedHistory", 0), ao(this, "_start", void 0), ao(this, "_dispose", void 0), ao(this, "_push", void 0), ao(this, "_cleanUrlOnDispose", void 0), this.windowTitle = t, this.writeTimer = void 0, this.writeDelay = a, this._createURL = s, this.parseURL = i, this.getLocation = l, this._start = c, this._dispose = u, this._push = m, this._cleanUrlOnDispose = typeof y > "u" ? !0 : y, process.env.NODE_ENV === "development" && typeof y > "u" && console.info(`Starting from the next major version, InstantSearch will not clean up the URL from active refinements when it is disposed.

We recommend setting \`cleanUrlOnDispose\` to false to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to true.

See documentation: `.concat(gn({
      name: "history-router"
    }), "#widget-param-cleanurlondispose")), Go(function(g) {
      var p = g.window, d = r.windowTitle && r.windowTitle(r.read());
      Dg(d), r.latestAcknowledgedHistory = p.history.length;
    });
  }
  return wB(o, [{
    key: "read",
    value: function() {
      return this.parseURL({
        qsModule: wg,
        location: this.getLocation()
      });
    }
    /**
     * Pushes a search state into the URL.
     */
  }, {
    key: "write",
    value: function(r) {
      var t = this;
      Go(function(n) {
        var a = n.window, s = t.createURL(r), i = t.windowTitle && t.windowTitle(r);
        t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function() {
          Dg(i), t.shouldWrite(s) && (t._push ? t._push(s) : a.history.pushState(r, i || "", s), t.latestAcknowledgedHistory = a.history.length), t.inPopState = !1, t.writeTimer = void 0;
        }, t.writeDelay);
      });
    }
    /**
     * Sets a callback on the `onpopstate` event of the history API of the current page.
     * It enables the URL sync to keep track of the changes.
     */
  }, {
    key: "onUpdate",
    value: function(r) {
      var t = this;
      this._start && this._start(function() {
        r(t.read());
      }), this._onPopState = function() {
        t.writeTimer && (clearTimeout(t.writeTimer), t.writeTimer = void 0), t.inPopState = !0, r(t.read());
      }, Go(function(n) {
        var a = n.window;
        a.addEventListener("popstate", t._onPopState);
      });
    }
    /**
     * Creates a complete URL from a given syncable UI state.
     *
     * It always generates the full URL, not a relative one.
     * This allows to handle cases like using a <base href>.
     * See: https://github.com/algolia/instantsearch/issues/790
     */
  }, {
    key: "createURL",
    value: function(r) {
      var t = this._createURL({
        qsModule: wg,
        routeState: r,
        location: this.getLocation()
      });
      if (process.env.NODE_ENV === "development")
        try {
          new URL(t);
        } catch {
          process.env.NODE_ENV === "development" && ue(!1, "The URL returned by the `createURL` function is invalid.\nPlease make sure it returns an absolute URL to avoid issues, e.g: `https://algolia.com/search?query=iphone`.");
        }
      return t;
    }
    /**
     * Removes the event listener and cleans up the URL.
     */
  }, {
    key: "dispose",
    value: function() {
      var r = this;
      this._dispose && this._dispose(), this.isDisposed = !0, Go(function(t) {
        var n = t.window;
        r._onPopState && n.removeEventListener("popstate", r._onPopState);
      }), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
    }
  }, {
    key: "start",
    value: function() {
      this.isDisposed = !1;
    }
  }, {
    key: "shouldWrite",
    value: function(r) {
      var t = this;
      return Go(function(n) {
        var a = n.window;
        if (t.isDisposed && !t._cleanUrlOnDispose)
          return !1;
        var s = !(t.isDisposed && t.latestAcknowledgedHistory !== a.history.length);
        return (
          // When the last state change was through popstate, the IS.js state changes,
          // but that should not write the URL.
          !t.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
          s && // When the URL is the same as the current one, we do not want to write it.
          r !== a.location.href
        );
      });
    }
  }]), o;
}();
function EB() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.createURL, r = e === void 0 ? function(p) {
    var d = p.qsModule, h = p.routeState, f = p.location, F = f.protocol, b = f.hostname, v = f.port, k = v === void 0 ? "" : v, E = f.pathname, S = f.hash, B = d.stringify(h), D = k === "" ? "" : ":".concat(k);
    return B ? "".concat(F, "//").concat(b).concat(D).concat(E, "?").concat(B).concat(S) : "".concat(F, "//").concat(b).concat(D).concat(E).concat(S);
  } : e, t = o.parseURL, n = t === void 0 ? function(p) {
    var d = p.qsModule, h = p.location;
    return d.parse(h.search.slice(1), {
      arrayLimit: 99
    });
  } : t, a = o.writeDelay, s = a === void 0 ? 400 : a, i = o.windowTitle, l = o.getLocation, c = l === void 0 ? function() {
    return Go(function(p) {
      var d = p.window;
      return d.location;
    }, {
      fallback: function() {
        throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
      }
    });
  } : l, u = o.start, m = o.dispose, y = o.push, g = o.cleanUrlOnDispose;
  return new SB({
    createURL: r,
    parseURL: n,
    writeDelay: s,
    windowTitle: i,
    getLocation: c,
    start: u,
    dispose: m,
    push: y,
    cleanUrlOnDispose: g
  });
}
function Qn(o) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qn(o);
}
var xB = ["configure"];
function Sg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ha(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sg(Object(r), !0).forEach(function(t) {
      pc(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Sg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function pc(o, e, r) {
  return e = AB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function AB(o) {
  var e = CB(o, "string");
  return Qn(e) == "symbol" ? e : String(e);
}
function CB(o, e) {
  if (Qn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Qn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function OB(o, e) {
  if (o == null) return {};
  var r = TB(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function TB(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function Eg(o) {
  o.configure;
  var e = OB(o, xB);
  return e;
}
function jB() {
  return {
    $$type: "ais.simple",
    stateToRoute: function(e) {
      return Object.keys(e).reduce(function(r, t) {
        return Ha(Ha({}, r), {}, pc({}, t, Eg(e[t])));
      }, {});
    },
    routeToState: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Object.keys(e).reduce(function(r, t) {
        return Ha(Ha({}, r), {}, pc({}, t, Eg(e[t])));
      }, {});
    }
  };
}
function Kn(o) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kn(o);
}
function xg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Wa(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xg(Object(r), !0).forEach(function(t) {
      If(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : xg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function If(o, e, r) {
  return e = MB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function MB(o) {
  var e = zB(o, "string");
  return Kn(e) == "symbol" ? e : String(e);
}
function zB(o, e) {
  if (Kn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Kn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var NB = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.router, t = r === void 0 ? EB() : r, n = e.stateMapping, a = n === void 0 ? jB() : n, s = e.$$internal, i = s === void 0 ? !1 : s;
  return function(l) {
    var c = l.instantSearchInstance;
    function u(g) {
      var p = (
        // If only the mainIndex is initialized, we don't yet know what other
        // index widgets are used. Therefore we fall back to the initialUiState.
        // We can't indiscriminately use the initialUiState because then we
        // reintroduce state that was changed by the user.
        // When there are no widgets, we are sure the user can't yet have made
        // any changes.
        c.mainIndex.getWidgets().length === 0 ? c._initialUiState : c.mainIndex.getWidgetUiState({})
      ), d = Object.keys(g).reduce(function(f, F) {
        return Wa(Wa({}, f), {}, If({}, F, g[F]));
      }, p), h = a.stateToRoute(d);
      return t.createURL(h);
    }
    c._createURL = u;
    var m = void 0, y = c._initialUiState;
    return {
      $$type: "ais.router({router:".concat(t.$$type || "__unknown__", ", stateMapping:").concat(a.$$type || "__unknown__", "})"),
      $$internal: i,
      onStateChange: function(p) {
        var d = p.uiState, h = a.stateToRoute(d);
        (m === void 0 || !Ur(m, h)) && (t.write(h), m = h);
      },
      subscribe: function() {
        process.env.NODE_ENV === "development" && ue(Object.keys(y).length === 0, "Using `initialUiState` together with routing is not recommended. The `initialUiState` will be overwritten by the URL parameters."), c._initialUiState = Wa(Wa({}, y), a.routeToState(t.read())), t.onUpdate(function(p) {
          c.mainIndex.getWidgets().length > 0 && c.setUiState(a.routeToState(p));
        });
      },
      started: function() {
        var p;
        (p = t.start) === null || p === void 0 || p.call(t);
      },
      unsubscribe: function() {
        t.dispose();
      }
    };
  };
};
function IB(o, e) {
  return o.toLocaleString(e);
}
function _n(o) {
  "@babel/helpers - typeof";
  return _n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _n(o);
}
function Ag(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function _o(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ag(Object(r), !0).forEach(function(t) {
      RB(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ag(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function RB(o, e, r) {
  return e = LB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function LB(o) {
  var e = HB(o, "string");
  return _n(e) == "symbol" ? e : String(e);
}
function HB(o, e) {
  if (_n(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (_n(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function WB(o) {
  var e = o.numberLocale;
  return {
    formatNumber: function(t, n) {
      return IB(Number(n(t)), e);
    },
    highlight: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(Ef(_o(_o({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The highlight helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseHighlight: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(xf(_o(_o({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseHighlight helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    snippet: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(Af(_o(_o({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The snippet helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseSnippet: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(Cf(_o(_o({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseSnippet helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    insights: function(t, n) {
      try {
        var a = JSON.parse(t), s = a.method, i = a.payload;
        return n(nf(s, _o({
          objectIDs: [this.objectID]
        }, i)));
      } catch {
        throw new Error(`
The insights helper expects a JSON object of the format:
{ "method": "method-name", "payload": { "eventName": "name of the event" } }`);
      }
    }
  };
}
const Rf = "4.77.3";
function Bt(o) {
  "@babel/helpers - typeof";
  return Bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bt(o);
}
function Cg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ll(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cg(Object(r), !0).forEach(function(t) {
      Pe(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Cg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function VB(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function GB(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, Lf(t.key), t);
  }
}
function ZB(o, e, r) {
  return e && GB(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function XB(o, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(e && e.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), e && dc(o, e);
}
function dc(o, e) {
  return dc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, dc(o, e);
}
function qB(o) {
  var e = YB();
  return function() {
    var t = Ps(o), n;
    if (e) {
      var a = Ps(this).constructor;
      n = Reflect.construct(t, arguments, a);
    } else
      n = t.apply(this, arguments);
    return UB(this, n);
  };
}
function UB(o, e) {
  if (e && (Bt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ve(o);
}
function ve(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function YB() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ps(o) {
  return Ps = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ps(o);
}
function Pe(o, e, r) {
  return e = Lf(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Lf(o) {
  var e = JB(o, "string");
  return Bt(e) == "symbol" ? e : String(e);
}
function JB(o, e) {
  if (Bt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Bt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var To = xe({
  name: "instantsearch"
});
function QB() {
  return "#";
}
var Hf = {
  preserveSharedStateOnUnmount: !1,
  persistHierarchicalRootCount: !1
}, KB = /* @__PURE__ */ function(o) {
  XB(r, o);
  var e = qB(r);
  function r(t) {
    var n, a;
    VB(this, r), a = e.call(this), Pe(ve(a), "client", void 0), Pe(ve(a), "indexName", void 0), Pe(ve(a), "compositionID", void 0), Pe(ve(a), "insightsClient", void 0), Pe(ve(a), "onStateChange", null), Pe(ve(a), "future", void 0), Pe(ve(a), "helper", void 0), Pe(ve(a), "mainHelper", void 0), Pe(ve(a), "mainIndex", void 0), Pe(ve(a), "started", void 0), Pe(ve(a), "templatesConfig", void 0), Pe(ve(a), "renderState", {}), Pe(ve(a), "_stalledSearchDelay", void 0), Pe(ve(a), "_searchStalledTimer", void 0), Pe(ve(a), "_initialUiState", void 0), Pe(ve(a), "_initialResults", void 0), Pe(ve(a), "_createURL", void 0), Pe(ve(a), "_searchFunction", void 0), Pe(ve(a), "_mainHelperSearch", void 0), Pe(ve(a), "_hasSearchWidget", !1), Pe(ve(a), "_hasRecommendWidget", !1), Pe(ve(a), "_insights", void 0), Pe(ve(a), "middleware", []), Pe(ve(a), "sendEventToInsights", void 0), Pe(ve(a), "status", "idle"), Pe(ve(a), "error", void 0), Pe(ve(a), "scheduleSearch", Nt(function() {
      a.started && a.mainHelper.search();
    })), Pe(ve(a), "scheduleRender", Nt(function() {
      var T, I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      (T = a.mainHelper) !== null && T !== void 0 && T.hasPendingRequests() || (clearTimeout(a._searchStalledTimer), a._searchStalledTimer = null, I && (a.status = "idle", a.error = void 0)), a.mainIndex.render({
        instantSearchInstance: ve(a)
      }), a.emit("render");
    })), Pe(ve(a), "onInternalStateChange", Nt(function() {
      var T = a.mainIndex.getWidgetUiState({});
      a.middleware.forEach(function(I) {
        var G = I.instance;
        G.onStateChange({
          uiState: T
        });
      });
    })), a.setMaxListeners(100);
    var s = t.indexName, i = s === void 0 ? "" : s, l = t.compositionID, c = t.numberLocale, u = t.initialUiState, m = u === void 0 ? {} : u, y = t.routing, g = y === void 0 ? null : y, p = t.insights, d = p === void 0 ? void 0 : p, h = t.searchFunction, f = t.stalledSearchDelay, F = f === void 0 ? 200 : f, b = t.searchClient, v = b === void 0 ? null : b, k = t.insightsClient, E = k === void 0 ? null : k, S = t.onStateChange, B = S === void 0 ? null : S, D = t.future, x = D === void 0 ? ll(ll({}, Hf), t.future || {}) : D;
    if (v === null)
      throw new Error(To("The `searchClient` option is required."));
    if (typeof v.search != "function")
      throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
    if (typeof v.addAlgoliaAgent == "function" && v.addAlgoliaAgent("instantsearch.js (".concat(Rf, ")")), process.env.NODE_ENV === "development" && ue(E === null, "`insightsClient` property has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), E && typeof E != "function")
      throw new Error(To("The `insightsClient` option should be a function."));
    if (process.env.NODE_ENV === "development" && ue(!t.searchParameters, "The `searchParameters` option is deprecated and will not be supported in InstantSearch.js 4.x.\n\nYou can replace it with the `configure` widget:\n\n```\nsearch.addWidgets([\n  configure(".concat(JSON.stringify(t.searchParameters, null, 2), `)
]);
\`\`\`

See `).concat(gn({
      name: "configure"
    }))), process.env.NODE_ENV === "development" && ((n = t.future) === null || n === void 0 ? void 0 : n.preserveSharedStateOnUnmount) === void 0 && console.info(`Starting from the next major version, InstantSearch will change how widgets state is preserved when they are removed. InstantSearch will keep the state of unmounted widgets to be usable by other widgets with the same attribute.

We recommend setting \`future.preserveSharedStateOnUnmount\` to true to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to false.

See documentation: `.concat(gn({
      name: "instantsearch"
    }), `#widget-param-future
          `)), a.client = v, a.future = x, a.insightsClient = E, a.indexName = i, a.compositionID = l, a.helper = null, a.mainHelper = null, a.mainIndex = Sf({
      // we use an index widget to render compositions
      // this only works because there's only one composition index allow for now
      indexName: a.compositionID || a.indexName
    }), a.onStateChange = B, a.started = !1, a.templatesConfig = {
      helpers: WB({
        numberLocale: c
      }),
      compileOptions: {}
    }, a._stalledSearchDelay = F, a._searchStalledTimer = null, a._createURL = QB, a._initialUiState = m, a._initialResults = null, a._insights = d, h && (process.env.NODE_ENV === "development" && ue(!1, "The `searchFunction` option is deprecated. Use `onStateChange` instead."), a._searchFunction = h), a.sendEventToInsights = fe, g) {
      var C = typeof g == "boolean" ? {} : g;
      C.$$internal = !0, a.use(NB(C));
    }
    if (d) {
      var O = typeof d == "boolean" ? {} : d;
      O.$$internal = !0, a.use(fg(O));
    }
    return fB() && a.use(hB({
      $$internal: !0
    })), a;
  }
  return ZB(r, [{
    key: "_isSearchStalled",
    get: (
      /**
       * @deprecated use `status === 'stalled'` instead
       */
      function() {
        return process.env.NODE_ENV === "development" && ue(!1, '`InstantSearch._isSearchStalled` is deprecated and will be removed in InstantSearch.js 5.0.\n\nUse `InstantSearch.status === "stalled"` instead.'), this.status === "stalled";
      }
    )
  }, {
    key: "use",
    value: function() {
      for (var n = this, a = arguments.length, s = new Array(a), i = 0; i < a; i++)
        s[i] = arguments[i];
      var l = s.map(function(c) {
        var u = ll({
          $$type: "__unknown__",
          $$internal: !1,
          subscribe: fe,
          started: fe,
          unsubscribe: fe,
          onStateChange: fe
        }, c({
          instantSearchInstance: n
        }));
        return n.middleware.push({
          creator: c,
          instance: u
        }), u;
      });
      return this.started && l.forEach(function(c) {
        c.subscribe(), c.started();
      }), this;
    }
    /**
     * Removes a middleware from the InstantSearch lifecycle.
     */
  }, {
    key: "unuse",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.middleware.filter(function(i) {
        return a.includes(i.creator);
      }).forEach(function(i) {
        return i.instance.unsubscribe();
      }), this.middleware = this.middleware.filter(function(i) {
        return !a.includes(i.creator);
      }), this;
    }
    // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now
  }, {
    key: "EXPERIMENTAL_use",
    value: function() {
      return process.env.NODE_ENV === "development" && ue(!1, "The middleware API is now considered stable, so we recommend replacing `EXPERIMENTAL_use` with `use` before upgrading to the next major version."), this.use.apply(this, arguments);
    }
    /**
     * Adds a widget to the search instance.
     * A widget can be added either before or after InstantSearch has started.
     * @param widget The widget to add to InstantSearch.
     *
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`.
     */
  }, {
    key: "addWidget",
    value: function(n) {
      return process.env.NODE_ENV === "development" && ue(!1, "addWidget will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`"), this.addWidgets([n]);
    }
    /**
     * Adds multiple widgets to the search instance.
     * Widgets can be added either before or after InstantSearch has started.
     * @param widgets The array of widgets to add to InstantSearch.
     */
  }, {
    key: "addWidgets",
    value: function(n) {
      if (!Array.isArray(n))
        throw new Error(To("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
      if (n.some(function(a) {
        return typeof a.init != "function" && typeof a.render != "function";
      }))
        throw new Error(To("The widget definition expects a `render` and/or an `init` method."));
      if (this.compositionID && n.some(go))
        throw new Error(To("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
      return this.mainIndex.addWidgets(n), this;
    }
    /**
     * Removes a widget from the search instance.
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`
     * @param widget The widget instance to remove from InstantSearch.
     *
     * The widget must implement a `dispose()` method to clear its state.
     */
  }, {
    key: "removeWidget",
    value: function(n) {
      return process.env.NODE_ENV === "development" && ue(!1, "removeWidget will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`"), this.removeWidgets([n]);
    }
    /**
     * Removes multiple widgets from the search instance.
     * @param widgets Array of widgets instances to remove from InstantSearch.
     *
     * The widgets must implement a `dispose()` method to clear their states.
     */
  }, {
    key: "removeWidgets",
    value: function(n) {
      if (!Array.isArray(n))
        throw new Error(To("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
      if (n.some(function(a) {
        return typeof a.dispose != "function";
      }))
        throw new Error(To("The widget definition expects a `dispose` method."));
      return this.mainIndex.removeWidgets(n), this;
    }
    /**
     * Ends the initialization of InstantSearch.js and triggers the
     * first search.
     */
  }, {
    key: "start",
    value: function() {
      var n = this;
      if (this.started)
        throw new Error(To("The `start` method has already been called once."));
      var a = this.mainHelper || $e(this.client, this.indexName, void 0, {
        persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
      });
      if (this.compositionID && (a.searchForFacetValues = a.searchForCompositionFacetValues.bind(a)), a.search = function() {
        return n.status = "loading", n.scheduleRender(!1), process.env.NODE_ENV === "development" && ue(!!n.indexName || !!n.compositionID || n.mainIndex.getWidgets().some(go), "No indexName provided, nor an explicit index widget in the widgets tree. This is required to be able to display results."), n._hasSearchWidget && (n.compositionID ? a.searchWithComposition() : a.searchOnlyWithDerivedHelpers()), n._hasRecommendWidget && a.recommend(), a;
      }, this._searchFunction) {
        var s = {
          search: function() {
            return new Promise(fe);
          }
        };
        this._mainHelperSearch = a.search.bind(a), a.search = function() {
          var l = n.mainIndex.getHelper(), c = $e(s, l.state.index, l.state);
          return c.once("search", function(u) {
            var m = u.state;
            l.overrideStateWithoutTriggeringChangeEvent(m), n._mainHelperSearch();
          }), c.on("change", function(u) {
            var m = u.state;
            l.setState(m);
          }), n._searchFunction(c), a;
        };
      }
      if (a.on("error", function(l) {
        var c = l.error;
        if (!(c instanceof Error)) {
          var u = c;
          c = Object.keys(u).reduce(function(m, y) {
            return m[y] = u[y], m;
          }, new Error(u.message));
        }
        c.error = c, n.error = c, n.status = "error", n.scheduleRender(!1), n.emit("error", c);
      }), this.mainHelper = a, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.subscribe();
      }), this.mainIndex.init({
        instantSearchInstance: this,
        parent: null,
        uiState: this._initialUiState
      }), this._initialResults) {
        N2(this.client, this._initialResults), x2(this.mainHelper, this._initialResults);
        var i = this.scheduleSearch;
        this.scheduleSearch = Nt(fe), Nt(function() {
          n.scheduleSearch = i;
        })();
      } else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
      this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.started();
      }), typeof this._insights > "u" && a.derivedHelpers[0].once("result", function() {
        var l = n.mainIndex.getScopedResults().some(function(c) {
          var u = c.results;
          return u == null ? void 0 : u._automaticInsights;
        });
        l && n.use(fg({
          $$internal: !0,
          $$automatic: !0
        }));
      });
    }
    /**
     * Removes all widgets without triggering a search afterwards.
     * @return {undefined} This method does not return anything
     */
  }, {
    key: "dispose",
    value: function() {
      var n;
      this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), (n = this.mainHelper) === null || n === void 0 || n.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(a) {
        var s = a.instance;
        s.unsubscribe();
      });
    }
  }, {
    key: "scheduleStalledRender",
    value: function() {
      var n = this;
      this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function() {
        n.status = "stalled", n.scheduleRender();
      }, this._stalledSearchDelay));
    }
    /**
     * Set the UI state and trigger a search.
     * @param uiState The next UI state or a function computing it from the current state
     * @param callOnStateChange private parameter used to know if the method is called from a state change
     */
  }, {
    key: "setUiState",
    value: function(n) {
      var a = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!this.mainHelper)
        throw new Error(To("The `start` method needs to be called before `setUiState`."));
      this.mainIndex.refreshUiState();
      var i = typeof n == "function" ? n(this.mainIndex.getWidgetUiState({})) : n;
      this.onStateChange && s ? this.onStateChange({
        uiState: i,
        setUiState: function(c) {
          _l(typeof c == "function" ? c(i) : c, a.mainIndex), a.scheduleSearch(), a.onInternalStateChange();
        }
      }) : (_l(i, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange());
    }
  }, {
    key: "getUiState",
    value: function() {
      return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
    }
  }, {
    key: "createURL",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!this.started)
        throw new Error(To("The `start` method needs to be called before `createURL`."));
      return this._createURL(n);
    }
  }, {
    key: "refresh",
    value: function() {
      if (!this.mainHelper)
        throw new Error(To("The `start` method needs to be called before `refresh`."));
      this.mainHelper.clearCache().search();
    }
  }]), r;
}(oB), Oo = function(e) {
  return new KB(e);
};
Oo.version = Rf;
Oo.createInfiniteHitsSessionStorageCache = dr($6, "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
Oo.highlight = dr(Ef, "import { highlight } from 'instantsearch.js/es/helpers'");
Oo.reverseHighlight = dr(xf, "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
Oo.snippet = dr(Af, "import { snippet } from 'instantsearch.js/es/helpers'");
Oo.reverseSnippet = dr(Cf, "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
Oo.insights = nf;
Oo.getInsightsAnonymousUserToken = J6;
Object.defineProperty(Oo, "widgets", {
  get: function() {
    throw new ReferenceError(`"instantsearch.widgets" are not available from the ES build.

To import the widgets:

import { searchBox } from 'instantsearch.js/es/widgets'`);
  }
});
Object.defineProperty(Oo, "connectors", {
  get: function() {
    throw new ReferenceError(`"instantsearch.connectors" are not available from the ES build.

To import the connectors:

import { connectSearchBox } from 'instantsearch.js/es/connectors'`);
  }
});
Object.defineProperty(Oo, "templates", {
  get: function() {
    throw new ReferenceError(`"instantsearch.templates" are not available from the ES build.

To import the templates:

import { carousel } from 'instantsearch.js/es/templates'`);
  }
});
var _B = "4.20.4", Wf = function(o) {
  var e;
  return pn(((e = { mixins: [be({ name: "InstantSearch" })], provide: function() {
    return { $_ais_instantSearchInstance: this.instantSearchInstance };
  }, watch: { searchClient: function(r) {
    ft(!1), this.instantSearchInstance.helper.setClient(r).search();
  }, indexName: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, compositionID: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, stalledSearchDelay: function(r) {
    this.instantSearchInstance._stalledSearchDelay = r;
  }, routing: function() {
    throw new Error(`routing configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, onStateChange: function() {
    throw new Error(`onStateChange configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, searchFunction: function(r) {
    this.instantSearchInstance._searchFunction = r;
  }, middlewares: { immediate: !0, handler: function(r, t) {
    var n = this;
    (t || []).filter(function(a) {
      return (r || []).indexOf(a) === -1;
    }).forEach(function(a) {
      n.instantSearchInstance.unuse(a);
    }), (r || []).filter(function(a) {
      return (t || []).indexOf(a) === -1;
    }).forEach(function(a) {
      n.instantSearchInstance.use(a);
    });
  } }, future: function(r) {
    this.instantSearchInstance.future = Object.assign(Hf, r);
  } }, created: function() {
    var r = this.instantSearchInstance.client;
    typeof r.addAlgoliaAgent == "function" && (r.addAlgoliaAgent("Vue (" + c1 + ")"), r.addAlgoliaAgent("Vue InstantSearch (" + _B + ")"));
  }, mounted: function() {
    var r = this;
    this.$nextTick(function() {
      r.instantSearchInstance.started || r.instantSearchInstance.start();
    });
  } }).beforeUnmount = function() {
    this.instantSearchInstance.started && this.instantSearchInstance.dispose(), this.instantSearchInstance.__initialSearchResults = void 0;
  }, e), o);
}, Og = `Vue InstantSearch: You used the prop api-key or app-id.
These have been replaced by search-client.

See more info here: https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-search-client`;
const uu = Wf({ name: "AisInstantSearch", props: { searchClient: { type: Object, required: !0 }, insightsClient: { type: Function, default: void 0 }, indexName: { type: String, required: !1 }, compositionID: { type: String, required: !1 }, routing: { default: void 0, validator: function(o) {
  return !(typeof o == "boolean" || !o.router && !o.stateMapping) || (ft("The `routing` option expects an object with `router` and/or `stateMapping`.\n\nSee https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-routing"), !1);
} }, insights: { default: void 0, validator: function(o) {
  return o === void 0 || typeof o == "boolean" || typeof o == "object";
} }, stalledSearchDelay: { type: Number, default: void 0 }, searchFunction: { type: Function, default: void 0 }, onStateChange: { type: Function, default: void 0 }, initialUiState: { type: Object, default: void 0 }, apiKey: { type: String, default: void 0, validator: function(o) {
  return o && ft(Og), !1;
} }, appId: { type: String, default: void 0, validator: function(o) {
  return o && ft(Og), !1;
} }, middlewares: { type: Array, default: null }, future: { type: Object, default: void 0 } }, data: function() {
  return { instantSearchInstance: Oo({ searchClient: this.searchClient, insightsClient: this.insightsClient, insights: this.insights, indexName: this.indexName, compositionID: this.compositionID, routing: this.routing, stalledSearchDelay: this.stalledSearchDelay, searchFunction: this.searchFunction, onStateChange: this.onStateChange, initialUiState: this.initialUiState, future: this.future }) };
}, render: ha(function(o) {
  var e;
  return o("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !1, e) }, Jc(this));
}) });
Wf({ name: "AisInstantSearchSsr", inject: { $_ais_ssrInstantSearchInstance: { default: function() {
  throw new Error("`createServerRootMixin` is required when using SSR.");
} } }, data: function() {
  return { instantSearchInstance: this.$_ais_ssrInstantSearchInstance };
}, render: ha(function(o) {
  var e;
  return o("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !0, e) }, Jc(this));
}) });
const pu = { name: "AisInfiniteHits", mixins: [De({ connector: sP }, { $$widgetType: "ais.infiniteHits" }), be({ name: "InfiniteHits" })], props: { showBanner: { type: Boolean, default: !0 }, showPrevious: { type: Boolean, default: !1 }, escapeHTML: { type: Boolean, default: !0 }, transformItems: { type: Function, default: void 0 }, cache: { type: Object, default: void 0 } }, computed: { widgetParams: function() {
  return { showBanner: this.showBanner, showPrevious: this.showPrevious, escapeHTML: this.escapeHTML, transformItems: this.transformItems, cache: this.cache };
} }, methods: { refinePrevious: function() {
  this.state.showPrevious();
}, refineNext: function() {
  this.state.showMore();
} } };
var $B = ["disabled"], ek = ["href", "target"], ok = ["src", "alt"], rk = ["src", "alt"], tk = ["onClick", "onAuxclick"], nk = ["disabled"];
function ak(o, e, r, t, n, a) {
  return o.state ? (w(), j("div", { key: 0, class: Z(o.suit()) }, [r.showPrevious ? R(o.$slots, "loadPrevious", { key: 0, refinePrevious: a.refinePrevious, page: o.state.results.page, isFirstPage: o.state.isFirstPage }, function() {
    return [A("button", { class: Z([o.suit("loadPrevious"), o.state.isFirstPage && o.suit("loadPrevious", "disabled")]), disabled: o.state.isFirstPage, onClick: e[0] || (e[0] = function(s) {
      return a.refinePrevious();
    }) }, " Show previous results ", 10, $B)];
  }) : Q("", !0), R(o.$slots, "default", { items: o.state.items, results: o.state.results, banner: o.state.banner, isLastPage: o.state.isLastPage, refinePrevious: a.refinePrevious, refineNext: a.refineNext, refine: a.refineNext, insights: o.state.insights, sendEvent: o.state.sendEvent }, function() {
    return [r.showBanner && o.state.banner && o.state.banner.image.urls[0].url ? R(o.$slots, "banner", { key: 0, banner: o.state.banner }, function() {
      return [A("aside", { class: Z(o.suit("banner")) }, [o.state.banner.link ? (w(), j("a", { key: 0, href: o.state.banner.link.url, target: o.state.banner.link.target, class: Z(o.suit("banner-link")) }, [A("img", { src: o.state.banner.image.urls[0].url, alt: o.state.banner.image.title, class: Z(o.suit("banner-image")) }, null, 10, ok)], 10, ek)) : (w(), j("img", { key: 1, src: o.state.banner.image.urls[0].url, alt: o.state.banner.image.title, class: Z(o.suit("banner-image")) }, null, 10, rk))], 2)];
    }) : Q("", !0), A("ol", { class: Z(o.suit("list")) }, [(w(!0), j(ye, null, je(o.state.items, function(s, i) {
      return w(), j("li", { class: Z(o.suit("item")), key: s.objectID, onClick: function(l) {
        return o.state.sendEvent("click:internal", s, "Hit Clicked");
      }, onAuxclick: function(l) {
        return o.state.sendEvent("click:internal", s, "Hit Clicked");
      } }, [R(o.$slots, "item", { item: s, index: i, insights: o.state.insights, sendEvent: o.state.sendEvent }, function() {
        return [se(" objectID: " + _(s.objectID) + ", index: " + _(i), 1)];
      })], 42, tk);
    }), 128))], 2), R(o.$slots, "loadMore", { refineNext: a.refineNext, refine: a.refineNext, page: o.state.results.page, isLastPage: o.state.isLastPage }, function() {
      return [A("button", { class: Z([o.suit("loadMore"), o.state.isLastPage && o.suit("loadMore", "disabled")]), disabled: o.state.isLastPage, onClick: e[1] || (e[1] = function(s) {
        return a.refineNext();
      }) }, " Show more results ", 10, nk)];
    })];
  })], 2)) : Q("", !0);
}
pu.render = ak;
be({ name: "Menu" }), De({ connector: lf }, { $$widgetType: "ais.menu" }), fo();
be({ name: "MenuSelect" }), De({ connector: lf }, { $$widgetType: "ais.menuSelect" }), fo();
De({ connector: SP }, { $$widgetType: "ais.numericMenu" }), be({ name: "NumericMenu" }), fo();
be({ name: "Pagination" }), De({ connector: IP }, { $$widgetType: "ais.pagination" }), fo();
be({ name: "Panel" }), v6();
be({ name: "PoweredBy" });
be({ name: "QueryRuleContext" }), De({ connector: Ff }, { $$widgetType: "ais.queryRuleContext" });
be({ name: "QueryRuleCustomData" }), De({ connector: Ff }, { $$widgetType: "ais.queryRuleCustomData" });
be({ name: "RangeInput" }), De({ connector: XP }, { $$widgetType: "ais.rangeInput" }), fo();
be({ name: "RatingMenu" }), De({ connector: b4 }, { $$widgetType: "ais.ratingMenu" }), fo();
A("symbol", { id: "ais-RatingMenu-starSymbol", viewBox: "0 0 24 24" }, [A("path", { d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" })], -1), A("symbol", { id: "ais-RatingMenu-starEmptySymbol", viewBox: "0 0 24 24" }, [A("path", { d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z" })], -1);
A("use", { "xlink:href": "#ais-RatingMenu-starSymbol" }, null, -1);
A("use", { "xlink:href": "#ais-RatingMenu-starEmptySymbol" }, null, -1);
const Vf = { name: "SearchInput", mixins: [be({ name: "SearchBox" })], props: { placeholder: { type: String, default: "Search here…" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !1 }, shouldShowLoadingIndicator: { type: Boolean, default: !1 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Search" }, resetTitle: { type: String, default: "Clear" }, value: { type: String, required: !1, default: void 0 }, modelValue: { type: String, required: !1, default: void 0 } }, emits: ["input", "update:modelValue", "blur", "focus", "reset"], data: function() {
  return { query: "" };
}, methods: { isFocused: function() {
  return document.activeElement === this.$refs.input;
}, onInput: function(o) {
  this.ignoreCompositionEvents && o.isComposing || (this.$emit("input", o.target.value), this.$emit("update:modelValue", o.target.value));
}, onFormSubmit: function() {
  this.$refs.input.blur();
}, onFormReset: function() {
  this.$emit("input", ""), this.$emit("update:modelValue", ""), this.$emit("reset");
} } };
var sk = ["placeholder", "autofocus", "value"], ik = ["title", "hidden"], lk = [A("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" }, null, -1)], ck = ["title", "hidden"], uk = [A("path", { d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" }, null, -1)], pk = ["hidden"], dk = ["aria-hidden"], gk = [rr('<g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g></g>', 1)];
function mk(o, e, r, t, n, a) {
  return w(), j("form", { action: "", role: "search", novalidate: "", class: Z(o.suit("form")), onSubmit: e[4] || (e[4] = Ml(function() {
    for (var s = [], i = arguments.length; i--; ) s[i] = arguments[i];
    return a.onFormSubmit && a.onFormSubmit.apply(a, s);
  }, ["prevent"])), onReset: e[5] || (e[5] = Ml(function() {
    for (var s = [], i = arguments.length; i--; ) s[i] = arguments[i];
    return a.onFormReset && a.onFormReset.apply(a, s);
  }, ["prevent"])) }, [A("input", { type: "search", autocorrect: "off", autocapitalize: "off", autocomplete: "off", spellcheck: "false", maxlength: "512", "aria-label": "Search", placeholder: r.placeholder, autofocus: r.autofocus, class: Z(o.suit("input")), value: r.value || r.modelValue, onFocus: e[0] || (e[0] = function(s) {
    return o.$emit("focus", s);
  }), onBlur: e[1] || (e[1] = function(s) {
    return o.$emit("blur", s);
  }), onInput: e[2] || (e[2] = function(s) {
    return a.onInput(s);
  }), onCompositionend: e[3] || (e[3] = function(s) {
    return a.onInput(s);
  }), ref: "input" }, null, 42, sk), A("button", { type: "submit", title: r.submitTitle, class: Z(o.suit("submit")), hidden: r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [R(o.$slots, "submit-icon", {}, function() {
    return [(w(), j("svg", { "aria-hidden": "true", width: "10", height: "10", viewBox: "0 0 40 40", class: Z(o.suit("submitIcon")) }, lk, 2))];
  })], 10, ik), A("button", { type: "reset", title: r.resetTitle, class: Z(o.suit("reset")), hidden: !r.value && !r.modelValue || r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [R(o.$slots, "reset-icon", {}, function() {
    return [(w(), j("svg", { "aria-hidden": "true", height: "10", viewBox: "0 0 20 20", class: Z(o.suit("resetIcon")), width: "10" }, uk, 2))];
  })], 10, ck), r.showLoadingIndicator ? (w(), j("span", { key: 0, hidden: !r.shouldShowLoadingIndicator, class: Z(o.suit("loadingIndicator")) }, [R(o.$slots, "loading-indicator", {}, function() {
    return [(w(), j("svg", { "aria-hidden": !r.shouldShowLoadingIndicator, "aria-label": "Results are loading", width: "16", height: "16", stroke: "#444", viewBox: "0 0 38 38", class: Z(o.suit("loadingIcon")) }, gk, 10, dk))];
  })], 10, pk)) : Q("", !0)], 34);
}
Vf.render = mk;
be({ name: "RefinementList" }), De({ connector: KP }, { $$widgetType: "ais.refinementList" }), fo();
var Va;
const yk = ((Va = { name: "AisStateResults", mixins: [De({ connector: !0 }), be({ name: "StateResults" })], props: { catchError: { type: Boolean, default: !1 } }, data: function() {
  var o = this;
  return { renderFn: function() {
    var e = o.instantSearchInstance, r = e.status, t = e.error, n = o.getParentIndex().getResults(), a = o.getParentIndex().getHelper(), s = a ? a.state : null;
    o.state = { results: n, state: s, status: r, error: t };
  } };
}, created: function() {
  this.instantSearchInstance.addListener("render", this.renderFn), this.renderFn();
} }).beforeUnmount = function() {
  this.widget && (this.instantSearchInstance.removeListener("render", this.renderFn), this.errorFn && this.instantSearchInstance.removeListener("error", this.errorFn));
}, Va.watch = { catchError: { immediate: !0, handler: function(o) {
  o ? (this.errorFn = function() {
  }, this.instantSearchInstance.addListener("error", this.errorFn)) : this.errorFn && (this.instantSearchInstance.removeListener("error", this.errorFn), this.errorFn = void 0);
} } }, Va.computed = { stateResults: function() {
  var o = this.state, e = o.results, r = o.state, t = o.status, n = o.error;
  return pn({}, e, { results: e, state: r, status: t, error: n });
} }, Va);
var fk = A("p", null, " Use this component to have a different layout based on a certain state. ", -1), hk = A("p", null, "Fill in the slot, and get access to the following things:", -1);
function Fk(o, e, r, t, n, a) {
  return o.state && o.state.state && o.state.results ? (w(), j("div", { key: 0, class: Z(o.suit()) }, [R(o.$slots, "default", Mm(zm(a.stateResults)), function() {
    return [fk, hk, A("pre", null, "results: " + _(Object.keys(o.state.results)), 1), A("pre", null, "state: " + _(Object.keys(o.state.state)), 1), A("pre", null, "status: " + _(o.state.status), 1), A("pre", null, "error: " + _(o.state.error), 1)];
  })], 2)) : Q("", !0);
}
yk.render = Fk;
const Xs = { name: "AisSearchBox", mixins: [De({ connector: n4 }, { $$widgetType: "ais.searchBox" }), be({ name: "SearchBox" })], components: { SearchInput: Vf }, props: { placeholder: { type: String, default: "" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !0 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Submit the search query" }, resetTitle: { type: String, default: "Clear the search query" }, value: { type: String, default: void 0 }, modelValue: { type: String, default: void 0 }, queryHook: { type: Function, default: void 0 } }, data: function() {
  return { localValue: "", isVue2: Pb, isVue3: Bb };
}, computed: { widgetParams: function() {
  return { queryHook: this.queryHook };
}, isControlled: function() {
  return this.value !== void 0 || this.modelValue !== void 0;
}, model: function() {
  return this.value || this.modelValue;
}, currentRefinement: { get: function() {
  this.isControlled && this.model !== this.localValue && (this.localValue = this.model, this.$emit("input", this.model), this.$emit("update:modelValue", this.model), this.state.refine(this.model));
  var o = this.$refs.searchInput;
  return o && o.isFocused() ? this.localValue : this.model || this.state.query || "";
}, set: function(o) {
  this.localValue = o, this.state.refine(o), this.isControlled && (this.$emit("input", o), this.$emit("update:modelValue", o));
} } } };
function bk(o, e, r, t, n, a) {
  var s = jm("search-input");
  return o.state ? (w(), j("div", { key: 0, class: Z(o.suit()) }, [R(o.$slots, "default", { currentRefinement: a.currentRefinement, isSearchStalled: o.state.isSearchStalled, refine: o.state.refine }, function() {
    return [H(s, { onFocus: e[0] || (e[0] = function(i) {
      return o.$emit("focus", i);
    }), onBlur: e[1] || (e[1] = function(i) {
      return o.$emit("blur", i);
    }), onReset: e[2] || (e[2] = function(i) {
      return o.$emit("reset");
    }), placeholder: r.placeholder, autofocus: r.autofocus, "show-loading-indicator": r.showLoadingIndicator, "should-show-loading-indicator": o.state.isSearchStalled, "ignore-composition-events": r.ignoreCompositionEvents, "submit-title": r.submitTitle, "reset-title": r.resetTitle, "class-names": o.classNames, modelValue: a.currentRefinement, "onUpdate:modelValue": e[3] || (e[3] = function(i) {
      return a.currentRefinement = i;
    }), ref: "searchInput" }, Nm({ default: M(function() {
      return [n.isVue2 ? R(o.$slots, "loading-indicator", { key: 0, slot: "loading-indicator" }) : Q("", !0), n.isVue2 ? R(o.$slots, "submit-icon", { key: 1, slot: "submit-icon" }) : Q("", !0), n.isVue2 ? R(o.$slots, "reset-icon", { key: 2, slot: "reset-icon" }) : Q("", !0)];
    }), _: 2 }, [n.isVue3 ? { name: "loading-indicator", fn: M(function() {
      return [R(o.$slots, "loading-indicator")];
    }), key: "0" } : void 0, n.isVue3 ? { name: "submit-icon", fn: M(function() {
      return [R(o.$slots, "submit-icon")];
    }), key: "1" } : void 0, n.isVue3 ? { name: "reset-icon", fn: M(function() {
      return [R(o.$slots, "reset-icon")];
    }), key: "2" } : void 0]), 1032, ["placeholder", "autofocus", "show-loading-indicator", "should-show-loading-indicator", "ignore-composition-events", "submit-title", "reset-title", "class-names", "modelValue"])];
  })], 2)) : Q("", !0);
}
Xs.render = bk;
be({ name: "Snippet" });
be({ name: "SortBy" }), De({ connector: l4 }, { $$widgetType: "ais.sortBy" }), fo();
De({ connector: D4 }, { $$widgetType: "ais.stats" }), be({ name: "Stats" });
be({ name: "ToggleRefinement" }), De({ connector: M4 }, { $$widgetType: "ais.toggleRefinement" }), fo();
De({ connector: g6 }, { $$widgetType: "ais.voiceSearch" }), be({ name: "VoiceSearch" });
rr('<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', 5);
A("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, null, -1);
A("line", { x1: "12", y1: "19", x2: "12", y2: "23" }, null, -1);
A("line", { x1: "8", y1: "23", x2: "16", y2: "23" }, null, -1);
be({ name: "RelevantSort" }), De({ connector: h6 }, { $$widgetType: "ais.relevantSort" });
const vk = { name: "AisDynamicWidgets", mixins: [De({ connector: $y }, { $$widgetType: "ais.dynamicWidgets" }), be({ name: "DynamicWidgets" })], props: { transformItems: { type: Function, default: void 0 }, facets: { type: Array, default: void 0 }, maxValuesPerFacet: { type: Number, default: void 0 } }, render: ha(function(o) {
  var e = this, r = /* @__PURE__ */ new Map();
  if ((Jc(this) || []).forEach(function(n) {
    var a = function s(i) {
      var l, c = i.props;
      if (c) {
        if (c.attribute) return c.attribute;
        if (Array.isArray(c.attributes)) return c.attributes[0];
      }
      if (l = i.children && i.children.default && i.children.default(), Array.isArray(l)) return l.reduce(function(u, m) {
        return u || s(m);
      }, void 0);
    }(n);
    a && r.set(a, o("div", { key: a, class: [e.suit("widget")] }, [n]));
  }), !this.state) {
    var t = [];
    return r.forEach(function(n) {
      return t.push(n);
    }), o("div", pn({ class: [this.suit()] }, { attrs: { hidden: !0 } }), t);
  }
  return o("div", { class: [this.suit()] }, this.state.attributesToRender.map(function(n) {
    return r.get(n);
  }));
}), computed: { widgetParams: function() {
  return { transformItems: this.transformItems, facets: this.facets, maxValuesPerFacet: this.maxValuesPerFacet, widgets: [] };
} } };
Object.assign({}, vk, { name: "AisExperimentalDynamicWidgets", mounted: function() {
  ft("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.");
} });
var Pk = {
  prefix: "fal",
  iconName: "calendar-day",
  icon: [
    448,
    512,
    [],
    "f783",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"
  ]
}, Bk = {
  prefix: "fal",
  iconName: "scale-balanced",
  icon: [
    640,
    512,
    [9878, "balance-scale"],
    "f24e",
    "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
  ]
}, Tg = {
  prefix: "fal",
  iconName: "circle-plus",
  icon: [
    512,
    512,
    ["plus-circle"],
    "f055",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
  ]
}, kk = {
  prefix: "fal",
  iconName: "gears",
  icon: [
    640,
    512,
    ["cogs"],
    "f085",
    "M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3 0 0 2.9 5.1 .2 .3 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3 0 0-3 5.1-.2 .3 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2 0 0-2.6-4.5-.1-.2 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2 0 0 2.6-4.5 .1-.2 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 0 0 5.1-2.9 .3-.2 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2 0 0 5.1 3 .3 .2 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1 0 0-4.5 2.6-.2 .1 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1 0 0-4.5-2.6-.2-.1 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, wk = {
  prefix: "fal",
  iconName: "building-magnifying-glass",
  icon: [
    603,
    512,
    [],
    "e61c",
    "M60.6 30.1H301.5c16.6 0 30.1 13.5 30.1 30.1V180.7c9.3-7 19.4-12.9 30.1-17.6V60.2C361.7 27 334.8 0 301.5 0H60.6C27.3 0 .3 27 .3 60.2V421.6c0 33.3 27 60.2 60.2 60.2h60.2 30.1 60.2 30.1 60.2c27.5 0 50.7-18.5 57.9-43.7c-9.9-4.5-19.2-10.1-27.8-16.5c0 16.6-13.5 30.1-30.1 30.1H241.3V391.5c0-33.3-27-60.2-60.2-60.2s-60.2 27-60.2 60.2v60.2H60.6c-16.6 0-30.1-13.5-30.1-30.1V60.2c0-16.6 13.5-30.1 30.1-30.1zM278.9 210.8H233.7c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h37.6c0-30.5 9.1-58.8 24.6-82.5c-4.1-4.8-10.3-7.8-17.1-7.8zM211.1 391.5v60.2H150.9V391.5c0-16.6 13.5-30.1 30.1-30.1s30.1 13.5 30.1 30.1zM60.6 112.9v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V120.5zM233.7 90.4c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H233.7zm7.5 60.2V120.5h30.1v30.1H241.3zM60.6 233.4v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V233.4c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V240.9zm150.6 30.1V240.9h30.1v30.1H241.3zM422 211a90.4 90.4 0 1 1 0 180.7A90.4 90.4 0 1 1 422 211zm0 210.8c27.8 0 53.5-9.4 73.9-25.3L577 477.6c5.9 5.9 15.4 5.9 21.3 0s5.9-15.4 0-21.3l-81.1-81.1c15.9-20.4 25.3-46 25.3-73.9c0-66.5-53.9-120.5-120.5-120.5s-120.5 53.9-120.5 120.5s53.9 120.5 120.5 120.5z"
  ]
}, Dk = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
  ]
}, Sk = Dk, Ek = {
  prefix: "fal",
  iconName: "bolt",
  icon: [
    448,
    512,
    [9889, "zap"],
    "f0e7",
    "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"
  ]
}, xk = {
  prefix: "fal",
  iconName: "pipe",
  icon: [
    64,
    512,
    [],
    "7c",
    "M32 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0z"
  ]
}, Gf = {
  prefix: "fal",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"
  ]
}, Ak = {
  prefix: "fal",
  iconName: "gear",
  icon: [
    512,
    512,
    [9881, "cog"],
    "f013",
    "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"
  ]
}, Ck = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, Ok = Ck, Tk = {
  prefix: "fal",
  iconName: "image-user",
  icon: [
    512,
    512,
    [],
    "e1b8",
    "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320H212.6c-18.6 0-34 14-36.3 32H335.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H256h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z"
  ]
}, jk = {
  prefix: "fal",
  iconName: "badge-check",
  icon: [
    512,
    512,
    [],
    "f336",
    "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, Mk = {
  prefix: "fal",
  iconName: "screwdriver-wrench",
  icon: [
    512,
    512,
    ["tools"],
    "f7d9",
    "M64.7 34.6L160 107.9V160H107.9L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h64c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"
  ]
}, zk = {
  prefix: "fal",
  iconName: "chart-line",
  icon: [
    512,
    512,
    ["line-chart"],
    "f201",
    "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"
  ]
}, Nk = {
  prefix: "fal",
  iconName: "memo-circle-check",
  icon: [
    576,
    512,
    [],
    "e1d9",
    "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z"
  ]
}, Ik = {
  prefix: "fal",
  iconName: "comments-dollar",
  icon: [
    640,
    512,
    [],
    "f653",
    "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, Rk = {
  prefix: "fal",
  iconName: "layer-group",
  icon: [
    576,
    512,
    [],
    "f5fd",
    "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"
  ]
}, Lk = {
  prefix: "fal",
  iconName: "person-shelter",
  icon: [
    512,
    512,
    [],
    "e54f",
    "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160V496c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7 480 169.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zM232 400h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232H243.8c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"
  ]
}, Zf = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, Xf = {
  prefix: "fal",
  iconName: "clipboard",
  icon: [
    384,
    512,
    [128203],
    "f328",
    "M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12H112c-8.8 0-16 7.2-16 16v32h96 96V96c0-8.8-7.2-16-16-16H254c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7C73.3 61.4 91.1 48 112 48h6.7zM320 128c0 17.7-14.3 32-32 32H192 96c-17.7 0-32-14.3-32-32V112c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
  ]
}, Hk = {
  prefix: "fal",
  iconName: "paper-plane-top",
  icon: [
    512,
    512,
    ["paper-plane-alt", "send"],
    "e20a",
    "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272H120zm322.7-32L32 64l88 176H442.7z"
  ]
}, Wk = {
  prefix: "fal",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM245.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L224 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"
  ]
}, Vk = {
  prefix: "fal",
  iconName: "file-chart-column",
  icon: [
    384,
    512,
    ["file-chart-line"],
    "f659",
    "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V368z"
  ]
}, Gk = Vk, Zk = {
  prefix: "fal",
  iconName: "key",
  icon: [
    512,
    512,
    [128273],
    "f084",
    "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48H144c-8.8 0-16 7.2-16 16v48H32V398.6L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V384h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, qf = {
  prefix: "fal",
  iconName: "eye-slash",
  icon: [
    640,
    512,
    [],
    "f070",
    "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
  ]
}, Xk = {
  prefix: "fal",
  iconName: "users",
  icon: [
    640,
    512,
    [],
    "f0c0",
    "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"
  ]
}, qk = {
  prefix: "fal",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"
  ]
}, Uk = {
  prefix: "fal",
  iconName: "arrow-progress",
  icon: [
    512,
    512,
    [],
    "e5df",
    "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112H400c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80H288L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432H126zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, Yk = {
  prefix: "fal",
  iconName: "browsers",
  icon: [
    576,
    512,
    [],
    "e0cb",
    "M512 32c17.7 0 32 14.3 32 32V96H256V32H512zM160 32h64V96H128V64c0-17.7 14.3-32 32-32zM128 352V128H240 544V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
  ]
};
const Jk = { class: "relative rounded-md shadow-sm" }, Qk = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex py-1.5 pr-1.5"
}, Kk = { class: "inline-flex items-center rounded border border-default-200 px-1 font-sans text-xs text-default-400" }, _k = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby", "type"], $k = ["disabled", "tabindex", "aria-disabled"], ba = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "Input",
  props: /* @__PURE__ */ lr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    keyboardShortcut: { default: void 0 },
    leadingIcon: { default: void 0 },
    trailingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o, { expose: e }) {
    const r = o, t = cr(o, "modelValue"), n = ie(), [a, s] = Uo(!1), i = ae(() => r.type === "password"), l = pe("field-id", null), c = pe("has-hint", !1), u = ae(() => {
      if (r.invalid)
        return `${l}-error`;
      if (c)
        return `${l}-hint`;
    });
    return e({
      input: n
    }), (m, y) => (w(), j("div", Jk, [
      m.leadingIcon || m.trailingIcon ? (w(), j("div", {
        key: 0,
        class: Z([
          "pointer-events-none absolute inset-y-0 flex items-center",
          m.leadingIcon && "left-0 pl-3",
          m.trailingIcon && "right-0 pr-3"
        ])
      }, [
        H(P(ce), {
          icon: m.leadingIcon ?? m.trailingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ], 2)) : Q("", !0),
      m.keyboardShortcut ? (w(), j("div", Qk, [
        A("kbd", Kk, _(m.keyboardShortcut), 1)
      ])) : Q("", !0),
      yo(A("input", He({
        id: P(l) ?? void 0,
        ref_key: "input",
        ref: n,
        "onUpdate:modelValue": y[0] || (y[0] = (g) => t.value = g),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900 ring-1 ring-inset ring-default-300",
          "placeholder:text-default-400",
          "focus:ring-2 focus:ring-inset focus:ring-primary-600",
          "sm:text-sm sm:leading-6",
          m.leadingIcon && "pl-10",
          (m.trailingIcon || m.keyboardShortcut || i.value) && "pr-10",
          m.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ],
        disabled: m.disabled,
        tabindex: m.disabled ? "-1" : 0,
        "aria-disabled": m.disabled,
        "aria-invalid": !!m.invalid,
        "aria-describedby": u.value,
        type: P(a) ? "text" : m.type
      }, m.$attrs), null, 16, _k), [
        [Im, t.value]
      ]),
      i.value && !m.trailingIcon ? (w(), j("button", {
        key: 2,
        class: Z([
          "absolute inset-y-0 right-0 flex items-center rounded-md px-3",
          "focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600",
          m.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ]),
        type: "button",
        disabled: m.disabled,
        tabindex: m.disabled ? "-1" : 0,
        "aria-disabled": m.disabled,
        onClick: y[1] || (y[1] = () => P(s)())
      }, [
        H(P(ce), {
          icon: P(qf),
          class: Z([P(a) ? "text-neutral-800" : "text-default-400", "size-5 cursor-pointer"]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"]),
        y[2] || (y[2] = A("span", { class: "sr-only" }, " Show password ", -1))
      ], 10, $k)) : Q("", !0)
    ]));
  }
}), ew = /* @__PURE__ */ W({
  __name: "ModalTitle",
  setup(o) {
    return (e, r) => (w(), L(Dr, { as: P(js) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), ow = { class: "fixed inset-0 w-screen overflow-y-auto" }, rw = {
  class: /* @__PURE__ */ Z([
    "flex min-h-full items-start justify-center p-4 text-center",
    "sm:items-center"
  ])
}, Uf = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    color: { default: "white" },
    scrollable: { type: Boolean, default: !1 },
    size: { default: "base" }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = o, t = e;
    Be("scrollable", r.scrollable), Be("color", r.color), Be("emit", t);
    const n = /* @__PURE__ */ new Map([
      ["sm", "sm:max-w-md"],
      ["base", "sm:max-w-lg"],
      ["lg", "sm:max-w-2xl"],
      ["xl", "sm:max-w-4xl"],
      ["2xl", "sm:max-w-6xl"]
    ]);
    return (a, s) => (w(), L(P(sa), {
      appear: "",
      show: a.open,
      as: "template"
    }, {
      default: M(() => [
        H(P(ia), {
          as: "div",
          class: "relative z-[60]",
          onClose: s[0] || (s[0] = (i) => t("close"))
        }, {
          default: M(() => [
            H(P(qo), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: M(() => s[1] || (s[1] = [
                A("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            A("div", ow, [
              A("div", rw, [
                H(P(qo), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: M(() => [
                    H(P(la), He({
                      class: [
                        "relative w-full transform rounded-lg bg-white text-left shadow-xl transition-all divide-y divide-default-300",
                        "sm:my-8",
                        P(n).get(a.size),
                        a.scrollable && "flex flex-col max-h-[calc(100dvh-2rem)] md:max-h-[calc(100dvh-6rem)]",
                        // Apply top border radius to ModalContent if there is no ModalHeader
                        "[&:not(:has([data-slot=modal-header]))_[data-slot=modal-content]]:rounded-t-lg",
                        // Apply bottom border radius to ModalContent if there is no ModalFooter
                        "[&:not(:has([data-slot=modal-footer]))_[data-slot=modal-content]]:rounded-b-lg"
                      ]
                    }, a.$attrs), {
                      default: M(() => [
                        R(a.$slots, "default")
                      ]),
                      _: 3
                    }, 16, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Yr = /* @__PURE__ */ W({
  __name: "Spinner",
  props: {
    as: { default: "span" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), {
      role: "status",
      class: "inline-flex"
    }, {
      default: M(() => r[0] || (r[0] = [
        A("svg", {
          class: "animate-spin",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "aria-hidden": "true"
        }, [
          A("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }),
          A("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })
        ], -1),
        A("span", { class: "sr-only" }, " Loading... ", -1)
      ])),
      _: 1
    }));
  }
}), tw = {};
function nw(o, e) {
  return w(), j(ye, null, [
    e[0] || (e[0] = A("span", { class: "absolute top-1/2 left-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden" }, null, -1)),
    R(o.$slots, "default")
  ], 64);
}
const Jr = /* @__PURE__ */ le(tw, [["render", nw]]), Po = /* @__PURE__ */ W({
  __name: "IconButton",
  props: {
    as: { default: void 0 },
    ariaLabel: {},
    circle: { type: Boolean, default: !1 },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    icon: {},
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: "p-2",
      base: "p-2.5",
      lg: "p-3",
      xl: "p-4"
    }, t = {
      primary: "shadow-sm border-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm border-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900 disabled:border-transparent",
      tertiary: "border-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm border-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm border-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm border-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = ae(() => r[e.size]), a = ae(() => t[e.color]), s = ae(() => e.circle ? "rounded-full" : e.size === "sm" ? "rounded" : "rounded-md"), i = ae(() => e.disabled || e.loading);
    return (l, c) => (w(), L(Fe(l.as ?? (l.href ? P(Co) : "button")), {
      class: Z([
        "relative inline-flex border border-px",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        n.value,
        a.value,
        i.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400",
        s.value
      ]),
      href: l.href,
      type: l.type,
      method: l.method,
      disabled: i.value,
      "aria-disabled": i.value,
      "aria-busy": l.loading,
      tabindex: i.value ? "-1" : 0,
      "aria-label": l.ariaLabel
    }, {
      default: M(() => [
        H(Jr, null, {
          default: M(() => [
            l.loading ? (w(), L(Yr, {
              key: 0,
              class: "size-4"
            })) : (w(), L(P(ce), {
              key: 1,
              icon: l.icon,
              "aria-hidden": "true",
              class: "size-4"
            }, null, 8, ["icon"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex", "aria-label"]));
  }
}), aw = {
  class: "py-2 pl-6 pr-2 flex items-center justify-between gap-2",
  "data-slot": "modal-header"
}, sw = { class: "flex-none flex gap-2" }, iw = { class: "flex-none flex gap-2" }, lw = /* @__PURE__ */ W({
  __name: "ModalHeader",
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", aw, [
      A("div", sw, [
        R(r.$slots, "default")
      ]),
      A("div", iw, [
        R(r.$slots, "buttons"),
        H(Po, {
          color: "tertiary",
          size: "sm",
          ariaLabel: "Close",
          type: "button",
          icon: P(fa),
          onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
        }, null, 8, ["icon"])
      ])
    ]));
  }
}), cw = /* @__PURE__ */ W({
  __name: "ModalContent",
  setup(o) {
    const e = pe("scrollable"), r = pe("color"), t = /* @__PURE__ */ new Map([
      ["white", "bg-white"],
      ["gray", "bg-default-100"]
    ]);
    return (n, a) => (w(), j("div", {
      class: Z([
        "p-6",
        P(e) && "flex-1 overflow-y-auto",
        P(t).get(P(r) ?? "white")
      ]),
      "data-slot": "modal-content"
    }, [
      R(n.$slots, "default")
    ], 2));
  }
}), uw = ["id"], pw = {
  role: "listbox",
  class: "divide-y divide-default-200"
}, dw = ["onClick"], EM = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "AddressSearchModal",
  props: {
    config: {},
    open: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = Qo(), { searchClient: a } = xc(r.config.hostUrl, r.config.apiKey), s = ie(), i = ie(""), [l, c] = Uo(!1);
    Ac(s, (g) => {
      g.input.focus();
    });
    const u = nn((g, p) => {
      c(!0), i.value = p, g(p);
    }, 300), m = (g) => {
      t("update:modelValue", g.barcode);
    }, y = async () => {
      t("close"), await Cc(200), i.value = "";
    };
    return (g, p) => (w(), L(Uf, {
      open: g.open,
      scrollable: "",
      onClose: y
    }, {
      default: M(() => [
        H(lw, null, {
          default: M(() => [
            H(ew, null, {
              default: M(() => p[0] || (p[0] = [
                se(" Find your address ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        H(cw, null, {
          default: M(() => [
            R(g.$slots, "default"),
            H(P(uu), {
              class: "space-y-base",
              "search-client": P(a),
              "index-name": "addresses:building_number:asc",
              future: { preserveSharedStateOnUnmount: !0 }
            }, {
              default: M(() => [
                H(P(P6), { hitsPerPage: 100 }),
                H(P(Xs), { class: "flex-none" }, {
                  default: M(({ refine: d }) => [
                    H(ba, He({
                      ref_key: "refInput",
                      ref: s,
                      "model-value": i.value,
                      type: "search",
                      "aria-controls": P(n),
                      "aria-expanded": P(l)
                    }, g.$attrs, {
                      "onUpdate:modelValue": (h) => P(u)(d, h)
                    }), null, 16, ["model-value", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                i.value.length ? (w(), L(P(T6), {
                  key: 0,
                  class: "-mx-6"
                }, {
                  default: M(({ items: d }) => [
                    A("div", {
                      id: P(n),
                      class: Z([
                        "w-full text-base",
                        "sm:text-sm"
                      ])
                    }, [
                      A("ul", pw, [
                        (w(!0), j(ye, null, je(d, (h) => (w(), j("li", {
                          key: h.id,
                          class: Z([
                            "relative cursor-default select-none py-2 px-base text-default-700",
                            "hover:bg-default-100"
                          ]),
                          role: "option",
                          onClick: (f) => m(h)
                        }, [
                          H(P(Gs), {
                            hit: h,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ], 8, dw))), 128))
                      ])
                    ], 8, uw)
                  ]),
                  _: 1
                })) : Q("", !0)
              ]),
              _: 1
            }, 8, ["search-client"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), gw = { class: "fixed inset-0 w-screen overflow-y-auto" }, mw = {
  class: /* @__PURE__ */ Z([
    "flex min-h-full items-end justify-center p-4 text-center",
    "sm:items-center"
  ])
}, yw = { class: "relative" }, xM = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "AiModal",
  props: {
    open: { type: Boolean, default: !1 },
    size: { default: "base" }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    Be("emit", r);
    const t = /* @__PURE__ */ new Map([
      ["sm", "sm:max-w-md"],
      ["base", "sm:max-w-lg"],
      ["lg", "sm:max-w-2xl"],
      ["xl", "sm:max-w-4xl"],
      ["2xl", "sm:max-w-6xl"]
    ]);
    return (n, a) => (w(), L(P(sa), {
      appear: "",
      show: n.open,
      as: "template"
    }, {
      default: M(() => [
        H(P(ia), {
          as: "div",
          class: "relative z-[60]",
          onClose: a[0] || (a[0] = (s) => r("close"))
        }, {
          default: M(() => [
            H(P(qo), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: M(() => a[1] || (a[1] = [
                A("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            A("div", gw, [
              A("div", mw, [
                H(P(qo), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: M(() => [
                    H(P(la), He({
                      class: [
                        "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all",
                        "sm:my-8 sm:w-full",
                        P(t).get(n.size),
                        // Apply top border radius to ModalContent if there is no ModalHeader
                        "[&:not(:has([data-slot=modal-header]))_[data-slot=modal-content]]:rounded-t-lg",
                        // Apply bottom border radius to ModalContent if there is no ModalFooter
                        "[&:not(:has([data-slot=modal-footer]))_[data-slot=modal-content]]:rounded-b-lg"
                      ]
                    }, n.$attrs), {
                      default: M(() => [
                        a[2] || (a[2] = A("div", { class: "absolute blur-3xl rotate-[-120deg] w-[480px] h-[250px] right-[-220px] top-[-100px] bg-[linear-gradient(90deg,_rgba(172,167,232,0.6)_0%,_rgba(214,150,229,0.6)_38.42%,_rgba(135,199,235,0.6)_66.92%,_rgba(119,165,234,0.6)_100%)]" }, null, -1)),
                        A("div", yw, [
                          R(n.$slots, "default")
                        ])
                      ]),
                      _: 3
                    }, 16, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), fw = {}, hw = {
  class: "p-6 text-sm",
  "data-slot": "modal-content"
};
function Fw(o, e) {
  return w(), j("div", hw, [
    R(o.$slots, "default")
  ]);
}
const AM = /* @__PURE__ */ le(fw, [["render", Fw]]), eo = /* @__PURE__ */ W({
  __name: "Button",
  props: {
    as: { default: void 0 },
    block: { type: Boolean },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    id: { default: void 0 },
    leadingIcon: { default: void 0 },
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    trailingIcon: { default: void 0 },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: "px-2.5 py-2 text-sm rounded gap-x-1.5",
      base: "px-3.5 py-2.5 text-sm rounded-md gap-x-2",
      lg: "px-4 py-3 text-base rounded-md gap-x-2",
      xl: "px-7 py-4 text-lg rounded-md gap-x-4"
    }, t = {
      primary: "shadow-sm border-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm border-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900",
      tertiary: "border-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm border-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm border-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm border-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = ae(() => r[e.size]), a = ae(() => t[e.color]), s = ae(() => e.disabled || e.loading);
    return (i, l) => (w(), L(Fe(i.as ?? (i.href ? P(Co) : "button")), {
      id: i.id,
      class: Z([
        "relative inline-flex justify-center items-center font-medium border border-px",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        n.value,
        a.value,
        i.block && "w-full",
        s.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400"
      ]),
      href: i.href,
      type: i.type,
      method: i.method,
      disabled: s.value,
      "aria-disabled": s.value,
      "aria-busy": i.loading,
      tabindex: s.value ? "-1" : 0
    }, {
      default: M(() => [
        H(Jr, null, {
          default: M(() => [
            i.leadingIcon && !i.loading ? (w(), L(P(ce), {
              key: 0,
              icon: i.leadingIcon,
              "aria-hidden": "true",
              class: "size-4"
            }, null, 8, ["icon"])) : Q("", !0),
            i.loading ? (w(), L(Yr, {
              key: 1,
              class: "size-4"
            })) : Q("", !0),
            R(i.$slots, "default"),
            i.trailingIcon ? (w(), L(P(ce), {
              key: 2,
              icon: i.trailingIcon,
              "aria-hidden": "true",
              class: "size-4"
            }, null, 8, ["icon"])) : Q("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex"]));
  }
}), bw = {
  class: /* @__PURE__ */ Z([
    "flex flex-row-reverse justify-start gap-2 px-6 py-4 border-t border-default-300"
  ]),
  "data-slot": "modal-footer"
}, CM = /* @__PURE__ */ W({
  __name: "AiModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", bw, [
      R(r.$slots, "default"),
      r.hideCancel ? Q("", !0) : (w(), L(eo, {
        key: 0,
        color: "secondary",
        type: "button",
        onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
      }, {
        default: M(() => t[1] || (t[1] = [
          se(" Cancel ")
        ])),
        _: 1
      }))
    ]));
  }
}), vw = {
  class: "px-6 pt-6 text-center",
  "data-slot": "modal-header"
}, Pw = { class: "absolute top-2 right-2" }, Bw = { class: "space-y-2" }, OM = /* @__PURE__ */ W({
  __name: "AiModalHeader",
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", vw, [
      A("div", Pw, [
        H(Po, {
          color: "tertiary",
          size: "sm",
          ariaLabel: "Close",
          type: "button",
          icon: P(fa),
          onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
        }, null, 8, ["icon"])
      ]),
      A("div", Bw, [
        H(P(ce), {
          icon: P(Q0),
          class: "text-violet-800 size-10 opacity-30",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        R(r.$slots, "default")
      ])
    ]));
  }
}), TM = /* @__PURE__ */ W({
  __name: "AiModalTitle",
  setup(o) {
    return (e, r) => (w(), L(Dr, {
      as: P(js),
      size: "lg"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
});
var kw = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [
    512,
    512,
    [61532, "times-circle", "xmark-circle"],
    "f057",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
  ]
}, ww = kw, Dw = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [
    512,
    512,
    [9888, "exclamation-triangle", "warning"],
    "f071",
    "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
  ]
}, Sw = {
  prefix: "fas",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
  ]
}, Ew = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
  ]
}, xw = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, Yf = xw, Aw = {
  prefix: "fas",
  iconName: "face-hand-over-mouth",
  icon: [
    512,
    512,
    [129762],
    "e378",
    "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
  ]
}, Cw = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Jf = Cw, Ow = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
};
const Tw = { class: "flex" }, jw = { class: "shrink-0" }, jM = /* @__PURE__ */ W({
  __name: "Alert",
  props: {
    icon: { default: void 0 },
    link: { default: void 0 },
    type: { default: "info" }
  },
  setup(o) {
    const e = o;
    Be("type", e.type);
    const r = /* @__PURE__ */ new Map([
      ["info", "bg-blue-50"],
      ["success", "bg-green-50"],
      ["error", "bg-red-50"],
      ["warning", "bg-yellow-50"]
    ]), t = /* @__PURE__ */ new Map([
      ["info", "text-blue-400"],
      ["success", "text-green-400"],
      ["error", "text-red-400"],
      ["warning", "text-yellow-400"]
    ]), n = ae(() => e.icon ? e.icon : {
      info: Yf,
      error: Aw,
      warning: Ow,
      success: Jf
    }[e.type]);
    return (a, s) => (w(), j("div", {
      class: Z(["rounded-md p-4", P(r).get(a.type)])
    }, [
      A("div", Tw, [
        A("div", jw, [
          H(P(ce), {
            icon: n.value,
            class: Z(["size-4", P(t).get(a.type)]),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])
        ]),
        A("div", {
          class: Z([["ml-3 flex-1 grid grid-cols-1 gap-2", "md:grid-cols-12"], "[&:has([data-slot='description'])_[data-slot='title']]:font-medium"])
        }, [
          R(a.$slots, "default")
        ])
      ])
    ], 2));
  }
}), MM = /* @__PURE__ */ W({
  __name: "AlertDescription",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = pe("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700"],
      ["success", "text-green-700"],
      ["error", "text-red-700"],
      ["warning", "text-yellow-700"]
    ]);
    return (t, n) => (w(), L(Fe(t.as), {
      class: Z([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-2 md:row-end-3",
        P(r).get(P(e))
      ]),
      "data-slot": "description"
    }, {
      default: M(() => [
        R(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), zM = /* @__PURE__ */ W({
  __name: "AlertLink",
  props: {
    as: { default: Co }
  },
  setup(o) {
    const e = pe("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700 hover:text-blue-600"],
      ["success", "text-green-700 hover:text-green-600"],
      ["error", "text-red-700 hover:text-red-600"],
      ["warning", "text-yellow-700 hover:text-yellow-600"]
    ]);
    return (t, n) => (w(), L(Fe(t.as), {
      class: Z([
        "pt-3 text-sm whitespace-nowrap font-medium",
        "md:pt-0 md:text-right md:col-start-11 md:col-end-13",
        P(r).get(P(e))
      ])
    }, {
      default: M(() => [
        R(t.$slots, "default"),
        n[0] || (n[0] = A("span", { "aria-hidden": "true" }, " →", -1))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Mw = { class: "fixed inset-0 w-screen overflow-y-auto" }, zw = {
  class: /* @__PURE__ */ Z([
    "flex min-h-full items-end justify-center p-4 text-center",
    "sm:items-center"
  ])
}, NM = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "AlertModal",
  props: {
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    return Be("emit", r), (t, n) => (w(), L(P(sa), {
      appear: "",
      show: t.open,
      as: "template"
    }, {
      default: M(() => [
        H(P(ia), {
          as: "div",
          class: "relative z-[60]",
          onClose: n[0] || (n[0] = (a) => r("close"))
        }, {
          default: M(() => [
            H(P(qo), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: M(() => n[1] || (n[1] = [
                A("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            A("div", Mw, [
              A("div", zw, [
                H(P(qo), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: M(() => [
                    H(P(la), He({ class: [
                      "relative transform rounded-lg bg-white text-left shadow-xl transition-all",
                      "sm:my-8 sm:w-full sm:max-w-lg"
                    ] }, t.$attrs), {
                      default: M(() => [
                        R(t.$slots, "default")
                      ]),
                      _: 3
                    }, 16)
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), IM = /* @__PURE__ */ W({
  __name: "AlertModalDescription",
  setup(o) {
    return (e, r) => (w(), L(P(Sc), { class: "text-default-500 text-sm" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Nw = { class: "py-4 px-6 flex flex-row-reverse justify-start gap-x-2 border-t border-default-300" }, RM = /* @__PURE__ */ W({
  __name: "AlertModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", Nw, [
      R(r.$slots, "default"),
      r.hideCancel ? Q("", !0) : (w(), L(eo, {
        key: 0,
        color: "secondary",
        onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
      }, {
        default: M(() => t[1] || (t[1] = [
          se(" Cancel ")
        ])),
        _: 1
      }))
    ]));
  }
}), Iw = {}, Rw = { class: "p-6 space-y-2" };
function Lw(o, e) {
  return w(), j("div", Rw, [
    R(o.$slots, "default")
  ]);
}
const LM = /* @__PURE__ */ le(Iw, [["render", Lw]]), HM = /* @__PURE__ */ W({
  __name: "AlertModalTitle",
  setup(o) {
    return (e, r) => (w(), L(Dr, { as: P(js) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), WM = /* @__PURE__ */ W({
  __name: "AlertTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    const e = pe("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-800"],
      ["success", "text-green-800"],
      ["error", "text-red-800"],
      ["warning", "text-yellow-800"]
    ]);
    return (t, n) => (w(), L(Fe(t.as), {
      class: Z([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-1 md:row-end-2",
        P(r).get(P(e))
      ]),
      "data-slot": "title"
    }, {
      default: M(() => [
        R(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Qf = /* @__PURE__ */ W({
  __name: "Badge",
  props: {
    color: { default: "default" },
    icon: { default: void 0 }
  },
  setup(o) {
    Be("badge-color", o.color);
    const r = /* @__PURE__ */ new Map([
      ["default", "bg-default-50 text-default-600 ring-default-500/10"],
      ["gray", "bg-gray-50 text-gray-600 ring-gray-500/10"],
      ["darkGray", "bg-gray-300 text-gray-700 ring-gray-500/10"],
      ["red", "bg-red-50 text-red-700 ring-red-600/10"],
      ["orange", "bg-orange-100 text-orange-700 ring-orange-400/10"],
      ["yellow", "bg-yellow-50 text-yellow-800 ring-yellow-600/20"],
      ["green", "bg-green-50 text-green-700 ring-green-600/20"],
      ["teal", "bg-teal-50 text-teal-700 ring-teal-600/20"],
      ["blue", "bg-blue-50 text-blue-700 ring-blue-700/10"],
      ["darkBlue", "bg-blue-200 text-blue-700 ring-blue-700/10"],
      ["primary", "bg-primary-50 text-primary-700 ring-primary-700/10"],
      ["purple", "bg-purple-50 text-purple-700 ring-purple-700/10"],
      ["pink", "bg-pink-50 text-pink-700 ring-pink-700/10"]
    ]);
    return (t, n) => (w(), j("span", {
      class: Z([
        "inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",
        P(r).get(t.color)
      ])
    }, [
      t.icon ? (w(), L(P(ce), {
        key: 0,
        icon: t.icon,
        "aria-hidden": "true",
        class: "size-2.5 -ml-1"
      }, null, 8, ["icon"])) : Q("", !0),
      R(t.$slots, "default")
    ], 2));
  }
}), Hw = { class: "sr-only" }, VM = /* @__PURE__ */ W({
  __name: "BadgeButton",
  props: {
    icon: {}
  },
  setup(o) {
    const e = pe("badge-color") ?? "default", r = /* @__PURE__ */ new Map([
      ["default", "hover:bg-default-500/20 text-default-600/50 hover:text-default-600/75"],
      ["gray", "hover:bg-gray-500/20 text-gray-600/50 hover:text-gray-600/75"],
      ["darkGray", "hover:bg-gray-500/20 text-gray-600/50 hover:text-gray-600/75"],
      ["red", "hover:bg-red-500/20 text-red-600/50 hover:text-red-600/75"],
      ["orange", "hover:bg-orange-500/20 text-orange-600/50 hover:text-orange-600/75"],
      ["yellow", "hover:bg-yellow-500/20 text-yellow-600/50 hover:text-yellow-600/75"],
      ["green", "hover:bg-green-500/20 text-green-600/50 hover:text-green-600/75"],
      ["teal", "hover:bg-teal-500/20 text-teal-600/50 hover:text-teal-600/75"],
      ["blue", "hover:bg-blue-500/20 text-blue-600/50 hover:text-blue-600/75"],
      ["darkBlue", "hover:bg-blue-500/20 text-blue-600/50 hover:text-blue-600/75"],
      ["primary", "hover:bg-primary-500/20 text-primary-600/50 hover:text-primary-600/75"],
      ["purple", "hover:bg-purple-500/20 text-purple-600/50 hover:text-purple-600/75"],
      ["pink", "hover:bg-pink-500/20 text-pink-600/50 hover:text-pink-600/75"]
    ]);
    return (t, n) => (w(), j("button", {
      type: "button",
      class: Z([
        "relative inline-flex justify-center items-center -mr-1 size-3.5 rounded-sm",
        P(r).get(P(e))
      ])
    }, [
      H(Jr, null, {
        default: M(() => [
          A("span", Hw, [
            R(t.$slots, "default")
          ]),
          H(P(ce), {
            icon: t.icon,
            class: "size-2.5",
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ]),
        _: 3
      })
    ], 2));
  }
}), Ww = { class: "w-full rounded-md bg-white p-base" }, Vw = { class: "mt-5 text-gray-500 text-sm leading-normal" }, jg = /* @__PURE__ */ W({
  __name: "TextPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    fontSize: {},
    textColour: {}
  },
  setup(o) {
    const e = o;
    return (r, t) => (w(), j("div", Ww, [
      A("h2", {
        style: zo({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          fontSize: `${e.fontSize}px`,
          color: e.textColour
        })
      }, " The Quick Brown Fox Jumps Over The Lazy Dog ", 4),
      A("p", Vw, _(r.fontFamily) + ", " + _(r.fontWeight) + ", " + _(r.fontSize) + "px, " + _(r.textColour), 1)
    ]));
  }
}), Gw = ["src"], Mg = /* @__PURE__ */ W({
  __name: "ImagePreview",
  props: {
    src: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", {
      class: Z(["flex size-full items-center justify-center rounded-md bg-white p-base", {
        "bg-checkerboard": !e.src
      }])
    }, [
      e.src ? (w(), j("img", {
        key: 0,
        src: e.src,
        alt: "Image Preview",
        class: "max-h-full max-w-full"
      }, null, 8, Gw)) : Q("", !0)
    ], 2));
  }
}), Zw = { class: "flex size-full items-center justify-center rounded-md bg-white p-base" }, zg = /* @__PURE__ */ W({
  __name: "ButtonPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    textColour: {},
    textHoverColour: {},
    backgroundColour: {},
    backgroundHoverColour: {},
    text: {}
  },
  setup(o) {
    const e = o;
    return (r, t) => (w(), j("div", Zw, [
      A("button", {
        class: "inline-flex items-center rounded-md px-3 py-2 text-sm transition duration-150 ease-in-out",
        style: zo({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          color: e.textColour,
          backgroundColor: e.backgroundColour
        })
      }, _(r.text ?? "Example button"), 5)
    ]));
  }
}), Xw = { class: "mx-2 items-center justify-center text-center" }, qw = { class: "text-xs text-gray-700" }, Ng = /* @__PURE__ */ W({
  __name: "ColourPreview",
  props: {
    colour: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", Xw, [
      A("div", {
        class: "mx-auto flex size-14 shrink-0 items-center justify-center rounded-md",
        style: zo(`background-color: ${e.colour}`)
      }, null, 4),
      A("span", qw, _(e.colour), 1)
    ]));
  }
}), Uw = {}, Yw = { class: "flex flex-col rounded-md bg-gray-200 p-base" }, Jw = { class: "grow" };
function Qw(o, e) {
  return w(), j("div", Yw, [
    e[0] || (e[0] = A("div", { class: "mb-3 flex justify-end" }, [
      A("span", { class: "rounded-full bg-blue-100 px-3 py-0.5 text-xs font-semibold text-blue-800" }, " Preview ")
    ], -1)),
    A("div", Jw, [
      R(o.$slots, "default")
    ])
  ]);
}
const Kw = /* @__PURE__ */ le(Uw, [["render", Qw]]), _w = { class: "max-w-2xl" }, $w = { class: "flex flex-row gap-base" }, eD = { class: "w-1/2" }, oD = { class: "w-1/2" }, rD = { class: "mt-base flex flex-col 2xl:flex-row gap-base" }, tD = { class: "w-full 2xl:w-2/12 mb-base 2xl:mb-0" }, nD = { class: "w-full 2xl:w-5/12 mb-base 2xl:mb-0" }, aD = { class: "flex h-full items-center rounded-md bg-white" }, sD = { class: "w-full 2xl:w-5/12" }, iD = { class: "flex justify-center rounded-md bg-white p-base" }, GM = /* @__PURE__ */ W({
  __name: "BrandPreviewLarge",
  props: {
    rectangleLogoSrc: {},
    squareLogoSrc: {},
    headingFontFamily: {},
    headingFontWeight: {},
    headingFontSize: {},
    headingTextColour: {},
    bodyFontFamily: {},
    bodyFontWeight: {},
    bodyFontSize: {},
    bodyTextColour: {},
    primaryColour: {},
    secondaryColour: {},
    primaryButtonFontFamily: {},
    primaryButtonFontWeight: {},
    primaryButtonTextColour: {},
    primaryButtonTextHoverColour: {},
    primaryButtonBackgroundColour: {},
    primaryButtonBackgroundHoverColour: {},
    secondaryButtonFontFamily: {},
    secondaryButtonFontWeight: {},
    secondaryButtonTextColour: {},
    secondaryButtonTextHoverColour: {},
    secondaryButtonBackgroundColour: {},
    secondaryButtonBackgroundHoverColour: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", _w, [
      H(Kw, null, {
        default: M(() => [
          A("div", $w, [
            A("div", eD, [
              H(Mg, {
                src: e.rectangleLogoSrc,
                class: "h-full"
              }, null, 8, ["src"])
            ]),
            A("div", oD, [
              H(jg, {
                "font-family": e.headingFontFamily,
                "font-weight": e.headingFontWeight,
                "font-size": e.headingFontSize,
                "text-colour": e.headingTextColour
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"]),
              H(jg, {
                "font-family": e.bodyFontFamily,
                "font-weight": e.bodyFontWeight,
                "font-size": e.bodyFontSize,
                "text-colour": e.bodyTextColour,
                class: "mt-base"
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"])
            ])
          ]),
          A("div", rD, [
            A("div", tD, [
              H(Mg, {
                src: e.squareLogoSrc,
                class: "h-full"
              }, null, 8, ["src"])
            ]),
            A("div", nD, [
              A("div", aD, [
                H(zg, {
                  "font-family": e.primaryButtonFontFamily,
                  "font-weight": e.primaryButtonFontWeight,
                  "text-colour": e.primaryButtonTextColour,
                  "text-hover-colour": e.primaryButtonTextHoverColour,
                  "background-colour": e.primaryButtonBackgroundColour,
                  "background-hover-colour": e.primaryButtonBackgroundHoverColour,
                  text: "Primary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"]),
                H(zg, {
                  "font-family": e.secondaryButtonFontFamily,
                  "font-weight": e.secondaryButtonFontWeight,
                  "text-colour": e.secondaryButtonTextColour,
                  "text-hover-colour": e.secondaryButtonTextHoverColour,
                  "background-colour": e.secondaryButtonBackgroundColour,
                  "background-hover-colour": e.secondaryButtonBackgroundHoverColour,
                  text: "Secondary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"])
              ])
            ]),
            A("div", sD, [
              A("div", iD, [
                H(Ng, { colour: e.primaryColour }, null, 8, ["colour"]),
                H(Ng, { colour: e.secondaryColour }, null, 8, ["colour"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]));
  }
}), lD = { class: "divide-y divide-default-300 rounded-md bg-default-50 border border-default-300 max-w-56 min-h-32" }, cD = { class: "space-y-base p-4 py-base items-center" }, uD = { class: "flex justify-between space-x-2" }, pD = { class: "flex space-x-1" }, dD = { key: 0 }, gD = ["src"], ZM = /* @__PURE__ */ W({
  __name: "BrandPreviewSmall",
  props: {
    rectangleLogoSrc: {},
    headingFontFamily: {},
    headingFontWeight: {},
    headingTextColour: {},
    primaryColour: {},
    secondaryColour: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", lD, [
      R(e.$slots, "default"),
      A("div", cD, [
        A("div", uD, [
          A("div", {
            style: zo({
              fontFamily: e.headingFontFamily,
              fontWeight: e.headingFontWeight,
              color: e.headingTextColour
            }),
            class: "text-3xl text-black"
          }, " Aa ", 4),
          A("div", pD, [
            A("span", {
              class: "h-full w-16 rounded-sm",
              style: zo({ backgroundColor: e.primaryColour })
            }, null, 4),
            A("span", {
              class: "h-full w-16 rounded-sm",
              style: zo({ backgroundColor: e.secondaryColour })
            }, null, 4)
          ])
        ]),
        e.rectangleLogoSrc ? (w(), j("div", dD, [
          A("img", {
            src: e.rectangleLogoSrc,
            class: "h-6 object-contain",
            alt: ""
          }, null, 8, gD)
        ])) : Q("", !0)
      ])
    ]));
  }
}), mD = {}, yD = { class: "px-2 py-2.5 text-left text-xs font-normal text-default-500" };
function fD(o, e) {
  return w(), j("div", yD, [
    R(o.$slots, "default")
  ]);
}
const XM = /* @__PURE__ */ le(mD, [["render", fD]]), hD = { class: "flex items-center" }, qM = /* @__PURE__ */ W({
  __name: "Breadcrumb",
  props: {
    current: { type: Boolean, default: !1 },
    href: {}
  },
  setup(o) {
    const e = pe("as");
    return (r, t) => (w(), j("li", null, [
      A("div", hD, [
        H(P(ce), {
          icon: P(Ew),
          class: "size-3 shrink-0 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        (w(), L(Fe(P(e)), {
          href: r.href,
          class: Z([
            "ml-3 text-sm font-medium",
            r.current ? "text-primary-600" : "text-default-600 hover:text-default-700"
          ]),
          "aria-current": r.current ? "page" : void 0
        }, {
          default: M(() => [
            R(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["href", "class", "aria-current"]))
      ])
    ]));
  }
}), FD = {
  class: "flex text-sm",
  "aria-label": "Breadcrumb"
}, bD = {
  role: "list",
  class: "flex items-center space-x-3"
}, UM = /* @__PURE__ */ W({
  __name: "BreadcrumbGroup",
  props: {
    as: { default: Co },
    homeUrl: {}
  },
  setup(o) {
    return Be("as", o.as), (r, t) => (w(), j("nav", FD, [
      A("ol", bD, [
        A("li", null, [
          A("div", null, [
            (w(), L(Fe(r.as), {
              href: r.homeUrl,
              class: Z([
                "text-default-600 hover:text-default-700"
              ])
            }, {
              default: M(() => [
                H(P(ce), {
                  icon: P(Gf),
                  class: "size-4",
                  "aria-hidden": "true"
                }, null, 8, ["icon"]),
                t[0] || (t[0] = A("span", { class: "sr-only" }, " Home ", -1))
              ]),
              _: 1
            }, 8, ["href"]))
          ])
        ]),
        R(r.$slots, "default")
      ])
    ]));
  }
}), vD = (o = "idle") => {
  const e = ie(o), r = (i) => {
    e.value = i;
  }, t = ae(() => e.value === "loading"), n = ae(() => e.value === "success"), a = ae(() => e.value === "error"), s = ae(() => e.value === "idle");
  return {
    setStatus: r,
    isLoading: t,
    isSuccess: n,
    isError: a,
    isIdle: s
  };
}, PD = { class: "rounded-lg overflow-hidden bg-white" }, BD = {
  key: 0,
  ref: "refMenuBar",
  class: "flex py-1.5 px-3 bg-default-50 border-b border-b-default-200 space-x-tiny",
  "aria-hidden": "true"
}, kD = {
  key: 1,
  class: "flex justify-between py-3 px-large items-center",
  "aria-hidden": "true"
}, wD = {
  key: 0,
  class: "bg-white flex items-center justify-center h-full"
}, DD = ["title", "src"], SD = {
  key: 2,
  class: "text-center h-full flex items-center justify-center bg-white"
}, YM = /* @__PURE__ */ W({
  __name: "BrowserWindow",
  props: {
    aspectRatio: { default: "16/9" },
    breakpoint: { default: "sm" },
    hideMenuBar: { type: Boolean },
    title: {},
    type: { default: "desktop" },
    url: {}
  },
  setup(o) {
    const e = o, r = vD(), t = ie(), n = ie(), a = Rm({}), s = ae(() => ({
      xs: 425,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536
    })[e.breakpoint]), i = async () => {
      var c;
      if ((c = t.value) != null && c.contentWindow)
        try {
          const u = t.value.contentWindow.document;
          u.readyState === "complete" || u.readyState === "interactive" ? r.setStatus("success") : j1(u, "DOMContentLoaded", () => {
            r.setStatus("success");
          });
        } catch (u) {
          r.setStatus("error"), console.error(u);
        }
    }, l = () => {
      if (!t.value || !n.value)
        return;
      const c = s.value, u = n.value.clientWidth / c, [m, y] = e.aspectRatio.split("/").map(Number), g = Math.ceil(n.value.clientWidth * y / m);
      a.width = `${c}px`, a.height = `${Math.ceil(g / u)}px`, a.transform = `scale(${u})`, n.value.style.height = `${g}px`;
    };
    return ur(() => {
      r.setStatus("loading"), l(), T1(n, () => {
        l();
      });
    }), Et(s, l), (c, u) => (w(), j("div", PD, [
      !c.hideMenuBar && c.type === "desktop" ? (w(), j("div", BD, u[0] || (u[0] = [
        A("span", { class: "bg-red-400 w-1.5 h-1.5 rounded-full block" }, null, -1),
        A("span", { class: "bg-yellow-300 w-1.5 h-1.5 rounded-full block" }, null, -1),
        A("span", { class: "bg-green-400 w-1.5 h-1.5 rounded-full block" }, null, -1)
      ]), 512)) : Q("", !0),
      !c.hideMenuBar && c.type === "mobile" ? (w(), j("div", kD, u[1] || (u[1] = [
        rr('<div><svg width="30" height="12" viewBox="0 0 30 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.85596 0.66748C7.11182 0.66748 9.07471 2.27148 9.07471 6.08008V6.09473C9.07471 9.6543 7.4707 11.7637 4.81201 11.7637C2.87109 11.7637 1.4209 10.6138 1.08398 8.99512L1.06934 8.91455H2.92969L2.95166 8.98779C3.22998 9.72754 3.88184 10.2109 4.81201 10.2109C6.48926 10.2109 7.19971 8.57031 7.28027 6.54883C7.28027 6.46826 7.2876 6.3877 7.2876 6.30713H7.14111C6.75293 7.14209 5.83008 7.88184 4.37988 7.88184C2.35107 7.88184 0.930176 6.40234 0.930176 4.39551V4.38086C0.930176 2.23486 2.56348 0.66748 4.85596 0.66748ZM4.84863 6.43164C6.04248 6.43164 6.95801 5.56738 6.95801 4.37354V4.35889C6.95801 3.15039 6.04248 2.20557 4.87061 2.20557C3.70605 2.20557 2.77588 3.13574 2.77588 4.31494V4.32959C2.77588 5.55273 3.64746 6.43164 4.84863 6.43164ZM12.0799 4.65186C11.4134 4.65186 10.9154 4.13916 10.9154 3.49463C10.9154 2.84277 11.4134 2.3374 12.0799 2.3374C12.7537 2.3374 13.2445 2.84277 13.2445 3.49463C13.2445 4.13916 12.7537 4.65186 12.0799 4.65186ZM12.0799 10.0864C11.4134 10.0864 10.9154 9.58105 10.9154 8.9292C10.9154 8.27734 11.4134 7.77197 12.0799 7.77197C12.7537 7.77197 13.2445 8.27734 13.2445 8.9292C13.2445 9.58105 12.7537 10.0864 12.0799 10.0864ZM20.2121 11.5V9.47119H15.0412V7.92578C16.4108 5.54541 17.9122 3.11377 19.3478 0.931152H22.0211V7.91113H23.442V9.47119H22.0211V11.5H20.2121ZM16.799 7.95508H20.2413V2.43994H20.1315C19.0475 4.09521 17.8244 6.05078 16.799 7.84521V7.95508ZM27.5019 11.5V2.7915H27.3774L24.748 4.65186V2.87207L27.5092 0.931152H29.3916V11.5H27.5019Z" fill="#020202"></path></svg></div><div><svg width="65" height="17" viewBox="0 0 65 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 3.5H16C15.4477 3.5 15 3.94772 15 4.5V13.1667C15 13.719 15.4477 14.1667 16 14.1667H17C17.5523 14.1667 18 13.719 18 13.1667V4.5C18 3.94772 17.5523 3.5 17 3.5ZM11.3333 5.83333H12.3333C12.8856 5.83333 13.3333 6.28105 13.3333 6.83333V13.1667C13.3333 13.719 12.8856 14.1667 12.3333 14.1667H11.3333C10.781 14.1667 10.3333 13.719 10.3333 13.1667V6.83333C10.3333 6.28105 10.781 5.83333 11.3333 5.83333ZM7.66667 8.16667H6.66667C6.11438 8.16667 5.66667 8.61438 5.66667 9.16667V13.1667C5.66667 13.719 6.11438 14.1667 6.66667 14.1667H7.66667C8.21895 14.1667 8.66667 13.719 8.66667 13.1667V9.16667C8.66667 8.61438 8.21895 8.16667 7.66667 8.16667ZM3 10.1667H2C1.44772 10.1667 1 10.6144 1 11.1667V13.1667C1 13.719 1.44772 14.1667 2 14.1667H3C3.55228 14.1667 4 13.719 4 13.1667V11.1667C4 10.6144 3.55228 10.1667 3 10.1667Z" fill="#020202"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M35.9392 8.15566C34.3333 6.62886 32.2021 5.77742 29.9862 5.77733C27.7701 5.77732 25.6387 6.62876 24.0325 8.15566C23.9117 8.27372 23.7182 8.27223 23.5992 8.15233L22.4429 6.98566C22.3826 6.92489 22.3491 6.84262 22.3496 6.75704C22.3502 6.67146 22.3848 6.58963 22.4459 6.52966C26.661 2.49011 33.3108 2.49011 37.5259 6.52966C37.5869 6.58967 37.6215 6.67153 37.622 6.75711C37.6225 6.84269 37.5889 6.92494 37.5285 6.98566L36.3725 8.15233C36.2534 8.27205 36.0601 8.27354 35.9392 8.15566ZM29.9863 9.57299C31.2038 9.57292 32.3778 10.0254 33.2803 10.8427C33.4023 10.9586 33.5946 10.9561 33.7136 10.837L34.8683 9.67032C34.9291 9.60913 34.9628 9.52611 34.9619 9.43985C34.9611 9.35358 34.9256 9.27127 34.8636 9.21132C32.1154 6.65494 27.8595 6.65494 25.1113 9.21132C25.0492 9.27127 25.0138 9.35362 25.013 9.43992C25.0121 9.52621 25.046 9.60922 25.1069 9.67032L26.2613 10.837C26.3803 10.9561 26.5725 10.9586 26.6946 10.8427C27.5965 10.026 28.7696 9.57349 29.9863 9.57299ZM32.2052 12.3573C32.267 12.2967 32.301 12.2133 32.2992 12.1268C32.2974 12.0403 32.2601 11.9584 32.1959 11.9003C30.9203 10.8214 29.0521 10.8214 27.7765 11.9003C27.7123 11.9583 27.6749 12.0402 27.6731 12.1267C27.6712 12.2132 27.7052 12.2967 27.7669 12.3573L29.7645 14.373C29.8231 14.4322 29.9029 14.4656 29.9862 14.4656C30.0695 14.4656 30.1493 14.4322 30.2079 14.373L32.2052 12.3573Z" fill="#020202"></path><g clip-path="url(#clip0_10335_39516)"><path opacity="0.35" d="M41.5 5.16666C41.5 3.97005 42.47 3 43.6667 3H60.3333C61.53 3 62.5 3.97005 62.5 5.16667V11.1667C62.5 12.3633 61.53 13.3333 60.3333 13.3333H43.6667C42.47 13.3333 41.5 12.3633 41.5 11.1667V5.16666Z" stroke="#020202"></path><path opacity="0.4" d="M64 6.1665V10.1665C64.8047 9.82773 65.328 9.03964 65.328 8.1665C65.328 7.29337 64.8047 6.50528 64 6.1665Z" fill="#020202"></path><path d="M43 5.83333C43 5.09695 43.597 4.5 44.3333 4.5H59.6667C60.403 4.5 61 5.09695 61 5.83333V10.5C61 11.2364 60.403 11.8333 59.6667 11.8333H44.3333C43.597 11.8333 43 11.2364 43 10.5V5.83333Z" fill="#020202"></path></g><defs><clipPath id="clip0_10335_39516"><rect width="25" height="16" fill="white" transform="translate(40 0.5)"></rect></clipPath></defs></svg></div>', 2)
      ]))) : Q("", !0),
      A("div", {
        ref_key: "refIframeContainer",
        ref: n
      }, [
        P(r).isLoading.value ? (w(), j("div", wD, [
          H(P(Yr), { class: "size-4 text-primary-500" })
        ])) : Q("", !0),
        P(r).isError.value ? (w(), j("div", SD, u[2] || (u[2] = [
          rr('<div><svg xmlns="http://www.w3.org/2000/svg" width="64" height="51" viewBox="0 0 64 51" class="mx-auto mb-sm" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25ZM18.2481 48.9999H14.7657H18.2481Z" fill="white"></path><path d="M18.2481 48.9999H14.7657M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25Z" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5563 11.1711C24.5563 27.2827 39.0666 40.5589 57.7502 42.3513C55.4089 45.2305 51.793 47.1837 47.6736 47.4905V47.4999H14.1216C10.0507 47.4999 3.25 45.7847 3.25 38.274C3.25 30.7633 8.5371 29.0482 14.1216 29.0482C14.359 29.0482 14.5946 29.0556 14.828 29.0703C14.6658 28.2276 14.6373 27.359 14.5812 26.4735C14.2019 20.4919 16.8115 12.9532 24.5653 10.4998C24.5591 10.7234 24.5563 10.947 24.5563 11.1711ZM29.8083 36.3788C28.2889 36.3788 27.0572 37.5959 27.0572 39.0973C27.0572 40.5987 28.2889 41.8158 29.8083 41.8158C31.3276 41.8158 32.5593 40.5987 32.5593 39.0973C32.5593 37.5959 31.3276 36.3788 29.8083 36.3788Z" fill="#E8F0FE"></path><path d="M30.002 42.0003C31.5208 42.0003 32.752 40.769 32.752 39.2503C32.752 37.7315 31.5208 36.5002 30.002 36.5002C28.4832 36.5002 27.252 37.7315 27.252 39.2503C27.252 40.769 28.4832 42.0003 30.002 42.0003Z" stroke="#1F64E7" stroke-width="2.5"></path><path d="M22.25 33.5001L25.75 30.7536L22.25 28.1389" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M37.75 33.5001L34.25 30.7536L37.75 28.1389" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M34.7505 12.5002C38.005 13.3615 40.5747 15.9067 41.4707 19.1469" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round"></path><path d="M45.252 4.00001C46.0804 4.00001 46.752 3.32844 46.752 2.50001C46.752 1.67158 46.0804 1 45.252 1C44.4235 1 43.752 1.67158 43.752 2.50001C43.752 3.32844 44.4235 4.00001 45.252 4.00001Z" stroke="#75A4FE" stroke-width="2"></path><path d="M60.75 11.9998C61.5784 11.9998 62.25 11.3282 62.25 10.4998C62.25 9.67133 61.5784 8.99976 60.75 8.99976C59.9216 8.99976 59.25 9.67133 59.25 10.4998C59.25 11.3282 59.9216 11.9998 60.75 11.9998Z" fill="#75A4FE"></path><path d="M49.1309 7.87842L53.31 12.0575M53.3735 7.87842L49.1944 12.0575L53.3735 7.87842Z" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.95117 16.7986L4.95118 19.7986M4.95118 16.7986L1.95117 19.7986L4.95118 16.7986Z" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.75001 13.4998C9.57844 13.4998 10.25 12.8282 10.25 11.9998C10.25 11.1713 9.57844 10.4998 8.75001 10.4998C7.92158 10.4998 7.25 11.1713 7.25 11.9998C7.25 12.8282 7.92158 13.4998 8.75001 13.4998Z" fill="#75A4FE"></path></svg><p class="text-md font-bold text-primary-600"> Whoops! </p></div>', 1)
        ]))) : (w(), j("iframe", {
          key: 1,
          ref_key: "refIframe",
          ref: t,
          title: c.title,
          style: zo(a),
          class: Z([
            "transform origin-top-left pointer-events-none",
            P(r).isLoading.value ? "opacity-0" : "opacity-100"
          ]),
          src: c.url,
          onLoad: i
        }, null, 46, DD))
      ], 512)
    ]));
  }
}), ED = {}, xD = {
  class: /* @__PURE__ */ Z([
    "isolate inline-flex rounded-md",
    "[&>*]:rounded-none [&>*:not(:first-child)]:-ml-px [&>*:first-child]:rounded-l-md [&>*:last-child]:rounded-r-md [&>*]:relative [&>*:focus]:z-10"
  ])
};
function AD(o, e) {
  return w(), j("span", xD, [
    R(o.$slots, "default")
  ]);
}
const JM = /* @__PURE__ */ le(ED, [["render", AD]]), CD = {}, OD = { class: "isolate mt-2 grid grid-cols-7 gap-px bg-default-200 text-sm shadow ring-1 ring-default-200 rounded-lg overflow-hidden" };
function TD(o, e) {
  return w(), j(ye, null, [
    e[0] || (e[0] = rr('<div class="grid grid-cols-7 text-center text-xs/6 text-default-900 font-medium"><span><abbr title="Monday">M</abbr></span><span><abbr title="Tuesday">T</abbr></span><span><abbr title="Wednesday">W</abbr></span><span><abbr title="Thursday">T</abbr></span><span><abbr title="Friday">F</abbr></span><span><abbr title="Saturday">S</abbr></span><span><abbr title="Sunday">S</abbr></span></div>', 1)),
    A("div", OD, [
      R(o.$slots, "default")
    ])
  ], 64);
}
const QM = /* @__PURE__ */ le(CD, [["render", TD]]), jD = ["datetime", "aria-current"], KM = /* @__PURE__ */ W({
  __name: "CalendarMonthViewDay",
  props: {
    as: { default: "span" },
    day: {},
    disabled: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(o) {
    const e = o, r = ae(() => e.as === "button");
    return (t, n) => (w(), L(Fe(t.as), {
      type: r.value ? "button" : void 0,
      class: Z([
        "py-1.5 font-medium",
        t.disabled && "cursor-not-allowed",
        r.value && !t.selected && !t.disabled && "hover:bg-default-100",
        r.value && t.selected && !t.disabled && "hover:bg-primary-700",
        r.value && "focus:z-10",
        t.day.isCurrentMonth && !t.selected ? "bg-white" : "bg-default-100",
        t.selected && "text-white bg-primary-600",
        !t.selected && t.day.isCurrentMonth && !t.day.isToday && "text-default-900",
        !t.selected && !t.day.isCurrentMonth && !t.day.isToday && "text-default-400",
        t.day.isToday && !t.selected && "text-primary-600"
      ]),
      disabled: r.value ? t.disabled : void 0,
      "aria-disabled": r.value ? t.disabled : void 0,
      tabindex: r.value ? t.disabled ? "-1" : 0 : void 0
    }, {
      default: M(() => {
        var a;
        return [
          A("time", {
            datetime: t.day.date,
            class: "mx-auto flex size-7 items-center justify-center",
            "aria-current": t.day.isToday ? "date" : void 0
          }, _((a = t.day.date.split("-").pop()) == null ? void 0 : a.replace(/^0/, "")), 9, jD)
        ];
      }),
      _: 1
    }, 8, ["type", "class", "disabled", "aria-disabled", "tabindex"]));
  }
}), MD = {}, zD = { class: "flex items-center gap-x-base" };
function ND(o, e) {
  return w(), j("div", zD, [
    R(o.$slots, "default")
  ]);
}
const _M = /* @__PURE__ */ le(MD, [["render", ND]]), $M = /* @__PURE__ */ W({
  __name: "CalendarNavigationTitle",
  props: {
    as: { default: "h2" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "flex-1 text-sm font-semibold text-default-900 text-center" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ID = { class: "flex flex-col overflow-hidden rounded-lg border border-default-200" }, ez = /* @__PURE__ */ W({
  __name: "CalendarWeekView",
  props: {
    days: {}
  },
  setup(o) {
    return Be("calendar-week-view-days", o.days), (r, t) => (w(), j("div", ID, [
      R(r.$slots, "default")
    ]));
  }
}), RD = {
  class: /* @__PURE__ */ Z([
    "flex max-w-full flex-none flex-col",
    "sm:max-w-none",
    "md:max-w-full"
  ]),
  style: { width: "165%" }
}, LD = {
  class: /* @__PURE__ */ Z([
    "grid grid-cols-7 text-sm/6 text-default-500",
    "sm:hidden"
  ])
}, HD = ["onClick"], WD = {
  class: /* @__PURE__ */ Z([
    "-mr-px hidden grid-cols-7 divide-x divide-default-100 border-r border-default-100 text-sm/6 text-default-500",
    "sm:grid"
  ])
}, VD = {
  key: 0,
  class: "flex items-baseline"
}, GD = { class: "ml-1.5 flex size-8 items-center justify-center rounded-full bg-primary-600 font-semibold text-white" }, ZD = { key: 1 }, XD = { class: "items-center justify-center font-semibold text-default-900" }, qD = { class: "flex flex-auto" }, UD = { class: "grid flex-auto grid-cols-1 grid-rows-1" }, YD = {
  class: "col-start-1 col-end-2 row-start-1 grid divide-y divide-default-100",
  style: { "grid-template-rows": "repeat(48, minmax(3.5rem, 1fr))" }
}, JD = { class: "sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs/5 text-default-400" }, QD = {
  class: /* @__PURE__ */ Z([
    "col-start-1 col-end-2 row-start-1 grid grid-cols-1",
    "sm:grid-cols-7 sm:pr-8"
  ]),
  style: { "grid-template-rows": "1.75rem repeat(288, minmax(0, 1fr)) auto" }
}, oz = /* @__PURE__ */ W({
  __name: "CalendarWeekViewGrid",
  emits: ["click"],
  setup(o, { emit: e }) {
    const r = pe("calendar-week-view-days"), t = ie(null), n = ie(null), a = ie(null), s = e;
    ur(() => {
      if (!t.value || !n.value || !a.value)
        return;
      const l = (/* @__PURE__ */ new Date()).getHours() * 60;
      t.value.scrollTop = (t.value.scrollHeight - n.value.offsetHeight - a.value.offsetHeight) * l / 1440;
    });
    const i = [
      "12AM",
      "1AM",
      "2AM",
      "3AM",
      "4AM",
      "5AM",
      "6AM",
      "7AM",
      "8AM",
      "9AM",
      "10AM",
      "11AM",
      "12PM",
      "1PM",
      "2PM",
      "3PM",
      "4PM",
      "5PM",
      "6PM",
      "7PM",
      "8PM",
      "9PM",
      "10PM",
      "11PM"
    ];
    return (l, c) => (w(), j("div", {
      ref_key: "container",
      ref: t,
      class: "isolate flex flex-auto flex-col overflow-auto bg-white"
    }, [
      A("div", RD, [
        A("div", {
          ref_key: "containerNav",
          ref: n,
          class: Z([
            "sticky top-0 z-30 flex-none bg-white shadow ring-1 ring-black/5",
            "sm:pr-8"
          ])
        }, [
          A("div", LD, [
            (w(!0), j(ye, null, je(P(r), (u) => (w(), j("button", {
              key: u.date,
              class: "flex flex-col items-center pb-3 pt-2",
              onClick: (m) => s("click", u)
            }, [
              se(_(u.dayName.substring(0, 1)) + " ", 1),
              A("span", {
                class: Z([
                  "mt-1 flex size-8 items-center justify-center font-semibold",
                  u.isToday ? "rounded-full bg-primary-600 font-semibold text-white" : "text-default-900"
                ])
              }, _(u.day), 3)
            ], 8, HD))), 128))
          ]),
          A("div", WD, [
            c[0] || (c[0] = A("div", { class: "col-end-1 w-14" }, null, -1)),
            (w(!0), j(ye, null, je(P(r), (u) => (w(), j("div", {
              key: u.date,
              class: "flex items-center justify-center py-6"
            }, [
              u.isToday ? (w(), j("span", VD, [
                se(_(u.dayName.substring(0, 3)) + " ", 1),
                A("span", GD, _(u.day), 1)
              ])) : (w(), j("span", ZD, [
                se(_(u.dayName.substring(0, 3)) + " ", 1),
                A("span", XD, _(u.day), 1)
              ]))
            ]))), 128))
          ])
        ], 512),
        A("div", qD, [
          c[3] || (c[3] = A("div", { class: "sticky left-0 z-10 w-14 flex-none bg-white ring-1 ring-default-100" }, null, -1)),
          A("div", UD, [
            A("div", YD, [
              A("div", {
                ref_key: "containerOffset",
                ref: a,
                class: "row-end-1 h-7"
              }, null, 512),
              (w(), j(ye, null, je(i, (u) => (w(), j(ye, { key: u }, [
                A("div", null, [
                  A("div", JD, _(u), 1)
                ]),
                c[1] || (c[1] = A("div", null, null, -1))
              ], 64))), 64))
            ]),
            c[2] || (c[2] = rr('<div class="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1 divide-x divide-default-100 sm:grid sm:grid-cols-7"><div class="col-start-1 row-span-full"></div><div class="col-start-2 row-span-full"></div><div class="col-start-3 row-span-full"></div><div class="col-start-4 row-span-full"></div><div class="col-start-5 row-span-full"></div><div class="col-start-6 row-span-full"></div><div class="col-start-7 row-span-full"></div><div class="col-start-8 row-span-full w-8"></div></div>', 1)),
            A("ol", QD, [
              R(l.$slots, "default")
            ])
          ])
        ])
      ])
    ], 512));
  }
});
var as = { exports: {} }, KD = as.exports, Ig;
function _D() {
  return Ig || (Ig = 1, function(o, e) {
    (function(r, t) {
      o.exports = t();
    })(KD, function() {
      var r = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
      return function(a, s, i) {
        var l = s.prototype;
        i.utc = function(d) {
          var h = { date: d, utc: !0, args: arguments };
          return new s(h);
        }, l.utc = function(d) {
          var h = i(this.toDate(), { locale: this.$L, utc: !0 });
          return d ? h.add(this.utcOffset(), r) : h;
        }, l.local = function() {
          return i(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = l.parse;
        l.parse = function(d) {
          d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), c.call(this, d);
        };
        var u = l.init;
        l.init = function() {
          if (this.$u) {
            var d = this.$d;
            this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
          } else u.call(this);
        };
        var m = l.utcOffset;
        l.utcOffset = function(d, h) {
          var f = this.$utils().u;
          if (f(d)) return this.$u ? 0 : f(this.$offset) ? m.call(this) : this.$offset;
          if (typeof d == "string" && (d = function(k) {
            k === void 0 && (k = "");
            var E = k.match(t);
            if (!E) return null;
            var S = ("" + E[0]).match(n) || ["-", 0, 0], B = S[0], D = 60 * +S[1] + +S[2];
            return D === 0 ? 0 : B === "+" ? D : -D;
          }(d), d === null)) return this;
          var F = Math.abs(d) <= 16 ? 60 * d : d, b = this;
          if (h) return b.$offset = F, b.$u = d === 0, b;
          if (d !== 0) {
            var v = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (b = this.local().add(F + v, r)).$offset = F, b.$x.$localOffset = v;
          } else b = this.utc();
          return b;
        };
        var y = l.format;
        l.format = function(d) {
          var h = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return y.call(this, h);
        }, l.valueOf = function() {
          var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * d;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var g = l.toDate;
        l.toDate = function(d) {
          return d === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
        };
        var p = l.diff;
        l.diff = function(d, h, f) {
          if (d && this.$u === d.$u) return p.call(this, d, h, f);
          var F = this.local(), b = i(d).local();
          return p.call(F, b, h, f);
        };
      };
    });
  }(as)), as.exports;
}
var $D = _D();
const e9 = /* @__PURE__ */ Ct($D);
var ss = { exports: {} }, o9 = ss.exports, Rg;
function r9() {
  return Rg || (Rg = 1, function(o, e) {
    (function(r, t) {
      o.exports = t();
    })(o9, function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, t = {};
      return function(n, a, s) {
        var i, l = function(y, g, p) {
          p === void 0 && (p = {});
          var d = new Date(y), h = function(f, F) {
            F === void 0 && (F = {});
            var b = F.timeZoneName || "short", v = f + "|" + b, k = t[v];
            return k || (k = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: f, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: b }), t[v] = k), k;
          }(g, p);
          return h.formatToParts(d);
        }, c = function(y, g) {
          for (var p = l(y, g), d = [], h = 0; h < p.length; h += 1) {
            var f = p[h], F = f.type, b = f.value, v = r[F];
            v >= 0 && (d[v] = parseInt(b, 10));
          }
          var k = d[3], E = k === 24 ? 0 : k, S = d[0] + "-" + d[1] + "-" + d[2] + " " + E + ":" + d[4] + ":" + d[5] + ":000", B = +y;
          return (s.utc(S).valueOf() - (B -= B % 1e3)) / 6e4;
        }, u = a.prototype;
        u.tz = function(y, g) {
          y === void 0 && (y = i);
          var p, d = this.utcOffset(), h = this.toDate(), f = h.toLocaleString("en-US", { timeZone: y }), F = Math.round((h - new Date(f)) / 1e3 / 60), b = 15 * -Math.round(h.getTimezoneOffset() / 15) - F;
          if (!Number(b)) p = this.utcOffset(0, g);
          else if (p = s(f, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(b, !0), g) {
            var v = p.utcOffset();
            p = p.add(d - v, "minute");
          }
          return p.$x.$timezone = y, p;
        }, u.offsetName = function(y) {
          var g = this.$x.$timezone || s.tz.guess(), p = l(this.valueOf(), g, { timeZoneName: y }).find(function(d) {
            return d.type.toLowerCase() === "timezonename";
          });
          return p && p.value;
        };
        var m = u.startOf;
        u.startOf = function(y, g) {
          if (!this.$x || !this.$x.$timezone) return m.call(this, y, g);
          var p = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return m.call(p, y, g).tz(this.$x.$timezone, !0);
        }, s.tz = function(y, g, p) {
          var d = p && g, h = p || g || i, f = c(+s(), h);
          if (typeof y != "string") return s(y).tz(h);
          var F = function(E, S, B) {
            var D = E - 60 * S * 1e3, x = c(D, B);
            if (S === x) return [D, S];
            var C = c(D -= 60 * (x - S) * 1e3, B);
            return x === C ? [D, x] : [E - 60 * Math.min(x, C) * 1e3, Math.max(x, C)];
          }(s.utc(y, d).valueOf(), f, h), b = F[0], v = F[1], k = s(b).utcOffset(v);
          return k.$x.$timezone = h, k;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(y) {
          i = y;
        };
      };
    });
  }(ss)), ss.exports;
}
var t9 = r9();
const n9 = /* @__PURE__ */ Ct(t9), a9 = { class: "absolute inset-0.5" }, rz = /* @__PURE__ */ W({
  __name: "CalendarWeekViewGridItem",
  props: {
    datetime: {},
    duration: {},
    timezone: { default: "Europe/London" }
  },
  setup(o) {
    Or.extend(e9), Or.extend(n9);
    const e = o, r = /* @__PURE__ */ new Map([
      [0, "sm:col-start-7"],
      [1, "sm:col-start-1"],
      [2, "sm:col-start-2"],
      [3, "sm:col-start-3"],
      [4, "sm:col-start-4"],
      [5, "sm:col-start-5"],
      [6, "sm:col-start-6"]
    ]), t = ae(() => {
      const n = Or.utc(e.datetime).tz(e.timezone), a = Or().hour(n.hour()).minute(n.minute()).second(0), s = a.hour() * 60 + a.minute();
      return Math.floor(s / 5) + 2;
    });
    return (n, a) => (w(), j("li", {
      class: Z([
        "relative mt-px flex sm:ml-px",
        P(r).get(P(Or).utc(n.datetime).tz(n.timezone).day())
      ]),
      style: zo({ gridRow: `${t.value} / span ${n.duration / 5}` })
    }, [
      A("div", a9, [
        R(n.$slots, "default")
      ])
    ], 6));
  }
}), s9 = { class: "flex flex-none items-center justify-between border-b border-default-200 px-6 py-4" }, i9 = { class: "flex items-center" }, l9 = { class: "pl-2 pr-base" }, c9 = ["datetime"], tz = /* @__PURE__ */ W({
  __name: "CalendarWeekViewHeader",
  props: {
    current: {}
  },
  emits: ["previous", "today", "next"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), j("header", s9, [
      A("div", i9, [
        H(Po, {
          color: "tertiary",
          size: "sm",
          icon: P(Uc),
          ariaLabel: "Previous week",
          onClick: n[0] || (n[0] = (a) => r("previous"))
        }, null, 8, ["icon"]),
        H(Po, {
          color: "tertiary",
          size: "sm",
          icon: P(Ws),
          ariaLabel: "Next week",
          onClick: n[1] || (n[1] = (a) => r("next"))
        }, null, 8, ["icon"]),
        A("div", l9, [
          H(Dr, { as: "h2" }, {
            default: M(() => [
              A("time", {
                datetime: P(Or)(t.current).format("YYYY-MM")
              }, _(P(Or)(t.current).format("MMMM YYYY")), 9, c9)
            ]),
            _: 1
          })
        ]),
        H(eo, {
          color: "secondary",
          size: "sm",
          onClick: n[2] || (n[2] = (a) => r("today"))
        }, {
          default: M(() => n[3] || (n[3] = [
            se(" Today ")
          ])),
          _: 1
        })
      ]),
      R(t.$slots, "default")
    ]));
  }
}), Kf = /* @__PURE__ */ W({
  __name: "Card",
  props: {
    color: { default: "white" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["gray", "bg-default-50"],
      ["white", "bg-white"]
    ]);
    return (r, t) => (w(), j("div", {
      class: Z([
        "rounded-lg shadow",
        P(e).get(r.color)
      ])
    }, [
      R(r.$slots, "default")
    ], 2));
  }
}), u9 = {}, p9 = { class: "px-4 py-5 sm:p-6" };
function d9(o, e) {
  return w(), j("div", p9, [
    R(o.$slots, "default")
  ]);
}
const _f = /* @__PURE__ */ le(u9, [["render", d9]]), g9 = {}, m9 = {
  class: /* @__PURE__ */ Z([
    "bg-default-50 px-4 py-4 rounded-b-lg",
    "sm:px-6"
  ])
};
function y9(o, e) {
  return w(), j("div", m9, [
    R(o.$slots, "default")
  ]);
}
const f9 = /* @__PURE__ */ le(g9, [["render", y9]]), h9 = {}, F9 = { class: "px-4 py-5 sm:px-6" };
function b9(o, e) {
  return w(), j("div", F9, [
    R(o.$slots, "default")
  ]);
}
const v9 = /* @__PURE__ */ le(h9, [["render", b9]]);
function Lg(o) {
  return o !== null && typeof o == "object" && "constructor" in o && o.constructor === Object;
}
function du(o, e) {
  o === void 0 && (o = {}), e === void 0 && (e = {});
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((t) => r.indexOf(t) < 0).forEach((t) => {
    typeof o[t] > "u" ? o[t] = e[t] : Lg(e[t]) && Lg(o[t]) && Object.keys(e[t]).length > 0 && du(o[t], e[t]);
  });
}
const $f = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function qe() {
  const o = typeof document < "u" ? document : {};
  return du(o, $f), o;
}
const P9 = {
  document: $f,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(o) {
    return typeof setTimeout > "u" ? (o(), null) : setTimeout(o, 0);
  },
  cancelAnimationFrame(o) {
    typeof setTimeout > "u" || clearTimeout(o);
  }
};
function ze() {
  const o = typeof window < "u" ? window : {};
  return du(o, P9), o;
}
function Fr(o) {
  return o === void 0 && (o = ""), o.trim().split(" ").filter((e) => !!e.trim());
}
function B9(o) {
  const e = o;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function Xr(o, e) {
  return e === void 0 && (e = 0), setTimeout(o, e);
}
function xo() {
  return Date.now();
}
function k9(o) {
  const e = ze();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(o, null)), !r && o.currentStyle && (r = o.currentStyle), r || (r = o.style), r;
}
function gc(o, e) {
  e === void 0 && (e = "x");
  const r = ze();
  let t, n, a;
  const s = k9(o);
  return r.WebKitCSSMatrix ? (n = s.transform || s.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((i) => i.replace(",", ".")).join(", ")), a = new r.WebKitCSSMatrix(n === "none" ? "" : n)) : (a = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), t = a.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? n = a.m41 : t.length === 16 ? n = parseFloat(t[12]) : n = parseFloat(t[4])), e === "y" && (r.WebKitCSSMatrix ? n = a.m42 : t.length === 16 ? n = parseFloat(t[13]) : n = parseFloat(t[5])), n || 0;
}
function qt(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function w9(o) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? o instanceof HTMLElement : o && (o.nodeType === 1 || o.nodeType === 11);
}
function Fo() {
  const o = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < arguments.length; r += 1) {
    const t = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (t != null && !w9(t)) {
      const n = Object.keys(Object(t)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, s = n.length; a < s; a += 1) {
        const i = n[a], l = Object.getOwnPropertyDescriptor(t, i);
        l !== void 0 && l.enumerable && (qt(o[i]) && qt(t[i]) ? t[i].__swiper__ ? o[i] = t[i] : Fo(o[i], t[i]) : !qt(o[i]) && qt(t[i]) ? (o[i] = {}, t[i].__swiper__ ? o[i] = t[i] : Fo(o[i], t[i])) : o[i] = t[i]);
      }
    }
  }
  return o;
}
function Ut(o, e, r) {
  o.style.setProperty(e, r);
}
function eh(o) {
  let {
    swiper: e,
    targetPosition: r,
    side: t
  } = o;
  const n = ze(), a = -e.translate;
  let s = null, i;
  const l = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
  const c = r > a ? "next" : "prev", u = (y, g) => c === "next" && y >= g || c === "prev" && y <= g, m = () => {
    i = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = i);
    const y = Math.max(Math.min((i - s) / l, 1), 0), g = 0.5 - Math.cos(y * Math.PI) / 2;
    let p = a + g * (r - a);
    if (u(p, r) && (p = r), e.wrapperEl.scrollTo({
      [t]: p
    }), u(p, r)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [t]: p
        });
      }), n.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = n.requestAnimationFrame(m);
  };
  m();
}
function Qr(o) {
  return o.querySelector(".swiper-slide-transform") || o.shadowRoot && o.shadowRoot.querySelector(".swiper-slide-transform") || o;
}
function Ye(o, e) {
  e === void 0 && (e = "");
  const r = ze(), t = [...o.children];
  return r.HTMLSlotElement && o instanceof HTMLSlotElement && t.push(...o.assignedElements()), e ? t.filter((n) => n.matches(e)) : t;
}
function D9(o, e) {
  const r = [e];
  for (; r.length > 0; ) {
    const t = r.shift();
    if (o === t)
      return !0;
    r.push(...t.children, ...t.shadowRoot ? t.shadowRoot.children : [], ...t.assignedElements ? t.assignedElements() : []);
  }
}
function S9(o, e) {
  const r = ze();
  let t = e.contains(o);
  return !t && r.HTMLSlotElement && e instanceof HTMLSlotElement && (t = [...e.assignedElements()].includes(o), t || (t = D9(o, e))), t;
}
function Bs(o) {
  try {
    console.warn(o);
    return;
  } catch {
  }
}
function Bo(o, e) {
  e === void 0 && (e = []);
  const r = document.createElement(o);
  return r.classList.add(...Array.isArray(e) ? e : Fr(e)), r;
}
function ks(o) {
  const e = ze(), r = qe(), t = o.getBoundingClientRect(), n = r.body, a = o.clientTop || n.clientTop || 0, s = o.clientLeft || n.clientLeft || 0, i = o === e ? e.scrollY : o.scrollTop, l = o === e ? e.scrollX : o.scrollLeft;
  return {
    top: t.top + i - a,
    left: t.left + l - s
  };
}
function E9(o, e) {
  const r = [];
  for (; o.previousElementSibling; ) {
    const t = o.previousElementSibling;
    e ? t.matches(e) && r.push(t) : r.push(t), o = t;
  }
  return r;
}
function x9(o, e) {
  const r = [];
  for (; o.nextElementSibling; ) {
    const t = o.nextElementSibling;
    e ? t.matches(e) && r.push(t) : r.push(t), o = t;
  }
  return r;
}
function Pr(o, e) {
  return ze().getComputedStyle(o, null).getPropertyValue(e);
}
function $n(o) {
  let e = o, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function Lr(o, e) {
  const r = [];
  let t = o.parentElement;
  for (; t; )
    e ? t.matches(e) && r.push(t) : r.push(t), t = t.parentElement;
  return r;
}
function en(o, e) {
  function r(t) {
    t.target === o && (e.call(o, t), o.removeEventListener("transitionend", r));
  }
  e && o.addEventListener("transitionend", r);
}
function mc(o, e, r) {
  const t = ze();
  return o[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(t.getComputedStyle(o, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(t.getComputedStyle(o, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function he(o) {
  return (Array.isArray(o) ? o : [o]).filter((e) => !!e);
}
function qs(o) {
  return (e) => Math.abs(e) > 0 && o.browser && o.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
let cl;
function A9() {
  const o = ze(), e = qe();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in o || o.DocumentTouch && e instanceof o.DocumentTouch)
  };
}
function oh() {
  return cl || (cl = A9()), cl;
}
let ul;
function C9(o) {
  let {
    userAgent: e
  } = o === void 0 ? {} : o;
  const r = oh(), t = ze(), n = t.navigator.platform, a = e || t.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, i = t.screen.width, l = t.screen.height, c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = a.match(/(iPad).*OS\s([\d_]+)/);
  const m = a.match(/(iPod)(.*OS\s([\d_]+))?/), y = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = n === "Win32";
  let p = n === "MacIntel";
  const d = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && r.touch && d.indexOf(`${i}x${l}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), c && !g && (s.os = "android", s.android = !0), (u || y || m) && (s.os = "ios", s.ios = !0), s;
}
function rh(o) {
  return o === void 0 && (o = {}), ul || (ul = C9(o)), ul;
}
let pl;
function O9() {
  const o = ze(), e = rh();
  let r = !1;
  function t() {
    const i = o.navigator.userAgent.toLowerCase();
    return i.indexOf("safari") >= 0 && i.indexOf("chrome") < 0 && i.indexOf("android") < 0;
  }
  if (t()) {
    const i = String(o.navigator.userAgent);
    if (i.includes("Version/")) {
      const [l, c] = i.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      r = l < 16 || l === 16 && c < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(o.navigator.userAgent), a = t(), s = a || n && e.ios;
  return {
    isSafari: r || a,
    needPerspectiveFix: r,
    need3dFix: s,
    isWebView: n
  };
}
function th() {
  return pl || (pl = O9()), pl;
}
function T9(o) {
  let {
    swiper: e,
    on: r,
    emit: t
  } = o;
  const n = ze();
  let a = null, s = null;
  const i = () => {
    !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"));
  }, l = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((m) => {
      s = n.requestAnimationFrame(() => {
        const {
          width: y,
          height: g
        } = e;
        let p = y, d = g;
        m.forEach((h) => {
          let {
            contentBoxSize: f,
            contentRect: F,
            target: b
          } = h;
          b && b !== e.el || (p = F ? F.width : (f[0] || f).inlineSize, d = F ? F.height : (f[0] || f).blockSize);
        }), (p !== y || d !== g) && i();
      });
    }), a.observe(e.el));
  }, c = () => {
    s && n.cancelAnimationFrame(s), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || t("orientationchange");
  };
  r("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", i), n.addEventListener("orientationchange", u);
  }), r("destroy", () => {
    c(), n.removeEventListener("resize", i), n.removeEventListener("orientationchange", u);
  });
}
function j9(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = [], s = ze(), i = function(u, m) {
    m === void 0 && (m = {});
    const y = s.MutationObserver || s.WebkitMutationObserver, g = new y((p) => {
      if (e.__preventObserver__) return;
      if (p.length === 1) {
        n("observerUpdate", p[0]);
        return;
      }
      const d = function() {
        n("observerUpdate", p[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(d) : s.setTimeout(d, 0);
    });
    g.observe(u, {
      attributes: typeof m.attributes > "u" ? !0 : m.attributes,
      childList: e.isElement || (typeof m.childList > "u" ? !0 : m).childList,
      characterData: typeof m.characterData > "u" ? !0 : m.characterData
    }), a.push(g);
  }, l = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = Lr(e.hostEl);
        for (let m = 0; m < u.length; m += 1)
          i(u[m]);
      }
      i(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), i(e.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    a.forEach((u) => {
      u.disconnect();
    }), a.splice(0, a.length);
  };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", l), t("destroy", c);
}
var M9 = {
  on(o, e, r) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    const n = r ? "unshift" : "push";
    return o.split(" ").forEach((a) => {
      t.eventsListeners[a] || (t.eventsListeners[a] = []), t.eventsListeners[a][n](e);
    }), t;
  },
  once(o, e, r) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    function n() {
      t.off(o, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
        s[i] = arguments[i];
      e.apply(t, s);
    }
    return n.__emitterProxy = e, t.on(o, n, r);
  },
  onAny(o, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof o != "function") return r;
    const t = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(o) < 0 && r.eventsAnyListeners[t](o), r;
  },
  offAny(o) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const r = e.eventsAnyListeners.indexOf(o);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(o, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || o.split(" ").forEach((t) => {
      typeof e > "u" ? r.eventsListeners[t] = [] : r.eventsListeners[t] && r.eventsListeners[t].forEach((n, a) => {
        (n === e || n.__emitterProxy && n.__emitterProxy === e) && r.eventsListeners[t].splice(a, 1);
      });
    }), r;
  },
  emit() {
    const o = this;
    if (!o.eventsListeners || o.destroyed || !o.eventsListeners) return o;
    let e, r, t;
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], r = a.slice(1, a.length), t = o) : (e = a[0].events, r = a[0].data, t = a[0].context || o), r.unshift(t), (Array.isArray(e) ? e : e.split(" ")).forEach((l) => {
      o.eventsAnyListeners && o.eventsAnyListeners.length && o.eventsAnyListeners.forEach((c) => {
        c.apply(t, [l, ...r]);
      }), o.eventsListeners && o.eventsListeners[l] && o.eventsListeners[l].forEach((c) => {
        c.apply(t, r);
      });
    }), o;
  }
};
function z9() {
  const o = this;
  let e, r;
  const t = o.el;
  typeof o.params.width < "u" && o.params.width !== null ? e = o.params.width : e = t.clientWidth, typeof o.params.height < "u" && o.params.height !== null ? r = o.params.height : r = t.clientHeight, !(e === 0 && o.isHorizontal() || r === 0 && o.isVertical()) && (e = e - parseInt(Pr(t, "padding-left") || 0, 10) - parseInt(Pr(t, "padding-right") || 0, 10), r = r - parseInt(Pr(t, "padding-top") || 0, 10) - parseInt(Pr(t, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(o, {
    width: e,
    height: r,
    size: o.isHorizontal() ? e : r
  }));
}
function N9() {
  const o = this;
  function e(x, C) {
    return parseFloat(x.getPropertyValue(o.getDirectionLabel(C)) || 0);
  }
  const r = o.params, {
    wrapperEl: t,
    slidesEl: n,
    size: a,
    rtlTranslate: s,
    wrongRTL: i
  } = o, l = o.virtual && r.virtual.enabled, c = l ? o.virtual.slides.length : o.slides.length, u = Ye(n, `.${o.params.slideClass}, swiper-slide`), m = l ? o.virtual.slides.length : u.length;
  let y = [];
  const g = [], p = [];
  let d = r.slidesOffsetBefore;
  typeof d == "function" && (d = r.slidesOffsetBefore.call(o));
  let h = r.slidesOffsetAfter;
  typeof h == "function" && (h = r.slidesOffsetAfter.call(o));
  const f = o.snapGrid.length, F = o.slidesGrid.length;
  let b = r.spaceBetween, v = -d, k = 0, E = 0;
  if (typeof a > "u")
    return;
  typeof b == "string" && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * a : typeof b == "string" && (b = parseFloat(b)), o.virtualSize = -b, u.forEach((x) => {
    s ? x.style.marginLeft = "" : x.style.marginRight = "", x.style.marginBottom = "", x.style.marginTop = "";
  }), r.centeredSlides && r.cssMode && (Ut(t, "--swiper-centered-offset-before", ""), Ut(t, "--swiper-centered-offset-after", ""));
  const S = r.grid && r.grid.rows > 1 && o.grid;
  S ? o.grid.initSlides(u) : o.grid && o.grid.unsetSlides();
  let B;
  const D = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((x) => typeof r.breakpoints[x].slidesPerView < "u").length > 0;
  for (let x = 0; x < m; x += 1) {
    B = 0;
    let C;
    if (u[x] && (C = u[x]), S && o.grid.updateSlide(x, C, u), !(u[x] && Pr(C, "display") === "none")) {
      if (r.slidesPerView === "auto") {
        D && (u[x].style[o.getDirectionLabel("width")] = "");
        const O = getComputedStyle(C), T = C.style.transform, I = C.style.webkitTransform;
        if (T && (C.style.transform = "none"), I && (C.style.webkitTransform = "none"), r.roundLengths)
          B = o.isHorizontal() ? mc(C, "width") : mc(C, "height");
        else {
          const G = e(O, "width"), U = e(O, "padding-left"), N = e(O, "padding-right"), z = e(O, "margin-left"), V = e(O, "margin-right"), Y = O.getPropertyValue("box-sizing");
          if (Y && Y === "border-box")
            B = G + z + V;
          else {
            const {
              clientWidth: K,
              offsetWidth: $
            } = C;
            B = G + U + N + z + V + ($ - K);
          }
        }
        T && (C.style.transform = T), I && (C.style.webkitTransform = I), r.roundLengths && (B = Math.floor(B));
      } else
        B = (a - (r.slidesPerView - 1) * b) / r.slidesPerView, r.roundLengths && (B = Math.floor(B)), u[x] && (u[x].style[o.getDirectionLabel("width")] = `${B}px`);
      u[x] && (u[x].swiperSlideSize = B), p.push(B), r.centeredSlides ? (v = v + B / 2 + k / 2 + b, k === 0 && x !== 0 && (v = v - a / 2 - b), x === 0 && (v = v - a / 2 - b), Math.abs(v) < 1 / 1e3 && (v = 0), r.roundLengths && (v = Math.floor(v)), E % r.slidesPerGroup === 0 && y.push(v), g.push(v)) : (r.roundLengths && (v = Math.floor(v)), (E - Math.min(o.params.slidesPerGroupSkip, E)) % o.params.slidesPerGroup === 0 && y.push(v), g.push(v), v = v + B + b), o.virtualSize += B + b, k = B, E += 1;
    }
  }
  if (o.virtualSize = Math.max(o.virtualSize, a) + h, s && i && (r.effect === "slide" || r.effect === "coverflow") && (t.style.width = `${o.virtualSize + b}px`), r.setWrapperSize && (t.style[o.getDirectionLabel("width")] = `${o.virtualSize + b}px`), S && o.grid.updateWrapperSize(B, y), !r.centeredSlides) {
    const x = [];
    for (let C = 0; C < y.length; C += 1) {
      let O = y[C];
      r.roundLengths && (O = Math.floor(O)), y[C] <= o.virtualSize - a && x.push(O);
    }
    y = x, Math.floor(o.virtualSize - a) - Math.floor(y[y.length - 1]) > 1 && y.push(o.virtualSize - a);
  }
  if (l && r.loop) {
    const x = p[0] + b;
    if (r.slidesPerGroup > 1) {
      const C = Math.ceil((o.virtual.slidesBefore + o.virtual.slidesAfter) / r.slidesPerGroup), O = x * r.slidesPerGroup;
      for (let T = 0; T < C; T += 1)
        y.push(y[y.length - 1] + O);
    }
    for (let C = 0; C < o.virtual.slidesBefore + o.virtual.slidesAfter; C += 1)
      r.slidesPerGroup === 1 && y.push(y[y.length - 1] + x), g.push(g[g.length - 1] + x), o.virtualSize += x;
  }
  if (y.length === 0 && (y = [0]), b !== 0) {
    const x = o.isHorizontal() && s ? "marginLeft" : o.getDirectionLabel("marginRight");
    u.filter((C, O) => !r.cssMode || r.loop ? !0 : O !== u.length - 1).forEach((C) => {
      C.style[x] = `${b}px`;
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let x = 0;
    p.forEach((O) => {
      x += O + (b || 0);
    }), x -= b;
    const C = x > a ? x - a : 0;
    y = y.map((O) => O <= 0 ? -d : O > C ? C + h : O);
  }
  if (r.centerInsufficientSlides) {
    let x = 0;
    p.forEach((O) => {
      x += O + (b || 0);
    }), x -= b;
    const C = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
    if (x + C < a) {
      const O = (a - x - C) / 2;
      y.forEach((T, I) => {
        y[I] = T - O;
      }), g.forEach((T, I) => {
        g[I] = T + O;
      });
    }
  }
  if (Object.assign(o, {
    slides: u,
    snapGrid: y,
    slidesGrid: g,
    slidesSizesGrid: p
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    Ut(t, "--swiper-centered-offset-before", `${-y[0]}px`), Ut(t, "--swiper-centered-offset-after", `${o.size / 2 - p[p.length - 1] / 2}px`);
    const x = -o.snapGrid[0], C = -o.slidesGrid[0];
    o.snapGrid = o.snapGrid.map((O) => O + x), o.slidesGrid = o.slidesGrid.map((O) => O + C);
  }
  if (m !== c && o.emit("slidesLengthChange"), y.length !== f && (o.params.watchOverflow && o.checkOverflow(), o.emit("snapGridLengthChange")), g.length !== F && o.emit("slidesGridLengthChange"), r.watchSlidesProgress && o.updateSlidesOffset(), o.emit("slidesUpdated"), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const x = `${r.containerModifierClass}backface-hidden`, C = o.el.classList.contains(x);
    m <= r.maxBackfaceHiddenSlides ? C || o.el.classList.add(x) : C && o.el.classList.remove(x);
  }
}
function I9(o) {
  const e = this, r = [], t = e.virtual && e.params.virtual.enabled;
  let n = 0, a;
  typeof o == "number" ? e.setTransition(o) : o === !0 && e.setTransition(e.params.speed);
  const s = (i) => t ? e.slides[e.getSlideIndexByData(i)] : e.slides[i];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((i) => {
        r.push(i);
      });
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const i = e.activeIndex + a;
        if (i > e.slides.length && !t) break;
        r.push(s(i));
      }
  else
    r.push(s(e.activeIndex));
  for (a = 0; a < r.length; a += 1)
    if (typeof r[a] < "u") {
      const i = r[a].offsetHeight;
      n = i > n ? i : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function R9() {
  const o = this, e = o.slides, r = o.isElement ? o.isHorizontal() ? o.wrapperEl.offsetLeft : o.wrapperEl.offsetTop : 0;
  for (let t = 0; t < e.length; t += 1)
    e[t].swiperSlideOffset = (o.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop) - r - o.cssOverflowAdjustment();
}
const Hg = (o, e, r) => {
  e && !o.classList.contains(r) ? o.classList.add(r) : !e && o.classList.contains(r) && o.classList.remove(r);
};
function L9(o) {
  o === void 0 && (o = this && this.translate || 0);
  const e = this, r = e.params, {
    slides: t,
    rtlTranslate: n,
    snapGrid: a
  } = e;
  if (t.length === 0) return;
  typeof t[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let s = -o;
  n && (s = o), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let i = r.spaceBetween;
  typeof i == "string" && i.indexOf("%") >= 0 ? i = parseFloat(i.replace("%", "")) / 100 * e.size : typeof i == "string" && (i = parseFloat(i));
  for (let l = 0; l < t.length; l += 1) {
    const c = t[l];
    let u = c.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (u -= t[0].swiperSlideOffset);
    const m = (s + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + i), y = (s - a[0] + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + i), g = -(s - u), p = g + e.slidesSizesGrid[l], d = g >= 0 && g <= e.size - e.slidesSizesGrid[l], h = g >= 0 && g < e.size - 1 || p > 1 && p <= e.size || g <= 0 && p >= e.size;
    h && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(l)), Hg(c, h, r.slideVisibleClass), Hg(c, d, r.slideFullyVisibleClass), c.progress = n ? -m : m, c.originalProgress = n ? -y : y;
  }
}
function H9(o) {
  const e = this;
  if (typeof o > "u") {
    const u = e.rtlTranslate ? -1 : 1;
    o = e && e.translate && e.translate * u || 0;
  }
  const r = e.params, t = e.maxTranslate() - e.minTranslate();
  let {
    progress: n,
    isBeginning: a,
    isEnd: s,
    progressLoop: i
  } = e;
  const l = a, c = s;
  if (t === 0)
    n = 0, a = !0, s = !0;
  else {
    n = (o - e.minTranslate()) / t;
    const u = Math.abs(o - e.minTranslate()) < 1, m = Math.abs(o - e.maxTranslate()) < 1;
    a = u || n <= 0, s = m || n >= 1, u && (n = 0), m && (n = 1);
  }
  if (r.loop) {
    const u = e.getSlideIndexByData(0), m = e.getSlideIndexByData(e.slides.length - 1), y = e.slidesGrid[u], g = e.slidesGrid[m], p = e.slidesGrid[e.slidesGrid.length - 1], d = Math.abs(o);
    d >= y ? i = (d - y) / p : i = (d + p - g) / p, i > 1 && (i -= 1);
  }
  Object.assign(e, {
    progress: n,
    progressLoop: i,
    isBeginning: a,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(o), a && !l && e.emit("reachBeginning toEdge"), s && !c && e.emit("reachEnd toEdge"), (l && !a || c && !s) && e.emit("fromEdge"), e.emit("progress", n);
}
const dl = (o, e, r) => {
  e && !o.classList.contains(r) ? o.classList.add(r) : !e && o.classList.contains(r) && o.classList.remove(r);
};
function W9() {
  const o = this, {
    slides: e,
    params: r,
    slidesEl: t,
    activeIndex: n
  } = o, a = o.virtual && r.virtual.enabled, s = o.grid && r.grid && r.grid.rows > 1, i = (m) => Ye(t, `.${r.slideClass}${m}, swiper-slide${m}`)[0];
  let l, c, u;
  if (a)
    if (r.loop) {
      let m = n - o.virtual.slidesBefore;
      m < 0 && (m = o.virtual.slides.length + m), m >= o.virtual.slides.length && (m -= o.virtual.slides.length), l = i(`[data-swiper-slide-index="${m}"]`);
    } else
      l = i(`[data-swiper-slide-index="${n}"]`);
  else
    s ? (l = e.find((m) => m.column === n), u = e.find((m) => m.column === n + 1), c = e.find((m) => m.column === n - 1)) : l = e[n];
  l && (s || (u = x9(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !u && (u = e[0]), c = E9(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !c === 0 && (c = e[e.length - 1]))), e.forEach((m) => {
    dl(m, m === l, r.slideActiveClass), dl(m, m === u, r.slideNextClass), dl(m, m === c, r.slidePrevClass);
  }), o.emitSlidesClasses();
}
const is = (o, e) => {
  if (!o || o.destroyed || !o.params) return;
  const r = () => o.isElement ? "swiper-slide" : `.${o.params.slideClass}`, t = e.closest(r());
  if (t) {
    let n = t.querySelector(`.${o.params.lazyPreloaderClass}`);
    !n && o.isElement && (t.shadowRoot ? n = t.shadowRoot.querySelector(`.${o.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      t.shadowRoot && (n = t.shadowRoot.querySelector(`.${o.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, gl = (o, e) => {
  if (!o.slides[e]) return;
  const r = o.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, yc = (o) => {
  if (!o || o.destroyed || !o.params) return;
  let e = o.params.lazyPreloadPrevNext;
  const r = o.slides.length;
  if (!r || !e || e < 0) return;
  e = Math.min(e, r);
  const t = o.params.slidesPerView === "auto" ? o.slidesPerViewDynamic() : Math.ceil(o.params.slidesPerView), n = o.activeIndex;
  if (o.params.grid && o.params.grid.rows > 1) {
    const s = n, i = [s - e];
    i.push(...Array.from({
      length: e
    }).map((l, c) => s + t + c)), o.slides.forEach((l, c) => {
      i.includes(l.column) && gl(o, c);
    });
    return;
  }
  const a = n + t - 1;
  if (o.params.rewind || o.params.loop)
    for (let s = n - e; s <= a + e; s += 1) {
      const i = (s % r + r) % r;
      (i < n || i > a) && gl(o, i);
    }
  else
    for (let s = Math.max(n - e, 0); s <= Math.min(a + e, r - 1); s += 1)
      s !== n && (s > a || s < n) && gl(o, s);
};
function V9(o) {
  const {
    slidesGrid: e,
    params: r
  } = o, t = o.rtlTranslate ? o.translate : -o.translate;
  let n;
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < "u" ? t >= e[a] && t < e[a + 1] - (e[a + 1] - e[a]) / 2 ? n = a : t >= e[a] && t < e[a + 1] && (n = a + 1) : t >= e[a] && (n = a);
  return r.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function G9(o) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: t,
    params: n,
    activeIndex: a,
    realIndex: s,
    snapIndex: i
  } = e;
  let l = o, c;
  const u = (g) => {
    let p = g - e.virtual.slidesBefore;
    return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = V9(e)), t.indexOf(r) >= 0)
    c = t.indexOf(r);
  else {
    const g = Math.min(n.slidesPerGroupSkip, l);
    c = g + Math.floor((l - g) / n.slidesPerGroup);
  }
  if (c >= t.length && (c = t.length - 1), l === a && !e.params.loop) {
    c !== i && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  if (l === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = u(l);
    return;
  }
  const m = e.grid && n.grid && n.grid.rows > 1;
  let y;
  if (e.virtual && n.virtual.enabled && n.loop)
    y = u(l);
  else if (m) {
    const g = e.slides.find((d) => d.column === l);
    let p = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(e.slides.indexOf(g), 0)), y = Math.floor(p / n.grid.rows);
  } else if (e.slides[l]) {
    const g = e.slides[l].getAttribute("data-swiper-slide-index");
    g ? y = parseInt(g, 10) : y = l;
  } else
    y = l;
  Object.assign(e, {
    previousSnapIndex: i,
    snapIndex: c,
    previousRealIndex: s,
    realIndex: y,
    previousIndex: a,
    activeIndex: l
  }), e.initialized && yc(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (s !== y && e.emit("realIndexChange"), e.emit("slideChange"));
}
function Z9(o, e) {
  const r = this, t = r.params;
  let n = o.closest(`.${t.slideClass}, swiper-slide`);
  !n && r.isElement && e && e.length > 1 && e.includes(o) && [...e.slice(e.indexOf(o) + 1, e.length)].forEach((i) => {
    !n && i.matches && i.matches(`.${t.slideClass}, swiper-slide`) && (n = i);
  });
  let a = !1, s;
  if (n) {
    for (let i = 0; i < r.slides.length; i += 1)
      if (r.slides[i] === n) {
        a = !0, s = i;
        break;
      }
  }
  if (n && a)
    r.clickedSlide = n, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = s;
  else {
    r.clickedSlide = void 0, r.clickedIndex = void 0;
    return;
  }
  t.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
}
var X9 = {
  updateSize: z9,
  updateSlides: N9,
  updateAutoHeight: I9,
  updateSlidesOffset: R9,
  updateSlidesProgress: L9,
  updateProgress: H9,
  updateSlidesClasses: W9,
  updateActiveIndex: G9,
  updateClickedSlide: Z9
};
function q9(o) {
  o === void 0 && (o = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: r,
    rtlTranslate: t,
    translate: n,
    wrapperEl: a
  } = e;
  if (r.virtualTranslate)
    return t ? -n : n;
  if (r.cssMode)
    return n;
  let s = gc(a, o);
  return s += e.cssOverflowAdjustment(), t && (s = -s), s || 0;
}
function U9(o, e) {
  const r = this, {
    rtlTranslate: t,
    params: n,
    wrapperEl: a,
    progress: s
  } = r;
  let i = 0, l = 0;
  const c = 0;
  r.isHorizontal() ? i = t ? -o : o : l = o, n.roundLengths && (i = Math.floor(i), l = Math.floor(l)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? i : l, n.cssMode ? a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -i : -l : n.virtualTranslate || (r.isHorizontal() ? i -= r.cssOverflowAdjustment() : l -= r.cssOverflowAdjustment(), a.style.transform = `translate3d(${i}px, ${l}px, ${c}px)`);
  let u;
  const m = r.maxTranslate() - r.minTranslate();
  m === 0 ? u = 0 : u = (o - r.minTranslate()) / m, u !== s && r.updateProgress(o), r.emit("setTranslate", r.translate, e);
}
function Y9() {
  return -this.snapGrid[0];
}
function J9() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Q9(o, e, r, t, n) {
  o === void 0 && (o = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), t === void 0 && (t = !0);
  const a = this, {
    params: s,
    wrapperEl: i
  } = a;
  if (a.animating && s.preventInteractionOnTransition)
    return !1;
  const l = a.minTranslate(), c = a.maxTranslate();
  let u;
  if (t && o > l ? u = l : t && o < c ? u = c : u = o, a.updateProgress(u), s.cssMode) {
    const m = a.isHorizontal();
    if (e === 0)
      i[m ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!a.support.smoothScroll)
        return eh({
          swiper: a,
          targetPosition: -u,
          side: m ? "left" : "top"
        }), !0;
      i.scrollTo({
        [m ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (a.setTransition(0), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, n), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, n), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(y) {
    !a || a.destroyed || y.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, r && a.emit("transitionEnd"));
  }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
var K9 = {
  getTranslate: q9,
  setTranslate: U9,
  minTranslate: Y9,
  maxTranslate: J9,
  translateTo: Q9
};
function _9(o, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${o}ms`, r.wrapperEl.style.transitionDelay = o === 0 ? "0ms" : ""), r.emit("setTransition", o, e);
}
function nh(o) {
  let {
    swiper: e,
    runCallbacks: r,
    direction: t,
    step: n
  } = o;
  const {
    activeIndex: a,
    previousIndex: s
  } = e;
  let i = t;
  if (i || (a > s ? i = "next" : a < s ? i = "prev" : i = "reset"), e.emit(`transition${n}`), r && a !== s) {
    if (i === "reset") {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    e.emit(`slideChangeTransition${n}`), i === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
  }
}
function $9(o, e) {
  o === void 0 && (o = !0);
  const r = this, {
    params: t
  } = r;
  t.cssMode || (t.autoHeight && r.updateAutoHeight(), nh({
    swiper: r,
    runCallbacks: o,
    direction: e,
    step: "Start"
  }));
}
function e7(o, e) {
  o === void 0 && (o = !0);
  const r = this, {
    params: t
  } = r;
  r.animating = !1, !t.cssMode && (r.setTransition(0), nh({
    swiper: r,
    runCallbacks: o,
    direction: e,
    step: "End"
  }));
}
var o7 = {
  setTransition: _9,
  transitionStart: $9,
  transitionEnd: e7
};
function r7(o, e, r, t, n) {
  o === void 0 && (o = 0), r === void 0 && (r = !0), typeof o == "string" && (o = parseInt(o, 10));
  const a = this;
  let s = o;
  s < 0 && (s = 0);
  const {
    params: i,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: u,
    activeIndex: m,
    rtlTranslate: y,
    wrapperEl: g,
    enabled: p
  } = a;
  if (!p && !t && !n || a.destroyed || a.animating && i.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = a.params.speed);
  const d = Math.min(a.params.slidesPerGroupSkip, s);
  let h = d + Math.floor((s - d) / a.params.slidesPerGroup);
  h >= l.length && (h = l.length - 1);
  const f = -l[h];
  if (i.normalizeSlideIndex)
    for (let S = 0; S < c.length; S += 1) {
      const B = -Math.floor(f * 100), D = Math.floor(c[S] * 100), x = Math.floor(c[S + 1] * 100);
      typeof c[S + 1] < "u" ? B >= D && B < x - (x - D) / 2 ? s = S : B >= D && B < x && (s = S + 1) : B >= D && (s = S);
    }
  if (a.initialized && s !== m && (!a.allowSlideNext && (y ? f > a.translate && f > a.minTranslate() : f < a.translate && f < a.minTranslate()) || !a.allowSlidePrev && f > a.translate && f > a.maxTranslate() && (m || 0) !== s))
    return !1;
  s !== (u || 0) && r && a.emit("beforeSlideChangeStart"), a.updateProgress(f);
  let F;
  s > m ? F = "next" : s < m ? F = "prev" : F = "reset";
  const b = a.virtual && a.params.virtual.enabled;
  if (!(b && n) && (y && -f === a.translate || !y && f === a.translate))
    return a.updateActiveIndex(s), i.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), i.effect !== "slide" && a.setTranslate(f), F !== "reset" && (a.transitionStart(r, F), a.transitionEnd(r, F)), !1;
  if (i.cssMode) {
    const S = a.isHorizontal(), B = y ? f : -f;
    if (e === 0)
      b && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), b && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[S ? "scrollLeft" : "scrollTop"] = B;
      })) : g[S ? "scrollLeft" : "scrollTop"] = B, b && requestAnimationFrame(() => {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });
    else {
      if (!a.support.smoothScroll)
        return eh({
          swiper: a,
          targetPosition: B,
          side: S ? "left" : "top"
        }), !0;
      g.scrollTo({
        [S ? "left" : "top"]: B,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const E = th().isSafari;
  return b && !n && E && a.isElement && a.virtual.update(!1, !1, s), a.setTransition(e), a.setTranslate(f), a.updateActiveIndex(s), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, t), a.transitionStart(r, F), e === 0 ? a.transitionEnd(r, F) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(B) {
    !a || a.destroyed || B.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(r, F));
  }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function t7(o, e, r, t) {
  o === void 0 && (o = 0), r === void 0 && (r = !0), typeof o == "string" && (o = parseInt(o, 10));
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  const a = n.grid && n.params.grid && n.params.grid.rows > 1;
  let s = o;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      s = s + n.virtual.slidesBefore;
    else {
      let i;
      if (a) {
        const y = s * n.params.grid.rows;
        i = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === y).column;
      } else
        i = n.getSlideIndexByData(s);
      const l = a ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: c
      } = n.params;
      let u = n.params.slidesPerView;
      u === "auto" ? u = n.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(n.params.slidesPerView, 10)), c && u % 2 === 0 && (u = u + 1));
      let m = l - i < u;
      if (c && (m = m || i < Math.ceil(u / 2)), t && c && n.params.slidesPerView !== "auto" && !a && (m = !1), m) {
        const y = c ? i < n.activeIndex ? "prev" : "next" : i - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: y,
          slideTo: !0,
          activeSlideIndex: y === "next" ? i + 1 : i - l + 1,
          slideRealIndex: y === "next" ? n.realIndex : void 0
        });
      }
      if (a) {
        const y = s * n.params.grid.rows;
        s = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === y).column;
      } else
        s = n.getSlideIndexByData(s);
    }
  return requestAnimationFrame(() => {
    n.slideTo(s, e, r, t);
  }), n;
}
function n7(o, e, r) {
  e === void 0 && (e = !0);
  const t = this, {
    enabled: n,
    params: a,
    animating: s
  } = t;
  if (!n || t.destroyed) return t;
  typeof o > "u" && (o = t.params.speed);
  let i = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (i = Math.max(t.slidesPerViewDynamic("current", !0), 1));
  const l = t.activeIndex < a.slidesPerGroupSkip ? 1 : i, c = t.virtual && a.virtual.enabled;
  if (a.loop) {
    if (s && !c && a.loopPreventsSliding) return !1;
    if (t.loopFix({
      direction: "next"
    }), t._clientLeft = t.wrapperEl.clientLeft, t.activeIndex === t.slides.length - 1 && a.cssMode)
      return requestAnimationFrame(() => {
        t.slideTo(t.activeIndex + l, o, e, r);
      }), !0;
  }
  return a.rewind && t.isEnd ? t.slideTo(0, o, e, r) : t.slideTo(t.activeIndex + l, o, e, r);
}
function a7(o, e, r) {
  e === void 0 && (e = !0);
  const t = this, {
    params: n,
    snapGrid: a,
    slidesGrid: s,
    rtlTranslate: i,
    enabled: l,
    animating: c
  } = t;
  if (!l || t.destroyed) return t;
  typeof o > "u" && (o = t.params.speed);
  const u = t.virtual && n.virtual.enabled;
  if (n.loop) {
    if (c && !u && n.loopPreventsSliding) return !1;
    t.loopFix({
      direction: "prev"
    }), t._clientLeft = t.wrapperEl.clientLeft;
  }
  const m = i ? t.translate : -t.translate;
  function y(F) {
    return F < 0 ? -Math.floor(Math.abs(F)) : Math.floor(F);
  }
  const g = y(m), p = a.map((F) => y(F)), d = n.freeMode && n.freeMode.enabled;
  let h = a[p.indexOf(g) - 1];
  if (typeof h > "u" && (n.cssMode || d)) {
    let F;
    a.forEach((b, v) => {
      g >= b && (F = v);
    }), typeof F < "u" && (h = d ? a[F] : a[F > 0 ? F - 1 : F]);
  }
  let f = 0;
  if (typeof h < "u" && (f = s.indexOf(h), f < 0 && (f = t.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (f = f - t.slidesPerViewDynamic("previous", !0) + 1, f = Math.max(f, 0))), n.rewind && t.isBeginning) {
    const F = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1;
    return t.slideTo(F, o, e, r);
  } else if (n.loop && t.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      t.slideTo(f, o, e, r);
    }), !0;
  return t.slideTo(f, o, e, r);
}
function s7(o, e, r) {
  e === void 0 && (e = !0);
  const t = this;
  if (!t.destroyed)
    return typeof o > "u" && (o = t.params.speed), t.slideTo(t.activeIndex, o, e, r);
}
function i7(o, e, r, t) {
  e === void 0 && (e = !0), t === void 0 && (t = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof o > "u" && (o = n.params.speed);
  let a = n.activeIndex;
  const s = Math.min(n.params.slidesPerGroupSkip, a), i = s + Math.floor((a - s) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[i]) {
    const c = n.snapGrid[i], u = n.snapGrid[i + 1];
    l - c > (u - c) * t && (a += n.params.slidesPerGroup);
  } else {
    const c = n.snapGrid[i - 1], u = n.snapGrid[i];
    l - c <= (u - c) * t && (a -= n.params.slidesPerGroup);
  }
  return a = Math.max(a, 0), a = Math.min(a, n.slidesGrid.length - 1), n.slideTo(a, o, e, r);
}
function l7() {
  const o = this;
  if (o.destroyed) return;
  const {
    params: e,
    slidesEl: r
  } = o, t = e.slidesPerView === "auto" ? o.slidesPerViewDynamic() : e.slidesPerView;
  let n = o.clickedIndex, a;
  const s = o.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (o.animating) return;
    a = parseInt(o.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? n < o.loopedSlides - t / 2 || n > o.slides.length - o.loopedSlides + t / 2 ? (o.loopFix(), n = o.getSlideIndex(Ye(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), Xr(() => {
      o.slideTo(n);
    })) : o.slideTo(n) : n > o.slides.length - t ? (o.loopFix(), n = o.getSlideIndex(Ye(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), Xr(() => {
      o.slideTo(n);
    })) : o.slideTo(n);
  } else
    o.slideTo(n);
}
var c7 = {
  slideTo: r7,
  slideToLoop: t7,
  slideNext: n7,
  slidePrev: a7,
  slideReset: s7,
  slideToClosest: i7,
  slideToClickedSlide: l7
};
function u7(o) {
  const e = this, {
    params: r,
    slidesEl: t
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled) return;
  const n = () => {
    Ye(t, `.${r.slideClass}, swiper-slide`).forEach((m, y) => {
      m.setAttribute("data-swiper-slide-index", y);
    });
  }, a = e.grid && r.grid && r.grid.rows > 1, s = r.slidesPerGroup * (a ? r.grid.rows : 1), i = e.slides.length % s !== 0, l = a && e.slides.length % r.grid.rows !== 0, c = (u) => {
    for (let m = 0; m < u; m += 1) {
      const y = e.isElement ? Bo("swiper-slide", [r.slideBlankClass]) : Bo("div", [r.slideClass, r.slideBlankClass]);
      e.slidesEl.append(y);
    }
  };
  if (i) {
    if (r.loopAddBlankSlides) {
      const u = s - e.slides.length % s;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      Bs("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else if (l) {
    if (r.loopAddBlankSlides) {
      const u = r.grid.rows - e.slides.length % r.grid.rows;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      Bs("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else
    n();
  e.loopFix({
    slideRealIndex: o,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function p7(o) {
  let {
    slideRealIndex: e,
    slideTo: r = !0,
    direction: t,
    setTranslate: n,
    activeSlideIndex: a,
    byController: s,
    byMousewheel: i
  } = o === void 0 ? {} : o;
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: c,
    allowSlidePrev: u,
    allowSlideNext: m,
    slidesEl: y,
    params: g
  } = l, {
    centeredSlides: p
  } = g;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && g.virtual.enabled) {
    r && (!g.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : g.centeredSlides && l.snapIndex < g.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = u, l.allowSlideNext = m, l.emit("loopFix");
    return;
  }
  let d = g.slidesPerView;
  d === "auto" ? d = l.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(g.slidesPerView, 10)), p && d % 2 === 0 && (d = d + 1));
  const h = g.slidesPerGroupAuto ? d : g.slidesPerGroup;
  let f = h;
  f % h !== 0 && (f += h - f % h), f += g.loopAdditionalSlides, l.loopedSlides = f;
  const F = l.grid && g.grid && g.grid.rows > 1;
  c.length < d + f ? Bs("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : F && g.grid.fill === "row" && Bs("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const b = [], v = [];
  let k = l.activeIndex;
  typeof a > "u" ? a = l.getSlideIndex(c.find((T) => T.classList.contains(g.slideActiveClass))) : k = a;
  const E = t === "next" || !t, S = t === "prev" || !t;
  let B = 0, D = 0;
  const x = F ? Math.ceil(c.length / g.grid.rows) : c.length, O = (F ? c[a].column : a) + (p && typeof n > "u" ? -d / 2 + 0.5 : 0);
  if (O < f) {
    B = Math.max(f - O, h);
    for (let T = 0; T < f - O; T += 1) {
      const I = T - Math.floor(T / x) * x;
      if (F) {
        const G = x - I - 1;
        for (let U = c.length - 1; U >= 0; U -= 1)
          c[U].column === G && b.push(U);
      } else
        b.push(x - I - 1);
    }
  } else if (O + d > x - f) {
    D = Math.max(O - (x - f * 2), h);
    for (let T = 0; T < D; T += 1) {
      const I = T - Math.floor(T / x) * x;
      F ? c.forEach((G, U) => {
        G.column === I && v.push(U);
      }) : v.push(I);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), S && b.forEach((T) => {
    c[T].swiperLoopMoveDOM = !0, y.prepend(c[T]), c[T].swiperLoopMoveDOM = !1;
  }), E && v.forEach((T) => {
    c[T].swiperLoopMoveDOM = !0, y.append(c[T]), c[T].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), g.slidesPerView === "auto" ? l.updateSlides() : F && (b.length > 0 && S || v.length > 0 && E) && l.slides.forEach((T, I) => {
    l.grid.updateSlide(I, T, l.slides);
  }), g.watchSlidesProgress && l.updateSlidesOffset(), r) {
    if (b.length > 0 && S) {
      if (typeof e > "u") {
        const T = l.slidesGrid[k], G = l.slidesGrid[k + B] - T;
        i ? l.setTranslate(l.translate - G) : (l.slideTo(k + Math.ceil(B), 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - G, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - G));
      } else if (n) {
        const T = F ? b.length / g.grid.rows : b.length;
        l.slideTo(l.activeIndex + T, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (v.length > 0 && E)
      if (typeof e > "u") {
        const T = l.slidesGrid[k], G = l.slidesGrid[k - D] - T;
        i ? l.setTranslate(l.translate - G) : (l.slideTo(k - D, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - G, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - G));
      } else {
        const T = F ? v.length / g.grid.rows : v.length;
        l.slideTo(l.activeIndex - T, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = u, l.allowSlideNext = m, l.controller && l.controller.control && !s) {
    const T = {
      slideRealIndex: e,
      direction: t,
      setTranslate: n,
      activeSlideIndex: a,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((I) => {
      !I.destroyed && I.params.loop && I.loopFix({
        ...T,
        slideTo: I.params.slidesPerView === g.slidesPerView ? r : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...T,
      slideTo: l.controller.control.params.slidesPerView === g.slidesPerView ? r : !1
    });
  }
  l.emit("loopFix");
}
function d7() {
  const o = this, {
    params: e,
    slidesEl: r
  } = o;
  if (!e.loop || !r || o.virtual && o.params.virtual.enabled) return;
  o.recalcSlides();
  const t = [];
  o.slides.forEach((n) => {
    const a = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    t[a] = n;
  }), o.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), t.forEach((n) => {
    r.append(n);
  }), o.recalcSlides(), o.slideTo(o.realIndex, 0);
}
var g7 = {
  loopCreate: u7,
  loopFix: p7,
  loopDestroy: d7
};
function m7(o) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = o ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function y7() {
  const o = this;
  o.params.watchOverflow && o.isLocked || o.params.cssMode || (o.isElement && (o.__preventObserver__ = !0), o[o.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", o.isElement && requestAnimationFrame(() => {
    o.__preventObserver__ = !1;
  }));
}
var f7 = {
  setGrabCursor: m7,
  unsetGrabCursor: y7
};
function h7(o, e) {
  e === void 0 && (e = this);
  function r(t) {
    if (!t || t === qe() || t === ze()) return null;
    t.assignedSlot && (t = t.assignedSlot);
    const n = t.closest(o);
    return !n && !t.getRootNode ? null : n || r(t.getRootNode().host);
  }
  return r(e);
}
function Wg(o, e, r) {
  const t = ze(), {
    params: n
  } = o, a = n.edgeSwipeDetection, s = n.edgeSwipeThreshold;
  return a && (r <= s || r >= t.innerWidth - s) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function F7(o) {
  const e = this, r = qe();
  let t = o;
  t.originalEvent && (t = t.originalEvent);
  const n = e.touchEventsData;
  if (t.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== t.pointerId)
      return;
    n.pointerId = t.pointerId;
  } else t.type === "touchstart" && t.targetTouches.length === 1 && (n.touchId = t.targetTouches[0].identifier);
  if (t.type === "touchstart") {
    Wg(e, t, t.targetTouches[0].pageX);
    return;
  }
  const {
    params: a,
    touches: s,
    enabled: i
  } = e;
  if (!i || !a.simulateTouch && t.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition)
    return;
  !e.animating && a.cssMode && a.loop && e.loopFix();
  let l = t.target;
  if (a.touchEventsTarget === "wrapper" && !S9(l, e.wrapperEl) || "which" in t && t.which === 3 || "button" in t && t.button > 0 || n.isTouched && n.isMoved) return;
  const c = !!a.noSwipingClass && a.noSwipingClass !== "", u = t.composedPath ? t.composedPath() : t.path;
  c && t.target && t.target.shadowRoot && u && (l = u[0]);
  const m = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, y = !!(t.target && t.target.shadowRoot);
  if (a.noSwiping && (y ? h7(m, l) : l.closest(m))) {
    e.allowClick = !0;
    return;
  }
  if (a.swipeHandler && !l.closest(a.swipeHandler))
    return;
  s.currentX = t.pageX, s.currentY = t.pageY;
  const g = s.currentX, p = s.currentY;
  if (!Wg(e, t, g))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = g, s.startY = p, n.touchStartTime = xo(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (n.allowThresholdMove = !1);
  let d = !0;
  l.matches(n.focusableElements) && (d = !1, l.nodeName === "SELECT" && (n.isTouched = !1)), r.activeElement && r.activeElement.matches(n.focusableElements) && r.activeElement !== l && (t.pointerType === "mouse" || t.pointerType !== "mouse" && !l.matches(n.focusableElements)) && r.activeElement.blur();
  const h = d && e.allowTouchMove && a.touchStartPreventDefault;
  (a.touchStartForcePreventDefault || h) && !l.isContentEditable && t.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", t);
}
function b7(o) {
  const e = qe(), r = this, t = r.touchEventsData, {
    params: n,
    touches: a,
    rtlTranslate: s,
    enabled: i
  } = r;
  if (!i || !n.simulateTouch && o.pointerType === "mouse") return;
  let l = o;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (t.touchId !== null || l.pointerId !== t.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((k) => k.identifier === t.touchId), !c || c.identifier !== t.touchId) return;
  } else
    c = l;
  if (!t.isTouched) {
    t.startMoving && t.isScrolling && r.emit("touchMoveOpposite", l);
    return;
  }
  const u = c.pageX, m = c.pageY;
  if (l.preventedByNestedSwiper) {
    a.startX = u, a.startY = m;
    return;
  }
  if (!r.allowTouchMove) {
    l.target.matches(t.focusableElements) || (r.allowClick = !1), t.isTouched && (Object.assign(a, {
      startX: u,
      startY: m,
      currentX: u,
      currentY: m
    }), t.touchStartTime = xo());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (r.isVertical()) {
      if (m < a.startY && r.translate <= r.maxTranslate() || m > a.startY && r.translate >= r.minTranslate()) {
        t.isTouched = !1, t.isMoved = !1;
        return;
      }
    } else if (u < a.startX && r.translate <= r.maxTranslate() || u > a.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(t.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(t.focusableElements)) {
    t.isMoved = !0, r.allowClick = !1;
    return;
  }
  t.allowTouchCallbacks && r.emit("touchMove", l), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = u, a.currentY = m;
  const y = a.currentX - a.startX, g = a.currentY - a.startY;
  if (r.params.threshold && Math.sqrt(y ** 2 + g ** 2) < r.params.threshold) return;
  if (typeof t.isScrolling > "u") {
    let k;
    r.isHorizontal() && a.currentY === a.startY || r.isVertical() && a.currentX === a.startX ? t.isScrolling = !1 : y * y + g * g >= 25 && (k = Math.atan2(Math.abs(g), Math.abs(y)) * 180 / Math.PI, t.isScrolling = r.isHorizontal() ? k > n.touchAngle : 90 - k > n.touchAngle);
  }
  if (t.isScrolling && r.emit("touchMoveOpposite", l), typeof t.startMoving > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (t.startMoving = !0), t.isScrolling || l.type === "touchmove" && t.preventTouchMoveFromPointerMove) {
    t.isTouched = !1;
    return;
  }
  if (!t.startMoving)
    return;
  r.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let p = r.isHorizontal() ? y : g, d = r.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  n.oneWayMovement && (p = Math.abs(p) * (s ? 1 : -1), d = Math.abs(d) * (s ? 1 : -1)), a.diff = p, p *= n.touchRatio, s && (p = -p, d = -d);
  const h = r.touchesDirection;
  r.swipeDirection = p > 0 ? "prev" : "next", r.touchesDirection = d > 0 ? "prev" : "next";
  const f = r.params.loop && !n.cssMode, F = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
  if (!t.isMoved) {
    if (f && F && r.loopFix({
      direction: r.swipeDirection
    }), t.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const k = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      r.wrapperEl.dispatchEvent(k);
    }
    t.allowMomentumBounce = !1, n.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && t.isMoved && t.allowThresholdMove && h !== r.touchesDirection && f && F && Math.abs(p) >= 1) {
    Object.assign(a, {
      startX: u,
      startY: m,
      currentX: u,
      currentY: m,
      startTranslate: t.currentTranslate
    }), t.loopSwapReset = !0, t.startTranslate = t.currentTranslate;
    return;
  }
  r.emit("sliderMove", l), t.isMoved = !0, t.currentTranslate = p + t.startTranslate;
  let b = !0, v = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (v = 0), p > 0 ? (f && F && t.allowThresholdMove && t.currentTranslate > (n.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (n.slidesPerView !== "auto" && r.slides.length - n.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), t.currentTranslate > r.minTranslate() && (b = !1, n.resistance && (t.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + t.startTranslate + p) ** v))) : p < 0 && (f && F && t.allowThresholdMove && t.currentTranslate < (n.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (n.slidesPerView !== "auto" && r.slides.length - n.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (n.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), t.currentTranslate < r.maxTranslate() && (b = !1, n.resistance && (t.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - t.startTranslate - p) ** v))), b && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && t.currentTranslate < t.startTranslate && (t.currentTranslate = t.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && t.currentTranslate > t.startTranslate && (t.currentTranslate = t.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (t.currentTranslate = t.startTranslate), n.threshold > 0)
    if (Math.abs(p) > n.threshold || t.allowThresholdMove) {
      if (!t.allowThresholdMove) {
        t.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, t.currentTranslate = t.startTranslate, a.diff = r.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      t.currentTranslate = t.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && r.freeMode || n.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(t.currentTranslate), r.setTranslate(t.currentTranslate));
}
function v7(o) {
  const e = this, r = e.touchEventsData;
  let t = o;
  t.originalEvent && (t = t.originalEvent);
  let n;
  if (t.type === "touchend" || t.type === "touchcancel") {
    if (n = [...t.changedTouches].find((k) => k.identifier === r.touchId), !n || n.identifier !== r.touchId) return;
  } else {
    if (r.touchId !== null || t.pointerId !== r.pointerId) return;
    n = t;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(t.type) && !(["pointercancel", "contextmenu"].includes(t.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  r.pointerId = null, r.touchId = null;
  const {
    params: s,
    touches: i,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: u
  } = e;
  if (!u || !s.simulateTouch && t.pointerType === "mouse") return;
  if (r.allowTouchCallbacks && e.emit("touchEnd", t), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && s.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  s.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const m = xo(), y = m - r.touchStartTime;
  if (e.allowClick) {
    const k = t.path || t.composedPath && t.composedPath();
    e.updateClickedSlide(k && k[0] || t.target, k), e.emit("tap click", t), y < 300 && m - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", t);
  }
  if (r.lastClickTime = xo(), Xr(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || i.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let g;
  if (s.followFinger ? g = l ? e.translate : -e.translate : g = -r.currentTranslate, s.cssMode)
    return;
  if (s.freeMode && s.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const p = g >= -e.maxTranslate() && !e.params.loop;
  let d = 0, h = e.slidesSizesGrid[0];
  for (let k = 0; k < c.length; k += k < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const E = k < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof c[k + E] < "u" ? (p || g >= c[k] && g < c[k + E]) && (d = k, h = c[k + E] - c[k]) : (p || g >= c[k]) && (d = k, h = c[c.length - 1] - c[c.length - 2]);
  }
  let f = null, F = null;
  s.rewind && (e.isBeginning ? F = s.virtual && s.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (f = 0));
  const b = (g - c[d]) / h, v = d < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (y > s.longSwipesMs) {
    if (!s.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (b >= s.longSwipesRatio ? e.slideTo(s.rewind && e.isEnd ? f : d + v) : e.slideTo(d)), e.swipeDirection === "prev" && (b > 1 - s.longSwipesRatio ? e.slideTo(d + v) : F !== null && b < 0 && Math.abs(b) > s.longSwipesRatio ? e.slideTo(F) : e.slideTo(d));
  } else {
    if (!s.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (t.target === e.navigation.nextEl || t.target === e.navigation.prevEl) ? t.target === e.navigation.nextEl ? e.slideTo(d + v) : e.slideTo(d) : (e.swipeDirection === "next" && e.slideTo(f !== null ? f : d + v), e.swipeDirection === "prev" && e.slideTo(F !== null ? F : d));
  }
}
function Vg() {
  const o = this, {
    params: e,
    el: r
  } = o;
  if (r && r.offsetWidth === 0) return;
  e.breakpoints && o.setBreakpoint();
  const {
    allowSlideNext: t,
    allowSlidePrev: n,
    snapGrid: a
  } = o, s = o.virtual && o.params.virtual.enabled;
  o.allowSlideNext = !0, o.allowSlidePrev = !0, o.updateSize(), o.updateSlides(), o.updateSlidesClasses();
  const i = s && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && o.isEnd && !o.isBeginning && !o.params.centeredSlides && !i ? o.slideTo(o.slides.length - 1, 0, !1, !0) : o.params.loop && !s ? o.slideToLoop(o.realIndex, 0, !1, !0) : o.slideTo(o.activeIndex, 0, !1, !0), o.autoplay && o.autoplay.running && o.autoplay.paused && (clearTimeout(o.autoplay.resizeTimeout), o.autoplay.resizeTimeout = setTimeout(() => {
    o.autoplay && o.autoplay.running && o.autoplay.paused && o.autoplay.resume();
  }, 500)), o.allowSlidePrev = n, o.allowSlideNext = t, o.params.watchOverflow && a !== o.snapGrid && o.checkOverflow();
}
function P7(o) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && o.preventDefault(), e.params.preventClicksPropagation && e.animating && (o.stopPropagation(), o.stopImmediatePropagation())));
}
function B7() {
  const o = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: t
  } = o;
  if (!t) return;
  o.previousTranslate = o.translate, o.isHorizontal() ? o.translate = -e.scrollLeft : o.translate = -e.scrollTop, o.translate === 0 && (o.translate = 0), o.updateActiveIndex(), o.updateSlidesClasses();
  let n;
  const a = o.maxTranslate() - o.minTranslate();
  a === 0 ? n = 0 : n = (o.translate - o.minTranslate()) / a, n !== o.progress && o.updateProgress(r ? -o.translate : o.translate), o.emit("setTranslate", o.translate, !1);
}
function k7(o) {
  const e = this;
  is(e, o.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function w7() {
  const o = this;
  o.documentTouchHandlerProceeded || (o.documentTouchHandlerProceeded = !0, o.params.touchReleaseOnEdges && (o.el.style.touchAction = "auto"));
}
const ah = (o, e) => {
  const r = qe(), {
    params: t,
    el: n,
    wrapperEl: a,
    device: s
  } = o, i = !!t.nested, l = e === "on" ? "addEventListener" : "removeEventListener", c = e;
  !n || typeof n == "string" || (r[l]("touchstart", o.onDocumentTouchStart, {
    passive: !1,
    capture: i
  }), n[l]("touchstart", o.onTouchStart, {
    passive: !1
  }), n[l]("pointerdown", o.onTouchStart, {
    passive: !1
  }), r[l]("touchmove", o.onTouchMove, {
    passive: !1,
    capture: i
  }), r[l]("pointermove", o.onTouchMove, {
    passive: !1,
    capture: i
  }), r[l]("touchend", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerup", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", o.onTouchEnd, {
    passive: !0
  }), r[l]("touchcancel", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", o.onTouchEnd, {
    passive: !0
  }), r[l]("contextmenu", o.onTouchEnd, {
    passive: !0
  }), (t.preventClicks || t.preventClicksPropagation) && n[l]("click", o.onClick, !0), t.cssMode && a[l]("scroll", o.onScroll), t.updateOnWindowResize ? o[c](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Vg, !0) : o[c]("observerUpdate", Vg, !0), n[l]("load", o.onLoad, {
    capture: !0
  }));
};
function D7() {
  const o = this, {
    params: e
  } = o;
  o.onTouchStart = F7.bind(o), o.onTouchMove = b7.bind(o), o.onTouchEnd = v7.bind(o), o.onDocumentTouchStart = w7.bind(o), e.cssMode && (o.onScroll = B7.bind(o)), o.onClick = P7.bind(o), o.onLoad = k7.bind(o), ah(o, "on");
}
function S7() {
  ah(this, "off");
}
var E7 = {
  attachEvents: D7,
  detachEvents: S7
};
const Gg = (o, e) => o.grid && e.grid && e.grid.rows > 1;
function x7() {
  const o = this, {
    realIndex: e,
    initialized: r,
    params: t,
    el: n
  } = o, a = t.breakpoints;
  if (!a || a && Object.keys(a).length === 0) return;
  const s = qe(), i = t.breakpointsBase === "window" || !t.breakpointsBase ? t.breakpointsBase : "container", l = ["window", "container"].includes(t.breakpointsBase) || !t.breakpointsBase ? o.el : s.querySelector(t.breakpointsBase), c = o.getBreakpoint(a, i, l);
  if (!c || o.currentBreakpoint === c) return;
  const m = (c in a ? a[c] : void 0) || o.originalParams, y = Gg(o, t), g = Gg(o, m), p = o.params.grabCursor, d = m.grabCursor, h = t.enabled;
  y && !g ? (n.classList.remove(`${t.containerModifierClass}grid`, `${t.containerModifierClass}grid-column`), o.emitContainerClasses()) : !y && g && (n.classList.add(`${t.containerModifierClass}grid`), (m.grid.fill && m.grid.fill === "column" || !m.grid.fill && t.grid.fill === "column") && n.classList.add(`${t.containerModifierClass}grid-column`), o.emitContainerClasses()), p && !d ? o.unsetGrabCursor() : !p && d && o.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((E) => {
    if (typeof m[E] > "u") return;
    const S = t[E] && t[E].enabled, B = m[E] && m[E].enabled;
    S && !B && o[E].disable(), !S && B && o[E].enable();
  });
  const f = m.direction && m.direction !== t.direction, F = t.loop && (m.slidesPerView !== t.slidesPerView || f), b = t.loop;
  f && r && o.changeDirection(), Fo(o.params, m);
  const v = o.params.enabled, k = o.params.loop;
  Object.assign(o, {
    allowTouchMove: o.params.allowTouchMove,
    allowSlideNext: o.params.allowSlideNext,
    allowSlidePrev: o.params.allowSlidePrev
  }), h && !v ? o.disable() : !h && v && o.enable(), o.currentBreakpoint = c, o.emit("_beforeBreakpoint", m), r && (F ? (o.loopDestroy(), o.loopCreate(e), o.updateSlides()) : !b && k ? (o.loopCreate(e), o.updateSlides()) : b && !k && o.loopDestroy()), o.emit("breakpoint", m);
}
function A7(o, e, r) {
  if (e === void 0 && (e = "window"), !o || e === "container" && !r) return;
  let t = !1;
  const n = ze(), a = e === "window" ? n.innerHeight : r.clientHeight, s = Object.keys(o).map((i) => {
    if (typeof i == "string" && i.indexOf("@") === 0) {
      const l = parseFloat(i.substr(1));
      return {
        value: a * l,
        point: i
      };
    }
    return {
      value: i,
      point: i
    };
  });
  s.sort((i, l) => parseInt(i.value, 10) - parseInt(l.value, 10));
  for (let i = 0; i < s.length; i += 1) {
    const {
      point: l,
      value: c
    } = s[i];
    e === "window" ? n.matchMedia(`(min-width: ${c}px)`).matches && (t = l) : c <= r.clientWidth && (t = l);
  }
  return t || "max";
}
var C7 = {
  setBreakpoint: x7,
  getBreakpoint: A7
};
function O7(o, e) {
  const r = [];
  return o.forEach((t) => {
    typeof t == "object" ? Object.keys(t).forEach((n) => {
      t[n] && r.push(e + n);
    }) : typeof t == "string" && r.push(e + t);
  }), r;
}
function T7() {
  const o = this, {
    classNames: e,
    params: r,
    rtl: t,
    el: n,
    device: a
  } = o, s = O7(["initialized", r.direction, {
    "free-mode": o.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: t
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: a.android
  }, {
    ios: a.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...s), n.classList.add(...e), o.emitContainerClasses();
}
function j7() {
  const o = this, {
    el: e,
    classNames: r
  } = o;
  !e || typeof e == "string" || (e.classList.remove(...r), o.emitContainerClasses());
}
var M7 = {
  addClasses: T7,
  removeClasses: j7
};
function z7() {
  const o = this, {
    isLocked: e,
    params: r
  } = o, {
    slidesOffsetBefore: t
  } = r;
  if (t) {
    const n = o.slides.length - 1, a = o.slidesGrid[n] + o.slidesSizesGrid[n] + t * 2;
    o.isLocked = o.size > a;
  } else
    o.isLocked = o.snapGrid.length === 1;
  r.allowSlideNext === !0 && (o.allowSlideNext = !o.isLocked), r.allowSlidePrev === !0 && (o.allowSlidePrev = !o.isLocked), e && e !== o.isLocked && (o.isEnd = !1), e !== o.isLocked && o.emit(o.isLocked ? "lock" : "unlock");
}
var N7 = {
  checkOverflow: z7
}, fc = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function I7(o, e) {
  return function(t) {
    t === void 0 && (t = {});
    const n = Object.keys(t)[0], a = t[n];
    if (typeof a != "object" || a === null) {
      Fo(e, t);
      return;
    }
    if (o[n] === !0 && (o[n] = {
      enabled: !0
    }), n === "navigation" && o[n] && o[n].enabled && !o[n].prevEl && !o[n].nextEl && (o[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && o[n] && o[n].enabled && !o[n].el && (o[n].auto = !0), !(n in o && "enabled" in a)) {
      Fo(e, t);
      return;
    }
    typeof o[n] == "object" && !("enabled" in o[n]) && (o[n].enabled = !0), o[n] || (o[n] = {
      enabled: !1
    }), Fo(e, t);
  };
}
const ml = {
  eventsEmitter: M9,
  update: X9,
  translate: K9,
  transition: o7,
  slide: c7,
  loop: g7,
  grabCursor: f7,
  events: E7,
  breakpoints: C7,
  checkOverflow: N7,
  classes: M7
}, yl = {};
class ho {
  constructor() {
    let e, r;
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? r = n[0] : [e, r] = n, r || (r = {}), r = Fo({}, r), e && !r.el && (r.el = e);
    const s = qe();
    if (r.el && typeof r.el == "string" && s.querySelectorAll(r.el).length > 1) {
      const u = [];
      return s.querySelectorAll(r.el).forEach((m) => {
        const y = Fo({}, r, {
          el: m
        });
        u.push(new ho(y));
      }), u;
    }
    const i = this;
    i.__swiper__ = !0, i.support = oh(), i.device = rh({
      userAgent: r.userAgent
    }), i.browser = th(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], r.modules && Array.isArray(r.modules) && i.modules.push(...r.modules);
    const l = {};
    i.modules.forEach((u) => {
      u({
        params: r,
        swiper: i,
        extendParams: I7(r, l),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const c = Fo({}, fc, l);
    return i.params = Fo({}, c, yl, r), i.originalParams = Fo({}, i.params), i.passedParams = Fo({}, r), i.params && i.params.on && Object.keys(i.params.on).forEach((u) => {
      i.on(u, i.params.on[u]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), Object.assign(i, {
      enabled: i.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return i.params.direction === "horizontal";
      },
      isVertical() {
        return i.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: i.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: t
    } = this, n = Ye(r, `.${t.slideClass}, swiper-slide`), a = $n(n[0]);
    return $n(e) - a;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((r) => r.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: t
    } = e;
    e.slides = Ye(r, `.${t.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const t = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = t.minTranslate(), s = (t.maxTranslate() - n) * e + n;
    t.translateTo(s, typeof r > "u" ? 0 : r), t.updateActiveIndex(), t.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = e.el.className.split(" ").filter((t) => t.indexOf("swiper") === 0 || t.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((t) => t.indexOf("swiper-slide") === 0 || t.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = [];
    e.slides.forEach((t) => {
      const n = e.getSlideClasses(t);
      r.push({
        slideEl: t,
        classNames: n
      }), e.emit("_slideClass", t, n);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e, r) {
    e === void 0 && (e = "current"), r === void 0 && (r = !1);
    const t = this, {
      params: n,
      slides: a,
      slidesGrid: s,
      slidesSizesGrid: i,
      size: l,
      activeIndex: c
    } = t;
    let u = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let m = a[c] ? Math.ceil(a[c].swiperSlideSize) : 0, y;
      for (let g = c + 1; g < a.length; g += 1)
        a[g] && !y && (m += Math.ceil(a[g].swiperSlideSize), u += 1, m > l && (y = !0));
      for (let g = c - 1; g >= 0; g -= 1)
        a[g] && !y && (m += a[g].swiperSlideSize, u += 1, m > l && (y = !0));
    } else if (e === "current")
      for (let m = c + 1; m < a.length; m += 1)
        (r ? s[m] + i[m] - s[c] < l : s[m] - s[c] < l) && (u += 1);
    else
      for (let m = c - 1; m >= 0; m -= 1)
        s[c] - s[m] < l && (u += 1);
    return u;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: r,
      params: t
    } = e;
    t.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && is(e, s);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function n() {
      const s = e.rtlTranslate ? e.translate * -1 : e.translate, i = Math.min(Math.max(s, e.maxTranslate()), e.minTranslate());
      e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let a;
    if (t.freeMode && t.freeMode.enabled && !t.cssMode)
      n(), t.autoHeight && e.updateAutoHeight();
    else {
      if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !t.centeredSlides) {
        const s = e.virtual && t.virtual.enabled ? e.virtual.slides : e.slides;
        a = e.slideTo(s.length - 1, 0, !1, !0);
      } else
        a = e.slideTo(e.activeIndex, 0, !1, !0);
      a || n();
    }
    t.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r) {
    r === void 0 && (r = !0);
    const t = this, n = t.params.direction;
    return e || (e = n === "horizontal" ? "vertical" : "horizontal"), e === n || e !== "horizontal" && e !== "vertical" || (t.el.classList.remove(`${t.params.containerModifierClass}${n}`), t.el.classList.add(`${t.params.containerModifierClass}${e}`), t.emitContainerClasses(), t.params.direction = e, t.slides.forEach((a) => {
      e === "vertical" ? a.style.width = "" : a.style.height = "";
    }), t.emit("changeDirection"), r && t.update()), t;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted) return !0;
    let t = e || r.params.el;
    if (typeof t == "string" && (t = document.querySelector(t)), !t)
      return !1;
    t.swiper = r, t.parentNode && t.parentNode.host && t.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
    const n = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = t && t.shadowRoot && t.shadowRoot.querySelector ? t.shadowRoot.querySelector(n()) : Ye(t, n())[0];
    return !s && r.params.createElements && (s = Bo("div", r.params.wrapperClass), t.append(s), Ye(t, `.${r.params.slideClass}`).forEach((i) => {
      s.append(i);
    })), Object.assign(r, {
      el: t,
      wrapperEl: s,
      slidesEl: r.isElement && !t.parentNode.host.slideSlots ? t.parentNode.host : s,
      hostEl: r.isElement ? t.parentNode.host : t,
      mounted: !0,
      // RTL
      rtl: t.dir.toLowerCase() === "rtl" || Pr(t, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || Pr(t, "direction") === "rtl"),
      wrongRTL: Pr(s, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    if (r.initialized || r.mount(e) === !1) return r;
    r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents();
    const n = [...r.el.querySelectorAll('[loading="lazy"]')];
    return r.isElement && n.push(...r.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((a) => {
      a.complete ? is(r, a) : a.addEventListener("load", (s) => {
        is(r, s.target);
      });
    }), yc(r), r.initialized = !0, yc(r), r.emit("init"), r.emit("afterInit"), r;
  }
  destroy(e, r) {
    e === void 0 && (e = !0), r === void 0 && (r = !0);
    const t = this, {
      params: n,
      el: a,
      wrapperEl: s,
      slides: i
    } = t;
    return typeof t.params > "u" || t.destroyed || (t.emit("beforeDestroy"), t.initialized = !1, t.detachEvents(), n.loop && t.loopDestroy(), r && (t.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), s && s.removeAttribute("style"), i && i.length && i.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), t.emit("destroy"), Object.keys(t.eventsListeners).forEach((l) => {
      t.off(l);
    }), e !== !1 && (t.el && typeof t.el != "string" && (t.el.swiper = null), B9(t)), t.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Fo(yl, e);
  }
  static get extendedDefaults() {
    return yl;
  }
  static get defaults() {
    return fc;
  }
  static installModule(e) {
    ho.prototype.__modules__ || (ho.prototype.__modules__ = []);
    const r = ho.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => ho.installModule(r)), ho) : (ho.installModule(e), ho);
  }
}
Object.keys(ml).forEach((o) => {
  Object.keys(ml[o]).forEach((e) => {
    ho.prototype[e] = ml[o][e];
  });
});
ho.use([T9, j9]);
function R7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  r({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let a;
  const s = qe();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const i = s.createElement("div");
  function l(p, d) {
    const h = e.params.virtual;
    if (h.cache && e.virtual.cache[d])
      return e.virtual.cache[d];
    let f;
    return h.renderSlide ? (f = h.renderSlide.call(e, p, d), typeof f == "string" && (i.innerHTML = f, f = i.children[0])) : e.isElement ? f = Bo("swiper-slide") : f = Bo("div", e.params.slideClass), f.setAttribute("data-swiper-slide-index", d), h.renderSlide || (f.innerHTML = p), h.cache && (e.virtual.cache[d] = f), f;
  }
  function c(p, d, h) {
    const {
      slidesPerView: f,
      slidesPerGroup: F,
      centeredSlides: b,
      loop: v,
      initialSlide: k
    } = e.params;
    if (d && !v && k > 0)
      return;
    const {
      addSlidesBefore: E,
      addSlidesAfter: S
    } = e.params.virtual, {
      from: B,
      to: D,
      slides: x,
      slidesGrid: C,
      offset: O
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const T = typeof h > "u" ? e.activeIndex || 0 : h;
    let I;
    e.rtlTranslate ? I = "right" : I = e.isHorizontal() ? "left" : "top";
    let G, U;
    b ? (G = Math.floor(f / 2) + F + S, U = Math.floor(f / 2) + F + E) : (G = f + (F - 1) + S, U = (v ? f : F) + E);
    let N = T - U, z = T + G;
    v || (N = Math.max(N, 0), z = Math.min(z, x.length - 1));
    let V = (e.slidesGrid[N] || 0) - (e.slidesGrid[0] || 0);
    v && T >= U ? (N -= U, b || (V += e.slidesGrid[0])) : v && T < U && (N = -U, b && (V += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: N,
      to: z,
      offset: V,
      slidesGrid: e.slidesGrid,
      slidesBefore: U,
      slidesAfter: G
    });
    function Y() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate");
    }
    if (B === N && D === z && !p) {
      e.slidesGrid !== C && V !== O && e.slides.forEach((q) => {
        q.style[I] = `${V - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), n("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: V,
        from: N,
        to: z,
        slides: function() {
          const J = [];
          for (let ee = N; ee <= z; ee += 1)
            J.push(x[ee]);
          return J;
        }()
      }), e.params.virtual.renderExternalUpdate ? Y() : n("virtualUpdate");
      return;
    }
    const K = [], $ = [], te = (q) => {
      let J = q;
      return q < 0 ? J = x.length + q : J >= x.length && (J = J - x.length), J;
    };
    if (p)
      e.slides.filter((q) => q.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((q) => {
        q.remove();
      });
    else
      for (let q = B; q <= D; q += 1)
        if (q < N || q > z) {
          const J = te(q);
          e.slides.filter((ee) => ee.matches(`.${e.params.slideClass}[data-swiper-slide-index="${J}"], swiper-slide[data-swiper-slide-index="${J}"]`)).forEach((ee) => {
            ee.remove();
          });
        }
    const ge = v ? -x.length : 0, X = v ? x.length * 2 : x.length;
    for (let q = ge; q < X; q += 1)
      if (q >= N && q <= z) {
        const J = te(q);
        typeof D > "u" || p ? $.push(J) : (q > D && $.push(J), q < B && K.push(J));
      }
    if ($.forEach((q) => {
      e.slidesEl.append(l(x[q], q));
    }), v)
      for (let q = K.length - 1; q >= 0; q -= 1) {
        const J = K[q];
        e.slidesEl.prepend(l(x[J], J));
      }
    else
      K.sort((q, J) => J - q), K.forEach((q) => {
        e.slidesEl.prepend(l(x[q], q));
      });
    Ye(e.slidesEl, ".swiper-slide, swiper-slide").forEach((q) => {
      q.style[I] = `${V - Math.abs(e.cssOverflowAdjustment())}px`;
    }), Y();
  }
  function u(p) {
    if (typeof p == "object" && "length" in p)
      for (let d = 0; d < p.length; d += 1)
        p[d] && e.virtual.slides.push(p[d]);
    else
      e.virtual.slides.push(p);
    c(!0);
  }
  function m(p) {
    const d = e.activeIndex;
    let h = d + 1, f = 1;
    if (Array.isArray(p)) {
      for (let F = 0; F < p.length; F += 1)
        p[F] && e.virtual.slides.unshift(p[F]);
      h = d + p.length, f = p.length;
    } else
      e.virtual.slides.unshift(p);
    if (e.params.virtual.cache) {
      const F = e.virtual.cache, b = {};
      Object.keys(F).forEach((v) => {
        const k = F[v], E = k.getAttribute("data-swiper-slide-index");
        E && k.setAttribute("data-swiper-slide-index", parseInt(E, 10) + f), b[parseInt(v, 10) + f] = k;
      }), e.virtual.cache = b;
    }
    c(!0), e.slideTo(h, 0);
  }
  function y(p) {
    if (typeof p > "u" || p === null) return;
    let d = e.activeIndex;
    if (Array.isArray(p))
      for (let h = p.length - 1; h >= 0; h -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[p[h]], Object.keys(e.virtual.cache).forEach((f) => {
          f > p && (e.virtual.cache[f - 1] = e.virtual.cache[f], e.virtual.cache[f - 1].setAttribute("data-swiper-slide-index", f - 1), delete e.virtual.cache[f]);
        })), e.virtual.slides.splice(p[h], 1), p[h] < d && (d -= 1), d = Math.max(d, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach((h) => {
        h > p && (e.virtual.cache[h - 1] = e.virtual.cache[h], e.virtual.cache[h - 1].setAttribute("data-swiper-slide-index", h - 1), delete e.virtual.cache[h]);
      })), e.virtual.slides.splice(p, 1), p < d && (d -= 1), d = Math.max(d, 0);
    c(!0), e.slideTo(d, 0);
  }
  function g() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), c(!0), e.slideTo(0, 0);
  }
  t("beforeInit", () => {
    if (!e.params.virtual.enabled) return;
    let p;
    if (typeof e.passedParams.virtual.slides > "u") {
      const d = [...e.slidesEl.children].filter((h) => h.matches(`.${e.params.slideClass}, swiper-slide`));
      d && d.length && (e.virtual.slides = [...d], p = !0, d.forEach((h, f) => {
        h.setAttribute("data-swiper-slide-index", f), e.virtual.cache[f] = h, h.remove();
      }));
    }
    p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, c(!1, !0);
  }), t("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(() => {
      c();
    }, 100)) : c());
  }), t("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && Ut(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: u,
    prependSlide: m,
    removeSlide: y,
    removeAllSlides: g,
    update: c
  });
}
function L7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = qe(), s = ze();
  e.keyboard = {
    enabled: !1
  }, r({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function i(u) {
    if (!e.enabled) return;
    const {
      rtlTranslate: m
    } = e;
    let y = u;
    y.originalEvent && (y = y.originalEvent);
    const g = y.keyCode || y.charCode, p = e.params.keyboard.pageUpDown, d = p && g === 33, h = p && g === 34, f = g === 37, F = g === 39, b = g === 38, v = g === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && F || e.isVertical() && v || h) || !e.allowSlidePrev && (e.isHorizontal() && f || e.isVertical() && b || d))
      return !1;
    if (!(y.shiftKey || y.altKey || y.ctrlKey || y.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (d || h || f || F || b || v)) {
        let k = !1;
        if (Lr(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Lr(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const E = e.el, S = E.clientWidth, B = E.clientHeight, D = s.innerWidth, x = s.innerHeight, C = ks(E);
        m && (C.left -= E.scrollLeft);
        const O = [[C.left, C.top], [C.left + S, C.top], [C.left, C.top + B], [C.left + S, C.top + B]];
        for (let T = 0; T < O.length; T += 1) {
          const I = O[T];
          if (I[0] >= 0 && I[0] <= D && I[1] >= 0 && I[1] <= x) {
            if (I[0] === 0 && I[1] === 0) continue;
            k = !0;
          }
        }
        if (!k) return;
      }
      e.isHorizontal() ? ((d || h || f || F) && (y.preventDefault ? y.preventDefault() : y.returnValue = !1), ((h || F) && !m || (d || f) && m) && e.slideNext(), ((d || f) && !m || (h || F) && m) && e.slidePrev()) : ((d || h || b || v) && (y.preventDefault ? y.preventDefault() : y.returnValue = !1), (h || v) && e.slideNext(), (d || b) && e.slidePrev()), n("keyPress", g);
    }
  }
  function l() {
    e.keyboard.enabled || (a.addEventListener("keydown", i), e.keyboard.enabled = !0);
  }
  function c() {
    e.keyboard.enabled && (a.removeEventListener("keydown", i), e.keyboard.enabled = !1);
  }
  t("init", () => {
    e.params.keyboard.enabled && l();
  }), t("destroy", () => {
    e.keyboard.enabled && c();
  }), Object.assign(e.keyboard, {
    enable: l,
    disable: c
  });
}
function H7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = ze();
  r({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let s, i = xo(), l;
  const c = [];
  function u(b) {
    let S = 0, B = 0, D = 0, x = 0;
    return "detail" in b && (B = b.detail), "wheelDelta" in b && (B = -b.wheelDelta / 120), "wheelDeltaY" in b && (B = -b.wheelDeltaY / 120), "wheelDeltaX" in b && (S = -b.wheelDeltaX / 120), "axis" in b && b.axis === b.HORIZONTAL_AXIS && (S = B, B = 0), D = S * 10, x = B * 10, "deltaY" in b && (x = b.deltaY), "deltaX" in b && (D = b.deltaX), b.shiftKey && !D && (D = x, x = 0), (D || x) && b.deltaMode && (b.deltaMode === 1 ? (D *= 40, x *= 40) : (D *= 800, x *= 800)), D && !S && (S = D < 1 ? -1 : 1), x && !B && (B = x < 1 ? -1 : 1), {
      spinX: S,
      spinY: B,
      pixelX: D,
      pixelY: x
    };
  }
  function m() {
    e.enabled && (e.mouseEntered = !0);
  }
  function y() {
    e.enabled && (e.mouseEntered = !1);
  }
  function g(b) {
    return e.params.mousewheel.thresholdDelta && b.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && xo() - i < e.params.mousewheel.thresholdTime ? !1 : b.delta >= 6 && xo() - i < 60 ? !0 : (b.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", b.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", b.raw)), i = new a.Date().getTime(), !1);
  }
  function p(b) {
    const v = e.params.mousewheel;
    if (b.direction < 0) {
      if (e.isEnd && !e.params.loop && v.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && v.releaseOnEdges)
      return !0;
    return !1;
  }
  function d(b) {
    let v = b, k = !0;
    if (!e.enabled || b.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const E = e.params.mousewheel;
    e.params.cssMode && v.preventDefault();
    let S = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (S = document.querySelector(e.params.mousewheel.eventsTarget));
    const B = S && S.contains(v.target);
    if (!e.mouseEntered && !B && !E.releaseOnEdges) return !0;
    v.originalEvent && (v = v.originalEvent);
    let D = 0;
    const x = e.rtlTranslate ? -1 : 1, C = u(v);
    if (E.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(C.pixelX) > Math.abs(C.pixelY)) D = -C.pixelX * x;
        else return !0;
      else if (Math.abs(C.pixelY) > Math.abs(C.pixelX)) D = -C.pixelY;
      else return !0;
    else
      D = Math.abs(C.pixelX) > Math.abs(C.pixelY) ? -C.pixelX * x : -C.pixelY;
    if (D === 0) return !0;
    E.invert && (D = -D);
    let O = e.getTranslate() + D * E.sensitivity;
    if (O >= e.minTranslate() && (O = e.minTranslate()), O <= e.maxTranslate() && (O = e.maxTranslate()), k = e.params.loop ? !0 : !(O === e.minTranslate() || O === e.maxTranslate()), k && e.params.nested && v.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const T = {
        time: xo(),
        delta: Math.abs(D),
        direction: Math.sign(D),
        raw: b
      };
      c.length >= 2 && c.shift();
      const I = c.length ? c[c.length - 1] : void 0;
      if (c.push(T), I ? (T.direction !== I.direction || T.delta > I.delta || T.time > I.time + 150) && g(T) : g(T), p(T))
        return !0;
    } else {
      const T = {
        time: xo(),
        delta: Math.abs(D),
        direction: Math.sign(D)
      }, I = l && T.time < l.time + 500 && T.delta <= l.delta && T.direction === l.direction;
      if (!I) {
        l = void 0;
        let G = e.getTranslate() + D * E.sensitivity;
        const U = e.isBeginning, N = e.isEnd;
        if (G >= e.minTranslate() && (G = e.minTranslate()), G <= e.maxTranslate() && (G = e.maxTranslate()), e.setTransition(0), e.setTranslate(G), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!U && e.isBeginning || !N && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: T.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(s), s = void 0, c.length >= 15 && c.shift();
          const z = c.length ? c[c.length - 1] : void 0, V = c[0];
          if (c.push(T), z && (T.delta > z.delta || T.direction !== z.direction))
            c.splice(0);
          else if (c.length >= 15 && T.time - V.time < 500 && V.delta - T.delta >= 1 && T.delta <= 6) {
            const Y = D > 0 ? 0.8 : 0.2;
            l = T, c.splice(0), s = Xr(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, Y);
            }, 0);
          }
          s || (s = Xr(() => {
            if (e.destroyed || !e.params) return;
            const Y = 0.5;
            l = T, c.splice(0), e.slideToClosest(e.params.speed, !0, void 0, Y);
          }, 500));
        }
        if (I || n("scroll", v), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), E.releaseOnEdges && (G === e.minTranslate() || G === e.maxTranslate()))
          return !0;
      }
    }
    return v.preventDefault ? v.preventDefault() : v.returnValue = !1, !1;
  }
  function h(b) {
    let v = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (v = document.querySelector(e.params.mousewheel.eventsTarget)), v[b]("mouseenter", m), v[b]("mouseleave", y), v[b]("wheel", d);
  }
  function f() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", d), !0) : e.mousewheel.enabled ? !1 : (h("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function F() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, d), !0) : e.mousewheel.enabled ? (h("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  t("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && F(), e.params.mousewheel.enabled && f();
  }), t("destroy", () => {
    e.params.cssMode && f(), e.mousewheel.enabled && F();
  }), Object.assign(e.mousewheel, {
    enable: f,
    disable: F
  });
}
function gu(o, e, r, t) {
  return o.params.createElements && Object.keys(t).forEach((n) => {
    if (!r[n] && r.auto === !0) {
      let a = Ye(o.el, `.${t[n]}`)[0];
      a || (a = Bo("div", t[n]), a.className = t[n], o.el.append(a)), r[n] = a, e[n] = a;
    }
  }), r;
}
function W7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  r({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(p) {
    let d;
    return p && typeof p == "string" && e.isElement && (d = e.el.querySelector(p) || e.hostEl.querySelector(p), d) ? d : (p && (typeof p == "string" && (d = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && d && d.length > 1 && e.el.querySelectorAll(p).length === 1 ? d = e.el.querySelector(p) : d && d.length === 1 && (d = d[0])), p && !d ? p : d);
  }
  function s(p, d) {
    const h = e.params.navigation;
    p = he(p), p.forEach((f) => {
      f && (f.classList[d ? "add" : "remove"](...h.disabledClass.split(" ")), f.tagName === "BUTTON" && (f.disabled = d), e.params.watchOverflow && e.enabled && f.classList[e.isLocked ? "add" : "remove"](h.lockClass));
    });
  }
  function i() {
    const {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    if (e.params.loop) {
      s(d, !1), s(p, !1);
      return;
    }
    s(d, e.isBeginning && !e.params.rewind), s(p, e.isEnd && !e.params.rewind);
  }
  function l(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
  }
  function c(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
  }
  function u() {
    const p = e.params.navigation;
    if (e.params.navigation = gu(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    let d = a(p.nextEl), h = a(p.prevEl);
    Object.assign(e.navigation, {
      nextEl: d,
      prevEl: h
    }), d = he(d), h = he(h);
    const f = (F, b) => {
      F && F.addEventListener("click", b === "next" ? c : l), !e.enabled && F && F.classList.add(...p.lockClass.split(" "));
    };
    d.forEach((F) => f(F, "next")), h.forEach((F) => f(F, "prev"));
  }
  function m() {
    let {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    p = he(p), d = he(d);
    const h = (f, F) => {
      f.removeEventListener("click", F === "next" ? c : l), f.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    p.forEach((f) => h(f, "next")), d.forEach((f) => h(f, "prev"));
  }
  t("init", () => {
    e.params.navigation.enabled === !1 ? g() : (u(), i());
  }), t("toEdge fromEdge lock unlock", () => {
    i();
  }), t("destroy", () => {
    m();
  }), t("enable disable", () => {
    let {
      nextEl: p,
      prevEl: d
    } = e.navigation;
    if (p = he(p), d = he(d), e.enabled) {
      i();
      return;
    }
    [...p, ...d].filter((h) => !!h).forEach((h) => h.classList.add(e.params.navigation.lockClass));
  }), t("click", (p, d) => {
    let {
      nextEl: h,
      prevEl: f
    } = e.navigation;
    h = he(h), f = he(f);
    const F = d.target;
    let b = f.includes(F) || h.includes(F);
    if (e.isElement && !b) {
      const v = d.path || d.composedPath && d.composedPath();
      v && (b = v.find((k) => h.includes(k) || f.includes(k)));
    }
    if (e.params.navigation.hideOnClick && !b) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === F || e.pagination.el.contains(F))) return;
      let v;
      h.length ? v = h[0].classList.contains(e.params.navigation.hiddenClass) : f.length && (v = f[0].classList.contains(e.params.navigation.hiddenClass)), n(v === !0 ? "navigationShow" : "navigationHide"), [...h, ...f].filter((k) => !!k).forEach((k) => k.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const y = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), u(), i();
  }, g = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), m();
  };
  Object.assign(e.navigation, {
    enable: y,
    disable: g,
    update: i,
    init: u,
    destroy: m
  });
}
function er(o) {
  return o === void 0 && (o = ""), `.${o.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function V7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = "swiper-pagination";
  r({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (F) => F,
      formatFractionTotal: (F) => F,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let s, i = 0;
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function c(F, b) {
    const {
      bulletActiveClass: v
    } = e.params.pagination;
    F && (F = F[`${b === "prev" ? "previous" : "next"}ElementSibling`], F && (F.classList.add(`${v}-${b}`), F = F[`${b === "prev" ? "previous" : "next"}ElementSibling`], F && F.classList.add(`${v}-${b}-${b}`)));
  }
  function u(F, b, v) {
    if (F = F % v, b = b % v, b === F + 1)
      return "next";
    if (b === F - 1)
      return "previous";
  }
  function m(F) {
    const b = F.target.closest(er(e.params.pagination.bulletClass));
    if (!b)
      return;
    F.preventDefault();
    const v = $n(b) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === v) return;
      const k = u(e.realIndex, v, e.slides.length);
      k === "next" ? e.slideNext() : k === "previous" ? e.slidePrev() : e.slideToLoop(v);
    } else
      e.slideTo(v);
  }
  function y() {
    const F = e.rtl, b = e.params.pagination;
    if (l()) return;
    let v = e.pagination.el;
    v = he(v);
    let k, E;
    const S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, B = e.params.loop ? Math.ceil(S / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (E = e.previousRealIndex || 0, k = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (k = e.snapIndex, E = e.previousSnapIndex) : (E = e.previousIndex || 0, k = e.activeIndex || 0), b.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const D = e.pagination.bullets;
      let x, C, O;
      if (b.dynamicBullets && (s = mc(D[0], e.isHorizontal() ? "width" : "height"), v.forEach((T) => {
        T.style[e.isHorizontal() ? "width" : "height"] = `${s * (b.dynamicMainBullets + 4)}px`;
      }), b.dynamicMainBullets > 1 && E !== void 0 && (i += k - (E || 0), i > b.dynamicMainBullets - 1 ? i = b.dynamicMainBullets - 1 : i < 0 && (i = 0)), x = Math.max(k - i, 0), C = x + (Math.min(D.length, b.dynamicMainBullets) - 1), O = (C + x) / 2), D.forEach((T) => {
        const I = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((G) => `${b.bulletActiveClass}${G}`)].map((G) => typeof G == "string" && G.includes(" ") ? G.split(" ") : G).flat();
        T.classList.remove(...I);
      }), v.length > 1)
        D.forEach((T) => {
          const I = $n(T);
          I === k ? T.classList.add(...b.bulletActiveClass.split(" ")) : e.isElement && T.setAttribute("part", "bullet"), b.dynamicBullets && (I >= x && I <= C && T.classList.add(...`${b.bulletActiveClass}-main`.split(" ")), I === x && c(T, "prev"), I === C && c(T, "next"));
        });
      else {
        const T = D[k];
        if (T && T.classList.add(...b.bulletActiveClass.split(" ")), e.isElement && D.forEach((I, G) => {
          I.setAttribute("part", G === k ? "bullet-active" : "bullet");
        }), b.dynamicBullets) {
          const I = D[x], G = D[C];
          for (let U = x; U <= C; U += 1)
            D[U] && D[U].classList.add(...`${b.bulletActiveClass}-main`.split(" "));
          c(I, "prev"), c(G, "next");
        }
      }
      if (b.dynamicBullets) {
        const T = Math.min(D.length, b.dynamicMainBullets + 4), I = (s * T - s) / 2 - O * s, G = F ? "right" : "left";
        D.forEach((U) => {
          U.style[e.isHorizontal() ? G : "top"] = `${I}px`;
        });
      }
    }
    v.forEach((D, x) => {
      if (b.type === "fraction" && (D.querySelectorAll(er(b.currentClass)).forEach((C) => {
        C.textContent = b.formatFractionCurrent(k + 1);
      }), D.querySelectorAll(er(b.totalClass)).forEach((C) => {
        C.textContent = b.formatFractionTotal(B);
      })), b.type === "progressbar") {
        let C;
        b.progressbarOpposite ? C = e.isHorizontal() ? "vertical" : "horizontal" : C = e.isHorizontal() ? "horizontal" : "vertical";
        const O = (k + 1) / B;
        let T = 1, I = 1;
        C === "horizontal" ? T = O : I = O, D.querySelectorAll(er(b.progressbarFillClass)).forEach((G) => {
          G.style.transform = `translate3d(0,0,0) scaleX(${T}) scaleY(${I})`, G.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      b.type === "custom" && b.renderCustom ? (D.innerHTML = b.renderCustom(e, k + 1, B), x === 0 && n("paginationRender", D)) : (x === 0 && n("paginationRender", D), n("paginationUpdate", D)), e.params.watchOverflow && e.enabled && D.classList[e.isLocked ? "add" : "remove"](b.lockClass);
    });
  }
  function g() {
    const F = e.params.pagination;
    if (l()) return;
    const b = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let v = e.pagination.el;
    v = he(v);
    let k = "";
    if (F.type === "bullets") {
      let E = e.params.loop ? Math.ceil(b / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && E > b && (E = b);
      for (let S = 0; S < E; S += 1)
        F.renderBullet ? k += F.renderBullet.call(e, S, F.bulletClass) : k += `<${F.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${F.bulletClass}"></${F.bulletElement}>`;
    }
    F.type === "fraction" && (F.renderFraction ? k = F.renderFraction.call(e, F.currentClass, F.totalClass) : k = `<span class="${F.currentClass}"></span> / <span class="${F.totalClass}"></span>`), F.type === "progressbar" && (F.renderProgressbar ? k = F.renderProgressbar.call(e, F.progressbarFillClass) : k = `<span class="${F.progressbarFillClass}"></span>`), e.pagination.bullets = [], v.forEach((E) => {
      F.type !== "custom" && (E.innerHTML = k || ""), F.type === "bullets" && e.pagination.bullets.push(...E.querySelectorAll(er(F.bulletClass)));
    }), F.type !== "custom" && n("paginationRender", v[0]);
  }
  function p() {
    e.params.pagination = gu(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const F = e.params.pagination;
    if (!F.el) return;
    let b;
    typeof F.el == "string" && e.isElement && (b = e.el.querySelector(F.el)), !b && typeof F.el == "string" && (b = [...document.querySelectorAll(F.el)]), b || (b = F.el), !(!b || b.length === 0) && (e.params.uniqueNavElements && typeof F.el == "string" && Array.isArray(b) && b.length > 1 && (b = [...e.el.querySelectorAll(F.el)], b.length > 1 && (b = b.find((v) => Lr(v, ".swiper")[0] === e.el))), Array.isArray(b) && b.length === 1 && (b = b[0]), Object.assign(e.pagination, {
      el: b
    }), b = he(b), b.forEach((v) => {
      F.type === "bullets" && F.clickable && v.classList.add(...(F.clickableClass || "").split(" ")), v.classList.add(F.modifierClass + F.type), v.classList.add(e.isHorizontal() ? F.horizontalClass : F.verticalClass), F.type === "bullets" && F.dynamicBullets && (v.classList.add(`${F.modifierClass}${F.type}-dynamic`), i = 0, F.dynamicMainBullets < 1 && (F.dynamicMainBullets = 1)), F.type === "progressbar" && F.progressbarOpposite && v.classList.add(F.progressbarOppositeClass), F.clickable && v.addEventListener("click", m), e.enabled || v.classList.add(F.lockClass);
    }));
  }
  function d() {
    const F = e.params.pagination;
    if (l()) return;
    let b = e.pagination.el;
    b && (b = he(b), b.forEach((v) => {
      v.classList.remove(F.hiddenClass), v.classList.remove(F.modifierClass + F.type), v.classList.remove(e.isHorizontal() ? F.horizontalClass : F.verticalClass), F.clickable && (v.classList.remove(...(F.clickableClass || "").split(" ")), v.removeEventListener("click", m));
    })), e.pagination.bullets && e.pagination.bullets.forEach((v) => v.classList.remove(...F.bulletActiveClass.split(" ")));
  }
  t("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const F = e.params.pagination;
    let {
      el: b
    } = e.pagination;
    b = he(b), b.forEach((v) => {
      v.classList.remove(F.horizontalClass, F.verticalClass), v.classList.add(e.isHorizontal() ? F.horizontalClass : F.verticalClass);
    });
  }), t("init", () => {
    e.params.pagination.enabled === !1 ? f() : (p(), g(), y());
  }), t("activeIndexChange", () => {
    typeof e.snapIndex > "u" && y();
  }), t("snapIndexChange", () => {
    y();
  }), t("snapGridLengthChange", () => {
    g(), y();
  }), t("destroy", () => {
    d();
  }), t("enable disable", () => {
    let {
      el: F
    } = e.pagination;
    F && (F = he(F), F.forEach((b) => b.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), t("lock unlock", () => {
    y();
  }), t("click", (F, b) => {
    const v = b.target, k = he(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && k && k.length > 0 && !v.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && v === e.navigation.nextEl || e.navigation.prevEl && v === e.navigation.prevEl)) return;
      const E = k[0].classList.contains(e.params.pagination.hiddenClass);
      n(E === !0 ? "paginationShow" : "paginationHide"), k.forEach((S) => S.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const h = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: F
    } = e.pagination;
    F && (F = he(F), F.forEach((b) => b.classList.remove(e.params.pagination.paginationDisabledClass))), p(), g(), y();
  }, f = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: F
    } = e.pagination;
    F && (F = he(F), F.forEach((b) => b.classList.add(e.params.pagination.paginationDisabledClass))), d();
  };
  Object.assign(e.pagination, {
    enable: h,
    disable: f,
    render: g,
    update: y,
    init: p,
    destroy: d
  });
}
function G7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = qe();
  let s = !1, i = null, l = null, c, u, m, y;
  r({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function g() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: O,
      rtlTranslate: T
    } = e, {
      dragEl: I,
      el: G
    } = O, U = e.params.scrollbar, N = e.params.loop ? e.progressLoop : e.progress;
    let z = u, V = (m - u) * N;
    T ? (V = -V, V > 0 ? (z = u - V, V = 0) : -V + u > m && (z = m + V)) : V < 0 ? (z = u + V, V = 0) : V + u > m && (z = m - V), e.isHorizontal() ? (I.style.transform = `translate3d(${V}px, 0, 0)`, I.style.width = `${z}px`) : (I.style.transform = `translate3d(0px, ${V}px, 0)`, I.style.height = `${z}px`), U.hide && (clearTimeout(i), G.style.opacity = 1, i = setTimeout(() => {
      G.style.opacity = 0, G.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function p(O) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${O}ms`);
  }
  function d() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: O
    } = e, {
      dragEl: T,
      el: I
    } = O;
    T.style.width = "", T.style.height = "", m = e.isHorizontal() ? I.offsetWidth : I.offsetHeight, y = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? u = m * y : u = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? T.style.width = `${u}px` : T.style.height = `${u}px`, y >= 1 ? I.style.display = "none" : I.style.display = "", e.params.scrollbar.hide && (I.style.opacity = 0), e.params.watchOverflow && e.enabled && O.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function h(O) {
    return e.isHorizontal() ? O.clientX : O.clientY;
  }
  function f(O) {
    const {
      scrollbar: T,
      rtlTranslate: I
    } = e, {
      el: G
    } = T;
    let U;
    U = (h(O) - ks(G)[e.isHorizontal() ? "left" : "top"] - (c !== null ? c : u / 2)) / (m - u), U = Math.max(Math.min(U, 1), 0), I && (U = 1 - U);
    const N = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * U;
    e.updateProgress(N), e.setTranslate(N), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function F(O) {
    const T = e.params.scrollbar, {
      scrollbar: I,
      wrapperEl: G
    } = e, {
      el: U,
      dragEl: N
    } = I;
    s = !0, c = O.target === N ? h(O) - O.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, O.preventDefault(), O.stopPropagation(), G.style.transitionDuration = "100ms", N.style.transitionDuration = "100ms", f(O), clearTimeout(l), U.style.transitionDuration = "0ms", T.hide && (U.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", O);
  }
  function b(O) {
    const {
      scrollbar: T,
      wrapperEl: I
    } = e, {
      el: G,
      dragEl: U
    } = T;
    s && (O.preventDefault && O.cancelable ? O.preventDefault() : O.returnValue = !1, f(O), I.style.transitionDuration = "0ms", G.style.transitionDuration = "0ms", U.style.transitionDuration = "0ms", n("scrollbarDragMove", O));
  }
  function v(O) {
    const T = e.params.scrollbar, {
      scrollbar: I,
      wrapperEl: G
    } = e, {
      el: U
    } = I;
    s && (s = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", G.style.transitionDuration = ""), T.hide && (clearTimeout(l), l = Xr(() => {
      U.style.opacity = 0, U.style.transitionDuration = "400ms";
    }, 1e3)), n("scrollbarDragEnd", O), T.snapOnRelease && e.slideToClosest());
  }
  function k(O) {
    const {
      scrollbar: T,
      params: I
    } = e, G = T.el;
    if (!G) return;
    const U = G, N = I.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, z = I.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!U) return;
    const V = O === "on" ? "addEventListener" : "removeEventListener";
    U[V]("pointerdown", F, N), a[V]("pointermove", b, N), a[V]("pointerup", v, z);
  }
  function E() {
    !e.params.scrollbar.el || !e.scrollbar.el || k("on");
  }
  function S() {
    !e.params.scrollbar.el || !e.scrollbar.el || k("off");
  }
  function B() {
    const {
      scrollbar: O,
      el: T
    } = e;
    e.params.scrollbar = gu(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const I = e.params.scrollbar;
    if (!I.el) return;
    let G;
    if (typeof I.el == "string" && e.isElement && (G = e.el.querySelector(I.el)), !G && typeof I.el == "string") {
      if (G = a.querySelectorAll(I.el), !G.length) return;
    } else G || (G = I.el);
    e.params.uniqueNavElements && typeof I.el == "string" && G.length > 1 && T.querySelectorAll(I.el).length === 1 && (G = T.querySelector(I.el)), G.length > 0 && (G = G[0]), G.classList.add(e.isHorizontal() ? I.horizontalClass : I.verticalClass);
    let U;
    G && (U = G.querySelector(er(e.params.scrollbar.dragClass)), U || (U = Bo("div", e.params.scrollbar.dragClass), G.append(U))), Object.assign(O, {
      el: G,
      dragEl: U
    }), I.draggable && E(), G && G.classList[e.enabled ? "remove" : "add"](...Fr(e.params.scrollbar.lockClass));
  }
  function D() {
    const O = e.params.scrollbar, T = e.scrollbar.el;
    T && T.classList.remove(...Fr(e.isHorizontal() ? O.horizontalClass : O.verticalClass)), S();
  }
  t("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const O = e.params.scrollbar;
    let {
      el: T
    } = e.scrollbar;
    T = he(T), T.forEach((I) => {
      I.classList.remove(O.horizontalClass, O.verticalClass), I.classList.add(e.isHorizontal() ? O.horizontalClass : O.verticalClass);
    });
  }), t("init", () => {
    e.params.scrollbar.enabled === !1 ? C() : (B(), d(), g());
  }), t("update resize observerUpdate lock unlock changeDirection", () => {
    d();
  }), t("setTranslate", () => {
    g();
  }), t("setTransition", (O, T) => {
    p(T);
  }), t("enable disable", () => {
    const {
      el: O
    } = e.scrollbar;
    O && O.classList[e.enabled ? "remove" : "add"](...Fr(e.params.scrollbar.lockClass));
  }), t("destroy", () => {
    D();
  });
  const x = () => {
    e.el.classList.remove(...Fr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...Fr(e.params.scrollbar.scrollbarDisabledClass)), B(), d(), g();
  }, C = () => {
    e.el.classList.add(...Fr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...Fr(e.params.scrollbar.scrollbarDisabledClass)), D();
  };
  Object.assign(e.scrollbar, {
    enable: x,
    disable: C,
    updateSize: d,
    setTranslate: g,
    init: B,
    destroy: D
  });
}
function Z7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    parallax: {
      enabled: !1
    }
  });
  const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", a = (l, c) => {
    const {
      rtl: u
    } = e, m = u ? -1 : 1, y = l.getAttribute("data-swiper-parallax") || "0";
    let g = l.getAttribute("data-swiper-parallax-x"), p = l.getAttribute("data-swiper-parallax-y");
    const d = l.getAttribute("data-swiper-parallax-scale"), h = l.getAttribute("data-swiper-parallax-opacity"), f = l.getAttribute("data-swiper-parallax-rotate");
    if (g || p ? (g = g || "0", p = p || "0") : e.isHorizontal() ? (g = y, p = "0") : (p = y, g = "0"), g.indexOf("%") >= 0 ? g = `${parseInt(g, 10) * c * m}%` : g = `${g * c * m}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * c}%` : p = `${p * c}px`, typeof h < "u" && h !== null) {
      const b = h - (h - 1) * (1 - Math.abs(c));
      l.style.opacity = b;
    }
    let F = `translate3d(${g}, ${p}, 0px)`;
    if (typeof d < "u" && d !== null) {
      const b = d - (d - 1) * (1 - Math.abs(c));
      F += ` scale(${b})`;
    }
    if (f && typeof f < "u" && f !== null) {
      const b = f * c * -1;
      F += ` rotate(${b}deg)`;
    }
    l.style.transform = F;
  }, s = () => {
    const {
      el: l,
      slides: c,
      progress: u,
      snapGrid: m,
      isElement: y
    } = e, g = Ye(l, n);
    e.isElement && g.push(...Ye(e.hostEl, n)), g.forEach((p) => {
      a(p, u);
    }), c.forEach((p, d) => {
      let h = p.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (h += Math.ceil(d / 2) - u * (m.length - 1)), h = Math.min(Math.max(h, -1), 1), p.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((f) => {
        a(f, h);
      });
    });
  }, i = function(l) {
    l === void 0 && (l = e.params.speed);
    const {
      el: c,
      hostEl: u
    } = e, m = [...c.querySelectorAll(n)];
    e.isElement && m.push(...u.querySelectorAll(n)), m.forEach((y) => {
      let g = parseInt(y.getAttribute("data-swiper-parallax-duration"), 10) || l;
      l === 0 && (g = 0), y.style.transitionDuration = `${g}ms`;
    });
  };
  t("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), t("init", () => {
    e.params.parallax.enabled && s();
  }), t("setTranslate", () => {
    e.params.parallax.enabled && s();
  }), t("setTransition", (l, c) => {
    e.params.parallax.enabled && i(c);
  });
}
function X7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = ze();
  r({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let s = 1, i = !1, l = !1, c = {
    x: 0,
    y: 0
  };
  const u = -3;
  let m, y;
  const g = [], p = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, d = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, h = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let f = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return f;
    },
    set(X) {
      if (f !== X) {
        const q = p.imageEl, J = p.slideEl;
        n("zoomChange", X, q, J);
      }
      f = X;
    }
  });
  function F() {
    if (g.length < 2) return 1;
    const X = g[0].pageX, q = g[0].pageY, J = g[1].pageX, ee = g[1].pageY;
    return Math.sqrt((J - X) ** 2 + (ee - q) ** 2);
  }
  function b() {
    const X = e.params.zoom, q = p.imageWrapEl.getAttribute("data-swiper-zoom") || X.maxRatio;
    if (X.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
      const J = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
      return Math.min(J, q);
    }
    return q;
  }
  function v() {
    if (g.length < 2) return {
      x: null,
      y: null
    };
    const X = p.imageEl.getBoundingClientRect();
    return [(g[0].pageX + (g[1].pageX - g[0].pageX) / 2 - X.x - a.scrollX) / s, (g[0].pageY + (g[1].pageY - g[0].pageY) / 2 - X.y - a.scrollY) / s];
  }
  function k() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function E(X) {
    const q = k();
    return !!(X.target.matches(q) || e.slides.filter((J) => J.contains(X.target)).length > 0);
  }
  function S(X) {
    const q = `.${e.params.zoom.containerClass}`;
    return !!(X.target.matches(q) || [...e.hostEl.querySelectorAll(q)].filter((J) => J.contains(X.target)).length > 0);
  }
  function B(X) {
    if (X.pointerType === "mouse" && g.splice(0, g.length), !E(X)) return;
    const q = e.params.zoom;
    if (m = !1, y = !1, g.push(X), !(g.length < 2)) {
      if (m = !0, p.scaleStart = F(), !p.slideEl) {
        p.slideEl = X.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
        let J = p.slideEl.querySelector(`.${q.containerClass}`);
        if (J && (J = J.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = J, J ? p.imageWrapEl = Lr(p.imageEl, `.${q.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
          p.imageEl = void 0;
          return;
        }
        p.maxRatio = b();
      }
      if (p.imageEl) {
        const [J, ee] = v();
        p.originX = J, p.originY = ee, p.imageEl.style.transitionDuration = "0ms";
      }
      i = !0;
    }
  }
  function D(X) {
    if (!E(X)) return;
    const q = e.params.zoom, J = e.zoom, ee = g.findIndex((me) => me.pointerId === X.pointerId);
    ee >= 0 && (g[ee] = X), !(g.length < 2) && (y = !0, p.scaleMove = F(), p.imageEl && (J.scale = p.scaleMove / p.scaleStart * s, J.scale > p.maxRatio && (J.scale = p.maxRatio - 1 + (J.scale - p.maxRatio + 1) ** 0.5), J.scale < q.minRatio && (J.scale = q.minRatio + 1 - (q.minRatio - J.scale + 1) ** 0.5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${J.scale})`));
  }
  function x(X) {
    if (!E(X) || X.pointerType === "mouse" && X.type === "pointerout") return;
    const q = e.params.zoom, J = e.zoom, ee = g.findIndex((me) => me.pointerId === X.pointerId);
    ee >= 0 && g.splice(ee, 1), !(!m || !y) && (m = !1, y = !1, p.imageEl && (J.scale = Math.max(Math.min(J.scale, p.maxRatio), q.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${J.scale})`, s = J.scale, i = !1, J.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${q.zoomedSlideClass}`) : J.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${q.zoomedSlideClass}`), J.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
  }
  let C;
  function O() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function T() {
    clearTimeout(C), e.touchEventsData.preventTouchMoveFromPointerMove = !0, C = setTimeout(() => {
      e.destroyed || O();
    });
  }
  function I(X) {
    const q = e.device;
    if (!p.imageEl || d.isTouched) return;
    q.android && X.cancelable && X.preventDefault(), d.isTouched = !0;
    const J = g.length > 0 ? g[0] : X;
    d.touchesStart.x = J.pageX, d.touchesStart.y = J.pageY;
  }
  function G(X) {
    const J = X.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!E(X) || !S(X))
      return;
    const ee = e.zoom;
    if (!p.imageEl)
      return;
    if (!d.isTouched || !p.slideEl) {
      J && z(X);
      return;
    }
    if (J) {
      z(X);
      return;
    }
    d.isMoved || (d.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, d.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, d.startX = gc(p.imageWrapEl, "x") || 0, d.startY = gc(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
    const me = d.width * ee.scale, Se = d.height * ee.scale;
    if (d.minX = Math.min(p.slideWidth / 2 - me / 2, 0), d.maxX = -d.minX, d.minY = Math.min(p.slideHeight / 2 - Se / 2, 0), d.maxY = -d.minY, d.touchesCurrent.x = g.length > 0 ? g[0].pageX : X.pageX, d.touchesCurrent.y = g.length > 0 ? g[0].pageY : X.pageY, Math.max(Math.abs(d.touchesCurrent.x - d.touchesStart.x), Math.abs(d.touchesCurrent.y - d.touchesStart.y)) > 5 && (e.allowClick = !1), !d.isMoved && !i) {
      if (e.isHorizontal() && (Math.floor(d.minX) === Math.floor(d.startX) && d.touchesCurrent.x < d.touchesStart.x || Math.floor(d.maxX) === Math.floor(d.startX) && d.touchesCurrent.x > d.touchesStart.x)) {
        d.isTouched = !1, O();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(d.minY) === Math.floor(d.startY) && d.touchesCurrent.y < d.touchesStart.y || Math.floor(d.maxY) === Math.floor(d.startY) && d.touchesCurrent.y > d.touchesStart.y)) {
        d.isTouched = !1, O();
        return;
      }
    }
    X.cancelable && X.preventDefault(), X.stopPropagation(), T(), d.isMoved = !0;
    const no = (ee.scale - s) / (p.maxRatio - e.params.zoom.minRatio), {
      originX: Lo,
      originY: Ge
    } = p;
    d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX + no * (d.width - Lo * 2), d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY + no * (d.height - Ge * 2), d.currentX < d.minX && (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** 0.8), d.currentX > d.maxX && (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** 0.8), d.currentY < d.minY && (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** 0.8), d.currentY > d.maxY && (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** 0.8), h.prevPositionX || (h.prevPositionX = d.touchesCurrent.x), h.prevPositionY || (h.prevPositionY = d.touchesCurrent.y), h.prevTime || (h.prevTime = Date.now()), h.x = (d.touchesCurrent.x - h.prevPositionX) / (Date.now() - h.prevTime) / 2, h.y = (d.touchesCurrent.y - h.prevPositionY) / (Date.now() - h.prevTime) / 2, Math.abs(d.touchesCurrent.x - h.prevPositionX) < 2 && (h.x = 0), Math.abs(d.touchesCurrent.y - h.prevPositionY) < 2 && (h.y = 0), h.prevPositionX = d.touchesCurrent.x, h.prevPositionY = d.touchesCurrent.y, h.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function U() {
    const X = e.zoom;
    if (g.length = 0, !p.imageEl) return;
    if (!d.isTouched || !d.isMoved) {
      d.isTouched = !1, d.isMoved = !1;
      return;
    }
    d.isTouched = !1, d.isMoved = !1;
    let q = 300, J = 300;
    const ee = h.x * q, me = d.currentX + ee, Se = h.y * J, Ee = d.currentY + Se;
    h.x !== 0 && (q = Math.abs((me - d.currentX) / h.x)), h.y !== 0 && (J = Math.abs((Ee - d.currentY) / h.y));
    const no = Math.max(q, J);
    d.currentX = me, d.currentY = Ee;
    const Lo = d.width * X.scale, Ge = d.height * X.scale;
    d.minX = Math.min(p.slideWidth / 2 - Lo / 2, 0), d.maxX = -d.minX, d.minY = Math.min(p.slideHeight / 2 - Ge / 2, 0), d.maxY = -d.minY, d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX), d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY), p.imageWrapEl.style.transitionDuration = `${no}ms`, p.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function N() {
    const X = e.zoom;
    p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), X.scale = 1, s = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
  }
  function z(X) {
    if (s <= 1 || !p.imageWrapEl || !E(X) || !S(X)) return;
    const q = a.getComputedStyle(p.imageWrapEl).transform, J = new a.DOMMatrix(q);
    if (!l) {
      l = !0, c.x = X.clientX, c.y = X.clientY, d.startX = J.e, d.startY = J.f, d.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, d.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
      return;
    }
    const ee = (X.clientX - c.x) * u, me = (X.clientY - c.y) * u, Se = d.width * s, Ee = d.height * s, no = p.slideWidth, Lo = p.slideHeight, Ge = Math.min(no / 2 - Se / 2, 0), Je = -Ge, Er = Math.min(Lo / 2 - Ee / 2, 0), Pa = -Er, et = Math.max(Math.min(d.startX + ee, Je), Ge), ot = Math.max(Math.min(d.startY + me, Pa), Er);
    p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${et}px, ${ot}px, 0)`, c.x = X.clientX, c.y = X.clientY, d.startX = et, d.startY = ot, d.currentX = et, d.currentY = ot;
  }
  function V(X) {
    const q = e.zoom, J = e.params.zoom;
    if (!p.slideEl) {
      X && X.target && (p.slideEl = X.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ye(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
      let Mt = p.slideEl.querySelector(`.${J.containerClass}`);
      Mt && (Mt = Mt.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Mt, Mt ? p.imageWrapEl = Lr(p.imageEl, `.${J.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    if (!p.imageEl || !p.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${J.zoomedSlideClass}`);
    let ee, me, Se, Ee, no, Lo, Ge, Je, Er, Pa, et, ot, Ba, ka, ni, ai, si, ii;
    typeof d.touchesStart.x > "u" && X ? (ee = X.pageX, me = X.pageY) : (ee = d.touchesStart.x, me = d.touchesStart.y);
    const li = s, rt = typeof X == "number" ? X : null;
    s === 1 && rt && (ee = void 0, me = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0);
    const Mu = b();
    q.scale = rt || Mu, s = rt || Mu, X && !(s === 1 && rt) ? (si = p.slideEl.offsetWidth, ii = p.slideEl.offsetHeight, Se = ks(p.slideEl).left + a.scrollX, Ee = ks(p.slideEl).top + a.scrollY, no = Se + si / 2 - ee, Lo = Ee + ii / 2 - me, Er = p.imageEl.offsetWidth || p.imageEl.clientWidth, Pa = p.imageEl.offsetHeight || p.imageEl.clientHeight, et = Er * q.scale, ot = Pa * q.scale, Ba = Math.min(si / 2 - et / 2, 0), ka = Math.min(ii / 2 - ot / 2, 0), ni = -Ba, ai = -ka, li > 0 && rt && typeof d.currentX == "number" && typeof d.currentY == "number" ? (Ge = d.currentX * q.scale / li, Je = d.currentY * q.scale / li) : (Ge = no * q.scale, Je = Lo * q.scale), Ge < Ba && (Ge = Ba), Ge > ni && (Ge = ni), Je < ka && (Je = ka), Je > ai && (Je = ai)) : (Ge = 0, Je = 0), rt && q.scale === 1 && (p.originX = 0, p.originY = 0), d.currentX = Ge, d.currentY = Je, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${Ge}px, ${Je}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${q.scale})`;
  }
  function Y() {
    const X = e.zoom, q = e.params.zoom;
    if (!p.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ye(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
      let J = p.slideEl.querySelector(`.${q.containerClass}`);
      J && (J = J.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = J, J ? p.imageWrapEl = Lr(p.imageEl, `.${q.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    !p.imageEl || !p.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), X.scale = 1, s = 1, d.currentX = void 0, d.currentY = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${q.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (c = {
      x: 0,
      y: 0
    }, l && (l = !1, d.startX = 0, d.startY = 0)));
  }
  function K(X) {
    const q = e.zoom;
    q.scale && q.scale !== 1 ? Y() : V(X);
  }
  function $() {
    const X = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, q = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: X,
      activeListenerWithCapture: q
    };
  }
  function te() {
    const X = e.zoom;
    if (X.enabled) return;
    X.enabled = !0;
    const {
      passiveListener: q,
      activeListenerWithCapture: J
    } = $();
    e.wrapperEl.addEventListener("pointerdown", B, q), e.wrapperEl.addEventListener("pointermove", D, J), ["pointerup", "pointercancel", "pointerout"].forEach((ee) => {
      e.wrapperEl.addEventListener(ee, x, q);
    }), e.wrapperEl.addEventListener("pointermove", G, J);
  }
  function ge() {
    const X = e.zoom;
    if (!X.enabled) return;
    X.enabled = !1;
    const {
      passiveListener: q,
      activeListenerWithCapture: J
    } = $();
    e.wrapperEl.removeEventListener("pointerdown", B, q), e.wrapperEl.removeEventListener("pointermove", D, J), ["pointerup", "pointercancel", "pointerout"].forEach((ee) => {
      e.wrapperEl.removeEventListener(ee, x, q);
    }), e.wrapperEl.removeEventListener("pointermove", G, J);
  }
  t("init", () => {
    e.params.zoom.enabled && te();
  }), t("destroy", () => {
    ge();
  }), t("touchStart", (X, q) => {
    e.zoom.enabled && I(q);
  }), t("touchEnd", (X, q) => {
    e.zoom.enabled && U();
  }), t("doubleTap", (X, q) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && K(q);
  }), t("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && N();
  }), t("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && N();
  }), Object.assign(e.zoom, {
    enable: te,
    disable: ge,
    in: V,
    out: Y,
    toggle: K
  });
}
function q7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function n(c, u) {
    const m = /* @__PURE__ */ function() {
      let d, h, f;
      return (F, b) => {
        for (h = -1, d = F.length; d - h > 1; )
          f = d + h >> 1, F[f] <= b ? h = f : d = f;
        return d;
      };
    }();
    this.x = c, this.y = u, this.lastIndex = c.length - 1;
    let y, g;
    return this.interpolate = function(d) {
      return d ? (g = m(this.x, d), y = g - 1, (d - this.x[y]) * (this.y[g] - this.y[y]) / (this.x[g] - this.x[y]) + this.y[y]) : 0;
    }, this;
  }
  function a(c) {
    e.controller.spline = e.params.loop ? new n(e.slidesGrid, c.slidesGrid) : new n(e.snapGrid, c.snapGrid);
  }
  function s(c, u) {
    const m = e.controller.control;
    let y, g;
    const p = e.constructor;
    function d(h) {
      if (h.destroyed) return;
      const f = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (a(h), g = -e.controller.spline.interpolate(-f)), (!g || e.params.controller.by === "container") && (y = (h.maxTranslate() - h.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(y) || !Number.isFinite(y)) && (y = 1), g = (f - e.minTranslate()) * y + h.minTranslate()), e.params.controller.inverse && (g = h.maxTranslate() - g), h.updateProgress(g), h.setTranslate(g, e), h.updateActiveIndex(), h.updateSlidesClasses();
    }
    if (Array.isArray(m))
      for (let h = 0; h < m.length; h += 1)
        m[h] !== u && m[h] instanceof p && d(m[h]);
    else m instanceof p && u !== m && d(m);
  }
  function i(c, u) {
    const m = e.constructor, y = e.controller.control;
    let g;
    function p(d) {
      d.destroyed || (d.setTransition(c, e), c !== 0 && (d.transitionStart(), d.params.autoHeight && Xr(() => {
        d.updateAutoHeight();
      }), en(d.wrapperEl, () => {
        y && d.transitionEnd();
      })));
    }
    if (Array.isArray(y))
      for (g = 0; g < y.length; g += 1)
        y[g] !== u && y[g] instanceof m && p(y[g]);
    else y instanceof m && u !== y && p(y);
  }
  function l() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  t("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((u) => {
        if (e.controller.control || (e.controller.control = []), u && u.swiper)
          e.controller.control.push(u.swiper);
        else if (u) {
          const m = `${e.params.eventsPrefix}init`, y = (g) => {
            e.controller.control.push(g.detail[0]), e.update(), u.removeEventListener(m, y);
          };
          u.addEventListener(m, y);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), t("update", () => {
    l();
  }), t("resize", () => {
    l();
  }), t("observerUpdate", () => {
    l();
  }), t("setTranslate", (c, u, m) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(u, m);
  }), t("setTransition", (c, u, m) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(u, m);
  }), Object.assign(e.controller, {
    setTranslate: s,
    setTransition: i
  });
}
function U7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let n = null, a, s, i = (/* @__PURE__ */ new Date()).getTime();
  function l(N) {
    const z = n;
    z.length !== 0 && (z.innerHTML = "", z.innerHTML = N);
  }
  function c(N) {
    const z = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(N).replace(/x/g, z);
  }
  function u(N) {
    N = he(N), N.forEach((z) => {
      z.setAttribute("tabIndex", "0");
    });
  }
  function m(N) {
    N = he(N), N.forEach((z) => {
      z.setAttribute("tabIndex", "-1");
    });
  }
  function y(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("role", z);
    });
  }
  function g(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("aria-roledescription", z);
    });
  }
  function p(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("aria-controls", z);
    });
  }
  function d(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("aria-label", z);
    });
  }
  function h(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("id", z);
    });
  }
  function f(N, z) {
    N = he(N), N.forEach((V) => {
      V.setAttribute("aria-live", z);
    });
  }
  function F(N) {
    N = he(N), N.forEach((z) => {
      z.setAttribute("aria-disabled", !0);
    });
  }
  function b(N) {
    N = he(N), N.forEach((z) => {
      z.setAttribute("aria-disabled", !1);
    });
  }
  function v(N) {
    if (N.keyCode !== 13 && N.keyCode !== 32) return;
    const z = e.params.a11y, V = N.target;
    if (!(e.pagination && e.pagination.el && (V === e.pagination.el || e.pagination.el.contains(N.target)) && !N.target.matches(er(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const Y = he(e.navigation.prevEl);
        he(e.navigation.nextEl).includes(V) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? l(z.lastSlideMessage) : l(z.nextSlideMessage)), Y.includes(V) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? l(z.firstSlideMessage) : l(z.prevSlideMessage));
      }
      e.pagination && V.matches(er(e.params.pagination.bulletClass)) && V.click();
    }
  }
  function k() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: N,
      prevEl: z
    } = e.navigation;
    z && (e.isBeginning ? (F(z), m(z)) : (b(z), u(z))), N && (e.isEnd ? (F(N), m(N)) : (b(N), u(N)));
  }
  function E() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function S() {
    return E() && e.params.pagination.clickable;
  }
  function B() {
    const N = e.params.a11y;
    E() && e.pagination.bullets.forEach((z) => {
      e.params.pagination.clickable && (u(z), e.params.pagination.renderBullet || (y(z, "button"), d(z, N.paginationBulletMessage.replace(/\{\{index\}\}/, $n(z) + 1)))), z.matches(er(e.params.pagination.bulletActiveClass)) ? z.setAttribute("aria-current", "true") : z.removeAttribute("aria-current");
    });
  }
  const D = (N, z, V) => {
    u(N), N.tagName !== "BUTTON" && (y(N, "button"), N.addEventListener("keydown", v)), d(N, V), p(N, z);
  }, x = (N) => {
    s && s !== N.target && !s.contains(N.target) && (a = !0), e.a11y.clicked = !0;
  }, C = () => {
    a = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, O = (N) => {
    i = (/* @__PURE__ */ new Date()).getTime();
  }, T = (N) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - i < 100) return;
    const z = N.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!z || !e.slides.includes(z)) return;
    s = z;
    const V = e.slides.indexOf(z) === e.activeIndex, Y = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(z);
    V || Y || N.sourceCapabilities && N.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      a || (e.params.loop ? e.slideToLoop(parseInt(z.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(z), 0), a = !1);
    }));
  }, I = () => {
    const N = e.params.a11y;
    N.itemRoleDescriptionMessage && g(e.slides, N.itemRoleDescriptionMessage), N.slideRole && y(e.slides, N.slideRole);
    const z = e.slides.length;
    N.slideLabelMessage && e.slides.forEach((V, Y) => {
      const K = e.params.loop ? parseInt(V.getAttribute("data-swiper-slide-index"), 10) : Y, $ = N.slideLabelMessage.replace(/\{\{index\}\}/, K + 1).replace(/\{\{slidesLength\}\}/, z);
      d(V, $);
    });
  }, G = () => {
    const N = e.params.a11y;
    e.el.append(n);
    const z = e.el;
    N.containerRoleDescriptionMessage && g(z, N.containerRoleDescriptionMessage), N.containerMessage && d(z, N.containerMessage), N.containerRole && y(z, N.containerRole);
    const V = e.wrapperEl, Y = N.id || V.getAttribute("id") || `swiper-wrapper-${c(16)}`, K = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    h(V, Y), f(V, K), I();
    let {
      nextEl: $,
      prevEl: te
    } = e.navigation ? e.navigation : {};
    $ = he($), te = he(te), $ && $.forEach((X) => D(X, Y, N.nextSlideMessage)), te && te.forEach((X) => D(X, Y, N.prevSlideMessage)), S() && he(e.pagination.el).forEach((q) => {
      q.addEventListener("keydown", v);
    }), qe().addEventListener("visibilitychange", O), e.el.addEventListener("focus", T, !0), e.el.addEventListener("focus", T, !0), e.el.addEventListener("pointerdown", x, !0), e.el.addEventListener("pointerup", C, !0);
  };
  function U() {
    n && n.remove();
    let {
      nextEl: N,
      prevEl: z
    } = e.navigation ? e.navigation : {};
    N = he(N), z = he(z), N && N.forEach((Y) => Y.removeEventListener("keydown", v)), z && z.forEach((Y) => Y.removeEventListener("keydown", v)), S() && he(e.pagination.el).forEach((K) => {
      K.removeEventListener("keydown", v);
    }), qe().removeEventListener("visibilitychange", O), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", T, !0), e.el.removeEventListener("pointerdown", x, !0), e.el.removeEventListener("pointerup", C, !0));
  }
  t("beforeInit", () => {
    n = Bo("span", e.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
  }), t("afterInit", () => {
    e.params.a11y.enabled && G();
  }), t("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && I();
  }), t("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && k();
  }), t("paginationUpdate", () => {
    e.params.a11y.enabled && B();
  }), t("destroy", () => {
    e.params.a11y.enabled && U();
  });
}
function Y7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let n = !1, a = {};
  const s = (g) => g.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), i = (g) => {
    const p = ze();
    let d;
    g ? d = new URL(g) : d = p.location;
    const h = d.pathname.slice(1).split("/").filter((v) => v !== ""), f = h.length, F = h[f - 2], b = h[f - 1];
    return {
      key: F,
      value: b
    };
  }, l = (g, p) => {
    const d = ze();
    if (!n || !e.params.history.enabled) return;
    let h;
    e.params.url ? h = new URL(e.params.url) : h = d.location;
    const f = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : e.slides[p];
    let F = s(f.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let v = e.params.history.root;
      v[v.length - 1] === "/" && (v = v.slice(0, v.length - 1)), F = `${v}/${g ? `${g}/` : ""}${F}`;
    } else h.pathname.includes(g) || (F = `${g ? `${g}/` : ""}${F}`);
    e.params.history.keepQuery && (F += h.search);
    const b = d.history.state;
    b && b.value === F || (e.params.history.replaceState ? d.history.replaceState({
      value: F
    }, null, F) : d.history.pushState({
      value: F
    }, null, F));
  }, c = (g, p, d) => {
    if (p)
      for (let h = 0, f = e.slides.length; h < f; h += 1) {
        const F = e.slides[h];
        if (s(F.getAttribute("data-history")) === p) {
          const v = e.getSlideIndex(F);
          e.slideTo(v, g, d);
        }
      }
    else
      e.slideTo(0, g, d);
  }, u = () => {
    a = i(e.params.url), c(e.params.speed, a.value, !1);
  }, m = () => {
    const g = ze();
    if (e.params.history) {
      if (!g.history || !g.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (n = !0, a = i(e.params.url), !a.key && !a.value) {
        e.params.history.replaceState || g.addEventListener("popstate", u);
        return;
      }
      c(0, a.value, e.params.runCallbacksOnInit), e.params.history.replaceState || g.addEventListener("popstate", u);
    }
  }, y = () => {
    const g = ze();
    e.params.history.replaceState || g.removeEventListener("popstate", u);
  };
  t("init", () => {
    e.params.history.enabled && m();
  }), t("destroy", () => {
    e.params.history.enabled && y();
  }), t("transitionEnd _freeModeNoMomentumRelease", () => {
    n && l(e.params.history.key, e.activeIndex);
  }), t("slideChange", () => {
    n && e.params.cssMode && l(e.params.history.key, e.activeIndex);
  });
}
function J7(o) {
  let {
    swiper: e,
    extendParams: r,
    emit: t,
    on: n
  } = o, a = !1;
  const s = qe(), i = ze();
  r({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(y, g) {
        if (e.virtual && e.params.virtual.enabled) {
          const p = e.slides.find((h) => h.getAttribute("data-hash") === g);
          return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(Ye(e.slidesEl, `.${e.params.slideClass}[data-hash="${g}"], swiper-slide[data-hash="${g}"]`)[0]);
      }
    }
  });
  const l = () => {
    t("hashChange");
    const y = s.location.hash.replace("#", ""), g = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = g ? g.getAttribute("data-hash") : "";
    if (y !== p) {
      const d = e.params.hashNavigation.getSlideIndex(e, y);
      if (typeof d > "u" || Number.isNaN(d)) return;
      e.slideTo(d);
    }
  }, c = () => {
    if (!a || !e.params.hashNavigation.enabled) return;
    const y = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], g = y ? y.getAttribute("data-hash") || y.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && i.history && i.history.replaceState ? (i.history.replaceState(null, null, `#${g}` || ""), t("hashSet")) : (s.location.hash = g || "", t("hashSet"));
  }, u = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    a = !0;
    const y = s.location.hash.replace("#", "");
    if (y) {
      const p = e.params.hashNavigation.getSlideIndex(e, y);
      e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && i.addEventListener("hashchange", l);
  }, m = () => {
    e.params.hashNavigation.watchState && i.removeEventListener("hashchange", l);
  };
  n("init", () => {
    e.params.hashNavigation.enabled && u();
  }), n("destroy", () => {
    e.params.hashNavigation.enabled && m();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    a && c();
  }), n("slideChange", () => {
    a && e.params.cssMode && c();
  });
}
function Q7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n,
    params: a
  } = o;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s, i, l = a && a.autoplay ? a.autoplay.delay : 3e3, c = a && a.autoplay ? a.autoplay.delay : 3e3, u, m = (/* @__PURE__ */ new Date()).getTime(), y, g, p, d, h, f, F;
  function b(z) {
    !e || e.destroyed || !e.wrapperEl || z.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", b), !(F || z.detail && z.detail.bySwiperTouchMove) && x());
  }
  const v = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? y = !0 : y && (c = u, y = !1);
    const z = e.autoplay.paused ? u : m + c - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = z, n("autoplayTimeLeft", z, z / l), i = requestAnimationFrame(() => {
      v();
    });
  }, k = () => {
    let z;
    return e.virtual && e.params.virtual.enabled ? z = e.slides.find((Y) => Y.classList.contains("swiper-slide-active")) : z = e.slides[e.activeIndex], z ? parseInt(z.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, E = (z) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(i), v();
    let V = typeof z > "u" ? e.params.autoplay.delay : z;
    l = e.params.autoplay.delay, c = e.params.autoplay.delay;
    const Y = k();
    !Number.isNaN(Y) && Y > 0 && typeof z > "u" && (V = Y, l = Y, c = Y), u = V;
    const K = e.params.speed, $ = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(K, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, K, !0, !0), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(K, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, K, !0, !0), n("autoplay")), e.params.cssMode && (m = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        E();
      })));
    };
    return V > 0 ? (clearTimeout(s), s = setTimeout(() => {
      $();
    }, V)) : requestAnimationFrame(() => {
      $();
    }), V;
  }, S = () => {
    m = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, E(), n("autoplayStart");
  }, B = () => {
    e.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(i), n("autoplayStop");
  }, D = (z, V) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(s), z || (f = !0);
    const Y = () => {
      n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", b) : x();
    };
    if (e.autoplay.paused = !0, V) {
      h && (u = e.params.autoplay.delay), h = !1, Y();
      return;
    }
    u = (u || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - m), !(e.isEnd && u < 0 && !e.params.loop) && (u < 0 && (u = 0), Y());
  }, x = () => {
    e.isEnd && u < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (m = (/* @__PURE__ */ new Date()).getTime(), f ? (f = !1, E(u)) : E(), e.autoplay.paused = !1, n("autoplayResume"));
  }, C = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const z = qe();
    z.visibilityState === "hidden" && (f = !0, D(!0)), z.visibilityState === "visible" && x();
  }, O = (z) => {
    z.pointerType === "mouse" && (f = !0, F = !0, !(e.animating || e.autoplay.paused) && D(!0));
  }, T = (z) => {
    z.pointerType === "mouse" && (F = !1, e.autoplay.paused && x());
  }, I = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", O), e.el.addEventListener("pointerleave", T));
  }, G = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", O), e.el.removeEventListener("pointerleave", T));
  }, U = () => {
    qe().addEventListener("visibilitychange", C);
  }, N = () => {
    qe().removeEventListener("visibilitychange", C);
  };
  t("init", () => {
    e.params.autoplay.enabled && (I(), U(), S());
  }), t("destroy", () => {
    G(), N(), e.autoplay.running && B();
  }), t("_freeModeStaticRelease", () => {
    (p || f) && x();
  }), t("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? B() : D(!0, !0);
  }), t("beforeTransitionStart", (z, V, Y) => {
    e.destroyed || !e.autoplay.running || (Y || !e.params.autoplay.disableOnInteraction ? D(!0, !0) : B());
  }), t("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        B();
        return;
      }
      g = !0, p = !1, f = !1, d = setTimeout(() => {
        f = !0, p = !0, D(!0);
      }, 200);
    }
  }), t("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !g)) {
      if (clearTimeout(d), clearTimeout(s), e.params.autoplay.disableOnInteraction) {
        p = !1, g = !1;
        return;
      }
      p && e.params.cssMode && x(), p = !1, g = !1;
    }
  }), t("slideChange", () => {
    e.destroyed || !e.autoplay.running || (h = !0);
  }), Object.assign(e.autoplay, {
    start: S,
    stop: B,
    pause: D,
    resume: x
  });
}
function K7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let n = !1, a = !1;
  e.thumbs = {
    swiper: null
  };
  function s() {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const u = c.clickedIndex, m = c.clickedSlide;
    if (m && m.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null) return;
    let y;
    c.params.loop ? y = parseInt(c.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : y = u, e.params.loop ? e.slideToLoop(y) : e.slideTo(y);
  }
  function i() {
    const {
      thumbs: c
    } = e.params;
    if (n) return !1;
    n = !0;
    const u = e.constructor;
    if (c.swiper instanceof u) {
      if (c.swiper.destroyed)
        return n = !1, !1;
      e.thumbs.swiper = c.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    } else if (qt(c.swiper)) {
      const m = Object.assign({}, c.swiper);
      Object.assign(m, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new u(m), a = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0;
  }
  function l(c) {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed) return;
    const m = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let y = 1;
    const g = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (y = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (y = 1), y = Math.floor(y), u.slides.forEach((h) => h.classList.remove(g)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let h = 0; h < y; h += 1)
        Ye(u.slidesEl, `[data-swiper-slide-index="${e.realIndex + h}"]`).forEach((f) => {
          f.classList.add(g);
        });
    else
      for (let h = 0; h < y; h += 1)
        u.slides[e.realIndex + h] && u.slides[e.realIndex + h].classList.add(g);
    const p = e.params.thumbs.autoScrollOffset, d = p && !u.params.loop;
    if (e.realIndex !== u.realIndex || d) {
      const h = u.activeIndex;
      let f, F;
      if (u.params.loop) {
        const b = u.slides.find((v) => v.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
        f = u.slides.indexOf(b), F = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        f = e.realIndex, F = f > e.previousIndex ? "next" : "prev";
      d && (f += F === "next" ? p : -1 * p), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(f) < 0 && (u.params.centeredSlides ? f > h ? f = f - Math.floor(m / 2) + 1 : f = f + Math.floor(m / 2) - 1 : f > h && u.params.slidesPerGroup, u.slideTo(f, c ? 0 : void 0));
    }
  }
  t("beforeInit", () => {
    const {
      thumbs: c
    } = e.params;
    if (!(!c || !c.swiper))
      if (typeof c.swiper == "string" || c.swiper instanceof HTMLElement) {
        const u = qe(), m = () => {
          const g = typeof c.swiper == "string" ? u.querySelector(c.swiper) : c.swiper;
          if (g && g.swiper)
            c.swiper = g.swiper, i(), l(!0);
          else if (g) {
            const p = `${e.params.eventsPrefix}init`, d = (h) => {
              c.swiper = h.detail[0], g.removeEventListener(p, d), i(), l(!0), c.swiper.update(), e.update();
            };
            g.addEventListener(p, d);
          }
          return g;
        }, y = () => {
          if (e.destroyed) return;
          m() || requestAnimationFrame(y);
        };
        requestAnimationFrame(y);
      } else
        i(), l(!0);
  }), t("slideChange update resize observerUpdate", () => {
    l();
  }), t("setTransition", (c, u) => {
    const m = e.thumbs.swiper;
    !m || m.destroyed || m.setTransition(u);
  }), t("beforeDestroy", () => {
    const c = e.thumbs.swiper;
    !c || c.destroyed || a && c.destroy();
  }), Object.assign(e.thumbs, {
    init: i,
    update: l
  });
}
function _7(o) {
  let {
    swiper: e,
    extendParams: r,
    emit: t,
    once: n
  } = o;
  r({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function a() {
    if (e.params.cssMode) return;
    const l = e.getTranslate();
    e.setTranslate(l), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function s() {
    if (e.params.cssMode) return;
    const {
      touchEventsData: l,
      touches: c
    } = e;
    l.velocities.length === 0 && l.velocities.push({
      position: c[e.isHorizontal() ? "startX" : "startY"],
      time: l.touchStartTime
    }), l.velocities.push({
      position: c[e.isHorizontal() ? "currentX" : "currentY"],
      time: xo()
    });
  }
  function i(l) {
    let {
      currentPos: c
    } = l;
    if (e.params.cssMode) return;
    const {
      params: u,
      wrapperEl: m,
      rtlTranslate: y,
      snapGrid: g,
      touchEventsData: p
    } = e, h = xo() - p.touchStartTime;
    if (c < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (c > -e.maxTranslate()) {
      e.slides.length < g.length ? e.slideTo(g.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (u.freeMode.momentum) {
      if (p.velocities.length > 1) {
        const B = p.velocities.pop(), D = p.velocities.pop(), x = B.position - D.position, C = B.time - D.time;
        e.velocity = x / C, e.velocity /= 2, Math.abs(e.velocity) < u.freeMode.minimumVelocity && (e.velocity = 0), (C > 150 || xo() - B.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= u.freeMode.momentumVelocityRatio, p.velocities.length = 0;
      let f = 1e3 * u.freeMode.momentumRatio;
      const F = e.velocity * f;
      let b = e.translate + F;
      y && (b = -b);
      let v = !1, k;
      const E = Math.abs(e.velocity) * 20 * u.freeMode.momentumBounceRatio;
      let S;
      if (b < e.maxTranslate())
        u.freeMode.momentumBounce ? (b + e.maxTranslate() < -E && (b = e.maxTranslate() - E), k = e.maxTranslate(), v = !0, p.allowMomentumBounce = !0) : b = e.maxTranslate(), u.loop && u.centeredSlides && (S = !0);
      else if (b > e.minTranslate())
        u.freeMode.momentumBounce ? (b - e.minTranslate() > E && (b = e.minTranslate() + E), k = e.minTranslate(), v = !0, p.allowMomentumBounce = !0) : b = e.minTranslate(), u.loop && u.centeredSlides && (S = !0);
      else if (u.freeMode.sticky) {
        let B;
        for (let D = 0; D < g.length; D += 1)
          if (g[D] > -b) {
            B = D;
            break;
          }
        Math.abs(g[B] - b) < Math.abs(g[B - 1] - b) || e.swipeDirection === "next" ? b = g[B] : b = g[B - 1], b = -b;
      }
      if (S && n("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (y ? f = Math.abs((-b - e.translate) / e.velocity) : f = Math.abs((b - e.translate) / e.velocity), u.freeMode.sticky) {
          const B = Math.abs((y ? -b : b) - e.translate), D = e.slidesSizesGrid[e.activeIndex];
          B < D ? f = u.speed : B < 2 * D ? f = u.speed * 1.5 : f = u.speed * 2.5;
        }
      } else if (u.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      u.freeMode.momentumBounce && v ? (e.updateProgress(k), e.setTransition(f), e.setTranslate(b), e.transitionStart(!0, e.swipeDirection), e.animating = !0, en(m, () => {
        !e || e.destroyed || !p.allowMomentumBounce || (t("momentumBounce"), e.setTransition(u.speed), setTimeout(() => {
          e.setTranslate(k), en(m, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (t("_freeModeNoMomentumRelease"), e.updateProgress(b), e.setTransition(f), e.setTranslate(b), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, en(m, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(b), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (u.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else u.freeMode && t("_freeModeNoMomentumRelease");
    (!u.freeMode.momentum || h >= u.longSwipesMs) && (t("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: a,
      onTouchMove: s,
      onTouchEnd: i
    }
  });
}
function $7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let n, a, s, i;
  const l = () => {
    let d = e.params.spaceBetween;
    return typeof d == "string" && d.indexOf("%") >= 0 ? d = parseFloat(d.replace("%", "")) / 100 * e.size : typeof d == "string" && (d = parseFloat(d)), d;
  }, c = (d) => {
    const {
      slidesPerView: h
    } = e.params, {
      rows: f,
      fill: F
    } = e.params.grid, b = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : d.length;
    s = Math.floor(b / f), Math.floor(b / f) === b / f ? n = b : n = Math.ceil(b / f) * f, h !== "auto" && F === "row" && (n = Math.max(n, h * f)), a = n / f;
  }, u = () => {
    e.slides && e.slides.forEach((d) => {
      d.swiperSlideGridSet && (d.style.height = "", d.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, m = (d, h, f) => {
    const {
      slidesPerGroup: F
    } = e.params, b = l(), {
      rows: v,
      fill: k
    } = e.params.grid, E = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : f.length;
    let S, B, D;
    if (k === "row" && F > 1) {
      const x = Math.floor(d / (F * v)), C = d - v * F * x, O = x === 0 ? F : Math.min(Math.ceil((E - x * v * F) / v), F);
      D = Math.floor(C / O), B = C - D * O + x * F, S = B + D * n / v, h.style.order = S;
    } else k === "column" ? (B = Math.floor(d / v), D = d - B * v, (B > s || B === s && D === v - 1) && (D += 1, D >= v && (D = 0, B += 1))) : (D = Math.floor(d / a), B = d - D * a);
    h.row = D, h.column = B, h.style.height = `calc((100% - ${(v - 1) * b}px) / ${v})`, h.style[e.getDirectionLabel("margin-top")] = D !== 0 ? b && `${b}px` : "", h.swiperSlideGridSet = !0;
  }, y = (d, h) => {
    const {
      centeredSlides: f,
      roundLengths: F
    } = e.params, b = l(), {
      rows: v
    } = e.params.grid;
    if (e.virtualSize = (d + b) * n, e.virtualSize = Math.ceil(e.virtualSize / v) - b, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + b}px`), f) {
      const k = [];
      for (let E = 0; E < h.length; E += 1) {
        let S = h[E];
        F && (S = Math.floor(S)), h[E] < e.virtualSize + h[0] && k.push(S);
      }
      h.splice(0, h.length), h.push(...k);
    }
  }, g = () => {
    i = e.params.grid && e.params.grid.rows > 1;
  }, p = () => {
    const {
      params: d,
      el: h
    } = e, f = d.grid && d.grid.rows > 1;
    i && !f ? (h.classList.remove(`${d.containerModifierClass}grid`, `${d.containerModifierClass}grid-column`), s = 1, e.emitContainerClasses()) : !i && f && (h.classList.add(`${d.containerModifierClass}grid`), d.grid.fill === "column" && h.classList.add(`${d.containerModifierClass}grid-column`), e.emitContainerClasses()), i = f;
  };
  t("init", g), t("update", p), e.grid = {
    initSlides: c,
    unsetSlides: u,
    updateSlide: m,
    updateWrapperSize: y
  };
}
function e8(o) {
  const e = this, {
    params: r,
    slidesEl: t
  } = e;
  r.loop && e.loopDestroy();
  const n = (a) => {
    if (typeof a == "string") {
      const s = document.createElement("div");
      s.innerHTML = a, t.append(s.children[0]), s.innerHTML = "";
    } else
      t.append(a);
  };
  if (typeof o == "object" && "length" in o)
    for (let a = 0; a < o.length; a += 1)
      o[a] && n(o[a]);
  else
    n(o);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update();
}
function o8(o) {
  const e = this, {
    params: r,
    activeIndex: t,
    slidesEl: n
  } = e;
  r.loop && e.loopDestroy();
  let a = t + 1;
  const s = (i) => {
    if (typeof i == "string") {
      const l = document.createElement("div");
      l.innerHTML = i, n.prepend(l.children[0]), l.innerHTML = "";
    } else
      n.prepend(i);
  };
  if (typeof o == "object" && "length" in o) {
    for (let i = 0; i < o.length; i += 1)
      o[i] && s(o[i]);
    a = t + o.length;
  } else
    s(o);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), e.slideTo(a, 0, !1);
}
function r8(o, e) {
  const r = this, {
    params: t,
    activeIndex: n,
    slidesEl: a
  } = r;
  let s = n;
  t.loop && (s -= r.loopedSlides, r.loopDestroy(), r.recalcSlides());
  const i = r.slides.length;
  if (o <= 0) {
    r.prependSlide(e);
    return;
  }
  if (o >= i) {
    r.appendSlide(e);
    return;
  }
  let l = s > o ? s + 1 : s;
  const c = [];
  for (let u = i - 1; u >= o; u -= 1) {
    const m = r.slides[u];
    m.remove(), c.unshift(m);
  }
  if (typeof e == "object" && "length" in e) {
    for (let u = 0; u < e.length; u += 1)
      e[u] && a.append(e[u]);
    l = s > o ? s + e.length : s;
  } else
    a.append(e);
  for (let u = 0; u < c.length; u += 1)
    a.append(c[u]);
  r.recalcSlides(), t.loop && r.loopCreate(), (!t.observer || r.isElement) && r.update(), t.loop ? r.slideTo(l + r.loopedSlides, 0, !1) : r.slideTo(l, 0, !1);
}
function t8(o) {
  const e = this, {
    params: r,
    activeIndex: t
  } = e;
  let n = t;
  r.loop && (n -= e.loopedSlides, e.loopDestroy());
  let a = n, s;
  if (typeof o == "object" && "length" in o) {
    for (let i = 0; i < o.length; i += 1)
      s = o[i], e.slides[s] && e.slides[s].remove(), s < a && (a -= 1);
    a = Math.max(a, 0);
  } else
    s = o, e.slides[s] && e.slides[s].remove(), s < a && (a -= 1), a = Math.max(a, 0);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), r.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1);
}
function n8() {
  const o = this, e = [];
  for (let r = 0; r < o.slides.length; r += 1)
    e.push(r);
  o.removeSlide(e);
}
function a8(o) {
  let {
    swiper: e
  } = o;
  Object.assign(e, {
    appendSlide: e8.bind(e),
    prependSlide: o8.bind(e),
    addSlide: r8.bind(e),
    removeSlide: t8.bind(e),
    removeAllSlides: n8.bind(e)
  });
}
function Ot(o) {
  const {
    effect: e,
    swiper: r,
    on: t,
    setTranslate: n,
    setTransition: a,
    overwriteParams: s,
    perspective: i,
    recreateShadows: l,
    getEffectParams: c
  } = o;
  t("beforeInit", () => {
    if (r.params.effect !== e) return;
    r.classNames.push(`${r.params.containerModifierClass}${e}`), i && i() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const m = s ? s() : {};
    Object.assign(r.params, m), Object.assign(r.originalParams, m);
  }), t("setTranslate", () => {
    r.params.effect === e && n();
  }), t("setTransition", (m, y) => {
    r.params.effect === e && a(y);
  }), t("transitionEnd", () => {
    if (r.params.effect === e && l) {
      if (!c || !c().slideShadows) return;
      r.slides.forEach((m) => {
        m.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((y) => y.remove());
      }), l();
    }
  });
  let u;
  t("virtualUpdate", () => {
    r.params.effect === e && (r.slides.length || (u = !0), requestAnimationFrame(() => {
      u && r.slides && r.slides.length && (n(), u = !1);
    }));
  });
}
function va(o, e) {
  const r = Qr(e);
  return r !== e && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function Us(o) {
  let {
    swiper: e,
    duration: r,
    transformElements: t,
    allSlides: n
  } = o;
  const {
    activeIndex: a
  } = e, s = (i) => i.parentElement ? i.parentElement : e.slides.find((c) => c.shadowRoot && c.shadowRoot === i.parentNode);
  if (e.params.virtualTranslate && r !== 0) {
    let i = !1, l;
    n ? l = t : l = t.filter((c) => {
      const u = c.classList.contains("swiper-slide-transform") ? s(c) : c;
      return e.getSlideIndex(u) === a;
    }), l.forEach((c) => {
      en(c, () => {
        if (i || !e || e.destroyed) return;
        i = !0, e.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function s8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    fadeEffect: {
      crossFade: !1
    }
  }), Ot({
    effect: "fade",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: s
      } = e, i = e.params.fadeEffect;
      for (let l = 0; l < s.length; l += 1) {
        const c = e.slides[l];
        let m = -c.swiperSlideOffset;
        e.params.virtualTranslate || (m -= e.translate);
        let y = 0;
        e.isHorizontal() || (y = m, m = 0);
        const g = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0), p = va(i, c);
        p.style.opacity = g, p.style.transform = `translate3d(${m}px, ${y}px, 0px)`;
      }
    },
    setTransition: (s) => {
      const i = e.slides.map((l) => Qr(l));
      i.forEach((l) => {
        l.style.transitionDuration = `${s}ms`;
      }), Us({
        swiper: e,
        duration: s,
        transformElements: i,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function i8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const n = (l, c, u) => {
    let m = u ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), y = u ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    m || (m = Bo("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "left" : "top"}`.split(" ")), l.append(m)), y || (y = Bo("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "right" : "bottom"}`.split(" ")), l.append(y)), m && (m.style.opacity = Math.max(-c, 0)), y && (y.style.opacity = Math.max(c, 0));
  };
  Ot({
    effect: "cube",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        el: l,
        wrapperEl: c,
        slides: u,
        width: m,
        height: y,
        rtlTranslate: g,
        size: p,
        browser: d
      } = e, h = qs(e), f = e.params.cubeEffect, F = e.isHorizontal(), b = e.virtual && e.params.virtual.enabled;
      let v = 0, k;
      f.shadow && (F ? (k = e.wrapperEl.querySelector(".swiper-cube-shadow"), k || (k = Bo("div", "swiper-cube-shadow"), e.wrapperEl.append(k)), k.style.height = `${m}px`) : (k = l.querySelector(".swiper-cube-shadow"), k || (k = Bo("div", "swiper-cube-shadow"), l.append(k))));
      for (let S = 0; S < u.length; S += 1) {
        const B = u[S];
        let D = S;
        b && (D = parseInt(B.getAttribute("data-swiper-slide-index"), 10));
        let x = D * 90, C = Math.floor(x / 360);
        g && (x = -x, C = Math.floor(-x / 360));
        const O = Math.max(Math.min(B.progress, 1), -1);
        let T = 0, I = 0, G = 0;
        D % 4 === 0 ? (T = -C * 4 * p, G = 0) : (D - 1) % 4 === 0 ? (T = 0, G = -C * 4 * p) : (D - 2) % 4 === 0 ? (T = p + C * 4 * p, G = p) : (D - 3) % 4 === 0 && (T = -p, G = 3 * p + p * 4 * C), g && (T = -T), F || (I = T, T = 0);
        const U = `rotateX(${h(F ? 0 : -x)}deg) rotateY(${h(F ? x : 0)}deg) translate3d(${T}px, ${I}px, ${G}px)`;
        O <= 1 && O > -1 && (v = D * 90 + O * 90, g && (v = -D * 90 - O * 90)), B.style.transform = U, f.slideShadows && n(B, O, F);
      }
      if (c.style.transformOrigin = `50% 50% -${p / 2}px`, c.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, f.shadow)
        if (F)
          k.style.transform = `translate3d(0px, ${m / 2 + f.shadowOffset}px, ${-m / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${f.shadowScale})`;
        else {
          const S = Math.abs(v) - Math.floor(Math.abs(v) / 90) * 90, B = 1.5 - (Math.sin(S * 2 * Math.PI / 360) / 2 + Math.cos(S * 2 * Math.PI / 360) / 2), D = f.shadowScale, x = f.shadowScale / B, C = f.shadowOffset;
          k.style.transform = `scale3d(${D}, 1, ${x}) translate3d(0px, ${y / 2 + C}px, ${-y / 2 / x}px) rotateX(-89.99deg)`;
        }
      const E = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -p / 2 : 0;
      c.style.transform = `translate3d(0px,0,${E}px) rotateX(${h(e.isHorizontal() ? 0 : v)}deg) rotateY(${h(e.isHorizontal() ? -v : 0)}deg)`, c.style.setProperty("--swiper-cube-translate-z", `${E}px`);
    },
    setTransition: (l) => {
      const {
        el: c,
        slides: u
      } = e;
      if (u.forEach((m) => {
        m.style.transitionDuration = `${l}ms`, m.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((y) => {
          y.style.transitionDuration = `${l}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const m = c.querySelector(".swiper-cube-shadow");
        m && (m.style.transitionDuration = `${l}ms`);
      }
    },
    recreateShadows: () => {
      const l = e.isHorizontal();
      e.slides.forEach((c) => {
        const u = Math.max(Math.min(c.progress, 1), -1);
        n(c, u, l);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function kt(o, e, r) {
  const t = `swiper-slide-shadow${r ? `-${r}` : ""}${o ? ` swiper-slide-shadow-${o}` : ""}`, n = Qr(e);
  let a = n.querySelector(`.${t.split(" ").join(".")}`);
  return a || (a = Bo("div", t.split(" ")), n.append(a)), a;
}
function l8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const n = (l, c) => {
    let u = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), m = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    u || (u = kt("flip", l, e.isHorizontal() ? "left" : "top")), m || (m = kt("flip", l, e.isHorizontal() ? "right" : "bottom")), u && (u.style.opacity = Math.max(-c, 0)), m && (m.style.opacity = Math.max(c, 0));
  };
  Ot({
    effect: "flip",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: l,
        rtlTranslate: c
      } = e, u = e.params.flipEffect, m = qs(e);
      for (let y = 0; y < l.length; y += 1) {
        const g = l[y];
        let p = g.progress;
        e.params.flipEffect.limitRotation && (p = Math.max(Math.min(g.progress, 1), -1));
        const d = g.swiperSlideOffset;
        let f = -180 * p, F = 0, b = e.params.cssMode ? -d - e.translate : -d, v = 0;
        e.isHorizontal() ? c && (f = -f) : (v = b, b = 0, F = -f, f = 0), g.style.zIndex = -Math.abs(Math.round(p)) + l.length, u.slideShadows && n(g, p);
        const k = `translate3d(${b}px, ${v}px, 0px) rotateX(${m(F)}deg) rotateY(${m(f)}deg)`, E = va(u, g);
        E.style.transform = k;
      }
    },
    setTransition: (l) => {
      const c = e.slides.map((u) => Qr(u));
      c.forEach((u) => {
        u.style.transitionDuration = `${l}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((m) => {
          m.style.transitionDuration = `${l}ms`;
        });
      }), Us({
        swiper: e,
        duration: l,
        transformElements: c
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((l) => {
        let c = l.progress;
        e.params.flipEffect.limitRotation && (c = Math.max(Math.min(l.progress, 1), -1)), n(l, c);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function c8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), Ot({
    effect: "coverflow",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        width: s,
        height: i,
        slides: l,
        slidesSizesGrid: c
      } = e, u = e.params.coverflowEffect, m = e.isHorizontal(), y = e.translate, g = m ? -y + s / 2 : -y + i / 2, p = m ? u.rotate : -u.rotate, d = u.depth, h = qs(e);
      for (let f = 0, F = l.length; f < F; f += 1) {
        const b = l[f], v = c[f], k = b.swiperSlideOffset, E = (g - k - v / 2) / v, S = typeof u.modifier == "function" ? u.modifier(E) : E * u.modifier;
        let B = m ? p * S : 0, D = m ? 0 : p * S, x = -d * Math.abs(S), C = u.stretch;
        typeof C == "string" && C.indexOf("%") !== -1 && (C = parseFloat(u.stretch) / 100 * v);
        let O = m ? 0 : C * S, T = m ? C * S : 0, I = 1 - (1 - u.scale) * Math.abs(S);
        Math.abs(T) < 1e-3 && (T = 0), Math.abs(O) < 1e-3 && (O = 0), Math.abs(x) < 1e-3 && (x = 0), Math.abs(B) < 1e-3 && (B = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(I) < 1e-3 && (I = 0);
        const G = `translate3d(${T}px,${O}px,${x}px)  rotateX(${h(D)}deg) rotateY(${h(B)}deg) scale(${I})`, U = va(u, b);
        if (U.style.transform = G, b.style.zIndex = -Math.abs(Math.round(S)) + 1, u.slideShadows) {
          let N = m ? b.querySelector(".swiper-slide-shadow-left") : b.querySelector(".swiper-slide-shadow-top"), z = m ? b.querySelector(".swiper-slide-shadow-right") : b.querySelector(".swiper-slide-shadow-bottom");
          N || (N = kt("coverflow", b, m ? "left" : "top")), z || (z = kt("coverflow", b, m ? "right" : "bottom")), N && (N.style.opacity = S > 0 ? S : 0), z && (z.style.opacity = -S > 0 ? -S : 0);
        }
      }
    },
    setTransition: (s) => {
      e.slides.map((l) => Qr(l)).forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function u8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const n = (i) => typeof i == "string" ? i : `${i}px`;
  Ot({
    effect: "creative",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: i,
        wrapperEl: l,
        slidesSizesGrid: c
      } = e, u = e.params.creativeEffect, {
        progressMultiplier: m
      } = u, y = e.params.centeredSlides, g = qs(e);
      if (y) {
        const p = c[0] / 2 - e.params.slidesOffsetBefore || 0;
        l.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < i.length; p += 1) {
        const d = i[p], h = d.progress, f = Math.min(Math.max(d.progress, -u.limitProgress), u.limitProgress);
        let F = f;
        y || (F = Math.min(Math.max(d.originalProgress, -u.limitProgress), u.limitProgress));
        const b = d.swiperSlideOffset, v = [e.params.cssMode ? -b - e.translate : -b, 0, 0], k = [0, 0, 0];
        let E = !1;
        e.isHorizontal() || (v[1] = v[0], v[0] = 0);
        let S = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        f < 0 ? (S = u.next, E = !0) : f > 0 && (S = u.prev, E = !0), v.forEach((I, G) => {
          v[G] = `calc(${I}px + (${n(S.translate[G])} * ${Math.abs(f * m)}))`;
        }), k.forEach((I, G) => {
          let U = S.rotate[G] * Math.abs(f * m);
          k[G] = U;
        }), d.style.zIndex = -Math.abs(Math.round(h)) + i.length;
        const B = v.join(", "), D = `rotateX(${g(k[0])}deg) rotateY(${g(k[1])}deg) rotateZ(${g(k[2])}deg)`, x = F < 0 ? `scale(${1 + (1 - S.scale) * F * m})` : `scale(${1 - (1 - S.scale) * F * m})`, C = F < 0 ? 1 + (1 - S.opacity) * F * m : 1 - (1 - S.opacity) * F * m, O = `translate3d(${B}) ${D} ${x}`;
        if (E && S.shadow || !E) {
          let I = d.querySelector(".swiper-slide-shadow");
          if (!I && S.shadow && (I = kt("creative", d)), I) {
            const G = u.shadowPerProgress ? f * (1 / u.limitProgress) : f;
            I.style.opacity = Math.min(Math.max(Math.abs(G), 0), 1);
          }
        }
        const T = va(u, d);
        T.style.transform = O, T.style.opacity = C, S.origin && (T.style.transformOrigin = S.origin);
      }
    },
    setTransition: (i) => {
      const l = e.slides.map((c) => Qr(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${i}ms`, c.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${i}ms`;
        });
      }), Us({
        swiper: e,
        duration: i,
        transformElements: l,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function p8(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), Ot({
    effect: "cards",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: s,
        activeIndex: i,
        rtlTranslate: l
      } = e, c = e.params.cardsEffect, {
        startTranslate: u,
        isTouched: m
      } = e.touchEventsData, y = l ? -e.translate : e.translate;
      for (let g = 0; g < s.length; g += 1) {
        const p = s[g], d = p.progress, h = Math.min(Math.max(d, -4), 4);
        let f = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (f -= s[0].swiperSlideOffset);
        let F = e.params.cssMode ? -f - e.translate : -f, b = 0;
        const v = -100 * Math.abs(h);
        let k = 1, E = -c.perSlideRotate * h, S = c.perSlideOffset - Math.abs(h) * 0.75;
        const B = e.virtual && e.params.virtual.enabled ? e.virtual.from + g : g, D = (B === i || B === i - 1) && h > 0 && h < 1 && (m || e.params.cssMode) && y < u, x = (B === i || B === i + 1) && h < 0 && h > -1 && (m || e.params.cssMode) && y > u;
        if (D || x) {
          const I = (1 - Math.abs((Math.abs(h) - 0.5) / 0.5)) ** 0.5;
          E += -28 * h * I, k += -0.5 * I, S += 96 * I, b = `${-25 * I * Math.abs(h)}%`;
        }
        if (h < 0 ? F = `calc(${F}px ${l ? "-" : "+"} (${S * Math.abs(h)}%))` : h > 0 ? F = `calc(${F}px ${l ? "-" : "+"} (-${S * Math.abs(h)}%))` : F = `${F}px`, !e.isHorizontal()) {
          const I = b;
          b = F, F = I;
        }
        const C = h < 0 ? `${1 + (1 - k) * h}` : `${1 - (1 - k) * h}`, O = `
        translate3d(${F}, ${b}, ${v}px)
        rotateZ(${c.rotate ? l ? -E : E : 0}deg)
        scale(${C})
      `;
        if (c.slideShadows) {
          let I = p.querySelector(".swiper-slide-shadow");
          I || (I = kt("cards", p)), I && (I.style.opacity = Math.min(Math.max((Math.abs(h) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(d)) + s.length;
        const T = va(c, p);
        T.style.transform = O;
      }
    },
    setTransition: (s) => {
      const i = e.slides.map((l) => Qr(l));
      i.forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      }), Us({
        swiper: e,
        duration: s,
        transformElements: i
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      _loopSwapReset: !1,
      watchSlidesProgress: !0,
      loopAdditionalSlides: 3,
      centeredSlides: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const d8 = [R7, L7, H7, W7, V7, G7, Z7, X7, q7, U7, Y7, J7, Q7, K7, _7, $7, a8, s8, i8, l8, c8, u8, p8];
ho.use(d8);
const Ys = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function wt(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object" && !o.__swiper__;
}
function hc(o, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((t) => r.indexOf(t) < 0).forEach((t) => {
    typeof o[t] > "u" ? o[t] = e[t] : wt(e[t]) && wt(o[t]) && Object.keys(e[t]).length > 0 ? e[t].__swiper__ ? o[t] = e[t] : hc(o[t], e[t]) : o[t] = e[t];
  });
}
function g8(o) {
  return o === void 0 && (o = {}), o.navigation && typeof o.navigation.nextEl > "u" && typeof o.navigation.prevEl > "u";
}
function m8(o) {
  return o === void 0 && (o = {}), o.pagination && typeof o.pagination.el > "u";
}
function y8(o) {
  return o === void 0 && (o = {}), o.scrollbar && typeof o.scrollbar.el > "u";
}
function ls(o) {
  return o === void 0 && (o = ""), o.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function f8(o) {
  let {
    swiper: e,
    slides: r,
    passedParams: t,
    changedParams: n,
    nextEl: a,
    prevEl: s,
    scrollbarEl: i,
    paginationEl: l
  } = o;
  const c = n.filter((D) => D !== "children" && D !== "direction" && D !== "wrapperClass"), {
    params: u,
    pagination: m,
    navigation: y,
    scrollbar: g,
    virtual: p,
    thumbs: d
  } = e;
  let h, f, F, b, v, k, E, S;
  n.includes("thumbs") && t.thumbs && t.thumbs.swiper && !t.thumbs.swiper.destroyed && u.thumbs && (!u.thumbs.swiper || u.thumbs.swiper.destroyed) && (h = !0), n.includes("controller") && t.controller && t.controller.control && u.controller && !u.controller.control && (f = !0), n.includes("pagination") && t.pagination && (t.pagination.el || l) && (u.pagination || u.pagination === !1) && m && !m.el && (F = !0), n.includes("scrollbar") && t.scrollbar && (t.scrollbar.el || i) && (u.scrollbar || u.scrollbar === !1) && g && !g.el && (b = !0), n.includes("navigation") && t.navigation && (t.navigation.prevEl || s) && (t.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && y && !y.prevEl && !y.nextEl && (v = !0);
  const B = (D) => {
    e[D] && (e[D].destroy(), D === "navigation" ? (e.isElement && (e[D].prevEl.remove(), e[D].nextEl.remove()), u[D].prevEl = void 0, u[D].nextEl = void 0, e[D].prevEl = void 0, e[D].nextEl = void 0) : (e.isElement && e[D].el.remove(), u[D].el = void 0, e[D].el = void 0));
  };
  n.includes("loop") && e.isElement && (u.loop && !t.loop ? k = !0 : !u.loop && t.loop ? E = !0 : S = !0), c.forEach((D) => {
    if (wt(u[D]) && wt(t[D]))
      Object.assign(u[D], t[D]), (D === "navigation" || D === "pagination" || D === "scrollbar") && "enabled" in t[D] && !t[D].enabled && B(D);
    else {
      const x = t[D];
      (x === !0 || x === !1) && (D === "navigation" || D === "pagination" || D === "scrollbar") ? x === !1 && B(D) : u[D] = t[D];
    }
  }), c.includes("controller") && !f && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), n.includes("children") && r && p && u.virtual.enabled ? (p.slides = r, p.update(!0)) : n.includes("virtual") && p && u.virtual.enabled && (r && (p.slides = r), p.update(!0)), n.includes("children") && r && u.loop && (S = !0), h && d.init() && d.update(!0), f && (e.controller.control = u.controller.control), F && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), e.el.appendChild(l)), l && (u.pagination.el = l), m.init(), m.render(), m.update()), b && (e.isElement && (!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-scrollbar"), i.part.add("scrollbar"), e.el.appendChild(i)), i && (u.scrollbar.el = i), g.init(), g.updateSize(), g.setTranslate()), v && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = e.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), e.el.appendChild(s))), a && (u.navigation.nextEl = a), s && (u.navigation.prevEl = s), y.init(), y.update()), n.includes("allowSlideNext") && (e.allowSlideNext = t.allowSlideNext), n.includes("allowSlidePrev") && (e.allowSlidePrev = t.allowSlidePrev), n.includes("direction") && e.changeDirection(t.direction, !1), (k || S) && e.loopDestroy(), (E || S) && e.loopCreate(), e.update();
}
const Zg = (o) => {
  if (parseFloat(o) === Number(o)) return Number(o);
  if (o === "true" || o === "") return !0;
  if (o === "false") return !1;
  if (o === "null") return null;
  if (o !== "undefined") {
    if (typeof o == "string" && o.includes("{") && o.includes("}") && o.includes('"')) {
      let e;
      try {
        e = JSON.parse(o);
      } catch {
        e = o;
      }
      return e;
    }
    return o;
  }
}, Xg = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function qg(o, e, r) {
  const t = {}, n = {};
  hc(t, fc);
  const a = [...Ys, "on"], s = a.map((l) => l.replace(/_/, ""));
  a.forEach((l) => {
    l = l.replace("_", ""), typeof o[l] < "u" && (n[l] = o[l]);
  });
  const i = [...o.attributes];
  return typeof e == "string" && typeof r < "u" && i.push({
    name: e,
    value: wt(r) ? {
      ...r
    } : r
  }), i.forEach((l) => {
    const c = Xg.find((u) => l.name.startsWith(`${u}-`));
    if (c) {
      const u = ls(c), m = ls(l.name.split(`${c}-`)[1]);
      typeof n[u] > "u" && (n[u] = {}), n[u] === !0 && (n[u] = {
        enabled: !0
      }), n[u][m] = Zg(l.value);
    } else {
      const u = ls(l.name);
      if (!s.includes(u)) return;
      const m = Zg(l.value);
      n[u] && Xg.includes(l.name) && !wt(m) ? (n[u].constructor !== Object && (n[u] = {}), n[u].enabled = !!m) : n[u] = m;
    }
  }), hc(t, n), t.navigation ? t.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...t.navigation !== !0 ? t.navigation : {}
  } : t.navigation === !1 && delete t.navigation, t.scrollbar ? t.scrollbar = {
    el: ".swiper-scrollbar",
    ...t.scrollbar !== !0 ? t.scrollbar : {}
  } : t.scrollbar === !1 && delete t.scrollbar, t.pagination ? t.pagination = {
    el: ".swiper-pagination",
    ...t.pagination !== !0 ? t.pagination : {}
  } : t.pagination === !1 && delete t.pagination, {
    params: t,
    passedParams: n
  };
}
const h8 = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", F8 = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class b8 {
}
const sh = typeof window > "u" || typeof HTMLElement > "u" ? b8 : HTMLElement, Ug = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, ih = (o, e) => {
  if (typeof CSSStyleSheet < "u" && o.adoptedStyleSheets) {
    const r = new CSSStyleSheet();
    r.replaceSync(e), o.adoptedStyleSheets = [r];
  } else {
    const r = document.createElement("style");
    r.rel = "stylesheet", r.textContent = e, o.appendChild(r);
  }
};
class lh extends sh {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return Ug;
  }
  static get prevButtonSvg() {
    return Ug.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      h8,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, r = [...this.querySelectorAll("[slot^=slide-]")].map((t) => parseInt(t.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = r.length ? Math.max(...r) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let t = e; t < this.slideSlots; t += 1) {
          const n = document.createElement("swiper-slide");
          n.setAttribute("part", `slide slide-${t + 1}`);
          const a = document.createElement("slot");
          a.setAttribute("name", `slide-${t + 1}`), n.appendChild(a), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(n);
        }
      else if (this.slideSlots < e) {
        const t = this.swiper.slides;
        for (let n = t.length - 1; n >= 0; n -= 1)
          n > this.slideSlots && t[n].remove();
      }
    }
  }
  render() {
    if (this.rendered) return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && ih(this.shadowRoot, e), this.cssLinks().forEach((t) => {
      if (this.shadowRoot.querySelector(`link[href="${t}"]`)) return;
      const a = document.createElement("link");
      a.rel = "stylesheet", a.href = t, this.shadowRoot.appendChild(a);
    });
    const r = document.createElement("div");
    r.classList.add("swiper"), r.part = "container", r.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((t, n) => `
        <swiper-slide part="slide slide-${n}">
          <slot name="slide-${n}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${g8(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${m8(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${y8(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(r), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.swiper && this.swiper.initialized) return;
    const {
      params: r,
      passedParams: t
    } = qg(this);
    this.swiperParams = r, this.passedParams = t, delete this.swiperParams.init, this.render(), this.swiper = new ho(this.shadowRoot.querySelector(".swiper"), {
      ...r.virtual ? {} : {
        observer: !0
      },
      ...r,
      touchEventsTarget: "container",
      onAny: function(n) {
        n === "observerUpdate" && e.calcSlideSlots();
        const a = r.eventsPrefix ? `${r.eventsPrefix}${n.toLowerCase()}` : n.toLowerCase();
        for (var s = arguments.length, i = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
          i[l - 1] = arguments[l];
        const c = new CustomEvent(a, {
          detail: i,
          bubbles: n !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(c);
      }
    });
  }
  connectedCallback() {
    this.swiper && this.swiper.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.swiper && this.swiper.destroy && this.swiper.destroy();
  }
  updateSwiperOnPropChange(e, r) {
    const {
      params: t,
      passedParams: n
    } = qg(this, e, r);
    this.passedParams = n, this.swiperParams = t, !(this.swiper && this.swiper.params[e] === r) && f8({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [ls(e)],
      ...e === "navigation" && n[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && n[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && n[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, r, t) {
    this.swiper && this.swiper.initialized && (r === "true" && t === null && (t = !1), this.updateSwiperOnPropChange(e, t));
  }
  static get observedAttributes() {
    return Ys.filter((r) => r.includes("_")).map((r) => r.replace(/[A-Z]/g, (t) => `-${t}`).replace("_", "").toLowerCase());
  }
}
Ys.forEach((o) => {
  o !== "init" && (o = o.replace("_", ""), Object.defineProperty(lh.prototype, o, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[o];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[o] = e, this.swiper && this.swiper.initialized && this.updateSwiperOnPropChange(o, e);
    }
  }));
});
class v8 extends sh {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (ih(this.shadowRoot, F8), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const r = document.createElement("div");
      r.classList.add("swiper-lazy-preloader"), r.part.add("preloader"), this.shadowRoot.appendChild(r);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.swiperLoopMoveDOM || this.initialize();
  }
}
const P8 = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", lh), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", v8));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (o) => {
  Ys.push(...o);
});
const B8 = ["pagination", "navigation"], k8 = /* @__PURE__ */ W({
  __name: "Carousel",
  props: {
    pagination: { type: [Object, Boolean], default: !0 },
    navigation: { type: [Object, Boolean], default: !1 }
  },
  setup(o) {
    const e = o, r = ae(() => e.pagination === !0 ? { clickable: !0 } : e.pagination), t = ae(() => e.navigation === !0 ? { clickable: !0 } : e.navigation);
    return P8(), (n, a) => (w(), j("swiper-container", {
      class: "rounded-md overflow-hidden",
      pagination: n.pagination ? r.value : !1,
      navigation: n.navigation ? t.value : !1
    }, [
      R(n.$slots, "default", {}, void 0, !0)
    ], 8, B8));
  }
}), nz = /* @__PURE__ */ le(k8, [["__scopeId", "data-v-dbe48761"]]), w8 = {};
function D8(o, e) {
  return w(), j("swiper-slide", null, [
    R(o.$slots, "default")
  ]);
}
const az = /* @__PURE__ */ le(w8, [["render", D8]]), S8 = ["id", "value", "indeterminate", "checked", "disabled", "tabindex", "aria-disabled"], sz = /* @__PURE__ */ W({
  __name: "Checkbox",
  props: {
    checked: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    indeterminate: { type: Boolean },
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = e, t = o, n = ae(() => t.checked ? !0 : Array.isArray(t.modelValue) && t.value ? t.modelValue.includes(t.value) : t.modelValue), a = (i) => {
      if (Array.isArray(t.modelValue) && t.value) {
        const l = t.modelValue.indexOf(t.value), { modelValue: c } = t;
        l === -1 ? c.push(t.value) : c.splice(l, 1), r("update:modelValue", c);
        return;
      }
      r("update:modelValue", i.target.checked);
    }, s = pe("field-id");
    return (i, l) => (w(), j("input", {
      id: P(s),
      type: "checkbox",
      class: Z([
        "h-4 w-4 rounded border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: i.value,
      indeterminate: i.indeterminate,
      checked: n.value,
      disabled: i.disabled,
      tabindex: i.disabled ? "-1" : 0,
      "aria-disabled": i.disabled,
      onChange: a
    }, null, 40, S8));
  }
}), iz = /* @__PURE__ */ W({
  __name: "CheckboxGroup",
  props: {
    columns: { default: 1 }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      [1, "grid-cols-1"],
      [2, "grid-cols-2"],
      [3, "grid-cols-3"],
      [4, "grid-cols-4"],
      [5, "grid-cols-5"]
    ]);
    return (r, t) => (w(), j("div", {
      class: Z([
        "grid gap-3",
        P(e).get(r.columns)
      ])
    }, [
      R(r.$slots, "default")
    ], 2));
  }
}), E8 = ["for"], lz = /* @__PURE__ */ W({
  __name: "CheckboxGroupField",
  setup(o) {
    const e = Qo();
    return Be("field-id", e), (r, t) => (w(), j("label", {
      for: P(e),
      class: Z([
        "bg-white flex items-center justify-between space-x-3 rounded-xl p-base border border-default-200 cursor-pointer",
        "[&>*]:cursor-pointer"
      ])
    }, [
      R(r.$slots, "default")
    ], 8, E8));
  }
}), No = /* @__PURE__ */ W({
  __name: "Label",
  props: {
    as: { default: "label" }
  },
  setup(o) {
    const r = o.as === "label" ? pe("field-id") : void 0;
    return (t, n) => (w(), L(Fe(t.as), {
      for: t.as === "label" ? P(r) : void 0,
      class: "block text-sm font-medium text-default-900"
    }, {
      default: M(() => [
        R(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["for"]));
  }
}), cz = /* @__PURE__ */ W({
  __name: "CheckboxGroupFieldLabel",
  setup(o) {
    return (e, r) => (w(), L(No, { as: "span" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), x8 = ["id"], mu = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "Field",
  props: {
    as: { default: "div" },
    hint: { default: void 0 }
  },
  setup(o) {
    const e = o, r = Qo();
    return Be("field-id", r), Be("has-hint", !!e.hint), (t, n) => (w(), j("div", {
      class: Z([
        t.hint && "relative"
      ])
    }, [
      t.hint ? (w(), j("span", {
        key: 0,
        id: `${P(r)}-hint`,
        class: "absolute top-0 right-0 text-default-500 text-sm"
      }, _(t.hint), 9, x8)) : Q("", !0),
      (w(), L(Fe(t.as), Mm(zm(t.$attrs)), {
        default: M(() => [
          R(t.$slots, "default")
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), A8 = {}, C8 = { class: "flex items-center justify-center" }, O8 = {
  key: 0,
  class: "px-4 text-sm text-default-500"
};
function T8(o, e) {
  return w(), j("div", C8, [
    e[0] || (e[0] = A("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1)),
    o.$slots.default ? (w(), j("span", O8, [
      R(o.$slots, "default")
    ])) : Q("", !0),
    e[1] || (e[1] = A("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1))
  ]);
}
const ch = /* @__PURE__ */ le(A8, [["render", T8]]), fl = /* @__PURE__ */ W({
  __name: "Color",
  props: {
    color: {},
    size: { default: "base" }
  },
  setup(o) {
    return (e, r) => (w(), j("span", {
      style: zo({ backgroundColor: e.color }),
      class: Z([
        "block rounded border border-black/10",
        e.size === "base" && "size-9",
        e.size === "sm" && "size-4"
      ])
    }, null, 6));
  }
}), uh = /* @__PURE__ */ W({
  __name: "Popover",
  props: {
    disabled: { type: Boolean, default: !1 },
    placement: { default: void 0 },
    size: { default: "base" },
    trigger: { default: void 0 }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["xs", "max-w-xs"],
      ["sm", "max-w-sm"],
      ["base", "max-w-md"],
      ["lg", "max-w-lg"],
      ["xl", "max-w-xl"],
      ["2xl", "max-w-2xl"]
    ]);
    return (r, t) => (w(), L(P(ca), null, {
      default: M(({ open: n, close: a }) => [
        H(P(Qm), {
          placement: r.placement,
          offset: 8,
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95"
        }, {
          default: M(() => [
            r.$slots.trigger ? R(r.$slots, "trigger", {
              key: 0,
              open: n
            }) : (w(), L(P(tr), {
              key: 1,
              as: eo,
              disabled: r.disabled,
              color: "tertiary"
            }, {
              default: M(() => [
                se(_(r.trigger), 1)
              ]),
              _: 1
            }, 8, ["disabled"])),
            H(P(ua), {
              class: Z([
                P(e).get(r.size),
                "w-screen p-base rounded-md bg-white shadow-lg ring-1 ring-black/5 whitespace-normal"
              ])
            }, {
              default: M(() => [
                R(r.$slots, "default", {
                  open: n,
                  close: a
                })
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1032, ["placement"])
      ]),
      _: 3
    }));
  }
}), j8 = { key: 0 }, M8 = { class: "flex pb-base space-x-3" }, z8 = { class: "flex-none" }, N8 = ["color"], I8 = ["color"], R8 = {
  key: 2,
  class: "-mx-base"
}, L8 = { class: "p-base" }, H8 = { class: "px-2 grid grid-cols-6 gap-1" }, uz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "ColorPicker",
  props: {
    alpha: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    label: { default: void 0 },
    modelValue: {},
    options: { default: void 0 },
    placement: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o;
    ur(async () => {
      await import("./hex-alpha-color-picker-Bf_ybK0Q.js"), await import("./hex-color-picker-DuRkZwuF.js");
    });
    const t = ie(r.modelValue);
    Ac(() => r.modelValue, (s) => {
      t.value = s;
    });
    const n = e, a = async (s) => {
      await Cc(75), n("update:modelValue", s);
    };
    return (s, i) => (w(), L(P(I1), {
      onTrigger: i[3] || (i[3] = (l) => n("update:modelValue", t.value))
    }, {
      default: M(() => [
        H(uh, He({
          trigger: "Open colour picker",
          size: "xs"
        }, s.$attrs), {
          trigger: M(() => [
            H(P(tr), {
              as: eo,
              color: "tertiary",
              size: "sm",
              "aria-label": "Open colour picker",
              disabled: s.disabled
            }, {
              default: M(() => [
                H(fl, {
                  color: s.modelValue,
                  size: "sm",
                  class: Z(s.disabled && "opacity-50")
                }, null, 8, ["color", "class"]),
                s.label ? (w(), j("span", j8, _(s.label), 1)) : Q("", !0)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          default: M(() => [
            A("div", M8, [
              A("div", z8, [
                H(fl, { color: t.value }, null, 8, ["color"])
              ]),
              H(mu, { class: "flex-1" }, {
                default: M(() => [
                  H(No, { class: "sr-only" }, {
                    default: M(() => i[4] || (i[4] = [
                      se(" Colour ")
                    ])),
                    _: 1
                  }),
                  H(ba, {
                    modelValue: t.value,
                    "onUpdate:modelValue": i[0] || (i[0] = (l) => t.value = l)
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            s.alpha ? (w(), j("hex-alpha-color-picker", {
              key: 0,
              color: t.value,
              class: "w-full",
              onColorChanged: i[1] || (i[1] = (l) => t.value = l.detail.value)
            }, null, 40, N8)) : (w(), j("hex-color-picker", {
              key: 1,
              color: t.value,
              class: "w-full",
              onColorChanged: i[2] || (i[2] = (l) => t.value = l.detail.value)
            }, null, 40, I8)),
            s.options ? (w(), j("div", R8, [
              H(ch, { class: "pt-base" }),
              A("div", L8, [
                H(No, { as: "span" }, {
                  default: M(() => i[5] || (i[5] = [
                    se(" Brand colours ")
                  ])),
                  _: 1
                })
              ]),
              A("div", H8, [
                (w(!0), j(ye, null, je(s.options, (l) => (w(), L(P(tr), {
                  key: l,
                  as: "button",
                  class: Z([
                    "border-transparent bg-transparent text-default-900 px-2.5 py-2 inline-flex justify-center items-center font-medium border border-px rounded-md",
                    "hover:bg-default-50",
                    "active:bg-white",
                    "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-default-200 focus-visible:outline-primary-900"
                  ]),
                  onClick: (c) => a(l)
                }, {
                  default: M(() => [
                    H(fl, {
                      color: l,
                      size: "sm"
                    }, null, 8, ["color"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))), 128))
              ])
            ])) : Q("", !0)
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }));
  }
}), pz = /* @__PURE__ */ W({
  __name: "Combobox",
  props: /* @__PURE__ */ lr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = cr(o, "modelValue");
    return Be("disabled", e.disabled), Be("modelValue", r), (t, n) => (w(), L(P(y1), {
      modelValue: r.value,
      "onUpdate:modelValue": n[0] || (n[0] = (a) => r.value = a),
      disabled: t.disabled,
      multiple: t.multiple,
      by: "id"
    }, {
      default: M(({ open: a, disabled: s }) => [
        R(t.$slots, "default", {
          open: a,
          disabled: s
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), W8 = { class: "flex flex-wrap gap-2 pt-2" }, dz = /* @__PURE__ */ W({
  __name: "ComboboxBadges",
  emits: ["remove"],
  setup(o, { emit: e }) {
    const r = pe("modelValue"), t = e;
    return (n, a) => (w(), j("ul", W8, [
      (w(!0), j(ye, null, je(P(r), (s) => (w(), j("li", {
        key: s.id
      }, [
        H(Qf, {
          color: "blue",
          remove: "",
          onRemove: (i) => t("remove", s)
        }, {
          default: M(() => [
            se(_(s.label), 1)
          ]),
          _: 2
        }, 1032, ["onRemove"])
      ]))), 128))
    ]));
  }
}), gz = /* @__PURE__ */ W({
  __name: "ComboboxControl",
  props: {
    query: {},
    value: {}
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = e, t = pe("disabled");
    return (n, a) => (w(), j("div", {
      class: Z([
        "relative",
        P(t) && "opacity-50 pointer-events-none"
      ])
    }, [
      H(P(f1), {
        class: Z([
          "border-none block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "placeholder:text-default-400",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6"
        ]),
        "display-value": (s) => {
          if (n.value)
            return n.value;
          const i = s;
          return Array.isArray(i) ? i.map((l) => l.label).join(", ") : i == null ? void 0 : i.label;
        },
        onChange: a[0] || (a[0] = (s) => r("change", s.target.value))
      }, null, 8, ["display-value"]),
      H(P(h1), {
        class: Z([
          "absolute inset-y-0 right-0 flex items-center rounded-r-md px-3",
          "focus:outline-none"
        ])
      }, {
        default: M(() => [
          H(P(ce), {
            icon: P(Yc),
            class: Z([
              "text-default-500 size-4",
              "sm:size-3"
            ]),
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      R(n.$slots, "default")
    ], 2));
  }
}), mz = /* @__PURE__ */ W({
  __name: "ComboboxLabel",
  setup(o) {
    return (e, r) => (w(), L(No, { as: P(F1) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), yz = /* @__PURE__ */ W({
  __name: "ComboboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(o) {
    return (e, r) => (w(), L(P(b1), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: M(({ active: t, selected: n }) => [
        A("li", {
          class: Z([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            t ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          A("span", {
            class: Z([
              n ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            R(e.$slots, "default")
          ], 2),
          n ? (w(), j("span", {
            key: 0,
            class: Z([
              t ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            H(P(ce), {
              icon: P(ya),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : Q("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), V8 = { key: 0 }, G8 = { class: "flex justify-center items-center py-2" }, Z8 = {
  key: 1,
  class: "flex justify-center items-center py-2 text-default-700"
}, fz = /* @__PURE__ */ W({
  __name: "ComboboxOptions",
  props: {
    endReached: { type: Boolean },
    empty: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["loadMore"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), L(Ro, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: M(() => [
        yo((w(), L(P(v1), {
          class: Z([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: M(() => [
            R(t.$slots, "default"),
            t.loading ? (w(), j("li", V8, [
              A("span", G8, [
                H(Yr, { class: "size-4 text-primary-600" })
              ])
            ])) : Q("", !0),
            t.empty && !t.loading ? (w(), j("li", Z8, " No results found. ")) : Q("", !0)
          ]),
          _: 3
        })), [
          [P(Ns), [() => r("loadMore"), { distance: 10, canLoadMore: () => !t.loading && !t.endReached && !t.empty }]]
        ])
      ]),
      _: 3
    }));
  }
}), X8 = /* @__PURE__ */ W({
  __name: "Container",
  props: {
    as: { default: "main" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "w-full max-w-[1920px] mx-auto" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ph = {
  mounted(o, e) {
    const { tippy: r } = R1(o, {
      content: e.value,
      theme: "spectre",
      maxWidth: 160
    });
    o._tippy = r.value;
  },
  updated(o, e) {
    var r;
    (r = o._tippy) == null || r.setContent(e.value);
  },
  unmounted(o) {
    var e;
    (e = o._tippy) == null || e.destroy();
  }
}, hz = /* @__PURE__ */ W({
  __name: "CopyToClipboard",
  props: {
    tooltip: {},
    value: {}
  },
  setup(o) {
    const e = o, { copy: r, copied: t } = Ym({
      legacy: !0,
      source: e.value.toString()
    });
    return (n, a) => yo((w(), j("button", {
      class: "relative",
      type: "button",
      onClick: a[0] || (a[0] = (s) => P(r)(n.value.toString()))
    }, [
      H(Jr, null, {
        default: M(() => [
          P(t) ? (w(), L(P(ce), {
            key: 1,
            icon: P(Zf),
            class: "size-4 text-emerald-800",
            "aria-hidden": "true"
          }, null, 8, ["icon"])) : (w(), j(ye, { key: 0 }, [
            H(P(ce), {
              icon: P(Xf),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"]),
            a[1] || (a[1] = A("span", { class: "sr-only" }, " Copy to clipboard ", -1))
          ], 64))
        ]),
        _: 1
      })
    ])), [
      [P(ph), n.tooltip]
    ]);
  }
}), Fz = /* @__PURE__ */ W({
  __name: "Description",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = pe("field-id", "");
    return (r, t) => (w(), L(Fe(r.as), {
      id: P(e) ? `${P(e)}-description` : void 0,
      class: "text-sm text-default-600"
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), q8 = {}, U8 = {
  class: /* @__PURE__ */ Z([
    "pt-1 pb-3 text-default-700",
    "sm:border-t sm:border-default-950/5 sm:py-3 sm:[&:nth-child(2)]:border-none"
  ])
};
function Y8(o, e) {
  return w(), j("dd", U8, [
    R(o.$slots, "default")
  ]);
}
const bz = /* @__PURE__ */ le(q8, [["render", Y8]]), J8 = {}, Q8 = {
  class: /* @__PURE__ */ Z([
    "grid grid-cols-1",
    "sm:grid-cols-[min(50%,calc(.25rem*80))_auto] sm:text-sm/6"
  ])
};
function K8(o, e) {
  return w(), j("dl", Q8, [
    R(o.$slots, "default")
  ]);
}
const vz = /* @__PURE__ */ le(J8, [["render", K8]]), _8 = {}, $8 = {
  class: /* @__PURE__ */ Z([
    "col-start-1 border-t border-default-950/5 pt-3 text-default-500",
    "first:border-none",
    "sm:border-t sm:border-default-950/5 sm:py-3"
  ])
};
function eS(o, e) {
  return w(), j("dt", $8, [
    R(o.$slots, "default")
  ]);
}
const Pz = /* @__PURE__ */ le(_8, [["render", eS]]), oS = {
  class: "size-full",
  xmlns: "http://www.w3.org/2000/svg"
}, rS = ["id"], tS = ["fill"], Bz = {
  __name: "DotPattern",
  setup(o) {
    const e = Qo();
    return (r, t) => (w(), j("svg", oS, [
      A("defs", null, [
        A("pattern", {
          id: P(e),
          x: "8",
          y: "8",
          width: "16",
          height: "16",
          patternUnits: "userSpaceOnUse"
        }, t[0] || (t[0] = [
          A("circle", {
            cx: "0.5",
            cy: "0.5",
            r: "0.5",
            fill: "currentColor"
          }, null, -1)
        ]), 8, rS)
      ]),
      A("rect", {
        width: "100%",
        height: "100%",
        fill: `url(#${P(e)})`
      }, null, 8, tS)
    ]));
  }
}, nS = { class: "fixed inset-0 overflow-hidden" }, aS = { class: "absolute inset-0 overflow-hidden" }, kz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "Drawer",
  props: {
    color: { default: "white" },
    direction: { default: "right" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = o, t = e;
    return Be("color", r.color), Be("emit", t), (n, a) => (w(), L(P(sa), {
      appear: "",
      as: "template",
      show: n.open
    }, {
      default: M(() => [
        H(P(ia), {
          as: "div",
          class: "relative z-[60]",
          onClose: a[0] || (a[0] = (s) => t("close"))
        }, {
          default: M(() => [
            H(P(qo), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: M(() => a[1] || (a[1] = [
                A("div", { class: "fixed inset-0 bg-black/25 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            A("div", nS, [
              A("div", aS, [
                A("div", {
                  class: Z(["pointer-events-none fixed inset-y-0 flex max-w-full", n.direction === "right" ? "pl-10 right-0" : "pr-10 left-0"])
                }, [
                  H(P(qo), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": n.direction === "right" ? "translate-x-full" : "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": n.direction === "right" ? "translate-x-full" : "-translate-x-full"
                  }, {
                    default: M(() => [
                      H(P(la), He({ class: "bg-white pointer-events-auto w-screen max-w-lg divide-y divide-default-300 flex flex-col" }, n.$attrs), {
                        default: M(() => [
                          R(n.$slots, "default")
                        ]),
                        _: 3
                      }, 16)
                    ]),
                    _: 3
                  }, 8, ["enter-from", "leave-to"])
                ], 2)
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), wz = /* @__PURE__ */ W({
  __name: "DrawerContent",
  setup(o) {
    const e = pe("color"), r = /* @__PURE__ */ new Map([
      ["white", "bg-white"],
      ["gray", "bg-default-100"]
    ]);
    return (t, n) => (w(), j("div", {
      class: Z([
        "flex-1 overflow-y-auto py-6 px-4",
        "sm:px-6",
        P(r).get(P(e) ?? "white")
      ])
    }, [
      R(t.$slots, "default")
    ], 2));
  }
}), sS = /* @__PURE__ */ W({
  __name: "Paragraph",
  props: {
    as: { default: "p" },
    size: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["base", "text-sm"],
      ["lg", "text-base"]
    ]);
    return (r, t) => (w(), L(Fe(r.as), {
      class: Z([
        "text-default-900",
        P(e).get(r.size)
      ])
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Dz = /* @__PURE__ */ W({
  __name: "DrawerDescription",
  setup(o) {
    return (e, r) => (w(), L(P(Sc), { as: sS }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), iS = {}, lS = { class: "flex flex-row-reverse justify-start gap-2 px-6 py-4" };
function cS(o, e) {
  return w(), j("div", lS, [
    R(o.$slots, "default")
  ]);
}
const Sz = /* @__PURE__ */ le(iS, [["render", cS]]), uS = {
  class: "py-2 pl-6 pr-2 flex items-center justify-between gap-2",
  "data-slot": "drawer-header"
}, pS = { class: "flex-none flex gap-2" }, dS = { class: "flex-none flex gap-2" }, Ez = /* @__PURE__ */ W({
  __name: "DrawerHeader",
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", uS, [
      A("div", pS, [
        R(r.$slots, "default")
      ]),
      A("div", dS, [
        R(r.$slots, "buttons"),
        H(Po, {
          color: "tertiary",
          size: "sm",
          ariaLabel: "Close",
          type: "button",
          icon: P(fa),
          onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
        }, null, 8, ["icon"])
      ])
    ]));
  }
}), xz = /* @__PURE__ */ W({
  __name: "DrawerTitle",
  setup(o) {
    return (e, r) => (w(), L(Dr, { as: P(js) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Az = /* @__PURE__ */ W({
  __name: "Dropdown",
  props: {
    disabled: { type: Boolean },
    trigger: { default: void 0 },
    placement: { default: void 0 },
    variant: { default: "default" }
  },
  setup(o) {
    return (e, r) => (w(), L(P(Gm), {
      as: "div",
      class: "inline-block text-left"
    }, {
      default: M(({ open: t }) => [
        H(P(Qm), {
          placement: e.placement,
          offset: 4,
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95"
        }, {
          default: M(() => [
            e.variant === "default" ? (w(), j(ye, { key: 0 }, [
              e.$slots.trigger ? R(e.$slots, "trigger", {
                key: 0,
                open: t,
                disabled: e.disabled
              }) : (w(), L(P(zl), {
                key: 1,
                as: eo,
                "trailing-icon": t ? P(K0) : P(Yc),
                disabled: e.disabled,
                color: "secondary"
              }, {
                default: M(() => [
                  se(_(e.trigger), 1)
                ]),
                _: 2
              }, 1032, ["trailing-icon", "disabled"]))
            ], 64)) : (w(), L(P(zl), {
              key: 1,
              as: Po,
              icon: P(Z0),
              disabled: e.disabled,
              color: "tertiary",
              "aria-label": e.trigger
            }, null, 8, ["icon", "disabled", "aria-label"])),
            H(P(Zm), { class: "z-10 p-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black/5" }, {
              default: M(() => [
                R(e.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 2
        }, 1032, ["placement"])
      ]),
      _: 3
    }));
  }
}), gS = { class: "inline-flex items-center gap-x-3" }, Cz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "DropdownItem",
  props: {
    as: { default: Co },
    disabled: { type: Boolean },
    href: { default: void 0 },
    leadingIcon: { default: void 0 }
  },
  emits: ["click"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), L(P(Xm), { disabled: t.disabled }, {
      default: M(({ active: a, close: s }) => [
        (w(), L(Fe(t.as), He({
          href: t.href,
          class: [
            t.disabled && "opacity-50 pointer-events-none",
            a && "bg-primary-50",
            "block text-left w-full rounded-lg font-medium text-default-500 px-3 py-2 leading-6 text-sm"
          ]
        }, t.$attrs, {
          onClick: () => {
            r("click"), s();
          }
        }), {
          default: M(() => [
            A("span", gS, [
              t.leadingIcon ? (w(), L(P(ce), {
                key: 0,
                icon: t.leadingIcon,
                class: Z([
                  a ? "text-default-500" : "text-default-400",
                  "size-4"
                ]),
                "aria-hidden": "true"
              }, null, 8, ["icon", "class"])) : Q("", !0),
              A("span", null, [
                R(t.$slots, "default")
              ])
            ])
          ]),
          _: 2
        }, 1040, ["href", "class", "onClick"]))
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
}), Yg = /* @__PURE__ */ JSON.parse('[{"codes":"1F600","char":"😀","name":"grinning face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F603","char":"😃","name":"grinning face with big eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F604","char":"😄","name":"grinning face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F601","char":"😁","name":"beaming face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F606","char":"😆","name":"grinning squinting face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F605","char":"😅","name":"grinning face with sweat","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F923","char":"🤣","name":"rolling on the floor laughing","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F602","char":"😂","name":"face with tears of joy","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F642","char":"🙂","name":"slightly smiling face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F643","char":"🙃","name":"upside-down face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1FAE0","char":"🫠","name":"melting face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F609","char":"😉","name":"winking face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F60A","char":"😊","name":"smiling face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F607","char":"😇","name":"smiling face with halo","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F970","char":"🥰","name":"smiling face with hearts","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F60D","char":"😍","name":"smiling face with heart-eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F929","char":"🤩","name":"star-struck","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F618","char":"😘","name":"face blowing a kiss","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F617","char":"😗","name":"kissing face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"263A FE0F","char":"☺️","name":"smiling face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"263A","char":"☺","name":"smiling face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F61A","char":"😚","name":"kissing face with closed eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F619","char":"😙","name":"kissing face with smiling eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F972","char":"🥲","name":"smiling face with tear","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F60B","char":"😋","name":"face savoring food","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61B","char":"😛","name":"face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61C","char":"😜","name":"winking face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F92A","char":"🤪","name":"zany face","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61D","char":"😝","name":"squinting face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F911","char":"🤑","name":"money-mouth face","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F917","char":"🤗","name":"smiling face with open hands","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F92D","char":"🤭","name":"face with hand over mouth","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE2","char":"🫢","name":"face with open eyes and hand over mouth","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE3","char":"🫣","name":"face with peeking eye","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F92B","char":"🤫","name":"shushing face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F914","char":"🤔","name":"thinking face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE1","char":"🫡","name":"saluting face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F910","char":"🤐","name":"zipper-mouth face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F928","char":"🤨","name":"face with raised eyebrow","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F610","char":"😐","name":"neutral face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F611","char":"😑","name":"expressionless face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636","char":"😶","name":"face without mouth","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1FAE5","char":"🫥","name":"dotted line face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636 200D 1F32B FE0F","char":"😶‍🌫️","name":"face in clouds","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636 200D 1F32B","char":"😶‍🌫","name":"face in clouds","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F60F","char":"😏","name":"smirking face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F612","char":"😒","name":"unamused face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F644","char":"🙄","name":"face with rolling eyes","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F62C","char":"😬","name":"grimacing face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F62E 200D 1F4A8","char":"😮‍💨","name":"face exhaling","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F925","char":"🤥","name":"lying face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1FAE8","char":"🫨","name":"shaking face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2194 FE0F","char":"🙂‍↔️","name":"head shaking horizontally","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2194","char":"🙂‍↔","name":"head shaking horizontally","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2195 FE0F","char":"🙂‍↕️","name":"head shaking vertically","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2195","char":"🙂‍↕","name":"head shaking vertically","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F60C","char":"😌","name":"relieved face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F614","char":"😔","name":"pensive face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F62A","char":"😪","name":"sleepy face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F924","char":"🤤","name":"drooling face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F634","char":"😴","name":"sleeping face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F637","char":"😷","name":"face with medical mask","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F912","char":"🤒","name":"face with thermometer","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F915","char":"🤕","name":"face with head-bandage","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F922","char":"🤢","name":"nauseated face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F92E","char":"🤮","name":"face vomiting","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F927","char":"🤧","name":"sneezing face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F975","char":"🥵","name":"hot face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F976","char":"🥶","name":"cold face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F974","char":"🥴","name":"woozy face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F635","char":"😵","name":"face with crossed-out eyes","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F635 200D 1F4AB","char":"😵‍💫","name":"face with spiral eyes","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F92F","char":"🤯","name":"exploding head","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F920","char":"🤠","name":"cowboy hat face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F973","char":"🥳","name":"partying face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F978","char":"🥸","name":"disguised face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F60E","char":"😎","name":"smiling face with sunglasses","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F913","char":"🤓","name":"nerd face","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F9D0","char":"🧐","name":"face with monocle","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F615","char":"😕","name":"confused face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1FAE4","char":"🫤","name":"face with diagonal mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F61F","char":"😟","name":"worried face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F641","char":"🙁","name":"slightly frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"2639 FE0F","char":"☹️","name":"frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"2639","char":"☹","name":"frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62E","char":"😮","name":"face with open mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62F","char":"😯","name":"hushed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F632","char":"😲","name":"astonished face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F633","char":"😳","name":"flushed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F97A","char":"🥺","name":"pleading face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F979","char":"🥹","name":"face holding back tears","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F626","char":"😦","name":"frowning face with open mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F627","char":"😧","name":"anguished face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F628","char":"😨","name":"fearful face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F630","char":"😰","name":"anxious face with sweat","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F625","char":"😥","name":"sad but relieved face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F622","char":"😢","name":"crying face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62D","char":"😭","name":"loudly crying face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F631","char":"😱","name":"face screaming in fear","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F616","char":"😖","name":"confounded face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F623","char":"😣","name":"persevering face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F61E","char":"😞","name":"disappointed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F613","char":"😓","name":"downcast face with sweat","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F629","char":"😩","name":"weary face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62B","char":"😫","name":"tired face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F971","char":"🥱","name":"yawning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F624","char":"😤","name":"face with steam from nose","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F621","char":"😡","name":"enraged face","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F620","char":"😠","name":"angry face","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F92C","char":"🤬","name":"face with symbols on mouth","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F608","char":"😈","name":"smiling face with horns","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F47F","char":"👿","name":"angry face with horns","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F480","char":"💀","name":"skull","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"2620 FE0F","char":"☠️","name":"skull and crossbones","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"2620","char":"☠","name":"skull and crossbones","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F4A9","char":"💩","name":"pile of poo","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F921","char":"🤡","name":"clown face","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F479","char":"👹","name":"ogre","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47A","char":"👺","name":"goblin","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47B","char":"👻","name":"ghost","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47D","char":"👽","name":"alien","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47E","char":"👾","name":"alien monster","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F916","char":"🤖","name":"robot","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F63A","char":"😺","name":"grinning cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F638","char":"😸","name":"grinning cat with smiling eyes","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F639","char":"😹","name":"cat with tears of joy","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63B","char":"😻","name":"smiling cat with heart-eyes","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63C","char":"😼","name":"cat with wry smile","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63D","char":"😽","name":"kissing cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F640","char":"🙀","name":"weary cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63F","char":"😿","name":"crying cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63E","char":"😾","name":"pouting cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F648","char":"🙈","name":"see-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F649","char":"🙉","name":"hear-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F64A","char":"🙊","name":"speak-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F48C","char":"💌","name":"love letter","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F498","char":"💘","name":"heart with arrow","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49D","char":"💝","name":"heart with ribbon","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F496","char":"💖","name":"sparkling heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F497","char":"💗","name":"growing heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F493","char":"💓","name":"beating heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49E","char":"💞","name":"revolving hearts","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F495","char":"💕","name":"two hearts","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49F","char":"💟","name":"heart decoration","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2763 FE0F","char":"❣️","name":"heart exclamation","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2763","char":"❣","name":"heart exclamation","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F494","char":"💔","name":"broken heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F 200D 1F525","char":"❤️‍🔥","name":"heart on fire","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 200D 1F525","char":"❤‍🔥","name":"heart on fire","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F 200D 1FA79","char":"❤️‍🩹","name":"mending heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 200D 1FA79","char":"❤‍🩹","name":"mending heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F","char":"❤️","name":"red heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764","char":"❤","name":"red heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA77","char":"🩷","name":"pink heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F9E1","char":"🧡","name":"orange heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49B","char":"💛","name":"yellow heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49A","char":"💚","name":"green heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F499","char":"💙","name":"blue heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA75","char":"🩵","name":"light blue heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49C","char":"💜","name":"purple heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F90E","char":"🤎","name":"brown heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F5A4","char":"🖤","name":"black heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA76","char":"🩶","name":"grey heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F90D","char":"🤍","name":"white heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F48B","char":"💋","name":"kiss mark","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AF","char":"💯","name":"hundred points","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A2","char":"💢","name":"anger symbol","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A5","char":"💥","name":"collision","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AB","char":"💫","name":"dizzy","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A6","char":"💦","name":"sweat droplets","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A8","char":"💨","name":"dashing away","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F573 FE0F","char":"🕳️","name":"hole","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F573","char":"🕳","name":"hole","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AC","char":"💬","name":"speech balloon","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 FE0F 200D 1F5E8 FE0F","char":"👁️‍🗨️","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 200D 1F5E8 FE0F","char":"👁‍🗨️","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 FE0F 200D 1F5E8","char":"👁️‍🗨","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 200D 1F5E8","char":"👁‍🗨","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5E8 FE0F","char":"🗨️","name":"left speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5E8","char":"🗨","name":"left speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5EF FE0F","char":"🗯️","name":"right anger bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5EF","char":"🗯","name":"right anger bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AD","char":"💭","name":"thought balloon","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A4","char":"💤","name":"ZZZ","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F44B","char":"👋","name":"waving hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FB","char":"👋🏻","name":"waving hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FC","char":"👋🏼","name":"waving hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FD","char":"👋🏽","name":"waving hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FE","char":"👋🏾","name":"waving hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FF","char":"👋🏿","name":"waving hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A","char":"🤚","name":"raised back of hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FB","char":"🤚🏻","name":"raised back of hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FC","char":"🤚🏼","name":"raised back of hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FD","char":"🤚🏽","name":"raised back of hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FE","char":"🤚🏾","name":"raised back of hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FF","char":"🤚🏿","name":"raised back of hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 FE0F","char":"🖐️","name":"hand with fingers splayed","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590","char":"🖐","name":"hand with fingers splayed","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FB","char":"🖐🏻","name":"hand with fingers splayed: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FC","char":"🖐🏼","name":"hand with fingers splayed: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FD","char":"🖐🏽","name":"hand with fingers splayed: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FE","char":"🖐🏾","name":"hand with fingers splayed: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FF","char":"🖐🏿","name":"hand with fingers splayed: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B","char":"✋","name":"raised hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FB","char":"✋🏻","name":"raised hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FC","char":"✋🏼","name":"raised hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FD","char":"✋🏽","name":"raised hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FE","char":"✋🏾","name":"raised hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FF","char":"✋🏿","name":"raised hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596","char":"🖖","name":"vulcan salute","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FB","char":"🖖🏻","name":"vulcan salute: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FC","char":"🖖🏼","name":"vulcan salute: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FD","char":"🖖🏽","name":"vulcan salute: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FE","char":"🖖🏾","name":"vulcan salute: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FF","char":"🖖🏿","name":"vulcan salute: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1","char":"🫱","name":"rightwards hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FB","char":"🫱🏻","name":"rightwards hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FC","char":"🫱🏼","name":"rightwards hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FD","char":"🫱🏽","name":"rightwards hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FE","char":"🫱🏾","name":"rightwards hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FF","char":"🫱🏿","name":"rightwards hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2","char":"🫲","name":"leftwards hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FB","char":"🫲🏻","name":"leftwards hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FC","char":"🫲🏼","name":"leftwards hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FD","char":"🫲🏽","name":"leftwards hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FE","char":"🫲🏾","name":"leftwards hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FF","char":"🫲🏿","name":"leftwards hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3","char":"🫳","name":"palm down hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FB","char":"🫳🏻","name":"palm down hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FC","char":"🫳🏼","name":"palm down hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FD","char":"🫳🏽","name":"palm down hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FE","char":"🫳🏾","name":"palm down hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FF","char":"🫳🏿","name":"palm down hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4","char":"🫴","name":"palm up hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FB","char":"🫴🏻","name":"palm up hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FC","char":"🫴🏼","name":"palm up hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FD","char":"🫴🏽","name":"palm up hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FE","char":"🫴🏾","name":"palm up hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FF","char":"🫴🏿","name":"palm up hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7","char":"🫷","name":"leftwards pushing hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FB","char":"🫷🏻","name":"leftwards pushing hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FC","char":"🫷🏼","name":"leftwards pushing hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FD","char":"🫷🏽","name":"leftwards pushing hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FE","char":"🫷🏾","name":"leftwards pushing hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FF","char":"🫷🏿","name":"leftwards pushing hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8","char":"🫸","name":"rightwards pushing hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FB","char":"🫸🏻","name":"rightwards pushing hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FC","char":"🫸🏼","name":"rightwards pushing hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FD","char":"🫸🏽","name":"rightwards pushing hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FE","char":"🫸🏾","name":"rightwards pushing hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FF","char":"🫸🏿","name":"rightwards pushing hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44C","char":"👌","name":"OK hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FB","char":"👌🏻","name":"OK hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FC","char":"👌🏼","name":"OK hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FD","char":"👌🏽","name":"OK hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FE","char":"👌🏾","name":"OK hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FF","char":"👌🏿","name":"OK hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C","char":"🤌","name":"pinched fingers","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FB","char":"🤌🏻","name":"pinched fingers: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FC","char":"🤌🏼","name":"pinched fingers: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FD","char":"🤌🏽","name":"pinched fingers: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FE","char":"🤌🏾","name":"pinched fingers: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FF","char":"🤌🏿","name":"pinched fingers: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F","char":"🤏","name":"pinching hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FB","char":"🤏🏻","name":"pinching hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FC","char":"🤏🏼","name":"pinching hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FD","char":"🤏🏽","name":"pinching hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FE","char":"🤏🏾","name":"pinching hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FF","char":"🤏🏿","name":"pinching hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C FE0F","char":"✌️","name":"victory hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C","char":"✌","name":"victory hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FB","char":"✌🏻","name":"victory hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FC","char":"✌🏼","name":"victory hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FD","char":"✌🏽","name":"victory hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FE","char":"✌🏾","name":"victory hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FF","char":"✌🏿","name":"victory hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E","char":"🤞","name":"crossed fingers","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FB","char":"🤞🏻","name":"crossed fingers: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FC","char":"🤞🏼","name":"crossed fingers: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FD","char":"🤞🏽","name":"crossed fingers: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FE","char":"🤞🏾","name":"crossed fingers: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FF","char":"🤞🏿","name":"crossed fingers: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0","char":"🫰","name":"hand with index finger and thumb crossed","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FB","char":"🫰🏻","name":"hand with index finger and thumb crossed: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FC","char":"🫰🏼","name":"hand with index finger and thumb crossed: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FD","char":"🫰🏽","name":"hand with index finger and thumb crossed: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FE","char":"🫰🏾","name":"hand with index finger and thumb crossed: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FF","char":"🫰🏿","name":"hand with index finger and thumb crossed: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F","char":"🤟","name":"love-you gesture","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FB","char":"🤟🏻","name":"love-you gesture: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FC","char":"🤟🏼","name":"love-you gesture: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FD","char":"🤟🏽","name":"love-you gesture: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FE","char":"🤟🏾","name":"love-you gesture: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FF","char":"🤟🏿","name":"love-you gesture: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918","char":"🤘","name":"sign of the horns","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FB","char":"🤘🏻","name":"sign of the horns: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FC","char":"🤘🏼","name":"sign of the horns: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FD","char":"🤘🏽","name":"sign of the horns: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FE","char":"🤘🏾","name":"sign of the horns: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FF","char":"🤘🏿","name":"sign of the horns: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919","char":"🤙","name":"call me hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FB","char":"🤙🏻","name":"call me hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FC","char":"🤙🏼","name":"call me hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FD","char":"🤙🏽","name":"call me hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FE","char":"🤙🏾","name":"call me hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FF","char":"🤙🏿","name":"call me hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F448","char":"👈","name":"backhand index pointing left","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FB","char":"👈🏻","name":"backhand index pointing left: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FC","char":"👈🏼","name":"backhand index pointing left: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FD","char":"👈🏽","name":"backhand index pointing left: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FE","char":"👈🏾","name":"backhand index pointing left: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FF","char":"👈🏿","name":"backhand index pointing left: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449","char":"👉","name":"backhand index pointing right","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FB","char":"👉🏻","name":"backhand index pointing right: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FC","char":"👉🏼","name":"backhand index pointing right: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FD","char":"👉🏽","name":"backhand index pointing right: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FE","char":"👉🏾","name":"backhand index pointing right: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FF","char":"👉🏿","name":"backhand index pointing right: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446","char":"👆","name":"backhand index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FB","char":"👆🏻","name":"backhand index pointing up: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FC","char":"👆🏼","name":"backhand index pointing up: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FD","char":"👆🏽","name":"backhand index pointing up: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FE","char":"👆🏾","name":"backhand index pointing up: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FF","char":"👆🏿","name":"backhand index pointing up: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595","char":"🖕","name":"middle finger","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FB","char":"🖕🏻","name":"middle finger: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FC","char":"🖕🏼","name":"middle finger: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FD","char":"🖕🏽","name":"middle finger: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FE","char":"🖕🏾","name":"middle finger: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FF","char":"🖕🏿","name":"middle finger: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447","char":"👇","name":"backhand index pointing down","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FB","char":"👇🏻","name":"backhand index pointing down: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FC","char":"👇🏼","name":"backhand index pointing down: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FD","char":"👇🏽","name":"backhand index pointing down: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FE","char":"👇🏾","name":"backhand index pointing down: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FF","char":"👇🏿","name":"backhand index pointing down: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D FE0F","char":"☝️","name":"index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D","char":"☝","name":"index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FB","char":"☝🏻","name":"index pointing up: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FC","char":"☝🏼","name":"index pointing up: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FD","char":"☝🏽","name":"index pointing up: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FE","char":"☝🏾","name":"index pointing up: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FF","char":"☝🏿","name":"index pointing up: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5","char":"🫵","name":"index pointing at the viewer","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FB","char":"🫵🏻","name":"index pointing at the viewer: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FC","char":"🫵🏼","name":"index pointing at the viewer: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FD","char":"🫵🏽","name":"index pointing at the viewer: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FE","char":"🫵🏾","name":"index pointing at the viewer: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FF","char":"🫵🏿","name":"index pointing at the viewer: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F44D","char":"👍","name":"thumbs up","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FB","char":"👍🏻","name":"thumbs up: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FC","char":"👍🏼","name":"thumbs up: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FD","char":"👍🏽","name":"thumbs up: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FE","char":"👍🏾","name":"thumbs up: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FF","char":"👍🏿","name":"thumbs up: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E","char":"👎","name":"thumbs down","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FB","char":"👎🏻","name":"thumbs down: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FC","char":"👎🏼","name":"thumbs down: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FD","char":"👎🏽","name":"thumbs down: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FE","char":"👎🏾","name":"thumbs down: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FF","char":"👎🏿","name":"thumbs down: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A","char":"✊","name":"raised fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FB","char":"✊🏻","name":"raised fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FC","char":"✊🏼","name":"raised fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FD","char":"✊🏽","name":"raised fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FE","char":"✊🏾","name":"raised fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FF","char":"✊🏿","name":"raised fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A","char":"👊","name":"oncoming fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FB","char":"👊🏻","name":"oncoming fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FC","char":"👊🏼","name":"oncoming fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FD","char":"👊🏽","name":"oncoming fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FE","char":"👊🏾","name":"oncoming fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FF","char":"👊🏿","name":"oncoming fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B","char":"🤛","name":"left-facing fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FB","char":"🤛🏻","name":"left-facing fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FC","char":"🤛🏼","name":"left-facing fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FD","char":"🤛🏽","name":"left-facing fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FE","char":"🤛🏾","name":"left-facing fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FF","char":"🤛🏿","name":"left-facing fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C","char":"🤜","name":"right-facing fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FB","char":"🤜🏻","name":"right-facing fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FC","char":"🤜🏼","name":"right-facing fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FD","char":"🤜🏽","name":"right-facing fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FE","char":"🤜🏾","name":"right-facing fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FF","char":"🤜🏿","name":"right-facing fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44F","char":"👏","name":"clapping hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FB","char":"👏🏻","name":"clapping hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FC","char":"👏🏼","name":"clapping hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FD","char":"👏🏽","name":"clapping hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FE","char":"👏🏾","name":"clapping hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FF","char":"👏🏿","name":"clapping hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C","char":"🙌","name":"raising hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FB","char":"🙌🏻","name":"raising hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FC","char":"🙌🏼","name":"raising hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FD","char":"🙌🏽","name":"raising hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FE","char":"🙌🏾","name":"raising hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FF","char":"🙌🏿","name":"raising hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6","char":"🫶","name":"heart hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FB","char":"🫶🏻","name":"heart hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FC","char":"🫶🏼","name":"heart hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FD","char":"🫶🏽","name":"heart hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FE","char":"🫶🏾","name":"heart hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FF","char":"🫶🏿","name":"heart hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450","char":"👐","name":"open hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FB","char":"👐🏻","name":"open hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FC","char":"👐🏼","name":"open hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FD","char":"👐🏽","name":"open hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FE","char":"👐🏾","name":"open hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FF","char":"👐🏿","name":"open hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932","char":"🤲","name":"palms up together","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FB","char":"🤲🏻","name":"palms up together: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FC","char":"🤲🏼","name":"palms up together: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FD","char":"🤲🏽","name":"palms up together: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FE","char":"🤲🏾","name":"palms up together: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FF","char":"🤲🏿","name":"palms up together: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D","char":"🤝","name":"handshake","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FB","char":"🤝🏻","name":"handshake: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FC","char":"🤝🏼","name":"handshake: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FD","char":"🤝🏽","name":"handshake: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FE","char":"🤝🏾","name":"handshake: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FF","char":"🤝🏿","name":"handshake: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FC","char":"🫱🏻‍🫲🏼","name":"handshake: light skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FD","char":"🫱🏻‍🫲🏽","name":"handshake: light skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FE","char":"🫱🏻‍🫲🏾","name":"handshake: light skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FF","char":"🫱🏻‍🫲🏿","name":"handshake: light skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FB","char":"🫱🏼‍🫲🏻","name":"handshake: medium-light skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FD","char":"🫱🏼‍🫲🏽","name":"handshake: medium-light skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FE","char":"🫱🏼‍🫲🏾","name":"handshake: medium-light skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FF","char":"🫱🏼‍🫲🏿","name":"handshake: medium-light skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FB","char":"🫱🏽‍🫲🏻","name":"handshake: medium skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FC","char":"🫱🏽‍🫲🏼","name":"handshake: medium skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FE","char":"🫱🏽‍🫲🏾","name":"handshake: medium skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FF","char":"🫱🏽‍🫲🏿","name":"handshake: medium skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FB","char":"🫱🏾‍🫲🏻","name":"handshake: medium-dark skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FC","char":"🫱🏾‍🫲🏼","name":"handshake: medium-dark skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FD","char":"🫱🏾‍🫲🏽","name":"handshake: medium-dark skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FF","char":"🫱🏾‍🫲🏿","name":"handshake: medium-dark skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FB","char":"🫱🏿‍🫲🏻","name":"handshake: dark skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FC","char":"🫱🏿‍🫲🏼","name":"handshake: dark skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FD","char":"🫱🏿‍🫲🏽","name":"handshake: dark skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FE","char":"🫱🏿‍🫲🏾","name":"handshake: dark skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F","char":"🙏","name":"folded hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FB","char":"🙏🏻","name":"folded hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FC","char":"🙏🏼","name":"folded hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FD","char":"🙏🏽","name":"folded hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FE","char":"🙏🏾","name":"folded hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FF","char":"🙏🏿","name":"folded hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"270D FE0F","char":"✍️","name":"writing hand","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D","char":"✍","name":"writing hand","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FB","char":"✍🏻","name":"writing hand: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FC","char":"✍🏼","name":"writing hand: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FD","char":"✍🏽","name":"writing hand: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FE","char":"✍🏾","name":"writing hand: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FF","char":"✍🏿","name":"writing hand: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485","char":"💅","name":"nail polish","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FB","char":"💅🏻","name":"nail polish: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FC","char":"💅🏼","name":"nail polish: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FD","char":"💅🏽","name":"nail polish: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FE","char":"💅🏾","name":"nail polish: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FF","char":"💅🏿","name":"nail polish: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933","char":"🤳","name":"selfie","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FB","char":"🤳🏻","name":"selfie: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FC","char":"🤳🏼","name":"selfie: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FD","char":"🤳🏽","name":"selfie: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FE","char":"🤳🏾","name":"selfie: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FF","char":"🤳🏿","name":"selfie: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F4AA","char":"💪","name":"flexed biceps","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FB","char":"💪🏻","name":"flexed biceps: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FC","char":"💪🏼","name":"flexed biceps: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FD","char":"💪🏽","name":"flexed biceps: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FE","char":"💪🏾","name":"flexed biceps: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FF","char":"💪🏿","name":"flexed biceps: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BE","char":"🦾","name":"mechanical arm","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BF","char":"🦿","name":"mechanical leg","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5","char":"🦵","name":"leg","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FB","char":"🦵🏻","name":"leg: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FC","char":"🦵🏼","name":"leg: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FD","char":"🦵🏽","name":"leg: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FE","char":"🦵🏾","name":"leg: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FF","char":"🦵🏿","name":"leg: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6","char":"🦶","name":"foot","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FB","char":"🦶🏻","name":"foot: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FC","char":"🦶🏼","name":"foot: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FD","char":"🦶🏽","name":"foot: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FE","char":"🦶🏾","name":"foot: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FF","char":"🦶🏿","name":"foot: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442","char":"👂","name":"ear","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FB","char":"👂🏻","name":"ear: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FC","char":"👂🏼","name":"ear: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FD","char":"👂🏽","name":"ear: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FE","char":"👂🏾","name":"ear: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FF","char":"👂🏿","name":"ear: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB","char":"🦻","name":"ear with hearing aid","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FB","char":"🦻🏻","name":"ear with hearing aid: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FC","char":"🦻🏼","name":"ear with hearing aid: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FD","char":"🦻🏽","name":"ear with hearing aid: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FE","char":"🦻🏾","name":"ear with hearing aid: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FF","char":"🦻🏿","name":"ear with hearing aid: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443","char":"👃","name":"nose","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FB","char":"👃🏻","name":"nose: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FC","char":"👃🏼","name":"nose: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FD","char":"👃🏽","name":"nose: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FE","char":"👃🏾","name":"nose: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FF","char":"👃🏿","name":"nose: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9E0","char":"🧠","name":"brain","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAC0","char":"🫀","name":"anatomical heart","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAC1","char":"🫁","name":"lungs","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B7","char":"🦷","name":"tooth","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B4","char":"🦴","name":"bone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F440","char":"👀","name":"eyes","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F441 FE0F","char":"👁️","name":"eye","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F441","char":"👁","name":"eye","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F445","char":"👅","name":"tongue","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F444","char":"👄","name":"mouth","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAE6","char":"🫦","name":"biting lip","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F476","char":"👶","name":"baby","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FB","char":"👶🏻","name":"baby: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FC","char":"👶🏼","name":"baby: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FD","char":"👶🏽","name":"baby: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FE","char":"👶🏾","name":"baby: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FF","char":"👶🏿","name":"baby: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2","char":"🧒","name":"child","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FB","char":"🧒🏻","name":"child: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FC","char":"🧒🏼","name":"child: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FD","char":"🧒🏽","name":"child: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FE","char":"🧒🏾","name":"child: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FF","char":"🧒🏿","name":"child: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466","char":"👦","name":"boy","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FB","char":"👦🏻","name":"boy: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FC","char":"👦🏼","name":"boy: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FD","char":"👦🏽","name":"boy: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FE","char":"👦🏾","name":"boy: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FF","char":"👦🏿","name":"boy: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467","char":"👧","name":"girl","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FB","char":"👧🏻","name":"girl: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FC","char":"👧🏼","name":"girl: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FD","char":"👧🏽","name":"girl: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FE","char":"👧🏾","name":"girl: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FF","char":"👧🏿","name":"girl: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1","char":"🧑","name":"person","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB","char":"🧑🏻","name":"person: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC","char":"🧑🏼","name":"person: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD","char":"🧑🏽","name":"person: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE","char":"🧑🏾","name":"person: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF","char":"🧑🏿","name":"person: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471","char":"👱","name":"person: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB","char":"👱🏻","name":"person: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC","char":"👱🏼","name":"person: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD","char":"👱🏽","name":"person: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE","char":"👱🏾","name":"person: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF","char":"👱🏿","name":"person: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468","char":"👨","name":"man","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB","char":"👨🏻","name":"man: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC","char":"👨🏼","name":"man: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD","char":"👨🏽","name":"man: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE","char":"👨🏾","name":"man: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF","char":"👨🏿","name":"man: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4","char":"🧔","name":"person: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB","char":"🧔🏻","name":"person: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC","char":"🧔🏼","name":"person: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD","char":"🧔🏽","name":"person: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE","char":"🧔🏾","name":"person: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF","char":"🧔🏿","name":"person: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2642 FE0F","char":"🧔‍♂️","name":"man: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2642","char":"🧔‍♂","name":"man: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2642 FE0F","char":"🧔🏻‍♂️","name":"man: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2642","char":"🧔🏻‍♂","name":"man: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2642 FE0F","char":"🧔🏼‍♂️","name":"man: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2642","char":"🧔🏼‍♂","name":"man: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2642 FE0F","char":"🧔🏽‍♂️","name":"man: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2642","char":"🧔🏽‍♂","name":"man: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2642 FE0F","char":"🧔🏾‍♂️","name":"man: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2642","char":"🧔🏾‍♂","name":"man: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2642 FE0F","char":"🧔🏿‍♂️","name":"man: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2642","char":"🧔🏿‍♂","name":"man: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2640 FE0F","char":"🧔‍♀️","name":"woman: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2640","char":"🧔‍♀","name":"woman: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2640 FE0F","char":"🧔🏻‍♀️","name":"woman: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2640","char":"🧔🏻‍♀","name":"woman: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2640 FE0F","char":"🧔🏼‍♀️","name":"woman: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2640","char":"🧔🏼‍♀","name":"woman: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2640 FE0F","char":"🧔🏽‍♀️","name":"woman: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2640","char":"🧔🏽‍♀","name":"woman: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2640 FE0F","char":"🧔🏾‍♀️","name":"woman: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2640","char":"🧔🏾‍♀","name":"woman: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2640 FE0F","char":"🧔🏿‍♀️","name":"woman: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2640","char":"🧔🏿‍♀","name":"woman: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B0","char":"👨‍🦰","name":"man: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B0","char":"👨🏻‍🦰","name":"man: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B0","char":"👨🏼‍🦰","name":"man: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B0","char":"👨🏽‍🦰","name":"man: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B0","char":"👨🏾‍🦰","name":"man: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B0","char":"👨🏿‍🦰","name":"man: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B1","char":"👨‍🦱","name":"man: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B1","char":"👨🏻‍🦱","name":"man: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B1","char":"👨🏼‍🦱","name":"man: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B1","char":"👨🏽‍🦱","name":"man: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B1","char":"👨🏾‍🦱","name":"man: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B1","char":"👨🏿‍🦱","name":"man: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B3","char":"👨‍🦳","name":"man: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B3","char":"👨🏻‍🦳","name":"man: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B3","char":"👨🏼‍🦳","name":"man: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B3","char":"👨🏽‍🦳","name":"man: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B3","char":"👨🏾‍🦳","name":"man: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B3","char":"👨🏿‍🦳","name":"man: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B2","char":"👨‍🦲","name":"man: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B2","char":"👨🏻‍🦲","name":"man: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B2","char":"👨🏼‍🦲","name":"man: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B2","char":"👨🏽‍🦲","name":"man: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B2","char":"👨🏾‍🦲","name":"man: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B2","char":"👨🏿‍🦲","name":"man: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469","char":"👩","name":"woman","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB","char":"👩🏻","name":"woman: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC","char":"👩🏼","name":"woman: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD","char":"👩🏽","name":"woman: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE","char":"👩🏾","name":"woman: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF","char":"👩🏿","name":"woman: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B0","char":"👩‍🦰","name":"woman: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B0","char":"👩🏻‍🦰","name":"woman: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B0","char":"👩🏼‍🦰","name":"woman: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B0","char":"👩🏽‍🦰","name":"woman: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B0","char":"👩🏾‍🦰","name":"woman: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B0","char":"👩🏿‍🦰","name":"woman: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B0","char":"🧑‍🦰","name":"person: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B0","char":"🧑🏻‍🦰","name":"person: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B0","char":"🧑🏼‍🦰","name":"person: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B0","char":"🧑🏽‍🦰","name":"person: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B0","char":"🧑🏾‍🦰","name":"person: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B0","char":"🧑🏿‍🦰","name":"person: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B1","char":"👩‍🦱","name":"woman: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B1","char":"👩🏻‍🦱","name":"woman: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B1","char":"👩🏼‍🦱","name":"woman: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B1","char":"👩🏽‍🦱","name":"woman: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B1","char":"👩🏾‍🦱","name":"woman: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B1","char":"👩🏿‍🦱","name":"woman: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B1","char":"🧑‍🦱","name":"person: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B1","char":"🧑🏻‍🦱","name":"person: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B1","char":"🧑🏼‍🦱","name":"person: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B1","char":"🧑🏽‍🦱","name":"person: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B1","char":"🧑🏾‍🦱","name":"person: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B1","char":"🧑🏿‍🦱","name":"person: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B3","char":"👩‍🦳","name":"woman: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B3","char":"👩🏻‍🦳","name":"woman: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B3","char":"👩🏼‍🦳","name":"woman: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B3","char":"👩🏽‍🦳","name":"woman: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B3","char":"👩🏾‍🦳","name":"woman: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B3","char":"👩🏿‍🦳","name":"woman: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B3","char":"🧑‍🦳","name":"person: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B3","char":"🧑🏻‍🦳","name":"person: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B3","char":"🧑🏼‍🦳","name":"person: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B3","char":"🧑🏽‍🦳","name":"person: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B3","char":"🧑🏾‍🦳","name":"person: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B3","char":"🧑🏿‍🦳","name":"person: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B2","char":"👩‍🦲","name":"woman: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B2","char":"👩🏻‍🦲","name":"woman: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B2","char":"👩🏼‍🦲","name":"woman: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B2","char":"👩🏽‍🦲","name":"woman: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B2","char":"👩🏾‍🦲","name":"woman: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B2","char":"👩🏿‍🦲","name":"woman: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B2","char":"🧑‍🦲","name":"person: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B2","char":"🧑🏻‍🦲","name":"person: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B2","char":"🧑🏼‍🦲","name":"person: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B2","char":"🧑🏽‍🦲","name":"person: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B2","char":"🧑🏾‍🦲","name":"person: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B2","char":"🧑🏿‍🦲","name":"person: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2640 FE0F","char":"👱‍♀️","name":"woman: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2640","char":"👱‍♀","name":"woman: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2640 FE0F","char":"👱🏻‍♀️","name":"woman: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2640","char":"👱🏻‍♀","name":"woman: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2640 FE0F","char":"👱🏼‍♀️","name":"woman: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2640","char":"👱🏼‍♀","name":"woman: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2640 FE0F","char":"👱🏽‍♀️","name":"woman: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2640","char":"👱🏽‍♀","name":"woman: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2640 FE0F","char":"👱🏾‍♀️","name":"woman: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2640","char":"👱🏾‍♀","name":"woman: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2640 FE0F","char":"👱🏿‍♀️","name":"woman: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2640","char":"👱🏿‍♀","name":"woman: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2642 FE0F","char":"👱‍♂️","name":"man: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2642","char":"👱‍♂","name":"man: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2642 FE0F","char":"👱🏻‍♂️","name":"man: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2642","char":"👱🏻‍♂","name":"man: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2642 FE0F","char":"👱🏼‍♂️","name":"man: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2642","char":"👱🏼‍♂","name":"man: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2642 FE0F","char":"👱🏽‍♂️","name":"man: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2642","char":"👱🏽‍♂","name":"man: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2642 FE0F","char":"👱🏾‍♂️","name":"man: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2642","char":"👱🏾‍♂","name":"man: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2642 FE0F","char":"👱🏿‍♂️","name":"man: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2642","char":"👱🏿‍♂","name":"man: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3","char":"🧓","name":"older person","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FB","char":"🧓🏻","name":"older person: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FC","char":"🧓🏼","name":"older person: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FD","char":"🧓🏽","name":"older person: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FE","char":"🧓🏾","name":"older person: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FF","char":"🧓🏿","name":"older person: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474","char":"👴","name":"old man","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FB","char":"👴🏻","name":"old man: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FC","char":"👴🏼","name":"old man: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FD","char":"👴🏽","name":"old man: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FE","char":"👴🏾","name":"old man: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FF","char":"👴🏿","name":"old man: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475","char":"👵","name":"old woman","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FB","char":"👵🏻","name":"old woman: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FC","char":"👵🏼","name":"old woman: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FD","char":"👵🏽","name":"old woman: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FE","char":"👵🏾","name":"old woman: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FF","char":"👵🏿","name":"old woman: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F64D","char":"🙍","name":"person frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB","char":"🙍🏻","name":"person frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC","char":"🙍🏼","name":"person frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD","char":"🙍🏽","name":"person frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE","char":"🙍🏾","name":"person frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF","char":"🙍🏿","name":"person frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2642 FE0F","char":"🙍‍♂️","name":"man frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2642","char":"🙍‍♂","name":"man frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2642 FE0F","char":"🙍🏻‍♂️","name":"man frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2642","char":"🙍🏻‍♂","name":"man frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2642 FE0F","char":"🙍🏼‍♂️","name":"man frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2642","char":"🙍🏼‍♂","name":"man frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2642 FE0F","char":"🙍🏽‍♂️","name":"man frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2642","char":"🙍🏽‍♂","name":"man frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2642 FE0F","char":"🙍🏾‍♂️","name":"man frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2642","char":"🙍🏾‍♂","name":"man frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2642 FE0F","char":"🙍🏿‍♂️","name":"man frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2642","char":"🙍🏿‍♂","name":"man frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2640 FE0F","char":"🙍‍♀️","name":"woman frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2640","char":"🙍‍♀","name":"woman frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2640 FE0F","char":"🙍🏻‍♀️","name":"woman frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2640","char":"🙍🏻‍♀","name":"woman frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2640 FE0F","char":"🙍🏼‍♀️","name":"woman frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2640","char":"🙍🏼‍♀","name":"woman frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2640 FE0F","char":"🙍🏽‍♀️","name":"woman frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2640","char":"🙍🏽‍♀","name":"woman frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2640 FE0F","char":"🙍🏾‍♀️","name":"woman frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2640","char":"🙍🏾‍♀","name":"woman frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2640 FE0F","char":"🙍🏿‍♀️","name":"woman frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2640","char":"🙍🏿‍♀","name":"woman frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E","char":"🙎","name":"person pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB","char":"🙎🏻","name":"person pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC","char":"🙎🏼","name":"person pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD","char":"🙎🏽","name":"person pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE","char":"🙎🏾","name":"person pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF","char":"🙎🏿","name":"person pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2642 FE0F","char":"🙎‍♂️","name":"man pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2642","char":"🙎‍♂","name":"man pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2642 FE0F","char":"🙎🏻‍♂️","name":"man pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2642","char":"🙎🏻‍♂","name":"man pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2642 FE0F","char":"🙎🏼‍♂️","name":"man pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2642","char":"🙎🏼‍♂","name":"man pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2642 FE0F","char":"🙎🏽‍♂️","name":"man pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2642","char":"🙎🏽‍♂","name":"man pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2642 FE0F","char":"🙎🏾‍♂️","name":"man pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2642","char":"🙎🏾‍♂","name":"man pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2642 FE0F","char":"🙎🏿‍♂️","name":"man pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2642","char":"🙎🏿‍♂","name":"man pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2640 FE0F","char":"🙎‍♀️","name":"woman pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2640","char":"🙎‍♀","name":"woman pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2640 FE0F","char":"🙎🏻‍♀️","name":"woman pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2640","char":"🙎🏻‍♀","name":"woman pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2640 FE0F","char":"🙎🏼‍♀️","name":"woman pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2640","char":"🙎🏼‍♀","name":"woman pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2640 FE0F","char":"🙎🏽‍♀️","name":"woman pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2640","char":"🙎🏽‍♀","name":"woman pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2640 FE0F","char":"🙎🏾‍♀️","name":"woman pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2640","char":"🙎🏾‍♀","name":"woman pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2640 FE0F","char":"🙎🏿‍♀️","name":"woman pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2640","char":"🙎🏿‍♀","name":"woman pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645","char":"🙅","name":"person gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB","char":"🙅🏻","name":"person gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC","char":"🙅🏼","name":"person gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD","char":"🙅🏽","name":"person gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE","char":"🙅🏾","name":"person gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF","char":"🙅🏿","name":"person gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2642 FE0F","char":"🙅‍♂️","name":"man gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2642","char":"🙅‍♂","name":"man gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2642 FE0F","char":"🙅🏻‍♂️","name":"man gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2642","char":"🙅🏻‍♂","name":"man gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2642 FE0F","char":"🙅🏼‍♂️","name":"man gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2642","char":"🙅🏼‍♂","name":"man gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2642 FE0F","char":"🙅🏽‍♂️","name":"man gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2642","char":"🙅🏽‍♂","name":"man gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2642 FE0F","char":"🙅🏾‍♂️","name":"man gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2642","char":"🙅🏾‍♂","name":"man gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2642 FE0F","char":"🙅🏿‍♂️","name":"man gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2642","char":"🙅🏿‍♂","name":"man gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2640 FE0F","char":"🙅‍♀️","name":"woman gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2640","char":"🙅‍♀","name":"woman gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2640 FE0F","char":"🙅🏻‍♀️","name":"woman gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2640","char":"🙅🏻‍♀","name":"woman gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2640 FE0F","char":"🙅🏼‍♀️","name":"woman gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2640","char":"🙅🏼‍♀","name":"woman gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2640 FE0F","char":"🙅🏽‍♀️","name":"woman gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2640","char":"🙅🏽‍♀","name":"woman gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2640 FE0F","char":"🙅🏾‍♀️","name":"woman gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2640","char":"🙅🏾‍♀","name":"woman gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2640 FE0F","char":"🙅🏿‍♀️","name":"woman gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2640","char":"🙅🏿‍♀","name":"woman gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646","char":"🙆","name":"person gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB","char":"🙆🏻","name":"person gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC","char":"🙆🏼","name":"person gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD","char":"🙆🏽","name":"person gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE","char":"🙆🏾","name":"person gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF","char":"🙆🏿","name":"person gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2642 FE0F","char":"🙆‍♂️","name":"man gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2642","char":"🙆‍♂","name":"man gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2642 FE0F","char":"🙆🏻‍♂️","name":"man gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2642","char":"🙆🏻‍♂","name":"man gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2642 FE0F","char":"🙆🏼‍♂️","name":"man gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2642","char":"🙆🏼‍♂","name":"man gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2642 FE0F","char":"🙆🏽‍♂️","name":"man gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2642","char":"🙆🏽‍♂","name":"man gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2642 FE0F","char":"🙆🏾‍♂️","name":"man gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2642","char":"🙆🏾‍♂","name":"man gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2642 FE0F","char":"🙆🏿‍♂️","name":"man gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2642","char":"🙆🏿‍♂","name":"man gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2640 FE0F","char":"🙆‍♀️","name":"woman gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2640","char":"🙆‍♀","name":"woman gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2640 FE0F","char":"🙆🏻‍♀️","name":"woman gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2640","char":"🙆🏻‍♀","name":"woman gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2640 FE0F","char":"🙆🏼‍♀️","name":"woman gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2640","char":"🙆🏼‍♀","name":"woman gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2640 FE0F","char":"🙆🏽‍♀️","name":"woman gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2640","char":"🙆🏽‍♀","name":"woman gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2640 FE0F","char":"🙆🏾‍♀️","name":"woman gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2640","char":"🙆🏾‍♀","name":"woman gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2640 FE0F","char":"🙆🏿‍♀️","name":"woman gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2640","char":"🙆🏿‍♀","name":"woman gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481","char":"💁","name":"person tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB","char":"💁🏻","name":"person tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC","char":"💁🏼","name":"person tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD","char":"💁🏽","name":"person tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE","char":"💁🏾","name":"person tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF","char":"💁🏿","name":"person tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2642 FE0F","char":"💁‍♂️","name":"man tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2642","char":"💁‍♂","name":"man tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2642 FE0F","char":"💁🏻‍♂️","name":"man tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2642","char":"💁🏻‍♂","name":"man tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2642 FE0F","char":"💁🏼‍♂️","name":"man tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2642","char":"💁🏼‍♂","name":"man tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2642 FE0F","char":"💁🏽‍♂️","name":"man tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2642","char":"💁🏽‍♂","name":"man tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2642 FE0F","char":"💁🏾‍♂️","name":"man tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2642","char":"💁🏾‍♂","name":"man tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2642 FE0F","char":"💁🏿‍♂️","name":"man tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2642","char":"💁🏿‍♂","name":"man tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2640 FE0F","char":"💁‍♀️","name":"woman tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2640","char":"💁‍♀","name":"woman tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2640 FE0F","char":"💁🏻‍♀️","name":"woman tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2640","char":"💁🏻‍♀","name":"woman tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2640 FE0F","char":"💁🏼‍♀️","name":"woman tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2640","char":"💁🏼‍♀","name":"woman tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2640 FE0F","char":"💁🏽‍♀️","name":"woman tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2640","char":"💁🏽‍♀","name":"woman tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2640 FE0F","char":"💁🏾‍♀️","name":"woman tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2640","char":"💁🏾‍♀","name":"woman tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2640 FE0F","char":"💁🏿‍♀️","name":"woman tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2640","char":"💁🏿‍♀","name":"woman tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B","char":"🙋","name":"person raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB","char":"🙋🏻","name":"person raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC","char":"🙋🏼","name":"person raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD","char":"🙋🏽","name":"person raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE","char":"🙋🏾","name":"person raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF","char":"🙋🏿","name":"person raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2642 FE0F","char":"🙋‍♂️","name":"man raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2642","char":"🙋‍♂","name":"man raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2642 FE0F","char":"🙋🏻‍♂️","name":"man raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2642","char":"🙋🏻‍♂","name":"man raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2642 FE0F","char":"🙋🏼‍♂️","name":"man raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2642","char":"🙋🏼‍♂","name":"man raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2642 FE0F","char":"🙋🏽‍♂️","name":"man raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2642","char":"🙋🏽‍♂","name":"man raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2642 FE0F","char":"🙋🏾‍♂️","name":"man raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2642","char":"🙋🏾‍♂","name":"man raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2642 FE0F","char":"🙋🏿‍♂️","name":"man raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2642","char":"🙋🏿‍♂","name":"man raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2640 FE0F","char":"🙋‍♀️","name":"woman raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2640","char":"🙋‍♀","name":"woman raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2640 FE0F","char":"🙋🏻‍♀️","name":"woman raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2640","char":"🙋🏻‍♀","name":"woman raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2640 FE0F","char":"🙋🏼‍♀️","name":"woman raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2640","char":"🙋🏼‍♀","name":"woman raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2640 FE0F","char":"🙋🏽‍♀️","name":"woman raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2640","char":"🙋🏽‍♀","name":"woman raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2640 FE0F","char":"🙋🏾‍♀️","name":"woman raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2640","char":"🙋🏾‍♀","name":"woman raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2640 FE0F","char":"🙋🏿‍♀️","name":"woman raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2640","char":"🙋🏿‍♀","name":"woman raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF","char":"🧏","name":"deaf person","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB","char":"🧏🏻","name":"deaf person: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC","char":"🧏🏼","name":"deaf person: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD","char":"🧏🏽","name":"deaf person: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE","char":"🧏🏾","name":"deaf person: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF","char":"🧏🏿","name":"deaf person: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2642 FE0F","char":"🧏‍♂️","name":"deaf man","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2642","char":"🧏‍♂","name":"deaf man","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2642 FE0F","char":"🧏🏻‍♂️","name":"deaf man: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2642","char":"🧏🏻‍♂","name":"deaf man: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2642 FE0F","char":"🧏🏼‍♂️","name":"deaf man: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2642","char":"🧏🏼‍♂","name":"deaf man: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2642 FE0F","char":"🧏🏽‍♂️","name":"deaf man: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2642","char":"🧏🏽‍♂","name":"deaf man: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2642 FE0F","char":"🧏🏾‍♂️","name":"deaf man: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2642","char":"🧏🏾‍♂","name":"deaf man: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2642 FE0F","char":"🧏🏿‍♂️","name":"deaf man: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2642","char":"🧏🏿‍♂","name":"deaf man: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2640 FE0F","char":"🧏‍♀️","name":"deaf woman","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2640","char":"🧏‍♀","name":"deaf woman","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2640 FE0F","char":"🧏🏻‍♀️","name":"deaf woman: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2640","char":"🧏🏻‍♀","name":"deaf woman: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2640 FE0F","char":"🧏🏼‍♀️","name":"deaf woman: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2640","char":"🧏🏼‍♀","name":"deaf woman: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2640 FE0F","char":"🧏🏽‍♀️","name":"deaf woman: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2640","char":"🧏🏽‍♀","name":"deaf woman: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2640 FE0F","char":"🧏🏾‍♀️","name":"deaf woman: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2640","char":"🧏🏾‍♀","name":"deaf woman: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2640 FE0F","char":"🧏🏿‍♀️","name":"deaf woman: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2640","char":"🧏🏿‍♀","name":"deaf woman: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647","char":"🙇","name":"person bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB","char":"🙇🏻","name":"person bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC","char":"🙇🏼","name":"person bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD","char":"🙇🏽","name":"person bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE","char":"🙇🏾","name":"person bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF","char":"🙇🏿","name":"person bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2642 FE0F","char":"🙇‍♂️","name":"man bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2642","char":"🙇‍♂","name":"man bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2642 FE0F","char":"🙇🏻‍♂️","name":"man bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2642","char":"🙇🏻‍♂","name":"man bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2642 FE0F","char":"🙇🏼‍♂️","name":"man bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2642","char":"🙇🏼‍♂","name":"man bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2642 FE0F","char":"🙇🏽‍♂️","name":"man bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2642","char":"🙇🏽‍♂","name":"man bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2642 FE0F","char":"🙇🏾‍♂️","name":"man bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2642","char":"🙇🏾‍♂","name":"man bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2642 FE0F","char":"🙇🏿‍♂️","name":"man bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2642","char":"🙇🏿‍♂","name":"man bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2640 FE0F","char":"🙇‍♀️","name":"woman bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2640","char":"🙇‍♀","name":"woman bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2640 FE0F","char":"🙇🏻‍♀️","name":"woman bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2640","char":"🙇🏻‍♀","name":"woman bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2640 FE0F","char":"🙇🏼‍♀️","name":"woman bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2640","char":"🙇🏼‍♀","name":"woman bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2640 FE0F","char":"🙇🏽‍♀️","name":"woman bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2640","char":"🙇🏽‍♀","name":"woman bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2640 FE0F","char":"🙇🏾‍♀️","name":"woman bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2640","char":"🙇🏾‍♀","name":"woman bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2640 FE0F","char":"🙇🏿‍♀️","name":"woman bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2640","char":"🙇🏿‍♀","name":"woman bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926","char":"🤦","name":"person facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB","char":"🤦🏻","name":"person facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC","char":"🤦🏼","name":"person facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD","char":"🤦🏽","name":"person facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE","char":"🤦🏾","name":"person facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF","char":"🤦🏿","name":"person facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2642 FE0F","char":"🤦‍♂️","name":"man facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2642","char":"🤦‍♂","name":"man facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2642 FE0F","char":"🤦🏻‍♂️","name":"man facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2642","char":"🤦🏻‍♂","name":"man facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2642 FE0F","char":"🤦🏼‍♂️","name":"man facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2642","char":"🤦🏼‍♂","name":"man facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2642 FE0F","char":"🤦🏽‍♂️","name":"man facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2642","char":"🤦🏽‍♂","name":"man facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2642 FE0F","char":"🤦🏾‍♂️","name":"man facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2642","char":"🤦🏾‍♂","name":"man facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2642 FE0F","char":"🤦🏿‍♂️","name":"man facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2642","char":"🤦🏿‍♂","name":"man facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2640 FE0F","char":"🤦‍♀️","name":"woman facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2640","char":"🤦‍♀","name":"woman facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2640 FE0F","char":"🤦🏻‍♀️","name":"woman facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2640","char":"🤦🏻‍♀","name":"woman facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2640 FE0F","char":"🤦🏼‍♀️","name":"woman facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2640","char":"🤦🏼‍♀","name":"woman facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2640 FE0F","char":"🤦🏽‍♀️","name":"woman facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2640","char":"🤦🏽‍♀","name":"woman facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2640 FE0F","char":"🤦🏾‍♀️","name":"woman facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2640","char":"🤦🏾‍♀","name":"woman facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2640 FE0F","char":"🤦🏿‍♀️","name":"woman facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2640","char":"🤦🏿‍♀","name":"woman facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937","char":"🤷","name":"person shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB","char":"🤷🏻","name":"person shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC","char":"🤷🏼","name":"person shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD","char":"🤷🏽","name":"person shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE","char":"🤷🏾","name":"person shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF","char":"🤷🏿","name":"person shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2642 FE0F","char":"🤷‍♂️","name":"man shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2642","char":"🤷‍♂","name":"man shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2642 FE0F","char":"🤷🏻‍♂️","name":"man shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2642","char":"🤷🏻‍♂","name":"man shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2642 FE0F","char":"🤷🏼‍♂️","name":"man shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2642","char":"🤷🏼‍♂","name":"man shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2642 FE0F","char":"🤷🏽‍♂️","name":"man shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2642","char":"🤷🏽‍♂","name":"man shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2642 FE0F","char":"🤷🏾‍♂️","name":"man shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2642","char":"🤷🏾‍♂","name":"man shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2642 FE0F","char":"🤷🏿‍♂️","name":"man shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2642","char":"🤷🏿‍♂","name":"man shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2640 FE0F","char":"🤷‍♀️","name":"woman shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2640","char":"🤷‍♀","name":"woman shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2640 FE0F","char":"🤷🏻‍♀️","name":"woman shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2640","char":"🤷🏻‍♀","name":"woman shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2640 FE0F","char":"🤷🏼‍♀️","name":"woman shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2640","char":"🤷🏼‍♀","name":"woman shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2640 FE0F","char":"🤷🏽‍♀️","name":"woman shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2640","char":"🤷🏽‍♀","name":"woman shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2640 FE0F","char":"🤷🏾‍♀️","name":"woman shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2640","char":"🤷🏾‍♀","name":"woman shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2640 FE0F","char":"🤷🏿‍♀️","name":"woman shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2640","char":"🤷🏿‍♀","name":"woman shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9D1 200D 2695 FE0F","char":"🧑‍⚕️","name":"health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2695","char":"🧑‍⚕","name":"health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2695 FE0F","char":"🧑🏻‍⚕️","name":"health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2695","char":"🧑🏻‍⚕","name":"health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2695 FE0F","char":"🧑🏼‍⚕️","name":"health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2695","char":"🧑🏼‍⚕","name":"health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2695 FE0F","char":"🧑🏽‍⚕️","name":"health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2695","char":"🧑🏽‍⚕","name":"health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2695 FE0F","char":"🧑🏾‍⚕️","name":"health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2695","char":"🧑🏾‍⚕","name":"health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2695 FE0F","char":"🧑🏿‍⚕️","name":"health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2695","char":"🧑🏿‍⚕","name":"health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2695 FE0F","char":"👨‍⚕️","name":"man health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2695","char":"👨‍⚕","name":"man health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2695 FE0F","char":"👨🏻‍⚕️","name":"man health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2695","char":"👨🏻‍⚕","name":"man health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2695 FE0F","char":"👨🏼‍⚕️","name":"man health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2695","char":"👨🏼‍⚕","name":"man health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2695 FE0F","char":"👨🏽‍⚕️","name":"man health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2695","char":"👨🏽‍⚕","name":"man health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2695 FE0F","char":"👨🏾‍⚕️","name":"man health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2695","char":"👨🏾‍⚕","name":"man health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2695 FE0F","char":"👨🏿‍⚕️","name":"man health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2695","char":"👨🏿‍⚕","name":"man health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2695 FE0F","char":"👩‍⚕️","name":"woman health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2695","char":"👩‍⚕","name":"woman health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2695 FE0F","char":"👩🏻‍⚕️","name":"woman health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2695","char":"👩🏻‍⚕","name":"woman health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2695 FE0F","char":"👩🏼‍⚕️","name":"woman health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2695","char":"👩🏼‍⚕","name":"woman health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2695 FE0F","char":"👩🏽‍⚕️","name":"woman health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2695","char":"👩🏽‍⚕","name":"woman health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2695 FE0F","char":"👩🏾‍⚕️","name":"woman health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2695","char":"👩🏾‍⚕","name":"woman health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2695 FE0F","char":"👩🏿‍⚕️","name":"woman health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2695","char":"👩🏿‍⚕","name":"woman health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F393","char":"🧑‍🎓","name":"student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F393","char":"🧑🏻‍🎓","name":"student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F393","char":"🧑🏼‍🎓","name":"student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F393","char":"🧑🏽‍🎓","name":"student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F393","char":"🧑🏾‍🎓","name":"student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F393","char":"🧑🏿‍🎓","name":"student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F393","char":"👨‍🎓","name":"man student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F393","char":"👨🏻‍🎓","name":"man student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F393","char":"👨🏼‍🎓","name":"man student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F393","char":"👨🏽‍🎓","name":"man student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F393","char":"👨🏾‍🎓","name":"man student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F393","char":"👨🏿‍🎓","name":"man student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F393","char":"👩‍🎓","name":"woman student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F393","char":"👩🏻‍🎓","name":"woman student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F393","char":"👩🏼‍🎓","name":"woman student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F393","char":"👩🏽‍🎓","name":"woman student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F393","char":"👩🏾‍🎓","name":"woman student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F393","char":"👩🏿‍🎓","name":"woman student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3EB","char":"🧑‍🏫","name":"teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3EB","char":"🧑🏻‍🏫","name":"teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3EB","char":"🧑🏼‍🏫","name":"teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3EB","char":"🧑🏽‍🏫","name":"teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3EB","char":"🧑🏾‍🏫","name":"teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3EB","char":"🧑🏿‍🏫","name":"teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3EB","char":"👨‍🏫","name":"man teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3EB","char":"👨🏻‍🏫","name":"man teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3EB","char":"👨🏼‍🏫","name":"man teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3EB","char":"👨🏽‍🏫","name":"man teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3EB","char":"👨🏾‍🏫","name":"man teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3EB","char":"👨🏿‍🏫","name":"man teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3EB","char":"👩‍🏫","name":"woman teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3EB","char":"👩🏻‍🏫","name":"woman teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3EB","char":"👩🏼‍🏫","name":"woman teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3EB","char":"👩🏽‍🏫","name":"woman teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3EB","char":"👩🏾‍🏫","name":"woman teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3EB","char":"👩🏿‍🏫","name":"woman teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2696 FE0F","char":"🧑‍⚖️","name":"judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2696","char":"🧑‍⚖","name":"judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2696 FE0F","char":"🧑🏻‍⚖️","name":"judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2696","char":"🧑🏻‍⚖","name":"judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2696 FE0F","char":"🧑🏼‍⚖️","name":"judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2696","char":"🧑🏼‍⚖","name":"judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2696 FE0F","char":"🧑🏽‍⚖️","name":"judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2696","char":"🧑🏽‍⚖","name":"judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2696 FE0F","char":"🧑🏾‍⚖️","name":"judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2696","char":"🧑🏾‍⚖","name":"judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2696 FE0F","char":"🧑🏿‍⚖️","name":"judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2696","char":"🧑🏿‍⚖","name":"judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2696 FE0F","char":"👨‍⚖️","name":"man judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2696","char":"👨‍⚖","name":"man judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2696 FE0F","char":"👨🏻‍⚖️","name":"man judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2696","char":"👨🏻‍⚖","name":"man judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2696 FE0F","char":"👨🏼‍⚖️","name":"man judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2696","char":"👨🏼‍⚖","name":"man judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2696 FE0F","char":"👨🏽‍⚖️","name":"man judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2696","char":"👨🏽‍⚖","name":"man judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2696 FE0F","char":"👨🏾‍⚖️","name":"man judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2696","char":"👨🏾‍⚖","name":"man judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2696 FE0F","char":"👨🏿‍⚖️","name":"man judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2696","char":"👨🏿‍⚖","name":"man judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2696 FE0F","char":"👩‍⚖️","name":"woman judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2696","char":"👩‍⚖","name":"woman judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2696 FE0F","char":"👩🏻‍⚖️","name":"woman judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2696","char":"👩🏻‍⚖","name":"woman judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2696 FE0F","char":"👩🏼‍⚖️","name":"woman judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2696","char":"👩🏼‍⚖","name":"woman judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2696 FE0F","char":"👩🏽‍⚖️","name":"woman judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2696","char":"👩🏽‍⚖","name":"woman judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2696 FE0F","char":"👩🏾‍⚖️","name":"woman judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2696","char":"👩🏾‍⚖","name":"woman judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2696 FE0F","char":"👩🏿‍⚖️","name":"woman judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2696","char":"👩🏿‍⚖","name":"woman judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F33E","char":"🧑‍🌾","name":"farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F33E","char":"🧑🏻‍🌾","name":"farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F33E","char":"🧑🏼‍🌾","name":"farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F33E","char":"🧑🏽‍🌾","name":"farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F33E","char":"🧑🏾‍🌾","name":"farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F33E","char":"🧑🏿‍🌾","name":"farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F33E","char":"👨‍🌾","name":"man farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F33E","char":"👨🏻‍🌾","name":"man farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F33E","char":"👨🏼‍🌾","name":"man farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F33E","char":"👨🏽‍🌾","name":"man farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F33E","char":"👨🏾‍🌾","name":"man farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F33E","char":"👨🏿‍🌾","name":"man farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F33E","char":"👩‍🌾","name":"woman farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F33E","char":"👩🏻‍🌾","name":"woman farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F33E","char":"👩🏼‍🌾","name":"woman farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F33E","char":"👩🏽‍🌾","name":"woman farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F33E","char":"👩🏾‍🌾","name":"woman farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F33E","char":"👩🏿‍🌾","name":"woman farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F373","char":"🧑‍🍳","name":"cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F373","char":"🧑🏻‍🍳","name":"cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F373","char":"🧑🏼‍🍳","name":"cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F373","char":"🧑🏽‍🍳","name":"cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F373","char":"🧑🏾‍🍳","name":"cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F373","char":"🧑🏿‍🍳","name":"cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F373","char":"👨‍🍳","name":"man cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F373","char":"👨🏻‍🍳","name":"man cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F373","char":"👨🏼‍🍳","name":"man cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F373","char":"👨🏽‍🍳","name":"man cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F373","char":"👨🏾‍🍳","name":"man cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F373","char":"👨🏿‍🍳","name":"man cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F373","char":"👩‍🍳","name":"woman cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F373","char":"👩🏻‍🍳","name":"woman cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F373","char":"👩🏼‍🍳","name":"woman cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F373","char":"👩🏽‍🍳","name":"woman cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F373","char":"👩🏾‍🍳","name":"woman cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F373","char":"👩🏿‍🍳","name":"woman cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F527","char":"🧑‍🔧","name":"mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F527","char":"🧑🏻‍🔧","name":"mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F527","char":"🧑🏼‍🔧","name":"mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F527","char":"🧑🏽‍🔧","name":"mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F527","char":"🧑🏾‍🔧","name":"mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F527","char":"🧑🏿‍🔧","name":"mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F527","char":"👨‍🔧","name":"man mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F527","char":"👨🏻‍🔧","name":"man mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F527","char":"👨🏼‍🔧","name":"man mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F527","char":"👨🏽‍🔧","name":"man mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F527","char":"👨🏾‍🔧","name":"man mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F527","char":"👨🏿‍🔧","name":"man mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F527","char":"👩‍🔧","name":"woman mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F527","char":"👩🏻‍🔧","name":"woman mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F527","char":"👩🏼‍🔧","name":"woman mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F527","char":"👩🏽‍🔧","name":"woman mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F527","char":"👩🏾‍🔧","name":"woman mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F527","char":"👩🏿‍🔧","name":"woman mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3ED","char":"🧑‍🏭","name":"factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3ED","char":"🧑🏻‍🏭","name":"factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3ED","char":"🧑🏼‍🏭","name":"factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3ED","char":"🧑🏽‍🏭","name":"factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3ED","char":"🧑🏾‍🏭","name":"factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3ED","char":"🧑🏿‍🏭","name":"factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3ED","char":"👨‍🏭","name":"man factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3ED","char":"👨🏻‍🏭","name":"man factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3ED","char":"👨🏼‍🏭","name":"man factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3ED","char":"👨🏽‍🏭","name":"man factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3ED","char":"👨🏾‍🏭","name":"man factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3ED","char":"👨🏿‍🏭","name":"man factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3ED","char":"👩‍🏭","name":"woman factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3ED","char":"👩🏻‍🏭","name":"woman factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3ED","char":"👩🏼‍🏭","name":"woman factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3ED","char":"👩🏽‍🏭","name":"woman factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3ED","char":"👩🏾‍🏭","name":"woman factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3ED","char":"👩🏿‍🏭","name":"woman factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F4BC","char":"🧑‍💼","name":"office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F4BC","char":"🧑🏻‍💼","name":"office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F4BC","char":"🧑🏼‍💼","name":"office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F4BC","char":"🧑🏽‍💼","name":"office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F4BC","char":"🧑🏾‍💼","name":"office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F4BC","char":"🧑🏿‍💼","name":"office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F4BC","char":"👨‍💼","name":"man office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F4BC","char":"👨🏻‍💼","name":"man office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F4BC","char":"👨🏼‍💼","name":"man office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F4BC","char":"👨🏽‍💼","name":"man office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F4BC","char":"👨🏾‍💼","name":"man office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F4BC","char":"👨🏿‍💼","name":"man office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F4BC","char":"👩‍💼","name":"woman office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F4BC","char":"👩🏻‍💼","name":"woman office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F4BC","char":"👩🏼‍💼","name":"woman office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F4BC","char":"👩🏽‍💼","name":"woman office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F4BC","char":"👩🏾‍💼","name":"woman office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F4BC","char":"👩🏿‍💼","name":"woman office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F52C","char":"🧑‍🔬","name":"scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F52C","char":"🧑🏻‍🔬","name":"scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F52C","char":"🧑🏼‍🔬","name":"scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F52C","char":"🧑🏽‍🔬","name":"scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F52C","char":"🧑🏾‍🔬","name":"scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F52C","char":"🧑🏿‍🔬","name":"scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F52C","char":"👨‍🔬","name":"man scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F52C","char":"👨🏻‍🔬","name":"man scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F52C","char":"👨🏼‍🔬","name":"man scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F52C","char":"👨🏽‍🔬","name":"man scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F52C","char":"👨🏾‍🔬","name":"man scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F52C","char":"👨🏿‍🔬","name":"man scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F52C","char":"👩‍🔬","name":"woman scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F52C","char":"👩🏻‍🔬","name":"woman scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F52C","char":"👩🏼‍🔬","name":"woman scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F52C","char":"👩🏽‍🔬","name":"woman scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F52C","char":"👩🏾‍🔬","name":"woman scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F52C","char":"👩🏿‍🔬","name":"woman scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F4BB","char":"🧑‍💻","name":"technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F4BB","char":"🧑🏻‍💻","name":"technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F4BB","char":"🧑🏼‍💻","name":"technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F4BB","char":"🧑🏽‍💻","name":"technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F4BB","char":"🧑🏾‍💻","name":"technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F4BB","char":"🧑🏿‍💻","name":"technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F4BB","char":"👨‍💻","name":"man technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F4BB","char":"👨🏻‍💻","name":"man technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F4BB","char":"👨🏼‍💻","name":"man technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F4BB","char":"👨🏽‍💻","name":"man technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F4BB","char":"👨🏾‍💻","name":"man technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F4BB","char":"👨🏿‍💻","name":"man technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F4BB","char":"👩‍💻","name":"woman technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F4BB","char":"👩🏻‍💻","name":"woman technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F4BB","char":"👩🏼‍💻","name":"woman technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F4BB","char":"👩🏽‍💻","name":"woman technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F4BB","char":"👩🏾‍💻","name":"woman technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F4BB","char":"👩🏿‍💻","name":"woman technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3A4","char":"🧑‍🎤","name":"singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3A4","char":"🧑🏻‍🎤","name":"singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3A4","char":"🧑🏼‍🎤","name":"singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3A4","char":"🧑🏽‍🎤","name":"singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3A4","char":"🧑🏾‍🎤","name":"singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3A4","char":"🧑🏿‍🎤","name":"singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3A4","char":"👨‍🎤","name":"man singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3A4","char":"👨🏻‍🎤","name":"man singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3A4","char":"👨🏼‍🎤","name":"man singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3A4","char":"👨🏽‍🎤","name":"man singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3A4","char":"👨🏾‍🎤","name":"man singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3A4","char":"👨🏿‍🎤","name":"man singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3A4","char":"👩‍🎤","name":"woman singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3A4","char":"👩🏻‍🎤","name":"woman singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3A4","char":"👩🏼‍🎤","name":"woman singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3A4","char":"👩🏽‍🎤","name":"woman singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3A4","char":"👩🏾‍🎤","name":"woman singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3A4","char":"👩🏿‍🎤","name":"woman singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3A8","char":"🧑‍🎨","name":"artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3A8","char":"🧑🏻‍🎨","name":"artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3A8","char":"🧑🏼‍🎨","name":"artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3A8","char":"🧑🏽‍🎨","name":"artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3A8","char":"🧑🏾‍🎨","name":"artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3A8","char":"🧑🏿‍🎨","name":"artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3A8","char":"👨‍🎨","name":"man artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3A8","char":"👨🏻‍🎨","name":"man artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3A8","char":"👨🏼‍🎨","name":"man artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3A8","char":"👨🏽‍🎨","name":"man artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3A8","char":"👨🏾‍🎨","name":"man artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3A8","char":"👨🏿‍🎨","name":"man artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3A8","char":"👩‍🎨","name":"woman artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3A8","char":"👩🏻‍🎨","name":"woman artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3A8","char":"👩🏼‍🎨","name":"woman artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3A8","char":"👩🏽‍🎨","name":"woman artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3A8","char":"👩🏾‍🎨","name":"woman artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3A8","char":"👩🏿‍🎨","name":"woman artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2708 FE0F","char":"🧑‍✈️","name":"pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2708","char":"🧑‍✈","name":"pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2708 FE0F","char":"🧑🏻‍✈️","name":"pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2708","char":"🧑🏻‍✈","name":"pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2708 FE0F","char":"🧑🏼‍✈️","name":"pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2708","char":"🧑🏼‍✈","name":"pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2708 FE0F","char":"🧑🏽‍✈️","name":"pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2708","char":"🧑🏽‍✈","name":"pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2708 FE0F","char":"🧑🏾‍✈️","name":"pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2708","char":"🧑🏾‍✈","name":"pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2708 FE0F","char":"🧑🏿‍✈️","name":"pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2708","char":"🧑🏿‍✈","name":"pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2708 FE0F","char":"👨‍✈️","name":"man pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2708","char":"👨‍✈","name":"man pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2708 FE0F","char":"👨🏻‍✈️","name":"man pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2708","char":"👨🏻‍✈","name":"man pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2708 FE0F","char":"👨🏼‍✈️","name":"man pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2708","char":"👨🏼‍✈","name":"man pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2708 FE0F","char":"👨🏽‍✈️","name":"man pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2708","char":"👨🏽‍✈","name":"man pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2708 FE0F","char":"👨🏾‍✈️","name":"man pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2708","char":"👨🏾‍✈","name":"man pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2708 FE0F","char":"👨🏿‍✈️","name":"man pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2708","char":"👨🏿‍✈","name":"man pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2708 FE0F","char":"👩‍✈️","name":"woman pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2708","char":"👩‍✈","name":"woman pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2708 FE0F","char":"👩🏻‍✈️","name":"woman pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2708","char":"👩🏻‍✈","name":"woman pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2708 FE0F","char":"👩🏼‍✈️","name":"woman pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2708","char":"👩🏼‍✈","name":"woman pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2708 FE0F","char":"👩🏽‍✈️","name":"woman pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2708","char":"👩🏽‍✈","name":"woman pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2708 FE0F","char":"👩🏾‍✈️","name":"woman pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2708","char":"👩🏾‍✈","name":"woman pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2708 FE0F","char":"👩🏿‍✈️","name":"woman pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2708","char":"👩🏿‍✈","name":"woman pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F680","char":"🧑‍🚀","name":"astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F680","char":"🧑🏻‍🚀","name":"astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F680","char":"🧑🏼‍🚀","name":"astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F680","char":"🧑🏽‍🚀","name":"astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F680","char":"🧑🏾‍🚀","name":"astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F680","char":"🧑🏿‍🚀","name":"astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F680","char":"👨‍🚀","name":"man astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F680","char":"👨🏻‍🚀","name":"man astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F680","char":"👨🏼‍🚀","name":"man astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F680","char":"👨🏽‍🚀","name":"man astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F680","char":"👨🏾‍🚀","name":"man astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F680","char":"👨🏿‍🚀","name":"man astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F680","char":"👩‍🚀","name":"woman astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F680","char":"👩🏻‍🚀","name":"woman astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F680","char":"👩🏼‍🚀","name":"woman astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F680","char":"👩🏽‍🚀","name":"woman astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F680","char":"👩🏾‍🚀","name":"woman astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F680","char":"👩🏿‍🚀","name":"woman astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F692","char":"🧑‍🚒","name":"firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F692","char":"🧑🏻‍🚒","name":"firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F692","char":"🧑🏼‍🚒","name":"firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F692","char":"🧑🏽‍🚒","name":"firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F692","char":"🧑🏾‍🚒","name":"firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F692","char":"🧑🏿‍🚒","name":"firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F692","char":"👨‍🚒","name":"man firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F692","char":"👨🏻‍🚒","name":"man firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F692","char":"👨🏼‍🚒","name":"man firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F692","char":"👨🏽‍🚒","name":"man firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F692","char":"👨🏾‍🚒","name":"man firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F692","char":"👨🏿‍🚒","name":"man firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F692","char":"👩‍🚒","name":"woman firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F692","char":"👩🏻‍🚒","name":"woman firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F692","char":"👩🏼‍🚒","name":"woman firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F692","char":"👩🏽‍🚒","name":"woman firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F692","char":"👩🏾‍🚒","name":"woman firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F692","char":"👩🏿‍🚒","name":"woman firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E","char":"👮","name":"police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB","char":"👮🏻","name":"police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC","char":"👮🏼","name":"police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD","char":"👮🏽","name":"police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE","char":"👮🏾","name":"police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF","char":"👮🏿","name":"police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2642 FE0F","char":"👮‍♂️","name":"man police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2642","char":"👮‍♂","name":"man police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2642 FE0F","char":"👮🏻‍♂️","name":"man police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2642","char":"👮🏻‍♂","name":"man police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2642 FE0F","char":"👮🏼‍♂️","name":"man police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2642","char":"👮🏼‍♂","name":"man police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2642 FE0F","char":"👮🏽‍♂️","name":"man police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2642","char":"👮🏽‍♂","name":"man police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2642 FE0F","char":"👮🏾‍♂️","name":"man police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2642","char":"👮🏾‍♂","name":"man police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2642 FE0F","char":"👮🏿‍♂️","name":"man police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2642","char":"👮🏿‍♂","name":"man police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2640 FE0F","char":"👮‍♀️","name":"woman police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2640","char":"👮‍♀","name":"woman police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2640 FE0F","char":"👮🏻‍♀️","name":"woman police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2640","char":"👮🏻‍♀","name":"woman police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2640 FE0F","char":"👮🏼‍♀️","name":"woman police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2640","char":"👮🏼‍♀","name":"woman police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2640 FE0F","char":"👮🏽‍♀️","name":"woman police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2640","char":"👮🏽‍♀","name":"woman police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2640 FE0F","char":"👮🏾‍♀️","name":"woman police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2640","char":"👮🏾‍♀","name":"woman police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2640 FE0F","char":"👮🏿‍♀️","name":"woman police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2640","char":"👮🏿‍♀","name":"woman police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F","char":"🕵️","name":"detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575","char":"🕵","name":"detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB","char":"🕵🏻","name":"detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC","char":"🕵🏼","name":"detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD","char":"🕵🏽","name":"detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE","char":"🕵🏾","name":"detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF","char":"🕵🏿","name":"detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2642 FE0F","char":"🕵️‍♂️","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2642 FE0F","char":"🕵‍♂️","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2642","char":"🕵️‍♂","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2642","char":"🕵‍♂","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2642 FE0F","char":"🕵🏻‍♂️","name":"man detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2642","char":"🕵🏻‍♂","name":"man detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2642 FE0F","char":"🕵🏼‍♂️","name":"man detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2642","char":"🕵🏼‍♂","name":"man detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2642 FE0F","char":"🕵🏽‍♂️","name":"man detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2642","char":"🕵🏽‍♂","name":"man detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2642 FE0F","char":"🕵🏾‍♂️","name":"man detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2642","char":"🕵🏾‍♂","name":"man detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2642 FE0F","char":"🕵🏿‍♂️","name":"man detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2642","char":"🕵🏿‍♂","name":"man detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2640 FE0F","char":"🕵️‍♀️","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2640 FE0F","char":"🕵‍♀️","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2640","char":"🕵️‍♀","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2640","char":"🕵‍♀","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2640 FE0F","char":"🕵🏻‍♀️","name":"woman detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2640","char":"🕵🏻‍♀","name":"woman detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2640 FE0F","char":"🕵🏼‍♀️","name":"woman detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2640","char":"🕵🏼‍♀","name":"woman detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2640 FE0F","char":"🕵🏽‍♀️","name":"woman detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2640","char":"🕵🏽‍♀","name":"woman detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2640 FE0F","char":"🕵🏾‍♀️","name":"woman detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2640","char":"🕵🏾‍♀","name":"woman detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2640 FE0F","char":"🕵🏿‍♀️","name":"woman detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2640","char":"🕵🏿‍♀","name":"woman detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482","char":"💂","name":"guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB","char":"💂🏻","name":"guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC","char":"💂🏼","name":"guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD","char":"💂🏽","name":"guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE","char":"💂🏾","name":"guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF","char":"💂🏿","name":"guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2642 FE0F","char":"💂‍♂️","name":"man guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2642","char":"💂‍♂","name":"man guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2642 FE0F","char":"💂🏻‍♂️","name":"man guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2642","char":"💂🏻‍♂","name":"man guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2642 FE0F","char":"💂🏼‍♂️","name":"man guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2642","char":"💂🏼‍♂","name":"man guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2642 FE0F","char":"💂🏽‍♂️","name":"man guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2642","char":"💂🏽‍♂","name":"man guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2642 FE0F","char":"💂🏾‍♂️","name":"man guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2642","char":"💂🏾‍♂","name":"man guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2642 FE0F","char":"💂🏿‍♂️","name":"man guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2642","char":"💂🏿‍♂","name":"man guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2640 FE0F","char":"💂‍♀️","name":"woman guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2640","char":"💂‍♀","name":"woman guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2640 FE0F","char":"💂🏻‍♀️","name":"woman guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2640","char":"💂🏻‍♀","name":"woman guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2640 FE0F","char":"💂🏼‍♀️","name":"woman guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2640","char":"💂🏼‍♀","name":"woman guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2640 FE0F","char":"💂🏽‍♀️","name":"woman guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2640","char":"💂🏽‍♀","name":"woman guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2640 FE0F","char":"💂🏾‍♀️","name":"woman guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2640","char":"💂🏾‍♀","name":"woman guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2640 FE0F","char":"💂🏿‍♀️","name":"woman guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2640","char":"💂🏿‍♀","name":"woman guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977","char":"🥷","name":"ninja","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FB","char":"🥷🏻","name":"ninja: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FC","char":"🥷🏼","name":"ninja: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FD","char":"🥷🏽","name":"ninja: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FE","char":"🥷🏾","name":"ninja: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FF","char":"🥷🏿","name":"ninja: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477","char":"👷","name":"construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB","char":"👷🏻","name":"construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC","char":"👷🏼","name":"construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD","char":"👷🏽","name":"construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE","char":"👷🏾","name":"construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF","char":"👷🏿","name":"construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2642 FE0F","char":"👷‍♂️","name":"man construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2642","char":"👷‍♂","name":"man construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2642 FE0F","char":"👷🏻‍♂️","name":"man construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2642","char":"👷🏻‍♂","name":"man construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2642 FE0F","char":"👷🏼‍♂️","name":"man construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2642","char":"👷🏼‍♂","name":"man construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2642 FE0F","char":"👷🏽‍♂️","name":"man construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2642","char":"👷🏽‍♂","name":"man construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2642 FE0F","char":"👷🏾‍♂️","name":"man construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2642","char":"👷🏾‍♂","name":"man construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2642 FE0F","char":"👷🏿‍♂️","name":"man construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2642","char":"👷🏿‍♂","name":"man construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2640 FE0F","char":"👷‍♀️","name":"woman construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2640","char":"👷‍♀","name":"woman construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2640 FE0F","char":"👷🏻‍♀️","name":"woman construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2640","char":"👷🏻‍♀","name":"woman construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2640 FE0F","char":"👷🏼‍♀️","name":"woman construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2640","char":"👷🏼‍♀","name":"woman construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2640 FE0F","char":"👷🏽‍♀️","name":"woman construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2640","char":"👷🏽‍♀","name":"woman construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2640 FE0F","char":"👷🏾‍♀️","name":"woman construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2640","char":"👷🏾‍♀","name":"woman construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2640 FE0F","char":"👷🏿‍♀️","name":"woman construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2640","char":"👷🏿‍♀","name":"woman construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5","char":"🫅","name":"person with crown","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FB","char":"🫅🏻","name":"person with crown: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FC","char":"🫅🏼","name":"person with crown: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FD","char":"🫅🏽","name":"person with crown: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FE","char":"🫅🏾","name":"person with crown: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FF","char":"🫅🏿","name":"person with crown: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934","char":"🤴","name":"prince","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FB","char":"🤴🏻","name":"prince: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FC","char":"🤴🏼","name":"prince: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FD","char":"🤴🏽","name":"prince: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FE","char":"🤴🏾","name":"prince: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FF","char":"🤴🏿","name":"prince: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478","char":"👸","name":"princess","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FB","char":"👸🏻","name":"princess: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FC","char":"👸🏼","name":"princess: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FD","char":"👸🏽","name":"princess: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FE","char":"👸🏾","name":"princess: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FF","char":"👸🏿","name":"princess: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473","char":"👳","name":"person wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB","char":"👳🏻","name":"person wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC","char":"👳🏼","name":"person wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD","char":"👳🏽","name":"person wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE","char":"👳🏾","name":"person wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF","char":"👳🏿","name":"person wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2642 FE0F","char":"👳‍♂️","name":"man wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2642","char":"👳‍♂","name":"man wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2642 FE0F","char":"👳🏻‍♂️","name":"man wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2642","char":"👳🏻‍♂","name":"man wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2642 FE0F","char":"👳🏼‍♂️","name":"man wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2642","char":"👳🏼‍♂","name":"man wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2642 FE0F","char":"👳🏽‍♂️","name":"man wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2642","char":"👳🏽‍♂","name":"man wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2642 FE0F","char":"👳🏾‍♂️","name":"man wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2642","char":"👳🏾‍♂","name":"man wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2642 FE0F","char":"👳🏿‍♂️","name":"man wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2642","char":"👳🏿‍♂","name":"man wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2640 FE0F","char":"👳‍♀️","name":"woman wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2640","char":"👳‍♀","name":"woman wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2640 FE0F","char":"👳🏻‍♀️","name":"woman wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2640","char":"👳🏻‍♀","name":"woman wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2640 FE0F","char":"👳🏼‍♀️","name":"woman wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2640","char":"👳🏼‍♀","name":"woman wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2640 FE0F","char":"👳🏽‍♀️","name":"woman wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2640","char":"👳🏽‍♀","name":"woman wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2640 FE0F","char":"👳🏾‍♀️","name":"woman wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2640","char":"👳🏾‍♀","name":"woman wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2640 FE0F","char":"👳🏿‍♀️","name":"woman wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2640","char":"👳🏿‍♀","name":"woman wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472","char":"👲","name":"person with skullcap","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FB","char":"👲🏻","name":"person with skullcap: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FC","char":"👲🏼","name":"person with skullcap: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FD","char":"👲🏽","name":"person with skullcap: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FE","char":"👲🏾","name":"person with skullcap: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FF","char":"👲🏿","name":"person with skullcap: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5","char":"🧕","name":"woman with headscarf","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FB","char":"🧕🏻","name":"woman with headscarf: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FC","char":"🧕🏼","name":"woman with headscarf: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FD","char":"🧕🏽","name":"woman with headscarf: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FE","char":"🧕🏾","name":"woman with headscarf: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FF","char":"🧕🏿","name":"woman with headscarf: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935","char":"🤵","name":"person in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB","char":"🤵🏻","name":"person in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC","char":"🤵🏼","name":"person in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD","char":"🤵🏽","name":"person in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE","char":"🤵🏾","name":"person in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF","char":"🤵🏿","name":"person in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2642 FE0F","char":"🤵‍♂️","name":"man in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2642","char":"🤵‍♂","name":"man in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2642 FE0F","char":"🤵🏻‍♂️","name":"man in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2642","char":"🤵🏻‍♂","name":"man in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2642 FE0F","char":"🤵🏼‍♂️","name":"man in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2642","char":"🤵🏼‍♂","name":"man in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2642 FE0F","char":"🤵🏽‍♂️","name":"man in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2642","char":"🤵🏽‍♂","name":"man in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2642 FE0F","char":"🤵🏾‍♂️","name":"man in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2642","char":"🤵🏾‍♂","name":"man in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2642 FE0F","char":"🤵🏿‍♂️","name":"man in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2642","char":"🤵🏿‍♂","name":"man in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2640 FE0F","char":"🤵‍♀️","name":"woman in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2640","char":"🤵‍♀","name":"woman in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2640 FE0F","char":"🤵🏻‍♀️","name":"woman in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2640","char":"🤵🏻‍♀","name":"woman in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2640 FE0F","char":"🤵🏼‍♀️","name":"woman in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2640","char":"🤵🏼‍♀","name":"woman in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2640 FE0F","char":"🤵🏽‍♀️","name":"woman in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2640","char":"🤵🏽‍♀","name":"woman in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2640 FE0F","char":"🤵🏾‍♀️","name":"woman in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2640","char":"🤵🏾‍♀","name":"woman in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2640 FE0F","char":"🤵🏿‍♀️","name":"woman in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2640","char":"🤵🏿‍♀","name":"woman in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470","char":"👰","name":"person with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB","char":"👰🏻","name":"person with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC","char":"👰🏼","name":"person with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD","char":"👰🏽","name":"person with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE","char":"👰🏾","name":"person with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF","char":"👰🏿","name":"person with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2642 FE0F","char":"👰‍♂️","name":"man with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2642","char":"👰‍♂","name":"man with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2642 FE0F","char":"👰🏻‍♂️","name":"man with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2642","char":"👰🏻‍♂","name":"man with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2642 FE0F","char":"👰🏼‍♂️","name":"man with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2642","char":"👰🏼‍♂","name":"man with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2642 FE0F","char":"👰🏽‍♂️","name":"man with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2642","char":"👰🏽‍♂","name":"man with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2642 FE0F","char":"👰🏾‍♂️","name":"man with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2642","char":"👰🏾‍♂","name":"man with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2642 FE0F","char":"👰🏿‍♂️","name":"man with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2642","char":"👰🏿‍♂","name":"man with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2640 FE0F","char":"👰‍♀️","name":"woman with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2640","char":"👰‍♀","name":"woman with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2640 FE0F","char":"👰🏻‍♀️","name":"woman with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2640","char":"👰🏻‍♀","name":"woman with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2640 FE0F","char":"👰🏼‍♀️","name":"woman with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2640","char":"👰🏼‍♀","name":"woman with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2640 FE0F","char":"👰🏽‍♀️","name":"woman with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2640","char":"👰🏽‍♀","name":"woman with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2640 FE0F","char":"👰🏾‍♀️","name":"woman with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2640","char":"👰🏾‍♀","name":"woman with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2640 FE0F","char":"👰🏿‍♀️","name":"woman with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2640","char":"👰🏿‍♀","name":"woman with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930","char":"🤰","name":"pregnant woman","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FB","char":"🤰🏻","name":"pregnant woman: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FC","char":"🤰🏼","name":"pregnant woman: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FD","char":"🤰🏽","name":"pregnant woman: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FE","char":"🤰🏾","name":"pregnant woman: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FF","char":"🤰🏿","name":"pregnant woman: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3","char":"🫃","name":"pregnant man","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FB","char":"🫃🏻","name":"pregnant man: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FC","char":"🫃🏼","name":"pregnant man: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FD","char":"🫃🏽","name":"pregnant man: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FE","char":"🫃🏾","name":"pregnant man: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FF","char":"🫃🏿","name":"pregnant man: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4","char":"🫄","name":"pregnant person","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FB","char":"🫄🏻","name":"pregnant person: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FC","char":"🫄🏼","name":"pregnant person: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FD","char":"🫄🏽","name":"pregnant person: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FE","char":"🫄🏾","name":"pregnant person: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FF","char":"🫄🏿","name":"pregnant person: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931","char":"🤱","name":"breast-feeding","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FB","char":"🤱🏻","name":"breast-feeding: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FC","char":"🤱🏼","name":"breast-feeding: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FD","char":"🤱🏽","name":"breast-feeding: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FE","char":"🤱🏾","name":"breast-feeding: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FF","char":"🤱🏿","name":"breast-feeding: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F37C","char":"👩‍🍼","name":"woman feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F37C","char":"👩🏻‍🍼","name":"woman feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F37C","char":"👩🏼‍🍼","name":"woman feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F37C","char":"👩🏽‍🍼","name":"woman feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F37C","char":"👩🏾‍🍼","name":"woman feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F37C","char":"👩🏿‍🍼","name":"woman feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F37C","char":"👨‍🍼","name":"man feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F37C","char":"👨🏻‍🍼","name":"man feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F37C","char":"👨🏼‍🍼","name":"man feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F37C","char":"👨🏽‍🍼","name":"man feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F37C","char":"👨🏾‍🍼","name":"man feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F37C","char":"👨🏿‍🍼","name":"man feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F37C","char":"🧑‍🍼","name":"person feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F37C","char":"🧑🏻‍🍼","name":"person feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F37C","char":"🧑🏼‍🍼","name":"person feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F37C","char":"🧑🏽‍🍼","name":"person feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F37C","char":"🧑🏾‍🍼","name":"person feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F37C","char":"🧑🏿‍🍼","name":"person feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F47C","char":"👼","name":"baby angel","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FB","char":"👼🏻","name":"baby angel: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FC","char":"👼🏼","name":"baby angel: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FD","char":"👼🏽","name":"baby angel: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FE","char":"👼🏾","name":"baby angel: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FF","char":"👼🏿","name":"baby angel: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385","char":"🎅","name":"Santa Claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FB","char":"🎅🏻","name":"Santa Claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FC","char":"🎅🏼","name":"Santa Claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FD","char":"🎅🏽","name":"Santa Claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FE","char":"🎅🏾","name":"Santa Claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FF","char":"🎅🏿","name":"Santa Claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936","char":"🤶","name":"Mrs. Claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FB","char":"🤶🏻","name":"Mrs. Claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FC","char":"🤶🏼","name":"Mrs. Claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FD","char":"🤶🏽","name":"Mrs. Claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FE","char":"🤶🏾","name":"Mrs. Claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FF","char":"🤶🏿","name":"Mrs. Claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 200D 1F384","char":"🧑‍🎄","name":"mx claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FB 200D 1F384","char":"🧑🏻‍🎄","name":"mx claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FC 200D 1F384","char":"🧑🏼‍🎄","name":"mx claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FD 200D 1F384","char":"🧑🏽‍🎄","name":"mx claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FE 200D 1F384","char":"🧑🏾‍🎄","name":"mx claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FF 200D 1F384","char":"🧑🏿‍🎄","name":"mx claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8","char":"🦸","name":"superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB","char":"🦸🏻","name":"superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC","char":"🦸🏼","name":"superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD","char":"🦸🏽","name":"superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE","char":"🦸🏾","name":"superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF","char":"🦸🏿","name":"superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2642 FE0F","char":"🦸‍♂️","name":"man superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2642","char":"🦸‍♂","name":"man superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2642 FE0F","char":"🦸🏻‍♂️","name":"man superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2642","char":"🦸🏻‍♂","name":"man superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2642 FE0F","char":"🦸🏼‍♂️","name":"man superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2642","char":"🦸🏼‍♂","name":"man superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2642 FE0F","char":"🦸🏽‍♂️","name":"man superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2642","char":"🦸🏽‍♂","name":"man superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2642 FE0F","char":"🦸🏾‍♂️","name":"man superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2642","char":"🦸🏾‍♂","name":"man superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2642 FE0F","char":"🦸🏿‍♂️","name":"man superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2642","char":"🦸🏿‍♂","name":"man superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2640 FE0F","char":"🦸‍♀️","name":"woman superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2640","char":"🦸‍♀","name":"woman superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2640 FE0F","char":"🦸🏻‍♀️","name":"woman superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2640","char":"🦸🏻‍♀","name":"woman superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2640 FE0F","char":"🦸🏼‍♀️","name":"woman superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2640","char":"🦸🏼‍♀","name":"woman superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2640 FE0F","char":"🦸🏽‍♀️","name":"woman superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2640","char":"🦸🏽‍♀","name":"woman superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2640 FE0F","char":"🦸🏾‍♀️","name":"woman superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2640","char":"🦸🏾‍♀","name":"woman superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2640 FE0F","char":"🦸🏿‍♀️","name":"woman superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2640","char":"🦸🏿‍♀","name":"woman superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9","char":"🦹","name":"supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB","char":"🦹🏻","name":"supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC","char":"🦹🏼","name":"supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD","char":"🦹🏽","name":"supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE","char":"🦹🏾","name":"supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF","char":"🦹🏿","name":"supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2642 FE0F","char":"🦹‍♂️","name":"man supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2642","char":"🦹‍♂","name":"man supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2642 FE0F","char":"🦹🏻‍♂️","name":"man supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2642","char":"🦹🏻‍♂","name":"man supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2642 FE0F","char":"🦹🏼‍♂️","name":"man supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2642","char":"🦹🏼‍♂","name":"man supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2642 FE0F","char":"🦹🏽‍♂️","name":"man supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2642","char":"🦹🏽‍♂","name":"man supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2642 FE0F","char":"🦹🏾‍♂️","name":"man supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2642","char":"🦹🏾‍♂","name":"man supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2642 FE0F","char":"🦹🏿‍♂️","name":"man supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2642","char":"🦹🏿‍♂","name":"man supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2640 FE0F","char":"🦹‍♀️","name":"woman supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2640","char":"🦹‍♀","name":"woman supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2640 FE0F","char":"🦹🏻‍♀️","name":"woman supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2640","char":"🦹🏻‍♀","name":"woman supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2640 FE0F","char":"🦹🏼‍♀️","name":"woman supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2640","char":"🦹🏼‍♀","name":"woman supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2640 FE0F","char":"🦹🏽‍♀️","name":"woman supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2640","char":"🦹🏽‍♀","name":"woman supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2640 FE0F","char":"🦹🏾‍♀️","name":"woman supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2640","char":"🦹🏾‍♀","name":"woman supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2640 FE0F","char":"🦹🏿‍♀️","name":"woman supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2640","char":"🦹🏿‍♀","name":"woman supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9","char":"🧙","name":"mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB","char":"🧙🏻","name":"mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC","char":"🧙🏼","name":"mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD","char":"🧙🏽","name":"mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE","char":"🧙🏾","name":"mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF","char":"🧙🏿","name":"mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2642 FE0F","char":"🧙‍♂️","name":"man mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2642","char":"🧙‍♂","name":"man mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2642 FE0F","char":"🧙🏻‍♂️","name":"man mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2642","char":"🧙🏻‍♂","name":"man mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2642 FE0F","char":"🧙🏼‍♂️","name":"man mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2642","char":"🧙🏼‍♂","name":"man mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2642 FE0F","char":"🧙🏽‍♂️","name":"man mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2642","char":"🧙🏽‍♂","name":"man mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2642 FE0F","char":"🧙🏾‍♂️","name":"man mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2642","char":"🧙🏾‍♂","name":"man mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2642 FE0F","char":"🧙🏿‍♂️","name":"man mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2642","char":"🧙🏿‍♂","name":"man mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2640 FE0F","char":"🧙‍♀️","name":"woman mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2640","char":"🧙‍♀","name":"woman mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2640 FE0F","char":"🧙🏻‍♀️","name":"woman mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2640","char":"🧙🏻‍♀","name":"woman mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2640 FE0F","char":"🧙🏼‍♀️","name":"woman mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2640","char":"🧙🏼‍♀","name":"woman mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2640 FE0F","char":"🧙🏽‍♀️","name":"woman mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2640","char":"🧙🏽‍♀","name":"woman mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2640 FE0F","char":"🧙🏾‍♀️","name":"woman mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2640","char":"🧙🏾‍♀","name":"woman mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2640 FE0F","char":"🧙🏿‍♀️","name":"woman mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2640","char":"🧙🏿‍♀","name":"woman mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA","char":"🧚","name":"fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB","char":"🧚🏻","name":"fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC","char":"🧚🏼","name":"fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD","char":"🧚🏽","name":"fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE","char":"🧚🏾","name":"fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF","char":"🧚🏿","name":"fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2642 FE0F","char":"🧚‍♂️","name":"man fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2642","char":"🧚‍♂","name":"man fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2642 FE0F","char":"🧚🏻‍♂️","name":"man fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2642","char":"🧚🏻‍♂","name":"man fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2642 FE0F","char":"🧚🏼‍♂️","name":"man fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2642","char":"🧚🏼‍♂","name":"man fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2642 FE0F","char":"🧚🏽‍♂️","name":"man fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2642","char":"🧚🏽‍♂","name":"man fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2642 FE0F","char":"🧚🏾‍♂️","name":"man fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2642","char":"🧚🏾‍♂","name":"man fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2642 FE0F","char":"🧚🏿‍♂️","name":"man fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2642","char":"🧚🏿‍♂","name":"man fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2640 FE0F","char":"🧚‍♀️","name":"woman fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2640","char":"🧚‍♀","name":"woman fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2640 FE0F","char":"🧚🏻‍♀️","name":"woman fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2640","char":"🧚🏻‍♀","name":"woman fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2640 FE0F","char":"🧚🏼‍♀️","name":"woman fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2640","char":"🧚🏼‍♀","name":"woman fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2640 FE0F","char":"🧚🏽‍♀️","name":"woman fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2640","char":"🧚🏽‍♀","name":"woman fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2640 FE0F","char":"🧚🏾‍♀️","name":"woman fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2640","char":"🧚🏾‍♀","name":"woman fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2640 FE0F","char":"🧚🏿‍♀️","name":"woman fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2640","char":"🧚🏿‍♀","name":"woman fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB","char":"🧛","name":"vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB","char":"🧛🏻","name":"vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC","char":"🧛🏼","name":"vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD","char":"🧛🏽","name":"vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE","char":"🧛🏾","name":"vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF","char":"🧛🏿","name":"vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2642 FE0F","char":"🧛‍♂️","name":"man vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2642","char":"🧛‍♂","name":"man vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2642 FE0F","char":"🧛🏻‍♂️","name":"man vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2642","char":"🧛🏻‍♂","name":"man vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2642 FE0F","char":"🧛🏼‍♂️","name":"man vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2642","char":"🧛🏼‍♂","name":"man vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2642 FE0F","char":"🧛🏽‍♂️","name":"man vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2642","char":"🧛🏽‍♂","name":"man vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2642 FE0F","char":"🧛🏾‍♂️","name":"man vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2642","char":"🧛🏾‍♂","name":"man vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2642 FE0F","char":"🧛🏿‍♂️","name":"man vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2642","char":"🧛🏿‍♂","name":"man vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2640 FE0F","char":"🧛‍♀️","name":"woman vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2640","char":"🧛‍♀","name":"woman vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2640 FE0F","char":"🧛🏻‍♀️","name":"woman vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2640","char":"🧛🏻‍♀","name":"woman vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2640 FE0F","char":"🧛🏼‍♀️","name":"woman vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2640","char":"🧛🏼‍♀","name":"woman vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2640 FE0F","char":"🧛🏽‍♀️","name":"woman vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2640","char":"🧛🏽‍♀","name":"woman vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2640 FE0F","char":"🧛🏾‍♀️","name":"woman vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2640","char":"🧛🏾‍♀","name":"woman vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2640 FE0F","char":"🧛🏿‍♀️","name":"woman vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2640","char":"🧛🏿‍♀","name":"woman vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC","char":"🧜","name":"merperson","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB","char":"🧜🏻","name":"merperson: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC","char":"🧜🏼","name":"merperson: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD","char":"🧜🏽","name":"merperson: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE","char":"🧜🏾","name":"merperson: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF","char":"🧜🏿","name":"merperson: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2642 FE0F","char":"🧜‍♂️","name":"merman","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2642","char":"🧜‍♂","name":"merman","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2642 FE0F","char":"🧜🏻‍♂️","name":"merman: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2642","char":"🧜🏻‍♂","name":"merman: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2642 FE0F","char":"🧜🏼‍♂️","name":"merman: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2642","char":"🧜🏼‍♂","name":"merman: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2642 FE0F","char":"🧜🏽‍♂️","name":"merman: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2642","char":"🧜🏽‍♂","name":"merman: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2642 FE0F","char":"🧜🏾‍♂️","name":"merman: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2642","char":"🧜🏾‍♂","name":"merman: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2642 FE0F","char":"🧜🏿‍♂️","name":"merman: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2642","char":"🧜🏿‍♂","name":"merman: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2640 FE0F","char":"🧜‍♀️","name":"mermaid","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2640","char":"🧜‍♀","name":"mermaid","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2640 FE0F","char":"🧜🏻‍♀️","name":"mermaid: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2640","char":"🧜🏻‍♀","name":"mermaid: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2640 FE0F","char":"🧜🏼‍♀️","name":"mermaid: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2640","char":"🧜🏼‍♀","name":"mermaid: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2640 FE0F","char":"🧜🏽‍♀️","name":"mermaid: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2640","char":"🧜🏽‍♀","name":"mermaid: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2640 FE0F","char":"🧜🏾‍♀️","name":"mermaid: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2640","char":"🧜🏾‍♀","name":"mermaid: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2640 FE0F","char":"🧜🏿‍♀️","name":"mermaid: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2640","char":"🧜🏿‍♀","name":"mermaid: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD","char":"🧝","name":"elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB","char":"🧝🏻","name":"elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC","char":"🧝🏼","name":"elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD","char":"🧝🏽","name":"elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE","char":"🧝🏾","name":"elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF","char":"🧝🏿","name":"elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2642 FE0F","char":"🧝‍♂️","name":"man elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2642","char":"🧝‍♂","name":"man elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2642 FE0F","char":"🧝🏻‍♂️","name":"man elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2642","char":"🧝🏻‍♂","name":"man elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2642 FE0F","char":"🧝🏼‍♂️","name":"man elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2642","char":"🧝🏼‍♂","name":"man elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2642 FE0F","char":"🧝🏽‍♂️","name":"man elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2642","char":"🧝🏽‍♂","name":"man elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2642 FE0F","char":"🧝🏾‍♂️","name":"man elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2642","char":"🧝🏾‍♂","name":"man elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2642 FE0F","char":"🧝🏿‍♂️","name":"man elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2642","char":"🧝🏿‍♂","name":"man elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2640 FE0F","char":"🧝‍♀️","name":"woman elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2640","char":"🧝‍♀","name":"woman elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2640 FE0F","char":"🧝🏻‍♀️","name":"woman elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2640","char":"🧝🏻‍♀","name":"woman elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2640 FE0F","char":"🧝🏼‍♀️","name":"woman elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2640","char":"🧝🏼‍♀","name":"woman elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2640 FE0F","char":"🧝🏽‍♀️","name":"woman elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2640","char":"🧝🏽‍♀","name":"woman elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2640 FE0F","char":"🧝🏾‍♀️","name":"woman elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2640","char":"🧝🏾‍♀","name":"woman elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2640 FE0F","char":"🧝🏿‍♀️","name":"woman elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2640","char":"🧝🏿‍♀","name":"woman elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE","char":"🧞","name":"genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2642 FE0F","char":"🧞‍♂️","name":"man genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2642","char":"🧞‍♂","name":"man genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2640 FE0F","char":"🧞‍♀️","name":"woman genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2640","char":"🧞‍♀","name":"woman genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF","char":"🧟","name":"zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2642 FE0F","char":"🧟‍♂️","name":"man zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2642","char":"🧟‍♂","name":"man zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2640 FE0F","char":"🧟‍♀️","name":"woman zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2640","char":"🧟‍♀","name":"woman zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9CC","char":"🧌","name":"troll","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F486","char":"💆","name":"person getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB","char":"💆🏻","name":"person getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC","char":"💆🏼","name":"person getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD","char":"💆🏽","name":"person getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE","char":"💆🏾","name":"person getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF","char":"💆🏿","name":"person getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2642 FE0F","char":"💆‍♂️","name":"man getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2642","char":"💆‍♂","name":"man getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2642 FE0F","char":"💆🏻‍♂️","name":"man getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2642","char":"💆🏻‍♂","name":"man getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2642 FE0F","char":"💆🏼‍♂️","name":"man getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2642","char":"💆🏼‍♂","name":"man getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2642 FE0F","char":"💆🏽‍♂️","name":"man getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2642","char":"💆🏽‍♂","name":"man getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2642 FE0F","char":"💆🏾‍♂️","name":"man getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2642","char":"💆🏾‍♂","name":"man getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2642 FE0F","char":"💆🏿‍♂️","name":"man getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2642","char":"💆🏿‍♂","name":"man getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2640 FE0F","char":"💆‍♀️","name":"woman getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2640","char":"💆‍♀","name":"woman getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2640 FE0F","char":"💆🏻‍♀️","name":"woman getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2640","char":"💆🏻‍♀","name":"woman getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2640 FE0F","char":"💆🏼‍♀️","name":"woman getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2640","char":"💆🏼‍♀","name":"woman getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2640 FE0F","char":"💆🏽‍♀️","name":"woman getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2640","char":"💆🏽‍♀","name":"woman getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2640 FE0F","char":"💆🏾‍♀️","name":"woman getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2640","char":"💆🏾‍♀","name":"woman getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2640 FE0F","char":"💆🏿‍♀️","name":"woman getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2640","char":"💆🏿‍♀","name":"woman getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487","char":"💇","name":"person getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB","char":"💇🏻","name":"person getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC","char":"💇🏼","name":"person getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD","char":"💇🏽","name":"person getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE","char":"💇🏾","name":"person getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF","char":"💇🏿","name":"person getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2642 FE0F","char":"💇‍♂️","name":"man getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2642","char":"💇‍♂","name":"man getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2642 FE0F","char":"💇🏻‍♂️","name":"man getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2642","char":"💇🏻‍♂","name":"man getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2642 FE0F","char":"💇🏼‍♂️","name":"man getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2642","char":"💇🏼‍♂","name":"man getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2642 FE0F","char":"💇🏽‍♂️","name":"man getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2642","char":"💇🏽‍♂","name":"man getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2642 FE0F","char":"💇🏾‍♂️","name":"man getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2642","char":"💇🏾‍♂","name":"man getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2642 FE0F","char":"💇🏿‍♂️","name":"man getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2642","char":"💇🏿‍♂","name":"man getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2640 FE0F","char":"💇‍♀️","name":"woman getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2640","char":"💇‍♀","name":"woman getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2640 FE0F","char":"💇🏻‍♀️","name":"woman getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2640","char":"💇🏻‍♀","name":"woman getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2640 FE0F","char":"💇🏼‍♀️","name":"woman getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2640","char":"💇🏼‍♀","name":"woman getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2640 FE0F","char":"💇🏽‍♀️","name":"woman getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2640","char":"💇🏽‍♀","name":"woman getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2640 FE0F","char":"💇🏾‍♀️","name":"woman getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2640","char":"💇🏾‍♀","name":"woman getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2640 FE0F","char":"💇🏿‍♀️","name":"woman getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2640","char":"💇🏿‍♀","name":"woman getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6","char":"🚶","name":"person walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB","char":"🚶🏻","name":"person walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC","char":"🚶🏼","name":"person walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD","char":"🚶🏽","name":"person walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE","char":"🚶🏾","name":"person walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF","char":"🚶🏿","name":"person walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F","char":"🚶‍♂️","name":"man walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642","char":"🚶‍♂","name":"man walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F","char":"🚶🏻‍♂️","name":"man walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642","char":"🚶🏻‍♂","name":"man walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F","char":"🚶🏼‍♂️","name":"man walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642","char":"🚶🏼‍♂","name":"man walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F","char":"🚶🏽‍♂️","name":"man walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642","char":"🚶🏽‍♂","name":"man walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F","char":"🚶🏾‍♂️","name":"man walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642","char":"🚶🏾‍♂","name":"man walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F","char":"🚶🏿‍♂️","name":"man walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642","char":"🚶🏿‍♂","name":"man walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F","char":"🚶‍♀️","name":"woman walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640","char":"🚶‍♀","name":"woman walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F","char":"🚶🏻‍♀️","name":"woman walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640","char":"🚶🏻‍♀","name":"woman walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F","char":"🚶🏼‍♀️","name":"woman walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640","char":"🚶🏼‍♀","name":"woman walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F","char":"🚶🏽‍♀️","name":"woman walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640","char":"🚶🏽‍♀","name":"woman walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F","char":"🚶🏾‍♀️","name":"woman walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640","char":"🚶🏾‍♀","name":"woman walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F","char":"🚶🏿‍♀️","name":"woman walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640","char":"🚶🏿‍♀","name":"woman walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 27A1 FE0F","char":"🚶‍➡️","name":"person walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 27A1","char":"🚶‍➡","name":"person walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 27A1 FE0F","char":"🚶🏻‍➡️","name":"person walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 27A1","char":"🚶🏻‍➡","name":"person walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 27A1 FE0F","char":"🚶🏼‍➡️","name":"person walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 27A1","char":"🚶🏼‍➡","name":"person walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 27A1 FE0F","char":"🚶🏽‍➡️","name":"person walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 27A1","char":"🚶🏽‍➡","name":"person walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 27A1 FE0F","char":"🚶🏾‍➡️","name":"person walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 27A1","char":"🚶🏾‍➡","name":"person walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 27A1 FE0F","char":"🚶🏿‍➡️","name":"person walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 27A1","char":"🚶🏿‍➡","name":"person walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶‍♀️‍➡️","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 200D 27A1 FE0F","char":"🚶‍♀‍➡️","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F 200D 27A1","char":"🚶‍♀️‍➡","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 200D 27A1","char":"🚶‍♀‍➡","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏻‍♀️‍➡️","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 200D 27A1 FE0F","char":"🚶🏻‍♀‍➡️","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F 200D 27A1","char":"🚶🏻‍♀️‍➡","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 200D 27A1","char":"🚶🏻‍♀‍➡","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏼‍♀️‍➡️","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 200D 27A1 FE0F","char":"🚶🏼‍♀‍➡️","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F 200D 27A1","char":"🚶🏼‍♀️‍➡","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 200D 27A1","char":"🚶🏼‍♀‍➡","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏽‍♀️‍➡️","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 200D 27A1 FE0F","char":"🚶🏽‍♀‍➡️","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F 200D 27A1","char":"🚶🏽‍♀️‍➡","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 200D 27A1","char":"🚶🏽‍♀‍➡","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏾‍♀️‍➡️","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 200D 27A1 FE0F","char":"🚶🏾‍♀‍➡️","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F 200D 27A1","char":"🚶🏾‍♀️‍➡","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 200D 27A1","char":"🚶🏾‍♀‍➡","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏿‍♀️‍➡️","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 200D 27A1 FE0F","char":"🚶🏿‍♀‍➡️","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F 200D 27A1","char":"🚶🏿‍♀️‍➡","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 200D 27A1","char":"🚶🏿‍♀‍➡","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶‍♂️‍➡️","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 200D 27A1 FE0F","char":"🚶‍♂‍➡️","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F 200D 27A1","char":"🚶‍♂️‍➡","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 200D 27A1","char":"🚶‍♂‍➡","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏻‍♂️‍➡️","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 200D 27A1 FE0F","char":"🚶🏻‍♂‍➡️","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F 200D 27A1","char":"🚶🏻‍♂️‍➡","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 200D 27A1","char":"🚶🏻‍♂‍➡","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏼‍♂️‍➡️","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 200D 27A1 FE0F","char":"🚶🏼‍♂‍➡️","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F 200D 27A1","char":"🚶🏼‍♂️‍➡","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 200D 27A1","char":"🚶🏼‍♂‍➡","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏽‍♂️‍➡️","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 200D 27A1 FE0F","char":"🚶🏽‍♂‍➡️","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F 200D 27A1","char":"🚶🏽‍♂️‍➡","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 200D 27A1","char":"🚶🏽‍♂‍➡","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏾‍♂️‍➡️","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 200D 27A1 FE0F","char":"🚶🏾‍♂‍➡️","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F 200D 27A1","char":"🚶🏾‍♂️‍➡","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 200D 27A1","char":"🚶🏾‍♂‍➡","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏿‍♂️‍➡️","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 200D 27A1 FE0F","char":"🚶🏿‍♂‍➡️","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F 200D 27A1","char":"🚶🏿‍♂️‍➡","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 200D 27A1","char":"🚶🏿‍♂‍➡","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD","char":"🧍","name":"person standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB","char":"🧍🏻","name":"person standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC","char":"🧍🏼","name":"person standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD","char":"🧍🏽","name":"person standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE","char":"🧍🏾","name":"person standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF","char":"🧍🏿","name":"person standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2642 FE0F","char":"🧍‍♂️","name":"man standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2642","char":"🧍‍♂","name":"man standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2642 FE0F","char":"🧍🏻‍♂️","name":"man standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2642","char":"🧍🏻‍♂","name":"man standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2642 FE0F","char":"🧍🏼‍♂️","name":"man standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2642","char":"🧍🏼‍♂","name":"man standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2642 FE0F","char":"🧍🏽‍♂️","name":"man standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2642","char":"🧍🏽‍♂","name":"man standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2642 FE0F","char":"🧍🏾‍♂️","name":"man standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2642","char":"🧍🏾‍♂","name":"man standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2642 FE0F","char":"🧍🏿‍♂️","name":"man standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2642","char":"🧍🏿‍♂","name":"man standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2640 FE0F","char":"🧍‍♀️","name":"woman standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2640","char":"🧍‍♀","name":"woman standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2640 FE0F","char":"🧍🏻‍♀️","name":"woman standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2640","char":"🧍🏻‍♀","name":"woman standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2640 FE0F","char":"🧍🏼‍♀️","name":"woman standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2640","char":"🧍🏼‍♀","name":"woman standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2640 FE0F","char":"🧍🏽‍♀️","name":"woman standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2640","char":"🧍🏽‍♀","name":"woman standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2640 FE0F","char":"🧍🏾‍♀️","name":"woman standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2640","char":"🧍🏾‍♀","name":"woman standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2640 FE0F","char":"🧍🏿‍♀️","name":"woman standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2640","char":"🧍🏿‍♀","name":"woman standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE","char":"🧎","name":"person kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB","char":"🧎🏻","name":"person kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC","char":"🧎🏼","name":"person kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD","char":"🧎🏽","name":"person kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE","char":"🧎🏾","name":"person kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF","char":"🧎🏿","name":"person kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F","char":"🧎‍♂️","name":"man kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642","char":"🧎‍♂","name":"man kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F","char":"🧎🏻‍♂️","name":"man kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642","char":"🧎🏻‍♂","name":"man kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F","char":"🧎🏼‍♂️","name":"man kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642","char":"🧎🏼‍♂","name":"man kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F","char":"🧎🏽‍♂️","name":"man kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642","char":"🧎🏽‍♂","name":"man kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F","char":"🧎🏾‍♂️","name":"man kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642","char":"🧎🏾‍♂","name":"man kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F","char":"🧎🏿‍♂️","name":"man kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642","char":"🧎🏿‍♂","name":"man kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F","char":"🧎‍♀️","name":"woman kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640","char":"🧎‍♀","name":"woman kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F","char":"🧎🏻‍♀️","name":"woman kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640","char":"🧎🏻‍♀","name":"woman kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F","char":"🧎🏼‍♀️","name":"woman kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640","char":"🧎🏼‍♀","name":"woman kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F","char":"🧎🏽‍♀️","name":"woman kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640","char":"🧎🏽‍♀","name":"woman kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F","char":"🧎🏾‍♀️","name":"woman kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640","char":"🧎🏾‍♀","name":"woman kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F","char":"🧎🏿‍♀️","name":"woman kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640","char":"🧎🏿‍♀","name":"woman kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 27A1 FE0F","char":"🧎‍➡️","name":"person kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 27A1","char":"🧎‍➡","name":"person kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 27A1 FE0F","char":"🧎🏻‍➡️","name":"person kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 27A1","char":"🧎🏻‍➡","name":"person kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 27A1 FE0F","char":"🧎🏼‍➡️","name":"person kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 27A1","char":"🧎🏼‍➡","name":"person kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 27A1 FE0F","char":"🧎🏽‍➡️","name":"person kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 27A1","char":"🧎🏽‍➡","name":"person kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 27A1 FE0F","char":"🧎🏾‍➡️","name":"person kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 27A1","char":"🧎🏾‍➡","name":"person kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 27A1 FE0F","char":"🧎🏿‍➡️","name":"person kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 27A1","char":"🧎🏿‍➡","name":"person kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎‍♀️‍➡️","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 200D 27A1 FE0F","char":"🧎‍♀‍➡️","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F 200D 27A1","char":"🧎‍♀️‍➡","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 200D 27A1","char":"🧎‍♀‍➡","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏻‍♀️‍➡️","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 200D 27A1 FE0F","char":"🧎🏻‍♀‍➡️","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F 200D 27A1","char":"🧎🏻‍♀️‍➡","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 200D 27A1","char":"🧎🏻‍♀‍➡","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏼‍♀️‍➡️","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 200D 27A1 FE0F","char":"🧎🏼‍♀‍➡️","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F 200D 27A1","char":"🧎🏼‍♀️‍➡","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 200D 27A1","char":"🧎🏼‍♀‍➡","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏽‍♀️‍➡️","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 200D 27A1 FE0F","char":"🧎🏽‍♀‍➡️","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F 200D 27A1","char":"🧎🏽‍♀️‍➡","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 200D 27A1","char":"🧎🏽‍♀‍➡","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏾‍♀️‍➡️","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 200D 27A1 FE0F","char":"🧎🏾‍♀‍➡️","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F 200D 27A1","char":"🧎🏾‍♀️‍➡","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 200D 27A1","char":"🧎🏾‍♀‍➡","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏿‍♀️‍➡️","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 200D 27A1 FE0F","char":"🧎🏿‍♀‍➡️","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F 200D 27A1","char":"🧎🏿‍♀️‍➡","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 200D 27A1","char":"🧎🏿‍♀‍➡","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎‍♂️‍➡️","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 200D 27A1 FE0F","char":"🧎‍♂‍➡️","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F 200D 27A1","char":"🧎‍♂️‍➡","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 200D 27A1","char":"🧎‍♂‍➡","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏻‍♂️‍➡️","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 200D 27A1 FE0F","char":"🧎🏻‍♂‍➡️","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F 200D 27A1","char":"🧎🏻‍♂️‍➡","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 200D 27A1","char":"🧎🏻‍♂‍➡","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏼‍♂️‍➡️","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 200D 27A1 FE0F","char":"🧎🏼‍♂‍➡️","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F 200D 27A1","char":"🧎🏼‍♂️‍➡","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 200D 27A1","char":"🧎🏼‍♂‍➡","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏽‍♂️‍➡️","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 200D 27A1 FE0F","char":"🧎🏽‍♂‍➡️","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F 200D 27A1","char":"🧎🏽‍♂️‍➡","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 200D 27A1","char":"🧎🏽‍♂‍➡","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏾‍♂️‍➡️","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 200D 27A1 FE0F","char":"🧎🏾‍♂‍➡️","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F 200D 27A1","char":"🧎🏾‍♂️‍➡","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 200D 27A1","char":"🧎🏾‍♂‍➡","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏿‍♂️‍➡️","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 200D 27A1 FE0F","char":"🧎🏿‍♂‍➡️","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F 200D 27A1","char":"🧎🏿‍♂️‍➡","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 200D 27A1","char":"🧎🏿‍♂‍➡","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF","char":"🧑‍🦯","name":"person with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF","char":"🧑🏻‍🦯","name":"person with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF","char":"🧑🏼‍🦯","name":"person with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF","char":"🧑🏽‍🦯","name":"person with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF","char":"🧑🏾‍🦯","name":"person with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF","char":"🧑🏿‍🦯","name":"person with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF 200D 27A1 FE0F","char":"🧑‍🦯‍➡️","name":"person with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF 200D 27A1","char":"🧑‍🦯‍➡","name":"person with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏻‍🦯‍➡️","name":"person with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF 200D 27A1","char":"🧑🏻‍🦯‍➡","name":"person with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏼‍🦯‍➡️","name":"person with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF 200D 27A1","char":"🧑🏼‍🦯‍➡","name":"person with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏽‍🦯‍➡️","name":"person with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF 200D 27A1","char":"🧑🏽‍🦯‍➡","name":"person with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏾‍🦯‍➡️","name":"person with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF 200D 27A1","char":"🧑🏾‍🦯‍➡","name":"person with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏿‍🦯‍➡️","name":"person with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF 200D 27A1","char":"🧑🏿‍🦯‍➡","name":"person with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF","char":"👨‍🦯","name":"man with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF","char":"👨🏻‍🦯","name":"man with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF","char":"👨🏼‍🦯","name":"man with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF","char":"👨🏽‍🦯","name":"man with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF","char":"👨🏾‍🦯","name":"man with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF","char":"👨🏿‍🦯","name":"man with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF 200D 27A1 FE0F","char":"👨‍🦯‍➡️","name":"man with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF 200D 27A1","char":"👨‍🦯‍➡","name":"man with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"👨🏻‍🦯‍➡️","name":"man with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF 200D 27A1","char":"👨🏻‍🦯‍➡","name":"man with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"👨🏼‍🦯‍➡️","name":"man with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF 200D 27A1","char":"👨🏼‍🦯‍➡","name":"man with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"👨🏽‍🦯‍➡️","name":"man with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF 200D 27A1","char":"👨🏽‍🦯‍➡","name":"man with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"👨🏾‍🦯‍➡️","name":"man with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF 200D 27A1","char":"👨🏾‍🦯‍➡","name":"man with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"👨🏿‍🦯‍➡️","name":"man with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF 200D 27A1","char":"👨🏿‍🦯‍➡","name":"man with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF","char":"👩‍🦯","name":"woman with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF","char":"👩🏻‍🦯","name":"woman with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF","char":"👩🏼‍🦯","name":"woman with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF","char":"👩🏽‍🦯","name":"woman with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF","char":"👩🏾‍🦯","name":"woman with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF","char":"👩🏿‍🦯","name":"woman with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF 200D 27A1 FE0F","char":"👩‍🦯‍➡️","name":"woman with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF 200D 27A1","char":"👩‍🦯‍➡","name":"woman with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"👩🏻‍🦯‍➡️","name":"woman with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF 200D 27A1","char":"👩🏻‍🦯‍➡","name":"woman with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"👩🏼‍🦯‍➡️","name":"woman with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF 200D 27A1","char":"👩🏼‍🦯‍➡","name":"woman with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"👩🏽‍🦯‍➡️","name":"woman with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF 200D 27A1","char":"👩🏽‍🦯‍➡","name":"woman with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"👩🏾‍🦯‍➡️","name":"woman with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF 200D 27A1","char":"👩🏾‍🦯‍➡","name":"woman with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"👩🏿‍🦯‍➡️","name":"woman with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF 200D 27A1","char":"👩🏿‍🦯‍➡","name":"woman with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC","char":"🧑‍🦼","name":"person in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC","char":"🧑🏻‍🦼","name":"person in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC","char":"🧑🏼‍🦼","name":"person in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC","char":"🧑🏽‍🦼","name":"person in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC","char":"🧑🏾‍🦼","name":"person in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC","char":"🧑🏿‍🦼","name":"person in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC 200D 27A1 FE0F","char":"🧑‍🦼‍➡️","name":"person in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC 200D 27A1","char":"🧑‍🦼‍➡","name":"person in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏻‍🦼‍➡️","name":"person in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC 200D 27A1","char":"🧑🏻‍🦼‍➡","name":"person in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏼‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC 200D 27A1","char":"🧑🏼‍🦼‍➡","name":"person in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏽‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC 200D 27A1","char":"🧑🏽‍🦼‍➡","name":"person in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏾‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC 200D 27A1","char":"🧑🏾‍🦼‍➡","name":"person in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏿‍🦼‍➡️","name":"person in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC 200D 27A1","char":"🧑🏿‍🦼‍➡","name":"person in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC","char":"👨‍🦼","name":"man in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC","char":"👨🏻‍🦼","name":"man in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC","char":"👨🏼‍🦼","name":"man in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC","char":"👨🏽‍🦼","name":"man in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC","char":"👨🏾‍🦼","name":"man in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC","char":"👨🏿‍🦼","name":"man in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC 200D 27A1 FE0F","char":"👨‍🦼‍➡️","name":"man in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC 200D 27A1","char":"👨‍🦼‍➡","name":"man in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"👨🏻‍🦼‍➡️","name":"man in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC 200D 27A1","char":"👨🏻‍🦼‍➡","name":"man in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"👨🏼‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC 200D 27A1","char":"👨🏼‍🦼‍➡","name":"man in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"👨🏽‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC 200D 27A1","char":"👨🏽‍🦼‍➡","name":"man in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"👨🏾‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC 200D 27A1","char":"👨🏾‍🦼‍➡","name":"man in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"👨🏿‍🦼‍➡️","name":"man in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC 200D 27A1","char":"👨🏿‍🦼‍➡","name":"man in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC","char":"👩‍🦼","name":"woman in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC","char":"👩🏻‍🦼","name":"woman in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC","char":"👩🏼‍🦼","name":"woman in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC","char":"👩🏽‍🦼","name":"woman in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC","char":"👩🏾‍🦼","name":"woman in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC","char":"👩🏿‍🦼","name":"woman in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC 200D 27A1 FE0F","char":"👩‍🦼‍➡️","name":"woman in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC 200D 27A1","char":"👩‍🦼‍➡","name":"woman in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"👩🏻‍🦼‍➡️","name":"woman in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC 200D 27A1","char":"👩🏻‍🦼‍➡","name":"woman in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"👩🏼‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC 200D 27A1","char":"👩🏼‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"👩🏽‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC 200D 27A1","char":"👩🏽‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"👩🏾‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC 200D 27A1","char":"👩🏾‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"👩🏿‍🦼‍➡️","name":"woman in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC 200D 27A1","char":"👩🏿‍🦼‍➡","name":"woman in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD","char":"🧑‍🦽","name":"person in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD","char":"🧑🏻‍🦽","name":"person in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD","char":"🧑🏼‍🦽","name":"person in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD","char":"🧑🏽‍🦽","name":"person in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD","char":"🧑🏾‍🦽","name":"person in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD","char":"🧑🏿‍🦽","name":"person in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD 200D 27A1 FE0F","char":"🧑‍🦽‍➡️","name":"person in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD 200D 27A1","char":"🧑‍🦽‍➡","name":"person in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏻‍🦽‍➡️","name":"person in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD 200D 27A1","char":"🧑🏻‍🦽‍➡","name":"person in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏼‍🦽‍➡️","name":"person in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD 200D 27A1","char":"🧑🏼‍🦽‍➡","name":"person in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏽‍🦽‍➡️","name":"person in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD 200D 27A1","char":"🧑🏽‍🦽‍➡","name":"person in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏾‍🦽‍➡️","name":"person in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD 200D 27A1","char":"🧑🏾‍🦽‍➡","name":"person in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏿‍🦽‍➡️","name":"person in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD 200D 27A1","char":"🧑🏿‍🦽‍➡","name":"person in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD","char":"👨‍🦽","name":"man in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD","char":"👨🏻‍🦽","name":"man in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD","char":"👨🏼‍🦽","name":"man in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD","char":"👨🏽‍🦽","name":"man in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD","char":"👨🏾‍🦽","name":"man in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD","char":"👨🏿‍🦽","name":"man in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD 200D 27A1 FE0F","char":"👨‍🦽‍➡️","name":"man in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD 200D 27A1","char":"👨‍🦽‍➡","name":"man in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"👨🏻‍🦽‍➡️","name":"man in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD 200D 27A1","char":"👨🏻‍🦽‍➡","name":"man in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"👨🏼‍🦽‍➡️","name":"man in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD 200D 27A1","char":"👨🏼‍🦽‍➡","name":"man in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"👨🏽‍🦽‍➡️","name":"man in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD 200D 27A1","char":"👨🏽‍🦽‍➡","name":"man in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"👨🏾‍🦽‍➡️","name":"man in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD 200D 27A1","char":"👨🏾‍🦽‍➡","name":"man in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"👨🏿‍🦽‍➡️","name":"man in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD 200D 27A1","char":"👨🏿‍🦽‍➡","name":"man in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD","char":"👩‍🦽","name":"woman in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD","char":"👩🏻‍🦽","name":"woman in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD","char":"👩🏼‍🦽","name":"woman in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD","char":"👩🏽‍🦽","name":"woman in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD","char":"👩🏾‍🦽","name":"woman in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD","char":"👩🏿‍🦽","name":"woman in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD 200D 27A1 FE0F","char":"👩‍🦽‍➡️","name":"woman in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD 200D 27A1","char":"👩‍🦽‍➡","name":"woman in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"👩🏻‍🦽‍➡️","name":"woman in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD 200D 27A1","char":"👩🏻‍🦽‍➡","name":"woman in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"👩🏼‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD 200D 27A1","char":"👩🏼‍🦽‍➡","name":"woman in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"👩🏽‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD 200D 27A1","char":"👩🏽‍🦽‍➡","name":"woman in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"👩🏾‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD 200D 27A1","char":"👩🏾‍🦽‍➡","name":"woman in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"👩🏿‍🦽‍➡️","name":"woman in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD 200D 27A1","char":"👩🏿‍🦽‍➡","name":"woman in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3","char":"🏃","name":"person running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB","char":"🏃🏻","name":"person running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC","char":"🏃🏼","name":"person running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD","char":"🏃🏽","name":"person running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE","char":"🏃🏾","name":"person running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF","char":"🏃🏿","name":"person running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F","char":"🏃‍♂️","name":"man running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642","char":"🏃‍♂","name":"man running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F","char":"🏃🏻‍♂️","name":"man running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642","char":"🏃🏻‍♂","name":"man running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F","char":"🏃🏼‍♂️","name":"man running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642","char":"🏃🏼‍♂","name":"man running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F","char":"🏃🏽‍♂️","name":"man running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642","char":"🏃🏽‍♂","name":"man running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F","char":"🏃🏾‍♂️","name":"man running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642","char":"🏃🏾‍♂","name":"man running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F","char":"🏃🏿‍♂️","name":"man running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642","char":"🏃🏿‍♂","name":"man running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F","char":"🏃‍♀️","name":"woman running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640","char":"🏃‍♀","name":"woman running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F","char":"🏃🏻‍♀️","name":"woman running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640","char":"🏃🏻‍♀","name":"woman running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F","char":"🏃🏼‍♀️","name":"woman running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640","char":"🏃🏼‍♀","name":"woman running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F","char":"🏃🏽‍♀️","name":"woman running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640","char":"🏃🏽‍♀","name":"woman running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F","char":"🏃🏾‍♀️","name":"woman running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640","char":"🏃🏾‍♀","name":"woman running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F","char":"🏃🏿‍♀️","name":"woman running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640","char":"🏃🏿‍♀","name":"woman running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 27A1 FE0F","char":"🏃‍➡️","name":"person running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 27A1","char":"🏃‍➡","name":"person running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 27A1 FE0F","char":"🏃🏻‍➡️","name":"person running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 27A1","char":"🏃🏻‍➡","name":"person running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 27A1 FE0F","char":"🏃🏼‍➡️","name":"person running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 27A1","char":"🏃🏼‍➡","name":"person running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 27A1 FE0F","char":"🏃🏽‍➡️","name":"person running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 27A1","char":"🏃🏽‍➡","name":"person running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 27A1 FE0F","char":"🏃🏾‍➡️","name":"person running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 27A1","char":"🏃🏾‍➡","name":"person running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 27A1 FE0F","char":"🏃🏿‍➡️","name":"person running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 27A1","char":"🏃🏿‍➡","name":"person running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃‍♀️‍➡️","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 200D 27A1 FE0F","char":"🏃‍♀‍➡️","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F 200D 27A1","char":"🏃‍♀️‍➡","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 200D 27A1","char":"🏃‍♀‍➡","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏻‍♀️‍➡️","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 200D 27A1 FE0F","char":"🏃🏻‍♀‍➡️","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F 200D 27A1","char":"🏃🏻‍♀️‍➡","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 200D 27A1","char":"🏃🏻‍♀‍➡","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏼‍♀️‍➡️","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 200D 27A1 FE0F","char":"🏃🏼‍♀‍➡️","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F 200D 27A1","char":"🏃🏼‍♀️‍➡","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 200D 27A1","char":"🏃🏼‍♀‍➡","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏽‍♀️‍➡️","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 200D 27A1 FE0F","char":"🏃🏽‍♀‍➡️","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F 200D 27A1","char":"🏃🏽‍♀️‍➡","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 200D 27A1","char":"🏃🏽‍♀‍➡","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏾‍♀️‍➡️","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 200D 27A1 FE0F","char":"🏃🏾‍♀‍➡️","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F 200D 27A1","char":"🏃🏾‍♀️‍➡","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 200D 27A1","char":"🏃🏾‍♀‍➡","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏿‍♀️‍➡️","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 200D 27A1 FE0F","char":"🏃🏿‍♀‍➡️","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F 200D 27A1","char":"🏃🏿‍♀️‍➡","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 200D 27A1","char":"🏃🏿‍♀‍➡","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃‍♂️‍➡️","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 200D 27A1 FE0F","char":"🏃‍♂‍➡️","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F 200D 27A1","char":"🏃‍♂️‍➡","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 200D 27A1","char":"🏃‍♂‍➡","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏻‍♂️‍➡️","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 200D 27A1 FE0F","char":"🏃🏻‍♂‍➡️","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F 200D 27A1","char":"🏃🏻‍♂️‍➡","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 200D 27A1","char":"🏃🏻‍♂‍➡","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏼‍♂️‍➡️","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 200D 27A1 FE0F","char":"🏃🏼‍♂‍➡️","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F 200D 27A1","char":"🏃🏼‍♂️‍➡","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 200D 27A1","char":"🏃🏼‍♂‍➡","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏽‍♂️‍➡️","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 200D 27A1 FE0F","char":"🏃🏽‍♂‍➡️","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F 200D 27A1","char":"🏃🏽‍♂️‍➡","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 200D 27A1","char":"🏃🏽‍♂‍➡","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏾‍♂️‍➡️","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 200D 27A1 FE0F","char":"🏃🏾‍♂‍➡️","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F 200D 27A1","char":"🏃🏾‍♂️‍➡","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 200D 27A1","char":"🏃🏾‍♂‍➡","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏿‍♂️‍➡️","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 200D 27A1 FE0F","char":"🏃🏿‍♂‍➡️","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F 200D 27A1","char":"🏃🏿‍♂️‍➡","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 200D 27A1","char":"🏃🏿‍♂‍➡","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483","char":"💃","name":"woman dancing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FB","char":"💃🏻","name":"woman dancing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FC","char":"💃🏼","name":"woman dancing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FD","char":"💃🏽","name":"woman dancing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FE","char":"💃🏾","name":"woman dancing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FF","char":"💃🏿","name":"woman dancing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A","char":"🕺","name":"man dancing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FB","char":"🕺🏻","name":"man dancing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FC","char":"🕺🏼","name":"man dancing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FD","char":"🕺🏽","name":"man dancing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FE","char":"🕺🏾","name":"man dancing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FF","char":"🕺🏿","name":"man dancing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 FE0F","char":"🕴️","name":"person in suit levitating","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574","char":"🕴","name":"person in suit levitating","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FB","char":"🕴🏻","name":"person in suit levitating: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FC","char":"🕴🏼","name":"person in suit levitating: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FD","char":"🕴🏽","name":"person in suit levitating: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FE","char":"🕴🏾","name":"person in suit levitating: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FF","char":"🕴🏿","name":"person in suit levitating: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F","char":"👯","name":"people with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2642 FE0F","char":"👯‍♂️","name":"men with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2642","char":"👯‍♂","name":"men with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2640 FE0F","char":"👯‍♀️","name":"women with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2640","char":"👯‍♀","name":"women with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6","char":"🧖","name":"person in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB","char":"🧖🏻","name":"person in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC","char":"🧖🏼","name":"person in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD","char":"🧖🏽","name":"person in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE","char":"🧖🏾","name":"person in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF","char":"🧖🏿","name":"person in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2642 FE0F","char":"🧖‍♂️","name":"man in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2642","char":"🧖‍♂","name":"man in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2642 FE0F","char":"🧖🏻‍♂️","name":"man in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2642","char":"🧖🏻‍♂","name":"man in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2642 FE0F","char":"🧖🏼‍♂️","name":"man in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2642","char":"🧖🏼‍♂","name":"man in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2642 FE0F","char":"🧖🏽‍♂️","name":"man in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2642","char":"🧖🏽‍♂","name":"man in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2642 FE0F","char":"🧖🏾‍♂️","name":"man in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2642","char":"🧖🏾‍♂","name":"man in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2642 FE0F","char":"🧖🏿‍♂️","name":"man in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2642","char":"🧖🏿‍♂","name":"man in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2640 FE0F","char":"🧖‍♀️","name":"woman in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2640","char":"🧖‍♀","name":"woman in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2640 FE0F","char":"🧖🏻‍♀️","name":"woman in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2640","char":"🧖🏻‍♀","name":"woman in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2640 FE0F","char":"🧖🏼‍♀️","name":"woman in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2640","char":"🧖🏼‍♀","name":"woman in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2640 FE0F","char":"🧖🏽‍♀️","name":"woman in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2640","char":"🧖🏽‍♀","name":"woman in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2640 FE0F","char":"🧖🏾‍♀️","name":"woman in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2640","char":"🧖🏾‍♀","name":"woman in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2640 FE0F","char":"🧖🏿‍♀️","name":"woman in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2640","char":"🧖🏿‍♀","name":"woman in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7","char":"🧗","name":"person climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB","char":"🧗🏻","name":"person climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC","char":"🧗🏼","name":"person climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD","char":"🧗🏽","name":"person climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE","char":"🧗🏾","name":"person climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF","char":"🧗🏿","name":"person climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2642 FE0F","char":"🧗‍♂️","name":"man climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2642","char":"🧗‍♂","name":"man climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2642 FE0F","char":"🧗🏻‍♂️","name":"man climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2642","char":"🧗🏻‍♂","name":"man climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2642 FE0F","char":"🧗🏼‍♂️","name":"man climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2642","char":"🧗🏼‍♂","name":"man climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2642 FE0F","char":"🧗🏽‍♂️","name":"man climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2642","char":"🧗🏽‍♂","name":"man climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2642 FE0F","char":"🧗🏾‍♂️","name":"man climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2642","char":"🧗🏾‍♂","name":"man climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2642 FE0F","char":"🧗🏿‍♂️","name":"man climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2642","char":"🧗🏿‍♂","name":"man climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2640 FE0F","char":"🧗‍♀️","name":"woman climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2640","char":"🧗‍♀","name":"woman climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2640 FE0F","char":"🧗🏻‍♀️","name":"woman climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2640","char":"🧗🏻‍♀","name":"woman climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2640 FE0F","char":"🧗🏼‍♀️","name":"woman climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2640","char":"🧗🏼‍♀","name":"woman climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2640 FE0F","char":"🧗🏽‍♀️","name":"woman climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2640","char":"🧗🏽‍♀","name":"woman climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2640 FE0F","char":"🧗🏾‍♀️","name":"woman climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2640","char":"🧗🏾‍♀","name":"woman climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2640 FE0F","char":"🧗🏿‍♀️","name":"woman climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2640","char":"🧗🏿‍♀","name":"woman climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F93A","char":"🤺","name":"person fencing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7","char":"🏇","name":"horse racing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FB","char":"🏇🏻","name":"horse racing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FC","char":"🏇🏼","name":"horse racing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FD","char":"🏇🏽","name":"horse racing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FE","char":"🏇🏾","name":"horse racing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FF","char":"🏇🏿","name":"horse racing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F7 FE0F","char":"⛷️","name":"skier","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F7","char":"⛷","name":"skier","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2","char":"🏂","name":"snowboarder","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FB","char":"🏂🏻","name":"snowboarder: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FC","char":"🏂🏼","name":"snowboarder: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FD","char":"🏂🏽","name":"snowboarder: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FE","char":"🏂🏾","name":"snowboarder: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FF","char":"🏂🏿","name":"snowboarder: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F","char":"🏌️","name":"person golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC","char":"🏌","name":"person golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB","char":"🏌🏻","name":"person golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC","char":"🏌🏼","name":"person golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD","char":"🏌🏽","name":"person golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE","char":"🏌🏾","name":"person golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF","char":"🏌🏿","name":"person golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2642 FE0F","char":"🏌️‍♂️","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2642 FE0F","char":"🏌‍♂️","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2642","char":"🏌️‍♂","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2642","char":"🏌‍♂","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2642 FE0F","char":"🏌🏻‍♂️","name":"man golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2642","char":"🏌🏻‍♂","name":"man golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2642 FE0F","char":"🏌🏼‍♂️","name":"man golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2642","char":"🏌🏼‍♂","name":"man golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2642 FE0F","char":"🏌🏽‍♂️","name":"man golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2642","char":"🏌🏽‍♂","name":"man golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2642 FE0F","char":"🏌🏾‍♂️","name":"man golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2642","char":"🏌🏾‍♂","name":"man golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2642 FE0F","char":"🏌🏿‍♂️","name":"man golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2642","char":"🏌🏿‍♂","name":"man golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2640 FE0F","char":"🏌️‍♀️","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2640 FE0F","char":"🏌‍♀️","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2640","char":"🏌️‍♀","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2640","char":"🏌‍♀","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2640 FE0F","char":"🏌🏻‍♀️","name":"woman golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2640","char":"🏌🏻‍♀","name":"woman golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2640 FE0F","char":"🏌🏼‍♀️","name":"woman golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2640","char":"🏌🏼‍♀","name":"woman golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2640 FE0F","char":"🏌🏽‍♀️","name":"woman golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2640","char":"🏌🏽‍♀","name":"woman golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2640 FE0F","char":"🏌🏾‍♀️","name":"woman golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2640","char":"🏌🏾‍♀","name":"woman golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2640 FE0F","char":"🏌🏿‍♀️","name":"woman golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2640","char":"🏌🏿‍♀","name":"woman golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4","char":"🏄","name":"person surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB","char":"🏄🏻","name":"person surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC","char":"🏄🏼","name":"person surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD","char":"🏄🏽","name":"person surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE","char":"🏄🏾","name":"person surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF","char":"🏄🏿","name":"person surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2642 FE0F","char":"🏄‍♂️","name":"man surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2642","char":"🏄‍♂","name":"man surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2642 FE0F","char":"🏄🏻‍♂️","name":"man surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2642","char":"🏄🏻‍♂","name":"man surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2642 FE0F","char":"🏄🏼‍♂️","name":"man surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2642","char":"🏄🏼‍♂","name":"man surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2642 FE0F","char":"🏄🏽‍♂️","name":"man surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2642","char":"🏄🏽‍♂","name":"man surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2642 FE0F","char":"🏄🏾‍♂️","name":"man surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2642","char":"🏄🏾‍♂","name":"man surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2642 FE0F","char":"🏄🏿‍♂️","name":"man surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2642","char":"🏄🏿‍♂","name":"man surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2640 FE0F","char":"🏄‍♀️","name":"woman surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2640","char":"🏄‍♀","name":"woman surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2640 FE0F","char":"🏄🏻‍♀️","name":"woman surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2640","char":"🏄🏻‍♀","name":"woman surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2640 FE0F","char":"🏄🏼‍♀️","name":"woman surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2640","char":"🏄🏼‍♀","name":"woman surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2640 FE0F","char":"🏄🏽‍♀️","name":"woman surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2640","char":"🏄🏽‍♀","name":"woman surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2640 FE0F","char":"🏄🏾‍♀️","name":"woman surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2640","char":"🏄🏾‍♀","name":"woman surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2640 FE0F","char":"🏄🏿‍♀️","name":"woman surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2640","char":"🏄🏿‍♀","name":"woman surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3","char":"🚣","name":"person rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB","char":"🚣🏻","name":"person rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC","char":"🚣🏼","name":"person rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD","char":"🚣🏽","name":"person rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE","char":"🚣🏾","name":"person rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF","char":"🚣🏿","name":"person rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2642 FE0F","char":"🚣‍♂️","name":"man rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2642","char":"🚣‍♂","name":"man rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2642 FE0F","char":"🚣🏻‍♂️","name":"man rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2642","char":"🚣🏻‍♂","name":"man rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2642 FE0F","char":"🚣🏼‍♂️","name":"man rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2642","char":"🚣🏼‍♂","name":"man rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2642 FE0F","char":"🚣🏽‍♂️","name":"man rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2642","char":"🚣🏽‍♂","name":"man rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2642 FE0F","char":"🚣🏾‍♂️","name":"man rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2642","char":"🚣🏾‍♂","name":"man rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2642 FE0F","char":"🚣🏿‍♂️","name":"man rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2642","char":"🚣🏿‍♂","name":"man rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2640 FE0F","char":"🚣‍♀️","name":"woman rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2640","char":"🚣‍♀","name":"woman rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2640 FE0F","char":"🚣🏻‍♀️","name":"woman rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2640","char":"🚣🏻‍♀","name":"woman rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2640 FE0F","char":"🚣🏼‍♀️","name":"woman rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2640","char":"🚣🏼‍♀","name":"woman rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2640 FE0F","char":"🚣🏽‍♀️","name":"woman rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2640","char":"🚣🏽‍♀","name":"woman rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2640 FE0F","char":"🚣🏾‍♀️","name":"woman rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2640","char":"🚣🏾‍♀","name":"woman rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2640 FE0F","char":"🚣🏿‍♀️","name":"woman rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2640","char":"🚣🏿‍♀","name":"woman rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA","char":"🏊","name":"person swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB","char":"🏊🏻","name":"person swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC","char":"🏊🏼","name":"person swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD","char":"🏊🏽","name":"person swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE","char":"🏊🏾","name":"person swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF","char":"🏊🏿","name":"person swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2642 FE0F","char":"🏊‍♂️","name":"man swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2642","char":"🏊‍♂","name":"man swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2642 FE0F","char":"🏊🏻‍♂️","name":"man swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2642","char":"🏊🏻‍♂","name":"man swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2642 FE0F","char":"🏊🏼‍♂️","name":"man swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2642","char":"🏊🏼‍♂","name":"man swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2642 FE0F","char":"🏊🏽‍♂️","name":"man swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2642","char":"🏊🏽‍♂","name":"man swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2642 FE0F","char":"🏊🏾‍♂️","name":"man swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2642","char":"🏊🏾‍♂","name":"man swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2642 FE0F","char":"🏊🏿‍♂️","name":"man swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2642","char":"🏊🏿‍♂","name":"man swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2640 FE0F","char":"🏊‍♀️","name":"woman swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2640","char":"🏊‍♀","name":"woman swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2640 FE0F","char":"🏊🏻‍♀️","name":"woman swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2640","char":"🏊🏻‍♀","name":"woman swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2640 FE0F","char":"🏊🏼‍♀️","name":"woman swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2640","char":"🏊🏼‍♀","name":"woman swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2640 FE0F","char":"🏊🏽‍♀️","name":"woman swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2640","char":"🏊🏽‍♀","name":"woman swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2640 FE0F","char":"🏊🏾‍♀️","name":"woman swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2640","char":"🏊🏾‍♀","name":"woman swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2640 FE0F","char":"🏊🏿‍♀️","name":"woman swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2640","char":"🏊🏿‍♀","name":"woman swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F","char":"⛹️","name":"person bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9","char":"⛹","name":"person bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB","char":"⛹🏻","name":"person bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC","char":"⛹🏼","name":"person bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD","char":"⛹🏽","name":"person bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE","char":"⛹🏾","name":"person bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF","char":"⛹🏿","name":"person bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2642 FE0F","char":"⛹️‍♂️","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2642 FE0F","char":"⛹‍♂️","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2642","char":"⛹️‍♂","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2642","char":"⛹‍♂","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2642 FE0F","char":"⛹🏻‍♂️","name":"man bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2642","char":"⛹🏻‍♂","name":"man bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2642 FE0F","char":"⛹🏼‍♂️","name":"man bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2642","char":"⛹🏼‍♂","name":"man bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2642 FE0F","char":"⛹🏽‍♂️","name":"man bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2642","char":"⛹🏽‍♂","name":"man bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2642 FE0F","char":"⛹🏾‍♂️","name":"man bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2642","char":"⛹🏾‍♂","name":"man bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2642 FE0F","char":"⛹🏿‍♂️","name":"man bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2642","char":"⛹🏿‍♂","name":"man bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2640 FE0F","char":"⛹️‍♀️","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2640 FE0F","char":"⛹‍♀️","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2640","char":"⛹️‍♀","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2640","char":"⛹‍♀","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2640 FE0F","char":"⛹🏻‍♀️","name":"woman bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2640","char":"⛹🏻‍♀","name":"woman bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2640 FE0F","char":"⛹🏼‍♀️","name":"woman bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2640","char":"⛹🏼‍♀","name":"woman bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2640 FE0F","char":"⛹🏽‍♀️","name":"woman bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2640","char":"⛹🏽‍♀","name":"woman bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2640 FE0F","char":"⛹🏾‍♀️","name":"woman bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2640","char":"⛹🏾‍♀","name":"woman bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2640 FE0F","char":"⛹🏿‍♀️","name":"woman bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2640","char":"⛹🏿‍♀","name":"woman bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F","char":"🏋️","name":"person lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB","char":"🏋","name":"person lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB","char":"🏋🏻","name":"person lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC","char":"🏋🏼","name":"person lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD","char":"🏋🏽","name":"person lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE","char":"🏋🏾","name":"person lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF","char":"🏋🏿","name":"person lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2642 FE0F","char":"🏋️‍♂️","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2642 FE0F","char":"🏋‍♂️","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2642","char":"🏋️‍♂","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2642","char":"🏋‍♂","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2642 FE0F","char":"🏋🏻‍♂️","name":"man lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2642","char":"🏋🏻‍♂","name":"man lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2642 FE0F","char":"🏋🏼‍♂️","name":"man lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2642","char":"🏋🏼‍♂","name":"man lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2642 FE0F","char":"🏋🏽‍♂️","name":"man lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2642","char":"🏋🏽‍♂","name":"man lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2642 FE0F","char":"🏋🏾‍♂️","name":"man lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2642","char":"🏋🏾‍♂","name":"man lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2642 FE0F","char":"🏋🏿‍♂️","name":"man lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2642","char":"🏋🏿‍♂","name":"man lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2640 FE0F","char":"🏋️‍♀️","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2640 FE0F","char":"🏋‍♀️","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2640","char":"🏋️‍♀","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2640","char":"🏋‍♀","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2640 FE0F","char":"🏋🏻‍♀️","name":"woman lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2640","char":"🏋🏻‍♀","name":"woman lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2640 FE0F","char":"🏋🏼‍♀️","name":"woman lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2640","char":"🏋🏼‍♀","name":"woman lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2640 FE0F","char":"🏋🏽‍♀️","name":"woman lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2640","char":"🏋🏽‍♀","name":"woman lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2640 FE0F","char":"🏋🏾‍♀️","name":"woman lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2640","char":"🏋🏾‍♀","name":"woman lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2640 FE0F","char":"🏋🏿‍♀️","name":"woman lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2640","char":"🏋🏿‍♀","name":"woman lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4","char":"🚴","name":"person biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB","char":"🚴🏻","name":"person biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC","char":"🚴🏼","name":"person biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD","char":"🚴🏽","name":"person biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE","char":"🚴🏾","name":"person biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF","char":"🚴🏿","name":"person biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2642 FE0F","char":"🚴‍♂️","name":"man biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2642","char":"🚴‍♂","name":"man biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2642 FE0F","char":"🚴🏻‍♂️","name":"man biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2642","char":"🚴🏻‍♂","name":"man biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2642 FE0F","char":"🚴🏼‍♂️","name":"man biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2642","char":"🚴🏼‍♂","name":"man biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2642 FE0F","char":"🚴🏽‍♂️","name":"man biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2642","char":"🚴🏽‍♂","name":"man biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2642 FE0F","char":"🚴🏾‍♂️","name":"man biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2642","char":"🚴🏾‍♂","name":"man biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2642 FE0F","char":"🚴🏿‍♂️","name":"man biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2642","char":"🚴🏿‍♂","name":"man biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2640 FE0F","char":"🚴‍♀️","name":"woman biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2640","char":"🚴‍♀","name":"woman biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2640 FE0F","char":"🚴🏻‍♀️","name":"woman biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2640","char":"🚴🏻‍♀","name":"woman biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2640 FE0F","char":"🚴🏼‍♀️","name":"woman biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2640","char":"🚴🏼‍♀","name":"woman biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2640 FE0F","char":"🚴🏽‍♀️","name":"woman biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2640","char":"🚴🏽‍♀","name":"woman biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2640 FE0F","char":"🚴🏾‍♀️","name":"woman biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2640","char":"🚴🏾‍♀","name":"woman biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2640 FE0F","char":"🚴🏿‍♀️","name":"woman biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2640","char":"🚴🏿‍♀","name":"woman biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5","char":"🚵","name":"person mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB","char":"🚵🏻","name":"person mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC","char":"🚵🏼","name":"person mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD","char":"🚵🏽","name":"person mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE","char":"🚵🏾","name":"person mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF","char":"🚵🏿","name":"person mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2642 FE0F","char":"🚵‍♂️","name":"man mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2642","char":"🚵‍♂","name":"man mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2642 FE0F","char":"🚵🏻‍♂️","name":"man mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2642","char":"🚵🏻‍♂","name":"man mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2642 FE0F","char":"🚵🏼‍♂️","name":"man mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2642","char":"🚵🏼‍♂","name":"man mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2642 FE0F","char":"🚵🏽‍♂️","name":"man mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2642","char":"🚵🏽‍♂","name":"man mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2642 FE0F","char":"🚵🏾‍♂️","name":"man mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2642","char":"🚵🏾‍♂","name":"man mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2642 FE0F","char":"🚵🏿‍♂️","name":"man mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2642","char":"🚵🏿‍♂","name":"man mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2640 FE0F","char":"🚵‍♀️","name":"woman mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2640","char":"🚵‍♀","name":"woman mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2640 FE0F","char":"🚵🏻‍♀️","name":"woman mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2640","char":"🚵🏻‍♀","name":"woman mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2640 FE0F","char":"🚵🏼‍♀️","name":"woman mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2640","char":"🚵🏼‍♀","name":"woman mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2640 FE0F","char":"🚵🏽‍♀️","name":"woman mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2640","char":"🚵🏽‍♀","name":"woman mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2640 FE0F","char":"🚵🏾‍♀️","name":"woman mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2640","char":"🚵🏾‍♀","name":"woman mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2640 FE0F","char":"🚵🏿‍♀️","name":"woman mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2640","char":"🚵🏿‍♀","name":"woman mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938","char":"🤸","name":"person cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB","char":"🤸🏻","name":"person cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC","char":"🤸🏼","name":"person cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD","char":"🤸🏽","name":"person cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE","char":"🤸🏾","name":"person cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF","char":"🤸🏿","name":"person cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2642 FE0F","char":"🤸‍♂️","name":"man cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2642","char":"🤸‍♂","name":"man cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2642 FE0F","char":"🤸🏻‍♂️","name":"man cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2642","char":"🤸🏻‍♂","name":"man cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2642 FE0F","char":"🤸🏼‍♂️","name":"man cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2642","char":"🤸🏼‍♂","name":"man cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2642 FE0F","char":"🤸🏽‍♂️","name":"man cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2642","char":"🤸🏽‍♂","name":"man cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2642 FE0F","char":"🤸🏾‍♂️","name":"man cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2642","char":"🤸🏾‍♂","name":"man cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2642 FE0F","char":"🤸🏿‍♂️","name":"man cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2642","char":"🤸🏿‍♂","name":"man cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2640 FE0F","char":"🤸‍♀️","name":"woman cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2640","char":"🤸‍♀","name":"woman cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2640 FE0F","char":"🤸🏻‍♀️","name":"woman cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2640","char":"🤸🏻‍♀","name":"woman cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2640 FE0F","char":"🤸🏼‍♀️","name":"woman cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2640","char":"🤸🏼‍♀","name":"woman cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2640 FE0F","char":"🤸🏽‍♀️","name":"woman cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2640","char":"🤸🏽‍♀","name":"woman cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2640 FE0F","char":"🤸🏾‍♀️","name":"woman cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2640","char":"🤸🏾‍♀","name":"woman cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2640 FE0F","char":"🤸🏿‍♀️","name":"woman cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2640","char":"🤸🏿‍♀","name":"woman cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C","char":"🤼","name":"people wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2642 FE0F","char":"🤼‍♂️","name":"men wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2642","char":"🤼‍♂","name":"men wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2640 FE0F","char":"🤼‍♀️","name":"women wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2640","char":"🤼‍♀","name":"women wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D","char":"🤽","name":"person playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB","char":"🤽🏻","name":"person playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC","char":"🤽🏼","name":"person playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD","char":"🤽🏽","name":"person playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE","char":"🤽🏾","name":"person playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF","char":"🤽🏿","name":"person playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2642 FE0F","char":"🤽‍♂️","name":"man playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2642","char":"🤽‍♂","name":"man playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2642 FE0F","char":"🤽🏻‍♂️","name":"man playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2642","char":"🤽🏻‍♂","name":"man playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2642 FE0F","char":"🤽🏼‍♂️","name":"man playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2642","char":"🤽🏼‍♂","name":"man playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2642 FE0F","char":"🤽🏽‍♂️","name":"man playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2642","char":"🤽🏽‍♂","name":"man playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2642 FE0F","char":"🤽🏾‍♂️","name":"man playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2642","char":"🤽🏾‍♂","name":"man playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2642 FE0F","char":"🤽🏿‍♂️","name":"man playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2642","char":"🤽🏿‍♂","name":"man playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2640 FE0F","char":"🤽‍♀️","name":"woman playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2640","char":"🤽‍♀","name":"woman playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2640 FE0F","char":"🤽🏻‍♀️","name":"woman playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2640","char":"🤽🏻‍♀","name":"woman playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2640 FE0F","char":"🤽🏼‍♀️","name":"woman playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2640","char":"🤽🏼‍♀","name":"woman playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2640 FE0F","char":"🤽🏽‍♀️","name":"woman playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2640","char":"🤽🏽‍♀","name":"woman playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2640 FE0F","char":"🤽🏾‍♀️","name":"woman playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2640","char":"🤽🏾‍♀","name":"woman playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2640 FE0F","char":"🤽🏿‍♀️","name":"woman playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2640","char":"🤽🏿‍♀","name":"woman playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E","char":"🤾","name":"person playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB","char":"🤾🏻","name":"person playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC","char":"🤾🏼","name":"person playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD","char":"🤾🏽","name":"person playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE","char":"🤾🏾","name":"person playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF","char":"🤾🏿","name":"person playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2642 FE0F","char":"🤾‍♂️","name":"man playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2642","char":"🤾‍♂","name":"man playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2642 FE0F","char":"🤾🏻‍♂️","name":"man playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2642","char":"🤾🏻‍♂","name":"man playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2642 FE0F","char":"🤾🏼‍♂️","name":"man playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2642","char":"🤾🏼‍♂","name":"man playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2642 FE0F","char":"🤾🏽‍♂️","name":"man playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2642","char":"🤾🏽‍♂","name":"man playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2642 FE0F","char":"🤾🏾‍♂️","name":"man playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2642","char":"🤾🏾‍♂","name":"man playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2642 FE0F","char":"🤾🏿‍♂️","name":"man playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2642","char":"🤾🏿‍♂","name":"man playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2640 FE0F","char":"🤾‍♀️","name":"woman playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2640","char":"🤾‍♀","name":"woman playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2640 FE0F","char":"🤾🏻‍♀️","name":"woman playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2640","char":"🤾🏻‍♀","name":"woman playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2640 FE0F","char":"🤾🏼‍♀️","name":"woman playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2640","char":"🤾🏼‍♀","name":"woman playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2640 FE0F","char":"🤾🏽‍♀️","name":"woman playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2640","char":"🤾🏽‍♀","name":"woman playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2640 FE0F","char":"🤾🏾‍♀️","name":"woman playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2640","char":"🤾🏾‍♀","name":"woman playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2640 FE0F","char":"🤾🏿‍♀️","name":"woman playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2640","char":"🤾🏿‍♀","name":"woman playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939","char":"🤹","name":"person juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB","char":"🤹🏻","name":"person juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC","char":"🤹🏼","name":"person juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD","char":"🤹🏽","name":"person juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE","char":"🤹🏾","name":"person juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF","char":"🤹🏿","name":"person juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2642 FE0F","char":"🤹‍♂️","name":"man juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2642","char":"🤹‍♂","name":"man juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2642 FE0F","char":"🤹🏻‍♂️","name":"man juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2642","char":"🤹🏻‍♂","name":"man juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2642 FE0F","char":"🤹🏼‍♂️","name":"man juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2642","char":"🤹🏼‍♂","name":"man juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2642 FE0F","char":"🤹🏽‍♂️","name":"man juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2642","char":"🤹🏽‍♂","name":"man juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2642 FE0F","char":"🤹🏾‍♂️","name":"man juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2642","char":"🤹🏾‍♂","name":"man juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2642 FE0F","char":"🤹🏿‍♂️","name":"man juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2642","char":"🤹🏿‍♂","name":"man juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2640 FE0F","char":"🤹‍♀️","name":"woman juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2640","char":"🤹‍♀","name":"woman juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2640 FE0F","char":"🤹🏻‍♀️","name":"woman juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2640","char":"🤹🏻‍♀","name":"woman juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2640 FE0F","char":"🤹🏼‍♀️","name":"woman juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2640","char":"🤹🏼‍♀","name":"woman juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2640 FE0F","char":"🤹🏽‍♀️","name":"woman juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2640","char":"🤹🏽‍♀","name":"woman juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2640 FE0F","char":"🤹🏾‍♀️","name":"woman juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2640","char":"🤹🏾‍♀","name":"woman juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2640 FE0F","char":"🤹🏿‍♀️","name":"woman juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2640","char":"🤹🏿‍♀","name":"woman juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F9D8","char":"🧘","name":"person in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB","char":"🧘🏻","name":"person in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC","char":"🧘🏼","name":"person in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD","char":"🧘🏽","name":"person in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE","char":"🧘🏾","name":"person in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF","char":"🧘🏿","name":"person in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2642 FE0F","char":"🧘‍♂️","name":"man in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2642","char":"🧘‍♂","name":"man in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2642 FE0F","char":"🧘🏻‍♂️","name":"man in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2642","char":"🧘🏻‍♂","name":"man in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2642 FE0F","char":"🧘🏼‍♂️","name":"man in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2642","char":"🧘🏼‍♂","name":"man in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2642 FE0F","char":"🧘🏽‍♂️","name":"man in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2642","char":"🧘🏽‍♂","name":"man in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2642 FE0F","char":"🧘🏾‍♂️","name":"man in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2642","char":"🧘🏾‍♂","name":"man in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2642 FE0F","char":"🧘🏿‍♂️","name":"man in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2642","char":"🧘🏿‍♂","name":"man in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2640 FE0F","char":"🧘‍♀️","name":"woman in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2640","char":"🧘‍♀","name":"woman in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2640 FE0F","char":"🧘🏻‍♀️","name":"woman in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2640","char":"🧘🏻‍♀","name":"woman in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2640 FE0F","char":"🧘🏼‍♀️","name":"woman in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2640","char":"🧘🏼‍♀","name":"woman in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2640 FE0F","char":"🧘🏽‍♀️","name":"woman in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2640","char":"🧘🏽‍♀","name":"woman in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2640 FE0F","char":"🧘🏾‍♀️","name":"woman in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2640","char":"🧘🏾‍♀","name":"woman in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2640 FE0F","char":"🧘🏿‍♀️","name":"woman in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2640","char":"🧘🏿‍♀","name":"woman in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0","char":"🛀","name":"person taking bath","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FB","char":"🛀🏻","name":"person taking bath: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FC","char":"🛀🏼","name":"person taking bath: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FD","char":"🛀🏽","name":"person taking bath: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FE","char":"🛀🏾","name":"person taking bath: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FF","char":"🛀🏿","name":"person taking bath: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC","char":"🛌","name":"person in bed","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FB","char":"🛌🏻","name":"person in bed: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FC","char":"🛌🏼","name":"person in bed: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FD","char":"🛌🏽","name":"person in bed: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FE","char":"🛌🏾","name":"person in bed: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FF","char":"🛌🏿","name":"person in bed: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D1 200D 1F91D 200D 1F9D1","char":"🧑‍🤝‍🧑","name":"people holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏻‍🤝‍🧑🏻","name":"people holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏻‍🤝‍🧑🏼","name":"people holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏻‍🤝‍🧑🏽","name":"people holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏻‍🤝‍🧑🏾","name":"people holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏻‍🤝‍🧑🏿","name":"people holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏼‍🤝‍🧑🏻","name":"people holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏼‍🤝‍🧑🏼","name":"people holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏼‍🤝‍🧑🏽","name":"people holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏼‍🤝‍🧑🏾","name":"people holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏼‍🤝‍🧑🏿","name":"people holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏽‍🤝‍🧑🏻","name":"people holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏽‍🤝‍🧑🏼","name":"people holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏽‍🤝‍🧑🏽","name":"people holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏽‍🤝‍🧑🏾","name":"people holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏽‍🤝‍🧑🏿","name":"people holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏾‍🤝‍🧑🏻","name":"people holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏾‍🤝‍🧑🏼","name":"people holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏾‍🤝‍🧑🏽","name":"people holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏾‍🤝‍🧑🏾","name":"people holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏾‍🤝‍🧑🏿","name":"people holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏿‍🤝‍🧑🏻","name":"people holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏿‍🤝‍🧑🏼","name":"people holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏿‍🤝‍🧑🏽","name":"people holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏿‍🤝‍🧑🏾","name":"people holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏿‍🤝‍🧑🏿","name":"people holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D","char":"👭","name":"women holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FB","char":"👭🏻","name":"women holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FC","char":"👩🏻‍🤝‍👩🏼","name":"women holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FD","char":"👩🏻‍🤝‍👩🏽","name":"women holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FE","char":"👩🏻‍🤝‍👩🏾","name":"women holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FF","char":"👩🏻‍🤝‍👩🏿","name":"women holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FB","char":"👩🏼‍🤝‍👩🏻","name":"women holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FC","char":"👭🏼","name":"women holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FD","char":"👩🏼‍🤝‍👩🏽","name":"women holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FE","char":"👩🏼‍🤝‍👩🏾","name":"women holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FF","char":"👩🏼‍🤝‍👩🏿","name":"women holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FB","char":"👩🏽‍🤝‍👩🏻","name":"women holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FC","char":"👩🏽‍🤝‍👩🏼","name":"women holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FD","char":"👭🏽","name":"women holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FE","char":"👩🏽‍🤝‍👩🏾","name":"women holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FF","char":"👩🏽‍🤝‍👩🏿","name":"women holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FB","char":"👩🏾‍🤝‍👩🏻","name":"women holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FC","char":"👩🏾‍🤝‍👩🏼","name":"women holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FD","char":"👩🏾‍🤝‍👩🏽","name":"women holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FE","char":"👭🏾","name":"women holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FF","char":"👩🏾‍🤝‍👩🏿","name":"women holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FB","char":"👩🏿‍🤝‍👩🏻","name":"women holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FC","char":"👩🏿‍🤝‍👩🏼","name":"women holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FD","char":"👩🏿‍🤝‍👩🏽","name":"women holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FE","char":"👩🏿‍🤝‍👩🏾","name":"women holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FF","char":"👭🏿","name":"women holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B","char":"👫","name":"woman and man holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FB","char":"👫🏻","name":"woman and man holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FC","char":"👩🏻‍🤝‍👨🏼","name":"woman and man holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FD","char":"👩🏻‍🤝‍👨🏽","name":"woman and man holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FE","char":"👩🏻‍🤝‍👨🏾","name":"woman and man holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FF","char":"👩🏻‍🤝‍👨🏿","name":"woman and man holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FB","char":"👩🏼‍🤝‍👨🏻","name":"woman and man holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FC","char":"👫🏼","name":"woman and man holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FD","char":"👩🏼‍🤝‍👨🏽","name":"woman and man holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FE","char":"👩🏼‍🤝‍👨🏾","name":"woman and man holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FF","char":"👩🏼‍🤝‍👨🏿","name":"woman and man holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FB","char":"👩🏽‍🤝‍👨🏻","name":"woman and man holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FC","char":"👩🏽‍🤝‍👨🏼","name":"woman and man holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FD","char":"👫🏽","name":"woman and man holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FE","char":"👩🏽‍🤝‍👨🏾","name":"woman and man holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FF","char":"👩🏽‍🤝‍👨🏿","name":"woman and man holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FB","char":"👩🏾‍🤝‍👨🏻","name":"woman and man holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FC","char":"👩🏾‍🤝‍👨🏼","name":"woman and man holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FD","char":"👩🏾‍🤝‍👨🏽","name":"woman and man holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FE","char":"👫🏾","name":"woman and man holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FF","char":"👩🏾‍🤝‍👨🏿","name":"woman and man holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FB","char":"👩🏿‍🤝‍👨🏻","name":"woman and man holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FC","char":"👩🏿‍🤝‍👨🏼","name":"woman and man holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FD","char":"👩🏿‍🤝‍👨🏽","name":"woman and man holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FE","char":"👩🏿‍🤝‍👨🏾","name":"woman and man holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FF","char":"👫🏿","name":"woman and man holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C","char":"👬","name":"men holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FB","char":"👬🏻","name":"men holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FC","char":"👨🏻‍🤝‍👨🏼","name":"men holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FD","char":"👨🏻‍🤝‍👨🏽","name":"men holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FE","char":"👨🏻‍🤝‍👨🏾","name":"men holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FF","char":"👨🏻‍🤝‍👨🏿","name":"men holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FB","char":"👨🏼‍🤝‍👨🏻","name":"men holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FC","char":"👬🏼","name":"men holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FD","char":"👨🏼‍🤝‍👨🏽","name":"men holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FE","char":"👨🏼‍🤝‍👨🏾","name":"men holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FF","char":"👨🏼‍🤝‍👨🏿","name":"men holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FB","char":"👨🏽‍🤝‍👨🏻","name":"men holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FC","char":"👨🏽‍🤝‍👨🏼","name":"men holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FD","char":"👬🏽","name":"men holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FE","char":"👨🏽‍🤝‍👨🏾","name":"men holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FF","char":"👨🏽‍🤝‍👨🏿","name":"men holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FB","char":"👨🏾‍🤝‍👨🏻","name":"men holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FC","char":"👨🏾‍🤝‍👨🏼","name":"men holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FD","char":"👨🏾‍🤝‍👨🏽","name":"men holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FE","char":"👬🏾","name":"men holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FF","char":"👨🏾‍🤝‍👨🏿","name":"men holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FB","char":"👨🏿‍🤝‍👨🏻","name":"men holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FC","char":"👨🏿‍🤝‍👨🏼","name":"men holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FD","char":"👨🏿‍🤝‍👨🏽","name":"men holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FE","char":"👨🏿‍🤝‍👨🏾","name":"men holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FF","char":"👬🏿","name":"men holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F","char":"💏","name":"kiss","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FB","char":"💏🏻","name":"kiss: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FC","char":"💏🏼","name":"kiss: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FD","char":"💏🏽","name":"kiss: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FE","char":"💏🏾","name":"kiss: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FF","char":"💏🏿","name":"kiss: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏻‍❤️‍💋‍🧑🏼","name":"kiss: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏻‍❤‍💋‍🧑🏼","name":"kiss: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏻‍❤️‍💋‍🧑🏽","name":"kiss: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏻‍❤‍💋‍🧑🏽","name":"kiss: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏻‍❤️‍💋‍🧑🏾","name":"kiss: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏻‍❤‍💋‍🧑🏾","name":"kiss: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏻‍❤️‍💋‍🧑🏿","name":"kiss: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏻‍❤‍💋‍🧑🏿","name":"kiss: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏼‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏼‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏼‍❤️‍💋‍🧑🏽","name":"kiss: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏼‍❤‍💋‍🧑🏽","name":"kiss: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏼‍❤️‍💋‍🧑🏾","name":"kiss: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏼‍❤‍💋‍🧑🏾","name":"kiss: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏼‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏼‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏽‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏽‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏽‍❤️‍💋‍🧑🏼","name":"kiss: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏽‍❤‍💋‍🧑🏼","name":"kiss: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏽‍❤️‍💋‍🧑🏾","name":"kiss: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏽‍❤‍💋‍🧑🏾","name":"kiss: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏽‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏽‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏾‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏾‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏾‍❤️‍💋‍🧑🏼","name":"kiss: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏾‍❤‍💋‍🧑🏼","name":"kiss: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏾‍❤️‍💋‍🧑🏽","name":"kiss: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏾‍❤‍💋‍🧑🏽","name":"kiss: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏾‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏾‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏿‍❤️‍💋‍🧑🏻","name":"kiss: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏿‍❤‍💋‍🧑🏻","name":"kiss: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏿‍❤️‍💋‍🧑🏼","name":"kiss: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏿‍❤‍💋‍🧑🏼","name":"kiss: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏿‍❤️‍💋‍🧑🏽","name":"kiss: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏿‍❤‍💋‍🧑🏽","name":"kiss: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏿‍❤️‍💋‍🧑🏾","name":"kiss: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏿‍❤‍💋‍🧑🏾","name":"kiss: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F48B 200D 1F468","char":"👩‍❤️‍💋‍👨","name":"kiss: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F48B 200D 1F468","char":"👩‍❤‍💋‍👨","name":"kiss: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏻‍❤️‍💋‍👨🏻","name":"kiss: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏻‍❤‍💋‍👨🏻","name":"kiss: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏻‍❤️‍💋‍👨🏼","name":"kiss: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏻‍❤‍💋‍👨🏼","name":"kiss: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏻‍❤️‍💋‍👨🏽","name":"kiss: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏻‍❤‍💋‍👨🏽","name":"kiss: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏻‍❤️‍💋‍👨🏾","name":"kiss: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏻‍❤‍💋‍👨🏾","name":"kiss: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏻‍❤️‍💋‍👨🏿","name":"kiss: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏻‍❤‍💋‍👨🏿","name":"kiss: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏼‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏼‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏼‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏼‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏼‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏼‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏼‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏼‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏼‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏼‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏽‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏽‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏽‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏽‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏽‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏽‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏽‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏽‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏽‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏽‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏾‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏾‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏾‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏾‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏾‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏾‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏾‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏾‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏾‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏾‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏿‍❤️‍💋‍👨🏻","name":"kiss: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏿‍❤‍💋‍👨🏻","name":"kiss: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏿‍❤️‍💋‍👨🏼","name":"kiss: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏿‍❤‍💋‍👨🏼","name":"kiss: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏿‍❤️‍💋‍👨🏽","name":"kiss: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏿‍❤‍💋‍👨🏽","name":"kiss: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏿‍❤️‍💋‍👨🏾","name":"kiss: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏿‍❤‍💋‍👨🏾","name":"kiss: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏿‍❤️‍💋‍👨🏿","name":"kiss: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏿‍❤‍💋‍👨🏿","name":"kiss: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 FE0F 200D 1F48B 200D 1F468","char":"👨‍❤️‍💋‍👨","name":"kiss: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 200D 1F48B 200D 1F468","char":"👨‍❤‍💋‍👨","name":"kiss: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏻‍❤️‍💋‍👨🏻","name":"kiss: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏻‍❤‍💋‍👨🏻","name":"kiss: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏻‍❤️‍💋‍👨🏼","name":"kiss: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏻‍❤‍💋‍👨🏼","name":"kiss: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏻‍❤️‍💋‍👨🏽","name":"kiss: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏻‍❤‍💋‍👨🏽","name":"kiss: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏻‍❤️‍💋‍👨🏾","name":"kiss: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏻‍❤‍💋‍👨🏾","name":"kiss: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏻‍❤️‍💋‍👨🏿","name":"kiss: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏻‍❤‍💋‍👨🏿","name":"kiss: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏼‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏼‍❤‍💋‍👨🏻","name":"kiss: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏼‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏼‍❤‍💋‍👨🏼","name":"kiss: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏼‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏼‍❤‍💋‍👨🏽","name":"kiss: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏼‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏼‍❤‍💋‍👨🏾","name":"kiss: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏼‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏼‍❤‍💋‍👨🏿","name":"kiss: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏽‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏽‍❤‍💋‍👨🏻","name":"kiss: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏽‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏽‍❤‍💋‍👨🏼","name":"kiss: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏽‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏽‍❤‍💋‍👨🏽","name":"kiss: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏽‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏽‍❤‍💋‍👨🏾","name":"kiss: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏽‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏽‍❤‍💋‍👨🏿","name":"kiss: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏾‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏾‍❤‍💋‍👨🏻","name":"kiss: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏾‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏾‍❤‍💋‍👨🏼","name":"kiss: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏾‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏾‍❤‍💋‍👨🏽","name":"kiss: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏾‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏾‍❤‍💋‍👨🏾","name":"kiss: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏾‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏾‍❤‍💋‍👨🏿","name":"kiss: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏿‍❤️‍💋‍👨🏻","name":"kiss: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏿‍❤‍💋‍👨🏻","name":"kiss: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏿‍❤️‍💋‍👨🏼","name":"kiss: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏿‍❤‍💋‍👨🏼","name":"kiss: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏿‍❤️‍💋‍👨🏽","name":"kiss: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏿‍❤‍💋‍👨🏽","name":"kiss: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏿‍❤️‍💋‍👨🏾","name":"kiss: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏿‍❤‍💋‍👨🏾","name":"kiss: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏿‍❤️‍💋‍👨🏿","name":"kiss: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏿‍❤‍💋‍👨🏿","name":"kiss: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F48B 200D 1F469","char":"👩‍❤️‍💋‍👩","name":"kiss: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F48B 200D 1F469","char":"👩‍❤‍💋‍👩","name":"kiss: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏻‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏻‍❤‍💋‍👩🏻","name":"kiss: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏻‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏻‍❤‍💋‍👩🏼","name":"kiss: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏻‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏻‍❤‍💋‍👩🏽","name":"kiss: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏻‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏻‍❤‍💋‍👩🏾","name":"kiss: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏻‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏻‍❤‍💋‍👩🏿","name":"kiss: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏼‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏼‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏼‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏼‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏼‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏼‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏼‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏼‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏼‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏼‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏽‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏽‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏽‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏽‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏽‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏽‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏽‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏽‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏽‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏽‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏾‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏾‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏾‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏾‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏾‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏾‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏾‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏾‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏾‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏾‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏿‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏿‍❤‍💋‍👩🏻","name":"kiss: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏿‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏿‍❤‍💋‍👩🏼","name":"kiss: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏿‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏿‍❤‍💋‍👩🏽","name":"kiss: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏿‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏿‍❤‍💋‍👩🏾","name":"kiss: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏿‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏿‍❤‍💋‍👩🏿","name":"kiss: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491","char":"💑","name":"couple with heart","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FB","char":"💑🏻","name":"couple with heart: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FC","char":"💑🏼","name":"couple with heart: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FD","char":"💑🏽","name":"couple with heart: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FE","char":"💑🏾","name":"couple with heart: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FF","char":"💑🏿","name":"couple with heart: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏻‍❤️‍🧑🏼","name":"couple with heart: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏻‍❤‍🧑🏼","name":"couple with heart: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏻‍❤️‍🧑🏽","name":"couple with heart: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏻‍❤‍🧑🏽","name":"couple with heart: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏻‍❤️‍🧑🏾","name":"couple with heart: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏻‍❤‍🧑🏾","name":"couple with heart: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏻‍❤️‍🧑🏿","name":"couple with heart: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏻‍❤‍🧑🏿","name":"couple with heart: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏼‍❤️‍🧑🏻","name":"couple with heart: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏼‍❤‍🧑🏻","name":"couple with heart: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏼‍❤️‍🧑🏽","name":"couple with heart: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏼‍❤‍🧑🏽","name":"couple with heart: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏼‍❤️‍🧑🏾","name":"couple with heart: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏼‍❤‍🧑🏾","name":"couple with heart: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏼‍❤️‍🧑🏿","name":"couple with heart: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏼‍❤‍🧑🏿","name":"couple with heart: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏽‍❤️‍🧑🏻","name":"couple with heart: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏽‍❤‍🧑🏻","name":"couple with heart: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏽‍❤️‍🧑🏼","name":"couple with heart: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏽‍❤‍🧑🏼","name":"couple with heart: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏽‍❤️‍🧑🏾","name":"couple with heart: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏽‍❤‍🧑🏾","name":"couple with heart: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏽‍❤️‍🧑🏿","name":"couple with heart: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏽‍❤‍🧑🏿","name":"couple with heart: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏾‍❤️‍🧑🏻","name":"couple with heart: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏾‍❤‍🧑🏻","name":"couple with heart: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏾‍❤️‍🧑🏼","name":"couple with heart: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏾‍❤‍🧑🏼","name":"couple with heart: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏾‍❤️‍🧑🏽","name":"couple with heart: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏾‍❤‍🧑🏽","name":"couple with heart: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏾‍❤️‍🧑🏿","name":"couple with heart: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏾‍❤‍🧑🏿","name":"couple with heart: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏿‍❤️‍🧑🏻","name":"couple with heart: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏿‍❤‍🧑🏻","name":"couple with heart: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏿‍❤️‍🧑🏼","name":"couple with heart: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏿‍❤‍🧑🏼","name":"couple with heart: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏿‍❤️‍🧑🏽","name":"couple with heart: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏿‍❤‍🧑🏽","name":"couple with heart: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏿‍❤️‍🧑🏾","name":"couple with heart: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏿‍❤‍🧑🏾","name":"couple with heart: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F468","char":"👩‍❤️‍👨","name":"couple with heart: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F468","char":"👩‍❤‍👨","name":"couple with heart: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏻‍❤️‍👨🏻","name":"couple with heart: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FB","char":"👩🏻‍❤‍👨🏻","name":"couple with heart: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏻‍❤️‍👨🏼","name":"couple with heart: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FC","char":"👩🏻‍❤‍👨🏼","name":"couple with heart: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏻‍❤️‍👨🏽","name":"couple with heart: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FD","char":"👩🏻‍❤‍👨🏽","name":"couple with heart: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏻‍❤️‍👨🏾","name":"couple with heart: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FE","char":"👩🏻‍❤‍👨🏾","name":"couple with heart: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏻‍❤️‍👨🏿","name":"couple with heart: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FF","char":"👩🏻‍❤‍👨🏿","name":"couple with heart: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏼‍❤️‍👨🏻","name":"couple with heart: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FB","char":"👩🏼‍❤‍👨🏻","name":"couple with heart: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏼‍❤️‍👨🏼","name":"couple with heart: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FC","char":"👩🏼‍❤‍👨🏼","name":"couple with heart: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏼‍❤️‍👨🏽","name":"couple with heart: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FD","char":"👩🏼‍❤‍👨🏽","name":"couple with heart: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏼‍❤️‍👨🏾","name":"couple with heart: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FE","char":"👩🏼‍❤‍👨🏾","name":"couple with heart: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏼‍❤️‍👨🏿","name":"couple with heart: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FF","char":"👩🏼‍❤‍👨🏿","name":"couple with heart: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏽‍❤️‍👨🏻","name":"couple with heart: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FB","char":"👩🏽‍❤‍👨🏻","name":"couple with heart: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏽‍❤️‍👨🏼","name":"couple with heart: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FC","char":"👩🏽‍❤‍👨🏼","name":"couple with heart: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏽‍❤️‍👨🏽","name":"couple with heart: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FD","char":"👩🏽‍❤‍👨🏽","name":"couple with heart: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏽‍❤️‍👨🏾","name":"couple with heart: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FE","char":"👩🏽‍❤‍👨🏾","name":"couple with heart: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏽‍❤️‍👨🏿","name":"couple with heart: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FF","char":"👩🏽‍❤‍👨🏿","name":"couple with heart: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏾‍❤️‍👨🏻","name":"couple with heart: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FB","char":"👩🏾‍❤‍👨🏻","name":"couple with heart: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏾‍❤️‍👨🏼","name":"couple with heart: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FC","char":"👩🏾‍❤‍👨🏼","name":"couple with heart: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏾‍❤️‍👨🏽","name":"couple with heart: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FD","char":"👩🏾‍❤‍👨🏽","name":"couple with heart: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏾‍❤️‍👨🏾","name":"couple with heart: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FE","char":"👩🏾‍❤‍👨🏾","name":"couple with heart: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏾‍❤️‍👨🏿","name":"couple with heart: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FF","char":"👩🏾‍❤‍👨🏿","name":"couple with heart: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏿‍❤️‍👨🏻","name":"couple with heart: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FB","char":"👩🏿‍❤‍👨🏻","name":"couple with heart: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏿‍❤️‍👨🏼","name":"couple with heart: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FC","char":"👩🏿‍❤‍👨🏼","name":"couple with heart: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏿‍❤️‍👨🏽","name":"couple with heart: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FD","char":"👩🏿‍❤‍👨🏽","name":"couple with heart: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏿‍❤️‍👨🏾","name":"couple with heart: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FE","char":"👩🏿‍❤‍👨🏾","name":"couple with heart: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏿‍❤️‍👨🏿","name":"couple with heart: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FF","char":"👩🏿‍❤‍👨🏿","name":"couple with heart: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 FE0F 200D 1F468","char":"👨‍❤️‍👨","name":"couple with heart: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 200D 1F468","char":"👨‍❤‍👨","name":"couple with heart: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏻‍❤️‍👨🏻","name":"couple with heart: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FB","char":"👨🏻‍❤‍👨🏻","name":"couple with heart: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏻‍❤️‍👨🏼","name":"couple with heart: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FC","char":"👨🏻‍❤‍👨🏼","name":"couple with heart: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏻‍❤️‍👨🏽","name":"couple with heart: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FD","char":"👨🏻‍❤‍👨🏽","name":"couple with heart: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏻‍❤️‍👨🏾","name":"couple with heart: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FE","char":"👨🏻‍❤‍👨🏾","name":"couple with heart: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏻‍❤️‍👨🏿","name":"couple with heart: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FF","char":"👨🏻‍❤‍👨🏿","name":"couple with heart: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏼‍❤️‍👨🏻","name":"couple with heart: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FB","char":"👨🏼‍❤‍👨🏻","name":"couple with heart: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏼‍❤️‍👨🏼","name":"couple with heart: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FC","char":"👨🏼‍❤‍👨🏼","name":"couple with heart: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏼‍❤️‍👨🏽","name":"couple with heart: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FD","char":"👨🏼‍❤‍👨🏽","name":"couple with heart: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏼‍❤️‍👨🏾","name":"couple with heart: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FE","char":"👨🏼‍❤‍👨🏾","name":"couple with heart: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏼‍❤️‍👨🏿","name":"couple with heart: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FF","char":"👨🏼‍❤‍👨🏿","name":"couple with heart: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏽‍❤️‍👨🏻","name":"couple with heart: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FB","char":"👨🏽‍❤‍👨🏻","name":"couple with heart: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏽‍❤️‍👨🏼","name":"couple with heart: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FC","char":"👨🏽‍❤‍👨🏼","name":"couple with heart: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏽‍❤️‍👨🏽","name":"couple with heart: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FD","char":"👨🏽‍❤‍👨🏽","name":"couple with heart: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏽‍❤️‍👨🏾","name":"couple with heart: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FE","char":"👨🏽‍❤‍👨🏾","name":"couple with heart: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏽‍❤️‍👨🏿","name":"couple with heart: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FF","char":"👨🏽‍❤‍👨🏿","name":"couple with heart: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏾‍❤️‍👨🏻","name":"couple with heart: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FB","char":"👨🏾‍❤‍👨🏻","name":"couple with heart: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏾‍❤️‍👨🏼","name":"couple with heart: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FC","char":"👨🏾‍❤‍👨🏼","name":"couple with heart: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏾‍❤️‍👨🏽","name":"couple with heart: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FD","char":"👨🏾‍❤‍👨🏽","name":"couple with heart: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏾‍❤️‍👨🏾","name":"couple with heart: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FE","char":"👨🏾‍❤‍👨🏾","name":"couple with heart: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏾‍❤️‍👨🏿","name":"couple with heart: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FF","char":"👨🏾‍❤‍👨🏿","name":"couple with heart: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏿‍❤️‍👨🏻","name":"couple with heart: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FB","char":"👨🏿‍❤‍👨🏻","name":"couple with heart: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏿‍❤️‍👨🏼","name":"couple with heart: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FC","char":"👨🏿‍❤‍👨🏼","name":"couple with heart: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏿‍❤️‍👨🏽","name":"couple with heart: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FD","char":"👨🏿‍❤‍👨🏽","name":"couple with heart: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏿‍❤️‍👨🏾","name":"couple with heart: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FE","char":"👨🏿‍❤‍👨🏾","name":"couple with heart: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏿‍❤️‍👨🏿","name":"couple with heart: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FF","char":"👨🏿‍❤‍👨🏿","name":"couple with heart: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F469","char":"👩‍❤️‍👩","name":"couple with heart: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F469","char":"👩‍❤‍👩","name":"couple with heart: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏻‍❤️‍👩🏻","name":"couple with heart: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FB","char":"👩🏻‍❤‍👩🏻","name":"couple with heart: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏻‍❤️‍👩🏼","name":"couple with heart: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FC","char":"👩🏻‍❤‍👩🏼","name":"couple with heart: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏻‍❤️‍👩🏽","name":"couple with heart: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FD","char":"👩🏻‍❤‍👩🏽","name":"couple with heart: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏻‍❤️‍👩🏾","name":"couple with heart: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FE","char":"👩🏻‍❤‍👩🏾","name":"couple with heart: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏻‍❤️‍👩🏿","name":"couple with heart: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FF","char":"👩🏻‍❤‍👩🏿","name":"couple with heart: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏼‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FB","char":"👩🏼‍❤‍👩🏻","name":"couple with heart: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏼‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FC","char":"👩🏼‍❤‍👩🏼","name":"couple with heart: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏼‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FD","char":"👩🏼‍❤‍👩🏽","name":"couple with heart: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏼‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FE","char":"👩🏼‍❤‍👩🏾","name":"couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏼‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FF","char":"👩🏼‍❤‍👩🏿","name":"couple with heart: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏽‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FB","char":"👩🏽‍❤‍👩🏻","name":"couple with heart: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏽‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FC","char":"👩🏽‍❤‍👩🏼","name":"couple with heart: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏽‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FD","char":"👩🏽‍❤‍👩🏽","name":"couple with heart: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏽‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FE","char":"👩🏽‍❤‍👩🏾","name":"couple with heart: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏽‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FF","char":"👩🏽‍❤‍👩🏿","name":"couple with heart: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏾‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FB","char":"👩🏾‍❤‍👩🏻","name":"couple with heart: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏾‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FC","char":"👩🏾‍❤‍👩🏼","name":"couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏾‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FD","char":"👩🏾‍❤‍👩🏽","name":"couple with heart: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏾‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FE","char":"👩🏾‍❤‍👩🏾","name":"couple with heart: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏾‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FF","char":"👩🏾‍❤‍👩🏿","name":"couple with heart: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏿‍❤️‍👩🏻","name":"couple with heart: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FB","char":"👩🏿‍❤‍👩🏻","name":"couple with heart: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏿‍❤️‍👩🏼","name":"couple with heart: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FC","char":"👩🏿‍❤‍👩🏼","name":"couple with heart: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏿‍❤️‍👩🏽","name":"couple with heart: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FD","char":"👩🏿‍❤‍👩🏽","name":"couple with heart: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏿‍❤️‍👩🏾","name":"couple with heart: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FE","char":"👩🏿‍❤‍👩🏾","name":"couple with heart: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏿‍❤️‍👩🏿","name":"couple with heart: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FF","char":"👩🏿‍❤‍👩🏿","name":"couple with heart: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F466","char":"👨‍👩‍👦","name":"family: man, woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467","char":"👨‍👩‍👧","name":"family: man, woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467 200D 1F466","char":"👨‍👩‍👧‍👦","name":"family: man, woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F466 200D 1F466","char":"👨‍👩‍👦‍👦","name":"family: man, woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467 200D 1F467","char":"👨‍👩‍👧‍👧","name":"family: man, woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F466","char":"👨‍👨‍👦","name":"family: man, man, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467","char":"👨‍👨‍👧","name":"family: man, man, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467 200D 1F466","char":"👨‍👨‍👧‍👦","name":"family: man, man, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F466 200D 1F466","char":"👨‍👨‍👦‍👦","name":"family: man, man, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467 200D 1F467","char":"👨‍👨‍👧‍👧","name":"family: man, man, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F466","char":"👩‍👩‍👦","name":"family: woman, woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467","char":"👩‍👩‍👧","name":"family: woman, woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467 200D 1F466","char":"👩‍👩‍👧‍👦","name":"family: woman, woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F466 200D 1F466","char":"👩‍👩‍👦‍👦","name":"family: woman, woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467 200D 1F467","char":"👩‍👩‍👧‍👧","name":"family: woman, woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F466","char":"👨‍👦","name":"family: man, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F466 200D 1F466","char":"👨‍👦‍👦","name":"family: man, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467","char":"👨‍👧","name":"family: man, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467 200D 1F466","char":"👨‍👧‍👦","name":"family: man, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467 200D 1F467","char":"👨‍👧‍👧","name":"family: man, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F466","char":"👩‍👦","name":"family: woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F466 200D 1F466","char":"👩‍👦‍👦","name":"family: woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467","char":"👩‍👧","name":"family: woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467 200D 1F466","char":"👩‍👧‍👦","name":"family: woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467 200D 1F467","char":"👩‍👧‍👧","name":"family: woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F5E3 FE0F","char":"🗣️","name":"speaking head","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F5E3","char":"🗣","name":"speaking head","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F464","char":"👤","name":"bust in silhouette","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F465","char":"👥","name":"busts in silhouette","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1FAC2","char":"🫂","name":"people hugging","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F46A","char":"👪","name":"family","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D1 200D 1F9D2","char":"🧑‍🧑‍🧒","name":"family: adult, adult, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D1 200D 1F9D2 200D 1F9D2","char":"🧑‍🧑‍🧒‍🧒","name":"family: adult, adult, child, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D2","char":"🧑‍🧒","name":"family: adult, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D2 200D 1F9D2","char":"🧑‍🧒‍🧒","name":"family: adult, child, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F463","char":"👣","name":"footprints","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F3FB","char":"🏻","name":"light skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FC","char":"🏼","name":"medium-light skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FD","char":"🏽","name":"medium skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FE","char":"🏾","name":"medium-dark skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FF","char":"🏿","name":"dark skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F9B0","char":"🦰","name":"red hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B1","char":"🦱","name":"curly hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B3","char":"🦳","name":"white hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B2","char":"🦲","name":"bald","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F435","char":"🐵","name":"monkey face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F412","char":"🐒","name":"monkey","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98D","char":"🦍","name":"gorilla","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A7","char":"🦧","name":"orangutan","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F436","char":"🐶","name":"dog face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F415","char":"🐕","name":"dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AE","char":"🦮","name":"guide dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F415 200D 1F9BA","char":"🐕‍🦺","name":"service dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F429","char":"🐩","name":"poodle","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43A","char":"🐺","name":"wolf","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98A","char":"🦊","name":"fox","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F99D","char":"🦝","name":"raccoon","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F431","char":"🐱","name":"cat face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F408","char":"🐈","name":"cat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F408 200D 2B1B","char":"🐈‍⬛","name":"black cat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F981","char":"🦁","name":"lion","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42F","char":"🐯","name":"tiger face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F405","char":"🐅","name":"tiger","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F406","char":"🐆","name":"leopard","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F434","char":"🐴","name":"horse face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1FACE","char":"🫎","name":"moose","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1FACF","char":"🫏","name":"donkey","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F40E","char":"🐎","name":"horse","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F984","char":"🦄","name":"unicorn","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F993","char":"🦓","name":"zebra","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98C","char":"🦌","name":"deer","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AC","char":"🦬","name":"bison","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42E","char":"🐮","name":"cow face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F402","char":"🐂","name":"ox","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F403","char":"🐃","name":"water buffalo","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F404","char":"🐄","name":"cow","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F437","char":"🐷","name":"pig face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F416","char":"🐖","name":"pig","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F417","char":"🐗","name":"boar","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43D","char":"🐽","name":"pig nose","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F40F","char":"🐏","name":"ram","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F411","char":"🐑","name":"ewe","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F410","char":"🐐","name":"goat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42A","char":"🐪","name":"camel","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42B","char":"🐫","name":"two-hump camel","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F999","char":"🦙","name":"llama","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F992","char":"🦒","name":"giraffe","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F418","char":"🐘","name":"elephant","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A3","char":"🦣","name":"mammoth","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98F","char":"🦏","name":"rhinoceros","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F99B","char":"🦛","name":"hippopotamus","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42D","char":"🐭","name":"mouse face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F401","char":"🐁","name":"mouse","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F400","char":"🐀","name":"rat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F439","char":"🐹","name":"hamster","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F430","char":"🐰","name":"rabbit face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F407","char":"🐇","name":"rabbit","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43F FE0F","char":"🐿️","name":"chipmunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43F","char":"🐿","name":"chipmunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AB","char":"🦫","name":"beaver","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F994","char":"🦔","name":"hedgehog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F987","char":"🦇","name":"bat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B","char":"🐻","name":"bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B 200D 2744 FE0F","char":"🐻‍❄️","name":"polar bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B 200D 2744","char":"🐻‍❄","name":"polar bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F428","char":"🐨","name":"koala","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43C","char":"🐼","name":"panda","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A5","char":"🦥","name":"sloth","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A6","char":"🦦","name":"otter","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A8","char":"🦨","name":"skunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F998","char":"🦘","name":"kangaroo","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A1","char":"🦡","name":"badger","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43E","char":"🐾","name":"paw prints","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F983","char":"🦃","name":"turkey","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F414","char":"🐔","name":"chicken","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F413","char":"🐓","name":"rooster","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F423","char":"🐣","name":"hatching chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F424","char":"🐤","name":"baby chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F425","char":"🐥","name":"front-facing baby chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426","char":"🐦","name":"bird","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F427","char":"🐧","name":"penguin","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F54A FE0F","char":"🕊️","name":"dove","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F54A","char":"🕊","name":"dove","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F985","char":"🦅","name":"eagle","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F986","char":"🦆","name":"duck","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A2","char":"🦢","name":"swan","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F989","char":"🦉","name":"owl","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A4","char":"🦤","name":"dodo","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FAB6","char":"🪶","name":"feather","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A9","char":"🦩","name":"flamingo","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F99A","char":"🦚","name":"peacock","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F99C","char":"🦜","name":"parrot","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FABD","char":"🪽","name":"wing","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426 200D 2B1B","char":"🐦‍⬛","name":"black bird","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FABF","char":"🪿","name":"goose","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426 200D 1F525","char":"🐦‍🔥","name":"phoenix","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F438","char":"🐸","name":"frog","category":"Animals & Nature (animal-amphibian)","group":"Animals & Nature","subgroup":"animal-amphibian"},{"codes":"1F40A","char":"🐊","name":"crocodile","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F422","char":"🐢","name":"turtle","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F98E","char":"🦎","name":"lizard","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F40D","char":"🐍","name":"snake","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F432","char":"🐲","name":"dragon face","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F409","char":"🐉","name":"dragon","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F995","char":"🦕","name":"sauropod","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F996","char":"🦖","name":"T-Rex","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F433","char":"🐳","name":"spouting whale","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F40B","char":"🐋","name":"whale","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F42C","char":"🐬","name":"dolphin","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F9AD","char":"🦭","name":"seal","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F41F","char":"🐟","name":"fish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F420","char":"🐠","name":"tropical fish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F421","char":"🐡","name":"blowfish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F988","char":"🦈","name":"shark","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F419","char":"🐙","name":"octopus","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F41A","char":"🐚","name":"spiral shell","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1FAB8","char":"🪸","name":"coral","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1FABC","char":"🪼","name":"jellyfish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F40C","char":"🐌","name":"snail","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F98B","char":"🦋","name":"butterfly","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41B","char":"🐛","name":"bug","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41C","char":"🐜","name":"ant","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41D","char":"🐝","name":"honeybee","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB2","char":"🪲","name":"beetle","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41E","char":"🐞","name":"lady beetle","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F997","char":"🦗","name":"cricket","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB3","char":"🪳","name":"cockroach","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F577 FE0F","char":"🕷️","name":"spider","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F577","char":"🕷","name":"spider","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F578 FE0F","char":"🕸️","name":"spider web","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F578","char":"🕸","name":"spider web","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F982","char":"🦂","name":"scorpion","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F99F","char":"🦟","name":"mosquito","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB0","char":"🪰","name":"fly","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB1","char":"🪱","name":"worm","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F9A0","char":"🦠","name":"microbe","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F490","char":"💐","name":"bouquet","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F338","char":"🌸","name":"cherry blossom","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F4AE","char":"💮","name":"white flower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1FAB7","char":"🪷","name":"lotus","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F3F5 FE0F","char":"🏵️","name":"rosette","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F3F5","char":"🏵","name":"rosette","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F339","char":"🌹","name":"rose","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F940","char":"🥀","name":"wilted flower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33A","char":"🌺","name":"hibiscus","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33B","char":"🌻","name":"sunflower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33C","char":"🌼","name":"blossom","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F337","char":"🌷","name":"tulip","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1FABB","char":"🪻","name":"hyacinth","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F331","char":"🌱","name":"seedling","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FAB4","char":"🪴","name":"potted plant","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F332","char":"🌲","name":"evergreen tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F333","char":"🌳","name":"deciduous tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F334","char":"🌴","name":"palm tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F335","char":"🌵","name":"cactus","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F33E","char":"🌾","name":"sheaf of rice","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F33F","char":"🌿","name":"herb","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"2618 FE0F","char":"☘️","name":"shamrock","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"2618","char":"☘","name":"shamrock","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F340","char":"🍀","name":"four leaf clover","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F341","char":"🍁","name":"maple leaf","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F342","char":"🍂","name":"fallen leaf","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F343","char":"🍃","name":"leaf fluttering in wind","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FAB9","char":"🪹","name":"empty nest","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FABA","char":"🪺","name":"nest with eggs","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F344","char":"🍄","name":"mushroom","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F347","char":"🍇","name":"grapes","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F348","char":"🍈","name":"melon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F349","char":"🍉","name":"watermelon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34A","char":"🍊","name":"tangerine","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34B","char":"🍋","name":"lemon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34B 200D 1F7E9","char":"🍋‍🟩","name":"lime","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34C","char":"🍌","name":"banana","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34D","char":"🍍","name":"pineapple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F96D","char":"🥭","name":"mango","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34E","char":"🍎","name":"red apple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34F","char":"🍏","name":"green apple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F350","char":"🍐","name":"pear","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F351","char":"🍑","name":"peach","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F352","char":"🍒","name":"cherries","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F353","char":"🍓","name":"strawberry","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1FAD0","char":"🫐","name":"blueberries","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F95D","char":"🥝","name":"kiwi fruit","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F345","char":"🍅","name":"tomato","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1FAD2","char":"🫒","name":"olive","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F965","char":"🥥","name":"coconut","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F951","char":"🥑","name":"avocado","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F346","char":"🍆","name":"eggplant","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F954","char":"🥔","name":"potato","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F955","char":"🥕","name":"carrot","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F33D","char":"🌽","name":"ear of corn","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F336 FE0F","char":"🌶️","name":"hot pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F336","char":"🌶","name":"hot pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FAD1","char":"🫑","name":"bell pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F952","char":"🥒","name":"cucumber","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F96C","char":"🥬","name":"leafy green","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F966","char":"🥦","name":"broccoli","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F9C4","char":"🧄","name":"garlic","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F9C5","char":"🧅","name":"onion","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F95C","char":"🥜","name":"peanuts","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FAD8","char":"🫘","name":"beans","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F330","char":"🌰","name":"chestnut","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FADA","char":"🫚","name":"ginger root","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FADB","char":"🫛","name":"pea pod","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F344 200D 1F7EB","char":"🍄‍🟫","name":"brown mushroom","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F35E","char":"🍞","name":"bread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F950","char":"🥐","name":"croissant","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F956","char":"🥖","name":"baguette bread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD3","char":"🫓","name":"flatbread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F968","char":"🥨","name":"pretzel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96F","char":"🥯","name":"bagel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F95E","char":"🥞","name":"pancakes","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C7","char":"🧇","name":"waffle","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C0","char":"🧀","name":"cheese wedge","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F356","char":"🍖","name":"meat on bone","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F357","char":"🍗","name":"poultry leg","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F969","char":"🥩","name":"cut of meat","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F953","char":"🥓","name":"bacon","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F354","char":"🍔","name":"hamburger","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F35F","char":"🍟","name":"french fries","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F355","char":"🍕","name":"pizza","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32D","char":"🌭","name":"hot dog","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96A","char":"🥪","name":"sandwich","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32E","char":"🌮","name":"taco","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32F","char":"🌯","name":"burrito","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD4","char":"🫔","name":"tamale","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F959","char":"🥙","name":"stuffed flatbread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C6","char":"🧆","name":"falafel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F95A","char":"🥚","name":"egg","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F373","char":"🍳","name":"cooking","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F958","char":"🥘","name":"shallow pan of food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F372","char":"🍲","name":"pot of food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD5","char":"🫕","name":"fondue","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F963","char":"🥣","name":"bowl with spoon","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F957","char":"🥗","name":"green salad","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F37F","char":"🍿","name":"popcorn","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C8","char":"🧈","name":"butter","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C2","char":"🧂","name":"salt","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96B","char":"🥫","name":"canned food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F371","char":"🍱","name":"bento box","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F358","char":"🍘","name":"rice cracker","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F359","char":"🍙","name":"rice ball","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35A","char":"🍚","name":"cooked rice","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35B","char":"🍛","name":"curry rice","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35C","char":"🍜","name":"steaming bowl","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35D","char":"🍝","name":"spaghetti","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F360","char":"🍠","name":"roasted sweet potato","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F362","char":"🍢","name":"oden","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F363","char":"🍣","name":"sushi","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F364","char":"🍤","name":"fried shrimp","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F365","char":"🍥","name":"fish cake with swirl","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F96E","char":"🥮","name":"moon cake","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F361","char":"🍡","name":"dango","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F95F","char":"🥟","name":"dumpling","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F960","char":"🥠","name":"fortune cookie","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F961","char":"🥡","name":"takeout box","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F980","char":"🦀","name":"crab","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F99E","char":"🦞","name":"lobster","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F990","char":"🦐","name":"shrimp","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F991","char":"🦑","name":"squid","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F9AA","char":"🦪","name":"oyster","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F366","char":"🍦","name":"soft ice cream","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F367","char":"🍧","name":"shaved ice","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F368","char":"🍨","name":"ice cream","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F369","char":"🍩","name":"doughnut","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36A","char":"🍪","name":"cookie","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F382","char":"🎂","name":"birthday cake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F370","char":"🍰","name":"shortcake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F9C1","char":"🧁","name":"cupcake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F967","char":"🥧","name":"pie","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36B","char":"🍫","name":"chocolate bar","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36C","char":"🍬","name":"candy","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36D","char":"🍭","name":"lollipop","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36E","char":"🍮","name":"custard","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36F","char":"🍯","name":"honey pot","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F37C","char":"🍼","name":"baby bottle","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F95B","char":"🥛","name":"glass of milk","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"2615","char":"☕","name":"hot beverage","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1FAD6","char":"🫖","name":"teapot","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F375","char":"🍵","name":"teacup without handle","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F376","char":"🍶","name":"sake","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37E","char":"🍾","name":"bottle with popping cork","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F377","char":"🍷","name":"wine glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F378","char":"🍸","name":"cocktail glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F379","char":"🍹","name":"tropical drink","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37A","char":"🍺","name":"beer mug","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37B","char":"🍻","name":"clinking beer mugs","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F942","char":"🥂","name":"clinking glasses","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F943","char":"🥃","name":"tumbler glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1FAD7","char":"🫗","name":"pouring liquid","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F964","char":"🥤","name":"cup with straw","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9CB","char":"🧋","name":"bubble tea","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9C3","char":"🧃","name":"beverage box","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9C9","char":"🧉","name":"mate","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9CA","char":"🧊","name":"ice","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F962","char":"🥢","name":"chopsticks","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F37D FE0F","char":"🍽️","name":"fork and knife with plate","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F37D","char":"🍽","name":"fork and knife with plate","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F374","char":"🍴","name":"fork and knife","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F944","char":"🥄","name":"spoon","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F52A","char":"🔪","name":"kitchen knife","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1FAD9","char":"🫙","name":"jar","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F3FA","char":"🏺","name":"amphora","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F30D","char":"🌍","name":"globe showing Europe-Africa","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F30E","char":"🌎","name":"globe showing Americas","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F30F","char":"🌏","name":"globe showing Asia-Australia","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F310","char":"🌐","name":"globe with meridians","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FA FE0F","char":"🗺️","name":"world map","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FA","char":"🗺","name":"world map","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FE","char":"🗾","name":"map of Japan","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F9ED","char":"🧭","name":"compass","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F3D4 FE0F","char":"🏔️","name":"snow-capped mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D4","char":"🏔","name":"snow-capped mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"26F0 FE0F","char":"⛰️","name":"mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"26F0","char":"⛰","name":"mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F30B","char":"🌋","name":"volcano","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F5FB","char":"🗻","name":"mount fuji","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D5 FE0F","char":"🏕️","name":"camping","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D5","char":"🏕","name":"camping","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D6 FE0F","char":"🏖️","name":"beach with umbrella","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D6","char":"🏖","name":"beach with umbrella","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DC FE0F","char":"🏜️","name":"desert","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DC","char":"🏜","name":"desert","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DD FE0F","char":"🏝️","name":"desert island","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DD","char":"🏝","name":"desert island","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DE FE0F","char":"🏞️","name":"national park","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DE","char":"🏞","name":"national park","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DF FE0F","char":"🏟️","name":"stadium","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DF","char":"🏟","name":"stadium","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DB FE0F","char":"🏛️","name":"classical building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DB","char":"🏛","name":"classical building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D7 FE0F","char":"🏗️","name":"building construction","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D7","char":"🏗","name":"building construction","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F9F1","char":"🧱","name":"brick","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1FAA8","char":"🪨","name":"rock","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1FAB5","char":"🪵","name":"wood","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F6D6","char":"🛖","name":"hut","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D8 FE0F","char":"🏘️","name":"houses","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D8","char":"🏘","name":"houses","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DA FE0F","char":"🏚️","name":"derelict house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DA","char":"🏚","name":"derelict house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E0","char":"🏠","name":"house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E1","char":"🏡","name":"house with garden","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E2","char":"🏢","name":"office building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E3","char":"🏣","name":"Japanese post office","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E4","char":"🏤","name":"post office","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E5","char":"🏥","name":"hospital","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E6","char":"🏦","name":"bank","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E8","char":"🏨","name":"hotel","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E9","char":"🏩","name":"love hotel","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EA","char":"🏪","name":"convenience store","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EB","char":"🏫","name":"school","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EC","char":"🏬","name":"department store","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3ED","char":"🏭","name":"factory","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EF","char":"🏯","name":"Japanese castle","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3F0","char":"🏰","name":"castle","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F492","char":"💒","name":"wedding","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F5FC","char":"🗼","name":"Tokyo tower","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F5FD","char":"🗽","name":"Statue of Liberty","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"26EA","char":"⛪","name":"church","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54C","char":"🕌","name":"mosque","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F6D5","char":"🛕","name":"hindu temple","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54D","char":"🕍","name":"synagogue","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26E9 FE0F","char":"⛩️","name":"shinto shrine","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26E9","char":"⛩","name":"shinto shrine","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54B","char":"🕋","name":"kaaba","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26F2","char":"⛲","name":"fountain","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"26FA","char":"⛺","name":"tent","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F301","char":"🌁","name":"foggy","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F303","char":"🌃","name":"night with stars","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3D9 FE0F","char":"🏙️","name":"cityscape","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3D9","char":"🏙","name":"cityscape","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F304","char":"🌄","name":"sunrise over mountains","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F305","char":"🌅","name":"sunrise","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F306","char":"🌆","name":"cityscape at dusk","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F307","char":"🌇","name":"sunset","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F309","char":"🌉","name":"bridge at night","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"2668 FE0F","char":"♨️","name":"hot springs","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"2668","char":"♨","name":"hot springs","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A0","char":"🎠","name":"carousel horse","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F6DD","char":"🛝","name":"playground slide","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A1","char":"🎡","name":"ferris wheel","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A2","char":"🎢","name":"roller coaster","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F488","char":"💈","name":"barber pole","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3AA","char":"🎪","name":"circus tent","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F682","char":"🚂","name":"locomotive","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F683","char":"🚃","name":"railway car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F684","char":"🚄","name":"high-speed train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F685","char":"🚅","name":"bullet train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F686","char":"🚆","name":"train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F687","char":"🚇","name":"metro","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F688","char":"🚈","name":"light rail","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F689","char":"🚉","name":"station","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68A","char":"🚊","name":"tram","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69D","char":"🚝","name":"monorail","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69E","char":"🚞","name":"mountain railway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68B","char":"🚋","name":"tram car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68C","char":"🚌","name":"bus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68D","char":"🚍","name":"oncoming bus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68E","char":"🚎","name":"trolleybus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F690","char":"🚐","name":"minibus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F691","char":"🚑","name":"ambulance","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F692","char":"🚒","name":"fire engine","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F693","char":"🚓","name":"police car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F694","char":"🚔","name":"oncoming police car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F695","char":"🚕","name":"taxi","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F696","char":"🚖","name":"oncoming taxi","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F697","char":"🚗","name":"automobile","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F698","char":"🚘","name":"oncoming automobile","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F699","char":"🚙","name":"sport utility vehicle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FB","char":"🛻","name":"pickup truck","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69A","char":"🚚","name":"delivery truck","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69B","char":"🚛","name":"articulated lorry","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69C","char":"🚜","name":"tractor","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CE FE0F","char":"🏎️","name":"racing car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CE","char":"🏎","name":"racing car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CD FE0F","char":"🏍️","name":"motorcycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CD","char":"🏍","name":"motorcycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F5","char":"🛵","name":"motor scooter","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F9BD","char":"🦽","name":"manual wheelchair","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F9BC","char":"🦼","name":"motorized wheelchair","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FA","char":"🛺","name":"auto rickshaw","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6B2","char":"🚲","name":"bicycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F4","char":"🛴","name":"kick scooter","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F9","char":"🛹","name":"skateboard","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FC","char":"🛼","name":"roller skate","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68F","char":"🚏","name":"bus stop","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E3 FE0F","char":"🛣️","name":"motorway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E3","char":"🛣","name":"motorway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E4 FE0F","char":"🛤️","name":"railway track","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E4","char":"🛤","name":"railway track","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E2 FE0F","char":"🛢️","name":"oil drum","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E2","char":"🛢","name":"oil drum","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"26FD","char":"⛽","name":"fuel pump","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6DE","char":"🛞","name":"wheel","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A8","char":"🚨","name":"police car light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A5","char":"🚥","name":"horizontal traffic light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A6","char":"🚦","name":"vertical traffic light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6D1","char":"🛑","name":"stop sign","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A7","char":"🚧","name":"construction","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"2693","char":"⚓","name":"anchor","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6DF","char":"🛟","name":"ring buoy","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F5","char":"⛵","name":"sailboat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F6","char":"🛶","name":"canoe","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6A4","char":"🚤","name":"speedboat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F3 FE0F","char":"🛳️","name":"passenger ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F3","char":"🛳","name":"passenger ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F4 FE0F","char":"⛴️","name":"ferry","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F4","char":"⛴","name":"ferry","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6E5 FE0F","char":"🛥️","name":"motor boat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6E5","char":"🛥","name":"motor boat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6A2","char":"🚢","name":"ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"2708 FE0F","char":"✈️","name":"airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"2708","char":"✈","name":"airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6E9 FE0F","char":"🛩️","name":"small airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6E9","char":"🛩","name":"small airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6EB","char":"🛫","name":"airplane departure","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6EC","char":"🛬","name":"airplane arrival","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1FA82","char":"🪂","name":"parachute","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F4BA","char":"💺","name":"seat","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F681","char":"🚁","name":"helicopter","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F69F","char":"🚟","name":"suspension railway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6A0","char":"🚠","name":"mountain cableway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6A1","char":"🚡","name":"aerial tramway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F0 FE0F","char":"🛰️","name":"satellite","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F0","char":"🛰","name":"satellite","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F680","char":"🚀","name":"rocket","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F8","char":"🛸","name":"flying saucer","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6CE FE0F","char":"🛎️","name":"bellhop bell","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"1F6CE","char":"🛎","name":"bellhop bell","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"1F9F3","char":"🧳","name":"luggage","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"231B","char":"⌛","name":"hourglass done","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F3","char":"⏳","name":"hourglass not done","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"231A","char":"⌚","name":"watch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F0","char":"⏰","name":"alarm clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F1 FE0F","char":"⏱️","name":"stopwatch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F1","char":"⏱","name":"stopwatch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F2 FE0F","char":"⏲️","name":"timer clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F2","char":"⏲","name":"timer clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F570 FE0F","char":"🕰️","name":"mantelpiece clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F570","char":"🕰","name":"mantelpiece clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55B","char":"🕛","name":"twelve o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F567","char":"🕧","name":"twelve-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F550","char":"🕐","name":"one o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55C","char":"🕜","name":"one-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F551","char":"🕑","name":"two o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55D","char":"🕝","name":"two-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F552","char":"🕒","name":"three o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55E","char":"🕞","name":"three-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F553","char":"🕓","name":"four o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55F","char":"🕟","name":"four-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F554","char":"🕔","name":"five o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F560","char":"🕠","name":"five-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F555","char":"🕕","name":"six o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F561","char":"🕡","name":"six-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F556","char":"🕖","name":"seven o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F562","char":"🕢","name":"seven-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F557","char":"🕗","name":"eight o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F563","char":"🕣","name":"eight-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F558","char":"🕘","name":"nine o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F564","char":"🕤","name":"nine-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F559","char":"🕙","name":"ten o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F565","char":"🕥","name":"ten-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55A","char":"🕚","name":"eleven o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F566","char":"🕦","name":"eleven-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F311","char":"🌑","name":"new moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F312","char":"🌒","name":"waxing crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F313","char":"🌓","name":"first quarter moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F314","char":"🌔","name":"waxing gibbous moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F315","char":"🌕","name":"full moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F316","char":"🌖","name":"waning gibbous moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F317","char":"🌗","name":"last quarter moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F318","char":"🌘","name":"waning crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F319","char":"🌙","name":"crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31A","char":"🌚","name":"new moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31B","char":"🌛","name":"first quarter moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31C","char":"🌜","name":"last quarter moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F321 FE0F","char":"🌡️","name":"thermometer","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F321","char":"🌡","name":"thermometer","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2600 FE0F","char":"☀️","name":"sun","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2600","char":"☀","name":"sun","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31D","char":"🌝","name":"full moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31E","char":"🌞","name":"sun with face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1FA90","char":"🪐","name":"ringed planet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2B50","char":"⭐","name":"star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31F","char":"🌟","name":"glowing star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F320","char":"🌠","name":"shooting star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F30C","char":"🌌","name":"milky way","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2601 FE0F","char":"☁️","name":"cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2601","char":"☁","name":"cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C5","char":"⛅","name":"sun behind cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C8 FE0F","char":"⛈️","name":"cloud with lightning and rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C8","char":"⛈","name":"cloud with lightning and rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F324 FE0F","char":"🌤️","name":"sun behind small cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F324","char":"🌤","name":"sun behind small cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F325 FE0F","char":"🌥️","name":"sun behind large cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F325","char":"🌥","name":"sun behind large cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F326 FE0F","char":"🌦️","name":"sun behind rain cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F326","char":"🌦","name":"sun behind rain cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F327 FE0F","char":"🌧️","name":"cloud with rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F327","char":"🌧","name":"cloud with rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F328 FE0F","char":"🌨️","name":"cloud with snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F328","char":"🌨","name":"cloud with snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F329 FE0F","char":"🌩️","name":"cloud with lightning","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F329","char":"🌩","name":"cloud with lightning","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32A FE0F","char":"🌪️","name":"tornado","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32A","char":"🌪","name":"tornado","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32B FE0F","char":"🌫️","name":"fog","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32B","char":"🌫","name":"fog","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32C FE0F","char":"🌬️","name":"wind face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32C","char":"🌬","name":"wind face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F300","char":"🌀","name":"cyclone","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F308","char":"🌈","name":"rainbow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F302","char":"🌂","name":"closed umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2602 FE0F","char":"☂️","name":"umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2602","char":"☂","name":"umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2614","char":"☔","name":"umbrella with rain drops","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26F1 FE0F","char":"⛱️","name":"umbrella on ground","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26F1","char":"⛱","name":"umbrella on ground","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26A1","char":"⚡","name":"high voltage","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2744 FE0F","char":"❄️","name":"snowflake","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2744","char":"❄","name":"snowflake","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2603 FE0F","char":"☃️","name":"snowman","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2603","char":"☃","name":"snowman","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C4","char":"⛄","name":"snowman without snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2604 FE0F","char":"☄️","name":"comet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2604","char":"☄","name":"comet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F525","char":"🔥","name":"fire","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F4A7","char":"💧","name":"droplet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F30A","char":"🌊","name":"water wave","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F383","char":"🎃","name":"jack-o-lantern","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F384","char":"🎄","name":"Christmas tree","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F386","char":"🎆","name":"fireworks","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F387","char":"🎇","name":"sparkler","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F9E8","char":"🧨","name":"firecracker","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"2728","char":"✨","name":"sparkles","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F388","char":"🎈","name":"balloon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F389","char":"🎉","name":"party popper","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38A","char":"🎊","name":"confetti ball","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38B","char":"🎋","name":"tanabata tree","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38D","char":"🎍","name":"pine decoration","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38E","char":"🎎","name":"Japanese dolls","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38F","char":"🎏","name":"carp streamer","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F390","char":"🎐","name":"wind chime","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F391","char":"🎑","name":"moon viewing ceremony","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F9E7","char":"🧧","name":"red envelope","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F380","char":"🎀","name":"ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F381","char":"🎁","name":"wrapped gift","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F397 FE0F","char":"🎗️","name":"reminder ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F397","char":"🎗","name":"reminder ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F39F FE0F","char":"🎟️","name":"admission tickets","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F39F","char":"🎟","name":"admission tickets","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F3AB","char":"🎫","name":"ticket","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F396 FE0F","char":"🎖️","name":"military medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F396","char":"🎖","name":"military medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F3C6","char":"🏆","name":"trophy","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F3C5","char":"🏅","name":"sports medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F947","char":"🥇","name":"1st place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F948","char":"🥈","name":"2nd place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F949","char":"🥉","name":"3rd place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"26BD","char":"⚽","name":"soccer ball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26BE","char":"⚾","name":"baseball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94E","char":"🥎","name":"softball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C0","char":"🏀","name":"basketball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D0","char":"🏐","name":"volleyball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C8","char":"🏈","name":"american football","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C9","char":"🏉","name":"rugby football","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BE","char":"🎾","name":"tennis","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94F","char":"🥏","name":"flying disc","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3B3","char":"🎳","name":"bowling","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3CF","char":"🏏","name":"cricket game","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D1","char":"🏑","name":"field hockey","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D2","char":"🏒","name":"ice hockey","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94D","char":"🥍","name":"lacrosse","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D3","char":"🏓","name":"ping pong","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3F8","char":"🏸","name":"badminton","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94A","char":"🥊","name":"boxing glove","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94B","char":"🥋","name":"martial arts uniform","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F945","char":"🥅","name":"goal net","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F3","char":"⛳","name":"flag in hole","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F8 FE0F","char":"⛸️","name":"ice skate","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F8","char":"⛸","name":"ice skate","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3A3","char":"🎣","name":"fishing pole","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F93F","char":"🤿","name":"diving mask","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BD","char":"🎽","name":"running shirt","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BF","char":"🎿","name":"skis","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F6F7","char":"🛷","name":"sled","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94C","char":"🥌","name":"curling stone","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3AF","char":"🎯","name":"bullseye","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA80","char":"🪀","name":"yo-yo","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA81","char":"🪁","name":"kite","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F52B","char":"🔫","name":"water pistol","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B1","char":"🎱","name":"pool 8 ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F52E","char":"🔮","name":"crystal ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA84","char":"🪄","name":"magic wand","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3AE","char":"🎮","name":"video game","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F579 FE0F","char":"🕹️","name":"joystick","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F579","char":"🕹","name":"joystick","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B0","char":"🎰","name":"slot machine","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B2","char":"🎲","name":"game die","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F9E9","char":"🧩","name":"puzzle piece","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F9F8","char":"🧸","name":"teddy bear","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA85","char":"🪅","name":"piñata","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FAA9","char":"🪩","name":"mirror ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA86","char":"🪆","name":"nesting dolls","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2660 FE0F","char":"♠️","name":"spade suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2660","char":"♠","name":"spade suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2665 FE0F","char":"♥️","name":"heart suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2665","char":"♥","name":"heart suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2666 FE0F","char":"♦️","name":"diamond suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2666","char":"♦","name":"diamond suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2663 FE0F","char":"♣️","name":"club suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2663","char":"♣","name":"club suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"265F FE0F","char":"♟️","name":"chess pawn","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"265F","char":"♟","name":"chess pawn","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F0CF","char":"🃏","name":"joker","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F004","char":"🀄","name":"mahjong red dragon","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B4","char":"🎴","name":"flower playing cards","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3AD","char":"🎭","name":"performing arts","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F5BC FE0F","char":"🖼️","name":"framed picture","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F5BC","char":"🖼","name":"framed picture","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F3A8","char":"🎨","name":"artist palette","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F9F5","char":"🧵","name":"thread","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1FAA1","char":"🪡","name":"sewing needle","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F9F6","char":"🧶","name":"yarn","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1FAA2","char":"🪢","name":"knot","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F453","char":"👓","name":"glasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F576 FE0F","char":"🕶️","name":"sunglasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F576","char":"🕶","name":"sunglasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97D","char":"🥽","name":"goggles","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97C","char":"🥼","name":"lab coat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9BA","char":"🦺","name":"safety vest","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F454","char":"👔","name":"necktie","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F455","char":"👕","name":"t-shirt","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F456","char":"👖","name":"jeans","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E3","char":"🧣","name":"scarf","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E4","char":"🧤","name":"gloves","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E5","char":"🧥","name":"coat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E6","char":"🧦","name":"socks","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F457","char":"👗","name":"dress","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F458","char":"👘","name":"kimono","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97B","char":"🥻","name":"sari","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA71","char":"🩱","name":"one-piece swimsuit","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA72","char":"🩲","name":"briefs","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA73","char":"🩳","name":"shorts","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F459","char":"👙","name":"bikini","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45A","char":"👚","name":"woman’s clothes","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FAAD","char":"🪭","name":"folding hand fan","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45B","char":"👛","name":"purse","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45C","char":"👜","name":"handbag","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45D","char":"👝","name":"clutch bag","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F6CD FE0F","char":"🛍️","name":"shopping bags","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F6CD","char":"🛍","name":"shopping bags","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F392","char":"🎒","name":"backpack","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA74","char":"🩴","name":"thong sandal","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45E","char":"👞","name":"man’s shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45F","char":"👟","name":"running shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97E","char":"🥾","name":"hiking boot","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97F","char":"🥿","name":"flat shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F460","char":"👠","name":"high-heeled shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F461","char":"👡","name":"woman’s sandal","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA70","char":"🩰","name":"ballet shoes","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F462","char":"👢","name":"woman’s boot","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FAAE","char":"🪮","name":"hair pick","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F451","char":"👑","name":"crown","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F452","char":"👒","name":"woman’s hat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F3A9","char":"🎩","name":"top hat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F393","char":"🎓","name":"graduation cap","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E2","char":"🧢","name":"billed cap","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA96","char":"🪖","name":"military helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"26D1 FE0F","char":"⛑️","name":"rescue worker’s helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"26D1","char":"⛑","name":"rescue worker’s helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F4FF","char":"📿","name":"prayer beads","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F484","char":"💄","name":"lipstick","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F48D","char":"💍","name":"ring","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F48E","char":"💎","name":"gem stone","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F507","char":"🔇","name":"muted speaker","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F508","char":"🔈","name":"speaker low volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F509","char":"🔉","name":"speaker medium volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F50A","char":"🔊","name":"speaker high volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4E2","char":"📢","name":"loudspeaker","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4E3","char":"📣","name":"megaphone","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4EF","char":"📯","name":"postal horn","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F514","char":"🔔","name":"bell","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F515","char":"🔕","name":"bell with slash","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F3BC","char":"🎼","name":"musical score","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B5","char":"🎵","name":"musical note","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B6","char":"🎶","name":"musical notes","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F399 FE0F","char":"🎙️","name":"studio microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F399","char":"🎙","name":"studio microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39A FE0F","char":"🎚️","name":"level slider","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39A","char":"🎚","name":"level slider","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39B FE0F","char":"🎛️","name":"control knobs","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39B","char":"🎛","name":"control knobs","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3A4","char":"🎤","name":"microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3A7","char":"🎧","name":"headphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F4FB","char":"📻","name":"radio","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B7","char":"🎷","name":"saxophone","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA97","char":"🪗","name":"accordion","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3B8","char":"🎸","name":"guitar","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3B9","char":"🎹","name":"musical keyboard","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3BA","char":"🎺","name":"trumpet","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3BB","char":"🎻","name":"violin","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA95","char":"🪕","name":"banjo","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F941","char":"🥁","name":"drum","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA98","char":"🪘","name":"long drum","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA87","char":"🪇","name":"maracas","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA88","char":"🪈","name":"flute","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F4F1","char":"📱","name":"mobile phone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4F2","char":"📲","name":"mobile phone with arrow","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"260E FE0F","char":"☎️","name":"telephone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"260E","char":"☎","name":"telephone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4DE","char":"📞","name":"telephone receiver","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4DF","char":"📟","name":"pager","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4E0","char":"📠","name":"fax machine","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F50B","char":"🔋","name":"battery","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1FAAB","char":"🪫","name":"low battery","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F50C","char":"🔌","name":"electric plug","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BB","char":"💻","name":"laptop","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A5 FE0F","char":"🖥️","name":"desktop computer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A5","char":"🖥","name":"desktop computer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A8 FE0F","char":"🖨️","name":"printer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A8","char":"🖨","name":"printer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"2328 FE0F","char":"⌨️","name":"keyboard","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"2328","char":"⌨","name":"keyboard","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B1 FE0F","char":"🖱️","name":"computer mouse","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B1","char":"🖱","name":"computer mouse","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B2 FE0F","char":"🖲️","name":"trackball","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B2","char":"🖲","name":"trackball","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BD","char":"💽","name":"computer disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BE","char":"💾","name":"floppy disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BF","char":"💿","name":"optical disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4C0","char":"📀","name":"dvd","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F9EE","char":"🧮","name":"abacus","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F3A5","char":"🎥","name":"movie camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F39E FE0F","char":"🎞️","name":"film frames","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F39E","char":"🎞","name":"film frames","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FD FE0F","char":"📽️","name":"film projector","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FD","char":"📽","name":"film projector","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F3AC","char":"🎬","name":"clapper board","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FA","char":"📺","name":"television","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F7","char":"📷","name":"camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F8","char":"📸","name":"camera with flash","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F9","char":"📹","name":"video camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FC","char":"📼","name":"videocassette","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F50D","char":"🔍","name":"magnifying glass tilted left","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F50E","char":"🔎","name":"magnifying glass tilted right","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F56F FE0F","char":"🕯️","name":"candle","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F56F","char":"🕯","name":"candle","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4A1","char":"💡","name":"light bulb","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F526","char":"🔦","name":"flashlight","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F3EE","char":"🏮","name":"red paper lantern","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1FA94","char":"🪔","name":"diya lamp","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4D4","char":"📔","name":"notebook with decorative cover","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D5","char":"📕","name":"closed book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D6","char":"📖","name":"open book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D7","char":"📗","name":"green book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D8","char":"📘","name":"blue book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D9","char":"📙","name":"orange book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4DA","char":"📚","name":"books","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D3","char":"📓","name":"notebook","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D2","char":"📒","name":"ledger","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4C3","char":"📃","name":"page with curl","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4DC","char":"📜","name":"scroll","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4C4","char":"📄","name":"page facing up","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4F0","char":"📰","name":"newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F5DE FE0F","char":"🗞️","name":"rolled-up newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F5DE","char":"🗞","name":"rolled-up newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D1","char":"📑","name":"bookmark tabs","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F516","char":"🔖","name":"bookmark","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F3F7 FE0F","char":"🏷️","name":"label","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F3F7","char":"🏷","name":"label","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4B0","char":"💰","name":"money bag","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1FA99","char":"🪙","name":"coin","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B4","char":"💴","name":"yen banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B5","char":"💵","name":"dollar banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B6","char":"💶","name":"euro banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B7","char":"💷","name":"pound banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B8","char":"💸","name":"money with wings","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B3","char":"💳","name":"credit card","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F9FE","char":"🧾","name":"receipt","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B9","char":"💹","name":"chart increasing with yen","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"2709 FE0F","char":"✉️","name":"envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"2709","char":"✉","name":"envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E7","char":"📧","name":"e-mail","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E8","char":"📨","name":"incoming envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E9","char":"📩","name":"envelope with arrow","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E4","char":"📤","name":"outbox tray","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E5","char":"📥","name":"inbox tray","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E6","char":"📦","name":"package","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EB","char":"📫","name":"closed mailbox with raised flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EA","char":"📪","name":"closed mailbox with lowered flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EC","char":"📬","name":"open mailbox with raised flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4ED","char":"📭","name":"open mailbox with lowered flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EE","char":"📮","name":"postbox","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F5F3 FE0F","char":"🗳️","name":"ballot box with ballot","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F5F3","char":"🗳","name":"ballot box with ballot","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"270F FE0F","char":"✏️","name":"pencil","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"270F","char":"✏","name":"pencil","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"2712 FE0F","char":"✒️","name":"black nib","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"2712","char":"✒","name":"black nib","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58B FE0F","char":"🖋️","name":"fountain pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58B","char":"🖋","name":"fountain pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58A FE0F","char":"🖊️","name":"pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58A","char":"🖊","name":"pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58C FE0F","char":"🖌️","name":"paintbrush","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58C","char":"🖌","name":"paintbrush","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58D FE0F","char":"🖍️","name":"crayon","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58D","char":"🖍","name":"crayon","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F4DD","char":"📝","name":"memo","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F4BC","char":"💼","name":"briefcase","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C1","char":"📁","name":"file folder","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C2","char":"📂","name":"open file folder","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C2 FE0F","char":"🗂️","name":"card index dividers","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C2","char":"🗂","name":"card index dividers","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C5","char":"📅","name":"calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C6","char":"📆","name":"tear-off calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D2 FE0F","char":"🗒️","name":"spiral notepad","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D2","char":"🗒","name":"spiral notepad","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D3 FE0F","char":"🗓️","name":"spiral calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D3","char":"🗓","name":"spiral calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C7","char":"📇","name":"card index","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C8","char":"📈","name":"chart increasing","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C9","char":"📉","name":"chart decreasing","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CA","char":"📊","name":"bar chart","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CB","char":"📋","name":"clipboard","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CC","char":"📌","name":"pushpin","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CD","char":"📍","name":"round pushpin","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CE","char":"📎","name":"paperclip","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F587 FE0F","char":"🖇️","name":"linked paperclips","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F587","char":"🖇","name":"linked paperclips","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CF","char":"📏","name":"straight ruler","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4D0","char":"📐","name":"triangular ruler","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"2702 FE0F","char":"✂️","name":"scissors","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"2702","char":"✂","name":"scissors","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C3 FE0F","char":"🗃️","name":"card file box","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C3","char":"🗃","name":"card file box","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C4 FE0F","char":"🗄️","name":"file cabinet","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C4","char":"🗄","name":"file cabinet","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D1 FE0F","char":"🗑️","name":"wastebasket","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D1","char":"🗑","name":"wastebasket","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F512","char":"🔒","name":"locked","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F513","char":"🔓","name":"unlocked","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F50F","char":"🔏","name":"locked with pen","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F510","char":"🔐","name":"locked with key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F511","char":"🔑","name":"key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F5DD FE0F","char":"🗝️","name":"old key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F5DD","char":"🗝","name":"old key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F528","char":"🔨","name":"hammer","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA93","char":"🪓","name":"axe","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26CF FE0F","char":"⛏️","name":"pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26CF","char":"⛏","name":"pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2692 FE0F","char":"⚒️","name":"hammer and pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2692","char":"⚒","name":"hammer and pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E0 FE0F","char":"🛠️","name":"hammer and wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E0","char":"🛠","name":"hammer and wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5E1 FE0F","char":"🗡️","name":"dagger","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5E1","char":"🗡","name":"dagger","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2694 FE0F","char":"⚔️","name":"crossed swords","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2694","char":"⚔","name":"crossed swords","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F4A3","char":"💣","name":"bomb","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA83","char":"🪃","name":"boomerang","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F3F9","char":"🏹","name":"bow and arrow","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E1 FE0F","char":"🛡️","name":"shield","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E1","char":"🛡","name":"shield","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9A","char":"🪚","name":"carpentry saw","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F527","char":"🔧","name":"wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9B","char":"🪛","name":"screwdriver","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F529","char":"🔩","name":"nut and bolt","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2699 FE0F","char":"⚙️","name":"gear","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2699","char":"⚙","name":"gear","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5DC FE0F","char":"🗜️","name":"clamp","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5DC","char":"🗜","name":"clamp","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2696 FE0F","char":"⚖️","name":"balance scale","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2696","char":"⚖","name":"balance scale","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9AF","char":"🦯","name":"white cane","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F517","char":"🔗","name":"link","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 FE0F 200D 1F4A5","char":"⛓️‍💥","name":"broken chain","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 200D 1F4A5","char":"⛓‍💥","name":"broken chain","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 FE0F","char":"⛓️","name":"chains","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3","char":"⛓","name":"chains","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9D","char":"🪝","name":"hook","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9F0","char":"🧰","name":"toolbox","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9F2","char":"🧲","name":"magnet","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9C","char":"🪜","name":"ladder","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2697 FE0F","char":"⚗️","name":"alembic","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"2697","char":"⚗","name":"alembic","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EA","char":"🧪","name":"test tube","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EB","char":"🧫","name":"petri dish","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EC","char":"🧬","name":"dna","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F52C","char":"🔬","name":"microscope","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F52D","char":"🔭","name":"telescope","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F4E1","char":"📡","name":"satellite antenna","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F489","char":"💉","name":"syringe","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA78","char":"🩸","name":"drop of blood","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1F48A","char":"💊","name":"pill","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA79","char":"🩹","name":"adhesive bandage","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7C","char":"🩼","name":"crutch","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7A","char":"🩺","name":"stethoscope","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7B","char":"🩻","name":"x-ray","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1F6AA","char":"🚪","name":"door","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6D7","char":"🛗","name":"elevator","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA9E","char":"🪞","name":"mirror","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA9F","char":"🪟","name":"window","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CF FE0F","char":"🛏️","name":"bed","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CF","char":"🛏","name":"bed","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CB FE0F","char":"🛋️","name":"couch and lamp","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CB","char":"🛋","name":"couch and lamp","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA91","char":"🪑","name":"chair","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6BD","char":"🚽","name":"toilet","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA0","char":"🪠","name":"plunger","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6BF","char":"🚿","name":"shower","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6C1","char":"🛁","name":"bathtub","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA4","char":"🪤","name":"mouse trap","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA92","char":"🪒","name":"razor","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F4","char":"🧴","name":"lotion bottle","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F7","char":"🧷","name":"safety pin","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F9","char":"🧹","name":"broom","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FA","char":"🧺","name":"basket","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FB","char":"🧻","name":"roll of paper","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA3","char":"🪣","name":"bucket","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FC","char":"🧼","name":"soap","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAE7","char":"🫧","name":"bubbles","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA5","char":"🪥","name":"toothbrush","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FD","char":"🧽","name":"sponge","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9EF","char":"🧯","name":"fire extinguisher","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6D2","char":"🛒","name":"shopping cart","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6AC","char":"🚬","name":"cigarette","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B0 FE0F","char":"⚰️","name":"coffin","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B0","char":"⚰","name":"coffin","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAA6","char":"🪦","name":"headstone","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B1 FE0F","char":"⚱️","name":"funeral urn","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B1","char":"⚱","name":"funeral urn","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F9FF","char":"🧿","name":"nazar amulet","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAAC","char":"🪬","name":"hamsa","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F5FF","char":"🗿","name":"moai","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAA7","char":"🪧","name":"placard","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAAA","char":"🪪","name":"identification card","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F3E7","char":"🏧","name":"ATM sign","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6AE","char":"🚮","name":"litter in bin sign","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6B0","char":"🚰","name":"potable water","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"267F","char":"♿","name":"wheelchair symbol","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6B9","char":"🚹","name":"men’s room","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BA","char":"🚺","name":"women’s room","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BB","char":"🚻","name":"restroom","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BC","char":"🚼","name":"baby symbol","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BE","char":"🚾","name":"water closet","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C2","char":"🛂","name":"passport control","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C3","char":"🛃","name":"customs","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C4","char":"🛄","name":"baggage claim","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C5","char":"🛅","name":"left luggage","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"26A0 FE0F","char":"⚠️","name":"warning","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"26A0","char":"⚠","name":"warning","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B8","char":"🚸","name":"children crossing","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"26D4","char":"⛔","name":"no entry","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AB","char":"🚫","name":"prohibited","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B3","char":"🚳","name":"no bicycles","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AD","char":"🚭","name":"no smoking","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AF","char":"🚯","name":"no littering","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B1","char":"🚱","name":"non-potable water","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B7","char":"🚷","name":"no pedestrians","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F4F5","char":"📵","name":"no mobile phones","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F51E","char":"🔞","name":"no one under eighteen","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2622 FE0F","char":"☢️","name":"radioactive","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2622","char":"☢","name":"radioactive","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2623 FE0F","char":"☣️","name":"biohazard","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2623","char":"☣","name":"biohazard","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2B06 FE0F","char":"⬆️","name":"up arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B06","char":"⬆","name":"up arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2197 FE0F","char":"↗️","name":"up-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2197","char":"↗","name":"up-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"27A1 FE0F","char":"➡️","name":"right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"27A1","char":"➡","name":"right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2198 FE0F","char":"↘️","name":"down-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2198","char":"↘","name":"down-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B07 FE0F","char":"⬇️","name":"down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B07","char":"⬇","name":"down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2199 FE0F","char":"↙️","name":"down-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2199","char":"↙","name":"down-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B05 FE0F","char":"⬅️","name":"left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B05","char":"⬅","name":"left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2196 FE0F","char":"↖️","name":"up-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2196","char":"↖","name":"up-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2195 FE0F","char":"↕️","name":"up-down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2195","char":"↕","name":"up-down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2194 FE0F","char":"↔️","name":"left-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2194","char":"↔","name":"left-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21A9 FE0F","char":"↩️","name":"right arrow curving left","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21A9","char":"↩","name":"right arrow curving left","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21AA FE0F","char":"↪️","name":"left arrow curving right","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21AA","char":"↪","name":"left arrow curving right","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2934 FE0F","char":"⤴️","name":"right arrow curving up","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2934","char":"⤴","name":"right arrow curving up","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2935 FE0F","char":"⤵️","name":"right arrow curving down","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2935","char":"⤵","name":"right arrow curving down","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F503","char":"🔃","name":"clockwise vertical arrows","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F504","char":"🔄","name":"counterclockwise arrows button","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F519","char":"🔙","name":"BACK arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51A","char":"🔚","name":"END arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51B","char":"🔛","name":"ON! arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51C","char":"🔜","name":"SOON arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51D","char":"🔝","name":"TOP arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F6D0","char":"🛐","name":"place of worship","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"269B FE0F","char":"⚛️","name":"atom symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"269B","char":"⚛","name":"atom symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F549 FE0F","char":"🕉️","name":"om","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F549","char":"🕉","name":"om","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2721 FE0F","char":"✡️","name":"star of David","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2721","char":"✡","name":"star of David","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2638 FE0F","char":"☸️","name":"wheel of dharma","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2638","char":"☸","name":"wheel of dharma","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262F FE0F","char":"☯️","name":"yin yang","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262F","char":"☯","name":"yin yang","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"271D FE0F","char":"✝️","name":"latin cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"271D","char":"✝","name":"latin cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2626 FE0F","char":"☦️","name":"orthodox cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2626","char":"☦","name":"orthodox cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262A FE0F","char":"☪️","name":"star and crescent","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262A","char":"☪","name":"star and crescent","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262E FE0F","char":"☮️","name":"peace symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262E","char":"☮","name":"peace symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F54E","char":"🕎","name":"menorah","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F52F","char":"🔯","name":"dotted six-pointed star","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1FAAF","char":"🪯","name":"khanda","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2648","char":"♈","name":"Aries","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2649","char":"♉","name":"Taurus","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264A","char":"♊","name":"Gemini","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264B","char":"♋","name":"Cancer","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264C","char":"♌","name":"Leo","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264D","char":"♍","name":"Virgo","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264E","char":"♎","name":"Libra","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264F","char":"♏","name":"Scorpio","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2650","char":"♐","name":"Sagittarius","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2651","char":"♑","name":"Capricorn","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2652","char":"♒","name":"Aquarius","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2653","char":"♓","name":"Pisces","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"26CE","char":"⛎","name":"Ophiuchus","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"1F500","char":"🔀","name":"shuffle tracks button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F501","char":"🔁","name":"repeat button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F502","char":"🔂","name":"repeat single button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25B6 FE0F","char":"▶️","name":"play button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25B6","char":"▶","name":"play button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23E9","char":"⏩","name":"fast-forward button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23ED FE0F","char":"⏭️","name":"next track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23ED","char":"⏭","name":"next track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EF FE0F","char":"⏯️","name":"play or pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EF","char":"⏯","name":"play or pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25C0 FE0F","char":"◀️","name":"reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25C0","char":"◀","name":"reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EA","char":"⏪","name":"fast reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EE FE0F","char":"⏮️","name":"last track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EE","char":"⏮","name":"last track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F53C","char":"🔼","name":"upwards button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EB","char":"⏫","name":"fast up button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F53D","char":"🔽","name":"downwards button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EC","char":"⏬","name":"fast down button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F8 FE0F","char":"⏸️","name":"pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F8","char":"⏸","name":"pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F9 FE0F","char":"⏹️","name":"stop button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F9","char":"⏹","name":"stop button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23FA FE0F","char":"⏺️","name":"record button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23FA","char":"⏺","name":"record button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23CF FE0F","char":"⏏️","name":"eject button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23CF","char":"⏏","name":"eject button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F3A6","char":"🎦","name":"cinema","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F505","char":"🔅","name":"dim button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F506","char":"🔆","name":"bright button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F6","char":"📶","name":"antenna bars","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F6DC","char":"🛜","name":"wireless","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F3","char":"📳","name":"vibration mode","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F4","char":"📴","name":"mobile phone off","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"2640 FE0F","char":"♀️","name":"female sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2640","char":"♀","name":"female sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2642 FE0F","char":"♂️","name":"male sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2642","char":"♂","name":"male sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"26A7 FE0F","char":"⚧️","name":"transgender symbol","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"26A7","char":"⚧","name":"transgender symbol","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2716 FE0F","char":"✖️","name":"multiply","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2716","char":"✖","name":"multiply","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2795","char":"➕","name":"plus","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2796","char":"➖","name":"minus","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2797","char":"➗","name":"divide","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"1F7F0","char":"🟰","name":"heavy equals sign","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"267E FE0F","char":"♾️","name":"infinity","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"267E","char":"♾","name":"infinity","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"203C FE0F","char":"‼️","name":"double exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"203C","char":"‼","name":"double exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2049 FE0F","char":"⁉️","name":"exclamation question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2049","char":"⁉","name":"exclamation question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2753","char":"❓","name":"red question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2754","char":"❔","name":"white question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2755","char":"❕","name":"white exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2757","char":"❗","name":"red exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"3030 FE0F","char":"〰️","name":"wavy dash","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"3030","char":"〰","name":"wavy dash","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"1F4B1","char":"💱","name":"currency exchange","category":"Symbols (currency)","group":"Symbols","subgroup":"currency"},{"codes":"1F4B2","char":"💲","name":"heavy dollar sign","category":"Symbols (currency)","group":"Symbols","subgroup":"currency"},{"codes":"2695 FE0F","char":"⚕️","name":"medical symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2695","char":"⚕","name":"medical symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"267B FE0F","char":"♻️","name":"recycling symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"267B","char":"♻","name":"recycling symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"269C FE0F","char":"⚜️","name":"fleur-de-lis","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"269C","char":"⚜","name":"fleur-de-lis","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F531","char":"🔱","name":"trident emblem","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F4DB","char":"📛","name":"name badge","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F530","char":"🔰","name":"Japanese symbol for beginner","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2B55","char":"⭕","name":"hollow red circle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2705","char":"✅","name":"check mark button","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2611 FE0F","char":"☑️","name":"check box with check","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2611","char":"☑","name":"check box with check","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2714 FE0F","char":"✔️","name":"check mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2714","char":"✔","name":"check mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"274C","char":"❌","name":"cross mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"274E","char":"❎","name":"cross mark button","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"27B0","char":"➰","name":"curly loop","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"27BF","char":"➿","name":"double curly loop","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"303D FE0F","char":"〽️","name":"part alternation mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"303D","char":"〽","name":"part alternation mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2733 FE0F","char":"✳️","name":"eight-spoked asterisk","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2733","char":"✳","name":"eight-spoked asterisk","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2734 FE0F","char":"✴️","name":"eight-pointed star","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2734","char":"✴","name":"eight-pointed star","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2747 FE0F","char":"❇️","name":"sparkle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2747","char":"❇","name":"sparkle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00A9 FE0F","char":"©️","name":"copyright","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00A9","char":"©","name":"copyright","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00AE FE0F","char":"®️","name":"registered","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00AE","char":"®","name":"registered","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2122 FE0F","char":"™️","name":"trade mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2122","char":"™","name":"trade mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"0023 FE0F 20E3","char":"#️⃣","name":"keycap: #","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0023 20E3","char":"#⃣","name":"keycap: #","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"002A FE0F 20E3","char":"*️⃣","name":"keycap: *","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"002A 20E3","char":"*⃣","name":"keycap: *","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0030 FE0F 20E3","char":"0️⃣","name":"keycap: 0","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0030 20E3","char":"0⃣","name":"keycap: 0","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0031 FE0F 20E3","char":"1️⃣","name":"keycap: 1","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0031 20E3","char":"1⃣","name":"keycap: 1","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0032 FE0F 20E3","char":"2️⃣","name":"keycap: 2","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0032 20E3","char":"2⃣","name":"keycap: 2","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0033 FE0F 20E3","char":"3️⃣","name":"keycap: 3","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0033 20E3","char":"3⃣","name":"keycap: 3","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0034 FE0F 20E3","char":"4️⃣","name":"keycap: 4","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0034 20E3","char":"4⃣","name":"keycap: 4","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0035 FE0F 20E3","char":"5️⃣","name":"keycap: 5","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0035 20E3","char":"5⃣","name":"keycap: 5","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0036 FE0F 20E3","char":"6️⃣","name":"keycap: 6","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0036 20E3","char":"6⃣","name":"keycap: 6","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0037 FE0F 20E3","char":"7️⃣","name":"keycap: 7","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0037 20E3","char":"7⃣","name":"keycap: 7","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0038 FE0F 20E3","char":"8️⃣","name":"keycap: 8","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0038 20E3","char":"8⃣","name":"keycap: 8","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0039 FE0F 20E3","char":"9️⃣","name":"keycap: 9","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0039 20E3","char":"9⃣","name":"keycap: 9","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"1F51F","char":"🔟","name":"keycap: 10","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"1F520","char":"🔠","name":"input latin uppercase","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F521","char":"🔡","name":"input latin lowercase","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F522","char":"🔢","name":"input numbers","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F523","char":"🔣","name":"input symbols","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F524","char":"🔤","name":"input latin letters","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F170 FE0F","char":"🅰️","name":"A button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F170","char":"🅰","name":"A button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F18E","char":"🆎","name":"AB button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F171 FE0F","char":"🅱️","name":"B button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F171","char":"🅱","name":"B button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F191","char":"🆑","name":"CL button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F192","char":"🆒","name":"COOL button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F193","char":"🆓","name":"FREE button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"2139 FE0F","char":"ℹ️","name":"information","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"2139","char":"ℹ","name":"information","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F194","char":"🆔","name":"ID button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"24C2 FE0F","char":"Ⓜ️","name":"circled M","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"24C2","char":"Ⓜ","name":"circled M","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F195","char":"🆕","name":"NEW button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F196","char":"🆖","name":"NG button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17E FE0F","char":"🅾️","name":"O button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17E","char":"🅾","name":"O button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F197","char":"🆗","name":"OK button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17F FE0F","char":"🅿️","name":"P button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17F","char":"🅿","name":"P button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F198","char":"🆘","name":"SOS button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F199","char":"🆙","name":"UP! button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F19A","char":"🆚","name":"VS button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F201","char":"🈁","name":"Japanese “here” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F202 FE0F","char":"🈂️","name":"Japanese “service charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F202","char":"🈂","name":"Japanese “service charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F237 FE0F","char":"🈷️","name":"Japanese “monthly amount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F237","char":"🈷","name":"Japanese “monthly amount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F236","char":"🈶","name":"Japanese “not free of charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F22F","char":"🈯","name":"Japanese “reserved” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F250","char":"🉐","name":"Japanese “bargain” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F239","char":"🈹","name":"Japanese “discount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F21A","char":"🈚","name":"Japanese “free of charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F232","char":"🈲","name":"Japanese “prohibited” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F251","char":"🉑","name":"Japanese “acceptable” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F238","char":"🈸","name":"Japanese “application” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F234","char":"🈴","name":"Japanese “passing grade” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F233","char":"🈳","name":"Japanese “vacancy” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3297 FE0F","char":"㊗️","name":"Japanese “congratulations” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3297","char":"㊗","name":"Japanese “congratulations” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3299 FE0F","char":"㊙️","name":"Japanese “secret” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3299","char":"㊙","name":"Japanese “secret” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F23A","char":"🈺","name":"Japanese “open for business” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F235","char":"🈵","name":"Japanese “no vacancy” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F534","char":"🔴","name":"red circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E0","char":"🟠","name":"orange circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E1","char":"🟡","name":"yellow circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E2","char":"🟢","name":"green circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F535","char":"🔵","name":"blue circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E3","char":"🟣","name":"purple circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E4","char":"🟤","name":"brown circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"26AB","char":"⚫","name":"black circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"26AA","char":"⚪","name":"white circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E5","char":"🟥","name":"red square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E7","char":"🟧","name":"orange square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E8","char":"🟨","name":"yellow square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E9","char":"🟩","name":"green square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E6","char":"🟦","name":"blue square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7EA","char":"🟪","name":"purple square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7EB","char":"🟫","name":"brown square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"2B1B","char":"⬛","name":"black large square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"2B1C","char":"⬜","name":"white large square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FC FE0F","char":"◼️","name":"black medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FC","char":"◼","name":"black medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FB FE0F","char":"◻️","name":"white medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FB","char":"◻","name":"white medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FE","char":"◾","name":"black medium-small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FD","char":"◽","name":"white medium-small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AA FE0F","char":"▪️","name":"black small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AA","char":"▪","name":"black small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AB FE0F","char":"▫️","name":"white small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AB","char":"▫","name":"white small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F536","char":"🔶","name":"large orange diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F537","char":"🔷","name":"large blue diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F538","char":"🔸","name":"small orange diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F539","char":"🔹","name":"small blue diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F53A","char":"🔺","name":"red triangle pointed up","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F53B","char":"🔻","name":"red triangle pointed down","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F4A0","char":"💠","name":"diamond with a dot","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F518","char":"🔘","name":"radio button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F533","char":"🔳","name":"white square button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F532","char":"🔲","name":"black square button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F3C1","char":"🏁","name":"chequered flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F6A9","char":"🚩","name":"triangular flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F38C","char":"🎌","name":"crossed flags","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4","char":"🏴","name":"black flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F","char":"🏳️","name":"white flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3","char":"🏳","name":"white flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 1F308","char":"🏳️‍🌈","name":"rainbow flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 1F308","char":"🏳‍🌈","name":"rainbow flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 26A7 FE0F","char":"🏳️‍⚧️","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 26A7 FE0F","char":"🏳‍⚧️","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 26A7","char":"🏳️‍⚧","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 26A7","char":"🏳‍⚧","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4 200D 2620 FE0F","char":"🏴‍☠️","name":"pirate flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4 200D 2620","char":"🏴‍☠","name":"pirate flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F1E6 1F1E8","char":"🇦🇨","name":"flag: Ascension Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1E9","char":"🇦🇩","name":"flag: Andorra","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EA","char":"🇦🇪","name":"flag: United Arab Emirates","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EB","char":"🇦🇫","name":"flag: Afghanistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EC","char":"🇦🇬","name":"flag: Antigua & Barbuda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EE","char":"🇦🇮","name":"flag: Anguilla","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F1","char":"🇦🇱","name":"flag: Albania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F2","char":"🇦🇲","name":"flag: Armenia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F4","char":"🇦🇴","name":"flag: Angola","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F6","char":"🇦🇶","name":"flag: Antarctica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F7","char":"🇦🇷","name":"flag: Argentina","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F8","char":"🇦🇸","name":"flag: American Samoa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F9","char":"🇦🇹","name":"flag: Austria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FA","char":"🇦🇺","name":"flag: Australia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FC","char":"🇦🇼","name":"flag: Aruba","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FD","char":"🇦🇽","name":"flag: Åland Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FF","char":"🇦🇿","name":"flag: Azerbaijan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E6","char":"🇧🇦","name":"flag: Bosnia & Herzegovina","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E7","char":"🇧🇧","name":"flag: Barbados","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E9","char":"🇧🇩","name":"flag: Bangladesh","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EA","char":"🇧🇪","name":"flag: Belgium","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EB","char":"🇧🇫","name":"flag: Burkina Faso","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EC","char":"🇧🇬","name":"flag: Bulgaria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1ED","char":"🇧🇭","name":"flag: Bahrain","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EE","char":"🇧🇮","name":"flag: Burundi","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EF","char":"🇧🇯","name":"flag: Benin","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F1","char":"🇧🇱","name":"flag: St. Barthélemy","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F2","char":"🇧🇲","name":"flag: Bermuda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F3","char":"🇧🇳","name":"flag: Brunei","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F4","char":"🇧🇴","name":"flag: Bolivia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F6","char":"🇧🇶","name":"flag: Caribbean Netherlands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F7","char":"🇧🇷","name":"flag: Brazil","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F8","char":"🇧🇸","name":"flag: Bahamas","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F9","char":"🇧🇹","name":"flag: Bhutan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FB","char":"🇧🇻","name":"flag: Bouvet Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FC","char":"🇧🇼","name":"flag: Botswana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FE","char":"🇧🇾","name":"flag: Belarus","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FF","char":"🇧🇿","name":"flag: Belize","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E6","char":"🇨🇦","name":"flag: Canada","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E8","char":"🇨🇨","name":"flag: Cocos (Keeling) Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E9","char":"🇨🇩","name":"flag: Congo - Kinshasa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EB","char":"🇨🇫","name":"flag: Central African Republic","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EC","char":"🇨🇬","name":"flag: Congo - Brazzaville","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1ED","char":"🇨🇭","name":"flag: Switzerland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EE","char":"🇨🇮","name":"flag: Côte d’Ivoire","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F0","char":"🇨🇰","name":"flag: Cook Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F1","char":"🇨🇱","name":"flag: Chile","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F2","char":"🇨🇲","name":"flag: Cameroon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F3","char":"🇨🇳","name":"flag: China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F4","char":"🇨🇴","name":"flag: Colombia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F5","char":"🇨🇵","name":"flag: Clipperton Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F7","char":"🇨🇷","name":"flag: Costa Rica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FA","char":"🇨🇺","name":"flag: Cuba","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FB","char":"🇨🇻","name":"flag: Cape Verde","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FC","char":"🇨🇼","name":"flag: Curaçao","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FD","char":"🇨🇽","name":"flag: Christmas Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FE","char":"🇨🇾","name":"flag: Cyprus","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FF","char":"🇨🇿","name":"flag: Czechia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EA","char":"🇩🇪","name":"flag: Germany","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EC","char":"🇩🇬","name":"flag: Diego Garcia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EF","char":"🇩🇯","name":"flag: Djibouti","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F0","char":"🇩🇰","name":"flag: Denmark","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F2","char":"🇩🇲","name":"flag: Dominica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F4","char":"🇩🇴","name":"flag: Dominican Republic","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1FF","char":"🇩🇿","name":"flag: Algeria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1E6","char":"🇪🇦","name":"flag: Ceuta & Melilla","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1E8","char":"🇪🇨","name":"flag: Ecuador","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1EA","char":"🇪🇪","name":"flag: Estonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1EC","char":"🇪🇬","name":"flag: Egypt","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1ED","char":"🇪🇭","name":"flag: Western Sahara","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F7","char":"🇪🇷","name":"flag: Eritrea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F8","char":"🇪🇸","name":"flag: Spain","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F9","char":"🇪🇹","name":"flag: Ethiopia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1FA","char":"🇪🇺","name":"flag: European Union","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1EE","char":"🇫🇮","name":"flag: Finland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1EF","char":"🇫🇯","name":"flag: Fiji","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F0","char":"🇫🇰","name":"flag: Falkland Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F2","char":"🇫🇲","name":"flag: Micronesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F4","char":"🇫🇴","name":"flag: Faroe Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F7","char":"🇫🇷","name":"flag: France","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E6","char":"🇬🇦","name":"flag: Gabon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E7","char":"🇬🇧","name":"flag: United Kingdom","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E9","char":"🇬🇩","name":"flag: Grenada","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EA","char":"🇬🇪","name":"flag: Georgia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EB","char":"🇬🇫","name":"flag: French Guiana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EC","char":"🇬🇬","name":"flag: Guernsey","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1ED","char":"🇬🇭","name":"flag: Ghana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EE","char":"🇬🇮","name":"flag: Gibraltar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F1","char":"🇬🇱","name":"flag: Greenland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F2","char":"🇬🇲","name":"flag: Gambia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F3","char":"🇬🇳","name":"flag: Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F5","char":"🇬🇵","name":"flag: Guadeloupe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F6","char":"🇬🇶","name":"flag: Equatorial Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F7","char":"🇬🇷","name":"flag: Greece","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F8","char":"🇬🇸","name":"flag: South Georgia & South Sandwich Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F9","char":"🇬🇹","name":"flag: Guatemala","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FA","char":"🇬🇺","name":"flag: Guam","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FC","char":"🇬🇼","name":"flag: Guinea-Bissau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FE","char":"🇬🇾","name":"flag: Guyana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F0","char":"🇭🇰","name":"flag: Hong Kong SAR China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F2","char":"🇭🇲","name":"flag: Heard & McDonald Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F3","char":"🇭🇳","name":"flag: Honduras","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F7","char":"🇭🇷","name":"flag: Croatia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F9","char":"🇭🇹","name":"flag: Haiti","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1FA","char":"🇭🇺","name":"flag: Hungary","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1E8","char":"🇮🇨","name":"flag: Canary Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1E9","char":"🇮🇩","name":"flag: Indonesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1EA","char":"🇮🇪","name":"flag: Ireland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F1","char":"🇮🇱","name":"flag: Israel","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F2","char":"🇮🇲","name":"flag: Isle of Man","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F3","char":"🇮🇳","name":"flag: India","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F4","char":"🇮🇴","name":"flag: British Indian Ocean Territory","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F6","char":"🇮🇶","name":"flag: Iraq","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F7","char":"🇮🇷","name":"flag: Iran","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F8","char":"🇮🇸","name":"flag: Iceland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F9","char":"🇮🇹","name":"flag: Italy","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1EA","char":"🇯🇪","name":"flag: Jersey","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F2","char":"🇯🇲","name":"flag: Jamaica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F4","char":"🇯🇴","name":"flag: Jordan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F5","char":"🇯🇵","name":"flag: Japan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EA","char":"🇰🇪","name":"flag: Kenya","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EC","char":"🇰🇬","name":"flag: Kyrgyzstan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1ED","char":"🇰🇭","name":"flag: Cambodia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EE","char":"🇰🇮","name":"flag: Kiribati","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F2","char":"🇰🇲","name":"flag: Comoros","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F3","char":"🇰🇳","name":"flag: St. Kitts & Nevis","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F5","char":"🇰🇵","name":"flag: North Korea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F7","char":"🇰🇷","name":"flag: South Korea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FC","char":"🇰🇼","name":"flag: Kuwait","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FE","char":"🇰🇾","name":"flag: Cayman Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FF","char":"🇰🇿","name":"flag: Kazakhstan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E6","char":"🇱🇦","name":"flag: Laos","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E7","char":"🇱🇧","name":"flag: Lebanon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E8","char":"🇱🇨","name":"flag: St. Lucia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1EE","char":"🇱🇮","name":"flag: Liechtenstein","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F0","char":"🇱🇰","name":"flag: Sri Lanka","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F7","char":"🇱🇷","name":"flag: Liberia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F8","char":"🇱🇸","name":"flag: Lesotho","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F9","char":"🇱🇹","name":"flag: Lithuania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FA","char":"🇱🇺","name":"flag: Luxembourg","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FB","char":"🇱🇻","name":"flag: Latvia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FE","char":"🇱🇾","name":"flag: Libya","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E6","char":"🇲🇦","name":"flag: Morocco","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E8","char":"🇲🇨","name":"flag: Monaco","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E9","char":"🇲🇩","name":"flag: Moldova","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EA","char":"🇲🇪","name":"flag: Montenegro","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EB","char":"🇲🇫","name":"flag: St. Martin","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EC","char":"🇲🇬","name":"flag: Madagascar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1ED","char":"🇲🇭","name":"flag: Marshall Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F0","char":"🇲🇰","name":"flag: North Macedonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F1","char":"🇲🇱","name":"flag: Mali","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F2","char":"🇲🇲","name":"flag: Myanmar (Burma)","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F3","char":"🇲🇳","name":"flag: Mongolia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F4","char":"🇲🇴","name":"flag: Macao SAR China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F5","char":"🇲🇵","name":"flag: Northern Mariana Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F6","char":"🇲🇶","name":"flag: Martinique","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F7","char":"🇲🇷","name":"flag: Mauritania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F8","char":"🇲🇸","name":"flag: Montserrat","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F9","char":"🇲🇹","name":"flag: Malta","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FA","char":"🇲🇺","name":"flag: Mauritius","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FB","char":"🇲🇻","name":"flag: Maldives","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FC","char":"🇲🇼","name":"flag: Malawi","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FD","char":"🇲🇽","name":"flag: Mexico","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FE","char":"🇲🇾","name":"flag: Malaysia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FF","char":"🇲🇿","name":"flag: Mozambique","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1E6","char":"🇳🇦","name":"flag: Namibia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1E8","char":"🇳🇨","name":"flag: New Caledonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EA","char":"🇳🇪","name":"flag: Niger","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EB","char":"🇳🇫","name":"flag: Norfolk Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EC","char":"🇳🇬","name":"flag: Nigeria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EE","char":"🇳🇮","name":"flag: Nicaragua","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F1","char":"🇳🇱","name":"flag: Netherlands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F4","char":"🇳🇴","name":"flag: Norway","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F5","char":"🇳🇵","name":"flag: Nepal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F7","char":"🇳🇷","name":"flag: Nauru","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1FA","char":"🇳🇺","name":"flag: Niue","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1FF","char":"🇳🇿","name":"flag: New Zealand","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F4 1F1F2","char":"🇴🇲","name":"flag: Oman","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1E6","char":"🇵🇦","name":"flag: Panama","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EA","char":"🇵🇪","name":"flag: Peru","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EB","char":"🇵🇫","name":"flag: French Polynesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EC","char":"🇵🇬","name":"flag: Papua New Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1ED","char":"🇵🇭","name":"flag: Philippines","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F0","char":"🇵🇰","name":"flag: Pakistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F1","char":"🇵🇱","name":"flag: Poland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F2","char":"🇵🇲","name":"flag: St. Pierre & Miquelon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F3","char":"🇵🇳","name":"flag: Pitcairn Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F7","char":"🇵🇷","name":"flag: Puerto Rico","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F8","char":"🇵🇸","name":"flag: Palestinian Territories","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F9","char":"🇵🇹","name":"flag: Portugal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1FC","char":"🇵🇼","name":"flag: Palau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1FE","char":"🇵🇾","name":"flag: Paraguay","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F6 1F1E6","char":"🇶🇦","name":"flag: Qatar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1EA","char":"🇷🇪","name":"flag: Réunion","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1F4","char":"🇷🇴","name":"flag: Romania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1F8","char":"🇷🇸","name":"flag: Serbia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1FA","char":"🇷🇺","name":"flag: Russia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1FC","char":"🇷🇼","name":"flag: Rwanda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E6","char":"🇸🇦","name":"flag: Saudi Arabia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E7","char":"🇸🇧","name":"flag: Solomon Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E8","char":"🇸🇨","name":"flag: Seychelles","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E9","char":"🇸🇩","name":"flag: Sudan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EA","char":"🇸🇪","name":"flag: Sweden","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EC","char":"🇸🇬","name":"flag: Singapore","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1ED","char":"🇸🇭","name":"flag: St. Helena","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EE","char":"🇸🇮","name":"flag: Slovenia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EF","char":"🇸🇯","name":"flag: Svalbard & Jan Mayen","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F0","char":"🇸🇰","name":"flag: Slovakia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F1","char":"🇸🇱","name":"flag: Sierra Leone","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F2","char":"🇸🇲","name":"flag: San Marino","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F3","char":"🇸🇳","name":"flag: Senegal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F4","char":"🇸🇴","name":"flag: Somalia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F7","char":"🇸🇷","name":"flag: Suriname","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F8","char":"🇸🇸","name":"flag: South Sudan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F9","char":"🇸🇹","name":"flag: São Tomé & Príncipe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FB","char":"🇸🇻","name":"flag: El Salvador","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FD","char":"🇸🇽","name":"flag: Sint Maarten","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FE","char":"🇸🇾","name":"flag: Syria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FF","char":"🇸🇿","name":"flag: Eswatini","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E6","char":"🇹🇦","name":"flag: Tristan da Cunha","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E8","char":"🇹🇨","name":"flag: Turks & Caicos Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E9","char":"🇹🇩","name":"flag: Chad","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EB","char":"🇹🇫","name":"flag: French Southern Territories","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EC","char":"🇹🇬","name":"flag: Togo","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1ED","char":"🇹🇭","name":"flag: Thailand","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EF","char":"🇹🇯","name":"flag: Tajikistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F0","char":"🇹🇰","name":"flag: Tokelau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F1","char":"🇹🇱","name":"flag: Timor-Leste","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F2","char":"🇹🇲","name":"flag: Turkmenistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F3","char":"🇹🇳","name":"flag: Tunisia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F4","char":"🇹🇴","name":"flag: Tonga","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F7","char":"🇹🇷","name":"flag: Türkiye","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F9","char":"🇹🇹","name":"flag: Trinidad & Tobago","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FB","char":"🇹🇻","name":"flag: Tuvalu","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FC","char":"🇹🇼","name":"flag: Taiwan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FF","char":"🇹🇿","name":"flag: Tanzania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1E6","char":"🇺🇦","name":"flag: Ukraine","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1EC","char":"🇺🇬","name":"flag: Uganda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F2","char":"🇺🇲","name":"flag: U.S. Outlying Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F3","char":"🇺🇳","name":"flag: United Nations","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F8","char":"🇺🇸","name":"flag: United States","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1FE","char":"🇺🇾","name":"flag: Uruguay","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1FF","char":"🇺🇿","name":"flag: Uzbekistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1E6","char":"🇻🇦","name":"flag: Vatican City","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1E8","char":"🇻🇨","name":"flag: St. Vincent & Grenadines","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EA","char":"🇻🇪","name":"flag: Venezuela","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EC","char":"🇻🇬","name":"flag: British Virgin Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EE","char":"🇻🇮","name":"flag: U.S. Virgin Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1F3","char":"🇻🇳","name":"flag: Vietnam","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1FA","char":"🇻🇺","name":"flag: Vanuatu","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FC 1F1EB","char":"🇼🇫","name":"flag: Wallis & Futuna","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FC 1F1F8","char":"🇼🇸","name":"flag: Samoa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FD 1F1F0","char":"🇽🇰","name":"flag: Kosovo","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FE 1F1EA","char":"🇾🇪","name":"flag: Yemen","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FE 1F1F9","char":"🇾🇹","name":"flag: Mayotte","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1E6","char":"🇿🇦","name":"flag: South Africa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1F2","char":"🇿🇲","name":"flag: Zambia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1FC","char":"🇿🇼","name":"flag: Zimbabwe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F3F4 E0067 E0062 E0065 E006E E0067 E007F","char":"🏴󠁧󠁢󠁥󠁮󠁧󠁿","name":"flag: England","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"},{"codes":"1F3F4 E0067 E0062 E0073 E0063 E0074 E007F","char":"🏴󠁧󠁢󠁳󠁣󠁴󠁿","name":"flag: Scotland","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"},{"codes":"1F3F4 E0067 E0062 E0077 E006C E0073 E007F","char":"🏴󠁧󠁢󠁷󠁬󠁳󠁿","name":"flag: Wales","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"}]'), mS = { class: "-m-base" }, yS = { class: "max-h-72 overflow-y-auto divide-y divide-default-300 pb-base" }, fS = { class: "sticky top-0 bg-white p-base" }, hS = { class: "px-2 grid grid-cols-6 gap-1" }, FS = {
  key: 1,
  class: "pt-base px-base text-sm text-center"
}, Oz = /* @__PURE__ */ W({
  __name: "EmojiPicker",
  props: {
    disabled: { type: Boolean },
    placement: { default: void 0 }
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = e, t = ie(""), n = ae(() => {
      const a = t.value.length > 2 ? Yg.filter((s) => s.name.includes(t.value)) : Yg;
      return L1(a, (s) => s.category.replace(/\s*\(.*?\)/, ""));
    });
    return (a, s) => (w(), L(uh, {
      size: "xs",
      disabled: a.disabled,
      placement: a.placement
    }, {
      trigger: M(() => [
        H(P(tr), {
          as: Po,
          icon: P(W0),
          color: "tertiary",
          size: "sm",
          "aria-label": "Open emoji picker",
          disabled: a.disabled
        }, null, 8, ["icon", "disabled"])
      ]),
      default: M(() => [
        A("div", mS, [
          H(mu, { class: "p-base" }, {
            default: M(() => [
              H(No, { class: "sr-only" }, {
                default: M(() => s[1] || (s[1] = [
                  se(" Search ")
                ])),
                _: 1
              }),
              H(ba, {
                modelValue: t.value,
                "onUpdate:modelValue": s[0] || (s[0] = (i) => t.value = i),
                placeholder: "Search",
                "leading-icon": P(Sk),
                type: "search"
              }, null, 8, ["modelValue", "leading-icon"])
            ]),
            _: 1
          }),
          H(ch),
          A("div", yS, [
            Object.values(n.value).length ? (w(!0), j(ye, { key: 0 }, je(n.value, (i, l) => (w(), j("div", { key: l }, [
              A("div", fS, [
                H(No, { as: "span" }, {
                  default: M(() => [
                    se(_(l), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              A("div", hS, [
                (w(!0), j(ye, null, je(i, (c) => (w(), L(P(tr), {
                  key: c.name,
                  class: Z([
                    "border-transparent bg-transparent text-default-900 px-2.5 py-2 inline-flex justify-center items-center font-medium border border-px rounded-md",
                    "hover:bg-default-50",
                    "active:bg-white",
                    "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-default-200 focus-visible:outline-primary-900"
                  ]),
                  "aria-label": c.name,
                  onClick: (u) => r("change", c.char)
                }, {
                  default: M(() => [
                    A("span", null, _(c.char), 1)
                  ]),
                  _: 2
                }, 1032, ["aria-label", "onClick"]))), 128))
              ])
            ]))), 128)) : (w(), j("div", FS, s[2] || (s[2] = [
              A("p", null, "No emojis found.", -1)
            ])))
          ])
        ])
      ]),
      _: 1
    }, 8, ["disabled", "placement"]));
  }
}), Tz = /* @__PURE__ */ W({
  __name: "ErrorMessage",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = pe("field-id", "");
    return (r, t) => (w(), L(Fe(r.as), {
      id: P(e) ? `${P(e)}-error` : void 0,
      class: "text-sm text-red-600"
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), jz = /* @__PURE__ */ W({
  __name: "ExpandingButton",
  props: {
    as: { default: void 0 },
    ariaLabel: {},
    label: {},
    labelPosition: { default: "start" },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    icon: {},
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: "px-2.5 py-2 text-sm rounded hover:gap-x-1.5",
      base: "px-3.5 py-2.5 text-sm rounded-md hover:gap-x-2",
      lg: "px-4 py-3 text-base rounded-md hover:gap-x-2",
      xl: "px-7 py-4 text-lg rounded-md hover:gap-x-4"
    }, t = {
      primary: "shadow-sm border-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm border-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900 disabled:border-transparent",
      tertiary: "border-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm border-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm border-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm border-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = ae(() => r[e.size]), a = ae(() => t[e.color]), s = ae(() => e.disabled || e.loading);
    return (i, l) => (w(), L(Fe(i.as ?? (i.href ? P(Co) : "button")), {
      class: Z([
        "group relative inline-flex justify-center items-center font-medium text-nowrap border border-px",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        "hover:text-wrap",
        n.value,
        a.value,
        s.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400"
      ]),
      href: i.href,
      type: i.type,
      method: i.method,
      disabled: s.value,
      "aria-disabled": s.value,
      "aria-busy": i.loading,
      tabindex: s.value ? "-1" : 0,
      "aria-label": i.ariaLabel
    }, {
      default: M(() => [
        H(Jr, null, {
          default: M(() => [
            i.loading ? (w(), L(Yr, {
              key: 0,
              class: "size-4"
            })) : (w(), L(P(ce), {
              key: 1,
              icon: i.icon,
              "aria-hidden": "true",
              class: "size-4"
            }, null, 8, ["icon"])),
            A("span", {
              class: Z([
                "w-0 overflow-hidden opacity-50 transition-all duration-150 ease-in group-hover:w-auto group-hover:opacity-100",
                i.labelPosition === "start" && "order-first"
              ])
            }, _(i.label), 3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex", "aria-label"]));
  }
}), bS = ["aria-labelledby"], vS = /* @__PURE__ */ W({
  __name: "Fieldset",
  setup(o) {
    const e = Qo();
    return Be("fieldset-id", e), (r, t) => (w(), j("fieldset", { "aria-labelledby": P(e) }, [
      R(r.$slots, "default")
    ], 8, bS));
  }
}), Mz = /* @__PURE__ */ W({
  __name: "GridCheckboxGroup",
  setup(o) {
    const e = Qo();
    return Be("grid-checkbox-group-id", e), (r, t) => (w(), L(vS, {
      class: "[&:has([data-slot='legend']:not(.sr-only))_[data-slot='options']]:mt-8 [&:has([data-slot='description']:not(.sr-only))_[data-slot='options']]:mt-8",
      "aria-describedby": P(e)
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-describedby"]));
  }
}), zz = /* @__PURE__ */ W({
  __name: "GridCheckboxGroupDescription",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = pe("grid-checkbox-group-id");
    return (r, t) => (w(), L(Fe(r.as), {
      id: P(e),
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), PS = ["id"], BS = /* @__PURE__ */ W({
  __name: "Legend",
  setup(o) {
    const e = pe("fieldset-id");
    return (r, t) => (w(), j("div", {
      id: P(e),
      class: "text-sm font-medium text-default-900"
    }, [
      R(r.$slots, "default")
    ], 8, PS));
  }
}), Nz = /* @__PURE__ */ W({
  __name: "GridCheckboxGroupLegend",
  setup(o) {
    return (e, r) => (w(), L(BS, {
      class: "block text-sm font-medium text-default-900",
      "data-slot": "legend"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), kS = ["id", "disabled", "tabindex", "aria-disabled", "checked", "value"], wS = ["for"], DS = { class: "sr-only" }, SS = {
  key: 0,
  class: "absolute top-2 right-2 inline-flex items-center justify-center p-2 rounded-full bg-primary-500"
}, Iz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "GridCheckboxGroupOption",
  props: {
    by: {},
    label: {},
    disabled: { type: Boolean },
    modelValue: {},
    value: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = ae(() => r.by ? !!r.modelValue.find((i) => i[r.by] === r.value[r.by]) : r.modelValue.includes(r.value)), a = () => {
      const i = r.by ? r.modelValue.findIndex((c) => c[r.by] === r.value[r.by]) : r.modelValue.indexOf(r.value), { modelValue: l } = r;
      i === -1 ? l.push(r.value) : l.splice(i, 1), t("update:modelValue", l);
    }, s = Qo();
    return (i, l) => (w(), j("div", null, [
      A("input", {
        id: P(s),
        type: "checkbox",
        disabled: i.disabled,
        tabindex: i.disabled ? "-1" : 0,
        "aria-disabled": i.disabled,
        checked: n.value,
        class: Z([
          "sr-only",
          "[&:focus-visible+label]:ring-2 [&:focus-visible+label]:ring-primary-500"
        ]),
        value: i.value,
        onChange: a
      }, null, 40, kS),
      A("label", He({
        for: P(s),
        class: [
          "flex bg-white min-h-12 relative ring-2 ring-default-300 w-full shadow-md cursor-pointer outline-none rounded-md overflow-hidden",
          "hover:ring-primary-500",
          n.value && "ring-primary-500",
          i.disabled && "opacity-50 pointer-events-none"
        ]
      }, i.$attrs), [
        A("span", DS, _(i.label), 1),
        n.value ? (w(), j("span", SS, [
          H(P(ce), {
            icon: P(ya),
            class: "size-4 text-white",
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ])) : Q("", !0),
        R(i.$slots, "default", { checked: n.value })
      ], 16, wS)
    ]));
  }
}), ES = {}, xS = {
  class: "grid gap-base",
  "data-slot": "options"
};
function AS(o, e) {
  return w(), j("div", xS, [
    R(o.$slots, "default")
  ]);
}
const Rz = /* @__PURE__ */ le(ES, [["render", AS]]), Lz = /* @__PURE__ */ W({
  __name: "GridRadioGroup",
  props: {
    by: { type: [String, Function] }
  },
  setup(o) {
    return (e, r) => (w(), L(P(Ms), {
      by: e.by,
      class: "[&:has([data-slot='label']:not(.sr-only))_[data-slot='options']]:mt-8 [&:has([data-slot='description']:not(.sr-only))_[data-slot='options']]:mt-8"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["by"]));
  }
}), Hz = /* @__PURE__ */ W({
  __name: "GridRadioGroupDescription",
  setup(o) {
    return (e, r) => (w(), L(P(Ec), {
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Wz = /* @__PURE__ */ W({
  __name: "GridRadioGroupLabel",
  setup(o) {
    return (e, r) => (w(), L(P(pa), {
      as: No,
      "data-slot": "label"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), CS = {
  key: 0,
  class: "absolute top-2 right-2 inline-flex items-center justify-center p-2 rounded-full bg-primary-500"
}, Vz = /* @__PURE__ */ W({
  __name: "GridRadioGroupOption",
  setup(o) {
    return (e, r) => (w(), L(P(zs), { as: "template" }, {
      default: M(({ checked: t, disabled: n }) => [
        A("button", {
          class: Z([
            "bg-white min-h-12 relative ring-2 ring-default-300 w-full shadow-md cursor-pointer outline-none rounded-md overflow-hidden",
            "hover:ring-primary-500",
            "focus-visible:ring-2 focus-visible:ring-primary-500",
            t && "ring-primary-500",
            n && "opacity-50 pointer-events-none"
          ]),
          type: "button"
        }, [
          t ? (w(), j("span", CS, [
            H(P(ce), {
              icon: P(ya),
              class: "size-4 text-white",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ])) : Q("", !0),
          R(e.$slots, "default", { checked: t })
        ], 2)
      ]),
      _: 3
    }));
  }
}), OS = {}, TS = {
  class: "grid gap-base",
  "data-slot": "options"
};
function jS(o, e) {
  return w(), j("div", TS, [
    R(o.$slots, "default")
  ]);
}
const Gz = /* @__PURE__ */ le(OS, [["render", jS]]), MS = { class: "flex rounded-md border border-blue-400 bg-blue-50 p-4 text-sm text-blue-800" }, zS = /* @__PURE__ */ W({
  __name: "InfoBox",
  setup(o) {
    return (e, r) => (w(), j("div", MS, [
      H(P(ce), {
        icon: P(qk),
        class: "mr-3 mt-1 text-lg",
        "aria-hidden": "true"
      }, null, 8, ["icon"]),
      A("div", null, [
        R(e.$slots, "default")
      ])
    ]));
  }
}), Zz = /* @__PURE__ */ W({
  __name: "InfoBoxTextLink",
  props: {
    as: { default: Co }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), {
      class: Z([
        "text-blue-800 underline underline-offset-2",
        "hover:text-blue-900"
      ])
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), NS = { class: "relative" }, IS = ["id"], RS = {
  key: 0,
  role: "listbox"
}, LS = ["onClick"], HS = { class: "block truncate" }, Xz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "InputAddressSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    leadingIcon: {},
    modelValue: {},
    initialSearchQuery: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = Qo(), n = e, { searchClient: a } = xc(r.config.hostUrl, r.config.apiKey), s = ie(r.initialSearchQuery ?? ""), [i, l] = Uo(!!r.initialSearchQuery), c = ie();
    Oc(c, () => l(!1));
    const u = nn((g, p) => {
      l(!0), s.value = p, g(p);
    }, 300), m = nn((g) => {
      g();
    }, 500), y = (g) => {
      n("update:modelValue", g.barcode), s.value = g.single_line_address, l(!1);
    };
    return (g, p) => (w(), j("div", NS, [
      H(P(uu), {
        "search-client": P(a),
        "index-name": "addresses:building_number:asc",
        "initial-ui-state": { "addresses:building_number:asc": { query: g.initialSearchQuery } },
        future: { preserveSharedStateOnUnmount: !0 }
      }, {
        default: M(() => [
          H(P(Xs), null, {
            default: M(({ refine: d }) => [
              H(ba, He({
                "model-value": s.value,
                type: "search",
                "leading-icon": g.leadingIcon,
                "aria-controls": P(t),
                "aria-expanded": P(i),
                autocomplete: "off"
              }, g.$attrs, {
                "onUpdate:modelValue": (h) => P(u)(d, h)
              }), null, 16, ["model-value", "leading-icon", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          H(P(pu), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: M(({ items: d, refineNext: h, isLastPage: f }) => [
              H(Ro, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: M(() => [
                  P(i) ? yo((w(), j("div", {
                    key: 0,
                    id: P(t),
                    ref_key: "dropdown",
                    ref: c,
                    class: Z([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    d.length ? (w(), j("ul", RS, [
                      (w(!0), j(ye, null, je(d, (F) => (w(), j("li", {
                        key: F.id,
                        class: Z([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none"
                        ]),
                        role: "option",
                        onClick: (b) => y(F)
                      }, [
                        A("span", HS, [
                          H(P(Gs), {
                            hit: F,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ])
                      ], 8, LS))), 128))
                    ])) : Q("", !0)
                  ], 8, IS)), [
                    [P(Ns), [() => P(m)(h), { distance: 10, canLoadMore: () => !f }]]
                  ]) : Q("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["search-client", "initial-ui-state"])
    ]));
  }
}), WS = { class: "flex shadow-sm rounded-md" }, VS = { class: "-mr-px flex-1" }, GS = ["id", "value"], qz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "InputCopyToClipboard",
  props: {
    value: {}
  },
  emits: ["copy"],
  setup(o, { emit: e }) {
    const r = o, t = e, { copy: n, copied: a } = Ym({
      legacy: !0,
      source: r.value.toString()
    });
    Ac(a, () => {
      t("copy");
    });
    const s = pe("field-id");
    return (i, l) => (w(), j("div", WS, [
      A("div", VS, [
        A("input", He({
          id: P(s),
          type: "url",
          readonly: "",
          class: [
            "text-base pointer-events-none block w-full rounded-l-md border-0 py-1.5 text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
            "placeholder:text-default-400",
            "sm:text-sm sm:leading-6",
            "focus:ring-0 focus:shadow-none focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
          ],
          value: i.value
        }, i.$attrs), null, 16, GS)
      ]),
      yo((w(), j("button", {
        "aria-label": "Copy to clipboard",
        type: "button",
        class: Z([
          "flex-none rounded-r-md bg-default-50 px-3 py-2 text-sm font-semibold text-default-900",
          "outline outline-1 -outline-offset-1 outline-default-300",
          "hover:bg-default-100",
          "focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
        ]),
        onClick: l[0] || (l[0] = (c) => P(n)(i.value))
      }, [
        P(a) ? (w(), L(P(ce), {
          key: 1,
          icon: P(Zf),
          class: "size-4 text-emerald-800",
          "aria-hidden": "true"
        }, null, 8, ["icon"])) : (w(), L(P(ce), {
          key: 0,
          icon: P(Xf),
          class: "size-4",
          "aria-hidden": "true"
        }, null, 8, ["icon"]))
      ])), [
        [P(ph), P(a) ? "Copied" : "Copy to clipboard"]
      ])
    ]));
  }
}), Uz = /* @__PURE__ */ W({
  __name: "InputFileButton",
  props: {
    options: {}
  },
  emits: ["cancel", "change"],
  setup(o, { emit: e }) {
    const r = o, t = e, { open: n, onChange: a } = Jm(r.options);
    return a((s) => {
      t("change", s);
    }), (s, i) => R(s.$slots, "default", { open: P(n) });
  }
}), ZS = ["disabled", "aria-disabled", "aria-labelledby", "tabindex"], XS = {
  key: 0,
  class: "flex items-center space-x-base relative"
}, qS = { class: "flex-1 text-left" }, US = { class: "text-sm text-default-500 pt-tiny" }, YS = {
  key: 1,
  class: "relative"
}, JS = { class: "block pt-sm" }, QS = { class: "text-sm text-default-500 pt-tiny" }, Yz = /* @__PURE__ */ W({
  __name: "InputFileDropZone",
  props: {
    accept: { default: void 0 },
    disabled: { type: Boolean },
    maxFileSize: {},
    multiple: { type: Boolean },
    variant: { default: "horizontal" }
  },
  emits: ["change", "error"],
  setup(o, { emit: e }) {
    const r = o, t = ie(), { isOverDropZone: n } = M1(t, {
      dataTypes: r.accept,
      multiple: r.multiple,
      onDrop(y) {
        !y || r.disabled || c(y);
      }
    }), { open: a, onChange: s } = Jm({
      accept: r.accept ? r.accept.join(", ") : "*",
      multiple: r.multiple
    });
    s((y) => {
      y && c(Array.from(y));
    });
    const i = e, l = ci.object({
      ...r.accept && {
        type: ci.string().refine((y) => {
          var g;
          return (g = r.accept) == null ? void 0 : g.includes(y);
        }, {
          message: `The file must have one of the following extensions: ${r.accept.join(", ")}.`
        })
      },
      size: ci.number().max(r.maxFileSize * 1024, {
        message: `The file must not be greater than ${r.maxFileSize} kilobytes.`
      })
    }), c = (y) => {
      const g = [];
      y.forEach((p) => {
        const d = l.safeParse(p);
        d.success ? g.push(p) : i("error", d.error.errors[0].message);
      }), g.length === y.length && i("change", y);
    }, u = () => {
      a();
    }, m = pe("field-id");
    return (y, g) => (w(), j("button", {
      ref_key: "dropZone",
      ref: t,
      type: "button",
      disabled: y.disabled,
      "aria-disabled": y.disabled,
      "aria-labelledby": P(m),
      tabindex: y.disabled ? "-1" : 0,
      class: Z([
        "w-full group text-center rounded-lg border border-dashed border-primary-600 relative p-base bg-primary-50",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        (P(n) || y.disabled) && "opacity-50",
        y.disabled ? "pointer-events-none" : "cursor-pointer"
      ]),
      onClick: u
    }, [
      y.variant === "horizontal" ? (w(), j("span", XS, [
        H(P(ce), {
          icon: P(Tg),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        A("span", qS, [
          A("span", {
            class: Z([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !y.disabled && "group-hover:text-primary-500"
            ])
          }, g[0] || (g[0] = [
            se(" Click to upload "),
            A("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2),
          A("span", US, " Max file size: " + _(y.maxFileSize / 1024) + "mb ", 1)
        ])
      ])) : Q("", !0),
      y.variant === "vertical" ? (w(), j("span", YS, [
        H(P(ce), {
          icon: P(Tg),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        A("span", JS, [
          A("span", {
            class: Z([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !y.disabled && "group-hover:text-primary-500"
            ])
          }, g[1] || (g[1] = [
            se(" Click to upload "),
            A("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2)
        ]),
        A("span", QS, " Max file size: " + _(y.maxFileSize / 1024) + "mb ", 1)
      ])) : Q("", !0)
    ], 10, ZS));
  }
}), KS = ["aria-disabled"], Jz = /* @__PURE__ */ W({
  __name: "InputGroup",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  setup(o) {
    return Be("disabled", o.disabled), (r, t) => (w(), j("div", {
      class: Z([
        "relative flex shadow-sm items-center rounded-md bg-white outline outline-1 -outline-offset-1 outline-default-300",
        "has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary-600",
        "[&>[data-slot=addon]:first-child]:pl-3",
        "[&>[data-slot=addon]:last-child]:pr-3",
        r.disabled && "opacity-50 pointer-events-none"
      ]),
      "aria-disabled": r.disabled
    }, [
      R(r.$slots, "default")
    ], 10, KS));
  }
}), _S = {}, $S = {
  "data-slot": "addon",
  class: /* @__PURE__ */ Z([
    "shrink-0 select-none text-base text-default-500",
    "sm:text-sm/6"
  ])
};
function e5(o, e) {
  return w(), j("div", $S, [
    R(o.$slots, "default")
  ]);
}
const Qz = /* @__PURE__ */ le(_S, [["render", e5]]), o5 = { class: "flex-1" }, r5 = {
  key: 0,
  class: "left-0 pl-3 pointer-events-none absolute inset-y-0 flex items-center"
}, t5 = ["id", "type", "disabled", "tabindex", "aria-disabled"], Kz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "InputGroupInput",
  props: /* @__PURE__ */ lr({
    leadingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = cr(o, "modelValue"), r = pe("field-id"), t = pe("disabled");
    return (n, a) => (w(), j("div", o5, [
      n.leadingIcon ? (w(), j("div", r5, [
        H(P(ce), {
          icon: n.leadingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : Q("", !0),
      yo(A("input", He({
        id: P(r),
        "onUpdate:modelValue": a[0] || (a[0] = (s) => e.value = s),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900",
          "placeholder:text-default-400",
          "focus:ring-0",
          "sm:text-sm sm:leading-6",
          n.leadingIcon && "pl-10"
        ],
        type: n.type,
        disabled: P(t),
        tabindex: P(t) ? "-1" : 0,
        "aria-disabled": P(t)
      }, n.$attrs), null, 16, t5), [
        [Im, e.value]
      ])
    ]));
  }
}), n5 = {
  class: /* @__PURE__ */ Z([
    "shrink-0",
    "focus-within:relative"
  ])
}, a5 = ["aria-label", "disabled", "tabindex"], _z = /* @__PURE__ */ W({
  __name: "InputGroupSelect",
  props: /* @__PURE__ */ lr({
    ariaLabel: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = cr(o, "modelValue"), r = pe("disabled");
    return (t, n) => (w(), j("div", n5, [
      yo(A("select", {
        "onUpdate:modelValue": n[0] || (n[0] = (a) => e.value = a),
        "aria-label": t.ariaLabel,
        class: Z([
          "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 text-base text-default-900",
          "sm:text-sm sm:leading-6",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "disabled:opacity-100"
        ]),
        disabled: P(r),
        tabindex: P(r) ? "-1" : 0
      }, [
        R(t.$slots, "default")
      ], 8, a5), [
        [Lm, e.value]
      ])
    ]));
  }
}), s5 = { class: "relative" }, i5 = ["id"], l5 = {
  key: 0,
  role: "listbox"
}, c5 = ["onClick"], u5 = { class: "block truncate" }, p5 = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-4 text-primary-600"
}, $z = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "InputMultiAddressSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    leadingIcon: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = Qo(), n = e, { searchClient: a } = xc(r.config.hostUrl, r.config.apiKey), s = ie(""), [i, l] = Uo(!1), c = ie();
    Oc(c, () => l(!1));
    const u = nn((g, p) => {
      l(!0), s.value = p, g(p);
    }, 300), m = nn((g) => {
      g();
    }, 500), y = (g) => {
      const p = [...r.modelValue], d = p.findIndex((h) => h.barcode === g.barcode);
      d === -1 ? p.push(g) : p.splice(d, 1), n("update:modelValue", p), s.value = "", l(!1);
    };
    return (g, p) => (w(), j("div", s5, [
      H(P(uu), {
        "search-client": P(a),
        "index-name": "addresses:building_number:asc",
        future: { preserveSharedStateOnUnmount: !0 }
      }, {
        default: M(() => [
          H(P(Xs), null, {
            default: M(({ refine: d }) => [
              H(ba, He({
                "model-value": s.value,
                type: "search",
                "leading-icon": g.leadingIcon,
                "aria-controls": P(t),
                "aria-expanded": P(i)
              }, g.$attrs, {
                "onUpdate:modelValue": (h) => P(u)(d, h)
              }), null, 16, ["model-value", "leading-icon", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          H(P(pu), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: M(({ items: d, refineNext: h, isLastPage: f }) => [
              H(Ro, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: M(() => [
                  P(i) ? yo((w(), j("div", {
                    key: 0,
                    id: P(t),
                    ref_key: "dropdown",
                    ref: c,
                    class: Z([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    d.length ? (w(), j("ul", l5, [
                      (w(!0), j(ye, null, je(d, (F) => (w(), j("li", {
                        key: F.id,
                        class: Z([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none",
                          g.modelValue.some((b) => b.barcode === F.barcode) ? "bg-primary-50" : ""
                        ]),
                        role: "option",
                        onClick: (b) => y(F)
                      }, [
                        A("span", u5, [
                          H(P(Gs), {
                            hit: F,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ]),
                        g.modelValue.some((b) => b.barcode === F.barcode) ? (w(), j("span", p5, [
                          H(P(ce), {
                            icon: P(ya),
                            class: "h-5 w-5"
                          }, null, 8, ["icon"])
                        ])) : Q("", !0)
                      ], 10, c5))), 128))
                    ])) : Q("", !0)
                  ], 8, i5)), [
                    [P(Ns), [() => P(m)(h), { distance: 10, canLoadMore: () => !f }]]
                  ]) : Q("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["search-client"])
    ]));
  }
}), d5 = ["id", "min", "max", "step", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], g5 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "InputRange",
  props: /* @__PURE__ */ lr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    min: {},
    max: {},
    step: { default: 1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = cr(o, "modelValue"), r = pe("field-id");
    return (t, n) => {
      var a;
      return w(), j("div", {
        class: Z([
          "inline-flex",
          t.disabled && "opacity-50 pointer-events-none"
        ])
      }, [
        yo(A("input", He({
          id: P(r),
          "onUpdate:modelValue": n[0] || (n[0] = (s) => e.value = s),
          type: "range",
          min: t.min,
          max: t.max,
          step: t.step,
          class: [
            "rounded-full bg-default-200 w-full appearance-none cursor-grab",
            "focus:outline-none focus:outline-primary-600 focus:outline-2 focus:outline-offset-2",
            "active:enabled:cursor-grabbing"
          ],
          style: {
            "--min": t.min,
            "--max": t.max,
            "--val": (a = e.value) == null ? void 0 : a.toString()
          },
          disabled: t.disabled,
          tabindex: t.disabled ? "-1" : 0,
          "aria-disabled": t.disabled,
          "aria-invalid": !!t.invalid,
          "aria-describedby": t.invalid ? `${P(r)}-error` : void 0
        }, t.$attrs), null, 16, d5), [
          [Dc, e.value]
        ])
      ], 2);
    };
  }
}), eN = /* @__PURE__ */ le(g5, [["__scopeId", "data-v-4f8f94c6"]]), m5 = {}, y5 = { class: "text-xs p-xxs border-default-200 bg-white border rounded" };
function f5(o, e) {
  return w(), j("span", y5, [
    R(o.$slots, "default")
  ]);
}
const oN = /* @__PURE__ */ le(m5, [["render", f5]]);
function Ue(o) {
  this.content = o;
}
Ue.prototype = {
  constructor: Ue,
  find: function(o) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === o) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(o) {
    var e = this.find(o);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(o, e, r) {
    var t = r && r != o ? this.remove(r) : this, n = t.find(o), a = t.content.slice();
    return n == -1 ? a.push(r || o, e) : (a[n + 1] = e, r && (a[n] = r)), new Ue(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(o) {
    var e = this.find(o);
    if (e == -1) return this;
    var r = this.content.slice();
    return r.splice(e, 2), new Ue(r);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(o, e) {
    return new Ue([o, e].concat(this.remove(o).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(o, e) {
    var r = this.remove(o).content.slice();
    return r.push(o, e), new Ue(r);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(o, e, r) {
    var t = this.remove(e), n = t.content.slice(), a = t.find(o);
    return n.splice(a == -1 ? n.length : a, 0, e, r), new Ue(n);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(o) {
    for (var e = 0; e < this.content.length; e += 2)
      o(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(o) {
    return o = Ue.from(o), o.size ? new Ue(o.content.concat(this.subtract(o).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(o) {
    return o = Ue.from(o), o.size ? new Ue(this.subtract(o).content.concat(o.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(o) {
    var e = this;
    o = Ue.from(o);
    for (var r = 0; r < o.content.length; r += 2)
      e = e.remove(o.content[r]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var o = {};
    return this.forEach(function(e, r) {
      o[e] = r;
    }), o;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Ue.from = function(o) {
  if (o instanceof Ue) return o;
  var e = [];
  if (o) for (var r in o) e.push(r, o[r]);
  return new Ue(e);
};
function dh(o, e, r) {
  for (let t = 0; ; t++) {
    if (t == o.childCount || t == e.childCount)
      return o.childCount == e.childCount ? null : r;
    let n = o.child(t), a = e.child(t);
    if (n == a) {
      r += n.nodeSize;
      continue;
    }
    if (!n.sameMarkup(a))
      return r;
    if (n.isText && n.text != a.text) {
      for (let s = 0; n.text[s] == a.text[s]; s++)
        r++;
      return r;
    }
    if (n.content.size || a.content.size) {
      let s = dh(n.content, a.content, r + 1);
      if (s != null)
        return s;
    }
    r += n.nodeSize;
  }
}
function gh(o, e, r, t) {
  for (let n = o.childCount, a = e.childCount; ; ) {
    if (n == 0 || a == 0)
      return n == a ? null : { a: r, b: t };
    let s = o.child(--n), i = e.child(--a), l = s.nodeSize;
    if (s == i) {
      r -= l, t -= l;
      continue;
    }
    if (!s.sameMarkup(i))
      return { a: r, b: t };
    if (s.isText && s.text != i.text) {
      let c = 0, u = Math.min(s.text.length, i.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == i.text[i.text.length - c - 1]; )
        c++, r--, t--;
      return { a: r, b: t };
    }
    if (s.content.size || i.content.size) {
      let c = gh(s.content, i.content, r - 1, t - 1);
      if (c)
        return c;
    }
    r -= l, t -= l;
  }
}
class oe {
  /**
  @internal
  */
  constructor(e, r) {
    if (this.content = e, this.size = r || 0, r == null)
      for (let t = 0; t < e.length; t++)
        this.size += e[t].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, r, t, n = 0, a) {
    for (let s = 0, i = 0; i < r; s++) {
      let l = this.content[s], c = i + l.nodeSize;
      if (c > e && t(l, n + i, a || null, s) !== !1 && l.content.size) {
        let u = i + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, r - u), t, n + u);
      }
      i = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, r, t, n) {
    let a = "", s = !0;
    return this.nodesBetween(e, r, (i, l) => {
      let c = i.isText ? i.text.slice(Math.max(e, l) - l, r - l) : i.isLeaf ? n ? typeof n == "function" ? n(i) : n : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && c || i.isTextblock) && t && (s ? s = !1 : a += t), a += c;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let r = this.lastChild, t = e.firstChild, n = this.content.slice(), a = 0;
    for (r.isText && r.sameMarkup(t) && (n[n.length - 1] = r.withText(r.text + t.text), a = 1); a < e.content.length; a++)
      n.push(e.content[a]);
    return new oe(n, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, r = this.size) {
    if (e == 0 && r == this.size)
      return this;
    let t = [], n = 0;
    if (r > e)
      for (let a = 0, s = 0; s < r; a++) {
        let i = this.content[a], l = s + i.nodeSize;
        l > e && ((s < e || l > r) && (i.isText ? i = i.cut(Math.max(0, e - s), Math.min(i.text.length, r - s)) : i = i.cut(Math.max(0, e - s - 1), Math.min(i.content.size, r - s - 1))), t.push(i), n += i.nodeSize), s = l;
      }
    return new oe(t, n);
  }
  /**
  @internal
  */
  cutByIndex(e, r) {
    return e == r ? oe.empty : e == 0 && r == this.content.length ? this : new oe(this.content.slice(e, r));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, r) {
    let t = this.content[e];
    if (t == r)
      return this;
    let n = this.content.slice(), a = this.size + r.nodeSize - t.nodeSize;
    return n[e] = r, new oe(n, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new oe([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new oe(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let r = 0; r < this.content.length; r++)
      if (!this.content[r].eq(e.content[r]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let r = this.content[e];
    if (!r)
      throw new RangeError("Index " + e + " out of range for " + this);
    return r;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let r = 0, t = 0; r < this.content.length; r++) {
      let n = this.content[r];
      e(n, t, r), t += n.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, r = 0) {
    return dh(this, e, r);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, r = this.size, t = e.size) {
    return gh(this, e, r, t);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, r = -1) {
    if (e == 0)
      return Ga(0, e);
    if (e == this.size)
      return Ga(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, n = 0; ; t++) {
      let a = this.child(t), s = n + a.nodeSize;
      if (s >= e)
        return s == e || r > 0 ? Ga(t + 1, s) : Ga(t, n);
      n = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return oe.empty;
    if (!Array.isArray(r))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new oe(r.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return oe.empty;
    let r, t = 0;
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      t += a.nodeSize, n && a.isText && e[n - 1].sameMarkup(a) ? (r || (r = e.slice(0, n)), r[r.length - 1] = a.withText(r[r.length - 1].text + a.text)) : r && r.push(a);
    }
    return new oe(r || e, t);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return oe.empty;
    if (e instanceof oe)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new oe([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
oe.empty = new oe([], 0);
const hl = { index: 0, offset: 0 };
function Ga(o, e) {
  return hl.index = o, hl.offset = e, hl;
}
function ws(o, e) {
  if (o === e)
    return !0;
  if (!(o && typeof o == "object") || !(e && typeof e == "object"))
    return !1;
  let r = Array.isArray(o);
  if (Array.isArray(e) != r)
    return !1;
  if (r) {
    if (o.length != e.length)
      return !1;
    for (let t = 0; t < o.length; t++)
      if (!ws(o[t], e[t]))
        return !1;
  } else {
    for (let t in o)
      if (!(t in e) || !ws(o[t], e[t]))
        return !1;
    for (let t in e)
      if (!(t in o))
        return !1;
  }
  return !0;
}
let Ie = class Fc {
  /**
  @internal
  */
  constructor(e, r) {
    this.type = e, this.attrs = r;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let r, t = !1;
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        r || (r = e.slice(0, n));
      else {
        if (a.type.excludes(this.type))
          return e;
        !t && a.type.rank > this.type.rank && (r || (r = e.slice(0, n)), r.push(this), t = !0), r && r.push(a);
      }
    }
    return r || (r = e.slice()), t || r.push(this), r;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return e.slice(0, r).concat(e.slice(r + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && ws(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let t = e.marks[r.type];
    if (!t)
      throw new RangeError(`There is no mark type ${r.type} in this schema`);
    let n = t.create(r.attrs);
    return t.checkAttrs(n.attrs), n;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, r) {
    if (e == r)
      return !0;
    if (e.length != r.length)
      return !1;
    for (let t = 0; t < e.length; t++)
      if (!e[t].eq(r[t]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Fc.none;
    if (e instanceof Fc)
      return [e];
    let r = e.slice();
    return r.sort((t, n) => t.type.rank - n.type.rank), r;
  }
};
Ie.none = [];
class Ds extends Error {
}
class de {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, r, t) {
    this.content = e, this.openStart = r, this.openEnd = t;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, r) {
    let t = yh(this.content, e + this.openStart, r);
    return t && new de(t, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, r) {
    return new de(mh(this.content, e + this.openStart, r + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return de.empty;
    let t = r.openStart || 0, n = r.openEnd || 0;
    if (typeof t != "number" || typeof n != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new de(oe.fromJSON(e, r.content), t, n);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, r = !0) {
    let t = 0, n = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (r || !a.type.spec.isolating); a = a.firstChild)
      t++;
    for (let a = e.lastChild; a && !a.isLeaf && (r || !a.type.spec.isolating); a = a.lastChild)
      n++;
    return new de(e, t, n);
  }
}
de.empty = new de(oe.empty, 0, 0);
function mh(o, e, r) {
  let { index: t, offset: n } = o.findIndex(e), a = o.maybeChild(t), { index: s, offset: i } = o.findIndex(r);
  if (n == e || a.isText) {
    if (i != r && !o.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return o.cut(0, e).append(o.cut(r));
  }
  if (t != s)
    throw new RangeError("Removing non-flat range");
  return o.replaceChild(t, a.copy(mh(a.content, e - n - 1, r - n - 1)));
}
function yh(o, e, r, t) {
  let { index: n, offset: a } = o.findIndex(e), s = o.maybeChild(n);
  if (a == e || s.isText)
    return o.cut(0, e).append(r).append(o.cut(e));
  let i = yh(s.content, e - a - 1, r);
  return i && o.replaceChild(n, s.copy(i));
}
function h5(o, e, r) {
  if (r.openStart > o.depth)
    throw new Ds("Inserted content deeper than insertion position");
  if (o.depth - r.openStart != e.depth - r.openEnd)
    throw new Ds("Inconsistent open depths");
  return fh(o, e, r, 0);
}
function fh(o, e, r, t) {
  let n = o.index(t), a = o.node(t);
  if (n == e.index(t) && t < o.depth - r.openStart) {
    let s = fh(o, e, r, t + 1);
    return a.copy(a.content.replaceChild(n, s));
  } else if (r.content.size)
    if (!r.openStart && !r.openEnd && o.depth == t && e.depth == t) {
      let s = o.parent, i = s.content;
      return Wr(s, i.cut(0, o.parentOffset).append(r.content).append(i.cut(e.parentOffset)));
    } else {
      let { start: s, end: i } = F5(r, o);
      return Wr(a, Fh(o, s, i, e, t));
    }
  else return Wr(a, Ss(o, e, t));
}
function hh(o, e) {
  if (!e.type.compatibleContent(o.type))
    throw new Ds("Cannot join " + e.type.name + " onto " + o.type.name);
}
function bc(o, e, r) {
  let t = o.node(r);
  return hh(t, e.node(r)), t;
}
function Hr(o, e) {
  let r = e.length - 1;
  r >= 0 && o.isText && o.sameMarkup(e[r]) ? e[r] = o.withText(e[r].text + o.text) : e.push(o);
}
function on(o, e, r, t) {
  let n = (e || o).node(r), a = 0, s = e ? e.index(r) : n.childCount;
  o && (a = o.index(r), o.depth > r ? a++ : o.textOffset && (Hr(o.nodeAfter, t), a++));
  for (let i = a; i < s; i++)
    Hr(n.child(i), t);
  e && e.depth == r && e.textOffset && Hr(e.nodeBefore, t);
}
function Wr(o, e) {
  return o.type.checkContent(e), o.copy(e);
}
function Fh(o, e, r, t, n) {
  let a = o.depth > n && bc(o, e, n + 1), s = t.depth > n && bc(r, t, n + 1), i = [];
  return on(null, o, n, i), a && s && e.index(n) == r.index(n) ? (hh(a, s), Hr(Wr(a, Fh(o, e, r, t, n + 1)), i)) : (a && Hr(Wr(a, Ss(o, e, n + 1)), i), on(e, r, n, i), s && Hr(Wr(s, Ss(r, t, n + 1)), i)), on(t, null, n, i), new oe(i);
}
function Ss(o, e, r) {
  let t = [];
  if (on(null, o, r, t), o.depth > r) {
    let n = bc(o, e, r + 1);
    Hr(Wr(n, Ss(o, e, r + 1)), t);
  }
  return on(e, null, r, t), new oe(t);
}
function F5(o, e) {
  let r = e.depth - o.openStart, n = e.node(r).copy(o.content);
  for (let a = r - 1; a >= 0; a--)
    n = e.node(a).copy(oe.from(n));
  return {
    start: n.resolveNoCache(o.openStart + r),
    end: n.resolveNoCache(n.content.size - o.openEnd - r)
  };
}
class ea {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.pos = e, this.path = r, this.parentOffset = t, this.depth = r.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, r = this.index(this.depth);
    if (r == e.childCount)
      return null;
    let t = this.pos - this.path[this.path.length - 1], n = e.child(r);
    return t ? e.child(r).cut(t) : n;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), r = this.pos - this.path[this.path.length - 1];
    return r ? this.parent.child(e).cut(0, r) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, r) {
    r = this.resolveDepth(r);
    let t = this.path[r * 3], n = r == 0 ? 0 : this.path[r * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      n += t.child(a).nodeSize;
    return n;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, r = this.index();
    if (e.content.size == 0)
      return Ie.none;
    if (this.textOffset)
      return e.child(r).marks;
    let t = e.maybeChild(r - 1), n = e.maybeChild(r);
    if (!t) {
      let i = t;
      t = n, n = i;
    }
    let a = t.marks;
    for (var s = 0; s < a.length; s++)
      a[s].type.spec.inclusive === !1 && (!n || !a[s].isInSet(n.marks)) && (a = a[s--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let r = this.parent.maybeChild(this.index());
    if (!r || !r.isInline)
      return null;
    let t = r.marks, n = e.parent.maybeChild(e.index());
    for (var a = 0; a < t.length; a++)
      t[a].type.spec.inclusive === !1 && (!n || !t[a].isInSet(n.marks)) && (t = t[a--].removeFromSet(t));
    return t;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let r = this.depth; r > 0; r--)
      if (this.start(r) <= e && this.end(r) >= e)
        return r;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, r) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let t = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); t >= 0; t--)
      if (e.pos <= this.end(t) && (!r || r(this.node(t))))
        return new Es(this, e, t);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let r = 1; r <= this.depth; r++)
      e += (e ? "/" : "") + this.node(r).type.name + "_" + this.index(r - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, r) {
    if (!(r >= 0 && r <= e.content.size))
      throw new RangeError("Position " + r + " out of range");
    let t = [], n = 0, a = r;
    for (let s = e; ; ) {
      let { index: i, offset: l } = s.content.findIndex(a), c = a - l;
      if (t.push(s, i, n + l), !c || (s = s.child(i), s.isText))
        break;
      a = c - 1, n += l + 1;
    }
    return new ea(r, t, a);
  }
  /**
  @internal
  */
  static resolveCached(e, r) {
    let t = Jg.get(e);
    if (t)
      for (let a = 0; a < t.elts.length; a++) {
        let s = t.elts[a];
        if (s.pos == r)
          return s;
      }
    else
      Jg.set(e, t = new b5());
    let n = t.elts[t.i] = ea.resolve(e, r);
    return t.i = (t.i + 1) % v5, n;
  }
}
class b5 {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const v5 = 12, Jg = /* @__PURE__ */ new WeakMap();
class Es {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, r, t) {
    this.$from = e, this.$to = r, this.depth = t;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const P5 = /* @__PURE__ */ Object.create(null);
let Vr = class vc {
  /**
  @internal
  */
  constructor(e, r, t, n = Ie.none) {
    this.type = e, this.attrs = r, this.marks = n, this.content = t || oe.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, r, t, n = 0) {
    this.content.nodesBetween(e, r, t, n, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, r, t, n) {
    return this.content.textBetween(e, r, t, n);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, r, t) {
    return this.type == e && ws(this.attrs, r || e.defaultAttrs || P5) && Ie.sameSet(this.marks, t || Ie.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new vc(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new vc(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, r = this.content.size) {
    return e == 0 && r == this.content.size ? this : this.copy(this.content.cut(e, r));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, r = this.content.size, t = !1) {
    if (e == r)
      return de.empty;
    let n = this.resolve(e), a = this.resolve(r), s = t ? 0 : n.sharedDepth(r), i = n.start(s), c = n.node(s).content.cut(n.pos - i, a.pos - i);
    return new de(c, n.depth - s, a.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, r, t) {
    return h5(this.resolve(e), this.resolve(r), t);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let r = this; ; ) {
      let { index: t, offset: n } = r.content.findIndex(e);
      if (r = r.maybeChild(t), !r)
        return null;
      if (n == e || r.isText)
        return r;
      e -= n + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: r, offset: t } = this.content.findIndex(e);
    return { node: this.content.maybeChild(r), index: r, offset: t };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: r, offset: t } = this.content.findIndex(e);
    if (t < e)
      return { node: this.content.child(r), index: r, offset: t };
    let n = this.content.child(r - 1);
    return { node: n, index: r - 1, offset: t - n.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return ea.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return ea.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, r, t) {
    let n = !1;
    return r > e && this.nodesBetween(e, r, (a) => (t.isInSet(a.marks) && (n = !0), !n)), n;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), bh(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let r = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!r)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return r;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, r, t = oe.empty, n = 0, a = t.childCount) {
    let s = this.contentMatchAt(e).matchFragment(t, n, a), i = s && s.matchFragment(this.content, r);
    if (!i || !i.validEnd)
      return !1;
    for (let l = n; l < a; l++)
      if (!this.type.allowsMarks(t.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, r, t, n) {
    if (n && !this.type.allowsMarks(n))
      return !1;
    let a = this.contentMatchAt(e).matchType(t), s = a && a.matchFragment(this.content, r);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Ie.none;
    for (let r = 0; r < this.marks.length; r++) {
      let t = this.marks[r];
      t.type.checkAttrs(t.attrs), e = t.addToSet(e);
    }
    if (!Ie.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((r) => r.type.name)}`);
    this.content.forEach((r) => r.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((r) => r.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Node.fromJSON");
    let t;
    if (r.marks) {
      if (!Array.isArray(r.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      t = r.marks.map(e.markFromJSON);
    }
    if (r.type == "text") {
      if (typeof r.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(r.text, t);
    }
    let n = oe.fromJSON(e, r.content), a = e.nodeType(r.type).create(r.attrs, n, t);
    return a.type.checkAttrs(a.attrs), a;
  }
};
Vr.prototype.text = void 0;
class xs extends Vr {
  /**
  @internal
  */
  constructor(e, r, t, n) {
    if (super(e, r, null, n), !t)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = t;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : bh(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, r) {
    return this.text.slice(e, r);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new xs(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new xs(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, r = this.text.length) {
    return e == 0 && r == this.text.length ? this : this.withText(this.text.slice(e, r));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function bh(o, e) {
  for (let r = o.length - 1; r >= 0; r--)
    e = o[r].type.name + "(" + e + ")";
  return e;
}
class qr {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, r) {
    let t = new B5(e, r);
    if (t.next == null)
      return qr.empty;
    let n = vh(t);
    t.next && t.err("Unexpected trailing text");
    let a = A5(x5(n));
    return C5(a, t), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let r = 0; r < this.next.length; r++)
      if (this.next[r].type == e)
        return this.next[r].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, r = 0, t = e.childCount) {
    let n = this;
    for (let a = r; n && a < t; a++)
      n = n.matchType(e.child(a).type);
    return n;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: r } = this.next[e];
      if (!(r.isText || r.hasRequiredAttrs()))
        return r;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let r = 0; r < this.next.length; r++)
      for (let t = 0; t < e.next.length; t++)
        if (this.next[r].type == e.next[t].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, r = !1, t = 0) {
    let n = [this];
    function a(s, i) {
      let l = s.matchFragment(e, t);
      if (l && (!r || l.validEnd))
        return oe.from(i.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: u, next: m } = s.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && n.indexOf(m) == -1) {
          n.push(m);
          let y = a(m, i.concat(u));
          if (y)
            return y;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let t = 0; t < this.wrapCache.length; t += 2)
      if (this.wrapCache[t] == e)
        return this.wrapCache[t + 1];
    let r = this.computeWrapping(e);
    return this.wrapCache.push(e, r), r;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let r = /* @__PURE__ */ Object.create(null), t = [{ match: this, type: null, via: null }];
    for (; t.length; ) {
      let n = t.shift(), a = n.match;
      if (a.matchType(e)) {
        let s = [];
        for (let i = n; i.type; i = i.via)
          s.push(i.type);
        return s.reverse();
      }
      for (let s = 0; s < a.next.length; s++) {
        let { type: i, next: l } = a.next[s];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in r) && (!n.type || l.validEnd) && (t.push({ match: i.contentMatch, type: i, via: n }), r[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function r(t) {
      e.push(t);
      for (let n = 0; n < t.next.length; n++)
        e.indexOf(t.next[n].next) == -1 && r(t.next[n].next);
    }
    return r(this), e.map((t, n) => {
      let a = n + (t.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < t.next.length; s++)
        a += (s ? ", " : "") + t.next[s].type.name + "->" + e.indexOf(t.next[s].next);
      return a;
    }).join(`
`);
  }
}
qr.empty = new qr(!0);
class B5 {
  constructor(e, r) {
    this.string = e, this.nodeTypes = r, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function vh(o) {
  let e = [];
  do
    e.push(k5(o));
  while (o.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function k5(o) {
  let e = [];
  do
    e.push(w5(o));
  while (o.next && o.next != ")" && o.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function w5(o) {
  let e = E5(o);
  for (; ; )
    if (o.eat("+"))
      e = { type: "plus", expr: e };
    else if (o.eat("*"))
      e = { type: "star", expr: e };
    else if (o.eat("?"))
      e = { type: "opt", expr: e };
    else if (o.eat("{"))
      e = D5(o, e);
    else
      break;
  return e;
}
function Qg(o) {
  /\D/.test(o.next) && o.err("Expected number, got '" + o.next + "'");
  let e = Number(o.next);
  return o.pos++, e;
}
function D5(o, e) {
  let r = Qg(o), t = r;
  return o.eat(",") && (o.next != "}" ? t = Qg(o) : t = -1), o.eat("}") || o.err("Unclosed braced range"), { type: "range", min: r, max: t, expr: e };
}
function S5(o, e) {
  let r = o.nodeTypes, t = r[e];
  if (t)
    return [t];
  let n = [];
  for (let a in r) {
    let s = r[a];
    s.isInGroup(e) && n.push(s);
  }
  return n.length == 0 && o.err("No node type or group '" + e + "' found"), n;
}
function E5(o) {
  if (o.eat("(")) {
    let e = vh(o);
    return o.eat(")") || o.err("Missing closing paren"), e;
  } else if (/\W/.test(o.next))
    o.err("Unexpected token '" + o.next + "'");
  else {
    let e = S5(o, o.next).map((r) => (o.inline == null ? o.inline = r.isInline : o.inline != r.isInline && o.err("Mixing inline and block content"), { type: "name", value: r }));
    return o.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function x5(o) {
  let e = [[]];
  return n(a(o, 0), r()), e;
  function r() {
    return e.push([]) - 1;
  }
  function t(s, i, l) {
    let c = { term: l, to: i };
    return e[s].push(c), c;
  }
  function n(s, i) {
    s.forEach((l) => l.to = i);
  }
  function a(s, i) {
    if (s.type == "choice")
      return s.exprs.reduce((l, c) => l.concat(a(c, i)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let c = a(s.exprs[l], i);
        if (l == s.exprs.length - 1)
          return c;
        n(c, i = r());
      }
    else if (s.type == "star") {
      let l = r();
      return t(i, l), n(a(s.expr, l), l), [t(l)];
    } else if (s.type == "plus") {
      let l = r();
      return n(a(s.expr, i), l), n(a(s.expr, l), l), [t(l)];
    } else {
      if (s.type == "opt")
        return [t(i)].concat(a(s.expr, i));
      if (s.type == "range") {
        let l = i;
        for (let c = 0; c < s.min; c++) {
          let u = r();
          n(a(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          n(a(s.expr, l), l);
        else
          for (let c = s.min; c < s.max; c++) {
            let u = r();
            t(l, u), n(a(s.expr, l), u), l = u;
          }
        return [t(l)];
      } else {
        if (s.type == "name")
          return [t(i, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Ph(o, e) {
  return e - o;
}
function Kg(o, e) {
  let r = [];
  return t(e), r.sort(Ph);
  function t(n) {
    let a = o[n];
    if (a.length == 1 && !a[0].term)
      return t(a[0].to);
    r.push(n);
    for (let s = 0; s < a.length; s++) {
      let { term: i, to: l } = a[s];
      !i && r.indexOf(l) == -1 && t(l);
    }
  }
}
function A5(o) {
  let e = /* @__PURE__ */ Object.create(null);
  return r(Kg(o, 0));
  function r(t) {
    let n = [];
    t.forEach((s) => {
      o[s].forEach(({ term: i, to: l }) => {
        if (!i)
          return;
        let c;
        for (let u = 0; u < n.length; u++)
          n[u][0] == i && (c = n[u][1]);
        Kg(o, l).forEach((u) => {
          c || n.push([i, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let a = e[t.join(",")] = new qr(t.indexOf(o.length - 1) > -1);
    for (let s = 0; s < n.length; s++) {
      let i = n[s][1].sort(Ph);
      a.next.push({ type: n[s][0], next: e[i.join(",")] || r(i) });
    }
    return a;
  }
}
function C5(o, e) {
  for (let r = 0, t = [o]; r < t.length; r++) {
    let n = t[r], a = !n.validEnd, s = [];
    for (let i = 0; i < n.next.length; i++) {
      let { type: l, next: c } = n.next[i];
      s.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), t.indexOf(c) == -1 && t.push(c);
    }
    a && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Bh(o) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let r in o) {
    let t = o[r];
    if (!t.hasDefault)
      return null;
    e[r] = t.default;
  }
  return e;
}
function kh(o, e) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let t in o) {
    let n = e && e[t];
    if (n === void 0) {
      let a = o[t];
      if (a.hasDefault)
        n = a.default;
      else
        throw new RangeError("No value supplied for attribute " + t);
    }
    r[t] = n;
  }
  return r;
}
function wh(o, e, r, t) {
  for (let n in e)
    if (!(n in o))
      throw new RangeError(`Unsupported attribute ${n} for ${r} of type ${n}`);
  for (let n in o) {
    let a = o[n];
    a.validate && a.validate(e[n]);
  }
}
function Dh(o, e) {
  let r = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let t in e)
      r[t] = new T5(o, t, e[t]);
  return r;
}
class As {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.name = e, this.schema = r, this.spec = t, this.markSet = null, this.groups = t.group ? t.group.split(" ") : [], this.attrs = Dh(e, t.attrs), this.defaultAttrs = Bh(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(t.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == qr.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : kh(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, r, t) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Vr(this, this.computeAttrs(e), oe.from(r), Ie.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, r, t) {
    return r = oe.from(r), this.checkContent(r), new Vr(this, this.computeAttrs(e), r, Ie.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, r, t) {
    if (e = this.computeAttrs(e), r = oe.from(r), r.size) {
      let s = this.contentMatch.fillBefore(r);
      if (!s)
        return null;
      r = s.append(r);
    }
    let n = this.contentMatch.matchFragment(r), a = n && n.fillBefore(oe.empty, !0);
    return a ? new Vr(this, e, r.append(a), Ie.setFrom(t)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let r = this.contentMatch.matchFragment(e);
    if (!r || !r.validEnd)
      return !1;
    for (let t = 0; t < e.childCount; t++)
      if (!this.allowsMarks(e.child(t).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    wh(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let r = 0; r < e.length; r++)
      if (!this.allowsMarkType(e[r].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let r;
    for (let t = 0; t < e.length; t++)
      this.allowsMarkType(e[t].type) ? r && r.push(e[t]) : r || (r = e.slice(0, t));
    return r ? r.length ? r : Ie.none : e;
  }
  /**
  @internal
  */
  static compile(e, r) {
    let t = /* @__PURE__ */ Object.create(null);
    e.forEach((a, s) => t[a] = new As(a, r, s));
    let n = r.spec.topNode || "doc";
    if (!t[n])
      throw new RangeError("Schema is missing its top node type ('" + n + "')");
    if (!t.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in t.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return t;
  }
}
function O5(o, e, r) {
  let t = r.split("|");
  return (n) => {
    let a = n === null ? "null" : typeof n;
    if (t.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${t} for attribute ${e} on type ${o}, got ${a}`);
  };
}
class T5 {
  constructor(e, r, t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default, this.validate = typeof t.validate == "string" ? O5(e, r, t.validate) : t.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class yu {
  /**
  @internal
  */
  constructor(e, r, t, n) {
    this.name = e, this.rank = r, this.schema = t, this.spec = n, this.attrs = Dh(e, n.attrs), this.excluded = null;
    let a = Bh(this.attrs);
    this.instance = a ? new Ie(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Ie(this, kh(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, r) {
    let t = /* @__PURE__ */ Object.create(null), n = 0;
    return e.forEach((a, s) => t[a] = new yu(a, n++, r, s)), t;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var r = 0; r < e.length; r++)
      e[r].type == this && (e = e.slice(0, r).concat(e.slice(r + 1)), r--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (e[r].type == this)
        return e[r];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    wh(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class j5 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let r = this.spec = {};
    for (let n in e)
      r[n] = e[n];
    r.nodes = Ue.from(e.nodes), r.marks = Ue.from(e.marks || {}), this.nodes = As.compile(this.spec.nodes, this), this.marks = yu.compile(this.spec.marks, this);
    let t = /* @__PURE__ */ Object.create(null);
    for (let n in this.nodes) {
      if (n in this.marks)
        throw new RangeError(n + " can not be both a node and a mark");
      let a = this.nodes[n], s = a.spec.content || "", i = a.spec.marks;
      if (a.contentMatch = t[s] || (t[s] = qr.parse(s, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = i == "_" ? null : i ? _g(this, i.split(" ")) : i == "" || !a.inlineContent ? [] : null;
    }
    for (let n in this.marks) {
      let a = this.marks[n], s = a.spec.excludes;
      a.excluded = s == null ? [a] : s == "" ? [] : _g(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, r = null, t, n) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof As) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(r, t, n);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, r) {
    let t = this.nodes.text;
    return new xs(t, t.defaultAttrs, e, Ie.setFrom(r));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, r) {
    return typeof e == "string" && (e = this.marks[e]), e.create(r);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return Vr.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return Ie.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let r = this.nodes[e];
    if (!r)
      throw new RangeError("Unknown node type: " + e);
    return r;
  }
}
function _g(o, e) {
  let r = [];
  for (let t = 0; t < e.length; t++) {
    let n = e[t], a = o.marks[n], s = a;
    if (a)
      r.push(a);
    else
      for (let i in o.marks) {
        let l = o.marks[i];
        (n == "_" || l.spec.group && l.spec.group.split(" ").indexOf(n) > -1) && r.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[t] + "'");
  }
  return r;
}
function M5(o) {
  return o.tag != null;
}
function z5(o) {
  return o.style != null;
}
class ht {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, r) {
    this.schema = e, this.rules = r, this.tags = [], this.styles = [];
    let t = this.matchedStyles = [];
    r.forEach((n) => {
      if (M5(n))
        this.tags.push(n);
      else if (z5(n)) {
        let a = /[^=]*/.exec(n.style)[0];
        t.indexOf(a) < 0 && t.push(a), this.styles.push(n);
      }
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let a = e.nodes[n.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, r = {}) {
    let t = new em(this, r, !1);
    return t.addAll(e, Ie.none, r.from, r.to), t.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, r = {}) {
    let t = new em(this, r, !0);
    return t.addAll(e, Ie.none, r.from, r.to), de.maxOpen(t.finish());
  }
  /**
  @internal
  */
  matchTag(e, r, t) {
    for (let n = t ? this.tags.indexOf(t) + 1 : 0; n < this.tags.length; n++) {
      let a = this.tags[n];
      if (R5(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || r.matchesContext(a.context))) {
        if (a.getAttrs) {
          let s = a.getAttrs(e);
          if (s === !1)
            continue;
          a.attrs = s || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, r, t, n) {
    for (let a = n ? this.styles.indexOf(n) + 1 : 0; a < this.styles.length; a++) {
      let s = this.styles[a], i = s.style;
      if (!(i.indexOf(e) != 0 || s.context && !t.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > e.length && (i.charCodeAt(e.length) != 61 || i.slice(e.length + 1) != r))) {
        if (s.getAttrs) {
          let l = s.getAttrs(r);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let r = [];
    function t(n) {
      let a = n.priority == null ? 50 : n.priority, s = 0;
      for (; s < r.length; s++) {
        let i = r[s];
        if ((i.priority == null ? 50 : i.priority) < a)
          break;
      }
      r.splice(s, 0, n);
    }
    for (let n in e.marks) {
      let a = e.marks[n].spec.parseDOM;
      a && a.forEach((s) => {
        t(s = om(s)), s.mark || s.ignore || s.clearMark || (s.mark = n);
      });
    }
    for (let n in e.nodes) {
      let a = e.nodes[n].spec.parseDOM;
      a && a.forEach((s) => {
        t(s = om(s)), s.node || s.ignore || s.mark || (s.node = n);
      });
    }
    return r;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new ht(e, ht.schemaRules(e)));
  }
}
const Sh = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, N5 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Eh = { ol: !0, ul: !0 }, oa = 1, Pc = 2, cs = 4;
function $g(o, e, r) {
  return e != null ? (e ? oa : 0) | (e === "full" ? Pc : 0) : o && o.whitespace == "pre" ? oa | Pc : r & -5;
}
class Za {
  constructor(e, r, t, n, a, s) {
    this.type = e, this.attrs = r, this.marks = t, this.solid = n, this.options = s, this.content = [], this.activeMarks = Ie.none, this.match = a || (s & cs ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let r = this.type.contentMatch.fillBefore(oe.from(e));
      if (r)
        this.match = this.type.contentMatch.matchFragment(r);
      else {
        let t = this.type.contentMatch, n;
        return (n = t.findWrapping(e.type)) ? (this.match = t, n) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & oa)) {
      let t = this.content[this.content.length - 1], n;
      if (t && t.isText && (n = /[ \t\r\n\u000c]+$/.exec(t.text))) {
        let a = t;
        t.text.length == n[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - n[0].length));
      }
    }
    let r = oe.from(this.content);
    return !e && this.match && (r = r.append(this.match.fillBefore(oe.empty, !0))), this.type ? this.type.create(this.attrs, r, this.marks) : r;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Sh.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class em {
  constructor(e, r, t) {
    this.parser = e, this.options = r, this.isOpen = t, this.open = 0, this.localPreserveWS = !1;
    let n = r.topNode, a, s = $g(null, r.preserveWhitespace, 0) | (t ? cs : 0);
    n ? a = new Za(n.type, n.attrs, Ie.none, !0, r.topMatch || n.type.contentMatch, s) : t ? a = new Za(null, null, Ie.none, !0, null, s) : a = new Za(e.schema.topNodeType, null, Ie.none, !0, null, s), this.nodes = [a], this.find = r.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, r) {
    e.nodeType == 3 ? this.addTextNode(e, r) : e.nodeType == 1 && this.addElement(e, r);
  }
  addTextNode(e, r) {
    let t = e.nodeValue, n = this.top, a = n.options & Pc ? "full" : this.localPreserveWS || (n.options & oa) > 0;
    if (a === "full" || n.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (a)
        a !== "full" ? t = t.replace(/\r?\n|\r/g, " ") : t = t.replace(/\r\n?/g, `
`);
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let s = n.content[n.content.length - 1], i = e.previousSibling;
        (!s || i && i.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t), r), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, r, t) {
    let n = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), i;
    Eh.hasOwnProperty(s) && this.parser.normalizeLists && I5(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, t));
    e: if (l ? l.ignore : N5.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, r);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (Sh.hasOwnProperty(s))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), c = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, r);
        break e;
      }
      let m = l && l.skip ? r : this.readStyles(e, r);
      m && this.addAll(e, m), c && this.sync(a), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, r);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = n;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, r) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), r);
  }
  // Called for ignored nodes
  ignoreFallback(e, r) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), r);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, r) {
    let t = e.style;
    if (t && t.length)
      for (let n = 0; n < this.parser.matchedStyles.length; n++) {
        let a = this.parser.matchedStyles[n], s = t.getPropertyValue(a);
        if (s)
          for (let i = void 0; ; ) {
            let l = this.parser.matchStyle(a, s, this, i);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? r = r.filter((c) => !l.clearMark(c)) : r = r.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              i = l;
            else
              break;
          }
      }
    return r;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, r, t, n) {
    let a, s;
    if (r.node)
      if (s = this.parser.schema.nodes[r.node], s.isLeaf)
        this.insertNode(s.create(r.attrs), t) || this.leafFallback(e, t);
      else {
        let l = this.enter(s, r.attrs || null, t, r.preserveWhitespace);
        l && (a = !0, t = l);
      }
    else {
      let l = this.parser.schema.marks[r.mark];
      t = t.concat(l.create(r.attrs));
    }
    let i = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (n)
      this.addElement(e, t, n);
    else if (r.getContent)
      this.findInside(e), r.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, t));
    else {
      let l = e;
      typeof r.contentElement == "string" ? l = e.querySelector(r.contentElement) : typeof r.contentElement == "function" ? l = r.contentElement(e) : r.contentElement && (l = r.contentElement), this.findAround(e, l, !0), this.addAll(l, t), this.findAround(e, l, !1);
    }
    a && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, r, t, n) {
    let a = t || 0;
    for (let s = t ? e.childNodes[t] : e.firstChild, i = n == null ? null : e.childNodes[n]; s != i; s = s.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(s, r);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, r) {
    let t, n;
    for (let a = this.open; a >= 0; a--) {
      let s = this.nodes[a], i = s.findWrapping(e);
      if (i && (!t || t.length > i.length) && (t = i, n = s, !i.length) || s.solid)
        break;
    }
    if (!t)
      return null;
    this.sync(n);
    for (let a = 0; a < t.length; a++)
      r = this.enterInner(t[a], null, r, !1);
    return r;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && (r = this.enterInner(n, null, r));
    }
    let t = this.findPlace(e, r);
    if (t) {
      this.closeExtra();
      let n = this.top;
      n.match && (n.match = n.match.matchType(e.type));
      let a = Ie.none;
      for (let s of t.concat(e.marks))
        (n.type ? n.type.allowsMarkType(s.type) : rm(s.type, e.type)) && (a = s.addToSet(a));
      return n.content.push(e.mark(a)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, r, t, n) {
    let a = this.findPlace(e.create(r), t);
    return a && (a = this.enterInner(e, r, t, !0, n)), a;
  }
  // Open a node of the given type
  enterInner(e, r, t, n = !1, a) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let i = $g(e, a, s.options);
    s.options & cs && s.content.length == 0 && (i |= cs);
    let l = Ie.none;
    return t = t.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : rm(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Za(e, r, l, n, null, i)), this.open++, t;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let r = this.nodes.length - 1;
    if (r > this.open) {
      for (; r > this.open; r--)
        this.nodes[r - 1].content.push(this.nodes[r].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let r = this.open; r >= 0; r--) {
      if (this.nodes[r] == e)
        return this.open = r, !0;
      this.localPreserveWS && (this.nodes[r].options |= oa);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let r = this.open; r >= 0; r--) {
      let t = this.nodes[r].content;
      for (let n = t.length - 1; n >= 0; n--)
        e += t[n].nodeSize;
      r && e++;
    }
    return e;
  }
  findAtPoint(e, r) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && this.find[t].offset == r && (this.find[t].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && (this.find[r].pos = this.currentPos);
  }
  findAround(e, r, t) {
    if (e != r && this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && r.compareDocumentPosition(this.find[n].node) & (t ? 2 : 4) && (this.find[n].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && (this.find[r].pos = this.currentPos - (e.nodeValue.length - this.find[r].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let r = e.split("/"), t = this.options.context, n = !this.isOpen && (!t || t.parent.type == this.nodes[0].type), a = -(t ? t.depth + 1 : 0) + (n ? 0 : 1), s = (i, l) => {
      for (; i >= 0; i--) {
        let c = r[i];
        if (c == "") {
          if (i == r.length - 1 || i == 0)
            continue;
          for (; l >= a; l--)
            if (s(i - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && n ? this.nodes[l].type : t && l >= a ? t.node(l - a).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(r.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let r = e.depth; r >= 0; r--) {
        let t = e.node(r).contentMatchAt(e.indexAfter(r)).defaultType;
        if (t && t.isTextblock && t.defaultAttrs)
          return t;
      }
    for (let r in this.parser.schema.nodes) {
      let t = this.parser.schema.nodes[r];
      if (t.isTextblock && t.defaultAttrs)
        return t;
    }
  }
}
function I5(o) {
  for (let e = o.firstChild, r = null; e; e = e.nextSibling) {
    let t = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    t && Eh.hasOwnProperty(t) && r ? (r.appendChild(e), e = r) : t == "li" ? r = e : t && (r = null);
  }
}
function R5(o, e) {
  return (o.matches || o.msMatchesSelector || o.webkitMatchesSelector || o.mozMatchesSelector).call(o, e);
}
function om(o) {
  let e = {};
  for (let r in o)
    e[r] = o[r];
  return e;
}
function rm(o, e) {
  let r = e.schema.nodes;
  for (let t in r) {
    let n = r[t];
    if (!n.allowsMarkType(o))
      continue;
    let a = [], s = (i) => {
      a.push(i);
      for (let l = 0; l < i.edgeCount; l++) {
        let { type: c, next: u } = i.edge(l);
        if (c == e || a.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(n.contentMatch))
      return !0;
  }
}
const xh = 65535, Ah = Math.pow(2, 16);
function L5(o, e) {
  return o + e * Ah;
}
function tm(o) {
  return o & xh;
}
function H5(o) {
  return (o - (o & xh)) / Ah;
}
const Ch = 1, Oh = 2, us = 4, Th = 8;
class nm {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.pos = e, this.delInfo = r, this.recover = t;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Th) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Ch | us)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Oh | us)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & us) > 0;
  }
}
class vo {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, r = !1) {
    if (this.ranges = e, this.inverted = r, !e.length && vo.empty)
      return vo.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let r = 0, t = tm(e);
    if (!this.inverted)
      for (let n = 0; n < t; n++)
        r += this.ranges[n * 3 + 2] - this.ranges[n * 3 + 1];
    return this.ranges[t * 3] + r + H5(e);
  }
  mapResult(e, r = 1) {
    return this._map(e, r, !1);
  }
  map(e, r = 1) {
    return this._map(e, r, !0);
  }
  /**
  @internal
  */
  _map(e, r, t) {
    let n = 0, a = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? n : 0);
      if (l > e)
        break;
      let c = this.ranges[i + a], u = this.ranges[i + s], m = l + c;
      if (e <= m) {
        let y = c ? e == l ? -1 : e == m ? 1 : r : r, g = l + n + (y < 0 ? 0 : u);
        if (t)
          return g;
        let p = e == (r < 0 ? l : m) ? null : L5(i / 3, e - l), d = e == l ? Oh : e == m ? Ch : us;
        return (r < 0 ? e != l : e != m) && (d |= Th), new nm(g, d, p);
      }
      n += u - c;
    }
    return t ? e + n : new nm(e + n, 0, null);
  }
  /**
  @internal
  */
  touches(e, r) {
    let t = 0, n = tm(r), a = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? t : 0);
      if (l > e)
        break;
      let c = this.ranges[i + a], u = l + c;
      if (e <= u && i == n * 3)
        return !0;
      t += this.ranges[i + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let r = this.inverted ? 2 : 1, t = this.inverted ? 1 : 2;
    for (let n = 0, a = 0; n < this.ranges.length; n += 3) {
      let s = this.ranges[n], i = s - (this.inverted ? a : 0), l = s + (this.inverted ? 0 : a), c = this.ranges[n + r], u = this.ranges[n + t];
      e(i, i + c, l, l + u), a += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new vo(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? vo.empty : new vo(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
vo.empty = new vo([]);
const Fl = /* @__PURE__ */ Object.create(null);
class to {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return vo.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, r) {
    if (!r || !r.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let t = Fl[r.stepType];
    if (!t)
      throw new RangeError(`No step type ${r.stepType} defined`);
    return t.fromJSON(e, r);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, r) {
    if (e in Fl)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Fl[e] = r, r.prototype.jsonID = e, r;
  }
}
class We {
  /**
  @internal
  */
  constructor(e, r) {
    this.doc = e, this.failed = r;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new We(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new We(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, r, t, n) {
    try {
      return We.ok(e.replace(r, t, n));
    } catch (a) {
      if (a instanceof Ds)
        return We.fail(a.message);
      throw a;
    }
  }
}
function fu(o, e, r) {
  let t = [];
  for (let n = 0; n < o.childCount; n++) {
    let a = o.child(n);
    a.content.size && (a = a.copy(fu(a.content, e, a))), a.isInline && (a = e(a, r, n)), t.push(a);
  }
  return oe.fromArray(t);
}
class Mr extends to {
  /**
  Create a mark step.
  */
  constructor(e, r, t) {
    super(), this.from = e, this.to = r, this.mark = t;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), t = e.resolve(this.from), n = t.node(t.sharedDepth(this.to)), a = new de(fu(r.content, (s, i) => !s.isAtom || !i.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), n), r.openStart, r.openEnd);
    return We.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new zr(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deleted && t.deleted || r.pos >= t.pos ? null : new Mr(r.pos, t.pos, this.mark);
  }
  merge(e) {
    return e instanceof Mr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Mr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Mr(r.from, r.to, e.markFromJSON(r.mark));
  }
}
to.jsonID("addMark", Mr);
class zr extends to {
  /**
  Create a mark-removing step.
  */
  constructor(e, r, t) {
    super(), this.from = e, this.to = r, this.mark = t;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), t = new de(fu(r.content, (n) => n.mark(this.mark.removeFromSet(n.marks)), e), r.openStart, r.openEnd);
    return We.fromReplace(e, this.from, this.to, t);
  }
  invert() {
    return new Mr(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deleted && t.deleted || r.pos >= t.pos ? null : new zr(r.pos, t.pos, this.mark);
  }
  merge(e) {
    return e instanceof zr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new zr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new zr(r.from, r.to, e.markFromJSON(r.mark));
  }
}
to.jsonID("removeMark", zr);
class Nr extends to {
  /**
  Create a node mark step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return We.fail("No node at mark step's position");
    let t = r.type.create(r.attrs, null, this.mark.addToSet(r.marks));
    return We.fromReplace(e, this.pos, this.pos + 1, new de(oe.from(t), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    if (r) {
      let t = this.mark.addToSet(r.marks);
      if (t.length == r.marks.length) {
        for (let n = 0; n < r.marks.length; n++)
          if (!r.marks[n].isInSet(t))
            return new Nr(this.pos, r.marks[n]);
        return new Nr(this.pos, this.mark);
      }
    }
    return new ra(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new Nr(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Nr(r.pos, e.markFromJSON(r.mark));
  }
}
to.jsonID("addNodeMark", Nr);
class ra extends to {
  /**
  Create a mark-removing step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return We.fail("No node at mark step's position");
    let t = r.type.create(r.attrs, null, this.mark.removeFromSet(r.marks));
    return We.fromReplace(e, this.pos, this.pos + 1, new de(oe.from(t), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    return !r || !this.mark.isInSet(r.marks) ? this : new Nr(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new ra(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ra(r.pos, e.markFromJSON(r.mark));
  }
}
to.jsonID("removeNodeMark", ra);
class bo extends to {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, r, t, n = !1) {
    super(), this.from = e, this.to = r, this.slice = t, this.structure = n;
  }
  apply(e) {
    return this.structure && Bc(e, this.from, this.to) ? We.fail("Structure replace would overwrite content") : We.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new vo([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new bo(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deletedAcross && t.deletedAcross ? null : new bo(r.pos, Math.max(r.pos, t.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof bo) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let r = this.slice.size + e.slice.size == 0 ? de.empty : new de(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new bo(this.from, this.to + (e.to - e.from), r, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let r = this.slice.size + e.slice.size == 0 ? de.empty : new de(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new bo(e.from, this.to, r, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new bo(r.from, r.to, de.fromJSON(e, r.slice), !!r.structure);
  }
}
to.jsonID("replace", bo);
class mo extends to {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, r, t, n, a, s, i = !1) {
    super(), this.from = e, this.to = r, this.gapFrom = t, this.gapTo = n, this.slice = a, this.insert = s, this.structure = i;
  }
  apply(e) {
    if (this.structure && (Bc(e, this.from, this.gapFrom) || Bc(e, this.gapTo, this.to)))
      return We.fail("Structure gap-replace would overwrite content");
    let r = e.slice(this.gapFrom, this.gapTo);
    if (r.openStart || r.openEnd)
      return We.fail("Gap is not a flat range");
    let t = this.slice.insertAt(this.insert, r.content);
    return t ? We.fromReplace(e, this.from, this.to, t) : We.fail("Content does not fit in gap");
  }
  getMap() {
    return new vo([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let r = this.gapTo - this.gapFrom;
    return new mo(this.from, this.from + this.slice.size + r, this.from + this.insert, this.from + this.insert + r, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1), n = this.from == this.gapFrom ? r.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? t.pos : e.map(this.gapTo, 1);
    return r.deletedAcross && t.deletedAcross || n < r.pos || a > t.pos ? null : new mo(r.pos, t.pos, n, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number" || typeof r.gapFrom != "number" || typeof r.gapTo != "number" || typeof r.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new mo(r.from, r.to, r.gapFrom, r.gapTo, de.fromJSON(e, r.slice), r.insert, !!r.structure);
  }
}
to.jsonID("replaceAround", mo);
function Bc(o, e, r) {
  let t = o.resolve(e), n = r - e, a = t.depth;
  for (; n > 0 && a > 0 && t.indexAfter(a) == t.node(a).childCount; )
    a--, n--;
  if (n > 0) {
    let s = t.node(a).maybeChild(t.indexAfter(a));
    for (; n > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, n--;
    }
  }
  return !1;
}
function W5(o, e, r) {
  return (e == 0 || o.canReplace(e, o.childCount)) && (r == o.childCount || o.canReplace(0, r));
}
function Tt(o) {
  let r = o.parent.content.cutByIndex(o.startIndex, o.endIndex);
  for (let t = o.depth; ; --t) {
    let n = o.$from.node(t), a = o.$from.index(t), s = o.$to.indexAfter(t);
    if (t < o.depth && n.canReplace(a, s, r))
      return t;
    if (t == 0 || n.type.spec.isolating || !W5(n, a, s))
      break;
  }
  return null;
}
function jh(o, e, r = null, t = o) {
  let n = V5(o, e), a = n && G5(t, e);
  return a ? n.map(am).concat({ type: e, attrs: r }).concat(a.map(am)) : null;
}
function am(o) {
  return { type: o, attrs: null };
}
function V5(o, e) {
  let { parent: r, startIndex: t, endIndex: n } = o, a = r.contentMatchAt(t).findWrapping(e);
  if (!a)
    return null;
  let s = a.length ? a[0] : e;
  return r.canReplaceWith(t, n, s) ? a : null;
}
function G5(o, e) {
  let { parent: r, startIndex: t, endIndex: n } = o, a = r.child(t), s = e.contentMatch.findWrapping(a.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = t; l && c < n; c++)
    l = l.matchType(r.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function or(o, e, r = 1, t) {
  let n = o.resolve(e), a = n.depth - r, s = t && t[t.length - 1] || n.parent;
  if (a < 0 || n.parent.type.spec.isolating || !n.parent.canReplace(n.index(), n.parent.childCount) || !s.type.validContent(n.parent.content.cutByIndex(n.index(), n.parent.childCount)))
    return !1;
  for (let c = n.depth - 1, u = r - 2; c > a; c--, u--) {
    let m = n.node(c), y = n.index(c);
    if (m.type.spec.isolating)
      return !1;
    let g = m.content.cutByIndex(y, m.childCount), p = t && t[u + 1];
    p && (g = g.replaceChild(0, p.type.create(p.attrs)));
    let d = t && t[u] || m;
    if (!m.canReplace(y + 1, m.childCount) || !d.type.validContent(g))
      return !1;
  }
  let i = n.indexAfter(a), l = t && t[0];
  return n.node(a).canReplaceWith(i, i, l ? l.type : n.node(a + 1).type);
}
function Kr(o, e) {
  let r = o.resolve(e), t = r.index();
  return Mh(r.nodeBefore, r.nodeAfter) && r.parent.canReplace(t, t + 1);
}
function Z5(o, e) {
  e.content.size || o.type.compatibleContent(e.type);
  let r = o.contentMatchAt(o.childCount), { linebreakReplacement: t } = o.type.schema;
  for (let n = 0; n < e.childCount; n++) {
    let a = e.child(n), s = a.type == t ? o.type.schema.nodes.text : a.type;
    if (r = r.matchType(s), !r || !o.type.allowsMarks(a.marks))
      return !1;
  }
  return r.validEnd;
}
function Mh(o, e) {
  return !!(o && e && !o.isLeaf && Z5(o, e));
}
function Js(o, e, r = -1) {
  let t = o.resolve(e);
  for (let n = t.depth; ; n--) {
    let a, s, i = t.index(n);
    if (n == t.depth ? (a = t.nodeBefore, s = t.nodeAfter) : r > 0 ? (a = t.node(n + 1), i++, s = t.node(n).maybeChild(i)) : (a = t.node(n).maybeChild(i - 1), s = t.node(n + 1)), a && !a.isTextblock && Mh(a, s) && t.node(n).canReplace(i, i + 1))
      return e;
    if (n == 0)
      break;
    e = r < 0 ? t.before(n) : t.after(n);
  }
}
function hu(o, e, r = e, t = de.empty) {
  if (e == r && !t.size)
    return null;
  let n = o.resolve(e), a = o.resolve(r);
  return X5(n, a, t) ? new bo(e, r, t) : new q5(n, a, t).fit();
}
function X5(o, e, r) {
  return !r.openStart && !r.openEnd && o.start() == e.start() && o.parent.canReplace(o.index(), e.index(), r.content);
}
class q5 {
  constructor(e, r, t) {
    this.$from = e, this.$to = r, this.unplaced = t, this.frontier = [], this.placed = oe.empty;
    for (let n = 0; n <= e.depth; n++) {
      let a = e.node(n);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(n))
      });
    }
    for (let n = e.depth; n > 0; n--)
      this.placed = oe.from(e.node(n).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, t = this.$from, n = this.close(e < 0 ? this.$to : t.doc.resolve(e));
    if (!n)
      return null;
    let a = this.placed, s = t.depth, i = n.depth;
    for (; s && i && a.childCount == 1; )
      a = a.firstChild.content, s--, i--;
    let l = new de(a, s, i);
    return e > -1 ? new mo(t.pos, e, this.$to.pos, this.$to.end(), l, r) : l.size || t.pos != this.$to.pos ? new bo(t.pos, n.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let r = this.unplaced.content, t = 0, n = this.unplaced.openEnd; t < e; t++) {
      let a = r.firstChild;
      if (r.childCount > 1 && (n = 0), a.type.spec.isolating && n <= t) {
        e = t;
        break;
      }
      r = a.content;
    }
    for (let r = 1; r <= 2; r++)
      for (let t = r == 1 ? e : this.unplaced.openStart; t >= 0; t--) {
        let n, a = null;
        t ? (a = bl(this.unplaced.content, t - 1).firstChild, n = a.content) : n = this.unplaced.content;
        let s = n.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: l, match: c } = this.frontier[i], u, m = null;
          if (r == 1 && (s ? c.matchType(s.type) || (m = c.fillBefore(oe.from(s), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: t, frontierDepth: i, parent: a, inject: m };
          if (r == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: t, frontierDepth: i, parent: a, wrap: u };
          if (a && c.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: r, openEnd: t } = this.unplaced, n = bl(e, r);
    return !n.childCount || n.firstChild.isLeaf ? !1 : (this.unplaced = new de(e, r + 1, Math.max(t, n.size + r >= e.size - t ? r + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: r, openEnd: t } = this.unplaced, n = bl(e, r);
    if (n.childCount <= 1 && r > 0) {
      let a = e.size - r <= r + n.size;
      this.unplaced = new de(Yt(e, r - 1, 1), r - 1, a ? r - 1 : t);
    } else
      this.unplaced = new de(Yt(e, r, 1), r, t);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: r, parent: t, inject: n, wrap: a }) {
    for (; this.depth > r; )
      this.closeFrontierNode();
    if (a)
      for (let d = 0; d < a.length; d++)
        this.openFrontierNode(a[d]);
    let s = this.unplaced, i = t ? t.content : s.content, l = s.openStart - e, c = 0, u = [], { match: m, type: y } = this.frontier[r];
    if (n) {
      for (let d = 0; d < n.childCount; d++)
        u.push(n.child(d));
      m = m.matchFragment(n);
    }
    let g = i.size + e - (s.content.size - s.openEnd);
    for (; c < i.childCount; ) {
      let d = i.child(c), h = m.matchType(d.type);
      if (!h)
        break;
      c++, (c > 1 || l == 0 || d.content.size) && (m = h, u.push(zh(d.mark(y.allowedMarks(d.marks)), c == 1 ? l : 0, c == i.childCount ? g : -1)));
    }
    let p = c == i.childCount;
    p || (g = -1), this.placed = Jt(this.placed, r, oe.from(u)), this.frontier[r].match = m, p && g < 0 && t && t.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let d = 0, h = i; d < g; d++) {
      let f = h.lastChild;
      this.frontier.push({ type: f.type, match: f.contentMatchAt(f.childCount) }), h = f.content;
    }
    this.unplaced = p ? e == 0 ? de.empty : new de(Yt(s.content, e - 1, 1), e - 1, g < 0 ? s.openEnd : e - 1) : new de(Yt(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], r;
    if (!e.type.isTextblock || !vl(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (r = this.findCloseLevel(this.$to)) && r.depth == this.depth)
      return -1;
    let { depth: t } = this.$to, n = this.$to.after(t);
    for (; t > 1 && n == this.$to.end(--t); )
      ++n;
    return n;
  }
  findCloseLevel(e) {
    e: for (let r = Math.min(this.depth, e.depth); r >= 0; r--) {
      let { match: t, type: n } = this.frontier[r], a = r < e.depth && e.end(r + 1) == e.pos + (e.depth - (r + 1)), s = vl(e, r, n, t, a);
      if (s) {
        for (let i = r - 1; i >= 0; i--) {
          let { match: l, type: c } = this.frontier[i], u = vl(e, i, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: r, fit: s, move: a ? e.doc.resolve(e.after(r + 1)) : e };
      }
    }
  }
  close(e) {
    let r = this.findCloseLevel(e);
    if (!r)
      return null;
    for (; this.depth > r.depth; )
      this.closeFrontierNode();
    r.fit.childCount && (this.placed = Jt(this.placed, r.depth, r.fit)), e = r.move;
    for (let t = r.depth + 1; t <= e.depth; t++) {
      let n = e.node(t), a = n.type.contentMatch.fillBefore(n.content, !0, e.index(t));
      this.openFrontierNode(n.type, n.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, r = null, t) {
    let n = this.frontier[this.depth];
    n.match = n.match.matchType(e), this.placed = Jt(this.placed, this.depth, oe.from(e.create(r, t))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let r = this.frontier.pop().match.fillBefore(oe.empty, !0);
    r.childCount && (this.placed = Jt(this.placed, this.frontier.length, r));
  }
}
function Yt(o, e, r) {
  return e == 0 ? o.cutByIndex(r, o.childCount) : o.replaceChild(0, o.firstChild.copy(Yt(o.firstChild.content, e - 1, r)));
}
function Jt(o, e, r) {
  return e == 0 ? o.append(r) : o.replaceChild(o.childCount - 1, o.lastChild.copy(Jt(o.lastChild.content, e - 1, r)));
}
function bl(o, e) {
  for (let r = 0; r < e; r++)
    o = o.firstChild.content;
  return o;
}
function zh(o, e, r) {
  if (e <= 0)
    return o;
  let t = o.content;
  return e > 1 && (t = t.replaceChild(0, zh(t.firstChild, e - 1, t.childCount == 1 ? r - 1 : 0))), e > 0 && (t = o.type.contentMatch.fillBefore(t).append(t), r <= 0 && (t = t.append(o.type.contentMatch.matchFragment(t).fillBefore(oe.empty, !0)))), o.copy(t);
}
function vl(o, e, r, t, n) {
  let a = o.node(e), s = n ? o.indexAfter(e) : o.index(e);
  if (s == a.childCount && !r.compatibleContent(a.type))
    return null;
  let i = t.fillBefore(a.content, !0, s);
  return i && !U5(r, a.content, s) ? i : null;
}
function U5(o, e, r) {
  for (let t = r; t < e.childCount; t++)
    if (!o.allowsMarks(e.child(t).marks))
      return !0;
  return !1;
}
class rn extends to {
  /**
  Construct an attribute step.
  */
  constructor(e, r, t) {
    super(), this.pos = e, this.attr = r, this.value = t;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return We.fail("No node at attribute step's position");
    let t = /* @__PURE__ */ Object.create(null);
    for (let a in r.attrs)
      t[a] = r.attrs[a];
    t[this.attr] = this.value;
    let n = r.type.create(t, null, r.marks);
    return We.fromReplace(e, this.pos, this.pos + 1, new de(oe.from(n), 0, r.isLeaf ? 0 : 1));
  }
  getMap() {
    return vo.empty;
  }
  invert(e) {
    return new rn(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new rn(r.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.pos != "number" || typeof r.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new rn(r.pos, r.attr, r.value);
  }
}
to.jsonID("attr", rn);
class Cs extends to {
  /**
  Construct an attribute step.
  */
  constructor(e, r) {
    super(), this.attr = e, this.value = r;
  }
  apply(e) {
    let r = /* @__PURE__ */ Object.create(null);
    for (let n in e.attrs)
      r[n] = e.attrs[n];
    r[this.attr] = this.value;
    let t = e.type.create(r, e.content, e.marks);
    return We.ok(t);
  }
  getMap() {
    return vo.empty;
  }
  invert(e) {
    return new Cs(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Cs(r.attr, r.value);
  }
}
to.jsonID("docAttr", Cs);
let ta = class extends Error {
};
ta = function o(e) {
  let r = Error.call(this, e);
  return r.__proto__ = o.prototype, r;
};
ta.prototype = Object.create(Error.prototype);
ta.prototype.constructor = ta;
ta.prototype.name = "TransformError";
const Pl = /* @__PURE__ */ Object.create(null);
class we {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, r, t) {
    this.$anchor = e, this.$head = r, this.ranges = t || [new Y5(e.min(r), e.max(r))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let r = 0; r < e.length; r++)
      if (e[r].$from.pos != e[r].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, r = de.empty) {
    let t = r.content.lastChild, n = null;
    for (let i = 0; i < r.openEnd; i++)
      n = t, t = t.lastChild;
    let a = e.steps.length, s = this.ranges;
    for (let i = 0; i < s.length; i++) {
      let { $from: l, $to: c } = s[i], u = e.mapping.slice(a);
      e.replaceRange(u.map(l.pos), u.map(c.pos), i ? de.empty : r), i == 0 && lm(e, a, (t ? t.isInline : n && n.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, r) {
    let t = e.steps.length, n = this.ranges;
    for (let a = 0; a < n.length; a++) {
      let { $from: s, $to: i } = n[a], l = e.mapping.slice(t), c = l.map(s.pos), u = l.map(i.pos);
      a ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, r), lm(e, t, r.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, r, t = !1) {
    let n = e.parent.inlineContent ? new Ne(e) : ut(e.node(0), e.parent, e.pos, e.index(), r, t);
    if (n)
      return n;
    for (let a = e.depth - 1; a >= 0; a--) {
      let s = r < 0 ? ut(e.node(0), e.node(a), e.before(a + 1), e.index(a), r, t) : ut(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, r, t);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, r = 1) {
    return this.findFrom(e, r) || this.findFrom(e, -r) || new Ao(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return ut(e, e, 0, 0, 1) || new Ao(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return ut(e, e, e.content.size, e.childCount, -1) || new Ao(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, r) {
    if (!r || !r.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let t = Pl[r.type];
    if (!t)
      throw new RangeError(`No selection type ${r.type} defined`);
    return t.fromJSON(e, r);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, r) {
    if (e in Pl)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Pl[e] = r, r.prototype.jsonID = e, r;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ne.between(this.$anchor, this.$head).getBookmark();
  }
}
we.prototype.visible = !0;
class Y5 {
  /**
  Create a range.
  */
  constructor(e, r) {
    this.$from = e, this.$to = r;
  }
}
let sm = !1;
function im(o) {
  !sm && !o.parent.inlineContent && (sm = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + o.parent.type.name + ")"));
}
class Ne extends we {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, r = e) {
    im(e), im(r), super(e, r);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, r) {
    let t = e.resolve(r.map(this.head));
    if (!t.parent.inlineContent)
      return we.near(t);
    let n = e.resolve(r.map(this.anchor));
    return new Ne(n.parent.inlineContent ? n : t, t);
  }
  replace(e, r = de.empty) {
    if (super.replace(e, r), r == de.empty) {
      let t = this.$from.marksAcross(this.$to);
      t && e.ensureMarks(t);
    }
  }
  eq(e) {
    return e instanceof Ne && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Qs(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number" || typeof r.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ne(e.resolve(r.anchor), e.resolve(r.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, r, t = r) {
    let n = e.resolve(r);
    return new this(n, t == r ? n : e.resolve(t));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, r, t) {
    let n = e.pos - r.pos;
    if ((!t || n) && (t = n >= 0 ? 1 : -1), !r.parent.inlineContent) {
      let a = we.findFrom(r, t, !0) || we.findFrom(r, -t, !0);
      if (a)
        r = a.$head;
      else
        return we.near(r, t);
    }
    return e.parent.inlineContent || (n == 0 ? e = r : (e = (we.findFrom(e, -t, !0) || we.findFrom(e, t, !0)).$anchor, e.pos < r.pos != n < 0 && (e = r))), new Ne(e, r);
  }
}
we.jsonID("text", Ne);
class Qs {
  constructor(e, r) {
    this.anchor = e, this.head = r;
  }
  map(e) {
    return new Qs(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ne.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Ce extends we {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let r = e.nodeAfter, t = e.node(0).resolve(e.pos + r.nodeSize);
    super(e, t), this.node = r;
  }
  map(e, r) {
    let { deleted: t, pos: n } = r.mapResult(this.anchor), a = e.resolve(n);
    return t ? we.near(a) : new Ce(a);
  }
  content() {
    return new de(oe.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Ce && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Fu(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Ce(e.resolve(r.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, r) {
    return new Ce(e.resolve(r));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Ce.prototype.visible = !1;
we.jsonID("node", Ce);
class Fu {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: r, pos: t } = e.mapResult(this.anchor);
    return r ? new Qs(t, t) : new Fu(t);
  }
  resolve(e) {
    let r = e.resolve(this.anchor), t = r.nodeAfter;
    return t && Ce.isSelectable(t) ? new Ce(r) : we.near(r);
  }
}
class Ao extends we {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, r = de.empty) {
    if (r == de.empty) {
      e.delete(0, e.doc.content.size);
      let t = we.atStart(e.doc);
      t.eq(e.selection) || e.setSelection(t);
    } else
      super.replace(e, r);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Ao(e);
  }
  map(e) {
    return new Ao(e);
  }
  eq(e) {
    return e instanceof Ao;
  }
  getBookmark() {
    return J5;
  }
}
we.jsonID("all", Ao);
const J5 = {
  map() {
    return this;
  },
  resolve(o) {
    return new Ao(o);
  }
};
function ut(o, e, r, t, n, a = !1) {
  if (e.inlineContent)
    return Ne.create(o, r);
  for (let s = t - (n > 0 ? 0 : 1); n > 0 ? s < e.childCount : s >= 0; s += n) {
    let i = e.child(s);
    if (i.isAtom) {
      if (!a && Ce.isSelectable(i))
        return Ce.create(o, r - (n < 0 ? i.nodeSize : 0));
    } else {
      let l = ut(o, i, r + n, n < 0 ? i.childCount : 0, n, a);
      if (l)
        return l;
    }
    r += i.nodeSize * n;
  }
  return null;
}
function lm(o, e, r) {
  let t = o.steps.length - 1;
  if (t < e)
    return;
  let n = o.steps[t];
  if (!(n instanceof bo || n instanceof mo))
    return;
  let a = o.mapping.maps[t], s;
  a.forEach((i, l, c, u) => {
    s == null && (s = u);
  }), o.setSelection(we.near(o.doc.resolve(s), r));
}
function cm(o, e) {
  return !e || !o ? o : o.bind(e);
}
class Xa {
  constructor(e, r, t) {
    this.name = e, this.init = cm(r.init, t), this.apply = cm(r.apply, t);
  }
}
new Xa("doc", {
  init(o) {
    return o.doc || o.schema.topNodeType.createAndFill();
  },
  apply(o) {
    return o.doc;
  }
}), new Xa("selection", {
  init(o, e) {
    return o.selection || we.atStart(e.doc);
  },
  apply(o) {
    return o.selection;
  }
}), new Xa("storedMarks", {
  init(o) {
    return o.storedMarks || null;
  },
  apply(o, e, r, t) {
    return t.selection.$cursor ? o.storedMarks : null;
  }
}), new Xa("scrollToSelection", {
  init() {
    return 0;
  },
  apply(o, e) {
    return o.scrolledIntoView ? e + 1 : e;
  }
});
function Nh(o, e, r) {
  for (let t in o) {
    let n = o[t];
    n instanceof Function ? n = n.bind(e) : t == "handleDOMEvents" && (n = Nh(n, e, {})), r[t] = n;
  }
  return r;
}
class _r {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Nh(e.props, this, this.props), this.key = e.key ? e.key.key : Ih("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Bl = /* @__PURE__ */ Object.create(null);
function Ih(o) {
  return o in Bl ? o + "$" + ++Bl[o] : (Bl[o] = 0, o + "$");
}
class $r {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Ih(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const bu = (o, e) => o.selection.empty ? !1 : (e && e(o.tr.deleteSelection().scrollIntoView()), !0);
function Rh(o, e) {
  let { $cursor: r } = o.selection;
  return !r || (e ? !e.endOfTextblock("backward", o) : r.parentOffset > 0) ? null : r;
}
const Lh = (o, e, r) => {
  let t = Rh(o, r);
  if (!t)
    return !1;
  let n = vu(t);
  if (!n) {
    let s = t.blockRange(), i = s && Tt(s);
    return i == null ? !1 : (e && e(o.tr.lift(s, i).scrollIntoView()), !0);
  }
  let a = n.nodeBefore;
  if (Yh(o, n, e, -1))
    return !0;
  if (t.parent.content.size == 0 && (Dt(a, "end") || Ce.isSelectable(a)))
    for (let s = t.depth; ; s--) {
      let i = hu(o.doc, t.before(s), t.after(s), de.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (e) {
          let l = o.tr.step(i);
          l.setSelection(Dt(a, "end") ? we.findFrom(l.doc.resolve(l.mapping.map(n.pos, -1)), -1) : Ce.create(l.doc, n.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || t.node(s - 1).childCount > 1)
        break;
    }
  return a.isAtom && n.depth == t.depth - 1 ? (e && e(o.tr.delete(n.pos - a.nodeSize, n.pos).scrollIntoView()), !0) : !1;
}, Q5 = (o, e, r) => {
  let t = Rh(o, r);
  if (!t)
    return !1;
  let n = vu(t);
  return n ? Hh(o, n, e) : !1;
}, K5 = (o, e, r) => {
  let t = Vh(o, r);
  if (!t)
    return !1;
  let n = Pu(t);
  return n ? Hh(o, n, e) : !1;
};
function Hh(o, e, r) {
  let t = e.nodeBefore, n = t, a = e.pos - 1;
  for (; !n.isTextblock; a--) {
    if (n.type.spec.isolating)
      return !1;
    let u = n.lastChild;
    if (!u)
      return !1;
    n = u;
  }
  let s = e.nodeAfter, i = s, l = e.pos + 1;
  for (; !i.isTextblock; l++) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.firstChild;
    if (!u)
      return !1;
    i = u;
  }
  let c = hu(o.doc, a, l, de.empty);
  if (!c || c.from != a || c instanceof bo && c.slice.size >= l - a)
    return !1;
  if (r) {
    let u = o.tr.step(c);
    u.setSelection(Ne.create(u.doc, a)), r(u.scrollIntoView());
  }
  return !0;
}
function Dt(o, e, r = !1) {
  for (let t = o; t; t = e == "start" ? t.firstChild : t.lastChild) {
    if (t.isTextblock)
      return !0;
    if (r && t.childCount != 1)
      return !1;
  }
  return !1;
}
const Wh = (o, e, r) => {
  let { $head: t, empty: n } = o.selection, a = t;
  if (!n)
    return !1;
  if (t.parent.isTextblock) {
    if (r ? !r.endOfTextblock("backward", o) : t.parentOffset > 0)
      return !1;
    a = vu(t);
  }
  let s = a && a.nodeBefore;
  return !s || !Ce.isSelectable(s) ? !1 : (e && e(o.tr.setSelection(Ce.create(o.doc, a.pos - s.nodeSize)).scrollIntoView()), !0);
};
function vu(o) {
  if (!o.parent.type.spec.isolating)
    for (let e = o.depth - 1; e >= 0; e--) {
      if (o.index(e) > 0)
        return o.doc.resolve(o.before(e + 1));
      if (o.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Vh(o, e) {
  let { $cursor: r } = o.selection;
  return !r || (e ? !e.endOfTextblock("forward", o) : r.parentOffset < r.parent.content.size) ? null : r;
}
const Gh = (o, e, r) => {
  let t = Vh(o, r);
  if (!t)
    return !1;
  let n = Pu(t);
  if (!n)
    return !1;
  let a = n.nodeAfter;
  if (Yh(o, n, e, 1))
    return !0;
  if (t.parent.content.size == 0 && (Dt(a, "start") || Ce.isSelectable(a))) {
    let s = hu(o.doc, t.before(), t.after(), de.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let i = o.tr.step(s);
        i.setSelection(Dt(a, "start") ? we.findFrom(i.doc.resolve(i.mapping.map(n.pos)), 1) : Ce.create(i.doc, i.mapping.map(n.pos))), e(i.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && n.depth == t.depth - 1 ? (e && e(o.tr.delete(n.pos, n.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, Zh = (o, e, r) => {
  let { $head: t, empty: n } = o.selection, a = t;
  if (!n)
    return !1;
  if (t.parent.isTextblock) {
    if (r ? !r.endOfTextblock("forward", o) : t.parentOffset < t.parent.content.size)
      return !1;
    a = Pu(t);
  }
  let s = a && a.nodeAfter;
  return !s || !Ce.isSelectable(s) ? !1 : (e && e(o.tr.setSelection(Ce.create(o.doc, a.pos)).scrollIntoView()), !0);
};
function Pu(o) {
  if (!o.parent.type.spec.isolating)
    for (let e = o.depth - 1; e >= 0; e--) {
      let r = o.node(e);
      if (o.index(e) + 1 < r.childCount)
        return o.doc.resolve(o.after(e + 1));
      if (r.type.spec.isolating)
        break;
    }
  return null;
}
const _5 = (o, e) => {
  let r = o.selection, t = r instanceof Ce, n;
  if (t) {
    if (r.node.isTextblock || !Kr(o.doc, r.from))
      return !1;
    n = r.from;
  } else if (n = Js(o.doc, r.from, -1), n == null)
    return !1;
  if (e) {
    let a = o.tr.join(n);
    t && a.setSelection(Ce.create(a.doc, n - o.doc.resolve(n).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, $5 = (o, e) => {
  let r = o.selection, t;
  if (r instanceof Ce) {
    if (r.node.isTextblock || !Kr(o.doc, r.to))
      return !1;
    t = r.to;
  } else if (t = Js(o.doc, r.to, 1), t == null)
    return !1;
  return e && e(o.tr.join(t).scrollIntoView()), !0;
}, eE = (o, e) => {
  let { $from: r, $to: t } = o.selection, n = r.blockRange(t), a = n && Tt(n);
  return a == null ? !1 : (e && e(o.tr.lift(n, a).scrollIntoView()), !0);
}, Xh = (o, e) => {
  let { $head: r, $anchor: t } = o.selection;
  return !r.parent.type.spec.code || !r.sameParent(t) ? !1 : (e && e(o.tr.insertText(`
`).scrollIntoView()), !0);
};
function Bu(o) {
  for (let e = 0; e < o.edgeCount; e++) {
    let { type: r } = o.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
const oE = (o, e) => {
  let { $head: r, $anchor: t } = o.selection;
  if (!r.parent.type.spec.code || !r.sameParent(t))
    return !1;
  let n = r.node(-1), a = r.indexAfter(-1), s = Bu(n.contentMatchAt(a));
  if (!s || !n.canReplaceWith(a, a, s))
    return !1;
  if (e) {
    let i = r.after(), l = o.tr.replaceWith(i, i, s.createAndFill());
    l.setSelection(we.near(l.doc.resolve(i), 1)), e(l.scrollIntoView());
  }
  return !0;
}, qh = (o, e) => {
  let r = o.selection, { $from: t, $to: n } = r;
  if (r instanceof Ao || t.parent.inlineContent || n.parent.inlineContent)
    return !1;
  let a = Bu(n.parent.contentMatchAt(n.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let s = (!t.parentOffset && n.index() < n.parent.childCount ? t : n).pos, i = o.tr.insert(s, a.createAndFill());
    i.setSelection(Ne.create(i.doc, s + 1)), e(i.scrollIntoView());
  }
  return !0;
}, Uh = (o, e) => {
  let { $cursor: r } = o.selection;
  if (!r || r.parent.content.size)
    return !1;
  if (r.depth > 1 && r.after() != r.end(-1)) {
    let a = r.before();
    if (or(o.doc, a))
      return e && e(o.tr.split(a).scrollIntoView()), !0;
  }
  let t = r.blockRange(), n = t && Tt(t);
  return n == null ? !1 : (e && e(o.tr.lift(t, n).scrollIntoView()), !0);
};
function rE(o) {
  return (e, r) => {
    let { $from: t, $to: n } = e.selection;
    if (e.selection instanceof Ce && e.selection.node.isBlock)
      return !t.parentOffset || !or(e.doc, t.pos) ? !1 : (r && r(e.tr.split(t.pos).scrollIntoView()), !0);
    if (!t.depth)
      return !1;
    let a = [], s, i, l = !1, c = !1;
    for (let g = t.depth; ; g--)
      if (t.node(g).isBlock) {
        l = t.end(g) == t.pos + (t.depth - g), c = t.start(g) == t.pos - (t.depth - g), i = Bu(t.node(g - 1).contentMatchAt(t.indexAfter(g - 1))), a.unshift(l && i ? { type: i } : null), s = g;
        break;
      } else {
        if (g == 1)
          return !1;
        a.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof Ne || e.selection instanceof Ao) && u.deleteSelection();
    let m = u.mapping.map(t.pos), y = or(u.doc, m, a.length, a);
    if (y || (a[0] = i ? { type: i } : null, y = or(u.doc, m, a.length, a)), u.split(m, a.length, a), !l && c && t.node(s).type != i) {
      let g = u.mapping.map(t.before(s)), p = u.doc.resolve(g);
      i && t.node(s - 1).canReplaceWith(p.index(), p.index() + 1, i) && u.setNodeMarkup(u.mapping.map(t.before(s)), i);
    }
    return r && r(u.scrollIntoView()), !0;
  };
}
const tE = rE(), nE = (o, e) => {
  let { $from: r, to: t } = o.selection, n, a = r.sharedDepth(t);
  return a == 0 ? !1 : (n = r.before(a), e && e(o.tr.setSelection(Ce.create(o.doc, n))), !0);
};
function aE(o, e, r) {
  let t = e.nodeBefore, n = e.nodeAfter, a = e.index();
  return !t || !n || !t.type.compatibleContent(n.type) ? !1 : !t.content.size && e.parent.canReplace(a - 1, a) ? (r && r(o.tr.delete(e.pos - t.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(n.isTextblock || Kr(o.doc, e.pos)) ? !1 : (r && r(o.tr.join(e.pos).scrollIntoView()), !0);
}
function Yh(o, e, r, t) {
  let n = e.nodeBefore, a = e.nodeAfter, s, i, l = n.type.spec.isolating || a.type.spec.isolating;
  if (!l && aE(o, e, r))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (i = n.contentMatchAt(n.childCount)).findWrapping(a.type)) && i.matchType(s[0] || a.type).validEnd) {
    if (r) {
      let g = e.pos + a.nodeSize, p = oe.empty;
      for (let f = s.length - 1; f >= 0; f--)
        p = oe.from(s[f].create(null, p));
      p = oe.from(n.copy(p));
      let d = o.tr.step(new mo(e.pos - 1, g, e.pos, g, new de(p, 1, 0), s.length, !0)), h = d.doc.resolve(g + 2 * s.length);
      h.nodeAfter && h.nodeAfter.type == n.type && Kr(d.doc, h.pos) && d.join(h.pos), r(d.scrollIntoView());
    }
    return !0;
  }
  let u = a.type.spec.isolating || t > 0 && l ? null : we.findFrom(e, 1), m = u && u.$from.blockRange(u.$to), y = m && Tt(m);
  if (y != null && y >= e.depth)
    return r && r(o.tr.lift(m, y).scrollIntoView()), !0;
  if (c && Dt(a, "start", !0) && Dt(n, "end")) {
    let g = n, p = [];
    for (; p.push(g), !g.isTextblock; )
      g = g.lastChild;
    let d = a, h = 1;
    for (; !d.isTextblock; d = d.firstChild)
      h++;
    if (g.canReplace(g.childCount, g.childCount, d.content)) {
      if (r) {
        let f = oe.empty;
        for (let b = p.length - 1; b >= 0; b--)
          f = oe.from(p[b].copy(f));
        let F = o.tr.step(new mo(e.pos - p.length, e.pos + a.nodeSize, e.pos + h, e.pos + a.nodeSize - h, new de(f, p.length, 0), 0, !0));
        r(F.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Jh(o) {
  return function(e, r) {
    let t = e.selection, n = o < 0 ? t.$from : t.$to, a = n.depth;
    for (; n.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return n.node(a).isTextblock ? (r && r(e.tr.setSelection(Ne.create(e.doc, o < 0 ? n.start(a) : n.end(a)))), !0) : !1;
  };
}
const sE = Jh(-1), iE = Jh(1);
function lE(o, e = null) {
  return function(r, t) {
    let { $from: n, $to: a } = r.selection, s = n.blockRange(a), i = s && jh(s, o, e);
    return i ? (t && t(r.tr.wrap(s, i).scrollIntoView()), !0) : !1;
  };
}
function um(o, e = null) {
  return function(r, t) {
    let n = !1;
    for (let a = 0; a < r.selection.ranges.length && !n; a++) {
      let { $from: { pos: s }, $to: { pos: i } } = r.selection.ranges[a];
      r.doc.nodesBetween(s, i, (l, c) => {
        if (n)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(o, e)))
          if (l.type == o)
            n = !0;
          else {
            let u = r.doc.resolve(c), m = u.index();
            n = u.parent.canReplaceWith(m, m + 1, o);
          }
      });
    }
    if (!n)
      return !1;
    if (t) {
      let a = r.tr;
      for (let s = 0; s < r.selection.ranges.length; s++) {
        let { $from: { pos: i }, $to: { pos: l } } = r.selection.ranges[s];
        a.setBlockType(i, l, o, e);
      }
      t(a.scrollIntoView());
    }
    return !0;
  };
}
function ku(...o) {
  return function(e, r, t) {
    for (let n = 0; n < o.length; n++)
      if (o[n](e, r, t))
        return !0;
    return !1;
  };
}
ku(bu, Lh, Wh);
ku(bu, Gh, Zh);
ku(Xh, qh, Uh, tE);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function cE(o, e = null) {
  return function(r, t) {
    let { $from: n, $to: a } = r.selection, s = n.blockRange(a);
    if (!s)
      return !1;
    let i = t ? r.tr : null;
    return uE(i, s, o, e) ? (t && t(i.scrollIntoView()), !0) : !1;
  };
}
function uE(o, e, r, t = null) {
  let n = !1, a = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(r) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    a = new Es(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Es(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), n = !0;
  }
  let i = jh(a, r, t, e);
  return i ? (o && pE(o, e, i, n, r), !0) : !1;
}
function pE(o, e, r, t, n) {
  let a = oe.empty;
  for (let u = r.length - 1; u >= 0; u--)
    a = oe.from(r[u].type.create(r[u].attrs, a));
  o.step(new mo(e.start - (t ? 2 : 0), e.end, e.start, e.end, new de(a, 0, 0), r.length, !0));
  let s = 0;
  for (let u = 0; u < r.length; u++)
    r[u].type == n && (s = u + 1);
  let i = r.length - s, l = e.start + r.length - (t ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, m = e.endIndex, y = !0; u < m; u++, y = !1)
    !y && or(o.doc, l, i) && (o.split(l, i), l += 2 * i), l += c.child(u).nodeSize;
  return o;
}
function dE(o) {
  return function(e, r) {
    let { $from: t, $to: n } = e.selection, a = t.blockRange(n, (s) => s.childCount > 0 && s.firstChild.type == o);
    return a ? r ? t.node(a.depth - 1).type == o ? gE(e, r, o, a) : mE(e, r, a) : !0 : !1;
  };
}
function gE(o, e, r, t) {
  let n = o.tr, a = t.end, s = t.$to.end(t.depth);
  a < s && (n.step(new mo(a - 1, s, a, s, new de(oe.from(r.create(null, t.parent.copy())), 1, 0), 1, !0)), t = new Es(n.doc.resolve(t.$from.pos), n.doc.resolve(s), t.depth));
  const i = Tt(t);
  if (i == null)
    return !1;
  n.lift(t, i);
  let l = n.doc.resolve(n.mapping.map(a, -1) - 1);
  return Kr(n.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && n.join(l.pos), e(n.scrollIntoView()), !0;
}
function mE(o, e, r) {
  let t = o.tr, n = r.parent;
  for (let g = r.end, p = r.endIndex - 1, d = r.startIndex; p > d; p--)
    g -= n.child(p).nodeSize, t.delete(g - 1, g + 1);
  let a = t.doc.resolve(r.start), s = a.nodeAfter;
  if (t.mapping.map(r.end) != r.start + a.nodeAfter.nodeSize)
    return !1;
  let i = r.startIndex == 0, l = r.endIndex == n.childCount, c = a.node(-1), u = a.index(-1);
  if (!c.canReplace(u + (i ? 0 : 1), u + 1, s.content.append(l ? oe.empty : oe.from(n))))
    return !1;
  let m = a.pos, y = m + s.nodeSize;
  return t.step(new mo(m - (i ? 1 : 0), y + (l ? 1 : 0), m + 1, y - 1, new de((i ? oe.empty : oe.from(n.copy(oe.empty))).append(l ? oe.empty : oe.from(n.copy(oe.empty))), i ? 0 : 1, l ? 0 : 1), i ? 0 : 1)), e(t.scrollIntoView()), !0;
}
function yE(o) {
  return function(e, r) {
    let { $from: t, $to: n } = e.selection, a = t.blockRange(n, (c) => c.childCount > 0 && c.firstChild.type == o);
    if (!a)
      return !1;
    let s = a.startIndex;
    if (s == 0)
      return !1;
    let i = a.parent, l = i.child(s - 1);
    if (l.type != o)
      return !1;
    if (r) {
      let c = l.lastChild && l.lastChild.type == i.type, u = oe.from(c ? o.create() : null), m = new de(oe.from(o.create(null, oe.from(i.type.create(null, u)))), c ? 3 : 1, 0), y = a.start, g = a.end;
      r(e.tr.step(new mo(y - (c ? 3 : 1), g, y, g, m, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Qh(o) {
  const { state: e, transaction: r } = o;
  let { selection: t } = r, { doc: n } = r, { storedMarks: a } = r;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return t;
    },
    get doc() {
      return n;
    },
    get tr() {
      return t = r.selection, n = r.doc, a = r.storedMarks, r;
    }
  };
}
class fE {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: r, state: t } = this, { view: n } = r, { tr: a } = t, s = this.buildProps(a);
    return Object.fromEntries(Object.entries(e).map(([i, l]) => [i, (...u) => {
      const m = l(...u)(s);
      return !a.getMeta("preventDispatch") && !this.hasCustomState && n.dispatch(a), m;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, r = !0) {
    const { rawCommands: t, editor: n, state: a } = this, { view: s } = n, i = [], l = !!e, c = e || a.tr, u = () => (!l && r && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), i.every((y) => y === !0)), m = {
      ...Object.fromEntries(Object.entries(t).map(([y, g]) => [y, (...d) => {
        const h = this.buildProps(c, r), f = g(...d)(h);
        return i.push(f), m;
      }])),
      run: u
    };
    return m;
  }
  createCan(e) {
    const { rawCommands: r, state: t } = this, n = !1, a = e || t.tr, s = this.buildProps(a, n);
    return {
      ...Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(a, n)
    };
  }
  buildProps(e, r = !0) {
    const { rawCommands: t, editor: n, state: a } = this, { view: s } = n, i = {
      tr: e,
      editor: n,
      view: s,
      state: Qh({
        state: a,
        transaction: e
      }),
      dispatch: r ? () => {
      } : void 0,
      chain: () => this.createChain(e, r),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(t).map(([l, c]) => [l, (...u) => c(...u)(i)]));
      }
    };
    return i;
  }
}
function so(o, e, r) {
  return o.config[e] === void 0 && o.parent ? so(o.parent, e, r) : typeof o.config[e] == "function" ? o.config[e].bind({
    ...r,
    parent: o.parent ? so(o.parent, e, r) : null
  }) : o.config[e];
}
function hE(o) {
  const e = o.filter((n) => n.type === "extension"), r = o.filter((n) => n.type === "node"), t = o.filter((n) => n.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: r,
    markExtensions: t
  };
}
function ro(o, e) {
  if (typeof o == "string") {
    if (!e.nodes[o])
      throw Error(`There is no node type named '${o}'. Maybe you forgot to add the extension?`);
    return e.nodes[o];
  }
  return o;
}
function Ks(...o) {
  return o.filter((e) => !!e).reduce((e, r) => {
    const t = { ...e };
    return Object.entries(r).forEach(([n, a]) => {
      if (!t[n]) {
        t[n] = a;
        return;
      }
      if (n === "class") {
        const i = a ? String(a).split(" ") : [], l = t[n] ? t[n].split(" ") : [], c = i.filter((u) => !l.includes(u));
        t[n] = [...l, ...c].join(" ");
      } else if (n === "style") {
        const i = a ? a.split(";").map((u) => u.trim()).filter(Boolean) : [], l = t[n] ? t[n].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [m, y] = u.split(":").map((g) => g.trim());
          c.set(m, y);
        }), i.forEach((u) => {
          const [m, y] = u.split(":").map((g) => g.trim());
          c.set(m, y);
        }), t[n] = Array.from(c.entries()).map(([u, m]) => `${u}: ${m}`).join("; ");
      } else
        t[n] = a;
    }), t;
  }, {});
}
function FE(o) {
  return typeof o == "function";
}
function io(o, e = void 0, ...r) {
  return FE(o) ? e ? o.bind(e)(...r) : o(...r) : o;
}
function bE(o) {
  return Object.prototype.toString.call(o) === "[object RegExp]";
}
class vE {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function PE(o) {
  return Object.prototype.toString.call(o).slice(8, -1);
}
function qa(o) {
  return PE(o) !== "Object" ? !1 : o.constructor === Object && Object.getPrototypeOf(o) === Object.prototype;
}
function _s(o, e) {
  const r = { ...o };
  return qa(o) && qa(e) && Object.keys(e).forEach((t) => {
    qa(e[t]) && qa(o[t]) ? r[t] = _s(o[t], e[t]) : r[t] = e[t];
  }), r;
}
class St {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = io(so(this, "addOptions", {
      name: this.name
    }))), this.storage = io(so(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new St(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => _s(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new St(e);
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = io(so(r, "addOptions", {
      name: r.name
    })), r.storage = io(so(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  static handleExit({ editor: e, mark: r }) {
    const { tr: t } = e.state, n = e.state.selection.$from;
    if (n.pos === n.end()) {
      const s = n.marks();
      if (!!!s.find((c) => (c == null ? void 0 : c.type.name) === r.name))
        return !1;
      const l = s.find((c) => (c == null ? void 0 : c.type.name) === r.name);
      return l && t.removeStoredMark(l), t.insertText(" ", n.pos), e.view.dispatch(t), !0;
    }
    return !1;
  }
}
class BE {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
class Io {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = io(so(this, "addOptions", {
      name: this.name
    }))), this.storage = io(so(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Io(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => _s(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new Io({ ...this.config, ...e });
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = io(so(r, "addOptions", {
      name: r.name
    })), r.storage = io(so(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
}
function kE(o, e, r) {
  const { from: t, to: n } = e, { blockSeparator: a = `

`, textSerializers: s = {} } = r || {};
  let i = "";
  return o.nodesBetween(t, n, (l, c, u, m) => {
    var y;
    l.isBlock && c > t && (i += a);
    const g = s == null ? void 0 : s[l.type.name];
    if (g)
      return u && (i += g({
        node: l,
        pos: c,
        parent: u,
        index: m,
        range: e
      })), !1;
    l.isText && (i += (y = l == null ? void 0 : l.text) === null || y === void 0 ? void 0 : y.slice(Math.max(t, c) - c, n - c));
  }), i;
}
function wE(o) {
  return Object.fromEntries(Object.entries(o.nodes).filter(([, e]) => e.spec.toText).map(([e, r]) => [e, r.spec.toText]));
}
Io.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new _r({
        key: new $r("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: o } = this, { state: e, schema: r } = o, { doc: t, selection: n } = e, { ranges: a } = n, s = Math.min(...a.map((u) => u.$from.pos)), i = Math.max(...a.map((u) => u.$to.pos)), l = wE(r);
            return kE(t, { from: s, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
});
const DE = () => ({ editor: o, view: e }) => (requestAnimationFrame(() => {
  var r;
  o.isDestroyed || (e.dom.blur(), (r = window == null ? void 0 : window.getSelection()) === null || r === void 0 || r.removeAllRanges());
}), !0), SE = (o = !1) => ({ commands: e }) => e.setContent("", o), EE = () => ({ state: o, tr: e, dispatch: r }) => {
  const { selection: t } = e, { ranges: n } = t;
  return r && n.forEach(({ $from: a, $to: s }) => {
    o.doc.nodesBetween(a.pos, s.pos, (i, l) => {
      if (i.type.isText)
        return;
      const { doc: c, mapping: u } = e, m = c.resolve(u.map(l)), y = c.resolve(u.map(l + i.nodeSize)), g = m.blockRange(y);
      if (!g)
        return;
      const p = Tt(g);
      if (i.type.isTextblock) {
        const { defaultType: d } = m.parent.contentMatchAt(m.index());
        e.setNodeMarkup(g.start, d);
      }
      (p || p === 0) && e.lift(g, p);
    });
  }), !0;
}, xE = (o) => (e) => o(e), AE = () => ({ state: o, dispatch: e }) => qh(o, e), CE = (o, e) => ({ editor: r, tr: t }) => {
  const { state: n } = r, a = n.doc.slice(o.from, o.to);
  t.deleteRange(o.from, o.to);
  const s = t.mapping.map(e);
  return t.insert(s, a.content), t.setSelection(new Ne(t.doc.resolve(s - 1))), !0;
}, OE = () => ({ tr: o, dispatch: e }) => {
  const { selection: r } = o, t = r.$anchor.node();
  if (t.content.size > 0)
    return !1;
  const n = o.selection.$anchor;
  for (let a = n.depth; a > 0; a -= 1)
    if (n.node(a).type === t.type) {
      if (e) {
        const i = n.before(a), l = n.after(a);
        o.delete(i, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, TE = (o) => ({ tr: e, state: r, dispatch: t }) => {
  const n = ro(o, r.schema), a = e.selection.$anchor;
  for (let s = a.depth; s > 0; s -= 1)
    if (a.node(s).type === n) {
      if (t) {
        const l = a.before(s), c = a.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, jE = (o) => ({ tr: e, dispatch: r }) => {
  const { from: t, to: n } = o;
  return r && e.delete(t, n), !0;
}, ME = () => ({ state: o, dispatch: e }) => bu(o, e), zE = () => ({ commands: o }) => o.keyboardShortcut("Enter"), NE = () => ({ state: o, dispatch: e }) => oE(o, e);
function Os(o, e, r = { strict: !0 }) {
  const t = Object.keys(e);
  return t.length ? t.every((n) => r.strict ? e[n] === o[n] : bE(e[n]) ? e[n].test(o[n]) : e[n] === o[n]) : !0;
}
function Kh(o, e, r = {}) {
  return o.find((t) => t.type === e && Os(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(r).map((n) => [n, t.attrs[n]])),
    r
  ));
}
function pm(o, e, r = {}) {
  return !!Kh(o, e, r);
}
function wu(o, e, r) {
  var t;
  if (!o || !e)
    return;
  let n = o.parent.childAfter(o.parentOffset);
  if ((!n.node || !n.node.marks.some((u) => u.type === e)) && (n = o.parent.childBefore(o.parentOffset)), !n.node || !n.node.marks.some((u) => u.type === e) || (r = r || ((t = n.node.marks[0]) === null || t === void 0 ? void 0 : t.attrs), !Kh([...n.node.marks], e, r)))
    return;
  let s = n.index, i = o.start() + n.offset, l = s + 1, c = i + n.node.nodeSize;
  for (; s > 0 && pm([...o.parent.child(s - 1).marks], e, r); )
    s -= 1, i -= o.parent.child(s).nodeSize;
  for (; l < o.parent.childCount && pm([...o.parent.child(l).marks], e, r); )
    c += o.parent.child(l).nodeSize, l += 1;
  return {
    from: i,
    to: c
  };
}
function Sr(o, e) {
  if (typeof o == "string") {
    if (!e.marks[o])
      throw Error(`There is no mark type named '${o}'. Maybe you forgot to add the extension?`);
    return e.marks[o];
  }
  return o;
}
const IE = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  const a = Sr(o, t.schema), { doc: s, selection: i } = r, { $from: l, from: c, to: u } = i;
  if (n) {
    const m = wu(l, a, e);
    if (m && m.from <= c && m.to >= u) {
      const y = Ne.create(s, m.from, m.to);
      r.setSelection(y);
    }
  }
  return !0;
}, RE = (o) => (e) => {
  const r = typeof o == "function" ? o(e) : o;
  for (let t = 0; t < r.length; t += 1)
    if (r[t](e))
      return !0;
  return !1;
};
function _h(o) {
  return o instanceof Ne;
}
function Ir(o = 0, e = 0, r = 0) {
  return Math.min(Math.max(o, e), r);
}
function LE(o, e = null) {
  if (!e)
    return null;
  const r = we.atStart(o), t = we.atEnd(o);
  if (e === "start" || e === !0)
    return r;
  if (e === "end")
    return t;
  const n = r.from, a = t.to;
  return e === "all" ? Ne.create(o, Ir(0, n, a), Ir(o.content.size, n, a)) : Ne.create(o, Ir(e, n, a), Ir(e, n, a));
}
function HE() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Du() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const WE = (o = null, e = {}) => ({ editor: r, view: t, tr: n, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (Du() || HE()) && t.dom.focus(), requestAnimationFrame(() => {
      r.isDestroyed || (t.focus(), e != null && e.scrollIntoView && r.commands.scrollIntoView());
    });
  };
  if (t.hasFocus() && o === null || o === !1)
    return !0;
  if (a && o === null && !_h(r.state.selection))
    return s(), !0;
  const i = LE(n.doc, o) || r.state.selection, l = r.state.selection.eq(i);
  return a && (l || n.setSelection(i), l && n.storedMarks && n.setStoredMarks(n.storedMarks), s()), !0;
}, VE = (o, e) => (r) => o.every((t, n) => e(t, { ...r, index: n })), GE = (o, e) => ({ tr: r, commands: t }) => t.insertContentAt({ from: r.selection.from, to: r.selection.to }, o, e), $h = (o) => {
  const e = o.childNodes;
  for (let r = e.length - 1; r >= 0; r -= 1) {
    const t = e[r];
    t.nodeType === 3 && t.nodeValue && /^(\n\s\s|\n)$/.test(t.nodeValue) ? o.removeChild(t) : t.nodeType === 1 && $h(t);
  }
  return o;
};
function Ua(o) {
  const e = `<body>${o}</body>`, r = new window.DOMParser().parseFromString(e, "text/html").body;
  return $h(r);
}
function Ts(o, e, r) {
  if (o instanceof Vr || o instanceof oe)
    return o;
  r = {
    slice: !0,
    parseOptions: {},
    ...r
  };
  const t = typeof o == "object" && o !== null, n = typeof o == "string";
  if (t)
    try {
      if (Array.isArray(o) && o.length > 0)
        return oe.fromArray(o.map((i) => e.nodeFromJSON(i)));
      const s = e.nodeFromJSON(o);
      return r.errorOnInvalidContent && s.check(), s;
    } catch (a) {
      if (r.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", o, "Error:", a), Ts("", e, r);
    }
  if (n) {
    if (r.errorOnInvalidContent) {
      let s = !1, i = "";
      const l = new j5({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, i = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (r.slice ? ht.fromSchema(l).parseSlice(Ua(o), r.parseOptions) : ht.fromSchema(l).parse(Ua(o), r.parseOptions), r.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${i}`) });
    }
    const a = ht.fromSchema(e);
    return r.slice ? a.parseSlice(Ua(o), r.parseOptions).content : a.parse(Ua(o), r.parseOptions);
  }
  return Ts("", e, r);
}
function ZE(o, e, r) {
  const t = o.steps.length - 1;
  if (t < e)
    return;
  const n = o.steps[t];
  if (!(n instanceof bo || n instanceof mo))
    return;
  const a = o.mapping.maps[t];
  let s = 0;
  a.forEach((i, l, c, u) => {
    s === 0 && (s = u);
  }), o.setSelection(we.near(o.doc.resolve(s), r));
}
const XE = (o) => !("type" in o), qE = (o, e, r) => ({ tr: t, dispatch: n, editor: a }) => {
  var s;
  if (n) {
    r = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...r
    };
    let i;
    try {
      i = Ts(e, a.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...r.parseOptions
        },
        errorOnInvalidContent: (s = r.errorOnInvalidContent) !== null && s !== void 0 ? s : a.options.enableContentCheck
      });
    } catch (p) {
      return a.emit("contentError", {
        editor: a,
        error: p,
        disableCollaboration: () => {
          a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof o == "number" ? { from: o, to: o } : { from: o.from, to: o.to }, u = !0, m = !0;
    if ((XE(i) ? i : [i]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, m = m ? p.isBlock : !1;
    }), l === c && m) {
      const { parent: p } = t.doc.resolve(l);
      p.isTextblock && !p.type.spec.code && !p.childCount && (l -= 1, c += 1);
    }
    let g;
    if (u) {
      if (Array.isArray(e))
        g = e.map((p) => p.text || "").join("");
      else if (e instanceof oe) {
        let p = "";
        e.forEach((d) => {
          d.text && (p += d.text);
        }), g = p;
      } else typeof e == "object" && e && e.text ? g = e.text : g = e;
      t.insertText(g, l, c);
    } else
      g = i, t.replaceWith(l, c, g);
    r.updateSelection && ZE(t, t.steps.length - 1, -1), r.applyInputRules && t.setMeta("applyInputRules", { from: l, text: g }), r.applyPasteRules && t.setMeta("applyPasteRules", { from: l, text: g });
  }
  return !0;
}, UE = () => ({ state: o, dispatch: e }) => _5(o, e), YE = () => ({ state: o, dispatch: e }) => $5(o, e), JE = () => ({ state: o, dispatch: e }) => Lh(o, e), QE = () => ({ state: o, dispatch: e }) => Gh(o, e), KE = () => ({ state: o, dispatch: e, tr: r }) => {
  try {
    const t = Js(o.doc, o.selection.$from.pos, -1);
    return t == null ? !1 : (r.join(t, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, _E = () => ({ state: o, dispatch: e, tr: r }) => {
  try {
    const t = Js(o.doc, o.selection.$from.pos, 1);
    return t == null ? !1 : (r.join(t, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, $E = () => ({ state: o, dispatch: e }) => Q5(o, e), ex = () => ({ state: o, dispatch: e }) => K5(o, e);
function e1() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function ox(o) {
  const e = o.split(/-(?!$)/);
  let r = e[e.length - 1];
  r === "Space" && (r = " ");
  let t, n, a, s;
  for (let i = 0; i < e.length - 1; i += 1) {
    const l = e[i];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      t = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      n = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      Du() || e1() ? s = !0 : n = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return t && (r = `Alt-${r}`), n && (r = `Ctrl-${r}`), s && (r = `Meta-${r}`), a && (r = `Shift-${r}`), r;
}
const rx = (o) => ({ editor: e, view: r, tr: t, dispatch: n }) => {
  const a = ox(o).split(/-(?!$)/), s = a.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), i = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    r.someProp("handleKeyDown", (c) => c(r, i));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(t.mapping);
    u && n && t.maybeStep(u);
  }), !0;
};
function Su(o, e, r = {}) {
  const { from: t, to: n, empty: a } = o.selection, s = e ? ro(e, o.schema) : null, i = [];
  o.doc.nodesBetween(t, n, (m, y) => {
    if (m.isText)
      return;
    const g = Math.max(t, y), p = Math.min(n, y + m.nodeSize);
    i.push({
      node: m,
      from: g,
      to: p
    });
  });
  const l = n - t, c = i.filter((m) => s ? s.name === m.node.type.name : !0).filter((m) => Os(m.node.attrs, r, { strict: !1 }));
  return a ? !!c.length : c.reduce((m, y) => m + y.to - y.from, 0) >= l;
}
const tx = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = ro(o, r.schema);
  return Su(r, n, e) ? eE(r, t) : !1;
}, nx = () => ({ state: o, dispatch: e }) => Uh(o, e), ax = (o) => ({ state: e, dispatch: r }) => {
  const t = ro(o, e.schema);
  return dE(t)(e, r);
}, sx = () => ({ state: o, dispatch: e }) => Xh(o, e);
function o1(o, e) {
  return e.nodes[o] ? "node" : e.marks[o] ? "mark" : null;
}
function dm(o, e) {
  const r = typeof e == "string" ? [e] : e;
  return Object.keys(o).reduce((t, n) => (r.includes(n) || (t[n] = o[n]), t), {});
}
const ix = (o, e) => ({ tr: r, state: t, dispatch: n }) => {
  let a = null, s = null;
  const i = o1(typeof o == "string" ? o : o.name, t.schema);
  return i ? (i === "node" && (a = ro(o, t.schema)), i === "mark" && (s = Sr(o, t.schema)), n && r.selection.ranges.forEach((l) => {
    t.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      a && a === c.type && r.setNodeMarkup(u, void 0, dm(c.attrs, e)), s && c.marks.length && c.marks.forEach((m) => {
        s === m.type && r.addMark(u, u + c.nodeSize, s.create(dm(m.attrs, e)));
      });
    });
  }), !0) : !1;
}, lx = () => ({ tr: o, dispatch: e }) => (e && o.scrollIntoView(), !0), cx = () => ({ tr: o, dispatch: e }) => {
  if (e) {
    const r = new Ao(o.doc);
    o.setSelection(r);
  }
  return !0;
}, ux = () => ({ state: o, dispatch: e }) => Wh(o, e), px = () => ({ state: o, dispatch: e }) => Zh(o, e), dx = () => ({ state: o, dispatch: e }) => nE(o, e), gx = () => ({ state: o, dispatch: e }) => iE(o, e), mx = () => ({ state: o, dispatch: e }) => sE(o, e);
function yx(o, e, r = {}, t = {}) {
  return Ts(o, e, {
    slice: !1,
    parseOptions: r,
    errorOnInvalidContent: t.errorOnInvalidContent
  });
}
const fx = (o, e = !1, r = {}, t = {}) => ({ editor: n, tr: a, dispatch: s, commands: i }) => {
  var l, c;
  const { doc: u } = a;
  if (r.preserveWhitespace !== "full") {
    const m = yx(o, n.schema, r, {
      errorOnInvalidContent: (l = t.errorOnInvalidContent) !== null && l !== void 0 ? l : n.options.enableContentCheck
    });
    return s && a.replaceWith(0, u.content.size, m).setMeta("preventUpdate", !e), !0;
  }
  return s && a.setMeta("preventUpdate", !e), i.insertContentAt({ from: 0, to: u.content.size }, o, {
    parseOptions: r,
    errorOnInvalidContent: (c = t.errorOnInvalidContent) !== null && c !== void 0 ? c : n.options.enableContentCheck
  });
};
function hx(o, e) {
  const r = Sr(e, o.schema), { from: t, to: n, empty: a } = o.selection, s = [];
  a ? (o.storedMarks && s.push(...o.storedMarks), s.push(...o.selection.$head.marks())) : o.doc.nodesBetween(t, n, (l) => {
    s.push(...l.marks);
  });
  const i = s.find((l) => l.type.name === r.name);
  return i ? { ...i.attrs } : {};
}
function Fx(o) {
  for (let e = 0; e < o.edgeCount; e += 1) {
    const { type: r } = o.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
function bx(o, e) {
  for (let r = o.depth; r > 0; r -= 1) {
    const t = o.node(r);
    if (e(t))
      return {
        pos: r > 0 ? o.before(r) : 0,
        start: o.start(r),
        depth: r,
        node: t
      };
  }
}
function Eu(o) {
  return (e) => bx(e.$from, o);
}
function r1(o, e, r) {
  const t = [];
  return o === e ? r.resolve(o).marks().forEach((n) => {
    const a = r.resolve(o), s = wu(a, n.type);
    s && t.push({
      mark: n,
      ...s
    });
  }) : r.nodesBetween(o, e, (n, a) => {
    !n || (n == null ? void 0 : n.nodeSize) === void 0 || t.push(...n.marks.map((s) => ({
      from: a,
      to: a + n.nodeSize,
      mark: s
    })));
  }), t;
}
function ps(o, e, r) {
  return Object.fromEntries(Object.entries(r).filter(([t]) => {
    const n = o.find((a) => a.type === e && a.name === t);
    return n ? n.attribute.keepOnSplit : !1;
  }));
}
function vx(o, e, r = {}) {
  const { empty: t, ranges: n } = o.selection, a = e ? Sr(e, o.schema) : null;
  if (t)
    return !!(o.storedMarks || o.selection.$from.marks()).filter((m) => a ? a.name === m.type.name : !0).find((m) => Os(m.attrs, r, { strict: !1 }));
  let s = 0;
  const i = [];
  if (n.forEach(({ $from: m, $to: y }) => {
    const g = m.pos, p = y.pos;
    o.doc.nodesBetween(g, p, (d, h) => {
      if (!d.isText && !d.marks.length)
        return;
      const f = Math.max(g, h), F = Math.min(p, h + d.nodeSize), b = F - f;
      s += b, i.push(...d.marks.map((v) => ({
        mark: v,
        from: f,
        to: F
      })));
    });
  }), s === 0)
    return !1;
  const l = i.filter((m) => a ? a.name === m.mark.type.name : !0).filter((m) => Os(m.mark.attrs, r, { strict: !1 })).reduce((m, y) => m + y.to - y.from, 0), c = i.filter((m) => a ? m.mark.type !== a && m.mark.type.excludes(a) : !0).reduce((m, y) => m + y.to - y.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function gm(o, e) {
  const { nodeExtensions: r } = hE(e), t = r.find((s) => s.name === o);
  if (!t)
    return !1;
  const n = {
    name: t.name,
    options: t.options,
    storage: t.storage
  }, a = io(so(t, "group", n));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function t1(o, { checkChildren: e = !0, ignoreWhitespace: r = !1 } = {}) {
  var t;
  if (r) {
    if (o.type.name === "hardBreak")
      return !0;
    if (o.isText)
      return /^\s*$/m.test((t = o.text) !== null && t !== void 0 ? t : "");
  }
  if (o.isText)
    return !o.text;
  if (o.isAtom || o.isLeaf)
    return !1;
  if (o.content.childCount === 0)
    return !0;
  if (e) {
    let n = !0;
    return o.content.forEach((a) => {
      n !== !1 && (t1(a, { ignoreWhitespace: r, checkChildren: e }) || (n = !1));
    }), n;
  }
  return !1;
}
function Px(o, e, r) {
  var t;
  const { selection: n } = e;
  let a = null;
  if (_h(n) && (a = n.$cursor), a) {
    const i = (t = o.storedMarks) !== null && t !== void 0 ? t : a.marks();
    return !!r.isInSet(i) || !i.some((l) => l.type.excludes(r));
  }
  const { ranges: s } = n;
  return s.some(({ $from: i, $to: l }) => {
    let c = i.depth === 0 ? o.doc.inlineContent && o.doc.type.allowsMarkType(r) : !1;
    return o.doc.nodesBetween(i.pos, l.pos, (u, m, y) => {
      if (c)
        return !1;
      if (u.isInline) {
        const g = !y || y.type.allowsMarkType(r), p = !!r.isInSet(u.marks) || !u.marks.some((d) => d.type.excludes(r));
        c = g && p;
      }
      return !c;
    }), c;
  });
}
const Bx = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  const { selection: a } = r, { empty: s, ranges: i } = a, l = Sr(o, t.schema);
  if (n)
    if (s) {
      const c = hx(t, l);
      r.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      i.forEach((c) => {
        const u = c.$from.pos, m = c.$to.pos;
        t.doc.nodesBetween(u, m, (y, g) => {
          const p = Math.max(g, u), d = Math.min(g + y.nodeSize, m);
          y.marks.find((f) => f.type === l) ? y.marks.forEach((f) => {
            l === f.type && r.addMark(p, d, l.create({
              ...f.attrs,
              ...e
            }));
          }) : r.addMark(p, d, l.create(e));
        });
      });
  return Px(t, r, l);
}, kx = (o, e) => ({ tr: r }) => (r.setMeta(o, e), !0), wx = (o, e = {}) => ({ state: r, dispatch: t, chain: n }) => {
  const a = ro(o, r.schema);
  let s;
  return r.selection.$anchor.sameParent(r.selection.$head) && (s = r.selection.$anchor.parent.attrs), a.isTextblock ? n().command(({ commands: i }) => um(a, { ...s, ...e })(r) ? !0 : i.clearNodes()).command(({ state: i }) => um(a, { ...s, ...e })(i, t)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Dx = (o) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: t } = e, n = Ir(o, 0, t.content.size), a = Ce.create(t, n);
    e.setSelection(a);
  }
  return !0;
}, Sx = (o) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: t } = e, { from: n, to: a } = typeof o == "number" ? { from: o, to: o } : o, s = Ne.atStart(t).from, i = Ne.atEnd(t).to, l = Ir(n, s, i), c = Ir(a, s, i), u = Ne.create(t, l, c);
    e.setSelection(u);
  }
  return !0;
}, Ex = (o) => ({ state: e, dispatch: r }) => {
  const t = ro(o, e.schema);
  return yE(t)(e, r);
};
function mm(o, e) {
  const r = o.storedMarks || o.selection.$to.parentOffset && o.selection.$from.marks();
  if (r) {
    const t = r.filter((n) => e == null ? void 0 : e.includes(n.type.name));
    o.tr.ensureMarks(t);
  }
}
const xx = ({ keepMarks: o = !0 } = {}) => ({ tr: e, state: r, dispatch: t, editor: n }) => {
  const { selection: a, doc: s } = e, { $from: i, $to: l } = a, c = n.extensionManager.attributes, u = ps(c, i.node().type.name, i.node().attrs);
  if (a instanceof Ce && a.node.isBlock)
    return !i.parentOffset || !or(s, i.pos) ? !1 : (t && (o && mm(r, n.extensionManager.splittableMarks), e.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const m = l.parentOffset === l.parent.content.size, y = i.depth === 0 ? void 0 : Fx(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let g = m && y ? [
    {
      type: y,
      attrs: u
    }
  ] : void 0, p = or(e.doc, e.mapping.map(i.pos), 1, g);
  if (!g && !p && or(e.doc, e.mapping.map(i.pos), 1, y ? [{ type: y }] : void 0) && (p = !0, g = y ? [
    {
      type: y,
      attrs: u
    }
  ] : void 0), t) {
    if (p && (a instanceof Ne && e.deleteSelection(), e.split(e.mapping.map(i.pos), 1, g), y && !m && !i.parentOffset && i.parent.type !== y)) {
      const d = e.mapping.map(i.before()), h = e.doc.resolve(d);
      i.node(-1).canReplaceWith(h.index(), h.index() + 1, y) && e.setNodeMarkup(e.mapping.map(i.before()), y);
    }
    o && mm(r, n.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, Ax = (o, e = {}) => ({ tr: r, state: t, dispatch: n, editor: a }) => {
  var s;
  const i = ro(o, t.schema), { $from: l, $to: c } = t.selection, u = t.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const m = l.node(-1);
  if (m.type !== i)
    return !1;
  const y = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== i || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (n) {
      let f = oe.empty;
      const F = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let B = l.depth - F; B >= l.depth - 3; B -= 1)
        f = oe.from(l.node(B).copy(f));
      const b = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, v = {
        ...ps(y, l.node().type.name, l.node().attrs),
        ...e
      }, k = ((s = i.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(v)) || void 0;
      f = f.append(oe.from(i.createAndFill(null, k) || void 0));
      const E = l.before(l.depth - (F - 1));
      r.replace(E, l.after(-b), new de(f, 4 - F, 0));
      let S = -1;
      r.doc.nodesBetween(E, r.doc.content.size, (B, D) => {
        if (S > -1)
          return !1;
        B.isTextblock && B.content.size === 0 && (S = D + 1);
      }), S > -1 && r.setSelection(Ne.near(r.doc.resolve(S))), r.scrollIntoView();
    }
    return !0;
  }
  const g = c.pos === l.end() ? m.contentMatchAt(0).defaultType : null, p = {
    ...ps(y, m.type.name, m.attrs),
    ...e
  }, d = {
    ...ps(y, l.node().type.name, l.node().attrs),
    ...e
  };
  r.delete(l.pos, c.pos);
  const h = g ? [
    { type: i, attrs: p },
    { type: g, attrs: d }
  ] : [{ type: i, attrs: p }];
  if (!or(r.doc, l.pos, 2))
    return !1;
  if (n) {
    const { selection: f, storedMarks: F } = t, { splittableMarks: b } = a.extensionManager, v = F || f.$to.parentOffset && f.$from.marks();
    if (r.split(l.pos, 2, h).scrollIntoView(), !v || !n)
      return !0;
    const k = v.filter((E) => b.includes(E.type.name));
    r.ensureMarks(k);
  }
  return !0;
}, kl = (o, e) => {
  const r = Eu((s) => s.type === e)(o.selection);
  if (!r)
    return !0;
  const t = o.doc.resolve(Math.max(0, r.pos - 1)).before(r.depth);
  if (t === void 0)
    return !0;
  const n = o.doc.nodeAt(t);
  return r.node.type === (n == null ? void 0 : n.type) && Kr(o.doc, r.pos) && o.join(r.pos), !0;
}, wl = (o, e) => {
  const r = Eu((s) => s.type === e)(o.selection);
  if (!r)
    return !0;
  const t = o.doc.resolve(r.start).after(r.depth);
  if (t === void 0)
    return !0;
  const n = o.doc.nodeAt(t);
  return r.node.type === (n == null ? void 0 : n.type) && Kr(o.doc, t) && o.join(t), !0;
}, Cx = (o, e, r, t = {}) => ({ editor: n, tr: a, state: s, dispatch: i, chain: l, commands: c, can: u }) => {
  const { extensions: m, splittableMarks: y } = n.extensionManager, g = ro(o, s.schema), p = ro(e, s.schema), { selection: d, storedMarks: h } = s, { $from: f, $to: F } = d, b = f.blockRange(F), v = h || d.$to.parentOffset && d.$from.marks();
  if (!b)
    return !1;
  const k = Eu((E) => gm(E.type.name, m))(d);
  if (b.depth >= 1 && k && b.depth - k.depth <= 1) {
    if (k.node.type === g)
      return c.liftListItem(p);
    if (gm(k.node.type.name, m) && g.validContent(k.node.content) && i)
      return l().command(() => (a.setNodeMarkup(k.pos, g), !0)).command(() => kl(a, g)).command(() => wl(a, g)).run();
  }
  return !r || !v || !i ? l().command(() => u().wrapInList(g, t) ? !0 : c.clearNodes()).wrapInList(g, t).command(() => kl(a, g)).command(() => wl(a, g)).run() : l().command(() => {
    const E = u().wrapInList(g, t), S = v.filter((B) => y.includes(B.type.name));
    return a.ensureMarks(S), E ? !0 : c.clearNodes();
  }).wrapInList(g, t).command(() => kl(a, g)).command(() => wl(a, g)).run();
}, Ox = (o, e = {}, r = {}) => ({ state: t, commands: n }) => {
  const { extendEmptyMarkRange: a = !1 } = r, s = Sr(o, t.schema);
  return vx(t, s, e) ? n.unsetMark(s, { extendEmptyMarkRange: a }) : n.setMark(s, e);
}, Tx = (o, e, r = {}) => ({ state: t, commands: n }) => {
  const a = ro(o, t.schema), s = ro(e, t.schema), i = Su(t, a, r);
  let l;
  return t.selection.$anchor.sameParent(t.selection.$head) && (l = t.selection.$anchor.parent.attrs), i ? n.setNode(s, l) : n.setNode(a, { ...l, ...r });
}, jx = (o, e = {}) => ({ state: r, commands: t }) => {
  const n = ro(o, r.schema);
  return Su(r, n, e) ? t.lift(n) : t.wrapIn(n, e);
}, Mx = () => ({ state: o, dispatch: e }) => {
  const r = o.plugins;
  for (let t = 0; t < r.length; t += 1) {
    const n = r[t];
    let a;
    if (n.spec.isInputRules && (a = n.getState(o))) {
      if (e) {
        const s = o.tr, i = a.transform;
        for (let l = i.steps.length - 1; l >= 0; l -= 1)
          s.step(i.steps[l].invert(i.docs[l]));
        if (a.text) {
          const l = s.doc.resolve(a.from).marks();
          s.replaceWith(a.from, a.to, o.schema.text(a.text, l));
        } else
          s.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, zx = () => ({ tr: o, dispatch: e }) => {
  const { selection: r } = o, { empty: t, ranges: n } = r;
  return t || e && n.forEach((a) => {
    o.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, Nx = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  var a;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: i } = r, l = Sr(o, t.schema), { $from: c, empty: u, ranges: m } = i;
  if (!n)
    return !0;
  if (u && s) {
    let { from: y, to: g } = i;
    const p = (a = c.marks().find((h) => h.type === l)) === null || a === void 0 ? void 0 : a.attrs, d = wu(c, l, p);
    d && (y = d.from, g = d.to), r.removeMark(y, g, l);
  } else
    m.forEach((y) => {
      r.removeMark(y.$from.pos, y.$to.pos, l);
    });
  return r.removeStoredMark(l), !0;
}, Ix = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  let a = null, s = null;
  const i = o1(typeof o == "string" ? o : o.name, t.schema);
  return i ? (i === "node" && (a = ro(o, t.schema)), i === "mark" && (s = Sr(o, t.schema)), n && r.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let m, y, g, p;
    r.selection.empty ? t.doc.nodesBetween(c, u, (d, h) => {
      a && a === d.type && (g = Math.max(h, c), p = Math.min(h + d.nodeSize, u), m = h, y = d);
    }) : t.doc.nodesBetween(c, u, (d, h) => {
      h < c && a && a === d.type && (g = Math.max(h, c), p = Math.min(h + d.nodeSize, u), m = h, y = d), h >= c && h <= u && (a && a === d.type && r.setNodeMarkup(h, void 0, {
        ...d.attrs,
        ...e
      }), s && d.marks.length && d.marks.forEach((f) => {
        if (s === f.type) {
          const F = Math.max(h, c), b = Math.min(h + d.nodeSize, u);
          r.addMark(F, b, s.create({
            ...f.attrs,
            ...e
          }));
        }
      }));
    }), y && (m !== void 0 && r.setNodeMarkup(m, void 0, {
      ...y.attrs,
      ...e
    }), s && y.marks.length && y.marks.forEach((d) => {
      s === d.type && r.addMark(g, p, s.create({
        ...d.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, Rx = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = ro(o, r.schema);
  return lE(n, e)(r, t);
}, Lx = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = ro(o, r.schema);
  return cE(n, e)(r, t);
};
var Hx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: DE,
  clearContent: SE,
  clearNodes: EE,
  command: xE,
  createParagraphNear: AE,
  cut: CE,
  deleteCurrentNode: OE,
  deleteNode: TE,
  deleteRange: jE,
  deleteSelection: ME,
  enter: zE,
  exitCode: NE,
  extendMarkRange: IE,
  first: RE,
  focus: WE,
  forEach: VE,
  insertContent: GE,
  insertContentAt: qE,
  joinBackward: JE,
  joinDown: YE,
  joinForward: QE,
  joinItemBackward: KE,
  joinItemForward: _E,
  joinTextblockBackward: $E,
  joinTextblockForward: ex,
  joinUp: UE,
  keyboardShortcut: rx,
  lift: tx,
  liftEmptyBlock: nx,
  liftListItem: ax,
  newlineInCode: sx,
  resetAttributes: ix,
  scrollIntoView: lx,
  selectAll: cx,
  selectNodeBackward: ux,
  selectNodeForward: px,
  selectParentNode: dx,
  selectTextblockEnd: gx,
  selectTextblockStart: mx,
  setContent: fx,
  setMark: Bx,
  setMeta: kx,
  setNode: wx,
  setNodeSelection: Dx,
  setTextSelection: Sx,
  sinkListItem: Ex,
  splitBlock: xx,
  splitListItem: Ax,
  toggleList: Cx,
  toggleMark: Ox,
  toggleNode: Tx,
  toggleWrap: jx,
  undoInputRule: Mx,
  unsetAllMarks: zx,
  unsetMark: Nx,
  updateAttributes: Ix,
  wrapIn: Rx,
  wrapInList: Lx
});
Io.create({
  name: "commands",
  addCommands() {
    return {
      ...Hx
    };
  }
});
Io.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new _r({
        key: new $r("tiptapDrop"),
        props: {
          handleDrop: (o, e, r, t) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: r,
              moved: t
            });
          }
        }
      })
    ];
  }
});
Io.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new _r({
        key: new $r("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
const Wx = new $r("focusEvents");
Io.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: o } = this;
    return [
      new _r({
        key: Wx,
        props: {
          handleDOMEvents: {
            focus: (e, r) => {
              o.isFocused = !0;
              const t = o.state.tr.setMeta("focus", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(t), !1;
            },
            blur: (e, r) => {
              o.isFocused = !1;
              const t = o.state.tr.setMeta("blur", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(t), !1;
            }
          }
        }
      })
    ];
  }
});
Io.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const o = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: i }) => {
        const { selection: l, doc: c } = i, { empty: u, $anchor: m } = l, { pos: y, parent: g } = m, p = m.parent.isTextblock && y > 0 ? i.doc.resolve(y - 1) : m, d = p.parent.type.spec.isolating, h = m.pos - m.parentOffset, f = d && p.parent.childCount === 1 ? h === m.pos : we.atStart(c).from === y;
        return !u || !g.type.isTextblock || g.textContent.length || !f || f && m.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), t = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: o,
      "Mod-Backspace": o,
      "Shift-Backspace": o,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, n = {
      ...t
    }, a = {
      ...t,
      "Ctrl-h": o,
      "Alt-Backspace": o,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Du() || e1() ? a : n;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new _r({
        key: new $r("clearDocument"),
        appendTransaction: (o, e, r) => {
          if (o.some((d) => d.getMeta("composition")))
            return;
          const t = o.some((d) => d.docChanged) && !e.doc.eq(r.doc), n = o.some((d) => d.getMeta("preventClearDocument"));
          if (!t || n)
            return;
          const { empty: a, from: s, to: i } = e.selection, l = we.atStart(e.doc).from, c = we.atEnd(e.doc).to;
          if (a || !(s === l && i === c) || !t1(r.doc))
            return;
          const y = r.tr, g = Qh({
            state: r,
            transaction: y
          }), { commands: p } = new fE({
            editor: this.editor,
            state: g
          });
          if (p.clearNodes(), !!y.steps.length)
            return y;
        }
      })
    ];
  }
});
Io.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new _r({
        key: new $r("tiptapPaste"),
        props: {
          handlePaste: (o, e, r) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: r
            });
          }
        }
      })
    ];
  }
});
Io.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new _r({
        key: new $r("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function na(o) {
  return new vE({
    find: o.find,
    handler: ({ state: e, range: r, match: t }) => {
      const n = io(o.getAttributes, void 0, t);
      if (n === !1 || n === null)
        return null;
      const { tr: a } = e, s = t[t.length - 1], i = t[0];
      if (s) {
        const l = i.search(/\S/), c = r.from + i.indexOf(s), u = c + s.length;
        if (r1(r.from, r.to, e.doc).filter((g) => g.mark.type.excluded.find((d) => d === o.type && d !== g.mark.type)).filter((g) => g.to > c).length)
          return null;
        u < r.to && a.delete(u, r.to), c > r.from && a.delete(r.from + l, c);
        const y = r.from + l + s.length;
        a.addMark(r.from + l, y, o.type.create(n || {})), a.removeStoredMark(o.type);
      }
    }
  });
}
let xu = class kc {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = io(so(this, "addOptions", {
      name: this.name
    }))), this.storage = io(so(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new kc(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => _s(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new kc(e);
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = io(so(r, "addOptions", {
      name: r.name
    })), r.storage = io(so(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
};
function aa(o) {
  return new BE({
    find: o.find,
    handler: ({ state: e, range: r, match: t, pasteEvent: n }) => {
      const a = io(o.getAttributes, void 0, t, n);
      if (a === !1 || a === null)
        return null;
      const { tr: s } = e, i = t[t.length - 1], l = t[0];
      let c = r.to;
      if (i) {
        const u = l.search(/\S/), m = r.from + l.indexOf(i), y = m + i.length;
        if (r1(r.from, r.to, e.doc).filter((p) => p.mark.type.excluded.find((h) => h === o.type && h !== p.mark.type)).filter((p) => p.to > m).length)
          return null;
        y < r.to && s.delete(y, r.to), m > r.from && s.delete(r.from + u, m), c = r.from + u + i.length, s.addMark(r.from + u, c, o.type.create(a || {})), s.removeStoredMark(o.type);
      }
    }
  });
}
const Vx = xu.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), Gx = xu.create({
  name: "text",
  group: "inline"
}), Zx = xu.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: o }) {
    return ["p", Ks(this.options.HTMLAttributes, o), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: o }) => o.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), Xx = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, qx = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, Ux = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, Yx = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, Jx = St.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (o) => o.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (o) => o.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (o) => /^(bold(er)?|[5-9]\d{2,})$/.test(o) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: o }) {
    return ["strong", Ks(this.options.HTMLAttributes, o), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: o }) => o.setMark(this.name),
      toggleBold: () => ({ commands: o }) => o.toggleMark(this.name),
      unsetBold: () => ({ commands: o }) => o.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      na({
        find: Xx,
        type: this.type
      }),
      na({
        find: Ux,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      aa({
        find: qx,
        type: this.type
      }),
      aa({
        find: Yx,
        type: this.type
      })
    ];
  }
}), Qx = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, Kx = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, _x = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, $x = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, eA = St.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (o) => o.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (o) => o.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: o }) {
    return ["em", Ks(this.options.HTMLAttributes, o), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: o }) => o.setMark(this.name),
      toggleItalic: () => ({ commands: o }) => o.toggleMark(this.name),
      unsetItalic: () => ({ commands: o }) => o.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      na({
        find: Qx,
        type: this.type
      }),
      na({
        find: _x,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      aa({
        find: Kx,
        type: this.type
      }),
      aa({
        find: $x,
        type: this.type
      })
    ];
  }
}), oA = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, rA = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, tA = St.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (o) => o.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: o }) {
    return ["s", Ks(this.options.HTMLAttributes, o), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: o }) => o.setMark(this.name),
      toggleStrike: () => ({ commands: o }) => o.toggleMark(this.name),
      unsetStrike: () => ({ commands: o }) => o.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      na({
        find: oA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      aa({
        find: rA,
        type: this.type
      })
    ];
  }
}), nA = {
  class: /* @__PURE__ */ Z([
    "rounded-md flex-1 overflow-x-scroll",
    "sm:text-sm sm:leading-6",
    "focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600"
  ])
}, aA = {
  key: 1,
  class: "py-2.5 px-3 flex items-center"
}, sA = /* @__PURE__ */ W({
  __name: "InputRichText",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean },
    modelValue: { default: void 0 },
    placeholder: { default: void 0 },
    inline: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = Vx.extend({
      content: r.inline ? "inline*" : "block"
    }), n = e, a = pe("field-id", null), [s, i] = Uo(!1), l = u1("target");
    Oc(l, () => i(!1));
    const c = H1({
      editorProps: {
        attributes: {
          class: "py-1.5 px-3 !whitespace-nowrap focus:outline-none"
        },
        handleDOMEvents: {
          focus: () => {
            r.disabled || i(!0);
          }
        }
      },
      content: r.modelValue,
      editable: !r.disabled,
      extensions: [
        t,
        Gx,
        Zx,
        Jx,
        eA,
        V1,
        tA,
        G1.configure({
          placeholder: r.placeholder
        })
      ],
      onUpdate: () => {
        var u;
        n("update:modelValue", (u = c.value) == null ? void 0 : u.getJSON());
      }
    });
    return (u, m) => (w(), L(P(ca), {
      ref_key: "target",
      ref: l,
      as: "div",
      class: Z([
        "relative rounded-md shadow-sm ring-1 ring-inset ring-default-300",
        u.disabled && "opacity-50 pointer-events-none"
      ])
    }, {
      default: M(() => [
        A("div", nA, [
          P(c) ? (w(), L(P(W1), {
            key: 0,
            editor: P(c),
            role: "textbox",
            "aria-label": u.ariaLabel,
            "aria-disabled": u.disabled,
            "aria-invalid": !!u.invalid,
            "aria-describedby": u.invalid ? `${P(a)}-error` : void 0
          }, null, 8, ["editor", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby"])) : (w(), j("div", aA, [
            H(Yr, { class: "size-4 text-primary-600" })
          ]))
        ]),
        H(Ro, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "translate-y-1 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "translate-y-1 opacity-0"
        }, {
          default: M(() => [
            P(s) ? (w(), L(P(ua), {
              key: 0,
              static: "",
              class: "absolute z-10 mt-2 ml-3 rounded-md bg-white shadow-lg ring-1 ring-default-300 p-2 flex space-x-2"
            }, {
              default: M(() => {
                var y, g, p, d;
                return [
                  H(Po, {
                    icon: P(Y0),
                    size: "sm",
                    ariaLabel: "Toggle bold",
                    color: (y = P(c)) != null && y.isActive("bold") ? "primary" : "tertiary",
                    onClick: m[0] || (m[0] = (h) => {
                      var f;
                      return (f = P(c)) == null ? void 0 : f.chain().focus().toggleBold().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  H(Po, {
                    icon: P(U0),
                    size: "sm",
                    ariaLabel: "Toggle italic",
                    color: (g = P(c)) != null && g.isActive("italic") ? "primary" : "tertiary",
                    onClick: m[1] || (m[1] = (h) => {
                      var f;
                      return (f = P(c)) == null ? void 0 : f.chain().focus().toggleItalic().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  H(Po, {
                    icon: P(J0),
                    size: "sm",
                    ariaLabel: "Toggle underline",
                    color: (p = P(c)) != null && p.isActive("underline") ? "primary" : "tertiary",
                    onClick: m[2] || (m[2] = (h) => {
                      var f;
                      return (f = P(c)) == null ? void 0 : f.chain().focus().toggleUnderline().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  H(Po, {
                    icon: P($0),
                    size: "sm",
                    ariaLabel: "Toggle strike through",
                    color: (d = P(c)) != null && d.isActive("strike") ? "primary" : "tertiary",
                    onClick: m[3] || (m[3] = (h) => {
                      var f;
                      return (f = P(c)) == null ? void 0 : f.chain().focus().toggleStrike().run();
                    })
                  }, null, 8, ["icon", "color"])
                ];
              }),
              _: 1
            })) : Q("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), rN = /* @__PURE__ */ le(sA, [["__scopeId", "data-v-afc3f8d0"]]), iA = { class: "isolate flex justify-between items-center" }, lA = { class: "flex flex-1 justify-between sm:hidden" }, tN = /* @__PURE__ */ W({
  __name: "LengthAwarePagination",
  props: {
    as: { default: Co },
    paginator: {}
  },
  setup(o) {
    const e = o, r = ie(e.paginator);
    return Be("paginator", r), Be("as", e.as), Et(() => e.paginator, (t) => {
      r.value = t;
    }), (t, n) => (w(), j("nav", iA, [
      A("div", lA, [
        H(eo, {
          as: r.value.prev_page_url ? t.as : "button",
          href: r.value.prev_page_url,
          color: "secondary",
          disabled: !r.value.prev_page_url
        }, {
          default: M(() => n[0] || (n[0] = [
            se(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        H(eo, {
          as: r.value.next_page_url ? t.as : "button",
          href: r.value.next_page_url,
          color: "secondary",
          disabled: !r.value.next_page_url
        }, {
          default: M(() => n[1] || (n[1] = [
            se(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ]),
      R(t.$slots, "default")
    ]));
  }
}), nN = /* @__PURE__ */ W({
  __name: "LinkTab",
  props: {
    badge: { default: void 0 },
    current: { type: Boolean, default: !1 },
    leadingIcon: { default: void 0 }
  },
  setup(o) {
    const e = pe("link-tab-group-as");
    return (r, t) => (w(), L(Fe(P(e)), {
      class: Z([
        r.current ? "border-primary-500 text-primary-600" : "border-transparent text-default-500 hover:border-default-300 hover:text-default-700",
        "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
      ]),
      "aria-current": r.current ? "page" : void 0
    }, {
      default: M(() => [
        r.leadingIcon ? (w(), L(P(ce), {
          key: 0,
          icon: r.leadingIcon,
          class: Z([
            r.current ? "text-primary-500" : "text-default-400 group-hover:text-default-500",
            "-ml-0.5 mr-2 size-4"
          ]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"])) : Q("", !0),
        R(r.$slots, "default"),
        r.badge ? (w(), j("span", {
          key: 1,
          class: Z([
            r.current ? "bg-primary-100 text-primary-600" : "bg-default-100 text-default-900",
            "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
          ])
        }, _(r.badge), 3)) : Q("", !0)
      ]),
      _: 3
    }, 8, ["class", "aria-current"]));
  }
}), cA = { class: "overflow-x-auto" }, uA = { class: "border-b border-default-200" }, pA = { class: "-mb-px flex space-x-8" }, aN = /* @__PURE__ */ W({
  __name: "LinkTabGroup",
  props: {
    as: { default: Co }
  },
  setup(o) {
    return Be("link-tab-group-as", o.as), (r, t) => (w(), j("div", cA, [
      A("div", uA, [
        A("nav", pA, [
          R(r.$slots, "default")
        ])
      ])
    ]));
  }
}), sN = /* @__PURE__ */ W({
  __name: "Listbox",
  props: /* @__PURE__ */ lr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = cr(o, "modelValue"), t = ie(e.disabled);
    return Et(
      () => e.disabled,
      (n) => {
        t.value = n;
      }
    ), Be("disabled", t), Be("modelValue", r), (n, a) => (w(), L(P(P1), {
      modelValue: r.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => r.value = s),
      disabled: n.disabled,
      multiple: n.multiple,
      by: "id"
    }, {
      default: M(({ open: s, disabled: i }) => [
        R(n.$slots, "default", {
          open: s,
          disabled: i
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), dA = { class: "flex flex-wrap gap-2 pt-2" }, iN = /* @__PURE__ */ W({
  __name: "ListboxBadges",
  emits: ["remove"],
  setup(o, { emit: e }) {
    const r = pe("modelValue"), t = e;
    return (n, a) => (w(), j("ul", dA, [
      (w(!0), j(ye, null, je(P(r), (s) => (w(), j("li", {
        key: s.id
      }, [
        H(Qf, {
          color: "blue",
          remove: "",
          onRemove: (i) => t("remove", s)
        }, {
          default: M(() => [
            se(_(s.label), 1)
          ]),
          _: 2
        }, 1032, ["onRemove"])
      ]))), 128))
    ]));
  }
}), gA = { class: "relative" }, mA = { class: "col-start-1 row-start-1 truncate pr-6 h-6" }, lN = /* @__PURE__ */ W({
  __name: "ListboxControl",
  props: {
    value: {}
  },
  setup(o) {
    const e = pe("modelValue"), r = pe("disabled");
    return (t, n) => (w(), j("div", gA, [
      H(P(B1), {
        class: Z([
          "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-3 text-left text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6",
          P(r) && "opacity-50 pointer-events-none"
        ]),
        disabled: P(r)
      }, {
        default: M(() => {
          var a;
          return [
            A("span", mA, [
              t.$slots.value ? R(t.$slots, "value", {
                key: 0,
                selected: P(e)
              }) : t.value ? (w(), j(ye, { key: 1 }, [
                se(_(t.value), 1)
              ], 64)) : (w(), j(ye, { key: 2 }, [
                Array.isArray(P(e)) ? (w(), j(ye, { key: 0 }, [
                  se(_(P(e).map((s) => s.label).join(", ")), 1)
                ], 64)) : (w(), j(ye, { key: 1 }, [
                  se(_((a = P(e)) == null ? void 0 : a.label), 1)
                ], 64))
              ], 64))
            ]),
            H(P(ce), {
              icon: P(Yc),
              class: Z([
                "col-start-1 row-start-1 size-4 self-center justify-self-end text-default-500",
                "sm:size-3"
              ]),
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ];
        }),
        _: 3
      }, 8, ["class", "disabled"]),
      R(t.$slots, "default")
    ]));
  }
}), cN = /* @__PURE__ */ W({
  __name: "ListboxLabel",
  setup(o) {
    return (e, r) => (w(), L(No, { as: P(k1) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), uN = /* @__PURE__ */ W({
  __name: "ListboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(o) {
    return (e, r) => (w(), L(P(w1), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: M(({ active: t, selected: n }) => [
        A("li", {
          class: Z([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            t ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          A("span", {
            class: Z([
              n ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            R(e.$slots, "default")
          ], 2),
          n ? (w(), j("span", {
            key: 0,
            class: Z([
              t ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            H(P(ce), {
              icon: P(ya),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : Q("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), yA = { key: 0 }, fA = { class: "flex justify-center items-center py-2" }, pN = /* @__PURE__ */ W({
  __name: "ListboxOptions",
  props: {
    endReached: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["loadMore"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), L(Ro, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: M(() => [
        yo((w(), L(P(D1), {
          class: Z([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: M(() => [
            R(t.$slots, "default"),
            t.loading ? (w(), j("li", yA, [
              A("span", fA, [
                H(Yr, { class: "size-4 text-primary-600" })
              ])
            ])) : Q("", !0)
          ]),
          _: 3
        })), [
          [P(Ns), [() => r("loadMore"), { distance: 10, canLoadMore: () => !t.loading && !t.endReached }]]
        ])
      ]),
      _: 3
    }));
  }
}), hA = ["fill"], dN = /* @__PURE__ */ W({
  __name: "SpectreLogo",
  props: {
    color: { default: "black" }
  },
  setup(o) {
    return (e, r) => (w(), j("svg", {
      viewBox: "0 0 763 100",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Spectre logo"
    }, r[0] || (r[0] = [
      rr('<path d="M757.24 19.4393V1.06225H697.727L707.823 19.4393H757.24Z"></path><path d="M707.844 97.4941H758.518V79.117H699.005L707.844 97.4941Z"></path><path d="M717.366 59.3802H749.295V40.9819H707.823L717.366 59.3802Z"></path><path d="M282.62 19.4393V1.06225H223.107L233.224 19.4393H282.62Z"></path><path d="M233.224 97.4939H283.898V79.1168H224.385L233.224 97.4939Z"></path><path d="M242.746 59.3802H274.696V40.9819H233.224L242.746 59.3802Z"></path><path d="M440.73 18.3983H473.746V97.409H492.17V18.3983H525.186V0.021286H440.73V18.3983Z"></path><path d="M376.894 81.4114C359.47 81.4114 345.305 67.2834 345.305 49.9049C345.305 32.5264 359.47 18.3983 376.894 18.3983C382.602 18.3983 388.183 19.928 393.039 22.8173L402.475 7.03218C394.765 2.44323 385.904 0.021286 376.894 0.021286C349.31 0.021286 326.881 22.3924 326.881 49.9049C326.881 77.4173 349.31 99.7885 376.894 99.7885C386.01 99.7885 394.956 97.3028 402.731 92.6289L393.21 76.9075C388.311 79.8393 382.666 81.4114 376.894 81.4114Z"></path><path d="M40.5771 40.4083C38.1488 39.8346 35.8271 39.4947 33.5906 39.1548C31.5031 38.8361 29.5009 38.5387 27.733 38.0925C23.7924 37.094 19.5537 33.7585 19.5537 28.7872C19.5537 23.051 25.2622 18.377 32.2913 18.377C34.7408 18.377 37.1264 18.9507 39.1713 20.0554C42.8349 22.01 45.0288 25.2817 45.0288 28.7872H63.4536C63.4536 18.5045 57.4682 8.94421 47.8405 3.82413C43.1331 1.3172 37.7441 0 32.27 0C15.0806 0 1.10762 12.917 1.10762 28.7872C1.10762 41.4493 10.1815 52.603 23.1747 55.896C25.8586 56.5758 28.3933 56.9582 30.8641 57.3194C32.8025 57.6168 34.6556 57.8718 36.317 58.2754C41.0883 59.4014 46.1365 63.5442 46.1365 68.983C46.1365 72.8284 43.7721 76.4188 39.8103 78.5433C37.5737 79.7543 34.9751 80.3916 32.2913 80.3916C24.6444 80.3916 18.4248 75.2715 18.4248 68.983H0C0 85.4055 14.4842 98.7687 32.2913 98.7687C38.0423 98.7687 43.6656 97.3665 48.586 94.7109C58.448 89.3996 64.5612 79.5418 64.5612 68.983C64.5825 55.726 54.4862 43.7013 40.5771 40.4083Z"></path><path d="M639.855 32.8237C639.855 15.3177 625.563 1.06225 608.012 1.06225H589.672V1.16847H572.376V96.8991H590.801V19.4393H607.99C615.381 19.4393 621.409 25.4304 621.409 32.8237C621.409 40.1958 615.403 46.2082 607.99 46.2082H602.452V64.5852L634.488 96.8354H660.474L623.987 60.145C633.423 54.6213 639.855 44.5086 639.855 32.8237Z"></path><path d="M148.696 46.2082H131.507V19.4393H148.696C156.087 19.4393 162.115 25.4304 162.115 32.8237C162.115 40.1958 156.087 46.2082 148.696 46.2082ZM148.696 1.06225H129.27V1.16847H113.082V96.8991H131.507V64.5852H148.696C166.247 64.5852 180.54 50.3297 180.54 32.8237C180.54 15.3177 166.269 1.06225 148.696 1.06225Z"></path>', 11)
    ]), 8, hA));
  }
}), gN = /* @__PURE__ */ W({
  __name: "ModalDescription",
  setup(o) {
    return (e, r) => (w(), L(P(Sc), { class: "text-sm text-default-500" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), FA = {
  class: "grid grid-cols-2 gap-4 px-6 py-4",
  "data-slot": "modal-footer"
}, bA = { class: "justify-self-start" }, vA = { class: "flex flex-row-reverse justify-start gap-2 justify-self-end" }, mN = /* @__PURE__ */ W({
  __name: "ModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = pe("emit");
    return (r, t) => (w(), j("div", FA, [
      A("div", bA, [
        R(r.$slots, "left")
      ]),
      A("div", vA, [
        R(r.$slots, "default"),
        r.hideCancel ? Q("", !0) : (w(), L(eo, {
          key: 0,
          color: "secondary",
          type: "button",
          onClick: t[0] || (t[0] = (n) => P(e) && P(e)("close"))
        }, {
          default: M(() => t[1] || (t[1] = [
            se(" Cancel ")
          ])),
          _: 1
        }))
      ])
    ]));
  }
}), PA = {
  environmentBadge: null,
  salesLinks: null,
  lettingsLinks: null,
  emailLinks: null,
  socialLinks: null,
  printAdminLinks: null,
  identityAdminLinks: null,
  insightsLinks: null,
  printSalesLinks: null,
  printLettingsLinks: null,
  mobileLinks: null,
  accountLinks: null,
  userLinks: null,
  credits: null,
  fullBranchName: null,
  userName: null,
  csrfToken: null,
  showSalesUpsellBanner: null,
  showLettingsUpsellBanner: null,
  applicationName: null,
  isAdmin: null
}, ym = ie("local"), Ya = ie(null), fm = {
  local: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.engineering.local"
  },
  uat: {
    baseUrl: "https://uat.id.",
    topLevelDomain: "spectre.internal.street.engineering"
  },
  production: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.uk.com"
  }
};
function jt() {
  return { getIdsBaseUri: (t) => {
    if (Ya.value !== null && Ya.value !== void 0 && t === "local")
      return Ya.value;
    const { baseUrl: n, topLevelDomain: a } = fm[t];
    return `${n}${a}`;
  }, getTopLevelDomain: (t) => {
    const { topLevelDomain: n } = fm[t];
    return n;
  }, initialiseEnvironment: (t, n) => {
    ym.value = t, Ya.value = n;
  }, environment: ym };
}
const { getIdsBaseUri: BA } = jt();
function kA() {
  return { client: async ({ env: e, route: r, method: t }) => {
    const n = BA(e);
    return (await Tc({
      url: n + r,
      method: t
    })).data;
  } };
}
var $o = /* @__PURE__ */ ((o) => (o.Print = "print", o.Email = "email", o.Insights = "insights", o.Social = "social", o.Identity = "identity", o))($o || {});
const wA = [
  { icon: "faHouse", title: "Dashboard", description: "Sales dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact vendors with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faCalendarStar", title: "Anniversaries", description: "Automatically keep in touch with your past purchasers.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faScaleBalanced", title: "Fee Recovery", description: "Reclaim fees you’re owed with Spectre’s easy-to-use Fee Recovery.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], DA = [
  { icon: "faHouse", title: "Dashboard", description: "Lettings dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact landlords with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPersonShelter", title: "Landlords", description: "Manage, add, update and nurture landlord relationships.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], SA = [
  { icon: "faChartLine", title: "Email Dashboard", description: "View the performance of your emails and track overall engagement and delivery", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPaperPlaneTop", title: "Emails", description: "Create new emails and see the performance of sent emails", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faArrowProgress", title: "Automated Journeys", description: "Set up and manage workflows and automate your email marketing", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faUsers", title: "Audience", description: "View, manage and segment your audiences", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faLayerGroup", title: "Templates", description: "Design your own branded templates with lego like blocks", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Manage your email settings for your company and preferences", link: null, subLinks: null, badge: null, isInertia: null }
], EA = [
  { icon: "faBuildingMagnifyingGlass", title: "Search and Create", description: "Explore, research, and create reports on millions of properties across the UK", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faMemoCircleCheck", title: "Saved Property Reports", description: "View, edit, and share your previously created reports", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faImageUser", title: "Leads", description: "View your leads generated by lead capture reports and landing pages", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBrowsers", title: "Landing Pages", description: "Create and manage your landing pages for instant valuations and more", link: null, subLinks: null, badge: null, isInertia: null }
], xA = "_SPECTRE_IMPERSONATED_BY", $s = ie(null), ei = ie(null), Au = ie(null), Cu = ie(null), Ou = ie(null), AA = ae(() => $s.value !== null && ei.value !== null), wc = () => {
  $s.value = null, ei.value = null, Au.value = null, Cu.value = null, Ou.value = null;
}, n1 = (o) => {
  if (o === null) {
    wc();
    return;
  }
  const {
    currentUser: e,
    shadowedUser: r,
    shadowedAccount: t,
    shadowedCompany: n,
    endSessionUrl: a
  } = o;
  typeof e != "object" && typeof r != "object" && wc(), $s.value = typeof e == "object" ? e : null, ei.value = typeof r == "object" ? r : null, Cu.value = typeof t == "object" ? t : null, Au.value = typeof n == "object" ? n : null, Ou.value = typeof a == "string" ? new URL(a) : a instanceof URL ? a : null;
}, CA = () => {
  if (typeof (document == null ? void 0 : document.cookie) != "string")
    return null;
  const o = document.cookie.split("; ").find((r) => r.startsWith(xA));
  if (o === void 0)
    return null;
  const e = window.atob(decodeURIComponent(o.split("=")[1]));
  return JSON.parse(e) ?? null;
}, OA = (o) => {
  wc();
  const e = CA();
  n1({
    ...e,
    ...typeof o == "object" ? o : {}
  });
};
function oi() {
  return {
    currentUser: $s,
    shadowedUser: ei,
    shadowedAccount: Cu,
    shadowedCompany: Au,
    endSessionUrl: Ou,
    isShadowing: AA,
    update: n1,
    initialiseShadowbar: OA
  };
}
const Me = ie(PA), Dl = ie(!1), Sl = ie(!1), El = ie(!1), hm = ie(!1), Fm = ie(!1), TA = ie(!1), { client: bm } = kA(), { update: jA } = oi();
function Ko() {
  const o = (l) => {
    l != null && (window.location.href = l);
  }, e = ae(() => {
    if (Me.value.credits === null)
      return "0";
    const l = parseFloat(Me.value.credits.branchCreditLimit), c = parseFloat(Me.value.credits.branchCreditsUsedThisMonth);
    return (l - c).toFixed(2);
  }), r = ae(() => Me.value.userName === null ? "" : Me.value.userName[0]), t = (l) => {
    Me.value = l, Sl.value = l.showSalesUpsellBanner ?? !1, El.value = l.showLettingsUpsellBanner ?? !1;
  }, n = (l) => {
    var h, f, F, b, v;
    const {
      print: c,
      insights: u,
      email: m,
      social: y,
      identity: g,
      shadowbarData: p,
      isAdmin: d
    } = l.data;
    return ((c == null ? void 0 : c.links.sales) === void 0 || (h = c == null ? void 0 : c.links.sales) != null && h.is_static) && (Sl.value = !0), ((c == null ? void 0 : c.links.lettings) === void 0 || (f = c == null ? void 0 : c.links.lettings) != null && f.is_static) && (El.value = !0), (u == null ? void 0 : u.links) === void 0 && (hm.value = !0), (m == null ? void 0 : m.links) === void 0 && (Fm.value = !0), y == null || y.links, p !== null && typeof p == "object" && jA(p), {
      salesLinks: ((F = c == null ? void 0 : c.links.sales) == null ? void 0 : F.links) ?? wA,
      lettingsLinks: ((b = c == null ? void 0 : c.links.lettings) == null ? void 0 : b.links) ?? DA,
      insightsLinks: (u == null ? void 0 : u.links) ?? EA,
      emailLinks: (m == null ? void 0 : m.links) ?? SA,
      // TODO: add social upsell links when social links are added to AS.
      socialLinks: (y == null ? void 0 : y.links) ?? [],
      mobileLinks: (c == null ? void 0 : c.links.mobile.links) ?? [],
      printAdminLinks: ((v = c == null ? void 0 : c.links.admin) == null ? void 0 : v.links) ?? [],
      identityAdminLinks: (g == null ? void 0 : g.links) ?? [],
      isAdmin: d
    };
  }, a = async (l, c, u, m = 5, y = 1e3) => {
    for (let g = 1; g <= m; g++)
      try {
        const p = u ? `/api/user/navigation/${c}?currentAccountId=${u}` : `/api/user/navigation/${c}`, d = await bm({
          env: l,
          route: p,
          method: "GET"
        }), {
          salesLinks: h,
          lettingsLinks: f,
          insightsLinks: F,
          emailLinks: b,
          socialLinks: v,
          printAdminLinks: k,
          identityAdminLinks: E,
          mobileLinks: S,
          isAdmin: B
        } = n(d);
        Me.value.isAdmin = B, Me.value.applicationName !== $o.Print && (Me.value.salesLinks = h), Me.value.applicationName !== $o.Print && (Me.value.lettingsLinks = f), Me.value.applicationName !== $o.Insights && (Me.value.insightsLinks = F), Me.value.applicationName !== $o.Email && (Me.value.emailLinks = b), Me.value.applicationName !== $o.Social && (Me.value.socialLinks = v), Me.value.applicationName !== $o.Print && (Me.value.mobileLinks = S), Me.value.applicationName !== $o.Print && (Me.value.printAdminLinks = k), Me.value.applicationName !== $o.Identity && (Me.value.identityAdminLinks = E);
        return;
      } catch (p) {
        if (console.error(`Attempt ${g} failed. Error fetching links:`, p), g === m) {
          console.error("All retry attempts failed. Exiting function.");
          return;
        }
        await new Promise((d) => setTimeout(d, g * y));
      }
  }, s = async (l, c, u) => await bm({
    env: l,
    route: `/api/request-access/${c}/${u}`,
    method: "POST"
  });
  return {
    initialiseNavigation: t,
    navigation: Me,
    fetchLinks: async ({ env: l, userUUID: c, currentAccountId: u }) => {
      Dl.value = !0, await a(l, c, u), Dl.value = !1;
    },
    getUsernameAbbreviation: r,
    redirectToTarget: o,
    remainingCredits: e,
    showSalesUpsellBanner: Cr(Sl),
    showLettingsUpsellBanner: Cr(El),
    showInsightsUpsellBanner: Cr(hm),
    showEmailUpsellBanner: Cr(Fm),
    showSocialUpsellBanner: Cr(TA),
    linksLoading: Dl,
    requestAccess: s
  };
}
function ri(o, e) {
  return w(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    A("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function MA(o, e) {
  return w(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    A("path", {
      "fill-rule": "evenodd",
      d: "M3.25 3A2.25 2.25 0 0 0 1 5.25v9.5A2.25 2.25 0 0 0 3.25 17h13.5A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H3.25Zm.943 8.752a.75.75 0 0 1 .055-1.06L6.128 9l-1.88-1.693a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 0 1-1.06-.055ZM9.75 10.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zA(o, e) {
  return w(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    A("path", {
      "fill-rule": "evenodd",
      d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const NA = ["onClick"], IA = {
  key: 0,
  class: "block text-black font-semibold px-3 py-2 leading-6 text-sm"
}, RA = ["action"], LA = ["value"], HA = {
  type: "submit",
  class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left"
}, WA = ["href", "target"], a1 = /* @__PURE__ */ W({
  __name: "BasicPanel",
  props: {
    links: {},
    csrfToken: {}
  },
  emits: ["selected"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), L(P(ca), { class: "relative" }, {
      default: M(({ open: a }) => [
        H(P(tr), {
          class: Z(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[300px]", a ? "bg-primary-600" : ""])
        }, {
          default: M(() => [
            R(t.$slots, "default"),
            H(P(ri), {
              class: Z(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": a }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        H(Ro, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: M(() => [
            H(P(ua), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 w-56 rounded-md bg-white p-2 shadow-lg ring-1 ring-gray-900/5" }, {
              default: M(() => [
                (w(!0), j(ye, null, je(t.links, (s) => (w(), j("div", {
                  key: s.name,
                  onClick: (i) => r("selected", s)
                }, [
                  s.isHeading ? (w(), j("span", IA, _(s.name), 1)) : s.isForm ? (w(), j("form", {
                    key: 1,
                    action: s.href,
                    method: "post"
                  }, [
                    A("input", {
                      type: "hidden",
                      name: "_token",
                      value: t.csrfToken
                    }, null, 8, LA),
                    A("button", HA, _(s.name), 1)
                  ], 8, RA)) : (w(), j("a", {
                    key: 2,
                    href: s.href,
                    target: s.target ? s.target : "",
                    class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm"
                  }, _(s.name), 9, WA))
                ], 8, NA))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), VA = { class: "inline-flex items-center px-3 h-9 text-sm rounded-md text-white bg-red-500 mr-3" }, GA = {
  __name: "EnvironmentBadge",
  setup(o) {
    const { navigation: e } = Ko();
    return (r, t) => (w(), j("div", VA, [
      H(P(MA), { class: "w-4 h-4 mr-2" }),
      se(" " + _(P(e).environmentBadge), 1)
    ]));
  }
}, vm = /* @__PURE__ */ W({
  __name: "Credits",
  props: {
    credits: {}
  },
  setup(o) {
    return (e, r) => (w(), j("span", null, [
      r[0] || (r[0] = A("span", null, "Company Credits", -1)),
      r[1] || (r[1] = A("span", { class: "mx-2" }, "|", -1)),
      A("span", null, _(e.credits), 1)
    ]));
  }
}), ZA = {
  key: 0,
  class: "inline-flex place-items-center text-sm font-medium leading-6 text-white gap-x-4"
}, XA = {
  key: 0,
  class: "text-white"
}, qA = /* @__PURE__ */ W({
  __name: "PrintCredits",
  setup(o) {
    const { navigation: e, remainingCredits: r } = Ko();
    return (t, n) => P(e).credits ? (w(), j("div", ZA, [
      P(e).credits.branchCreditLimit ? (w(), j("span", XA, [
        n[0] || (n[0] = A("span", null, "Branch Credits", -1)),
        n[1] || (n[1] = A("span", { class: "mx-2" }, "|", -1)),
        A("span", null, _(P(r)) + " / " + _(P(e).credits.branchCreditLimit), 1)
      ])) : Q("", !0),
      P(e).credits.canManageCredits ? (w(), L(a1, {
        key: 1,
        links: P(e).credits.links,
        "csrf-token": P(e).csrfToken
      }, {
        default: M(() => [
          H(vm, {
            credits: P(e).credits.credits
          }, null, 8, ["credits"])
        ]),
        _: 1
      }, 8, ["links", "csrf-token"])) : (w(), L(vm, {
        key: 2,
        credits: P(e).credits.credits
      }, null, 8, ["credits"]))
    ])) : Q("", !0);
  }
});
function UA(o, e) {
  return w(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    A("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const YA = {
  faBuildingMagnifyingGlass: wk,
  faMemoCircleCheck: Nk,
  faImageUser: Tk,
  faBrowsers: Yk,
  faGears: kk,
  faBolt: Ek,
  faCalendarStar: Wk,
  faScaleBalanced: Bk,
  faPersonShelter: Lk,
  faHouse: Gf,
  faUsers: Xk,
  faBadgeCheck: jk,
  faCommentsDollar: Ik,
  faKey: Zk,
  faCalendarDay: Pk,
  faScrewdriverWrench: Mk,
  faFileChartLine: Gk,
  faGear: Ak,
  faChartLine: zk,
  faPaperPlaneTop: Hk,
  faArrowProgress: Uk,
  faLayerGroup: Rk,
  faPipe: xk,
  faEyeSlash: qf,
  faInfoCircle: Ok
};
function Tu() {
  return {
    resolveIcon: (e) => e === null ? null : YA[e]
  };
}
const JA = { class: "relative self-start" }, QA = {
  key: 1,
  class: "w-1.5 h-1.5 rounded-full bg-red-400 absolute -top-1.5 -right-1.5"
}, KA = { class: "block text-left" }, _A = { class: "flex justify-start items-center mb-1" }, $A = { class: "font-medium text-black text-sm block mr-3" }, eC = { class: "text-gray-400 text-xs block" }, oC = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md bg-primary-50 border border-primary-200", rC = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md", tC = /* @__PURE__ */ W({
  __name: "PanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean },
    isVerticalMovement: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { resolveIcon: r } = Tu(), t = o, n = ae(() => r(t.link.icon)), a = ae(() => t.isVerticalMovement ? oC : rC), s = e, i = (l) => {
      l.link !== null && s("inertiaLinkClick", l);
    };
    return (l, c) => (w(), L(Fe(l.link.isInertia ? P(tr) : "button"), {
      class: Z(["border border-white w-full flex p-4 items-center gap-x-6 rounded-md", a.value]),
      onClick: c[0] || (c[0] = (u) => i(l.link))
    }, {
      default: M(() => [
        A("span", JA, [
          n.value ? (w(), L(P(ce), {
            key: 0,
            icon: n.value,
            class: "size-8 text-gray-500"
          }, null, 8, ["icon"])) : Q("", !0),
          l.link.badge ? (w(), j("span", QA)) : Q("", !0)
        ]),
        A("span", KA, [
          A("span", _A, [
            A("span", $A, _(l.link.title), 1)
          ]),
          A("span", eC, _(l.link.description), 1)
        ]),
        l.hasSubLinks ? (w(), L(P(UA), {
          key: 0,
          class: "size-6 text-gray-500 shrink-0"
        })) : Q("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function nC() {
  const o = ie(0), e = ie(0), r = ie(!1);
  return {
    handleMouseOver: (n) => {
      const a = n.clientX - o.value, s = n.clientY - e.value;
      return o.value = n.clientX, e.value = n.clientY, r.value = Math.abs(s) > Math.abs(a), r.value;
    }
  };
}
const Pm = "data:image/png;base64,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", aC = "data:image/png;base64,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", sC = "data:image/png;base64,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", iC = "data:image/png;base64,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", lC = "data:image/png;base64,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", Bm = ie(null);
function s1() {
  const o = (e) => {
    Bm.value = e;
  };
  return {
    userUUID: Cr(Bm),
    setUserUUID: o
  };
}
const cC = { class: "basis-[230px] bg-gray-50 text-black flex flex-col justify-center items-center" }, uC = {
  key: 0,
  class: "mt-4"
}, pC = ["src"], dC = {
  id: "upgrade-banner-title",
  class: "text-lg font-bold text-black mt-4 px-5 text-center flex justify-center items-center"
}, gC = {
  id: "upgrade-banner-description",
  class: "text-sm font-medium text-gray-400 mt-2 px-5 text-center flex justify-center items-center"
}, mC = { class: "p-5 flex flex-col justify-center items-center" }, yC = ["disabled"], fC = ["href"], hC = /* @__PURE__ */ W({
  __name: "UpgradeBanner",
  props: {
    product: {}
  },
  setup(o) {
    const { requestAccess: e } = Ko(), { environment: r } = jt(), { userUUID: t } = s1(), n = ie(null), a = o, s = async (u) => {
      t.value !== null && (n.value = await e(r.value, u, t.value));
    }, i = {
      sales: {
        title: "Spectre Sales",
        description: "Direct mail prospecting for property instructions.",
        imagePath: Pm,
        buttonText: "Unlock",
        idProductName: "print_sales",
        learnMore: "https://spectre.uk.com/product/sales"
      },
      lettings: {
        title: "Spectre Lettings",
        description: "Identify and target landlord leads to grow your portfolio.",
        imagePath: aC,
        buttonText: "Unlock",
        idProductName: "print_lettings",
        learnMore: "https://spectre.uk.com/product/lettings"
      },
      email: {
        title: "Email Marketing",
        description: "Deliver hyper-targeted emails automatically.",
        imagePath: iC,
        buttonText: "Unlock",
        idProductName: "spectre_email",
        learnMore: "https://spectre.uk.com/product/email-marketing"
      },
      insights: {
        title: "Property Reports",
        description: "Create and share data-driven reports.",
        imagePath: sC,
        buttonText: "Unlock",
        idProductName: "property_reports",
        learnMore: "https://spectre.uk.com/product/property-reports"
      },
      social: {
        title: "Spectre Social",
        description: "Automated social feeds with on-brand content.",
        imagePath: lC,
        buttonText: "Start Free Trial",
        idProductName: "spectre_social",
        learnMore: "https://spectre.uk.com/product/social-media-automation"
      }
    }, l = {
      title: "",
      description: "",
      imagePath: Pm,
      buttonText: "",
      idProductName: "",
      learnMore: ""
    }, c = ie(i[a.product] ?? l);
    return (u, m) => {
      var y, g, p;
      return w(), j("div", cC, [
        c.value ? (w(), j("div", uC, [
          A("img", {
            src: c.value.imagePath,
            alt: "Lettings Upgrade",
            class: "w-full"
          }, null, 8, pC),
          A("p", dC, _(c.value.title), 1),
          A("p", gC, _(c.value.description), 1)
        ])) : Q("", !0),
        A("div", mC, [
          A("button", {
            class: Z([{
              "bg-primary-600 hover:bg-primary-700": n.value === null,
              "bg-green-500": ((y = n.value) == null ? void 0 : y.status) === "success",
              "bg-red-500": ((g = n.value) == null ? void 0 : g.status) === "error"
            }, "w-[189px] rounded-md px-4 py-2 text-white inline-block text-center cursor-pointer"]),
            disabled: n.value !== null,
            onClick: m[0] || (m[0] = (d) => s(c.value.idProductName))
          }, _(((p = n.value) == null ? void 0 : p.message) ?? c.value.buttonText), 11, yC),
          m[1] || (m[1] = A("div", { class: "relative my-3 w-full flex justify-center items-center" }, [
            A("div", {
              class: "absolute inset-0 flex items-center",
              "aria-hidden": "true"
            })
          ], -1)),
          A("a", {
            href: c.value.learnMore,
            target: "_blank",
            class: "text-blue-600 hover:text-blue-700 inline-block text-center"
          }, " Learn more ", 8, fC)
        ])
      ]);
    };
  }
});
function FC(o, e) {
  return w(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    A("path", {
      "fill-rule": "evenodd",
      d: "M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const bC = {
  class: "border border-white cursor-not-allowed w-full flex p-4 items-center gap-x-6 rounded-md",
  disabled: ""
}, vC = { class: "relative self-start" }, PC = { class: "block text-left" }, BC = { class: "flex justify-start items-center mb-1" }, kC = { class: "font-medium text-gray-300 text-sm block mr-3" }, wC = { class: "text-gray-300 text-xs block" }, DC = /* @__PURE__ */ W({
  __name: "DisabledPanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean }
  },
  setup(o) {
    const { resolveIcon: e } = Tu(), r = o, t = ae(() => e(r.link.icon));
    return (n, a) => (w(), j("button", bC, [
      A("span", vC, [
        t.value ? (w(), L(P(ce), {
          key: 0,
          icon: t.value,
          class: "w-8 h-8 text-gray-300"
        }, null, 8, ["icon"])) : Q("", !0)
      ]),
      A("span", PC, [
        A("span", BC, [
          A("span", kC, _(n.link.title), 1)
        ]),
        A("span", wC, _(n.link.description), 1)
      ]),
      n.hasSubLinks ? (w(), L(P(FC), {
        key: 0,
        class: "w-4 h-4 text-gray-300"
      })) : Q("", !0)
    ]));
  }
});
function ju(o) {
  const e = ie(null), r = ie(null), t = ie(!1), n = (l, c, u, m) => {
    const y = /* @__PURE__ */ new Date();
    y.setTime(y.getTime() + m * 24 * 60 * 60 * 1e3);
    const g = `; expires=${y.toUTCString()}`;
    document.cookie = `${l}=${encodeURIComponent(c)}; domain=${u}; path=/;${g}`;
  }, a = (l) => {
    const c = `${l}=`, u = document.cookie.split(";");
    for (let m = 0; m < u.length; m++) {
      let y = u[m];
      for (; y.charAt(0) === " "; ) y = y.substring(1, y.length);
      if (y.indexOf(c) === 0) return decodeURIComponent(y.substring(c.length, y.length));
    }
    return null;
  }, s = (l, c, u) => {
    n("storedLink", JSON.stringify({
      clickedLink: l,
      activeVerticalLink: c,
      product: u
    }), o, 7);
  };
  return {
    clickedLink: e,
    activeVerticalLink: r,
    isProductMatch: t,
    saveToCookieStorage: s,
    loadFromCookieStorage: (l) => {
      let c = a("storedLink");
      (c == null || c === "") && (s(null, null, l), c = a("storedLink"));
      try {
        const u = JSON.parse(c), m = (u == null ? void 0 : u.product) ?? null;
        t.value = m !== null && m === l, t.value ? (e.value = u.clickedLink ?? null, r.value = u.activeVerticalLink ?? null) : (e.value = null, r.value = null);
      } catch (u) {
        console.error("Error parsing storedLink:", u);
      }
    }
  };
}
const SC = { class: "basis-[370px] p-4 overflow-y-auto" }, EC = { key: 0 }, xC = { key: 1 }, AC = {
  key: 0,
  class: "basis-[230px] bg-gray-50 text-black px-4 py-8 overflow-y-auto"
}, CC = ["onClick"], OC = /* @__PURE__ */ W({
  __name: "NavigationPanel",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] },
    open: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { expose: e, emit: r }) {
    var k, E;
    const { isShadowing: t } = oi(), { getTopLevelDomain: n, environment: a } = jt(), s = ae(() => n(a.value)), i = o, l = r, c = ie(((E = (k = i.links) == null ? void 0 : k[0]) == null ? void 0 : E.subLinks) ?? null), { clickedLink: u, activeVerticalLink: m, saveToCookieStorage: y, loadFromCookieStorage: g } = ju(s.value), p = ae(() => c.value), { handleMouseOver: d } = nC(), h = (S, B) => {
      d(S) && B && (v(B.subLinks), m.value = B.title);
    }, f = (S) => {
      if (S.link !== null) {
        if (u.value = S.title, y(u.value, m.value, i.product), S.isInertia === !0) {
          l("inertiaLinkClick", S.link);
          return;
        }
        window.location.href = S.link;
      }
    };
    ur(() => {
      F(), window.addEventListener("resize", F), g(i.product);
    }), p1(() => {
      window.removeEventListener("resize", F);
    });
    const F = () => {
      const S = window.innerHeight;
      b.value = S - (t.value ? 144 : 72);
    }, b = ie(0), v = (S) => {
      c.value = S;
    };
    return Et(() => i.open, F), e({ activeLinks: c }), (S, B) => (w(), L(P(ua), null, {
      default: M(() => [
        A("div", {
          ref: "dropdownPanel",
          class: Z(["flex absolute -left-8 top-full z-10 mt-3 w-screen overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5", p.value || S.showUpsellBanner ? "max-w-[600px]" : "max-w-[370px]"]),
          style: zo({ maxHeight: `${b.value}px` })
        }, [
          A("div", SC, [
            S.showUpsellBanner ? (w(), j("div", xC, [
              (w(!0), j(ye, null, je(S.links, (D, x) => (w(), L(DC, {
                key: `${x}-d-link`,
                link: D,
                "has-sub-links": !!D.subLinks
              }, null, 8, ["link", "has-sub-links"]))), 128))
            ])) : (w(), j("div", EC, [
              (w(!0), j(ye, null, je(S.links, (D, x) => (w(), L(tC, {
                key: `${x}-link`,
                link: D,
                "has-sub-links": !!D.subLinks,
                "is-vertical-movement": P(m) === D.title,
                onMouseover: (C) => h(C, D),
                onInertiaLinkClick: f
              }, null, 8, ["link", "has-sub-links", "is-vertical-movement", "onMouseover"]))), 128))
            ]))
          ]),
          p.value && !S.showUpsellBanner ? (w(), j("div", AC, [
            (w(!0), j(ye, null, je(c.value, (D) => (w(), j("button", {
              key: `${D.title}-link`,
              class: Z([{
                "bg-primary-50": P(u) === D.title,
                "hover:bg-primary-50": P(u) !== D.title
              }, "text-sm rounded-md p-2 my-2 flex items-center justify-start gap-x-3 w-full"]),
              onClick: (x) => f(D)
            }, _(D.title), 11, CC))), 128))
          ])) : Q("", !0),
          S.showUpsellBanner ? (w(), L(hC, {
            key: 1,
            product: S.product
          }, null, 8, ["product"])) : Q("", !0)
        ], 6)
      ]),
      _: 1
    }));
  }
}), Ar = /* @__PURE__ */ W({
  __name: "NavigationLink",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { getTopLevelDomain: r, environment: t } = jt(), n = ae(() => r(t.value)), a = o, { isProductMatch: s, loadFromCookieStorage: i } = ju(n.value), l = e, c = (u) => {
      l("inertiaLinkClick", u);
    };
    return ur(() => {
      i(a.product);
    }), (u, m) => (w(), L(P(ca), { class: "relative" }, {
      default: M(({ open: y }) => [
        H(P(tr), {
          class: Z(["flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500", [y || P(s) && "bg-primary-500", y && "bg-primary-600"]])
        }, {
          default: M(() => [
            R(u.$slots, "default"),
            H(P(ri), {
              class: Z(["h-5 w-5 flex-none", ["text-white", { "rotate-180 transform": y }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        H(Ro, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: M(() => [
            H(OC, {
              links: u.links,
              product: u.product,
              open: y,
              "show-upsell-banner": u.showUpsellBanner,
              onInertiaLinkClick: c
            }, null, 8, ["links", "product", "open", "show-upsell-banner"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), TC = {};
function jC(o, e) {
  return w(), j("svg", He(o.$attrs, {
    viewBox: "0 0 260 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    rr('<g clip-path="url(#clip0_1429_30706)"><path d="M154.672 5.47436H164.481V28.9838H169.955V5.47436H179.765V0.00631714H154.672V5.47436Z"></path><path d="M99.9481 5.78412V0.316071H82.2659L85.272 5.78412H99.9481Z"></path><path d="M85.272 29.0091H100.328V23.541H82.6456L85.272 29.0091Z"></path><path d="M88.1009 17.6684H97.5939V12.1941H85.272L88.1009 17.6684Z"></path><path d="M258.879 5.78412V0.316071H241.197L244.197 5.78412H258.879Z"></path><path d="M244.203 29.0091H259.259V23.541H241.577L244.203 29.0091Z"></path><path d="M247.032 17.6684H256.519V12.1941H244.197L247.032 17.6684Z"></path><path d="M132.8 24.2237C127.623 24.2237 123.415 20.02 123.415 14.8491C123.415 9.67812 127.623 5.47436 132.8 5.47436C134.496 5.47436 136.154 5.9295 137.597 6.78922L140.401 2.09239C138.11 0.726961 135.477 0.00631714 132.8 0.00631714C124.605 0.00631714 117.94 6.66279 117.94 14.8491C117.94 23.0353 124.605 29.6918 132.8 29.6918C135.509 29.6918 138.167 28.9522 140.477 27.5615L137.648 22.8836C136.192 23.756 134.515 24.2237 132.8 24.2237Z"></path><path d="M12.056 12.0234C11.3346 11.8527 10.6448 11.7516 9.98026 11.6504C9.36005 11.5556 8.76516 11.4671 8.23988 11.3343C7.06909 11.0372 5.80969 10.0448 5.80969 8.56555C5.80969 6.85876 7.50576 5.46804 9.59421 5.46804C10.322 5.46804 11.0308 5.63872 11.6384 5.96744C12.7269 6.54901 13.3787 7.52251 13.3787 8.56555H18.853C18.853 5.50597 17.0747 2.66133 14.2141 1.13786C12.8155 0.391929 11.2143 0 9.58788 0C4.48067 0 0.329089 3.84343 0.329089 8.56555C0.329089 12.3331 3.02509 15.6519 6.88556 16.6317C7.68296 16.834 8.43607 16.9478 9.17019 17.0552C9.7461 17.1437 10.2967 17.2196 10.7903 17.3397C12.2079 17.6747 13.7078 18.9074 13.7078 20.5257C13.7078 21.6699 13.0053 22.7382 11.8282 23.3704C11.1637 23.7307 10.3916 23.9203 9.59421 23.9203C7.32223 23.9203 5.47427 22.3969 5.47427 20.5257H0C0 25.4122 4.30347 29.3884 9.59421 29.3884C11.3029 29.3884 12.9737 28.9712 14.4356 28.181C17.3658 26.6006 19.1821 23.6675 19.1821 20.5257C19.1884 16.5811 16.1886 13.0032 12.056 12.0234Z"></path><path d="M216.256 9.76662C216.256 4.55776 212.009 0.316071 206.794 0.316071H201.345V0.347678H196.207V28.8321H201.681V5.78411H206.788C208.984 5.78411 210.775 7.56676 210.775 9.76662C210.775 11.9602 208.99 13.7491 206.788 13.7491H205.143V19.2172L214.661 28.8131H222.382L211.541 17.896C214.345 16.2524 216.256 13.2434 216.256 9.76662Z"></path><path d="M50.9582 13.7491H45.851V5.78411H50.9582C53.1542 5.78411 54.9452 7.56676 54.9452 9.76662C54.9452 11.9602 53.1542 13.7491 50.9582 13.7491ZM50.9582 0.316071H45.1865V0.347678H40.3767V28.8321H45.851V19.2172H50.9582C56.173 19.2172 60.4195 14.9755 60.4195 9.76662C60.4195 4.55776 56.1793 0.316071 50.9582 0.316071Z"></path></g>', 1)
  ]), 16);
}
const MC = /* @__PURE__ */ le(TC, [["render", jC]]), zC = {};
function NC(o, e) {
  return w(), j("svg", He(o.$attrs, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    A("path", {
      "fill-rule": "evenodd",
      "lip-rule": "evenodd",
      d: "M16.3232 11.5055C16.7293 11.567 17.15 11.6308 17.589 11.7344H17.5849C20.2485 12.3647 22.182 14.6664 22.182 17.2079C22.182 19.2289 21.0113 21.1158 19.1227 22.1324C18.1804 22.6407 17.1036 22.9091 16.0022 22.9091C12.5921 22.9091 9.81836 20.3513 9.81836 17.2079H13.3508C13.3508 18.4116 14.5419 19.3916 16.0063 19.3916C16.5203 19.3916 17.0179 19.2696 17.4462 19.0378C18.2049 18.6312 18.6577 17.9439 18.6577 17.2079C18.6577 16.1669 17.6909 15.3739 16.7772 15.1584C16.5045 15.0922 16.2048 15.0469 15.891 14.9994C15.8387 14.9915 15.786 14.9835 15.733 14.9754C15.2598 14.9063 14.7744 14.8331 14.2605 14.703C11.7722 14.0726 10.0345 11.9378 10.0345 9.51413C10.0345 6.47648 12.7104 4.00407 15.9981 4C17.0465 4 18.0785 4.25212 18.9799 4.73196C20.8237 5.71198 21.9699 7.5419 21.9699 9.51007H18.4415C18.4415 8.8391 18.0214 8.21286 17.3198 7.83875C16.9282 7.62729 16.4713 7.5175 16.0022 7.5175C14.6561 7.5175 13.5629 8.41212 13.5629 9.51007C13.5629 10.4616 14.3747 11.1001 15.1293 11.2912C15.4534 11.3729 15.8185 11.4286 16.1998 11.4867C16.2168 11.4893 16.2339 11.4919 16.251 11.4945C16.2751 11.4982 16.2991 11.5018 16.3232 11.5055ZM21.4547 24.3636V28H12.5433L10.5456 24.3636H21.4547Z"
    }, null, -1)
  ]), 16);
}
const i1 = /* @__PURE__ */ le(zC, [["render", NC]]), IC = {
  id: "account-branch-name",
  class: "font-medium text-ellipsis overflow-hidden text-nowrap"
}, RC = { class: "flex items-center" }, LC = {
  class: "overflow-y-scroll overflow-x-hidden border-t border-solid border-gray-200 w-[300px]",
  style: { "max-height": "240px" }
}, HC = ["id", "onClick"], WC = /* @__PURE__ */ W({
  __name: "AccountSelector",
  props: {
    branchName: {},
    links: {}
  },
  emits: ["selected"],
  setup(o, { expose: e, emit: r }) {
    const t = r, n = o, a = ie(""), s = ae(() => a.value === "" ? n.links : n.links.filter((i) => i.name.toLowerCase().includes(a.value.toLowerCase())));
    return e({ filteredLinks: s }), (i, l) => (w(), L(P(ca), { class: "relative" }, {
      default: M(({ open: c }) => [
        H(P(tr), {
          class: Z(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[400px]", c ? "bg-primary-600" : ""])
        }, {
          default: M(() => [
            A("div", IC, _(i.branchName), 1),
            H(P(ri), {
              class: Z(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": c }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        H(Ro, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: M(() => [
            H(P(ua), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 overflow-hidden" }, {
              default: M(() => [
                A("div", RC, [
                  H(P(zA), { class: "h-5 w-5 text-gray-500 mx-4" }),
                  yo(A("input", {
                    "onUpdate:modelValue": l[0] || (l[0] = (u) => a.value = u),
                    type: "search",
                    class: "w-full border-none h-12 py-2 pr-2 pl-0 text-gray-500 text-sm focus:outline-none focus:ring-0",
                    placeholder: "Search"
                  }, null, 512), [
                    [Dc, a.value]
                  ])
                ]),
                A("div", LC, [
                  l[1] || (l[1] = A("span", { class: "block text-gray-600 font-medium px-3 py-2 leading-6 text-sm mx-2 mt-2" }, "All Accounts", -1)),
                  (w(!0), j(ye, null, je(s.value, (u) => (w(), j("button", {
                    id: `account-button-${u.id}`,
                    key: u.name,
                    class: "block rounded-lg font-medium text-black hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left mx-2",
                    onClick: (m) => t("selected", u)
                  }, _(u.name), 9, HC))), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), VC = { class: "flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1" }, xl = /* @__PURE__ */ W({
  __name: "PlaceholderLink",
  setup(o) {
    return (e, r) => (w(), j("span", VC, [
      R(e.$slots, "default"),
      H(P(ri), { class: "h-5 w-5 flex-none text-white" })
    ]));
  }
}), GC = { class: "flex items-center" }, ZC = { class: "flex items-center gap-x-2" }, XC = {
  id: "middle_section",
  class: "grow"
}, qC = { class: "flex items-center gap-x-2" }, UC = /* @__PURE__ */ W({
  __name: "DesktopNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {},
    userLinks: {}
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { showSalesUpsellBanner: r, showLettingsUpsellBanner: t, navigation: n, showInsightsUpsellBanner: a, showEmailUpsellBanner: s, showSocialUpsellBanner: i, linksLoading: l } = Ko(), { getTopLevelDomain: c, environment: u } = jt(), m = ae(() => c(u.value)), { saveToCookieStorage: y } = ju(m.value), g = e, p = (F) => {
      g("selectedAccount", F);
    }, d = (F) => {
      g("inertiaLinkClick", F);
    }, h = o, f = () => {
      y(null, null, null), window.location.href = h.dashboardLink;
    };
    return (F, b) => (w(), j("nav", He(F.$attrs, { class: "w-full text-white h-16 flex items-center font-inter z-50 bg-spectre-purple" }), [
      H(P(qm), { class: "flex items-center justify-between w-full mx-8" }, {
        default: M(() => {
          var v, k, E, S, B, D, x, C;
          return [
            A("section", GC, [
              A("button", {
                "aria-label": "Go to dashboard",
                onClick: f
              }, [
                H(MC, { class: "fill-white w-[150px] mr-5 hidden lg:block" }),
                H(i1, { class: "fill-white w-6 mr-5 block lg:hidden" })
              ]),
              A("div", ZC, [
                A("button", {
                  class: "text-sm font-medium leading-6 text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500",
                  onClick: f
                }, " Dashboard "),
                P(n).isAdmin ? Q("", !0) : (w(), L(Ar, {
                  key: 0,
                  links: P(n).salesLinks,
                  product: "sales",
                  "show-upsell-banner": P(r),
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[0] || (b[0] = [
                    se(" Sales ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                P(n).isAdmin ? Q("", !0) : (w(), L(Ar, {
                  key: 1,
                  links: P(n).lettingsLinks,
                  product: "lettings",
                  "show-upsell-banner": P(t),
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[1] || (b[1] = [
                    se(" Lettings ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                (v = P(n).emailLinks) != null && v.length ? (w(), L(Ar, {
                  key: 2,
                  links: P(n).emailLinks,
                  product: "email",
                  "show-upsell-banner": P(s),
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[2] || (b[2] = [
                    A("span", { class: "hidden 2xl:inline" }, "Email Marketing", -1),
                    A("span", { class: "2xl:hidden" }, "Email", -1)
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : Q("", !0),
                !((k = P(n).emailLinks) != null && k.length) && !P(s) && P(l) ? (w(), L(xl, { key: 3 }, {
                  default: M(() => b[3] || (b[3] = [
                    se(" Email Marketing ")
                  ])),
                  _: 1
                })) : Q("", !0),
                (E = P(n).insightsLinks) != null && E.length ? (w(), L(Ar, {
                  key: 4,
                  links: P(n).insightsLinks,
                  product: "insights",
                  "show-upsell-banner": P(a),
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[4] || (b[4] = [
                    A("span", { class: "hidden 2xl:inline" }, "Property Reports", -1),
                    A("span", { class: "2xl:hidden" }, "Reports", -1)
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : Q("", !0),
                !((S = P(n).insightsLinks) != null && S.length) && !P(a) && P(l) ? (w(), L(xl, { key: 5 }, {
                  default: M(() => b[5] || (b[5] = [
                    se(" Property Reports ")
                  ])),
                  _: 1
                })) : Q("", !0),
                (B = P(n).socialLinks) != null && B.length ? (w(), L(Ar, {
                  key: 6,
                  links: P(n).socialLinks,
                  product: "social",
                  "show-upsell-banner": P(i),
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[6] || (b[6] = [
                    se(" Social Media ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : Q("", !0),
                P(n).isAdmin && ((D = P(n).printAdminLinks) != null && D.length) ? (w(), L(Ar, {
                  key: 7,
                  links: P(n).printAdminLinks,
                  product: "print",
                  "show-upsell-banner": P(n).showSalesUpsellBanner,
                  onInertiaLinkClick: d
                }, {
                  default: M(() => b[7] || (b[7] = [
                    se(" Print ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : Q("", !0),
                P(n).isAdmin && !((x = P(n).printAdminLinks) != null && x.length) && P(l) ? (w(), L(xl, { key: 8 }, {
                  default: M(() => b[8] || (b[8] = [
                    se(" Print ")
                  ])),
                  _: 1
                })) : Q("", !0)
              ])
            ]),
            A("section", XC, [
              R(F.$slots, "default")
            ]),
            A("section", qC, [
              P(n).environmentBadge ? (w(), L(GA, { key: 0 })) : Q("", !0),
              P(n).credits ? (w(), L(qA, { key: 1 })) : Q("", !0),
              P(n).accountLinks && P(n).fullBranchName ? (w(), L(WC, {
                key: 2,
                "branch-name": P(n).fullBranchName,
                links: P(n).accountLinks,
                onSelected: p
              }, null, 8, ["branch-name", "links"])) : Q("", !0),
              (C = P(n).identityAdminLinks) != null && C.length ? (w(), L(Ar, {
                key: 3,
                links: P(n).identityAdminLinks,
                product: "identity",
                "show-upsell-banner": !1,
                onInertiaLinkClick: d
              }, {
                default: M(() => b[9] || (b[9] = [
                  se(" Spectre Admin ")
                ])),
                _: 1
              }, 8, ["links"])) : Q("", !0),
              b[10] || (b[10] = A("span", { class: "text-xl text-gray-300" }, "|", -1)),
              P(n).userName && F.userLinks ? (w(), L(a1, {
                key: 4,
                links: F.userLinks,
                "csrf-token": P(n).csrfToken
              }, {
                default: M(() => [
                  se(_(P(n).userName), 1)
                ]),
                _: 1
              }, 8, ["links", "csrf-token"])) : Q("", !0)
            ])
          ];
        }),
        _: 3
      })
    ], 16));
  }
}), { navigation: Al } = Ko(), ct = Rm({
  label: "",
  links: null
}), km = ie(!1);
function ti() {
  const o = (a) => {
    km.value = a;
  }, e = (a, s) => {
    ct.label = s, ct.links = a;
  }, r = () => {
    ct.label = "", ct.links = null;
  }, t = ae(() => ct.label !== ""), n = ae(() => {
    if (Al.value.mobileLinks === void 0 || Al.value.mobileLinks === null)
      return [];
    const a = Al.value.mobileLinks.find((s) => s.title === "MobileUserDropdownMenu");
    return a === void 0 ? [] : a.subLinks ?? [];
  });
  return {
    setMobileNavSlideOver: o,
    setMobileNavLinksInFocus: e,
    resetMobileNavLinksInFocus: r,
    isMobileLinksInFocus: t,
    mobileNavLinksInFocus: ct,
    getMobileDropdownLinks: n,
    isMobileNavSlideoverOpen: Cr(km)
  };
}
const YC = { class: "py-1" }, JC = /* @__PURE__ */ W({
  __name: "MobileMenuDropdown",
  props: {
    dynamicMenuLinks: {}
  },
  setup(o) {
    const { redirectToTarget: e } = Ko();
    return (r, t) => (w(), L(P(Gm), {
      as: "div",
      class: "relative z-50 inline-block text-left"
    }, {
      default: M(() => [
        A("div", null, [
          H(P(zl), { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md py-2 text-sm font-semibold text-gray-900" }, {
            default: M(() => [
              R(r.$slots, "menu-button")
            ]),
            _: 3
          })
        ]),
        H(Ro, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: M(() => [
            r.dynamicMenuLinks.length ? (w(), L(P(Zm), {
              key: 0,
              class: "absolute right-0 mr-4 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            }, {
              default: M(() => [
                A("div", YC, [
                  t[0] || (t[0] = A("p", {
                    href: "#",
                    class: "px-4 py-2 text-sm text-black font-semibold"
                  }, " Account ", -1)),
                  (w(!0), j(ye, null, je(r.dynamicMenuLinks, (n, a) => (w(), L(P(Xm), {
                    key: a,
                    onClick: (s) => P(e)(n.link)
                  }, {
                    default: M(({ active: s }) => [
                      A("a", {
                        href: "#",
                        class: Z([s ? "bg-gray-100 text-gray-900" : "text-gray-700", "block px-4 py-2 text-sm"])
                      }, _(n.title), 3)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ])
              ]),
              _: 1
            })) : Q("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), tn = /* @__PURE__ */ W({
  __name: "NavigationLink",
  props: {
    icon: {},
    iconClasses: {},
    target: {}
  },
  setup(o) {
    const e = o, { redirectToTarget: r } = Ko();
    return (t, n) => (w(), j("aside", {
      class: "flex gap-2 w-full relative items-center",
      onClick: n[0] || (n[0] = (a) => P(r)(e.target))
    }, [
      A("p", null, [
        R(t.$slots, "link-title")
      ]),
      R(t.$slots, "badge"),
      t.icon ? (w(), L(P(ce), {
        key: 0,
        icon: t.icon,
        class: Z(["w-6 w-6 text-black absolute right-0 animate duration-500", t.iconClasses])
      }, null, 8, ["icon", "class"])) : Q("", !0)
    ]));
  }
}), QC = {}, KC = { class: "bg-red-400 text-xs px-1 py-0.5 flex items-center justify-center rounded text-white" };
function _C(o, e) {
  return w(), j("span", KC, [
    R(o.$slots, "default")
  ]);
}
const l1 = /* @__PURE__ */ le(QC, [["render", _C]]), $C = {}, eO = { class: "bg-blue-100 text-xs px-1 py-0.5 flex items-center justify-center rounded text-blue-800" };
function oO(o, e) {
  return w(), j("span", eO, [
    R(o.$slots, "default")
  ]);
}
const wm = /* @__PURE__ */ le($C, [["render", oO]]), rO = { class: "flex flex-col gap-4" }, tO = { class: "mt-12 ml-2 text-sm space-y-6" }, nO = { class: "ml-2 text-sm space-y-6" }, aO = /* @__PURE__ */ W({
  __name: "NavigationLinkList",
  props: {
    dashboardLink: {}
  },
  setup(o) {
    const e = o, { navigation: r, redirectToTarget: t, remainingCredits: n } = Ko(), { setMobileNavLinksInFocus: a } = ti(), s = [
      { name: "Settings", href: "https://spectre.uk.com/portal/account/settings" },
      { name: "Help & Support", href: "https://support.spectre.uk.com/knowledge" }
    ], i = [
      {
        show: !0,
        title: "Dashboard",
        href: e.dashboardLink,
        badge: null,
        dispatchAction: () => {
          t(e.dashboardLink);
        }
      },
      {
        show: !0,
        title: "Sales",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.salesLinks === null) {
            t("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/dashboard&account_type=sales");
            return;
          }
          a(r.value.salesLinks, "Sales");
        }
      },
      {
        show: !0,
        title: "Lettings",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.lettingsLinks === null) {
            t("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/lettings/dashboard&account_type=lettings");
            return;
          }
          a(r.value.lettingsLinks, "Lettings");
        }
      },
      {
        show: r.value.emailLinks,
        title: "Email Marketing",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.emailLinks !== null && a(r.value.emailLinks, "Email Marketing");
        }
      },
      {
        show: r.value.insightsLinks,
        title: "Property Reports",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.insightsLinks !== null && a(r.value.insightsLinks, "Property Reports");
        }
      },
      {
        show: r.value.socialLinks,
        title: "Social Media",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.socialLinks !== null && a(r.value.socialLinks, "Social Media");
        }
      }
    ], l = ae(() => i.filter((c) => c.show));
    return (c, u) => (w(), j("aside", rO, [
      A("nav", tO, [
        (w(!0), j(ye, null, je(l.value, (m, y) => (w(), L(tn, {
          key: y,
          icon: P(pp),
          onClick: m.dispatchAction
        }, Nm({
          "link-title": M(() => [
            A("p", null, _(m.title), 1)
          ]),
          _: 2
        }, [
          m != null && m.badge ? {
            name: "badge",
            fn: M(() => [
              H(l1, null, {
                default: M(() => [
                  A("p", null, _(m.badge), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["icon", "onClick"]))), 128))
      ]),
      u[1] || (u[1] = A("div", { class: "h-[1px] bg-gray-200 w-full" }, null, -1)),
      A("nav", nO, [
        P(r).credits ? (w(), L(tn, { key: 0 }, {
          "link-title": M(() => u[0] || (u[0] = [
            A("p", null, "Branch credits", -1)
          ])),
          badge: M(() => [
            P(r).credits.branchCreditLimit ? (w(), L(wm, { key: 0 }, {
              default: M(() => [
                A("p", null, _(P(n)) + " / " + _(P(r).credits.branchCreditLimit), 1)
              ]),
              _: 1
            })) : (w(), L(wm, { key: 1 }, {
              default: M(() => {
                var m;
                return [
                  se(_((m = P(r).credits) == null ? void 0 : m.credits), 1)
                ];
              }),
              _: 1
            }))
          ]),
          _: 1
        })) : Q("", !0),
        (w(), j(ye, null, je(s, (m, y) => H(tn, {
          key: y,
          icon: P(pp),
          target: m.href
        }, {
          "link-title": M(() => [
            A("p", null, _(m.name), 1)
          ]),
          _: 2
        }, 1032, ["icon", "target"])), 64))
      ])
    ]));
  }
}), sO = { class: "mt-12 overflow-scroll max-h-[500px] ml-2 text-sm space-y-6" }, iO = { class: "text-base font-semibold" }, lO = { class: "w-full space-y-6" }, cO = /* @__PURE__ */ W({
  __name: "NavigationLinksInFocus",
  setup(o) {
    const { resetMobileNavLinksInFocus: e, mobileNavLinksInFocus: r } = ti();
    return (t, n) => (w(), j("section", null, [
      A("nav", sO, [
        A("p", iO, _(P(r).label), 1),
        A("aside", {
          class: "flex items-center gap-2",
          onClick: n[0] || (n[0] = //@ts-ignore
          (...a) => P(e) && P(e)(...a))
        }, [
          H(P(ce), {
            icon: P(q0),
            class: "w-6 w-6 text-black"
          }, null, 8, ["icon"]),
          n[1] || (n[1] = se(" Back "))
        ]),
        A("div", lO, [
          (w(!0), j(ye, null, je(P(r).links, (a, s) => (w(), L(P(Hm), {
            key: s,
            as: "div"
          }, {
            default: M(({ open: i }) => [
              H(P(Wm), { class: "flex w-full" }, {
                default: M(() => {
                  var l;
                  return [
                    H(tn, {
                      "icon-classes": i ? "rotate-90" : "rotate-0",
                      icon: (l = a == null ? void 0 : a.subLinks) != null && l.length ? P(Ws) : null,
                      target: a.link
                    }, {
                      "link-title": M(() => [
                        A("p", null, _(a.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon-classes", "icon", "target"])
                  ];
                }),
                _: 2
              }, 1024),
              H(Ro, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "transform opacity-0",
                "enter-to-class": "transform opacity-100",
                "leave-active-class": "transition duration-200 ease-out",
                "leave-from-class": "transform opacity-100",
                "leave-to-class": "transform opacity-0"
              }, {
                default: M(() => {
                  var l;
                  return [
                    (l = a == null ? void 0 : a.subLinks) != null && l.length ? (w(), L(P(Vm), {
                      key: 0,
                      class: "pl-4 py-2 pt-4 space-y-6 text-sm"
                    }, {
                      default: M(() => [
                        (w(!0), j(ye, null, je(a.subLinks, (c, u) => (w(), L(tn, {
                          key: u,
                          target: c.link
                        }, {
                          "link-title": M(() => [
                            A("p", null, _(c.title), 1)
                          ]),
                          badge: M(() => [
                            c != null && c.badge ? (w(), L(l1, {
                              key: 0,
                              class: "absolute right-0"
                            }, {
                              default: M(() => [
                                A("p", null, _(c.badge), 1)
                              ]),
                              _: 2
                            }, 1024)) : Q("", !0)
                          ]),
                          _: 2
                        }, 1032, ["target"]))), 128))
                      ]),
                      _: 2
                    }, 1024)) : Q("", !0)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ])
      ])
    ]));
  }
}), uO = { class: "fixed inset-0 overflow-hidden" }, pO = { class: "absolute inset-0 overflow-hidden" }, dO = { class: "pointer-events-none fixed inset-y-0 left-0 flex w-10/12" }, gO = { class: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl" }, mO = { class: "px-4 sm:px-6" }, yO = /* @__PURE__ */ W({
  __name: "MobileMenuSlideover",
  props: {
    open: { type: Boolean },
    dashboardLink: {}
  },
  emits: ["close-slide-over"],
  setup(o, { emit: e }) {
    const { isMobileLinksInFocus: r } = ti(), t = e;
    return (n, a) => (w(), L(P(sa), {
      as: "template",
      show: n.open
    }, {
      default: M(() => [
        H(P(ia), {
          class: "relative z-50",
          onClose: a[1] || (a[1] = (s) => t("close-slide-over"))
        }, {
          default: M(() => [
            H(P(qo), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: M(() => a[2] || (a[2] = [
                A("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            A("div", uO, [
              A("div", pO, [
                A("div", dO, [
                  H(P(qo), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "-translate-x-full"
                  }, {
                    default: M(() => [
                      H(P(la), { class: "pointer-events-auto relative w-screen max-w-md" }, {
                        default: M(() => [
                          A("div", gO, [
                            A("div", mO, [
                              H(P(ce), {
                                icon: P(fa),
                                class: "w-8 w-8 text-black",
                                onClick: a[0] || (a[0] = (s) => t("close-slide-over"))
                              }, null, 8, ["icon"]),
                              P(r) ? (w(), L(cO, { key: 0 })) : (w(), L(aO, {
                                key: 1,
                                "dashboard-link": n.dashboardLink
                              }, null, 8, ["dashboard-link"]))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), fO = { class: "fixed w-full z-50 text-white h-16 flex items-center border-b border-gray-200 font-inter z-49 bg-spectre-purple" }, hO = { class: "flex items-center" }, FO = ["href"], bO = { class: "w-4 h-4 text-xs font-semibold flex text-black p-4 items-center justify-center bg-gray-100 rounded-full" }, vO = /* @__PURE__ */ W({
  __name: "MobileNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {}
  },
  setup(o) {
    const { getUsernameAbbreviation: e } = Ko(), { isMobileNavSlideoverOpen: r, setMobileNavSlideOver: t, getMobileDropdownLinks: n } = ti();
    return (a, s) => (w(), j("nav", fO, [
      H(P(qm), { class: "flex items-center justify-between w-full mx-4" }, {
        default: M(() => [
          A("section", null, [
            H(P(ce), {
              icon: P(_0),
              class: "w-6 w-6 text-white",
              onClick: s[0] || (s[0] = (i) => P(t)(!0))
            }, null, 8, ["icon"])
          ]),
          A("section", hO, [
            A("a", { href: a.dashboardLink }, [
              H(i1, { class: "fill-white w-6" })
            ], 8, FO)
          ]),
          A("section", null, [
            H(JC, { "dynamic-menu-links": P(n) }, {
              "menu-button": M(() => [
                A("div", bO, [
                  A("p", null, _(P(e)), 1)
                ])
              ]),
              _: 1
            }, 8, ["dynamic-menu-links"])
          ])
        ]),
        _: 1
      }),
      H(yO, {
        open: P(r),
        "dashboard-link": a.dashboardLink,
        onCloseSlideOver: s[1] || (s[1] = (i) => P(t)(!P(r)))
      }, null, 8, ["open", "dashboard-link"])
    ]));
  }
}), PO = { class: "hidden lg:flex flex-initial items-center divide-x w-full" }, BO = { class: "font-semibold" }, kO = { class: "font-semibold" }, wO = { class: "px-2" }, DO = { class: "font-semibold" }, SO = /* @__PURE__ */ W({
  __name: "ShadowBar",
  setup(o) {
    const { resolveIcon: e } = Tu(), r = e("faPipe"), t = e("faEyeSlash"), n = e("faInfoCircle"), {
      currentUser: a,
      shadowedUser: s,
      shadowedAccount: i,
      shadowedCompany: l,
      endSessionUrl: c
    } = oi(), u = async (y) => {
      await navigator.clipboard.writeText(y);
    }, m = () => {
      if (!(c.value instanceof URL))
        throw new Error("Trying to end shadowing but URL is missing");
      window.location.href = c.value.toString();
    };
    return (y, g) => (w(), j("div", He(y.$attrs, { class: "w-full text-sm text-indigo-900 h-16 p-4 flex justify-between items-center font-inter z-50 bg-indigo-100" }), [
      A("div", PO, [
        P(t) ? (w(), L(P(ce), {
          key: 0,
          icon: P(t),
          class: "font-semibold"
        }, null, 8, ["icon"])) : Q("", !0),
        P(s) && P(a) ? (w(), j("div", {
          key: 1,
          class: "px-2 cursor-copy",
          onClick: g[0] || (g[0] = (p) => u(P(s).id))
        }, [
          A("span", BO, _(P(a).name), 1),
          g[4] || (g[4] = A("span", null, " you are currently shadowing ", -1)),
          A("span", kO, _(P(s).name), 1)
        ])) : Q("", !0),
        P(r) && P(l) ? (w(), L(P(ce), {
          key: 2,
          icon: P(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : Q("", !0),
        P(l) ? (w(), j("div", {
          key: 3,
          class: "px-2 cursor-copy",
          onClick: g[1] || (g[1] = (p) => u(P(l).id))
        }, [
          g[5] || (g[5] = A("span", { class: "font-semibold" }, "Company: ", -1)),
          A("span", null, _(P(l).name), 1)
        ])) : Q("", !0),
        P(r) && P(i) ? (w(), L(P(ce), {
          key: 4,
          icon: P(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : Q("", !0),
        P(i) ? (w(), j("div", {
          key: 5,
          class: "pl-2 cursor-copy",
          onClick: g[2] || (g[2] = (p) => u(P(i).id))
        }, [
          g[6] || (g[6] = A("span", { class: "font-semibold" }, "Account: ", -1)),
          A("span", null, _(P(i).name), 1)
        ])) : Q("", !0)
      ]),
      P(a) && P(s) ? (w(), j("div", {
        key: 0,
        class: "lg:hidden flex flex-initial items-center divide-x w-full cursor-copy",
        onClick: g[3] || (g[3] = (p) => {
          var d, h;
          return u(`User: ${P(s).id}, Company: ${((d = P(l)) == null ? void 0 : d.id) ?? "N/A"}, Account: ${((h = P(i)) == null ? void 0 : h.id) ?? "N/A"}`);
        })
      }, [
        A("div", wO, [
          A("span", DO, _(P(a).name), 1),
          g[7] || (g[7] = A("span", null, " is shadowing", -1))
        ]),
        P(n) ? (w(), L(P(ce), {
          key: 0,
          icon: P(n)
        }, null, 8, ["icon"])) : Q("", !0)
      ])) : Q("", !0),
      A("button", {
        class: "bg-indigo-800 rounded text-white text-center text-xs font-normal leading-4 align-middle min-w-24 max-w-28 h-full w-full",
        onClick: m
      }, " End Session ")
    ], 16));
  }
}), EO = { class: "hidden lg:block" }, yN = /* @__PURE__ */ W({
  __name: "NavigationBar",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: { default: null },
    environment: { default: "production" },
    userUuid: {},
    accountServiceUrl: {},
    currentAccountId: { default: null }
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { setUserUUID: r } = s1(), { initialiseNavigation: t, navigation: n, fetchLinks: a } = Ko(), { isShadowing: s, initialiseShadowbar: i } = oi(), { initialiseEnvironment: l, getIdsBaseUri: c, environment: u } = jt(), m = o, y = e, g = (v) => {
      y("inertiaLinkClick", v);
    }, p = ae(() => m.dashboardLink ?? `${c(u.value)}/dashboard`), d = ae(() => `${c(u.value)}/profile`), h = ae(() => `${c(u.value)}/settings`), f = ae(() => `${c(u.value)}/settings/users`), F = ae(() => n.value.userLinks ?? [
      { name: "Support", isHeading: !0 },
      { name: "Help Centre", href: "https://support.spectre.uk.com/knowledge", target: "_blank" },
      { name: "Make a Suggestion", href: "https://info.spectre.uk.com/feature-request", target: "_blank" },
      { name: "Contact Us", href: "https://support.spectre.uk.com/knowledge/contact-us", target: "_blank" },
      { name: "Account", isHeading: !0 },
      { name: "Users", href: f.value },
      { name: "Profile", href: d.value },
      { name: "Settings", href: h.value },
      { name: "Log Out", href: m.logoutLink, isForm: !0 }
    ]);
    ur(async () => {
      var v;
      t(m.config), i(((v = m.config) == null ? void 0 : v.shadowbarData) ?? null), l(m.environment, m.accountServiceUrl), m.userUuid !== null && (r(m.userUuid), await a({
        env: m.environment,
        userUUID: m.userUuid,
        currentAccountId: m.currentAccountId
      }));
    });
    const b = (v) => {
      y("selectedAccount", v);
    };
    return (v, k) => (w(), j("div", He(v.$attrs, { class: "w-full" }), [
      P(s) ? (w(), L(SO, { key: 0 })) : Q("", !0),
      H(vO, {
        config: v.config,
        "dashboard-link": p.value,
        "logout-link": m.logoutLink,
        "insights-links": P(n).insightsLinks,
        class: "block lg:hidden"
      }, null, 8, ["config", "dashboard-link", "logout-link", "insights-links"]),
      A("div", EO, [
        H(UC, {
          config: v.config,
          "user-links": F.value,
          "dashboard-link": p.value,
          "logout-link": m.logoutLink,
          "insights-links": P(n).insightsLinks,
          onSelectedAccount: b,
          onInertiaLinkClick: g
        }, {
          default: M(() => [
            R(v.$slots, "default")
          ]),
          _: 3
        }, 8, ["config", "user-links", "dashboard-link", "logout-link", "insights-links"])
      ])
    ], 16));
  }
}), Dm = (o) => {
  const e = d1(o);
  return {
    url: z1(e)
  };
}, fN = /* @__PURE__ */ W({
  __name: "ObjectUrlPreview",
  props: {
    file: {}
  },
  setup(o) {
    const e = o, r = ie();
    return Et(() => e.file, (t) => {
      if (t) {
        r.value = Dm(t).url.value;
        return;
      }
      r.value = void 0;
    }), ur(() => {
      r.value = Dm(e.file).url.value;
    }), (t, n) => r.value ? R(t.$slots, "default", {
      key: 0,
      url: r.value
    }) : Q("", !0);
  }
}), xO = {
  class: /* @__PURE__ */ Z([
    "py-base border-b border-default-300 bg-white"
  ])
}, AO = { class: "flex items-center gap-base" }, hN = /* @__PURE__ */ W({
  __name: "PageHeading",
  setup(o) {
    return (e, r) => (w(), j("header", xO, [
      H(X8, {
        class: Z([
          "px-base",
          "lg:px-large"
        ])
      }, {
        default: M(() => [
          A("div", AO, [
            R(e.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]));
  }
}), CO = {}, OO = { class: "flex gap-2 items-center flex-1" };
function TO(o, e) {
  return w(), j("div", OO, [
    R(o.$slots, "default")
  ]);
}
const FN = /* @__PURE__ */ le(CO, [["render", TO]]), bN = /* @__PURE__ */ W({
  __name: "PageHeadingTitle",
  props: {
    as: { default: "h1" }
  },
  setup(o) {
    return (e, r) => (w(), L(Dr, {
      as: e.as,
      size: "xl"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Sm = /* @__PURE__ */ W({
  __name: "PaginationNextPreviousLink",
  props: {
    disabled: { type: Boolean },
    link: {}
  },
  setup(o) {
    const e = pe("as");
    return (r, t) => (w(), L(Fe(r.disabled ? "button" : P(e)), {
      href: r.link.url,
      class: Z([
        "bg-white relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-default-300",
        "focus:z-20",
        r.disabled ? "opacity-50 pointer-events-none" : "hover:bg-default-50"
      ]),
      disabled: r.disabled,
      tabindex: r.disabled ? "-1" : 0,
      "aria-disabled": r.disabled
    }, {
      default: M(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "class", "disabled", "tabindex", "aria-disabled"]));
  }
}), jO = { class: "sr-only" }, MO = { class: "sr-only" }, zO = /* @__PURE__ */ W({
  __name: "PaginationLink",
  props: {
    current: { type: Boolean },
    link: {}
  },
  setup(o) {
    const e = o, r = pe("as"), t = ae(() => !e.link.url);
    return (n, a) => n.link.label === "Previous" ? (w(), L(Sm, {
      key: 0,
      class: "rounded-l-md",
      link: n.link,
      disabled: t.value
    }, {
      default: M(() => [
        H(P(ce), {
          icon: P(Uc),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        A("span", jO, _(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : n.link.label === "Next" ? (w(), L(Sm, {
      key: 1,
      class: "rounded-r-md",
      link: n.link,
      disabled: t.value
    }, {
      default: M(() => [
        H(P(ce), {
          icon: P(Ws),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        A("span", MO, _(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : (w(), L(Fe(t.value ? "span" : P(r)), {
      key: 2,
      href: n.link.url,
      class: Z([
        "relative inline-flex items-center py-2 px-4 text-sm font-medium ring-1 ring-inset",
        "focus:z-20",
        n.current ? "z-10 bg-primary-50 text-primary-600 ring-primary-500" : "text-default-700 bg-white ring-default-300",
        n.current && !t.value && "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        !n.current && !t.value && "hover:bg-default-50 hover:text-primary-600"
      ]),
      "aria-current": n.current
    }, {
      default: M(() => [
        se(_(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["href", "class", "aria-current"]));
  }
}), NO = { class: "-space-x-px hidden sm:flex" }, vN = /* @__PURE__ */ W({
  __name: "PaginationLinks",
  setup(o) {
    const e = pe("paginator");
    return (r, t) => {
      var n;
      return w(), j("div", NO, [
        (w(!0), j(ye, null, je((n = P(e)) == null ? void 0 : n.links, (a) => (w(), L(zO, {
          key: a.label,
          link: a,
          current: a.active
        }, null, 8, ["link", "current"]))), 128))
      ]);
    };
  }
}), IO = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], RO = /* @__PURE__ */ W({
  __name: "Select",
  props: /* @__PURE__ */ lr({
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = cr(o, "modelValue"), r = pe("field-id");
    return (t, n) => yo((w(), j("select", {
      id: P(r),
      "onUpdate:modelValue": n[0] || (n[0] = (a) => e.value = a),
      disabled: t.disabled,
      tabindex: t.disabled ? "-1" : 0,
      "aria-disabled": t.disabled,
      "aria-invalid": !!t.invalid,
      "aria-describedby": t.invalid ? `${P(r)}-error` : void 0,
      class: Z([
        "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 shadow-sm text-base text-default-900 ring-1 ring-inset ring-default-300",
        "focus:ring-2 focus:ring-inset focus:ring-primary-600",
        "sm:text-sm sm:leading-6",
        t.disabled && "disabled:opacity-50 disabled:pointer-events-none"
      ])
    }, [
      R(t.$slots, "default")
    ], 10, IO)), [
      [Lm, e.value]
    ]);
  }
}), LO = {
  class: /* @__PURE__ */ Z([
    "hidden",
    "sm:flex sm:space-x-3 sm:items-center"
  ])
}, HO = { key: 0 }, WO = { class: "hidden md:block text-sm text-default-700" }, VO = { class: "font-medium" }, GO = { class: "font-medium" }, ZO = { class: "font-medium" }, PN = /* @__PURE__ */ W({
  __name: "PaginationMeta",
  props: {
    perPage: {}
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = pe("paginator"), t = e;
    return (n, a) => (w(), j("div", LO, [
      H(mu, null, {
        default: M(() => [
          H(No, { class: "sr-only" }, {
            default: M(() => a[1] || (a[1] = [
              se(" Results per page ")
            ])),
            _: 1
          }),
          H(RO, {
            "model-value": n.perPage,
            "onUpdate:modelValue": a[0] || (a[0] = (s) => t("change", s))
          }, {
            default: M(() => a[2] || (a[2] = [
              A("option", { value: 10 }, " 10 ", -1),
              A("option", { value: 25 }, " 25 ", -1),
              A("option", { value: 50 }, " 50 ", -1)
            ])),
            _: 1
          }, 8, ["model-value"])
        ]),
        _: 1
      }),
      P(r) && P(r).from && P(r).to && P(r).total ? (w(), j("div", HO, [
        A("p", WO, [
          a[3] || (a[3] = se(" Showing " + _(" ") + " ")),
          A("span", VO, _(P(r).from), 1),
          a[4] || (a[4] = se(" " + _(" ") + " to " + _(" ") + " ")),
          A("span", GO, _(P(r).to), 1),
          a[5] || (a[5] = se(" " + _(" ") + " of " + _(" ") + " ")),
          A("span", ZO, _(P(r).total), 1),
          a[6] || (a[6] = se(" " + _(" ") + " results "))
        ])
      ])) : Q("", !0)
    ]));
  }
}), XO = {}, qO = { class: "inline-block cursor-wait bg-current min-h-4 animate-pulse rounded" };
function UO(o, e) {
  return w(), j("span", qO);
}
const BN = /* @__PURE__ */ le(XO, [["render", UO]]);
var Cl = {}, Ol = {}, Em;
function YO() {
  return Em || (Em = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      return Array.isArray(r) ? r.map((t) => e(t)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([t, n]) => [
        t,
        e(n)
      ])) : r;
    }
  }(Ol)), Ol;
}
var Tl, xm;
function JO() {
  return xm || (xm = 1, Tl = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: o }) => ({
        ...o("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: o }) => o("blur"),
      backdropBrightness: ({ theme: o }) => o("brightness"),
      backdropContrast: ({ theme: o }) => o("contrast"),
      backdropGrayscale: ({ theme: o }) => o("grayscale"),
      backdropHueRotate: ({ theme: o }) => o("hueRotate"),
      backdropInvert: ({ theme: o }) => o("invert"),
      backdropOpacity: ({ theme: o }) => o("opacity"),
      backdropSaturate: ({ theme: o }) => o("saturate"),
      backdropSepia: ({ theme: o }) => o("sepia"),
      backgroundColor: ({ theme: o }) => o("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: o }) => o("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: o }) => ({
        ...o("colors"),
        DEFAULT: o("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: o }) => o("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: o }) => ({
        ...o("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: o }) => o("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: o }) => o("colors"),
      colors: ({ colors: o }) => ({
        inherit: o.inherit,
        current: o.current,
        transparent: o.transparent,
        black: o.black,
        white: o.white,
        slate: o.slate,
        gray: o.gray,
        zinc: o.zinc,
        neutral: o.neutral,
        stone: o.stone,
        red: o.red,
        orange: o.orange,
        amber: o.amber,
        yellow: o.yellow,
        lime: o.lime,
        green: o.green,
        emerald: o.emerald,
        teal: o.teal,
        cyan: o.cyan,
        sky: o.sky,
        blue: o.blue,
        indigo: o.indigo,
        violet: o.violet,
        purple: o.purple,
        fuchsia: o.fuchsia,
        pink: o.pink,
        rose: o.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: o }) => o("borderColor"),
      divideOpacity: ({ theme: o }) => o("borderOpacity"),
      divideWidth: ({ theme: o }) => o("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: o }) => ({
        none: "none",
        ...o("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: o }) => o("spacing"),
      gradientColorStops: ({ theme: o }) => o("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: o }) => ({
        ...o("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: o, breakpoints: e }) => ({
        ...o("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...e(o("screens"))
      }),
      minHeight: ({ theme: o }) => ({
        ...o("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: o }) => ({
        ...o("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: o }) => o("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: o }) => o("spacing"),
      placeholderColor: ({ theme: o }) => o("colors"),
      placeholderOpacity: ({ theme: o }) => o("opacity"),
      ringColor: ({ theme: o }) => ({
        DEFAULT: o("colors.blue.500", "#3b82f6"),
        ...o("colors")
      }),
      ringOffsetColor: ({ theme: o }) => o("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: o }) => ({
        DEFAULT: "0.5",
        ...o("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: o }) => ({
        ...o("spacing")
      }),
      scrollPadding: ({ theme: o }) => o("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: o }) => ({
        ...o("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: o }) => ({
        none: "none",
        ...o("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: o }) => o("colors"),
      textDecorationColor: ({ theme: o }) => o("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: o }) => ({
        ...o("spacing")
      }),
      textOpacity: ({ theme: o }) => o("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: o }) => ({
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), Tl;
}
var Am;
function QO() {
  return Am || (Am = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const e = YO(), r = /* @__PURE__ */ t(JO());
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    const n = (0, e.cloneDeep)(r.default.theme);
  }(Cl)), Cl;
}
var jl, Cm;
function KO() {
  if (Cm) return jl;
  Cm = 1;
  let o = QO();
  return jl = (o.__esModule ? o : { default: o }).default, jl;
}
var _O = KO();
const Om = /* @__PURE__ */ Ct(_O), kN = {
  theme: {
    extend: {
      fontFamily: {
        sans: ["Inter", ...Om.fontFamily.sans],
        gilmer: ["Gilmer", ...Om.fontFamily.sans]
      },
      spacing: {
        tiny: "var(--spacing-tiny, 2px)",
        xxs: "var(--spacing-xxs, 4px)",
        xs: "var(--spacing-xs, 6px)",
        sm: "var(--spacing-sm, 8px)",
        medium: "var(--spacing-medium, 12px)",
        base: "var(--spacing-base, 16px)",
        large: "var(--spacing-large, 24px)",
        xl: "var(--spacing-xl, 32px)",
        xxl: "var(--spacing-xxl, 40px)",
        huge: "var(--spacing-huge, 48px)"
      },
      colors: {
        "spectre-purple": "rgba(var(--color-spectre-purple), <alpha-value>)",
        default: {
          50: "rgba(var(--color-default-50), <alpha-value>)",
          100: "rgba(var(--color-default-100), <alpha-value>)",
          200: "rgba(var(--color-default-200), <alpha-value>)",
          300: "rgba(var(--color-default-300), <alpha-value>)",
          400: "rgba(var(--color-default-400), <alpha-value>)",
          500: "rgba(var(--color-default-500), <alpha-value>)",
          600: "rgba(var(--color-default-600), <alpha-value>)",
          700: "rgba(var(--color-default-700), <alpha-value>)",
          800: "rgba(var(--color-default-800), <alpha-value>)",
          900: "rgba(var(--color-default-900), <alpha-value>)"
        },
        primary: {
          50: "rgba(var(--color-primary-50), <alpha-value>)",
          100: "rgba(var(--color-primary-100), <alpha-value>)",
          200: "rgba(var(--color-primary-200), <alpha-value>)",
          300: "rgba(var(--color-primary-300), <alpha-value>)",
          400: "rgba(var(--color-primary-400), <alpha-value>)",
          500: "rgba(var(--color-primary-500), <alpha-value>)",
          600: "rgba(var(--color-primary-600), <alpha-value>)",
          700: "rgba(var(--color-primary-700), <alpha-value>)",
          800: "rgba(var(--color-primary-800), <alpha-value>)",
          900: "rgba(var(--color-primary-900), <alpha-value>)"
        },
        dark: {
          50: "rgba(var(--color-dark-50), <alpha-value>)",
          100: "rgba(var(--color-dark-100), <alpha-value>)",
          200: "rgba(var(--color-dark-200), <alpha-value>)",
          300: "rgba(var(--color-dark-300), <alpha-value>)",
          400: "rgba(var(--color-dark-400), <alpha-value>)",
          500: "rgba(var(--color-dark-500), <alpha-value>)",
          600: "rgba(var(--color-dark-600), <alpha-value>)",
          700: "rgba(var(--color-dark-700), <alpha-value>)",
          800: "rgba(var(--color-dark-800), <alpha-value>)",
          900: "rgba(var(--color-dark-900), <alpha-value>)"
        },
        danger: {
          300: "rgba(var(--color-danger-300), <alpha-value>)",
          400: "rgba(var(--color-danger-400), <alpha-value>)",
          500: "rgba(var(--color-danger-500), <alpha-value>)",
          600: "rgba(var(--color-danger-600), <alpha-value>)",
          700: "rgba(var(--color-danger-700), <alpha-value>)",
          900: "rgba(var(--color-danger-900), <alpha-value>)"
        }
      }
    }
  },
  plugins: [Z1]
}, $O = ["aria-valuenow"], wN = /* @__PURE__ */ W({
  __name: "Progress",
  props: {
    value: { default: 0 }
  },
  setup(o) {
    return (e, r) => (w(), j("div", {
      class: "overflow-hidden rounded-full bg-default-200 h-2",
      role: "progressbar",
      "aria-valuenow": e.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      A("div", {
        class: "h-full rounded-full bg-gradient-to-r from-primary-800 to-primary-600 transition-all ease-in-out",
        style: zo({
          width: `${e.value}%`
        })
      }, null, 4)
    ], 8, $O));
  }
}), eT = {
  class: /* @__PURE__ */ Z([
    "space-y-base",
    "lg:flex lg:gap-x-base lg:space-y-0"
  ])
}, oT = { "aria-hidden": "true" }, rT = { class: "inline-flex size-12 items-center justify-center rounded-full bg-default-100" }, tT = {
  class: /* @__PURE__ */ Z([
    "flex-1 space-y-4",
    "lg:grid lg:space-y-1 lg:grid-cols-4 lg:gap-base lg:[&>div:first-child]:col-span-3 lg:[&>div:last-child]:text-right"
  ])
}, DN = /* @__PURE__ */ W({
  __name: "ProgressCard",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (w(), L(Kf, {
      class: Z(e.disabled && "opacity-60 pointer-events-none")
    }, {
      default: M(() => [
        H(_f, null, {
          default: M(() => [
            A("div", eT, [
              A("div", oT, [
                A("span", rT, [
                  A("span", {
                    class: Z([
                      "inline-flex size-9 items-center justify-center rounded-full",
                      e.checked ? "bg-primary-600" : "bg-default-300"
                    ])
                  }, [
                    e.checked ? (w(), L(P(ce), {
                      key: 0,
                      icon: P(Sw),
                      class: "size-4 text-white"
                    }, null, 8, ["icon"])) : Q("", !0)
                  ], 2)
                ])
              ]),
              A("div", tT, [
                R(e.$slots, "default")
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), nT = {}, aT = { class: "text-sm text-default-500" };
function sT(o, e) {
  return w(), j("p", aT, [
    R(o.$slots, "default")
  ]);
}
const SN = /* @__PURE__ */ le(nT, [["render", sT]]), iT = {}, lT = { class: "space-y-3 rounded-xl bg-default-100 p-3 shadow" };
function cT(o, e) {
  return w(), j("div", lT, [
    R(o.$slots, "default")
  ]);
}
const EN = /* @__PURE__ */ le(iT, [["render", cT]]), xN = /* @__PURE__ */ W({
  __name: "ProgressCardTitle",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "text-lg font-semibold text-black" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), uT = ["id", "value", "checked", "disabled", "tabindex", "aria-disabled"], pT = /* @__PURE__ */ W({
  __name: "Radio",
  props: /* @__PURE__ */ lr({
    checked: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = cr(o, "modelValue"), t = pe("field-id"), n = ae(() => e.checked ? !0 : e.modelValue === e.value);
    return (a, s) => yo((w(), j("input", {
      id: P(t),
      "onUpdate:modelValue": s[0] || (s[0] = (i) => r.value = i),
      type: "radio",
      class: Z([
        "h-4 w-4 rounded-full border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: a.value,
      checked: n.value,
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled
    }, null, 8, uT)), [
      [g1, r.value]
    ]);
  }
}), dT = {}, gT = { class: "space-y-3" };
function mT(o, e) {
  return w(), j("div", gT, [
    R(o.$slots, "default")
  ]);
}
const AN = /* @__PURE__ */ le(dT, [["render", mT]]), yT = ["for"], CN = /* @__PURE__ */ W({
  __name: "RadioGroupRadio",
  props: /* @__PURE__ */ lr({
    checked: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {},
    hidden: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = Qo();
    Be("field-id", e);
    const r = cr(o, "modelValue");
    return (t, n) => (w(), j("label", {
      for: P(e),
      class: Z([
        "bg-gray-50 flex items-center space-x-3 rounded-xl p-base min-h-[58px] cursor-pointer",
        "[&>*]:cursor-pointer",
        t.checked || o.modelValue === t.value ? "shadow-sm ring-2 ring-white ring-offset-2 ring-offset-primary-600" : ""
      ])
    }, [
      H(pT, {
        modelValue: r.value,
        "onUpdate:modelValue": n[0] || (n[0] = (a) => r.value = a),
        checked: t.checked,
        disabled: t.disabled,
        value: t.value,
        class: Z({
          hidden: t.hidden
        })
      }, null, 8, ["modelValue", "checked", "disabled", "value", "class"]),
      R(t.$slots, "default")
    ], 10, yT));
  }
}), ON = /* @__PURE__ */ W({
  __name: "RadioGroupRadioLabel",
  setup(o) {
    return (e, r) => (w(), L(No, { as: "span" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), TN = /* @__PURE__ */ W({
  __name: "SegmentedButton",
  props: {
    color: { default: "blue" },
    value: {}
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["red", "bg-red-100 border-red-600"],
      ["yellow", "bg-yellow-100 border-yellow-600"],
      ["green", "bg-green-100 border-green-600"],
      ["blue", "bg-blue-100 border-blue-600"],
      ["primary", "bg-primary-100 border-primary-600"],
      ["purple", "bg-purple-100 border-purple-600"],
      ["pink", "bg-pink-100 border-pink-600"]
    ]);
    return (r, t) => (w(), L(P(zs), {
      as: "template",
      value: r.value
    }, {
      default: M(({ checked: n }) => [
        A("button", {
          type: "button",
          class: Z([
            "rounded-full py-1.5 px-4 font-gilmer font-bold text-sm border text-default-700",
            "focus:outline-none",
            n ? P(e).get(r.color) : "border-default-300 bg-white"
          ])
        }, [
          R(r.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), fT = { class: "flex gap-base" }, jN = /* @__PURE__ */ W({
  __name: "SegmentedButtonGroup",
  props: {
    description: {},
    label: {}
  },
  setup(o) {
    return (e, r) => (w(), L(P(Ms), null, {
      default: M(() => [
        H(P(pa), { class: "sr-only" }, {
          default: M(() => [
            se(_(e.label), 1)
          ]),
          _: 1
        }),
        e.description ? (w(), L(P(Ec), {
          key: 0,
          class: "sr-only"
        }, {
          default: M(() => [
            se(_(e.description), 1)
          ]),
          _: 1
        })) : Q("", !0),
        A("div", fT, [
          R(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), hT = /* @__PURE__ */ W({
  __name: "SettingCardButton",
  props: {
    as: { default: "button" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "underline font-medium text-default-700" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), FT = { key: 0 }, bT = {
  key: 1,
  class: "text-default-500 font-medium text-sm"
}, MN = /* @__PURE__ */ W({
  __name: "SettingCard",
  props: {
    showEdit: { type: Boolean }
  },
  emits: ["submit", "cancel", "edit"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (w(), L(Kf, null, {
      default: M(() => [
        t.showEdit ? Q("", !0) : (w(), L(v9, {
          key: 0,
          class: "flex justify-between items-center"
        }, {
          default: M(() => [
            A("div", null, [
              R(t.$slots, "default")
            ]),
            A("div", null, [
              t.$slots.button ? R(t.$slots, "button", { key: 0 }) : (w(), L(hT, {
                key: 1,
                onClick: n[0] || (n[0] = (a) => r("edit"))
              }, {
                default: M(() => n[3] || (n[3] = [
                  se(" Edit ")
                ])),
                _: 1
              }))
            ])
          ]),
          _: 3
        })),
        A("form", {
          onSubmit: n[2] || (n[2] = Ml((a) => r("submit"), ["prevent"]))
        }, [
          H(_f, null, {
            default: M(() => [
              t.showEdit ? (w(), j("div", FT, [
                R(t.$slots, "edit")
              ])) : (w(), j("div", bT, [
                R(t.$slots, "preview")
              ]))
            ]),
            _: 3
          }),
          t.showEdit ? (w(), L(f9, {
            key: 0,
            class: "flex flex-row-reverse gap-3"
          }, {
            default: M(() => [
              H(eo, { type: "submit" }, {
                default: M(() => n[4] || (n[4] = [
                  se(" Save ")
                ])),
                _: 1
              }),
              H(eo, {
                type: "button",
                color: "secondary",
                onClick: n[1] || (n[1] = (a) => r("cancel"))
              }, {
                default: M(() => n[5] || (n[5] = [
                  se(" Cancel ")
                ])),
                _: 1
              }),
              R(t.$slots, "footer-buttons")
            ]),
            _: 3
          })) : Q("", !0)
        ], 32)
      ]),
      _: 3
    }));
  }
}), vT = { class: "grid grid-cols-9 gap-6" }, PT = { class: "col-span-9 lg:col-span-6" }, BT = {
  key: 0,
  class: /* @__PURE__ */ Z([
    "col-span-3 hidden",
    "lg:block"
  ])
}, zN = /* @__PURE__ */ W({
  __name: "SettingCardGroup",
  props: {
    help: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", vT, [
      A("div", PT, [
        R(e.$slots, "default")
      ]),
      e.help ? (w(), j("div", BT, [
        H(zS, null, {
          default: M(() => [
            A("p", null, _(e.help), 1)
          ]),
          _: 1
        })
      ])) : Q("", !0)
    ]));
  }
}), kT = {}, wT = { class: "bg-default-200 rounded-lg px-4 py-5 sm:p-6 space-y-5" };
function DT(o, e) {
  return w(), j("div", wT, [
    R(o.$slots, "default")
  ]);
}
const NN = /* @__PURE__ */ le(kT, [["render", DT]]), IN = /* @__PURE__ */ W({
  __name: "SettingCardTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), { class: "text-default-700 font-medium" }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ST = {};
function ET(o, e) {
  return w(), j("section", null, [
    R(o.$slots, "default")
  ]);
}
const RN = /* @__PURE__ */ le(ST, [["render", ET]]), xT = {}, AT = { class: "space-y-base" };
function CT(o, e) {
  return w(), j("div", AT, [
    R(o.$slots, "default")
  ]);
}
const LN = /* @__PURE__ */ le(xT, [["render", CT]]), HN = /* @__PURE__ */ W({
  __name: "SettingGroupTitle",
  props: {
    as: { default: "h2" }
  },
  setup(o) {
    return (e, r) => (w(), L(Dr, {
      as: e.as,
      size: "xl",
      class: "pb-medium"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), OT = { class: "flex items-center justify-between" }, TT = { class: "flex flex-1 justify-between sm:justify-end space-x-3" }, WN = /* @__PURE__ */ W({
  __name: "SimplePagination",
  props: {
    as: { default: Co },
    paginator: {}
  },
  setup(o) {
    return Be("paginator", o.paginator), (r, t) => (w(), j("nav", OT, [
      R(r.$slots, "default"),
      A("div", TT, [
        H(eo, {
          as: r.paginator.prev_page_url ? r.as : "button",
          href: r.paginator.prev_page_url,
          color: "secondary",
          disabled: !r.paginator.prev_page_url
        }, {
          default: M(() => t[0] || (t[0] = [
            se(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        H(eo, {
          as: r.paginator.next_page_url ? r.as : "button",
          href: r.paginator.next_page_url,
          color: "secondary",
          disabled: !r.paginator.next_page_url
        }, {
          default: M(() => t[1] || (t[1] = [
            se(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ])
    ]));
  }
}), jT = { class: "flex gap-3 items-center" }, VN = /* @__PURE__ */ W({
  __name: "SmallCardsRadioGroup",
  setup(o) {
    return (e, r) => (w(), L(P(Ms), null, {
      default: M(() => [
        A("div", jT, [
          R(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), GN = /* @__PURE__ */ W({
  __name: "SmallCardsRadioGroupLabel",
  setup(o) {
    return (e, r) => (w(), L(No, { as: P(pa) }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), ZN = /* @__PURE__ */ W({
  __name: "SmallCardsRadioGroupOption",
  setup(o) {
    return (e, r) => (w(), L(P(zs), { as: "template" }, {
      default: M(({ checked: t, disabled: n }) => [
        A("button", {
          class: Z([
            "font-medium shadow-sm text-sm px-3.5 py-2.5 cursor-pointer outline-none rounded-md overflow-hidden border",
            t ? "border-transparent bg-primary-600 text-white focus-visible:outline-primary-900" : "border-default-300 bg-white text-default-900 hover:bg-default-50",
            n && "opacity-50 pointer-events-none"
          ]),
          type: "button"
        }, [
          H(P(pa), { as: "span" }, {
            default: M(() => [
              R(e.$slots, "default", { checked: t })
            ]),
            _: 2
          }, 1024)
        ], 2)
      ]),
      _: 3
    }));
  }
}), MT = {}, zT = {
  class: /* @__PURE__ */ Z([
    "px-4 py-5",
    "sm:p-6"
  ])
};
function NT(o, e) {
  return w(), j("div", zT, [
    R(o.$slots, "default")
  ]);
}
const XN = /* @__PURE__ */ le(MT, [["render", NT]]), qN = /* @__PURE__ */ W({
  __name: "StatGroup",
  setup(o) {
    var n, a, s, i, l;
    const e = ((s = (a = (n = zu()).default) == null ? void 0 : a.call(n)[0].children) == null ? void 0 : s.length) ?? ((l = (i = zu()).default) == null ? void 0 : l.call(i).length), r = Math.min(e ?? 1, 5), t = /* @__PURE__ */ new Map([
      [1, "md:grid-cols-1"],
      [2, "md:grid-cols-2"],
      [3, "md:grid-cols-3"],
      [4, "md:grid-cols-4"],
      [5, "md:grid-cols-5"]
    ]);
    return (c, u) => (w(), j("dl", {
      class: Z([
        "grid grid-cols-1 divide-y divide-default-200 overflow-hidden rounded-lg bg-white shadow",
        P(t).get(P(r)),
        "md:divide-x md:divide-y-0"
      ])
    }, [
      R(c.$slots, "default")
    ], 2));
  }
}), IT = {}, RT = { class: "ml-2 text-sm font-medium text-default-500" };
function LT(o, e) {
  return w(), j("span", RT, [
    R(o.$slots, "default")
  ]);
}
const UN = /* @__PURE__ */ le(IT, [["render", LT]]), HT = {}, WT = { class: "text-base font-normal text-default-900" };
function VT(o, e) {
  return w(), j("dt", WT, [
    R(o.$slots, "default")
  ]);
}
const YN = /* @__PURE__ */ le(HT, [["render", VT]]), GT = {}, ZT = {
  class: /* @__PURE__ */ Z([
    "mt-1 flex items-baseline justify-between",
    "md:block lg:flex"
  ])
}, XT = { class: "flex items-baseline text-2xl font-semibold text-primary-600" };
function qT(o, e) {
  return w(), j("dd", ZT, [
    A("div", XT, [
      R(o.$slots, "default")
    ])
  ]);
}
const JN = /* @__PURE__ */ le(GT, [["render", qT]]), UT = { class: "flex gap-2 px-6 py-4 justify-between items-center" }, YT = { class: "text-sm text-default-500" }, JT = { class: "flex flex-row-reverse gap-3" }, QN = /* @__PURE__ */ W({
  __name: "StepModal",
  props: {
    open: { type: Boolean, default: !1 },
    size: { default: "base" },
    stepper: {}
  },
  emits: ["close", "finish"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = async () => {
      t("close"), await Cc(300), Ru(r.stepper.steps.value[0]) ? r.stepper.goTo(r.stepper.steps.value[0]) : r.stepper.goTo(Object.keys(r.stepper.steps.value)[0]);
    }, a = async () => {
      await n(), t("finish");
    }, s = (i) => Ru(i) ? !0 : i.isValid();
    return (i, l) => (w(), L(Uf, {
      open: i.open,
      size: i.size,
      onClose: n
    }, {
      default: M(() => [
        R(i.$slots, "default"),
        A("div", UT, [
          A("p", YT, _(i.stepper.index.value + 1) + " of " + _(i.stepper.stepNames.value.length), 1),
          A("div", JT, [
            i.stepper.isLast.value ? Q("", !0) : (w(), L(eo, {
              key: 0,
              disabled: !s(i.stepper.current.value),
              color: "primary",
              onClick: i.stepper.goToNext
            }, {
              default: M(() => l[0] || (l[0] = [
                se(" Next ")
              ])),
              _: 1
            }, 8, ["disabled", "onClick"])),
            i.stepper.isLast.value ? (w(), L(eo, {
              key: 1,
              disabled: !s(i.stepper.current.value),
              onClick: a
            }, {
              default: M(() => l[1] || (l[1] = [
                se(" Finish ")
              ])),
              _: 1
            }, 8, ["disabled"])) : Q("", !0),
            i.stepper.isFirst.value ? Q("", !0) : (w(), L(eo, {
              key: 2,
              color: "secondary",
              onClick: i.stepper.goToPrevious
            }, {
              default: M(() => l[2] || (l[2] = [
                se(" Back ")
              ])),
              _: 1
            }, 8, ["onClick"]))
          ])
        ])
      ]),
      _: 3
    }, 8, ["open", "size"]));
  }
}), QT = ["aria-label"], KT = { class: "flex justify-center items-center gap-1.5 flex-wrap" }, _T = ["aria-label", "aria-current", "onClick"], KN = /* @__PURE__ */ W({
  __name: "StepperNavigation",
  props: {
    ariaLabel: {},
    stepper: {}
  },
  setup(o) {
    return (e, r) => (w(), j("nav", {
      "aria-label": e.ariaLabel,
      class: "flex justify-between items-center space-x-base"
    }, [
      H(Po, {
        as: "button",
        size: "sm",
        color: "tertiary",
        icon: P(Uc),
        ariaLabel: "Go to previous",
        disabled: e.stepper.isFirst.value,
        onClick: e.stepper.goToPrevious
      }, null, 8, ["icon", "disabled", "onClick"]),
      A("ul", KT, [
        (w(!0), j(ye, null, je(e.stepper.steps.value, (t, n) => (w(), j("li", { key: n }, [
          A("button", {
            class: Z([
              "relative size-2 rounded-full",
              e.stepper.isCurrent(t) ? "bg-primary-600" : "bg-default-200"
            ]),
            "aria-label": `Go to page ${n + 1}`,
            "aria-current": e.stepper.isCurrent(t) ? "page" : void 0,
            onClick: (a) => e.stepper.goTo(t)
          }, [
            H(Jr)
          ], 10, _T)
        ]))), 128))
      ]),
      H(Po, {
        as: "button",
        size: "sm",
        color: "tertiary",
        icon: P(Ws),
        ariaLabel: "Go to next",
        disabled: e.stepper.isLast.value,
        onClick: e.stepper.goToNext
      }, null, 8, ["icon", "disabled", "onClick"])
    ], 8, QT));
  }
}), $T = ["fill"], _N = /* @__PURE__ */ W({
  __name: "StreetLogo",
  props: {
    color: { default: "black" }
  },
  setup(o) {
    return (e, r) => (w(), j("svg", {
      viewBox: "0 0 780 117",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Street logo"
    }, r[0] || (r[0] = [
      rr('<path d="M724.075 32.1443C723.658 42.8779 714.651 51.0504 703.141 51.0504C688.839 51.0504 679.602 41.3384 679.602 26.2883C679.602 11.2383 688.839 1.41113 703.141 1.41113C714.507 1.41113 722.852 9.18076 724.147 19.6697C724.234 20.346 723.687 20.9215 722.996 20.9215L711.831 20.8927C711.284 20.8927 710.824 20.5043 710.709 19.9719C710.292 17.9144 708.738 14.231 703.126 14.231C696.781 14.231 693.573 18.2885 693.573 26.2739C693.573 34.2594 696.781 38.2593 703.126 38.2593C708.896 38.2593 710.536 34.5903 710.968 32.1731"></path><path d="M703.083 114.762C690.45 114.762 682.277 106.848 682.277 94.6039V66.8346C682.277 66.2016 682.795 65.6836 683.428 65.6836H694.939C695.572 65.6836 696.09 66.2016 696.09 66.8346V94.4744C696.09 99.7117 698.248 102.043 703.097 102.043C707.946 102.043 710.162 99.7836 710.162 94.4744V66.8346C710.162 66.2016 710.68 65.6836 711.313 65.6836H722.881C723.514 65.6836 724.032 66.2016 724.032 66.8346V94.6039C724.032 106.848 715.816 114.762 703.111 114.762H703.083Z"></path><path d="M755.67 51.0504C741.325 51.0504 732.059 41.3096 732.059 26.2308C732.059 11.1519 741.325 1.41113 755.67 1.41113C770.015 1.41113 779.281 11.1519 779.281 26.2308C779.281 41.3096 770.015 51.0504 755.67 51.0504ZM755.67 14.2454C749.281 14.2454 746.044 18.2741 746.044 26.2308C746.044 34.1874 749.281 38.2161 755.67 38.2161C762.058 38.2161 765.295 34.1874 765.295 26.2308C765.295 18.2741 762.058 14.2454 755.67 14.2454Z"></path><path d="M761.653 113.798L749.884 100.302C749.423 99.7836 748.574 100.1 748.574 100.791V113.035C748.574 113.668 748.056 114.186 747.423 114.186H735.913C735.28 114.186 734.762 113.668 734.762 113.035V66.8346C734.762 66.2016 735.28 65.6836 735.913 65.6836H747.423C748.056 65.6836 748.574 66.2016 748.574 66.8346V77.6977C748.574 78.3884 749.438 78.7337 749.898 78.2157L761.049 66.0577C761.265 65.8275 761.567 65.6836 761.898 65.6836H776.257C777.25 65.6836 777.768 66.8778 777.092 67.6116L757.984 88.3162C757.581 88.7479 757.581 89.4097 757.97 89.8557L777.811 112.301C778.459 113.035 777.941 114.201 776.948 114.201H762.517C762.186 114.201 761.869 114.057 761.653 113.812V113.798Z"></path><path d="M16.5199 79.8257C17.1386 79.8257 17.6278 80.2861 17.7141 80.8904C19.2968 92.4729 28.5772 99.7533 43.3251 99.7533C59.9147 99.7533 67.9864 94.1851 67.9864 82.7465C67.9864 74.315 62.634 69.5813 50.0875 66.9482L34.1598 63.5095C13.2538 59.0203 3.51295 49.0062 3.51295 32.0137C3.51295 11.971 18.4623 0 43.4977 0C66.6483 0 82.4609 12.0429 84.3602 33.1935C84.4177 33.8986 83.8566 34.5029 83.1516 34.5029L67.9433 34.4597C67.3246 34.4597 66.821 33.9705 66.749 33.3518C65.6555 23.2225 56.8356 16.5608 43.1956 16.5608C29.5556 16.5608 21.8147 21.7549 21.8147 32.0137C21.8147 36.546 23.5701 42.9631 38.7784 46.258L53.5982 49.3803C74.9791 53.8262 86.2882 65.3655 86.2882 82.7609C86.2882 103.379 69.8281 116.185 43.3538 116.185C16.8796 116.185 0.606535 103.681 0.00223074 81.1925C-0.0121575 80.5163 0.534594 79.9695 1.21084 79.9552L16.5343 79.8257H16.5199Z"></path><path d="M127.167 68.5752V19.1805C127.167 18.5043 126.62 17.9719 125.958 17.9719H106.074C105.398 17.9719 104.865 17.4252 104.865 16.7633V2.61974C104.865 1.9435 105.412 1.41113 106.074 1.41113H165.972C166.648 1.41113 167.18 1.95788 167.18 2.61974V16.7633C167.18 17.4396 166.634 17.9719 165.972 17.9719H146.203C145.526 17.9719 144.994 18.5187 144.994 19.1805V68.5752C144.994 69.2514 144.447 69.7838 143.785 69.7838H128.404C127.728 69.7838 127.196 69.2371 127.196 68.5752H127.167Z"></path><path d="M159.726 98.1436H113.972C113.288 98.1436 112.734 98.6976 112.734 99.3809V113.481C112.734 114.165 113.288 114.719 113.972 114.719H159.726C160.41 114.719 160.964 114.165 160.964 113.481V99.3809C160.964 98.6976 160.41 98.1436 159.726 98.1436Z"></path><path d="M266.285 114.761C265.867 114.761 265.479 114.56 265.249 114.215L236.89 71.5679L236.803 71.5248H214.689C213.998 71.5248 213.451 72.0859 213.451 72.7622V113.524C213.451 114.215 212.89 114.761 212.214 114.761H197.034C196.344 114.761 195.797 114.2 195.797 113.524V2.64852C195.797 1.95788 196.358 1.41113 197.034 1.41113H241.077C263.364 1.41113 277.766 15.0799 277.766 36.2305C277.766 51.1223 269.982 62.935 256.803 68.3162C256.069 68.6184 255.781 69.496 256.213 70.1579L284.601 112.848C285.148 113.668 284.558 114.776 283.565 114.776H266.27L266.285 114.761ZM240.3 54.9496C252.86 54.9496 259.493 48.5325 259.493 36.3888C259.493 24.2452 252.673 17.9719 240.3 17.9719H214.703C214.012 17.9719 213.466 18.5331 213.466 19.2093V53.7122C213.466 54.4028 214.027 54.9496 214.703 54.9496H240.3Z"></path><path d="M314.028 114.761H312.892C312.201 114.761 311.654 114.2 311.654 113.524V2.64852C311.654 1.95788 312.215 1.41113 312.892 1.41113H384.746C385.437 1.41113 385.984 1.97227 385.984 2.64852V16.7346C385.984 17.4252 385.423 17.9719 384.746 17.9719H330.56C329.87 17.9719 329.323 18.5331 329.323 19.2093V46.8346C329.323 47.5253 329.884 48.072 330.56 48.072H379.912C380.602 48.072 381.149 48.6332 381.149 49.3094V50.4461V62.2588V63.4098C381.149 64.0861 380.588 64.6472 379.897 64.6472H330.56C329.87 64.6472 329.323 65.2084 329.323 65.8846V97.107C329.323 97.7976 329.884 98.3444 330.56 98.3444H384.746C385.437 98.3444 385.984 98.9055 385.984 99.5817V113.51C385.984 114.2 385.423 114.747 384.746 114.747H314.028V114.761Z"></path><path d="M417.704 114.761H416.567C415.877 114.761 415.33 114.2 415.33 113.524V2.64852C415.33 1.95788 415.891 1.41113 416.567 1.41113H488.422C489.113 1.41113 489.659 1.97227 489.659 2.64852V16.7346C489.659 17.4252 489.098 17.9719 488.422 17.9719H434.236C433.545 17.9719 432.999 18.5331 432.999 19.2093V46.8346C432.999 47.5253 433.56 48.072 434.236 48.072H483.588C484.278 48.072 484.825 48.6332 484.825 49.3094V50.4461V62.2588V63.4098C484.825 64.0861 484.264 64.6472 483.573 64.6472H434.236C433.545 64.6472 432.999 65.2084 432.999 65.8846V97.107C432.999 97.7976 433.56 98.3444 434.236 98.3444H488.422C489.113 98.3444 489.659 98.9055 489.659 99.5817V113.51C489.659 114.2 489.098 114.747 488.422 114.747H417.704V114.761Z"></path><path d="M545.877 114.761H544.74C544.049 114.761 543.503 114.2 543.503 113.524V19.2093C543.503 18.5187 542.941 17.9719 542.265 17.9719H510.87C510.18 17.9719 509.633 17.4108 509.633 16.7346V2.64852C509.633 1.95788 510.194 1.41113 510.87 1.41113H593.962C594.653 1.41113 595.199 1.97227 595.199 2.64852V16.7346C595.199 17.4252 594.638 17.9719 593.962 17.9719H562.567C561.876 17.9719 561.33 18.5331 561.33 19.2093V113.524C561.33 114.215 560.768 114.761 560.092 114.761H545.891H545.877Z"></path><path d="M609.245 115.251C608.555 115.251 608.008 114.69 608.008 114.014V99.9278C608.008 99.2372 608.569 98.6904 609.245 98.6904H655C655.69 98.6904 656.237 99.2516 656.237 99.9278V114.014C656.237 114.704 655.676 115.251 655 115.251H609.245Z"></path>', 12)
    ]), 8, $T));
  }
}), $N = /* @__PURE__ */ W({
  __name: "Switch",
  props: {
    checked: { type: Boolean },
    modelValue: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = ae(() => r.checked ? !0 : r.modelValue), n = e;
    return ur(() => {
      const a = m1();
      a != null && a.id && console.error('Directly passing an "id" attribute to the Switch component is not recommended. Use the HeadlessUI SwitchGroup and SwitchLabel components to manage labels and accessibility instead.');
    }), (a, s) => (w(), L(P(S1), {
      "default-checked": t.value,
      class: Z([
        "group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full",
        "focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50"
      ]),
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => n("update:modelValue", i))
    }, {
      default: M(() => [
        s[1] || (s[1] = A("span", {
          "aria-hidden": "true",
          class: "pointer-events-none absolute h-full w-full rounded-md"
        }, null, -1)),
        A("span", {
          "aria-hidden": "true",
          class: Z([
            t.value ? "bg-primary-600" : "bg-default-200",
            a.disabled && "bg-default-200",
            "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
          ])
        }, null, 2),
        A("span", {
          "aria-hidden": "true",
          class: Z([
            t.value ? "translate-x-5" : "translate-x-0",
            "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-default-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
          ])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["default-checked", "disabled", "tabindex", "aria-disabled"]));
  }
}), ej = {}, oj = { class: "space-y-3" };
function rj(o, e) {
  return w(), j("div", oj, [
    R(o.$slots, "default")
  ]);
}
const eI = /* @__PURE__ */ le(ej, [["render", rj]]), oI = /* @__PURE__ */ W({
  __name: "SwitchGroupField",
  setup(o) {
    return (e, r) => (w(), L(P(E1), {
      as: "div",
      class: "bg-white flex items-center justify-between space-x-3 rounded-xl p-base ring-1 ring-default-200"
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), rI = /* @__PURE__ */ W({
  __name: "SwitchLabel",
  props: {
    disabled: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (w(), L(P(x1), {
      class: Z([
        "block text-sm font-medium",
        e.disabled ? "text-default-400" : "text-default-900"
      ])
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), tj = /* @__PURE__ */ W({
  __name: "DefaultTab",
  props: {
    icon: {}
  },
  setup(o) {
    return (e, r) => (w(), L(P(Um), { as: "template" }, {
      default: M(({ selected: t }) => [
        A("button", {
          class: Z([
            t ? "border-primary-500 text-primary-600" : "border-transparent text-default-500 hover:border-default-300 hover:text-default-700",
            "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium outline-none"
          ])
        }, [
          e.icon ? (w(), L(P(ce), {
            key: 0,
            icon: e.icon,
            class: Z([
              t ? "text-primary-500" : "text-default-400 group-hover:text-default-500",
              "-ml-0.5 mr-2 size-4"
            ]),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])) : Q("", !0),
          R(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), nj = { class: "block" }, aj = /* @__PURE__ */ W({
  __name: "FullWidthTab",
  props: {
    icon: {}
  },
  setup(o) {
    const e = pe("size"), r = /* @__PURE__ */ new Map([
      ["sm", "py-base"],
      ["base", "py-large"]
    ]);
    return (t, n) => (w(), L(P(Um), { as: "template" }, {
      default: M(({ selected: a }) => [
        P(e) ? (w(), j("button", {
          key: 0,
          class: Z([
            "flex-1 text-sm font-medium text-default-500 border-b-2 outline-none px-base",
            a ? "border-primary-500" : "border-default-200",
            P(r).get(P(e))
          ])
        }, [
          t.icon ? (w(), L(P(ce), {
            key: 0,
            icon: t.icon,
            class: "size-4 mb-2"
          }, null, 8, ["icon"])) : Q("", !0),
          A("span", nj, [
            R(t.$slots, "default")
          ])
        ], 2)) : Q("", !0)
      ]),
      _: 3
    }));
  }
}), tI = /* @__PURE__ */ W({
  __name: "Tab",
  props: {
    icon: {}
  },
  setup(o) {
    const e = pe("variant"), r = /* @__PURE__ */ new Map([
      ["default", tj],
      ["full-width", aj]
    ]);
    return (t, n) => (w(), L(Fe(P(r).get(P(e) ?? "default")), { icon: t.icon }, {
      default: M(() => [
        R(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["icon"]));
  }
}), nI = /* @__PURE__ */ W({
  __name: "TabGroup",
  props: {
    as: { default: "template" },
    defaultIndex: { default: 0 },
    selectedIndex: { default: void 0 },
    size: { default: "base" },
    manual: { type: Boolean },
    variant: { default: "default" }
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = o;
    Be("size", r.size), Be("variant", r.variant);
    const t = e;
    return (n, a) => (w(), j("div", null, [
      H(P(A1), {
        as: n.as,
        "default-index": n.defaultIndex,
        "selected-index": n.selectedIndex,
        manual: n.manual,
        onChange: a[0] || (a[0] = (s) => t("change", s))
      }, {
        default: M(() => [
          R(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "default-index", "selected-index", "manual"])
    ]));
  }
}), sj = {}, ij = { class: "overflow-x-auto" }, lj = { class: "inline-block min-w-full align-middle p-px" }, cj = { class: "overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg" }, uj = { class: "min-w-full divide-y divide-default-300" };
function pj(o, e) {
  return w(), j("div", ij, [
    A("div", lj, [
      A("div", cj, [
        A("table", uj, [
          R(o.$slots, "default")
        ])
      ])
    ])
  ]);
}
const aI = /* @__PURE__ */ le(sj, [["render", pj]]), dj = {}, gj = { class: "divide-y divide-default-200 bg-white" };
function mj(o, e) {
  return w(), j("tbody", gj, [
    R(o.$slots, "default")
  ]);
}
const sI = /* @__PURE__ */ le(dj, [["render", mj]]), yj = {}, fj = { class: "px-6 py-4 whitespace-nowrap text-sm text-default-900" };
function hj(o, e) {
  return w(), j("td", fj, [
    R(o.$slots, "default")
  ]);
}
const iI = /* @__PURE__ */ le(yj, [["render", hj]]), Fj = {}, bj = { class: "bg-default-50" };
function vj(o, e) {
  return w(), j("thead", bj, [
    R(o.$slots, "default")
  ]);
}
const lI = /* @__PURE__ */ le(Fj, [["render", vj]]), Pj = {}, Bj = { class: "px-6 py-3 text-left text-xs font-medium text-default-500 uppercase tracking-wider" };
function kj(o, e) {
  return w(), j("th", Bj, [
    R(o.$slots, "default")
  ]);
}
const cI = /* @__PURE__ */ le(Pj, [["render", kj]]), wj = {};
function Dj(o, e) {
  return w(), j("tr", null, [
    R(o.$slots, "default")
  ]);
}
const uI = /* @__PURE__ */ le(wj, [["render", Dj]]), Sj = { class: "overflow-x-auto" }, Ej = { class: "border-b border-default-200" }, xj = { class: "-mb-px flex space-x-8" }, pI = /* @__PURE__ */ W({
  __name: "TabList",
  setup(o) {
    const e = pe("variant");
    return (r, t) => (w(), j(ye, null, [
      P(e) === "default" ? (w(), L(P(Nu), { key: 0 }, {
        default: M(() => [
          A("div", Sj, [
            A("div", Ej, [
              A("div", xj, [
                R(r.$slots, "default")
              ])
            ])
          ])
        ]),
        _: 3
      })) : Q("", !0),
      P(e) === "full-width" ? (w(), L(P(Nu), {
        key: 1,
        class: "flex"
      }, {
        default: M(() => [
          R(r.$slots, "default")
        ]),
        _: 3
      })) : Q("", !0)
    ], 64));
  }
}), dI = /* @__PURE__ */ W({
  __name: "TabPanel",
  setup(o) {
    return (e, r) => (w(), L(P(C1), null, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Aj = { class: "p-sm rounded-b-lg" }, gI = /* @__PURE__ */ W({
  __name: "TabPanels",
  props: {
    as: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", Aj, [
      H(P(O1), { as: e.as }, {
        default: M(() => [
          R(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["as"])
    ]));
  }
}), Cj = {}, Oj = { class: "p-large bg-white rounded-md shadow" };
function Tj(o, e) {
  return w(), j("section", Oj, [
    R(o.$slots, "default")
  ]);
}
const mI = /* @__PURE__ */ le(Cj, [["render", Tj]]), jj = ["id", "resize", "maxlength", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], Mj = {
  key: 0,
  class: "pt-2 text-sm text-default-500"
}, yI = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "Textarea",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    resize: { type: Boolean },
    maxLength: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const t = ie(o.modelValue ?? ""), n = e, a = pe("field-id");
    return (s, i) => {
      var l;
      return w(), j(ye, null, [
        yo(A("textarea", He({
          id: P(a),
          "onUpdate:modelValue": i[0] || (i[0] = (c) => t.value = c),
          resize: s.resize,
          maxlength: s.maxLength,
          disabled: s.disabled,
          tabindex: s.disabled ? "-1" : 0,
          "aria-disabled": s.disabled,
          "aria-invalid": !!s.invalid,
          "aria-describedby": s.invalid ? `${P(a)}-error` : void 0,
          class: [
            "text-sm block w-full px-3 py-2 rounded-md border border-default-300 placeholder-default-400 outline-none relative",
            "focus-visible:ring-inset focus-visible:ring-primary-500",
            !s.resize && "resize-none",
            s.disabled && "disabled:opacity-50 disabled:pointer-events-none"
          ]
        }, s.$attrs, {
          onInput: i[1] || (i[1] = (c) => {
            var u;
            return n("update:modelValue", (u = c.target) == null ? void 0 : u.value);
          })
        }), null, 16, jj), [
          [Dc, t.value]
        ]),
        s.maxLength ? (w(), j("p", Mj, " Characters remaining: " + _(s.maxLength - (((l = t.value) == null ? void 0 : l.length) ?? 0)), 1)) : Q("", !0)
      ], 64);
    };
  }
}), fI = /* @__PURE__ */ W({
  __name: "TextLink",
  props: {
    as: { default: Co }
  },
  setup(o) {
    return (e, r) => (w(), L(Fe(e.as), {
      class: Z([
        "text-primary-600",
        "hover:text-primary-700 hover:underline"
      ])
    }, {
      default: M(() => [
        R(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), zj = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
}, Nj = { class: "p-base" }, Ij = { class: "flex items-start" }, Rj = { class: "shrink-0" }, Lj = { class: "ml-3 w-0 flex-1" }, Hj = { class: "text-sm font-medium text-default-900" }, Wj = { class: "ml-4 flex shrink-0" }, Vj = /* @__PURE__ */ W({
  __name: "Toast",
  props: {
    toast: {},
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => t.show ? (w(), j("div", zj, [
      A("div", Nj, [
        A("div", Ij, [
          A("div", Rj, [
            t.toast.type === "success" ? (w(), L(P(ce), {
              key: 0,
              icon: P(Jf),
              class: "size-4 text-emerald-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : Q("", !0),
            t.toast.type === "error" ? (w(), L(P(ce), {
              key: 1,
              icon: P(ww),
              class: "size-4 text-red-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : Q("", !0),
            t.toast.type === "warning" ? (w(), L(P(ce), {
              key: 2,
              icon: P(Dw),
              class: "size-4 text-amber-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : Q("", !0),
            t.toast.type === "info" ? (w(), L(P(ce), {
              key: 3,
              icon: P(Yf),
              class: "size-4 text-blue-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : Q("", !0)
          ]),
          A("div", Lj, [
            A("p", Hj, _(t.toast.label), 1)
          ]),
          A("div", Wj, [
            A("button", {
              class: Z(["relative inline-flex rounded-md", "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"]),
              onClick: n[0] || (n[0] = (a) => r("close"))
            }, [
              H(Jr, null, {
                default: M(() => [
                  H(P(ce), {
                    icon: P(fa),
                    class: "size-5 text-default-400",
                    "aria-hidden": "true"
                  }, null, 8, ["icon"]),
                  n[1] || (n[1] = A("span", { class: "sr-only" }, " Close ", -1))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])) : Q("", !0);
  }
}), Ja = ie([]);
let Gj = 0;
const Zj = () => ({
  enqueue: (t, n = "success") => {
    Ja.value.push({
      id: `toasts-${Gj += 1}`,
      label: t,
      type: n
    });
  },
  dequeue: () => {
    Ja.value.length && Ja.value.shift();
  },
  duration: 5e3,
  queue: Ja
}), Tm = 300, Xj = /* @__PURE__ */ W({
  __name: "ToastTransition",
  setup(o) {
    const { dequeue: e, duration: r } = Zj(), [t] = Uo(!1), n = () => {
      t.value = !1, Iu(() => {
        e();
      }, Tm);
    }, { start: a, stop: s } = Iu(() => {
      n();
    }, r - Tm);
    return ur(() => {
      t.value = !0, a();
    }), (i, l) => (w(), L(Ro, {
      "enter-active-class": "transform ease-out duration-300 transition",
      "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
      "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
      "leave-active-class": "transition ease-in duration-300",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      onMouseover: P(s),
      onMouseleave: P(a)
    }, {
      default: M(() => [
        R(i.$slots, "default", {
          show: P(t),
          onClose: n
        })
      ]),
      _: 3
    }, 8, ["onMouseover", "onMouseleave"]));
  }
}), qj = {
  "aria-live": "assertive",
  class: /* @__PURE__ */ Z([
    "z-[70] pointer-events-none fixed inset-0 flex items-end px-4 py-6",
    "sm:items-start sm:p-6"
  ])
}, Uj = {
  class: /* @__PURE__ */ Z([
    "flex w-full flex-col items-center space-y-4",
    "sm:items-end"
  ])
}, hI = /* @__PURE__ */ W({
  __name: "ToastGroup",
  props: {
    toasts: {}
  },
  setup(o) {
    return (e, r) => (w(), j("div", qj, [
      A("div", Uj, [
        (w(!0), j(ye, null, je(e.toasts, (t) => (w(), L(Xj, {
          key: t.id
        }, {
          default: M(({ show: n, onClose: a }) => [
            H(Vj, {
              toast: t,
              show: n,
              onClose: a
            }, null, 8, ["toast", "show", "onClose"])
          ]),
          _: 2
        }, 1024))), 128))
      ])
    ]));
  }
}), FI = /* @__PURE__ */ W({
  __name: "ToggleButton",
  setup(o) {
    return (e, r) => (w(), L(P(zs), { as: "template" }, {
      default: M(({ checked: t }) => [
        A("button", {
          type: "button",
          class: Z([
            "rounded outline-none py-2 px-8 border text-sm font-medium text-default-700",
            t ? "bg-white border-default-200" : "border-transparent"
          ])
        }, [
          R(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), Yj = { class: "inline-flex bg-default-100 rounded p-tiny space-x-tiny" }, bI = /* @__PURE__ */ W({
  __name: "ToggleButtonGroup",
  props: {
    description: {},
    label: {}
  },
  setup(o) {
    return (e, r) => (w(), L(P(Ms), null, {
      default: M(() => [
        H(P(pa), { class: "sr-only" }, {
          default: M(() => [
            se(_(e.label), 1)
          ]),
          _: 1
        }),
        e.description ? (w(), L(P(Ec), {
          key: 0,
          class: "sr-only"
        }, {
          default: M(() => [
            se(_(e.description), 1)
          ]),
          _: 1
        })) : Q("", !0),
        A("div", Yj, [
          R(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), Jj = { class: "flex-1" }, vI = /* @__PURE__ */ W({
  __name: "VerticalNavigationLink",
  props: {
    as: { default: Co },
    current: { type: Boolean },
    href: {},
    trailingIcon: { default: void 0 }
  },
  setup(o) {
    return (e, r) => (w(), j("li", null, [
      (w(), L(Fe(e.as), {
        href: e.href,
        class: Z([
          "inline-flex space-x-3 w-full cursor-pointer px-base py-3 text-sm font-medium rounded-md",
          "hover:bg-primary-100 hover:text-primary-600",
          e.current ? "bg-primary-100 text-primary-600" : "text-default-900"
        ])
      }, {
        default: M(() => [
          A("span", Jj, [
            R(e.$slots, "default")
          ]),
          e.trailingIcon ? (w(), L(P(ce), {
            key: 0,
            icon: e.trailingIcon,
            class: "size-4",
            "aria-hidden": "true"
          }, null, 8, ["icon"])) : Q("", !0)
        ]),
        _: 3
      }, 8, ["href", "class"]))
    ]));
  }
}), Qj = {}, Kj = { class: "space-y-3" };
function _j(o, e) {
  return w(), j("nav", null, [
    A("ul", Kj, [
      R(o.$slots, "default")
    ])
  ]);
}
const PI = /* @__PURE__ */ le(Qj, [["render", _j]]), BI = (o) => {
  const e = ie(0), r = ie([]), [t, n] = Uo(!1), [a, s] = Uo(!1), i = ie(""), l = async () => {
    var g, p;
    if (a.value)
      return;
    n(!0);
    const u = {};
    u[((g = o.parameters) == null ? void 0 : g.page) ?? "page"] = e.value += 1, u[((p = o.parameters) == null ? void 0 : p.query) ?? "query"] = i.value.length >= 3 ? i.value : void 0;
    const { data: m } = await Tc.get(o.url, {
      params: u
    }), y = o.transform ? o.transform(m) : m;
    if (!y.length) {
      if (e.value -= 1, n(!1), i.value) {
        r.value = [];
        return;
      }
      s(!0);
      return;
    }
    i.value ? r.value = y : r.value = [
      ...r.value,
      ...y
    ], n(!1);
  };
  N1(i, async (u) => {
    e.value = 0, s(!1), u || (r.value = []), await l();
  }, { debounce: 500 });
  const c = ae(() => r.value.length === 0 && i.value !== "");
  return {
    endReached: a,
    isEmpty: c,
    isLoading: t,
    fetch: l,
    options: r,
    query: i
  };
}, kI = (o) => {
  const e = ie(0), r = ie([]), [t, n] = Uo(!1), [a, s] = Uo(!1);
  return {
    endReached: a,
    isLoading: t,
    fetch: async () => {
      var m;
      if (a.value)
        return;
      n(!0);
      const l = {};
      l[((m = o.parameters) == null ? void 0 : m.page) ?? "page"] = e.value += 1;
      const { data: c } = await Tc.get(o.url, {
        params: l
      }), u = o.transform ? o.transform(c) : c;
      if (!u.length) {
        e.value -= 1, s(!0), n(!1);
        return;
      }
      r.value = [
        ...r.value,
        ...u
      ], n(!1);
    },
    options: r
  };
};
export {
  yM as SpectreAccordion,
  fM as SpectreAccordionButton,
  hM as SpectreAccordionGroup,
  FM as SpectreAccordionPanel,
  bM as SpectreActionBanner,
  vM as SpectreActionBannerActions,
  PM as SpectreActionBannerDescription,
  BM as SpectreActionBannerTitle,
  kM as SpectreActionPanel,
  wM as SpectreActionPanelContent,
  DM as SpectreActionPanelDescription,
  SM as SpectreActionPanelTitle,
  EM as SpectreAddressSearchModal,
  xM as SpectreAiModal,
  AM as SpectreAiModalContent,
  CM as SpectreAiModalFooter,
  OM as SpectreAiModalHeader,
  TM as SpectreAiModalTitle,
  jM as SpectreAlert,
  MM as SpectreAlertDescription,
  zM as SpectreAlertLink,
  NM as SpectreAlertModal,
  IM as SpectreAlertModalDescription,
  RM as SpectreAlertModalFooter,
  LM as SpectreAlertModalHeader,
  HM as SpectreAlertModalTitle,
  WM as SpectreAlertTitle,
  Qf as SpectreBadge,
  VM as SpectreBadgeButton,
  GM as SpectreBrandPreviewLarge,
  ZM as SpectreBrandPreviewSmall,
  XM as SpectreBrandPreviewSmallTitle,
  qM as SpectreBreadcrumb,
  UM as SpectreBreadcrumbGroup,
  YM as SpectreBrowserWindow,
  eo as SpectreButton,
  JM as SpectreButtonGroup,
  zg as SpectreButtonPreview,
  QM as SpectreCalendarMonthView,
  KM as SpectreCalendarMonthViewDay,
  _M as SpectreCalendarNavigation,
  $M as SpectreCalendarNavigationTitle,
  ez as SpectreCalendarWeekView,
  oz as SpectreCalendarWeekViewGrid,
  rz as SpectreCalendarWeekViewGridItem,
  tz as SpectreCalendarWeekViewHeader,
  Kf as SpectreCard,
  _f as SpectreCardContent,
  f9 as SpectreCardFooter,
  v9 as SpectreCardHeader,
  nz as SpectreCarousel,
  az as SpectreCarouselSlide,
  sz as SpectreCheckbox,
  iz as SpectreCheckboxGroup,
  lz as SpectreCheckboxGroupField,
  cz as SpectreCheckboxGroupFieldLabel,
  uz as SpectreColorPicker,
  Ng as SpectreColourPreview,
  pz as SpectreCombobox,
  dz as SpectreComboboxBadges,
  gz as SpectreComboboxControl,
  mz as SpectreComboboxLabel,
  yz as SpectreComboboxOption,
  fz as SpectreComboboxOptions,
  X8 as SpectreContainer,
  hz as SpectreCopyToClipboard,
  Fz as SpectreDescription,
  bz as SpectreDescriptionDetails,
  vz as SpectreDescriptionList,
  Pz as SpectreDescriptionTerm,
  ch as SpectreDivider,
  Bz as SpectreDotPattern,
  kz as SpectreDrawer,
  wz as SpectreDrawerContent,
  Dz as SpectreDrawerDescription,
  Sz as SpectreDrawerFooter,
  Ez as SpectreDrawerHeader,
  xz as SpectreDrawerTitle,
  Az as SpectreDropdown,
  Cz as SpectreDropdownItem,
  Oz as SpectreEmojiPicker,
  Tz as SpectreErrorMessage,
  jz as SpectreExpandingButton,
  mu as SpectreField,
  vS as SpectreFieldset,
  Mz as SpectreGridCheckboxGroup,
  zz as SpectreGridCheckboxGroupDescription,
  Nz as SpectreGridCheckboxGroupLegend,
  Iz as SpectreGridCheckboxGroupOption,
  Rz as SpectreGridCheckboxGroupOptions,
  Lz as SpectreGridRadioGroup,
  Hz as SpectreGridRadioGroupDescription,
  Wz as SpectreGridRadioGroupLabel,
  Vz as SpectreGridRadioGroupOption,
  Gz as SpectreGridRadioGroupOptions,
  Dr as SpectreHeading,
  Po as SpectreIconButton,
  Mg as SpectreImagePreview,
  zS as SpectreInfoBox,
  Zz as SpectreInfoBoxTextLink,
  ba as SpectreInput,
  Xz as SpectreInputAddressSearch,
  qz as SpectreInputCopyToClipboard,
  Uz as SpectreInputFileButton,
  Yz as SpectreInputFileDropZone,
  Jz as SpectreInputGroup,
  Qz as SpectreInputGroupAddon,
  Kz as SpectreInputGroupInput,
  _z as SpectreInputGroupSelect,
  $z as SpectreInputMultiAddressSearch,
  eN as SpectreInputRange,
  oN as SpectreInputRangeBadge,
  rN as SpectreInputRichText,
  No as SpectreLabel,
  BS as SpectreLegend,
  tN as SpectreLengthAwarePagination,
  nN as SpectreLinkTab,
  aN as SpectreLinkTabGroup,
  sN as SpectreListbox,
  iN as SpectreListboxBadges,
  lN as SpectreListboxControl,
  cN as SpectreListboxLabel,
  uN as SpectreListboxOption,
  pN as SpectreListboxOptions,
  dN as SpectreLogo,
  Uf as SpectreModal,
  cw as SpectreModalContent,
  gN as SpectreModalDescription,
  mN as SpectreModalFooter,
  lw as SpectreModalHeader,
  ew as SpectreModalTitle,
  yN as SpectreNavigationBar,
  fN as SpectreObjectUrlPreview,
  hN as SpectrePageHeading,
  FN as SpectrePageHeadingColumn,
  bN as SpectrePageHeadingTitle,
  vN as SpectrePaginationLinks,
  PN as SpectrePaginationMeta,
  sS as SpectreParagraph,
  BN as SpectrePlaceholder,
  uh as SpectrePopover,
  kN as SpectrePreset,
  Kw as SpectrePreviewContainer,
  wN as SpectreProgress,
  DN as SpectreProgressCard,
  SN as SpectreProgressCardDescription,
  EN as SpectreProgressCardGroup,
  xN as SpectreProgressCardTitle,
  pT as SpectreRadio,
  AN as SpectreRadioGroup,
  CN as SpectreRadioGroupRadio,
  ON as SpectreRadioGroupRadioLabel,
  TN as SpectreSegmentedButton,
  jN as SpectreSegmentedButtonGroup,
  RO as SpectreSelect,
  MN as SpectreSettingCard,
  hT as SpectreSettingCardButton,
  zN as SpectreSettingCardGroup,
  NN as SpectreSettingCardPreview,
  IN as SpectreSettingCardTitle,
  RN as SpectreSettingGroup,
  LN as SpectreSettingGroupContent,
  HN as SpectreSettingGroupTitle,
  WN as SpectreSimplePagination,
  VN as SpectreSmallCardsRadioGroup,
  GN as SpectreSmallCardsRadioGroupLabel,
  ZN as SpectreSmallCardsRadioGroupOption,
  Yr as SpectreSpinner,
  XN as SpectreStat,
  qN as SpectreStatGroup,
  UN as SpectreStatPreviousValue,
  YN as SpectreStatTitle,
  JN as SpectreStatValue,
  QN as SpectreStepModal,
  KN as SpectreStepperNavigation,
  _N as SpectreStreetLogo,
  $N as SpectreSwitch,
  eI as SpectreSwitchGroup,
  oI as SpectreSwitchGroupField,
  rI as SpectreSwitchLabel,
  tI as SpectreTab,
  nI as SpectreTabGroup,
  pI as SpectreTabList,
  dI as SpectreTabPanel,
  gI as SpectreTabPanels,
  mI as SpectreTabSection,
  aI as SpectreTable,
  sI as SpectreTableBody,
  iI as SpectreTableData,
  lI as SpectreTableHead,
  cI as SpectreTableHeader,
  uI as SpectreTableRow,
  fI as SpectreTextLink,
  jg as SpectreTextPreview,
  yI as SpectreTextarea,
  hI as SpectreToastGroup,
  FI as SpectreToggleButton,
  bI as SpectreToggleButtonGroup,
  Jr as SpectreTouchTarget,
  vI as SpectreVerticalNavigationLink,
  PI as SpectreVerticalNavigationLinkGroup,
  BI as useCombobox,
  kI as useListbox,
  Dm as useObjectUrlPreview,
  vD as useStatus,
  Zj as useToasts,
  ph as vTooltip
};
